const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Tsukuyomi Arkaplanı",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Fazla sahne varlıkları yüzünden yayınlama başarısız oldu. Lütfen bazı varlıkları silip tekrar dene.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "Şu anda üyelikle ilgili özelliklere erişim iznin yok",
  T_12_I_GIFT_SENDER_BELL: "Çan",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "Demin buradaydı, nereye gitti? [FFB300](Kaskları gizler)[-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Yaşlı Adamın Maskesi",
  T_12_L_COS_PINKMAN: "Pembe Dino",
  T_12_L_COS_POLAR: "Kutup Ayısı",
  T_12_L_COS_RENDER: "Gökkuşağı Dino",
  T_12_L_COS_TIGER: "Kaplan Kıyafeti",
  T_12_L_MALE_BOTTOM_COS_ELF: "Kış Elfi (Alt)",
  T_12_L_MALE_COS_SANTA: "Huysuz Yaşlı Adam",
  T_12_L_MALE_HAIR_COS_ELF: "Kış Elfi (Kafa)",
  T_12_L_MALE_SHOE_COS_ELF: "Kış Elfi (Ayakkabı)",
  T_12_L_MALE_TOP_COS_ELF: "Kış Elfi (Üst)",
  T_12_O_CAT_NAME: "Kedicik",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014 - Kış Diyarı",
  T_12_O_MACHETE_GOLD_NAME: "Pala - Altın Bıçak",
  T_12_O_PET_TITLE: "YOLDAŞ",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "Zıplama Ayakkabıları",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "Modern teknolojiyle yapılmış ayakkabılar. Giyenler iki kez zıplayabilir.",
  T_12_Q_ITEM_FLYSHOE: "Roket Ayakkabılar",
  T_12_Q_ITEM_FLYSHOE_DESC: "Giyeni uçuran ayakkabılar. Havadayken yakıtını bitirmemeye özen göster.",
  T_12_Q_ITEM_STOCK1: "1. Svy Kabza",
  T_12_Q_ITEM_STOCK2: "2. Svy Kabza",
  T_12_Q_ITEM_STOCK3: "3. Svy Kabza",
  T_12_Q_ITEM_TREATMENTGUN: "Şifa Tabancası",
  T_12_Q_ITEM_VEST4: "4. Svy Yelek",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Antonio",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Wukong",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Ateş Etme Dansı",
  T_12_R_EMOTE_WAVE_NAME: "Kol Dalgası",
  T_12_R_SKILL_NAME_GANGLEADER: "Çeteci Ruhu",
  T_12_R_SKILL_NAME_MONKEYGOD: "Kamuflaj",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Yüzen Araba",
  T_13_I_COLLECTION_V_JEEP: "Cip",
  T_13_I_COLLECTION_V_MONSTER: "Canavar Kamyon",
  T_13_I_COLLECTION_V_MOTOBIKE: "Motosiklet",
  T_13_I_COLLECTION_V_ROADSTER: "Spor Araba",
  T_13_I_COLLECTION_V_SUV: "Kamyonet",
  T_13_I_COLLECTION_V_TUTU: "Üçteker",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Kutup Mavisi (Maske)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Aşk Kokuları (Alt)",
  T_13_L_MALE_HAIR_COS_BJD: "Kutup Mavisi (Kafa)",
  T_13_L_MALE_TOP_COS_VALENTINE: "Aşk Kokuları (Üst)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "Silah",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "Yoldaş Görünümü: Dedektif Kedicik",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR - Aşk Tanrısı",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Moco",
  T_13_R_EMOTE_BABYSHARK_NAME: "Yavru Köpekbalığı",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Şınav",
  T_13_R_EMOTE_EGYPT_NAME: "Mumya Dansı",
  T_13_R_PVE_WEAPON_SLOT: "Silah Yuvası",
  T_13_R_PVE_WEAPONSKIN_RANGE: "Etkili Menzil",
  T_13_R_PVE_WEAPONSKIN_SPEED: "Atış Hızı",
  T_13_R_SKILL_DESC_HACKERGIRL: "Vurulan düşmanlar [FFB300]{0}[-] saniyeliğine işaretlenir. Takım arkadaşlarıyla da bilgi paylaşılır.",
  T_13_R_SKILL_NAME_HACKERGIRL: "Hacker Gözü",
  T_13_Z_KICKOFF_BAN: "ENGELLEME",
  T_13_Z_ROOM_MORNING: "Gündüz",
  T_13_Z_ROOM_NIGHT: "Gece",
  T_14_G_ITEM_KATANA: "Katana",
  T_14_I_HEADPIC_SONGKRAN_NAME: "CUP CUP!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Küp Tavşan",
  T_14_L_COS_EASTER: "İzleyici 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Alev Leydisi (Ayakkabı)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Tavşan Savaşçı (Maske)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47 - Su Balonu",
  T_14_O_DOG_NAME: "Mekanik Köpekçik",
  T_14_O_PETSKIN_IRON_DOG_NAME: "Yoldaş Görünümü: Çelik Köpekçik",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "Yoldaş Görünümü: Yıldırım Köpekçik",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "Yoldaş Görünümü: Manyetik Köpekçik",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "Yoldaş Görünümü: Gece Kediciği",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR - Kanlı Ay",
  T_14_O_SCAR_SHARK_NAME: "SCAR - Köpekbalığı Saldırısı",
  T_14_Q_ITEM_RGS50: "RGS50",
  T_14_R_CHARACTER_SAMURAI_NAME: "Hayato",
  T_14_R_SKILL_DESC_SAMURAI: "CP her [FFB300]%{0}[-] azaldığında, zırh delme [FFB300]%{1}[-] artar.",
  T_14_R_SKILL_NAME_SAMURAI: "Buşido",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Açlık Darbesi (Maske)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Zehirli Dokunuş (Maske)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Açlık Darbesi (Alt)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Zehirli Dokunuş (Alt)",
  T_15_L_MALE_SHOE_COS_FAIM: "Açlık Darbesi (Ayakkabı)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Zehirli Dokunuş (Ayakkabı)",
  T_15_L_MALE_TOP_COS_FAIM: "Açlık Darbesi (Üst)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Zehirli Dokunuş (Üst)",
  T_15_L_TOP_COS_MOTHERSDAY: "En İyi Anne",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - Büyük Felaket",
  T_15_O_BASEBALLBAT_VIKING_NAME: "Sopa - Viking",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - Büyük Felaket",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - Büyük Felaket",
  T_15_O_PANTHER_NAME: "Gece Panteri",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "Yoldaş Görünümü: Kaptan",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "Yoldaş Görünümü: Altın Leopar",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "Yoldaş Görünümü: Hâkimiyet",
  T_15_O_SKS_DEATH_NAME: "SKS - Son Arzu",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - Büyük Felaket",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "Mitralyöz",
  T_15_R_CHARACTER_AGENT_NAME: "Laura",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Benimle Çalkala",
  T_15_R_SKILL_DESC_AGENT: "Dürbünle nişan alırken isabet oranı [FFB300]%{0}[-] artar.",
  T_15_R_SKILL_NAME_AGENT: "Keskin Nişancı",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Çanta - Mor Kanatlar",
  T_16_B_ITEM_GRAPPLINGHOOK: "Kanca",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "Kanca Silahı",
  T_16_L_MALE_COS_LEGO: "Çılgın Tuğla Adam",
  T_16_L_MALE_SHOE_COS_SUMMER: "Yaz Tatilcisi (Ayakkabı)",
  T_16_P_MANUAL_MONSTER: "Canavar Kamyon",
  T_16_P_MANUAL_MUSHROOM1: "1. Svy Mantar",
  T_16_P_MANUAL_MUSHROOM2: "2. Svy Mantar",
  T_16_P_MANUAL_MUSHROOM3: "3. Svy Mantar",
  T_16_P_MANUAL_MUSHROOM4: "4. Svy Mantar",
  T_16_P_MANUAL_ROADSTER_DESC: "Tarz bir spor araba. Düşük canına karşın azami hızı epey yüksektir. 2 oyuncuya kadar taşıyabilir.",
  T_16_P_MANUAL_STROP: "Çelik Halat",
  T_16_P_MANUAL_SUV: "Kamyonet",
  T_16_P_MANUAL_SUV_DESC: "Free Fire'ın meşhur aracı. Zırhı ve azami hızı orta seviyededir. 2 oyuncuya kadar taşıyabilir.",
  T_16_P_MANUAL_TUTU_DESC: "Düşük CP ve hıza sahip olan bir araç. 3 oyuncuya kadar taşıyabilir.",
  T_16_P_MANUAL_WEAPON_AR: "Tüfek",
  T_16_P_MANUAL_WEAPON_BOMB: "Bombalar",
  T_16_P_MANUAL_WEAPON_PISTOL: "Tabanca",
  T_16_P_MANUAL_WEAPON_SG: "Pompalı Tüfek",
  T_16_P_MANUAL_WEAPON_SMG: "Hafif Makineli Tüfek",
  T_16_P_MANUAL_WEAPON_SR: "Keskin Nişancı Tüfeği",
  T_16_Q_MINISENTRY: "Mini Taret",
  T_16_Q_MINISENTRY_DESC: "Modern teknolojiyle geliştirilen bir otomatik taret. Yakındaki düşmanları tespit edip saldırıya geçer.",
  T_16_R_EMOTE_DESERT_NAME: "Öfkeli Vuruş",
  T_16_R_EMOTE_EPHUNTER_NAME: "Savaş Dansı",
  T_16_R_EMOTE_EPHUNTER2_NAME: "Çak Bir Beşlik",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Ay Taklası",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Kıpırtılı Yürüyüş",
  T_16_W_AK_FIRE_NAME: "AK47 - Kırmızı Alev",
  T_16_W_SCAR_LLENN_NAME: "SCAR - Pembe Şeytan",
  T_16_W_SCAR_WATER_NAME: "SCAR - Su Elementi",
  T_16_Y_CHARACTER_HITMAN_NAME: "Rafael",
  T_16_Y_PANDA_NAME: "Dedektif Panda",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "Yoldaş Görünümü: Vahşi Panda",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "Yoldaş Görünümü: Kafatası Panda",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "Yoldaş Görünümü: Yıldırım Panda",
  T_17_B_CS_MODE_NAME: "EKİP ÇARPIŞMASI",
  T_17_C_SKILL_NAME_PLAYBOY: "Kaçık Hareketler",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Kraliyet Soytarısı (Maske)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Kanlı Hanım (Maske)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Kanlı Hanım (Alt)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Büyülü Tilki (Kafa)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Kanlı Hanım (Ayakkabı)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Kanlı Hanım (Üst)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Vampirin İntikamı (Maske)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Sokak Serserisi (Alt)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Vampirin İntikamı (Alt)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Mor Gölge (Kafa)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "Beyefendi (Ayakkabı)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Vampirin İntikamı (Ayakkabı)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Vampirin İntikamı (Üst)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Altın Gölge (Üst)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "Yoldaş Görünümü: Miyav Prensesi",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "Yoldaş Görünümü: Altın Kuyruk",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "Yoldaş Görünümü: Derin Mavi",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "Yoldaş Görünümü: Şanslı Yeşil",
  T_17_O_SHIBA_NAME: "Shiba",
  T_17_Q_FOLDWINGS: "Planör",
  T_17_Q_FOLDWINGS_DESC: "Yüksek mekânlardan yavaşça süzülmeni sağlar.",
  T_17_Q_SUPERHEAT: "PLAZMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Parti Dansı",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS - Vampir",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR - Hayalet Suikastçı",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR - Eski Usul",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Joseph",
  T_17_Z_CS_NAME: "İsim",
  T_17_Z_ROOM_JUMP_SWITCH: "Zıplama Yüksekliği",
  T_17_Z_ROOM_SPEED_SWITCH: "Hareket Hızı",
  T_18_B_THROWINGKNIFE_NAME: "FF Bıçağı",
  T_18_C_DUMMY_NAME: "Yem Bombası",
  T_18_C_SKILL_DESC_DJMALE: "[FFB300]{0}[-] saniye boyunca dost oyuncuların hareket hızını [FFB300]%{3}[-] arttıran ve [FFB300]{2}[-] CP yenileyen [FFB300]{1} [-]metrelik bir alan oluşturur. Etki birikmez.",
  T_18_C_SKILL_NAME_DJMALE: "Ritmi Hisset",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Parça Dönüşümü",
  T_18_L_COS_INDIANEWYEAR: "Divali Dino",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Asık Surat",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Kırmızı Alev (Maske)",
  T_18_O_FOX_NAME: "Ruh Tilkisi",
  T_18_O_PETSKIN_BLACKFOX_NAME: "Yoldaş Görünümü: Savaş Tilkisi",
  T_18_O_PETSKIN_BLUEFOX_NAME: "Yoldaş Görünümü: Mavi Tilki",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "Yoldaş Görünümü: Lav Balkabağı",
  T_18_O_PETSKIN_PINKFOX_NAME: "Yoldaş Görünümü: Kızıl Tilki",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "Yoldaş Görünümü: Ruh",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1 - Alevli Kafatası",
  T_18_W_UMP_GEISHA_N: "UMP - Savaş Sanatı",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Shani",
  T_19_B_HB_NAME: "Elektrikli Sörf Tahtası",
  T_19_C_ICE_GUN_NAME: "Buz Tabancası",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "Patlayıcı silah hasarı [FFB300]%{0}[-], hasar menzili [FFB300]%{1}[-] artar.",
  T_19_C_SKILL_DESC_TOMBOY: "Sürüş sırasında, maksimum [FFB300]{2}[-] CP'ye kadar, araçtaki herkes için her [FFB300]{0}s[-]'de bir [FFB300]{1} CP[-] yeniler.",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "Yıkım Sanatı",
  T_19_C_SKILL_NAME_TOMBOY: "Yarışçı Yeteneği",
  T_19_I_EVENT_INFI_ITEM: "Sınırsız",
  T_19_L_A_ICEFESTIVAL19_B: "Son Gülen",
  T_19_L_F_S_ICEFESTIVAL: "Karlı Hizmetçi (Ayakkabı)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Disko Fiyasko (Alt)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Disko Fiyasko (Kafa)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Disko Fiyasko (Üst)",
  T_19_O_PETSKIN_NAME: "Yoldaş Görünümü: Varsayılan",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "Yoldaş Görünümü: Hip Hop Panda",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "Yoldaş Görünümü: Kutup Pandası",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "Yoldaş Görünümü: Firavun Robo",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "Yoldaş Görünümü: Bahar Festivali Robo",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "Yoldaş Görünümü: Karlı Robo",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "Yoldaş Görünümü: Hip Hop Shiba",
  T_19_O_ROBOT_NAME: "Robo",
  T_19_O_TDM_NAME: "TAKIM ÖLÜM MAÇI",
  T_19_R_EMOTE_MIGUEL_NAME: "Break Dans",
  T_19_S_SECOND_WEAPON_TITLE: "Yedek Silah",
  T_19_S_VEST_TITLE: "Kurşun Geçirmez Yelek",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Çifte Şarjör",
  T_19_W_GROZA_TAGGERCREW_N: "Groza - Sanatçı İsyanı",
  T_19_W_M60_ICEFESTIVAL_N: "M60 - Noel Babanın Tercihi",
  T_19_W_MP40_PARK_N: "MP40 - Karnaval Kıyımı",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR - Altın Ejder",
  T_19_X_PVE_SAMURAINAME: "Muhafız Samuray",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Alvaro",
  T_19_Y_CHARACTER_TOMBOY_N: "Notora",
  T_20_C_INHALER_NAME: "Soluk Cihazı",
  T_20_C_SKILL_DESC_PARKOURGUY: "Silah kullandığında, rakibe hasar vermek CP doldurur, rakibi yere sermek ise CP değerinin [FFB300]{0}%[-] kadarını doldurur.",
  T_20_C_SKILL_NAME_GRAFFITIST: "Boyalı Sığınak",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Amansız Sürat",
  T_20_C_SKILL_NAME_PARKOURGUY: "Süregelen Baskınlar",
  T_20_L_A_APRILFOOL2020: "Kuçu",
  T_20_L_F_A_METALHEAD_RED: "Bayan Ateşli Boynuz Kafa (Maske)",
  T_20_L_F_B_THAIGIRL: "Yükselen Anka (Alt)",
  T_20_L_F_H_KILLERCUPID: "Canım Cicim (Kafa)",
  T_20_L_F_H_THAIGIRL: "Yükselen Anka (Kafa)",
  T_20_L_F_S_THAIGIRL: "Yükselen Anka (Ayakkabı)",
  T_20_L_F_T_METALHEAD_RED: "Bayan Ateşli Boynuz Kafa (Üst)",
  T_20_L_F_T_THAIGIRL: "Yükselen Anka (Üst)",
  T_20_L_JEANDINO: "Kot Dino",
  T_20_L_M_A_METALHEAD_RED: "Bay Ateşli Boynuz Kafa (Maske)",
  T_20_L_M_T_METALHEAD_RED: "Bay Ateşli Boynuz Kafa (Üst)",
  T_20_L_M_T_STOCKING: "Beyefendi (Üst)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "Yoldaş Görünümü: Sevgili Tilki",
  T_20_P_CHANNEL_G: "Klan",
  T_20_P_WORLD_SSPEAKER: "Megafon",
  T_20_S_CSROOM_COIN: "Varsayılan para",
  T_20_U_SHIELD_GUN_NAME: "Kalkan Tabancası",
  T_20_W_AN94_METALHEAD_N: "AN94 - Havuçlu Boynuz Kafa",
  T_20_W_P90_EVILBONE_N: "P90 - Cezalandırıcılar",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Steffie",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: '"Süratli" Kelly',
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "Etrafta duman oluşturur, rakibin görüşünü engellemek ve yanlardan kuşatmak için kullanılabilir.",
  T_21_B_SMOKEGRENADE_NAME: "Sis Bombası",
  T_21_C_AUTOPICKUP_AVERAGE: "Varsayılan",
  T_21_C_SKILL_DESC_KPOPSINGER: "Bir takım arkadaşına yardım ederken, söz konusu takım arkadaşına bir [FFB300]{0} CP[-] kalkanı ve[ FFB300]% {1}[-] hareket hızı takviyesi verir. Takviye etkileri, kaldırdıktan sonra [FFB300]{2}s[-] içerisinde azalır. Yere düşen takım arkadaşlarının kanama hızını [FFB300]%{3}[-] azaltır. Etkiler birikmez.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "Her haklama maksimum can puanını [FFB300]{0}[-] arttırır. Maks: [FFB300]{1}[-].",
  T_21_C_SKILL_NAME_KPOPSINGER: "İyileştirme Şarkısı",
  T_21_C_SKILL_NAME_SOCCERSTAR: "Hat Trick",
  T_21_L_ANGELICAL: "Melek Dino",
  T_21_L_S_VNSLIPPER: "Vietnam Terlikleri",
  T_21_O_OTTER_NAME: "Samuro",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "Yoldaş Görünümü: Radyoaktif Samuro",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "Yoldaş Görünümü: Sakura Samuro",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "Yoldaş Görünümü: Neon Samuro",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "Yoldaş Görünümü: Karanlık Ustası",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "Yoldaş Görünümü: Yıldırım Topu",
  T_21_R_EMOTE_SORROW_NAME: "Neden? Ah, Neden?!",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "Çanta - Punkçı",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Son Karanlık Darbe",
  T_21_W_M79_RABBITKILLER_N: "M79 - Hipster Tavşan",
  T_21_W_PAN_VOLCANO_N: "Tava - Volkanik Öfke",
  T_21_W_XM8_RAINBOW_N: "XM8 - Boşluk",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Luqueta",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "[FFB300]{0} m[-] içerisinde sürünmeyen ve çömelmeyen tüm düşmanların yerini gösterir. [FFB300]{1} sn[-] sürer. Takım arkadaşları yetenek etkisini paylaşır. Bekleme süresi: [FFB300]{2}s[-].",
  T_22_C_SKILL_NAME_DETECTIVE: "Adım İzleme",
  T_22_C_SKILL_NAME_STREAMERGUY: "Sahne Işığı",
  T_22_L_F_H_COLLEGE: "Genç Kan Çanağı (Kafa)",
  T_22_L_F_S_SUMMER20: "Yaz Aşkı (Ayakkabı)",
  T_22_L_M_A_GREENCOAT: "Yemyeşil Kulüpçü (Maske)",
  T_22_L_M_A_PINKFUR: "Sakura Kulüpçü (Maske)",
  T_22_L_M_A_PLAGUE2: "Veba İfriti (Maske)",
  T_22_L_M_B_FAIM2: "Açlık Ateşi (Alt)",
  T_22_L_M_B_GREENCOAT: "Yemyeşil Kulüpçü (Alt)",
  T_22_L_M_B_PINKFUR: "Sakura Kulüpçü (Alt)",
  T_22_L_M_B_PLAGUE2: "Veba İfriti (Alt)",
  T_22_L_M_B_REDPANTS: "Popüler Kulüpçü (Alt)",
  T_22_L_M_B_TIGERSTRIPE: "Kaplanlı Kulüpçü (Alt)",
  T_22_L_M_H_COLLEGE: "Kıdemli Kan Çanağı (Kafa)",
  T_22_L_M_H_FAIM2: "Açlık Ateşi (Kafa)",
  T_22_L_M_H_GREENCOAT: "Yemyeşil Kulüpçü (Kafa)",
  T_22_L_M_H_PINKFUR: "Sakura Kulüpçü (Kafa)",
  T_22_L_M_H_PLAGUE2: "Veba İfriti (Kafa)",
  T_22_L_M_H_REDPANTS: "Popüler Kulüpçü (Kafa)",
  T_22_L_M_H_TIGERSTRIPE: "Kaplanlı Kulüpçü (Kafa)",
  T_22_L_M_S_FAIM2: "Açlık Ateşi (Ayakkabı)",
  T_22_L_M_S_PLAGUE2: "Veba İfriti (Ayakkabı)",
  T_22_L_M_T_FAIM2: "Açlık Ateşi (Üst)",
  T_22_L_M_T_GREENCOAT: "Yemyeşil Kulüpçü (Üst)",
  T_22_L_M_T_PINKFUR: "Sakura Kulüpçü (Üst)",
  T_22_L_M_T_PLAGUE2: "Veba İfriti (Üst)",
  T_22_L_M_T_REDPANTS: "Popüler Kulüpçü (Üst)",
  T_22_L_M_T_TIGERSTRIPE: "Kaplanlı Kulüpçü (Üst)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98k - Asi Akademisi",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Tava - Karpuz",
  T_22_LC_SCAR_HERMIT_N: "SCAR - Esrarengiz Arayıcı",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Şifa Tabancası - Hayat Işını",
  T_22_O_HAWK_NAME: "Şaho",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "Yoldaş Görünümü: Kıyamet Tilkisi",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "Yoldaş Görünümü: Cehennem Ateşi Şaho",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "Yoldaş Görünümü: Hep Yeşil Şaho",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "Yoldaş Görünümü: Gün Işığı Shiba",
  T_22_Q_BOMB_PLIERS: "Bomba İmha Pensesi",
  T_22_R_EMOTE_SHIMMY_NAME: "Yalpa Dans",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "Zırh Delme",
  T_22_U_WPNSKN_SPEED_RUN: "Hareket Hızı",
  T_22_Y_CHARACTER_DETECTIVE_N: "Clu",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "Ufuk Aşısı",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Kılıç Sanatı",
  T_23_C_SKILL_NAME_SWATGUY: "Öfkeli Doldurma",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'Hayato "Alev Ruhu"',
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Paragöz Müzisyen (Alt)",
  T_23_L_F_B_MIKOGIRL: "Kutup Ateşi Rahibesi (Alt)",
  T_23_L_F_B_NAVYGIRL: "Denizci Kız (Alt)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Paragöz Müzisyen (Kafa)",
  T_23_L_F_H_MIKOGIRL: "Kutup Ateşi Rahibesi (Kafa)",
  T_23_L_F_H_NAVYGIRL: "Denizci Kız (Kafa)",
  T_23_L_F_S_MIKOGIRL: "Kutup Ateşi Rahibesi (Ayakkabı)",
  T_23_L_F_S_ORDERCHALLENGER: "Soygun Planlayıcısı (Ayakkabı)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Paragöz Müzisyen (Üst)",
  T_23_L_F_T_MIKOGIRL: "Kutup Ateşi Rahibesi (Üst)",
  T_23_L_F_T_NAVYGIRL: "Denizci Kız (Üst)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Paragöz Rapçi (Maske)",
  T_23_L_M_B_FOXGUY: "Kutup Ateşi Rahibi (Alt)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Paragöz Rapçi (Alt)",
  T_23_L_M_H_FOXGUY: "Kutup Ateşi Rahibi (Kafa)",
  T_23_LC_SKS_GEMINI_N: "SKS - Histeri",
  T_23_O_PENGUIN_NAME: "Bay Paytarz",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "Yoldaş Görünümü: Parti Paytarz",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "Yoldaş Görünümü: Siber Paytarz",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "Yoldaş Görünümü: Altın Paytarz",
  T_23_T_ANNI3_LOBBY_NODENAME20: "Ekip Çarpışması",
  T_23_T_ANNI3_LOBBY_NODENAME5: "Karakter",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "UYARI",
  T_24_C_FLAMETHROWER_NAME: "Alev Silahı",
  T_24_C_SKILL_DESC_PROFESSOR: "Maksimum EP [FFB300]{0}[-] artar. Jiujitsu Modu: [FFB300]{2} m[-] içerisindeki dostların EP yenileme oranı [FFB300]%{1}[-] artar. Psikoloji Modu: Her [FFB300]{4}[-] saniyede [FFB300]{5}[-]; toplamda [FFB300]{6}[-] EP yeniler. Mod değişimi bekleme süresi [FFB300]{3}[-] saniyedir.",
  T_24_C_SKILL_NAME_PARTYGIRL: "Parti Başlasın",
  T_24_C_SKILL_NAME_PROFESSOR: "Her Şeyin Ustası",
  T_24_D_CHARACTER_PARTYGIRL_N: "Dasha",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "MAX Pantolonu",
  T_24_L_H_PUMPKIN2020_A: "Çarpık Balkabağı (Kafa)",
  T_24_L_T_TSHIRT_COMEDIAN: "Son Mermi Kahramanı",
  T_24_LC_MP5_RICHBOXER_N: "MP5 - Şampiyon Boksör",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR - Parti Bağımlısı",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD - Kılıç Ustası Efsanesi",
  T_24_U_M21A5: "Ağaçkakan",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "Toplam Skor",
  T_24_V_TRAINING_BOX_ATTACH: "Eklentiler",
  T_24_V_TRAINING_BOX_WEAPON: "Silahlar",
  T_24_W_ARMORY: "Silahlar",
  T_24_W_ARMOTY_MELEE: "Yakın",
  T_24_W_ARMOTY_PISTOL: "Tabancalar",
  T_24_W_ARMOTY_RIFLE: "Tüfekler",
  T_24_W_ARMOTY_SHOTGUN: "Pompalı Tüfekler",
  T_24_W_ARMOTY_SNIPER: "Keskin Nişancı Tüfekleri",
  T_24_W_ARMOTY_SPECIAL: "Diğerleri",
  T_24_W_ARMOTY_SUBMACHINE: "Hafif Makineli Tüfekler",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "Yoldaş Görünümü: İşte Booyah Panda",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "Yoldaş Görünümü: İskelet Rakunrol",
  T_24_W_PETSKIN_RACCOON_MECH_N: "Yoldaş Görünümü: Partici Rakunrol",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "Yoldaş Görünümü: Zombi Rakunrol",
  T_24_W_RACCOON_N: "Rakunrol",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "Zaman Döndürücü",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "Ön ayar 1",
  T_25_E_HUD_02: "Ön ayar 2",
  T_25_L_F_B_DEMONKILLER: "Öfkeli Liseli (Alt)",
  T_25_L_F_H_DEMONKILLER: "Öfkeli Liseli (Kafa)",
  T_25_L_F_S_DEMONKILLER: "Öfkeli Liseli (Ayakkabı)",
  T_25_L_F_T_DEMONKILLER: "Öfkeli Liseli (Üst)",
  T_25_L_HA_FP_EVIL: "Kötülük (Yüz Boyası)",
  T_25_L_M_H_ANIMEHAIR: "Esinti (Saç)",
  T_25_L_S_MAXSNEAKERS: "MAX Spor Ayakkabılar",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Sopa - Siber Sallayış",
  T_25_LC_GLOO_WINTERFEST2020_N: "Muhafız Duvar - Kış Diyarı 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887 - Kış Diyarı 2020",
  T_25_LC_MACHETE_BOUNTY_N: "Pala - Siber Kılıç",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90 - Yeşil Akort Patlatan",
  T_25_LC_P90_MUSICFALL_RED_N: "P90 - Kırmızı Akort Patlatan",
  T_25_LC_PAN_BOUNTY_N: "Tava - Siber Kelle Avcısı",
  T_25_R_LEGEND_REMIND: "Hatırlatıcı",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Tırpan",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "Bombabun",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "Yoldaş Görünümü: Buzul Bombabun",
  T_25_W_PETSKIN_BABOON_HELL_N: "Yoldaş Görünümü: Alevli Bombabun",
  T_25_W_PETSKIN_BABOON_PURE_N: "Yoldaş Görünümü: Büyük Beyaz Bombabun",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "Yoldaş Görünümü: Kar Panteri",
  T_25_Z_R_SIMULATOR_OFF: "İzin Verme",
  T_26_C_SKILL_DESC_SUPERSTAR: "[FFB300]{0} m[-] boyunca ileri doğru bir ses dalgası gönderir. Ses dalgası patlar ve [FFB300]{2}sn[-] boyunca[FFB300] {1}m[-] yarıçap içindeki Muhafız Duvarlara hasar verir. Bekleme Süresi: [FFB300]{3} sn[-].",
  T_26_C_SKILL_NAME_SUPERSTAR: "Karışık Ritim",
  T_26_D_CHARACTER_DELIVERY_N: "Shirou",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "İHA-mini",
  T_26_L_A_FLAMING_PREM: "Cehennem Askeri (Maske)",
  T_26_L_A_SANTAMODE: "Kardan Kâmil (Maske)",
  T_26_L_B_SANTAMODE: "Kardan Kâmil (Alt)",
  T_26_L_F_B_WATERFEST21_A: "Yaz Esintisi (Alt)",
  T_26_L_F_H_WATERFEST21_A: "Yaz Esintisi (Kafa)",
  T_26_L_F_S_WATERFEST21_A: "Yaz Esintisi (Ayakkabı)",
  T_26_L_F_T_WATERFEST21_A: "Yaz Esintisi (Üst)",
  T_26_L_M_A_EGGDAY2021: "Siber Tavşan (Maske)",
  T_26_L_M_B_EGGDAY2021: "Siber Tavşan (Alt)",
  T_26_L_M_B_PAIRING: "Erkek Dinamik İkili (Alt)",
  T_26_L_M_B_WATERFEST21_A: "Yaz Dalgası (Alt)",
  T_26_L_M_H_EGGDAY2021: "Siber Tavşan (Kafa)",
  T_26_L_M_H_PAIRING: "Erkek Dinamik İkili (Kafa)",
  T_26_L_M_H_WATERFEST21_A: "Yaz Dalgası (Kafa)",
  T_26_L_M_S_EGGDAY2021: "Siber Tavşan (Ayakkabı)",
  T_26_L_M_S_PAIRING: "Erkek Dinamik İkili (Ayakkabı)",
  T_26_L_M_S_WATERFEST21_A: "Yaz Dalgası (Ayakkabı)",
  T_26_L_M_T_EGGDAY2021: "Siber Tavşan (Üst)",
  T_26_L_M_T_PAIRING: "Erkek Dinamik İkili (Üst)",
  T_26_L_M_T_WATERFEST21_A: "Yaz Dalgası (Üst)",
  T_26_L_S_SANTAMODE: "Kardan Kâmil (Ayakkabı)",
  T_26_L_T_SANTAMODE: "Kardan Kâmil (Üst)",
  T_26_LC_AWM_KOICARP_N: "AWM - Şanslı Koi",
  T_26_LC_KATANA_VALENTINE2021_N: "Katana - Pembe Sezonu",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Spor Araba - Cobra",
  T_26_P_SKILL_NAME_DELIVERY: "Hasar Verildi",
  T_26_V_TRAINING_BHH: "Şatafatlı Çekiç",
  T_26_V_TRAINING_DICE: "Dev Zar",
  T_26_W_DRAGON_N: "Ejdercik",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "Yoldaş Görünümü: Islak Ejdercik",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "Yoldaş Görünümü: Çarpan Ejdercik",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "Yoldaş Görünümü: Galaksi Ejdercik",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "Yoldaş Görünümü: Âşık Paytarz",
  T_26_XL_SETTING_TEAMMATE_INFO: "Takım Arkadaşı Bilgisi",
  T_26_YP_HISTORY_WIN: "Zafer",
  T_26_YP_SOCIAL_GENDER_FEMALE: "Kadın",
  T_26_YP_SOCIAL_GENDER_MALE: "Erkek",
  T_26_YP_SOCIAL_NAME: "Takma Ad",
  T_27_C_SKILL_DESC__RACERGIRL: "Araç sürüş hızı [FFB300]%{0}[-] artar. Araç içerisindeyken, karaktere nişan almak daha zor olur ve alınan hasar [FFB300]%{1}[-] azalır.",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "Rakiplerden gelen [FFB300]{0} [-]hasarı emen bir güç kalkanı oluşturur. Kalkanın içindeyken, dışarıda kalan rakiplere hasar verilemez. Tüm etkilerin süresi [FFB300]{1}sn[-] sürer. Bekleme süresi: [FFB300]{2}sn.[-]",
  T_27_C_SKILL_DESC_FALCONER: "[FFB300]%{0}[-] kadara olmak üzere, mesafe ile beraber hasar da artar. İşaretlenmiş rakiplere verilen hasar [FFB300]%{1} [-]artar.",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "Uyanış: Kaybettiğin her [FFB300]%{0}[-] CP için önden aldığın hasar [FFB300]%{1}[-] azalır.",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "Uyanış: Etkinleştirmek için [FFB300]{0}sn[-] boyunca depar at. Etkinleştirildiğinde, ilk [FFB300]{2}[-] atış, [FFB300]%{1}[-] hasar verir. [FFB300]{3} [-]saniye sürer.",
  T_27_C_SKILL_NAME_FALCONER: "Şahin Coşkusu",
  T_27_C_SKILL_NAME_XTREME: "Ekstrem Karşılaşma",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: '"Haşin" Andrew',
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Xayne",
  T_27_F_EAP_PKG3_D: "Tarz sahibi olarak çatış!",
  T_27_HYL_SKILLBOARD_HP: "CP",
  T_27_L_A_CARDBOARD_MID2: "Karton Kaplan (Maske)",
  T_27_L_B_CARDBOARD_REG: "Karton Ayı (Alt)",
  T_27_L_M_S_KAZAKHSTAN: "Baghatur (Ayakkabı)",
  T_27_L_S_CARDBOARD_REG: "Karton Ayı (Ayakkabı)",
  T_27_L_T_CARDBOARD_REG: "Karton Ayı (Üst)",
  T_27_LC_VECTOR_FFWS2021_N: "Vektör - FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Canavar Kamyon - FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Motosiklet - Nakavt Gecesi",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Spor Araba - Zümrüt Parıltı",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Kamyonet - Alevli Draco",
  T_27_P_SKILL_NAME_HITMAN_RE: "Ölüm Sessizliği",
  T_27_R_EMOTE_GREETING_NAME: "Merhaba",
  T_27_R_VEHICLE_ACCELERATION: "İvme",
  T_27_R_VEHICLE_HP: "Dayanıklılık",
  T_27_R_VEHICLE_SPEED: "Maks Hız",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "Uyanış: Zırh hasarı azaltımı [FFB300]{0}[-] oranında artırıldı. [FFB300]{2}m[-] içindeki her takım arkadaşı için ek [FFB300]{1}[-] hasar azaltımı.",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "Kurt Sürüsü",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "Aylı",
  T_27_W_ARMOTY_DMR: "Nişancı Tüfeği",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "Ortak Kostümü: Kristal Aylı",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "Ortak Kostümü: Oyuncu Aylı",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "Ortak Kostümü: Hipster Aylı",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "Ortak Kostümü: FFWS 2021 Köpeciği",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "Ortak Kostümü: FFWS 2021 Panda",
  T_27_XC_REPLAY_DIE: "Ölüm",
  T_27_XC_REPLAY_KILL: "Leş",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "Tamir Et",
  T_28_C_G_ICE_NAME: "Donuk Flaş",
  T_28_C_SKILL_DESC_STREETBEAT: "Hareket ederken ateş edince hareket hızı [FFB300]%{0}[-], isabetlilik [FFB300]%{1}[-] artar.",
  T_28_C_SKILL_NAME_STREETBEAT: "Mermi Ritmi",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "23 Numaralı Futbol Forması (Alt)",
  T_28_L_B_BRJERSEY_B: "10 Numaralı Futbol Forması (Alt)",
  T_28_L_B_BRJERSEY_C: "24 Numaralı Futbol Forması (Alt)",
  T_28_L_B_BRJERSEY_D: "30 Numaralı Futbol Forması (Alt)",
  T_28_L_B_BRJERSEY_E: "1 Numaralı Futbol Forması (Alt)",
  T_28_L_B_BRJERSEY_F: "20 Numaralı Futbol Forması (Alt)",
  T_28_L_F_B_FOURSYMBOLS_C: "Kızıl Kasırga (Alt)",
  T_28_L_F_H_FOURSYMBOLS_C: "Kızıl Kasırga (Kafa)",
  T_28_L_F_HA_FOURSYMBOLS_C: "Kızıl Kasırga (Yüz Boyası)",
  T_28_L_F_S_FOURSYMBOLS_C: "Kızıl Kasırga (Ayakkabı)",
  T_28_L_F_T_FOURSYMBOLS_C: "Kızıl Kasırga (Üst)",
  T_28_L_HA_THUNDER: "Yıldırımlı Gözler (Yüz Boyası)",
  T_28_L_M_A_SPORTSUIT: "Yürekli Kaykaycı (Maske)",
  T_28_L_M_B_FOURSYMBOLS_D: "Gölgeli Deprem Getiren (Alt)",
  T_28_L_M_B_SPORTSUIT: "Yürekli Kaykaycı (Alt)",
  T_28_L_M_H_FOURSYMBOLS_D: "Gölgeli Deprem Getiren (Kafa)",
  T_28_L_M_H_SPORTSUIT: "Yürekli Kaykaycı (Kafa)",
  T_28_L_M_S_FOURSYMBOLS_D: "Gölgeli Deprem Getiren (Ayakkabı)",
  T_28_L_M_S_SPORTSUIT: "Yürekli Kaykaycı (Ayakkabı)",
  T_28_L_M_T_FALLWINTER: "Pişkin Tarz (Üst)",
  T_28_L_M_T_FOURSYMBOLS_D: "Gölgeli Deprem Getiren (Üst)",
  T_28_L_M_T_SPORTSUIT: "Yürekli Kaykaycı (Üst)",
  T_28_L_T_BRJERSEY_A: "23 Numaralı Futbol Forması (Üst)",
  T_28_L_T_BRJERSEY_B: "10 Numaralı Futbol Forması (Üst)",
  T_28_L_T_BRJERSEY_C: "24 Numaralı Futbol Forması (Üst)",
  T_28_L_T_BRJERSEY_D: "30 Numaralı Futbol Forması (Üst)",
  T_28_L_T_BRJERSEY_E: "1 Numaralı Futbol Forması (Üst)",
  T_28_L_T_BRJERSEY_F: "20 Numaralı Futbol Forması (Üst)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94 - Yakut Gelin",
  T_28_LC_GLOO_FALLWINTER_N: "Muhafız Duvar - Pişkin Tarz",
  T_28_LC_GLOO_FOURSYMBOLS_N: "Muhafız Duvar - Fırtına Getiren",
  T_28_LC_KORD_SHINOBI_N: "Kord - Tehlikeli Kıvılcım Shinobi",
  T_28_LC_M21A5_FANTASYEYE_N: "Ağaçkakan - Merhametsiz Kara Büyücü",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - Tehlikeli Yüzen Dişler",
  T_28_LC_PAN_FOURSYMBOLS_N: "Tava - Deprem Getiren",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Cip - Fırtına Getiren",
  T_28_T_WS_ITEM1: "Kare Kutu",
  T_28_T_WS_ITEM10: "Kulübe",
  T_28_T_WS_ITEM11: "Nöbet Kulesi",
  T_28_T_WS_ITEM12: "Karakol",
  T_28_T_WS_ITEM13: "A Evi",
  T_28_T_WS_ITEM14: "B Evi",
  T_28_T_WS_ITEM15: "C Evi",
  T_28_T_WS_ITEM16: "Kum Yapısı",
  T_28_T_WS_ITEM17: "Çeşme",
  T_28_T_WS_ITEM18: "Kiraz Çiçeği",
  T_28_T_WS_ITEM19: "Muz Ağacı",
  T_28_T_WS_ITEM2: "Uzun Kutu",
  T_28_T_WS_ITEM20: "Tuvalet",
  T_28_T_WS_ITEM21: "Çit",
  T_28_T_WS_ITEM3: "Çalı",
  T_28_T_WS_ITEM4: "Saman",
  T_28_T_WS_ITEM5: "Araba",
  T_28_T_WS_ITEM6: "Otobüs",
  T_28_T_WS_ITEM7: "A Konteyneri",
  T_28_T_WS_ITEM8: "B Konteyneri",
  T_28_T_WS_ITEM9: "C Konteyneri",
  T_28_T_WS_TYPE1: "Nesneler",
  T_28_T_WS_TYPE4: "Dekorasyon",
  T_28_W_DUCK_N: "Dr. Bereli",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "Yoldaş Görünümü: Mythos Ejdercik",
  T_28_W_PETSKIN_DUCK_ARMY_N: "Yoldaş Görünümü: Çvş. Bereli",
  T_28_W_PETSKIN_DUCK_BLACK_N: "Yoldaş Görünümü: Çeteci Bereli",
  T_28_W_PETSKIN_DUCK_SHINY_N: "Yoldaş Görünümü: DJ Bereli",
  T_28_YF_AR15: "Yalıçapkını",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "Uyanış: Rakipler hareket ettikçe üzerlerindeki işaretler daha uzun süre kalır. [FFB300]{0}s [-]sürer.",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "Sırların Gözü",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "Hayati Titreşimler",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "İyileştiren Kalp Atışı",
  T_29_D_CHARACTER_AMOCO_N: '"Sırra Kadem" Moco',
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Kırmızı Beyaz Forma (Alt)",
  T_29_L_M_A_FALCONER_C: "Leopar Şıklığı (Maske)",
  T_29_L_M_A_JUNGLE_GREEN: "Zırh-lumbağa (Maske)",
  T_29_L_M_B_FALCONER_C: "Leopar Şıklığı (Alt)",
  T_29_L_M_B_JUNGLE_GREEN: "Zırh-lumbağa (Alt)",
  T_29_L_M_H_FALCONER_C: "Leopar Şıklığı (Kafa)",
  T_29_L_M_H_JUNGLE_GREEN: "Zırh-lumbağa (Kafa)",
  T_29_L_M_S_FALCONER_C: "Leopar Şıklığı (Ayakkabı)",
  T_29_L_M_S_JUNGLE_GREEN: "Zırh-lumbağa (Ayakkabı)",
  T_29_L_M_T_FALCONER_C: "Leopar Şıklığı (Üst)",
  T_29_L_M_T_JUNGLE_GREEN: "Zırh-lumbağa (Üst)",
  T_29_L_T_TRJERSEY: "Kırmızı Beyaz Forma (Üst)",
  T_29_M_WS_ITEM22: "Sağlam Konteyner",
  T_29_M_WS_ITEM23: "Sağlam Çit",
  T_29_M_WS_ITEM24: "A Başlangıç Noktası",
  T_29_M_WS_ITEM25: "B Başlangıç Noktası",
  T_29_M_WS_TYPE5: "Etkileşimler",
  T_29_W_PETSKIN_BROWN_TIGER_N: "Yoldaş Kostümü: Topraklı Kaplan Usta",
  T_29_W_PETSKIN_FIRE_TIGER_N: "Yoldaş Kostümü: Alevli Kaplan Usta",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "Yoldaş Kostümü: Siber Şaho",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "Yoldaş Kostümü: Panda Partisi",
  T_29_W_PETSKIN_WHITE_TIGER_N: "Yoldaş Kostümü: Buzlu Kaplan Usta",
  T_29_W_TIGER_NINJA_N: "Kaplan Usta",
  T_29_YF_MACHETE_MUSICFEST_N: "Pala - Ses Dalgası Palası",
  T_29_YF_MAGEZINE_CHAIN_N: "TT Şarjörü",
  T_29_YF_MUZZLE_CRASH_N: "HMT Ağızlığı",
  T_29_YF_MUZZLE_WIDE_N: "Pompalı Tüfek Ağızlığı",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12 - Kozmik Operatör",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi - Kehribar Gardiyan",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Canavar Kamyon - Yol Bekçisi",
  T_30_AD_RP_ROUNDEND: "TUR BİTTİ",
  T_30_AD_TRAINING_SNOWBALL: "Kartopu",
  T_30_AD_TRAINING_SNOWBALL_DES: "Gel ve kartopu savaşı yapalım!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-], saldırıya uğradıktan sonra, [FFB300]{2}s[-] boyunca [FFB300]{1}HP[-]/sn doldurur",
  T_30_C_SKILL_NAME_BOOYAHGUY: "Son Saniye",
  T_30_C_SKILL_NAME_MUERTOGUY: "Hafıza Sisi",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Otho",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Jai'in Mikroçipi",
  T_30_L_A_BRMASCOT_ADULT: "Sinirli Civciv Kafası",
  T_30_L_A_BRMASCOT_KIDS: "Tatlı Civciv Kafası",
  T_30_L_A_SUGARSKULL21_BANDANA: "Ölümcül Isırış Maskesi",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF Futbol Forması - Siyah (Alt)",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF Futbol Forması - Yeşil (Alt)",
  T_30_L_B_BRFOOTBALL_GREY: "CBF Futbol Forması - Gri (Alt)",
  T_30_L_B_BRUNIFORM: "Küçük Kanarya (Alt)",
  T_30_L_F_A_SUGARSKULL21: "Altınyakalı Kraliçe (Maske)",
  T_30_L_F_B_SUGARSKULL21: "Altınyakalı Kraliçe (Alt)",
  T_30_L_F_B_THASIAN: "Mercan Belası (Alt)",
  T_30_L_F_H_CATEARS: "Tatlış Kulaklar",
  T_30_L_F_H_SUGARSKULL21: "Altınyakalı Kraliçe (Kafa)",
  T_30_L_F_H_THASIAN: "Mercan Belası (Kafa)",
  T_30_L_F_S_SUGARSKULL21: "Altınyakalı Kraliçe (Ayakkabı)",
  T_30_L_F_S_THASIAN: "Mercan Belası (Ayakkabı)",
  T_30_L_F_T_SUGARSKULL21: "Altınyakalı Kraliçe (Üst)",
  T_30_L_F_T_THASIAN: "Mercan Belası (Üst)",
  T_30_L_H_CHILDRENSDAY_BLUE: "Yunus Kafası",
  T_30_L_H_CHILDRENSDAY_RED: "Fil Kafası",
  T_30_L_H_CLOWNHAT: "Sirk Şapkası - Sarı",
  T_30_L_H_ZASCARF: "Cüretkâr Altın Eşarp",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Taşralı Eşkıya (Maske)",
  T_30_L_M_A_SUGARSKULL21: "Altınyakalı Kral (Maske)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Taşralı Eşkıya (Alt)",
  T_30_L_M_B_PKCRICKET: "Yeşilli Şampiyon (Alt)",
  T_30_L_M_B_SUGARSKULL21: "Altınyakalı Kral (Alt)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Rüzgâr Yarışçısı (Alt)",
  T_30_L_M_B_THASIAN: "Mercan Asisi (Alt)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Taşralı Eşkıya (Kafa)",
  T_30_L_M_H_SUGARSKULL21: "Altınyakalı Kral (Kafa)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Rüzgâr Yarışçısı (Kafa)",
  T_30_L_M_H_THASIAN: "Mercan Asisi (Kafa)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Alfa Kemik Canavarı (Yüz Boyası)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Taşralı Eşkıya (Ayakkabı)",
  T_30_L_M_S_PKCRICKET: "Yeşilli Şampiyon (Ayakkabı)",
  T_30_L_M_S_SUGARSKULL21: "Altınyakalı Kral (Ayakkabı)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Rüzgâr Yarışçısı (Ayakkabı)",
  T_30_L_M_S_THASIAN: "Mercan Asisi (Ayakkabı)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Taşralı Eşkıya (Üst)",
  T_30_L_M_T_PKCRICKET: "Yeşilli Şampiyon (Üst)",
  T_30_L_M_T_SUGARSKULL21: "Altınyakalı Kral (Üst)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Rüzgâr Yarışçısı (Üst)",
  T_30_L_M_T_THASIAN: "Mercan Asisi (Üst)",
  T_30_L_S_BRUNIFORM: "Küçük Kanarya (Ayakkabı)",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF Futbol Forması - Siyah (Üst)",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF Futbol Forması - Yeşil (Üst)",
  T_30_L_T_BRFOOTBALL_GREY: "CBF Futbol Forması - Gri (Üst)",
  T_30_L_T_BRUNIFORM: "Küçük Kanarya (Üst)",
  T_30_M_WS_PARTY_MODE: "Oyun Alanı",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Hodri Meydan",
  T_30_R_EMOTE_MAX_NAME: "Rap Tarzı",
  T_30_R_LEGEND_HALO_NAME: "Sıcaklık Dalgası",
  T_30_T_WS_DEFAULTDESCRIPTION: "Free Fire Üretim Diyarı'nda heyecan verici bir harita.",
  T_30_T_WS_ITEM26: "Lastikler",
  T_30_T_WS_ITEM27: "Pis Lastikler A",
  T_30_T_WS_ITEM28: "Pis Lastikler B",
  T_30_T_WS_ITEM29: "Pis Lastikler C",
  T_30_T_WS_ITEM30: "Çarpışan Araba",
  T_30_T_WS_ITEM31: "Yüzen Araba",
  T_30_T_WS_ITEM32: "Cip",
  T_30_T_WS_ITEM33: "Çöp Tenekesi",
  T_30_T_WS_ITEM34: "Gölge",
  T_30_T_WS_ITEM35: "Tıbbi Çadır",
  T_30_T_WS_ITEM36: "Garaj",
  T_30_T_WS_ITEM37: "Boyalı Duvarlar",
  T_30_T_WS_ITEM38: "Torii",
  T_30_T_WS_ITEM39: "Demir Platform",
  T_30_T_WS_ITEM40: "Şantiye Kulübesi",
  T_30_T_WS_ITEM41: "Karavan",
  T_30_T_WS_ITEM42: "Duvar A",
  T_30_T_WS_ITEM43: "Duvar B",
  T_30_T_WS_ITEM44: "Duvar C",
  T_30_T_WS_ITEM45: "Duvar D",
  T_30_T_WS_ITEM46: "Duvar E",
  T_30_T_WS_ITEM47: "Duvar F",
  T_30_U_ATTACHMENT_1: "Kalkan Güçlendirici",
  T_30_U_ATTACHMENT_4: "Yelek Kaplama",
  T_30_U_ATTACHMENT_5: "Kask Kaplama",
  T_30_U_ATTACHMENT_6: "Yelek Kaplama",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "Yoldaş Kostümü: Kafatası Bombabun",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "Yoldaş Kostümü: Punk Paytarz",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "Yoldaş Kostümü: Nişancı Ajan Zıp",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "Yoldaş Kostümü: Karnaval Ajan Zıp",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "Yoldaş Kostümü: Siber Ajan Zıp",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "Yoldaş Kostümü: Nazar Robo",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "Yolda Kostümü: Donuk Yeşil Robo",
  T_30_W_RABBIT_N: "Ajan Zıp",
  T_30_XH_PCMAP_P17: "Fabrika",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Muhafız Duvar - İŞTE BOOYAH GÜNÜ 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "El Bombası - İŞTE BOOYAH GÜNÜ 2021",
  T_30_YF_Healinggun_Sniper_N: "Şifa Tüfeği",
  T_30_YF_MINI_LIGHTFEST_N: "AC80 - Kraliyet Savaşçısı",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL - Kızıl Vâris",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR - Kraliyet Savaşçısı",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson - Altınyakalı Hediyesi",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Spor Araba - Kafataslı Punkçı",
  T_31_C_SKILL_NAME_WINTERGUY: "Buz Demir",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Kış Sopası",
  T_31_HQ_GLOO_EAGLE_N: "Muhafız Duvar - Kızgın Kum Prensi",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "Şifa Tüfeği - Buzul Kemikler",
  T_31_HQ_KATANA_WINTERFEST21_N: "Katana - Karlı Kıyamet",
  T_31_HQ_PAN_WINTERFEST21_N: "Tava - Karlı Kıyamet",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "Yoldaş Görünümü: Karlı Samuro",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "Yoldaş Görünümü: Buzul Paytarz",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "Yoldaş Görünümü: Kabile Yetisi",
  T_31_HQ_PETSKIN_YETI_RED_N: "Yoldaş Görünümü: Alevli Yeti",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Tırpan - Kar",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "Motosiklet - Buzul Tomurcuk",
  T_31_HQ_YETI_N: "Yeti",
  T_31_KK_WINTER_BUJIX: "İkmal Sandığı",
  T_31_KK_WINTER_SANJITOU: "Kasket",
  T_31_L_A_BDCRICKET: "Kriket Uzmanı (Maske)",
  T_31_L_A_WINTERFEST21: "Ren Geyiği Örtüsü",
  T_31_L_B_BDCRICKET: "Kriket Uzmanı (Alt)",
  T_31_L_B_MEJERSEY_10: "10 Numara Kızıl Forma (Alt)",
  T_31_L_B_MEJERSEY_11: "11 Numara Kırmızı Forma (Alt)",
  T_31_L_B_MEJERSEY_13: "13 Numara Beyaz Forma (Alt)",
  T_31_L_B_MEJERSEY_18G: "18 Numara Yeşil Forma (Alt)",
  T_31_L_B_MEJERSEY_18R: "18 Numara Kestane Forma (Alt)",
  T_31_L_B_MEJERSEY_7: "7 Numara Brezilya Forması (Alt)",
  T_31_L_F_B_RUMUSICIAN: "Sargılı TRANS (Alt)",
  T_31_L_F_B_THAGENT: "Gece Provokatörü (Alt)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Reggae Kovası",
  T_31_L_F_H_RUMUSICIAN: "Sargılı TRANS (Kafa)",
  T_31_L_F_H_THAGENT: "Gece Provokatörü (Kafa)",
  T_31_L_F_HA_RUMUSICIAN: "Sargılı TRANS (Yüz Boyası)",
  T_31_L_F_S_RUMUSICIAN: "Sargılı TRANS (Ayakkabı)",
  T_31_L_F_S_THAGENT: "Gece Provokatörü (Ayakkabı)",
  T_31_L_F_T_RUMUSICIAN: "Sargılı TRANS (Üst)",
  T_31_L_F_T_THAGENT: "Gece Provokatörü (Üst)",
  T_31_L_HA_RUMUSICIAN_MU: "Yıldız Kapanı (Yüz Boyası)",
  T_31_L_HA_WINTERFEST21_BLUE: "Donmuş Palyaço Yüz Boyası",
  T_31_L_HA_WINTERFEST21_PINK: "Pembe Havai Fişek Yüz Boyası",
  T_31_L_M_A_REGGAETON_B: "Neon Reggae (Maske)",
  T_31_L_M_A_REGGAETON_P: "Coşkun Kibir (Maske)",
  T_31_L_M_A_RUMUSICIAN: "Sargılı T.R.A.P (Maske)",
  T_31_L_M_A_THAGENT: "Gece Akıncısı (Maske)",
  T_31_L_M_B_PKCOSTUME: "Bilge Yeşil (Alt)",
  T_31_L_M_B_REGGAETON_B: "Neon Reggae (Alt)",
  T_31_L_M_B_REGGAETON_P: "Coşkun Kibir (Alt)",
  T_31_L_M_B_RUMUSICIAN: "Sargılı T.R.A.P (Alt)",
  T_31_L_M_B_THAGENT: "Gece Akıncısı (Alt)",
  T_31_L_M_H_GREENCAP: "Kazanan Şapkası",
  T_31_L_M_H_PKCOSTUME: "Bilge Yeşil (Kafa)",
  T_31_L_M_H_REGGAETON_B: "Neon Reggae (Kafa)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Reggae Şapkası",
  T_31_L_M_H_REGGAETON_P: "Coşkun Kibir (Kafa)",
  T_31_L_M_H_RUMUSICIAN: "Sargılı T.R.A.P (Kafa)",
  T_31_L_M_H_THAGENT: "Gece Akıncısı (Kafa)",
  T_31_L_M_S_PKCOSTUME: "Bilge Yeşil (Ayakkabı)",
  T_31_L_M_S_REGGAETON_B: "Neon Reggae (Ayakkabı)",
  T_31_L_M_S_REGGAETON_P: "Coşkun Kibir (Ayakkabı)",
  T_31_L_M_S_RUMUSICIAN: "Sargılı T.R.A.P (Ayakkabı)",
  T_31_L_M_S_THAGENT: "Gece Akıncısı (Ayakkabı)",
  T_31_L_M_T_PKCOSTUME: "Bilge Yeşil (Üst)",
  T_31_L_M_T_REGGAETON_B: "Neon Reggae (Üst)",
  T_31_L_M_T_REGGAETON_P: "Coşkun Kibir (Üst)",
  T_31_L_M_T_REGGAETON_TATOO: "Aile Dövmesi",
  T_31_L_M_T_RUMUSICIAN: "Sargılı T.R.A.P (Üst)",
  T_31_L_M_T_THAGENT: "Gece Akıncısı (Üst)",
  T_31_L_S_BDCRICKET: "Kriket Uzmanı (Ayakkabı)",
  T_31_L_T_BDCRICKET: "Kriket Uzmanı (Üst)",
  T_31_L_T_BRBANK: "Bordo Bombacı",
  T_31_L_T_MEJERSEY_10: "10 Numara Kızıl Forma (Üst)",
  T_31_L_T_MEJERSEY_11: "11 Numara Kırmızı Forma (Üst)",
  T_31_L_T_MEJERSEY_13: "13 Numara Beyaz Forma (Üst)",
  T_31_L_T_MEJERSEY_18G: "18 Numara Yeşil Forma (Üst)",
  T_31_L_T_MEJERSEY_18R: "18 Numara Kestane Forma (Üst)",
  T_31_L_T_MEJERSEY_7: "7 Numara Brezilya Forması (Üst)",
  T_31_L_T_PKMOBILE: "Sonsuzluk Tişörtü",
  T_31_L_T_REGGAETON_HOOD: "Halkım İçin",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "1 Numara",
  T_31_RW_COMBINEMACHINE_2: "Akimbo Etkinleştirici (Gelişmiş)",
  T_31_RW_VIBRATION_EXPLOSION: "Patlamalar",
  T_31_RW_VIBRATION_MELEEWEAPONS: "Yakın menzilli silahlar",
  T_31_RW_VIBRATION_OTHERWEAPONS: "Diğer silahlar",
  T_31_T_WS_1PLAYERTEAM: "Tekli",
  T_31_T_WS_2PLAYERTEAM: "İkili",
  T_31_T_WS_3PLAYERTEAM: "Üçlü",
  T_31_T_WS_4PLAYERTEAM: "Takım",
  T_31_T_WS_5PLAYERTEAM: "Beşli",
  T_31_T_WS_6PLAYERTEAM: "Altılı",
  T_31_T_WS_BUFFTIME_TITLE: "Yenileme Süresi (sn)",
  T_31_T_WS_BUFFTYPE_AMMO: "Cephane",
  T_31_T_WS_BUFFTYPE_ARMOR: "Zırh",
  T_31_T_WS_BUFFTYPE_HP: "CP",
  T_31_T_WS_BUFFTYPE_RANDOM: "Rastgele",
  T_31_T_WS_BUFFTYPE_TITLE: "Güçlendirme Tipi",
  T_31_T_WS_DESC48: "Birkaç milisaniyede seni başka bir yere götürür.",
  T_31_T_WS_DESC49: "Piyano sesi çıkartır.",
  T_31_T_WS_DESC51: "Davul sesi çıkartır.",
  T_31_T_WS_DESC53: "Sentezleyici sesi çıkartır.",
  T_31_T_WS_DESC59: "Periyodik olarak bir güçlendirme üreten bir cihaz. Güçlendirmeyi edinmek için cihazı al.",
  T_31_T_WS_DRUMTYPE_CLAPS: "Alkış",
  T_31_T_WS_DRUMTYPE_HIHATS: "Bateri",
  T_31_T_WS_DRUMTYPE_KICK: "Davulu Tekmele",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Bateri Açılıyor",
  T_31_T_WS_DRUMTYPE_RIDES: "Zil Sür",
  T_31_T_WS_DRUMTYPE_SNARES: "Trampet",
  T_31_T_WS_EARLYSHRINK: "Çabuk Daraltma",
  T_31_T_WS_ITEM48: "Portal",
  T_31_T_WS_ITEM49: "Piyano Tuşu",
  T_31_T_WS_ITEM51: "Davul Anahtarı",
  T_31_T_WS_ITEM53: "Kombo Tuşu A",
  T_31_T_WS_ITEM55: "Kombo Tuşu B",
  T_31_T_WS_ITEM57: "Kombo Tuşu C",
  T_31_T_WS_ITEM59: "Güçlendirme Üreticisi",
  T_31_T_WS_LATESHRINK: "Geç Daraltma",
  T_31_T_WS_ME_DAMAGE: "Verilen Hasar",
  T_31_T_WS_ME_DAMAGED: "Alınan Hasar",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "İlk EP Oranı",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "İlk Güvenli Bölge Alanı",
  T_31_T_WS_ME_EPQUICKRESTORE: "Hızlı EP Dönüştürme",
  T_31_T_WS_ME_FLOW: "Mod",
  T_31_T_WS_ME_GENERALSETTING: "Genel",
  T_31_T_WS_ME_INRANDOMSPAWN: "Rastgele dirilme noktası",
  T_31_T_WS_ME_KILLSCORE: "Leş Bonusu",
  T_31_T_WS_ME_MAXEP: "Maksimum EP",
  T_31_T_WS_ME_MAXHP: "Maksimum CP",
  T_31_T_WS_ME_NEARTEAM: "Takım arkadaşları civarında",
  T_31_T_WS_ME_REBIRTH: "Dirilme Bekleme Süresi",
  T_31_T_WS_ME_REBIRTHLOCATION: "Dirilme Bölgesi",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "Alan Küçülme Süresi",
  T_31_T_WS_ME_WINSCORE: "Kazanma Skoru",
  T_31_T_WS_MINIZONE: "Mini Bölge",
  T_31_T_WS_MUSICTYPE_TITLE: "Müzik Tipi",
  T_31_T_WS_UNLIMITEDAMMO: "Sınırsız Cephane",
  T_31_WT_WS_DESC1: "İstiflenebilen kare bir ahşap kutu.",
  T_31_WT_WS_DESC10: "Yukarı tırmanmak için ahşap merdivenleri olan köhne bir kulübe",
  T_31_WT_WS_DESC11: "Çekim amaçları için birden fazla pencere ile oluşturulmuştur",
  T_31_WT_WS_DESC12: "Metalden yapılmış ve kapı ile pencereleri içerir",
  T_31_WT_WS_DESC13: "Kapıları ve pencereleri içerir",
  T_31_WT_WS_DESC14: "Teraslı iki katlı bir ev",
  T_31_WT_WS_DESC15: "Mühürlü çatılı iki katlı bir ev",
  T_31_WT_WS_DESC16: "Dekor - kalp şeklinde kumdan bir heykel",
  T_31_WT_WS_DESC17: "Dekor - kristal berraklığında su çeşmesi",
  T_31_WT_WS_DESC18: "Dekor - pembe çiçekli bir ağaç",
  T_31_WT_WS_DESC19: "Dekor - muz içermeyen küçük bir muz ağacı",
  T_31_WT_WS_DESC2: "İstiflenebilen dikdörtgen bir ahşap kutu.",
  T_31_WT_WS_DESC20: "İç mekanlara yerleştirilebilen beyaz bir banyo mobilyası",
  T_31_WT_WS_DESC21: "Alanları bölmek için kullanılabilecek küçük bir çit",
  T_31_WT_WS_DESC22: "Bu konteynerin yan ahşap levhası zorla kırılabilir.",
  T_31_WT_WS_DESC23: "Zorla kırılabilen küçük bir çit",
  T_31_WT_WS_DESC24: "A Takımı Başlangıç Bölgesi (Sadece Ekip Çarpışması, Takım Ölüm Maçı ve Oyun Alanı modlarında geçerli)",
  T_31_WT_WS_DESC25: "B Takımı Başlangıç Bölgesi (Sadece Ekip Çarpışması, Takım Ölüm Maçı ve Oyun Alanı modlarında geçerli)",
  T_31_WT_WS_DESC26: "Oyuncuları kısa bir mesafe için yüzlerinin dönük olduğu yöne fırlatır",
  T_31_WT_WS_DESC27: "Oyuncuları kısa bir mesafe için önceden ayarlanmış yöne fırlatır.",
  T_31_WT_WS_DESC28: "Orta mesafe için oyuncuları önceden ayarlanmış yöne fırlatır.",
  T_31_WT_WS_DESC29: "Oyuncuları uzun bir mesafe için önceden ayarlanmış yöne fırlatır",
  T_31_WT_WS_DESC3: "Savaş alanını aydınlatabilecek kırmızı ve sarı çiçeklerle süslenmiş",
  T_31_WT_WS_DESC30: "Sürülebilen bir çarpışan araba",
  T_31_WT_WS_DESC31: "Sürülebilen bir yüzen araba",
  T_31_WT_WS_DESC32: "Sürülebilen bir cip",
  T_31_WT_WS_DESC33: "Çöple dolu. Bir insandan daha kısa ama biraz koruma sağlayabilir.",
  T_31_WT_WS_DESC34: "Açık hava, metalik yarış pisti barınağı.",
  T_31_WT_WS_DESC35: "İki kapılı ancak penceresiz orta boy bir çadır.",
  T_31_WT_WS_DESC36: "Tuğladan yapılmış büyük bir garaj.",
  T_31_WT_WS_DESC37: "Alanları bölmek için kullanılabilecek büyük bir tuğla duvar.",
  T_31_WT_WS_DESC38: "Kullanışlı bir işaret noktası",
  T_31_WT_WS_DESC39: "Ana dövüş çukuru olarak kullanılabilecek büyük bir metalik platform.",
  T_31_WT_WS_DESC4: "Bir insandan daha uzun, bu yüzden siper olarak kullanılabilir.",
  T_31_WT_WS_DESC40: "Eğlence aracına benziyor ve birden fazla kapısı ve penceresi var.",
  T_31_WT_WS_DESC41: "Bir eğlence aracına benziyor ve bir kapısı ve birden çok penceresi var.",
  T_31_WT_WS_DESC42: "Girişi olan tek taraflı bir duvar.",
  T_31_WT_WS_DESC43: "Normal tek taraflı duvar.",
  T_31_WT_WS_DESC44: "Bir duvar köşesi.",
  T_31_WT_WS_DESC45: "Yamuk duvar köşesi.",
  T_31_WT_WS_DESC46: "Yamuk duvar köşesi.",
  T_31_WT_WS_DESC47: "Pencereli bir duvar köşesi",
  T_31_WT_WS_DESC5: "Bir insandan biraz daha kısa olan ancak bir miktar koruma sağlayabilen terk edilmiş bir araba",
  T_31_WT_WS_DESC6: "Bir insandan daha uzun, bu yüzden siper olarak kullanılabilir.",
  T_31_WT_WS_DESC7: "Her iki ucu açık ve yollar oluşturmak veya alanları bölmek için düzenlenebilir",
  T_31_WT_WS_DESC8: "Bir ucu açık ve alanları bölmek için kullanılabilir",
  T_31_WT_WS_DESC9: "Her iki uçta sızdırmazdır ve alanları bölmek için kullanılabilir",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "Araç",
  T_31_Z_OB_UAV: "İHA",
  T_32_C_SKILL_DESC_YAKUZA: "[FFB300]{0}s[-] boyunca yüksek hızda ileri atılır. Bu beceri, her kullanım arasında [FFB300]{3}[-] saniyelik bekleme süresi ile [FFB300]{2} defaya[-] kadar art arda kullanım için biriktirilebilir. Bekleme süresi [FFB300]{1}s[-].",
  T_32_C_SKILL_NAME_YAKUZA: "Asi Acelesi",
  T_32_HQ_AUG_VNSTREET_N: "AUG - Kükreyen Nişancı",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Çanta - Gün Batımı Ejderi",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B - Vampir Lordu",
  T_32_HQ_GLOO_DUNHUANG_N: "Muhafız Duvar - Donmuş Platinyum",
  T_32_HQ_GLOO_HURRICANE_2_N: "Muhafız Duvar - Kuzey Işığı Çekirdeği",
  T_32_HQ_GRENADE_HURRICANE_N: "El Bombası - Mekanik Mikrofon",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10 - Donmuş Platinyum",
  T_32_HQ_PETSKIN_DUCK_RED_N: "Yoldaş Görünümü: Kırmızı Bereli",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "Yoldaş Görünümü: Siber Flaş",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "Yoldaş Görünümü: Oyuncu Flaş",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "Yoldaş Görünümü: Festivalci Flaş",
  T_32_HQ_TORTOISE_N: "Flaş",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Spor Arabası - Gömülü Eflatun Tozu",
  T_32_L_F_A_PHARAOH: "Altın Sargılı Cleo (Maske)",
  T_32_L_F_B_PHARAOH: "Altın Sargılı Cleo (Alt)",
  T_32_L_F_H_PHARAOH: "Altın Sargılı Cleo (Kafa)",
  T_32_L_F_HA_PHARAOH: "Altın Sargılı Cleo (Yüz Boyası)",
  T_32_L_F_S_PHARAOH: "Altın Sargılı Cleo (Ayakkabı)",
  T_32_L_F_T_PHARAOH: "Altın Sargılı Cleo (Üst)",
  T_32_L_M_A_JUNKFOOD: "Burger Çocuk (Maske)",
  T_32_L_M_A_PHARAOH: "Altın Sargılı Mumya (Maske)",
  T_32_L_M_B_JUNKFOOD: "Burger Çocuk (Alt)",
  T_32_L_M_B_PHARAOH: "Altın Sargılı Mumya (Alt)",
  T_32_L_M_H_JUNKFOOD: "Burger Çocuk (Kafa)",
  T_32_L_M_H_PHARAOH: "Altın Sargılı Mumya (Kafa)",
  T_32_L_M_S_JUNKFOOD: "Burger Çocuk (Ayakkabı)",
  T_32_L_M_S_PHARAOH: "Altın Sargılı Mumya (Ayakkabı)",
  T_32_L_M_T_JUNKFOOD: "Burger Çocuk (Üst)",
  T_32_L_M_T_PHARAOH: "Altın Sargılı Mumya (Üst)",
  T_32_L_T_WHITESWEATER: "Beyaz Balıkçı Yaka",
  T_32_LC_NEWVAULT_EMOTE: "İfade",
  T_32_LO_WS_IMMORTAL: "Ölümsüz Bölge",
  T_32_LO_WS_ITEM60: "Boru",
  T_32_LO_WS_ITEM60_DESC: "Yürünebilir bir tünel",
  T_32_LO_WS_ITEM61: "T Borusu",
  T_32_LO_WS_ITEM61_DESC: "Yürünebilir T şeklinde tünel",
  T_32_LO_WS_ITEM62: "Boru Kesişimi",
  T_32_LO_WS_ITEM62_DESC: "Yürünebilir, kesişen tünel",
  T_32_LO_WS_ITEM63: "Boru Köşesi",
  T_32_LO_WS_ITEM63_DESC: "Yürünebilir, virajlı tünel",
  T_32_LO_WS_ITEM64: "Seyyar Yemek Kamyonu",
  T_32_LO_WS_ITEM64_DESC: "Burada dur ve bir lokma bir şeyler ye",
  T_32_LO_WS_ITEM65: "Mantar Gölgesi",
  T_32_LO_WS_ITEM65_DESC: "Bir insanı bile taşıyabilecek kadar büyük bir mantar",
  T_32_LO_WS_ITEM66: "Askı",
  T_32_LO_WS_ITEM66_DESC: "Genellikle yerleşim alanlarında görülür.",
  T_32_LO_WS_ITEM67: "Ahşap Kalas",
  T_32_LO_WS_ITEM67_DESC: "Basit, tahtadan bir köprü oluşturmak için kullan",
  T_32_LO_WS_ITEM68: "Kafes Ekran",
  T_32_LO_WS_ITEM68_DESC: "Biraz doğu esintisi",
  T_32_LO_WS_ITEM69: "Sütun",
  T_32_LO_WS_ITEM69_DESC: "İnşaat alanlarında oldukça fazla görülür",
  T_32_LO_WS_ITEM70: "Kaktüs",
  T_32_LO_WS_ITEM70_DESC: "Kocaman bir muamma",
  T_32_LO_WS_ITEM71: "Yapraksız Ağaç",
  T_32_LO_WS_ITEM71_DESC: "Yüzlerce yıl yaşamış bir ağaç",
  T_32_LO_WS_ITEM72: "Taş Fener",
  T_32_LO_WS_ITEM72_DESC: "İmparatorluk bahçelerinde manzaralı dekorasyon",
  T_32_LO_WS_ITEM73: "Sokak Lambası",
  T_32_LO_WS_ITEM73_DESC: "Genelde sokaklarda görünür",
  T_32_LO_WS_ITEM74: "Güneş Paneli",
  T_32_LO_WS_ITEM74_DESC: "Güneş ışığından enerji emer",
  T_32_LO_WS_ITEM75: "Klima A",
  T_32_LO_WS_ITEM75_DESC: "Sıcakta serin kal",
  T_32_LO_WS_ITEM76: "Vantilatör",
  T_32_LO_WS_ITEM77: "Uçan Tava",
  T_32_LO_WS_ITEM78: "Küp",
  T_32_LO_WS_ITEM79: "Ring",
  T_32_LO_WS_ITEM80: "Çekiç",
  T_32_LO_WS_ITEM81: "Pano",
  T_32_LO_WS_ITEM82: "Atış Hedefi",
  T_32_LO_WS_ITEM83: "Esnek Duvar",
  T_32_LO_WS_ITEM84AMMO: "Cephane Yağma Noktası",
  T_32_LO_WS_ITEM84AMMO_DESC: "Yerleştirildiğinde, seçilmiş tipteki cephaneler burada belirir.",
  T_32_LO_WS_ITEM84AR: "Zırh Yağma Noktası",
  T_32_LO_WS_ITEM84AR_DESC: "Yerleştirildiğinde, seçilmiş zırh tipleri burada belirir",
  T_32_LO_WS_ITEM84ARLV1: "Zırh Svy.1",
  T_32_LO_WS_ITEM84ARLV2: "Zırh Svy.2",
  T_32_LO_WS_ITEM84ARLV3: "Zırh Svy.3",
  T_32_LO_WS_ITEM84CO: "Harcanabilenler Yağma Noktası",
  T_32_LO_WS_ITEM84CO_DESC: "Yerleştirildiğinde, seçilmiş olan kullanılabilir eşyalar burada belirecek",
  T_32_LO_WS_ITEM84JA: "Fırlatılabilenler Yağma Noktası",
  T_32_LO_WS_ITEM84JA_DESC: "Yerleştirildiğinde, seçilmiş olan fırlatılabilen eşyalar burada belirecek",
  T_32_LO_WS_ITEM84TE: "Dürbün Yağma Noktası",
  T_32_LO_WS_ITEM84TE_DESC: "Yerleştirildiğinde, seçilmiş tipteki dürbünler burada belirir",
  T_32_LO_WS_ITEM84W: "Silah Yağma Noktası",
  T_32_LO_WS_ITEM84W_DESC: "Yerleştirildiğinde, seçilmiş olan silah tipleri burada belirir",
  T_32_LO_WS_ITEM85: "Kıyamet/Ölümsüz Bölge",
  T_32_LO_WS_ITEM85_DESC: "Yerleştirildiğinde, tetikleme bölgesine giren oyuncular, ölümsüz veya kıyametin belirli bir etkisini yaşayacaklar. (Ekip Çarpışması, Takım Ölüm Oyunu ve Oyun Alanı modlarında geçerli değildir)",
  T_32_LO_WS_ITEM85CP: "Kontrol Noktası",
  T_32_LO_WS_ITEM85CP_DESC: "Parkur modunda oyun oynamak için kullanılan bir eşya. Son kontrol noktasının görünmesi için oyuncuların her bir kontrol noktasından tek tek geçmesi gerekir. Avlandığında ve yeniden doğduğunda, oyuncu geçtikleri son kontrol noktasında yeniden doğmayı seçebilir. (Ekip Çarpışması, Takım Ölüm Oyunu ve Oyun Alanı modlarında geçerli değildir)",
  T_32_LO_WS_ITEM85TM: "Bitiş Noktası",
  T_32_LO_WS_ITEM85TM_DESC: "Parkur modunda oyun oynamak için kullanılan bir eşya. Hedefin tamamlanması için oyuncular bitiş çizgisine gelmelidir. (Ekip Çarpışması, Takım Ölüm Oyunu ve Oyun Alanı modlarında geçerli değildir)",
  T_32_LO_WS_ITEM86: "Başlangıç Noktası",
  T_32_LO_WS_ITEM86_DESC: "Bu noktaya belirli bir takım atanmayacak. Yerleştirildiğinde, burada rastgele bir takım doğar. (Ekip Çarpışması, Takım Ölüm Oyunu ve Oyun Alanı modlarında geçerli değildir)",
  T_32_LO_WS_ITEM86L: "Büyük Başlangıç Noktası",
  T_32_LO_WS_ITEM86L_DESC: "Tüm oyuncuların art arda ortaya çıkacağı Parkur modu için önerilen büyük bir başlangıç noktası. (Ekip Çarpışması, Takım Ölüm Oyunu ve Oyun Alanı modlarında geçerli değildir)",
  T_32_LO_WS_ITEM87: "Blok",
  T_32_LO_WS_ITEM87_DESC: "Büyüklüğü özelleştirmeyi etkinleştirir",
  T_32_LO_WS_ITEM88: "Küboid ve Eğim",
  T_32_LO_WS_ITEM88_DESC: "Boyutu ayarlanabilen bir küboid veya eğim",
  T_32_LO_WS_ITEMLINE: "Değiştir",
  T_32_LO_WS_ITEMMOVE: "Ayarları Tetikle",
  T_32_LO_WS_ITEMROT: "Dönüştür",
  T_32_LO_WS_ITEMSCALE: "Ölçek",
  T_32_LO_WS_KILLZONE: "Kıyamet Noktası",
  T_32_LO_WS_LOOT_AMMOTYPE: "Cephane",
  T_32_LO_WS_LOOT_ARTYPE: "Zırh",
  T_32_LO_WS_LOOT_COTYPE: "Harcanabilir",
  T_32_LO_WS_LOOT_JATYPE: "Fırlatılabilir",
  T_32_LO_WS_LOOT_RANDOM: "Rastgele",
  T_32_LO_WS_LOOT_TETYPE: "Dürbün",
  T_32_LO_WS_LOOT_WEAPONTYPE: "Silah",
  T_32_LO_WS_SCALEX: "Uzunluk",
  T_32_LO_WS_SCALEY: "Yükseklik",
  T_32_LO_WS_SCALEZ: "Genişlik",
  T_32_LO_WS_TRIGGERH: "Sakla",
  T_32_LO_WS_TRIGGERHORP: "Tetikleri Göster/Sakla",
  T_32_LO_WS_TRIGGERP: "Göster",
  T_32_LO_WS_TRIGGERTYPE: "Tetik Tipi",
  T_32_M_WS_MODE_ANNIHILATE: "Yok Oluş",
  T_32_M_WS_MODE_SCORE: "Puan Toplama",
  T_32_M_WS_MODE_SPEED: "Parkur",
  T_32_M_WS_MULTIPLETEAMS: "Çoklu Takım Çatışması",
  T_32_M_WS_ROUNDS: "Tur",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Değişen Adımlar",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "Tehlikeli Bölge",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "Hasar",
  T_32_T_WS_ME_BLUECIRCLESETTING: "Tehlikeli Bölge",
  T_32_T_WS_ME_CUSTOM: "Özelleştir",
  T_32_T_WS_ME_ENDTYPE1: "Yok Oluş",
  T_32_T_WS_ME_ENDTYPE2: "Puan Toplama",
  T_32_T_WS_ME_ENDTYPE3: "Parkur",
  T_32_T_WS_ME_ENDTYPEDESC1: "Hayatta kalan son takım ol",
  T_32_T_WS_ME_ENDTYPEDESC2: `Puan bazlı bir moddur; hedef skora ilk ulaşan takım kazanır.
Oyun kurallarını ve oyun parametrelerini dilediğin gibi ayarlayabilirsin, eleme başına verilecek puanı belirlemek de buna dahil.`,
  T_32_T_WS_ME_ENDTYPEDESC3: `Tüm üyeleri bitiş noktasına ilk ulaşan takımın kazandığı bir parkur modudur.
Oyun kurallarını, parkur üzerindeki nesneleri ve bitiş çizgisini istediğin gibi ayarlayabilirsin.`,
  T_32_T_WS_ME_MATCHTIME: "Maç süresi",
  T_32_T_WS_ME_MECHANIC: "Mekanizma",
  T_32_T_WS_ME_NEARCHECKPOINT: "Civar kontrol noktası",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "Toplamda 12 oyuncudan fazla olamaz.",
  T_32_T_WS_ME_PREGAMETIME: "Hazırlık süresi",
  T_32_T_WS_ME_RESPAWN: "Yeniden doğuşlar",
  T_32_T_WS_ME_RESPAWNSETTING: "Yeniden doğuşlar",
  T_32_T_WS_ME_ROUNDNUM: "Tur sayısı",
  T_32_T_WS_ME_ROUNDOPEN: "Çoklu turları etkinleştir",
  T_32_T_WS_ME_ROUNDRESET: "Yenilenen Tur",
  T_32_T_WS_ME_ROUNDSETTING: "Tur",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "Alan Küçülme Süresi",
  T_32_T_WS_ME_SCORESETTING: "Skor",
  T_32_T_WS_ME_TEAMMATENUM: "Takım başına oyuncu",
  T_32_T_WS_ME_TEAMNUM: "Takım sayısı",
  T_32_T_WS_ME_TEAMSETTING: "Takım",
  T_32_U_ATTACHMENT_8: "Çanta Kılıfı",
  "T_32_U_GOLD_FAMAS-I": "FAMAS-I",
  "T_32_U_GOLD_FAMAS-II": "FAMAS-II",
  "T_32_U_GOLD_FAMAS-III": "FAMAS-III",
  T_32_U_GOLD_HEATGUN_I: "PLAZMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLAZMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLAZMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98k-I",
  T_32_U_GOLD_KAR98K_II: "Kar98k-II",
  T_32_U_GOLD_KAR98K_III: "Kar98k-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "Yükseltme Çipi",
  T_32_WT_WS_BARRIER: "Bariyerler",
  T_32_WT_WS_BDS: "Yapılar",
  T_32_WT_WS_MMINVALIDERROR: "Geçersiz harita kodu",
  T_32_WT_WS_TRGS: "Tetikler",
  T_32_YF_CHARGESHOT_N: "Şarj Bozan",
  T_32_YF_GOLD_GROZA_N: "Groza-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "Ekstra Hasar",
  T_32_YS_WEAPON_TAG_3: "Ateş Oranı",
  T_32_YS_WEAPON_TAG_36: "Zırh Delici",
  T_32_YS_WEAPON_TAG_39: "Akimbo Destekler",
  T_32_YS_WEAPON_TAG_42: "Buz Duvar",
  T_33_C_SKILL_DESC_GRAFFITIST: "Fırlatılabilir nesneleri engelleyen[FFB300] {0}m[-] büyüklüğünde bir alan oluşturur. Bölgedeki müttefikler her saniye [FFB300]{1}%[-] zırh dayanıklılığı yenileyecek ve düşmanlardan alınan cephane hasarı [FFB300]{2}%[-] azalacaktır.[FFB300] {3}sn[-] sürer. Etkiler birikmez. Bekleme süresi:[FFB300]{4} sn.[-] .",
  T_33_C_SKILL_DESC_HITMAN: "Keskin Nişancı ve Nişancı Tüfeklerini kullanırken, atış sesi susturulur ve başarılı atışlar, yere serilen düşmanların [FFB300]{0}%[-] daha hızlı kanamasına neden olur.",
  T_33_C_SKILL_DESC_KENTA: "Önden gelen silah hasarını [FFB300]%{1}[-] azaltan, [FFB300]{0}m[-] genişliğinde bir kalkan oluşturur. Ateş ederken, hasar azaltma [FFB300]%{2}[-]ye düşer. [FFB300]{3}[-] saniye sürer. Bekleme Süresi: [FFB300]{4} sn[-].",
  T_33_C_SKILL_DESC_MADEMANA: "Düşmanları etkisiz hale getiren [FFB300]{0}m[-] alanda bir elektromanyetik dalga yayar; yetenek kullanımını ve etkileşim geri sayımını keser [FFB300]{3}[-] hasar verir. [FFB300]{1}sn[-] sürer. Bekleme süresi: [FFB300]{2}s[-].",
  T_33_C_SKILL_NAME_BODYGUARD: "Ateşli Silahlar Uzmanı",
  T_33_C_SKILL_NAME_KENTA: "Kılıç Ustası Öfkesi",
  T_33_C_SKILL_NAME_MADEMANA: "Savaş Heyecanı",
  T_33_DY_AXOLOTL_N: "Minik Miço",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "Yoldaş Görünümü: Meyveli Minik Miço",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "Yoldaş Görünümü FFWS Bereli",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "Yoldaş Görünümü: Çiçeklenen Şaho",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Sopa - Ölümcül Baget",
  T_33_HQ_EMOTE_SONGKRAN_N: "Gel ve Dans Et",
  T_33_HQ_G18_CYBERTHIEF_N: "G18 - Mavi Hiper Çekirdek",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "El Bombası - Mavi Hiper Çekirdek",
  T_33_HQ_M14_SPIDERLILY_N: "M14 - Alevli Zambak",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7 - Gölgeli Serseri",
  T_33_HQ_MP40_FFWS03_N: "MP40 - Sığınak Savaşçısı",
  T_33_HQ_SCAR_FFWS03_N: "SCAR - Sığınak Savaşçısı",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Tırpan - Zümrüt Gücü",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "Hançer - Sığınak Savaşçısı",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vektör - Mavi Hiper Çekirdek",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "Cip - Zümrüt Parıltı",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Canavar Kamyon - Kemik Kıran",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "Kamyonet - Sığınak Gardiyanı",
  T_33_LO_WS_BHPARA_A: "Aktif",
  T_33_LO_WS_BHPARA_ATKMODE: "Saldırı tipi",
  T_33_LO_WS_BHPARA_GROUP: "Takım",
  T_33_LO_WS_BHPARA_NA: "Saldırı yok",
  T_33_LO_WS_BHPARA_P: "Pasif",
  T_33_LO_WS_DICE_DESC: "Atlamalarınızı geliştiren ve çeşitli oyunlarda kullanılabilen bir zar",
  T_33_LO_WS_DICEVXZ: "Yatay Hız",
  T_33_LO_WS_DICEVY: "Dikey Hız",
  T_33_LO_WS_DTOWER: "Kule",
  T_33_LO_WS_DTOWER_DESC: "Savunma yapısından belirli bir mesafede bulunan düşmanlara otomatik olarak saldırır. CP değeri sıfıra ulaştığında devre dışı bırakılır. (Ekip Çarpışması, Takım Ölüm Oyunu, ve Oyun Alanı modlarında geçerli değildir.)",
  T_33_LO_WS_FORT: "Kale",
  T_33_LO_WS_FORT_DESC: "Kritik yapıdan belirli bir mesafede bulunan düşmanlara otomatik olarak saldırır. CP değeri sıfıra ulaştığında devre dışı bırakılır. (Ekip Çarpışması, Takım Ölüm Oyunu, ve Oyun Alanı modlarında geçerli değildir.)",
  T_33_LO_WS_ITEM89: "Rafineri Tankı",
  T_33_LO_WS_ITEM89_DESC: "Su depolayan bir yapı",
  T_33_LO_WS_ITEM90: "Köpek Evi",
  T_33_LO_WS_ITEM90_DESC: "Köpecikler için bir ev",
  T_33_LO_WS_ITEM91: "Otobüs Durağı",
  T_33_LO_WS_ITEM91_DESC: "Basit bir otobüs durağı",
  T_33_LO_WS_ITEM92: "Graffiti Duvarı",
  T_33_LO_WS_ITEM92_DESC: "Üzerinde sprey boya olan terk edilmiş bir duvar",
  T_33_LO_WS_ITEM93: "Stabil",
  T_33_LO_WS_ITEM93_DESC: "Temel, samandan yapılmış yapı.",
  T_33_LO_WS_ITEM94: "Bank",
  T_33_LO_WS_ITEM94_DESC: "Bir park bankı",
  T_33_LO_WS_ITEM95: "Taş Köprü",
  T_33_LO_WS_ITEM95_DESC: "Taşlarla inşa edilmiş bir köprü.",
  T_33_LO_WS_ITEM96: "Güneş Gölgesi",
  T_33_LO_WS_ITEM96_DESC: "Şemsiye kullan ve güneş yanıklarının önüne geç.",
  T_33_LO_WS_ITEM97: "Bitiş Çizgisi",
  T_33_LO_WS_ITEM97_DESC: "Bitiş çizgisini belirt",
  T_33_LO_WS_ITEM98: "Reklam Panosu",
  T_33_LO_WS_ITEM98_DESC: "Reklamlar için normal bir sancak",
  T_33_LO_WS_PARA_DM: "Hasar",
  T_33_LO_WS_PARA_HP: "CP",
  T_33_LO_WS_PARA_RANGE: "Rakip tarama mesafesi",
  T_33_LO_WS_PARA_SP: "Hız",
  T_33_LO_WS_ZBPARA_AMOUNT: "Dalga başına zombi",
  T_33_LO_WS_ZBPARA_INTERVAL: "Dalga Aralığı (s)",
  T_33_LO_WS_ZBPARA_ROUND: "# dalga sırası",
  T_33_LO_WS_ZBSPAWNER: "Zombi Noktası",
  T_33_LO_WS_ZBSPAWNER_DESC: "Davranışları yapılandırılabilen zombileri otomatik olarak ortaya çıkartan bölge. (Ekip Çarpışması, Takım Ölüm Oyunu, ve Oyun Alanı modlarında geçerli değildir.)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "Seviye Atladın",
  T_33_RW_SKILL_DESC_GANGGIRL: "Ateşleme oranını [FFB300]{0}%[-] artırır. Kullanıcı bir düşmanı vurduğunda, atış hızının maksimum [FFB300]%{1}[-] kadarı hareket hızına dönüşür ve kullanıcı savaşta hayatta kaldığında dönüştürme sıfırlanır.",
  T_33_RW_SKILL_NAME_GANGGIRL: "Kaç ya da Savaş",
  T_33_WT_WS_BASICSET1: "Temel",
  T_33_WT_WS_QCEPRTIP: "EP değerini daha hızlı CP değerine dönüştür",
  T_33_WT_WS_SKILLSET_TAG: "Limitsiz yetenek",
  T_33_WT_WS_SKILLSET1: "Yetenek Ayarları",
  T_33_WT_WS_SKILLSET10: "Zaman Döndürücü (Chrono)",
  T_33_WT_WS_SKILLSET11: "Karışık Ritim (Skyler)",
  T_33_WT_WS_SKILLSET12: "Ekstrem Karşılaşma (Xayne)",
  T_33_WT_WS_SKILLSET13: "İyileştiren Kalp Atışı (Dimitri)",
  T_33_WT_WS_SKILLSET2: "Pasif Yetenekler",
  T_33_WT_WS_SKILLSET2_TIP: "Pasif yetenekleri aç/kapat",
  T_33_WT_WS_SKILLSET3: "Aktif Yetenekler",
  T_33_WT_WS_SKILLSET3_TIP: "Aktif becerileri aç/kapat. Açıksa, çeşitli aktif becerilerin bekleme süresi aşağıda yapılandırılabilir.",
  T_33_WT_WS_SKILLSET4: "Kamuflaj (Wukong)",
  T_33_WT_WS_SKILLSET5: "Savaş Heyecanı (A124)",
  T_33_WT_WS_SKILLSET6: "Ritmi Hisset (Alok)",
  T_33_WT_WS_SKILLSET7: "Boyalı Sığınak",
  T_33_WT_WS_SKILLSET8: "Adım İzleme (Clu)",
  T_33_WT_WS_SKILLSET9: "Her Şeyin Ustası (K)",
  T_33_WT_WS_UNIT_HPSECOND: "CP/s",
  T_33_WT_WS_UNIT_METER: "m",
  T_33_WT_WS_UNIT_SECOND: "sn",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Sarı Yağmurluk (Alt)",
  T_33_YS_H_ONIGIRI: "Onigiri Kapüşonu",
  T_33_YS_H_RAINCOAT: "Sarı Yağmurluk (Kafa)",
  T_33_YS_HA_CRYINGFACE: "Ağlama İfadesi (Yüz Boyası)",
  T_33_YS_M_H_FROGKING: "Kurbağa Kral Şapkası",
  T_33_YS_S_RAINCOAT: "Sarı Yağmurluk (Ayakkabı)",
  T_33_YS_T_BLACKHOLE: "Doppler Etkisi Kapüşonu",
  T_33_YS_T_RAINCOAT: "Sarı Yağmurluk (Üst)",
  T_33_YS_T_SOCCER_GREEN: "Yıldırım Tekme (Forma)",
  T_33_YS_T_SOCCER_YELLOW: "Enerjik Tekme (Forma)",
  T_33_YS_T_WIFI: "Net ' Next Tişörtü",
  T_34_C_SKILL_DESC_STREAMERGUY: "Her elemede bir seyirci eklenir ve seyirci sayısı azalmaz. İlave her izleyiciyle, kafadan vuruşlardan alınan hasar [FFB300]%{0}[-] (maks. [FFB300]%{1}[-]) azalır ve kafadan vuruşlarla düşmanlara verilen hasar [FFB300]%{2}[-] (maks. [FFB300]%{3}[-]) artar.",
  T_34_C_SKILL_DESC_TRACKER: "[FFB300]100m[-] ön mesafedeki en yakın düşmana doğru bir dron salarak, hareket hızını [FFB300]%{0}[-] ve atış hızını [FFB300]%{1}[-] azaltan [FFB300]{5}m çapında[-] bir darbe patlaması yaratır. [FFB300]{3}sn[-] sürer. [FFB300]{2} hasar[-] verir. Bekleme süresi: [FFB300]{4} sn[-].",
  T_34_C_SKILL_NAME_TRACKER: "Şok Dalgası Duyuları",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "Yoldaş Görünümü: Kızgın Sörfçü Yüzgeç",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "Yoldaş Görünümü: Derin Deniz Yüzgeç",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "Yoldaş Görünümü: Gök Gürültüsü Yüzgeç",
  T_34_DY_PETSKIN_TIGER_BIS_N: "Yoldaş Görünümü: Dijital Kaplan",
  T_34_DY_SURFSHARK_N: "Yüzgeç",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Büyük Kondüktör",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Enerjik",
  T_34_HQ_EMOTE_RIDICULE_N: "Dalga geç",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Kamyonet - Şeytani Mühendis",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Tuk Tuk - Yavru Husky",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle - Hibrid Patlama",
  T_34_JL_G36_MADBIONIC_N: "G36 - Tutuşmuş Biyonik",
  T_34_JL_GRENADE_BIS_N: "El Bombası - Piksel Asker",
  T_34_JL_MACHETE_RAMPAGE4_N: "Pala - Gece Hançeri",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Hançer - Muz",
  T_34_JL_UMP45_BIS_N: "UMP - Dijital Atılgan",
  T_34_LY_WS_ABS_DESC: "Bu sayının mutlak değerini alın",
  T_34_LY_WS_ADD_DESC: "Listenin sonuna yeni bir öğe ekle",
  T_34_LY_WS_AUTO_A: "Rakipleri Oto-Tara",
  T_34_LY_WS_BOT: "Temel",
  T_34_LY_WS_BOT_PATH: "Yol",
  T_34_LY_WS_BOT_TYPE: "Tip",
  T_34_LY_WS_BOT4: "Balta",
  T_34_LY_WS_BOT5: "Savur",
  T_34_LY_WS_BOT6: "İmha",
  T_34_LY_WS_BOT8: "Kalkanlı",
  T_34_LY_WS_COL_DESC: "Bir renk seç",
  T_34_LY_WS_DEL_DESC: "Listedeki belirlenmiş bir dizinin karşılık gelen öğesini silin",
  T_34_LY_WS_DF_PER: "Defans %",
  T_34_LY_WS_FORT_INTERVAL: "Saldırı aralığı süresi (sn)",
  T_34_LY_WS_GET: "Al",
  T_34_LY_WS_GET_DESC: "Bir listede belirlenmiş bir dizinin karşılık gelen öğesini elde edin",
  T_34_LY_WS_GLEN_ARR_DESC: "Geçerli listedeki öğelerin sayısını alın",
  T_34_LY_WS_GLEN_DESC: "Bu metin dizisinin uzunluğunu al",
  T_34_LY_WS_GVX: "X vektör bileşenini elde edin",
  T_34_LY_WS_GVX_DESC: "Bir vektörün ilk bileşenini elde edin",
  T_34_LY_WS_GVY: "Y vektör bileşenini elde edin",
  T_34_LY_WS_GVY_DESC: "Bir vektörün ikinci bileşenini elde edin",
  T_34_LY_WS_GVZ: "Z vektör bileşenini elde edin",
  T_34_LY_WS_GVZ_DESC: "Bir vektörün üçüncü bileşenini elde edin",
  T_34_LY_WS_INDEX: "Dizin",
  T_34_LY_WS_JOIN: "Bağla",
  T_34_LY_WS_NEG_DESC: "Bu sayının negatif değerini al",
  T_34_LY_WS_PATH: "Belirleyici",
  T_34_LY_WS_PATH_DESC: "Özel canlı öğelerin seyahat yolunu belirtmek için kullan. (Ekip Çarpışması, Takım Ölüm Oyunu, ve Oyun Alanı modlarında geçerli değildir.)",
  T_34_LY_WS_POINT: "İşaret",
  T_34_LY_WS_POINT_DESC: "Geçerli konumun konumunu işaretlemek için kullanın. (Ekip Çarpışması, Takım Ölüm Oyunu, ve Oyun Alanı modlarında geçerli değildir.)",
  T_34_LY_WS_RANGE_F: "Uzak",
  T_34_LY_WS_RANGE_M: "Orta",
  T_34_LY_WS_RANGE_N: "Yakın",
  T_34_LY_WS_RNDF_DESC: "Bir aralıktan rastgele bir ondalık sayı üret",
  T_34_LY_WS_RNDI_DESC: "Bir aralıktan rastgele bir tam sayı üret",
  T_34_LY_WS_SET: "Ayarla",
  T_34_LY_WS_SET_DESC: "Bir listede belirlenmiş bir dizinin karşılık gelen öğesini ayarlayın",
  T_34_LY_WS_SQRT_DESC: "Bu sayının karekökünü al",
  T_34_LY_WS_STRC_DESC: "İki metin dizisini bağlayın",
  T_34_LY_WS_SVX: "X vektör bileşenini ayarla",
  T_34_LY_WS_SVX_DESC: "Bir vektörün ilk bileşenini ayarlayın",
  T_34_LY_WS_SVY: "Y vektör bileşenini ayarla",
  T_34_LY_WS_SVY_DESC: "Bir vektörün ikinci bileşenini ayarlayın",
  T_34_LY_WS_SVZ: "Z vektör bileşenini ayarla",
  T_34_LY_WS_SVZ_DESC: "Bir vektörün üçüncü bileşenini ayarlayın",
  T_34_LY_WS_VADD: "Vektör ilavesi",
  T_34_LY_WS_VADD_DESC: "İki vektör ekle",
  T_34_LY_WS_VAL_DESC: "Senaryoya göre bir tam sayı veya ondalık sayı girin",
  T_34_LY_WS_VANG_DESC: "İki vektör arasındaki açıyı hesaplayın",
  T_34_LY_WS_VCP: "Çapraz ürün",
  T_34_LY_WS_VCP_DESC: "İki vektörün çapraz çarpımını hesaplayın",
  T_34_LY_WS_VDIS_DESC: "İki vektör arasındaki mesafeyi hesaplayın",
  T_34_LY_WS_VDP: "Nokta ürün",
  T_34_LY_WS_VDP_DESC: "İki vektörün nokta çarpımını hesaplayın",
  T_34_LY_WS_VFX1: "Küre",
  T_34_LY_WS_VFX2: "Silindir",
  T_34_LY_WS_VFX3: "Yüzük",
  T_34_LY_WS_VFX4: "Bom",
  T_34_LY_WS_VFX5: "Piksel",
  T_34_LY_WS_VFX6: "Kıvılcım",
  T_34_LY_WS_VMOD_DESC: "Bir vektörün büyüklüğünü hesaplayın",
  T_34_LY_WS_VMUL: "Vektör çarpma",
  T_34_LY_WS_VMUL_DESC: "İki vektörü çarpın",
  T_34_LY_WS_VNOR_DESC: "Bir vektörü normalleştirin",
  T_34_LY_WS_VSUB: "Vektör çıkarma",
  T_34_LY_WS_VSUB_DESC: "İki vektörü çıkar",
  T_34_M_WS_ANGLE: "Açıyı döndür",
  T_34_M_WS_ARRAY: "Liste",
  T_34_M_WS_ATT: "Özellik",
  T_34_M_WS_BOOL: "Boole",
  T_34_M_WS_COLORARRAY: "Renk dizisi",
  T_34_M_WS_COLOUR: "Renk",
  T_34_M_WS_CONFRONBANNER: "Savaş sancağı",
  T_34_M_WS_COORDINATE: "Koordinatlar",
  T_34_M_WS_CUSTOMINF: "Özel Arayüz",
  T_34_M_WS_CUSTOMMODEDESC: `Önceden belirlenmiş bir oyun modunun olmadığı, tamamen boş ve tamamen özelleştirilebilir bir moddur; kendi kurallarını oluşturarak oynayabilirsin.
Yeni başlayan harita yaratıcıları için biraz zorlayıcı olabilir.`,
  T_34_M_WS_DAMAGETYPE: "Hasar tipi",
  T_34_M_WS_DAMAGETYPEDESC: "Halihazırda sistem tarafından belirlenen hasar türü",
  T_34_M_WS_DESCTEXT: "Açıklayıcı yazı",
  T_34_M_WS_DURACTION: "Süre",
  T_34_M_WS_ECAMODE: "FF Zanaat Modu",
  T_34_M_WS_ENDPHASEDESC: "Mevcut aşamayı hemen sonlandır ve bir sonraki aşamaya geç",
  T_34_M_WS_ENTITY: "Varlık",
  T_34_M_WS_FLOAT: "Ondalık",
  T_34_M_WS_GAME: "Oyun",
  T_34_M_WS_GAMERESULTS: "Maç sonucu",
  T_34_M_WS_GETCONTROL2: "Varlığın özelliklerini (tasarım, renk, içerik vb. dahil) düzenlemek için oynatıcılar arayüzünden bir kontrol varlığı edinin.",
  T_34_M_WS_HEIGHT: "Yükseklik",
  T_34_M_WS_HUDBUTTONWIDGET: "Düğme kontrol",
  T_34_M_WS_HUDEMPTYWIDGET: "Boş pivot",
  T_34_M_WS_HUDIMAGEWIDGET: "Görsel kontrol",
  T_34_M_WS_HUDINPUTWIDGET: "Metin kutusu kontrol",
  T_34_M_WS_HUDLABELWIDGET: "Metin kontrol",
  T_34_M_WS_ICON: "İkon",
  T_34_M_WS_ICON_AIM: "Nişan",
  T_34_M_WS_ICON_ARROW: "Ok",
  T_34_M_WS_ICON_BLAST: "Şok",
  T_34_M_WS_ICON_CIRCULAR: "Yuvarlak",
  T_34_M_WS_ICON_CLOTH: "Palmiye",
  T_34_M_WS_ICON_COLLIMATION: "Artı İşareti",
  T_34_M_WS_ICON_CORPSE: "Zombi",
  T_34_M_WS_ICON_CROSS: "Artı",
  T_34_M_WS_ICON_DAY: "Güneş",
  T_34_M_WS_ICON_DEFENSE: "Kalkan",
  T_34_M_WS_ICON_DIALOGUE: "Diyalog",
  T_34_M_WS_ICON_DIAMONDS: "Elmas",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "Ünlem işareti",
  T_34_M_WS_ICON_FLAG: "Bayrak",
  T_34_M_WS_ICON_FOLDER: "Dosya",
  T_34_M_WS_ICON_GLASSES: "Göz",
  T_34_M_WS_ICON_GUN: "Tabanca",
  T_34_M_WS_ICON_HEART: "Kalp",
  T_34_M_WS_ICON_HEXAGON: "Altıgen",
  T_34_M_WS_ICON_HOURGLASS: "Kum saati",
  T_34_M_WS_ICON_HOUSE: "Ev",
  T_34_M_WS_ICON_KEY: "Anahtar",
  T_34_M_WS_ICON_LIGHTNING: "Yıldırım",
  T_34_M_WS_ICON_LOCK: "Kilit",
  T_34_M_WS_ICON_LOOP: "Döngü",
  T_34_M_WS_ICON_MAGNIFIER: "Büyüteç",
  T_34_M_WS_ICON_MONEY: "Para",
  T_34_M_WS_ICON_MONTH: "Ay",
  T_34_M_WS_ICON_OPENFOLDER: "Dosyayı aç",
  T_34_M_WS_ICON_PLUS: "Artı",
  T_34_M_WS_ICON_QUADRI: "Dörtgen",
  T_34_M_WS_ICON_QUESTIONMARK: "Soru işareti",
  T_34_M_WS_ICON_RECYCLING: "Geri dönüştür",
  T_34_M_WS_ICON_REFRESH: "Yenile",
  T_34_M_WS_ICON_REST: "Dinlen",
  T_34_M_WS_ICON_RETURN: "Geri",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "Sağ yamuk",
  T_34_M_WS_ICON_SCISSORS: "Makas",
  T_34_M_WS_ICON_SETUP: "Ayarlar",
  T_34_M_WS_ICON_SIGN: "İşaret",
  T_34_M_WS_ICON_SIGNOUT: "Çıkış",
  T_34_M_WS_ICON_SQUARE: "Kare",
  T_34_M_WS_ICON_STAR: "Yıldız",
  T_34_M_WS_ICON_STONE: "Taş",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Deniz simidi",
  T_34_M_WS_ICON_TAGGING: "Pin",
  T_34_M_WS_ICON_THESWORD: "Kılıç",
  T_34_M_WS_ICON_TRAPEZOID: "Yamuk",
  T_34_M_WS_ICON_TRASHCAN: "Çöp kutusu",
  T_34_M_WS_ICON_TRIANGLE: "Üçgen",
  T_34_M_WS_ICON_TROPHY: "Kupa",
  T_34_M_WS_ICON_UP: "Baş parmak havaya",
  T_34_M_WS_ICON_WRONG: "Yanlış",
  T_34_M_WS_ICON_YES: "Sağ",
  T_34_M_WS_ICONNAME: "İkon ismi",
  T_34_M_WS_INT: "Tam sayı",
  T_34_M_WS_KILLZONE: "Kıyamet Bölgesi",
  T_34_M_WS_LEFTCOLOR: "Sol renk",
  T_34_M_WS_LEFTTEAMINDEX: "Sol takım indeksi",
  T_34_M_WS_LEFTTEAMSCORE: "Sol takım skoru",
  T_34_M_WS_LOCSWITCH: "Yerelleştirme anahtarı",
  T_34_M_WS_MAX: "Maksimum",
  T_34_M_WS_MIN: "Minimum",
  T_34_M_WS_NUMBER: "Sayı",
  T_34_M_WS_OBJECT: "Varlık",
  T_34_M_WS_OPEN: "Açık",
  T_34_M_WS_OPENSATUS: "Durumu aç",
  T_34_M_WS_PICTURE: "Grafikler",
  T_34_M_WS_RANKARRAY: "Derece dizisi",
  T_34_M_WS_RESULTS: "Sonuçlar",
  T_34_M_WS_RIGHTCOLOR: "Sağ renk",
  T_34_M_WS_RIGHTTEAMINDEX: "Sağ takım indeksi",
  T_34_M_WS_RIGHTTEAMSCORE: "Sağ takım skoru",
  T_34_M_WS_ROUNDBANNER: "Tur sancağı",
  T_34_M_WS_ROUNDDESC: "Tur açıklaması",
  T_34_M_WS_ROUNDHUD: "Tur sayısı",
  T_34_M_WS_ROUNDPARAMS: "Yuvarlak sayı dizisi",
  T_34_M_WS_SAME_NAME: "Tekrar eden isim. Lütfen yeni bir tane dene.",
  T_34_M_WS_SCOREARRAY: "Skor dizisi",
  T_34_M_WS_SCORINGTYPE: "Skor tipi",
  T_34_M_WS_SCORINGTYPEDECS: "Oyuncuların alabileceği puan türü. Puan özelleştirmeyi destekler.",
  T_34_M_WS_SCUFFLESCORING: "Çoklu-takım skoru",
  T_34_M_WS_SETATTRIBUTES: "Özellik ayarları",
  T_34_M_WS_SHUT: "Kapalı",
  T_34_M_WS_SOUND: "Ses efektleri",
  T_34_M_WS_SOUNDCLICK: "Tıklama",
  T_34_M_WS_SOUNDDD: "Bekleme Süresi",
  T_34_M_WS_SOUNDFEMALEA: "Yaralı (Kadın)",
  T_34_M_WS_SOUNDM: "Silah atışı",
  T_34_M_WS_SOUNDMALEA: "Yaralı (Erkek)",
  T_34_M_WS_SOUNDUAV: "Patlama",
  T_34_M_WS_ST_ASSISTCOUNT: "Yardımlar",
  T_34_M_WS_ST_CHECKPROGRESS: "Kontrol noktası ilerlemesi",
  T_34_M_WS_ST_DAMAGESUM: "Hasar",
  T_34_M_WS_ST_FINISHCOUNT: "Ulaşılan hedef miktarı",
  T_34_M_WS_ST_FINISHORDER: "Ulaşılan hedeflerin sırası",
  T_34_M_WS_ST_FINISHTIME: "Ulaşılan hedeflerin zamanı",
  T_34_M_WS_ST_KILLCOUNT: "Leş",
  T_34_M_WS_ST_MAINSCORE: "Hedef Skor",
  T_34_M_WS_ST_RANKSCORE: "Derece skoru",
  T_34_M_WS_ST_SURVIVALDURACTION: "Hayatta kalma süresi",
  T_34_M_WS_ST_UNKOWN: "Bilinmeyen",
  T_34_M_WS_STARTBANNER: "Başlangıç sancağı",
  T_34_M_WS_STARTTIME: "Başlangıç süresi,",
  T_34_M_WS_STRING: "Yazı",
  T_34_M_WS_STUDIO: "STÜDYO",
  T_34_M_WS_TEAMARRAY: "Takım dizisi",
  T_34_M_WS_TEXTCONTENT: "İçerik",
  T_34_M_WS_THEMECOLOR: "Tema rengi",
  T_34_M_WS_TIME: "Geri Sayım Arayüzü",
  T_34_M_WS_TITLETEXT: "Başlık yazısı",
  T_34_M_WS_TYPE: "Tip",
  T_34_M_WS_UODATETYPE: "Tipi güncelle",
  T_34_M_WS_VARNAME: "Değişken ismi",
  T_34_M_WS_VECTOR: "Vektör",
  T_34_M_WS_VFX: "Görsel efektler",
  T_34_M_WS_WIDTH: "Genişlik",
  T_34_MF_CHARACTER_TRACKER_N: "Homer",
  T_34_PD_FlagBattle_HYPE_1: "Ateş",
  T_34_SP_WS_BLOCK1_NAME: "Aşama değiş",
  T_34_SP_WS_BLOCK1_NAMEDESC: "İstediğin bir aşamaya (veya tura) girmek için bir maçın aşamasını değiştir. Turların da ayrıca aşama indeksleri vardır ve özel bir aşama türüdür.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "Hedef aşamanın indeksi",
  T_34_SP_WS_BLOCK10_NAME: "Görsel Efektler Oluştur",
  T_34_SP_WS_BLOCK10_NAMEDESC: "Belirlenmiş görsel efektleri kullanarak bir simge oluşturun. Görsel efektin daha fazla özelliği, görsel efekt varlığının özellikleri ayarlanarak yapılandırılabilir.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "Görsel Efekt",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "Uygulanabilecek görsel efekt türleri",
  T_34_SP_WS_BLOCK12_NAME: "Görsel efektleri sil",
  T_34_SP_WS_BLOCK12_NAMEDESC: "Belirlenen görsel efekti sil",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Görsel efekt varlığı",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "Silinecek görsel efekt varlığı",
  T_34_SP_WS_BLOCK13_NAMEDESC: "Müşterinin görsel efekti oynamasını sipariş edin",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "Oyuncu Listesi",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "Mesajı alacak oyuncular",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "Kaynak yolu",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "Sistem kaynağı yolu şurada: path. Özel kaynak yolu: path. Varsayılan olarak boş.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "RGBA kanalı, her kanal INT32'de 0 ila 255 arasında bir değer alıyor. Varsayılan renk beyazdır (255,255,255,255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Yakınlaştır",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "Yakınlaştırma ölçeği; varsayılan 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "Küresel koordinatlarda ifade edilen gösterim konumu. Varsayılan olarak Vector3(0).",
  T_34_SP_WS_BLOCK14_NAME: "Ses efektini oynat",
  T_34_SP_WS_BLOCK14_NAMEDESC: "Müşterinin ses efekti oynamasını sipariş edin",
  T_34_SP_WS_BLOCK15_NAME: "Çıkış günlüğü",
  T_34_SP_WS_BLOCK15_NAMEDESC: "Günlük arayüzüne çıktı içeriği",
  T_34_SP_WS_BLOCK2_NAMEDESC: "Güvenli Bölge dışındaki oyunculara zarar vermek için açın",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "Güvenli Bölgenin merkez noktası",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "Yarıçap",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "Güvenli Bölgenin yarıçapı",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "Güvenli Bölgenin küçülmeye başlaması için geri sayım başladı",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "Güvenli Bölge Küçülme Süresi",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "Güvenli Bölge dışındayken alınan hasar miktarı",
  T_34_SP_WS_BLOCK3_NAMEDESC: "Tehlikeli Bölge kapatıldığında, Güvenli Bölge dışındaki oyuncular hasar almaz",
  T_34_SP_WS_BLOCK4_NAMEDESC: "Belirlenen bir süre için sonraki bir eylemi geciktirmek için kullan",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "Bekleme süresi milisaniye cinsinden ölçülür",
  T_34_SP_WS_BLOCK5_NAMEDESC: "Bir sonraki çerçeveye sonraki bir eylemi ertelemek için kullanın",
  T_34_SP_WS_BLOCK6_NAME: "Özel HUD oluştur",
  T_34_SP_WS_BLOCK6_NAMEDESC: "Belirlenmiş bir özel HUD oluştur",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "HUD varlığı oluşturmak için kullanılan bir ad. Karşılık geldiği yerel değişken, oluşturulan HUD'ın varlığıdır.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "Oyuncu",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "Belirli bir oyuncunun varlığı. Sadece söz konusu oyuncu tarafından görülebilir.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "Tek HUD endeksi",
  T_34_SP_WS_BLOCK7_NAMEDESC: "Yalnızca belirlenmiş oyuncular tarafından görülebilen varsayılan bir HUD oluşturun",
  T_34_SP_WS_BLOCK8_NAMEDESC: "Silindiğinde, varsayılan HUD istemcide görülmez (gizli veya atılır)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD varlığı",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "Silinecek HUD varlığı",
  T_34_SP_WS_BLOCK9_NAMEDESC: "Silindiğinde, özel HUD istemcide görünmez (gizli veya atılır)",
  T_34_T_WS_BLOCK1_NAMEDESC: "Maç başladığında olay tetiklenir",
  T_34_T_WS_BLOCK10_NAMEDESC: "Bir oyuncu elendiğinde olay tetiklenir",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "Olayı tetikleyecek elenen oyuncu",
  T_34_T_WS_BLOCK13_NAMEDESC: "Olay, bir oyuncu başka bir oyuncuya yardım ettiğinde tetiklenir",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "Elenen oyuncu",
  T_34_T_WS_BLOCK14_NAMEDESC: "Olay, bir oyuncu hasar verdiğinde tetiklenir",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "Hasarı alan oyuncu",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "Verilen hasarın türü",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "Verilen hasar miktarı",
  T_34_T_WS_BLOCK15_NAMEDESC: "Olay, bir oyuncu başka bir oyuncuyu ortadan kaldırdığında tetiklenir",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "Elenen oyuncu",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "Elenmeye neden olan hasarın türü",
  T_34_T_WS_BLOCK16_NAMEDESC: "Bir oyuncu maça katıldığında olay tetiklenir",
  T_34_T_WS_BLOCK17_NAMEDESC: "Bir oyuncu canlandırıldığında olay tetiklenir",
  T_34_T_WS_BLOCK18_NAMEDESC: "Bir ekip kaldırıldığında olay tetiklenir",
  T_34_T_WS_BLOCK19_NAMEDESC: "Bir ekip eklendiğinde olay tetiklenir",
  T_34_T_WS_BLOCK2_NAMEDESC: "Maç bittiğinde olay tetiklenir",
  T_34_T_WS_BLOCK20_NAMEDESC: "Bir takım silindiğinde olay tetiklenir",
  T_34_T_WS_BLOCK3_NAMEDESC: "Olay, her tur başladığında tetiklenir",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "Tur sayısı 0 değerinden başlar",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "Tur indeksi",
  T_34_T_WS_BLOCK4_NAMEDESC: "Olay, her tur bittiğinde tetiklenir",
  T_34_T_WS_BLOCK5_NAMEDESC: "Sahne başladığında olay tetiklenir",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "Aşama sayısı 0 değerinden başlar",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Sahne varlığı",
  T_34_T_WS_BLOCK6_NAMEDESC: "Sahne sona erdiğinde olay tetiklenir",
  T_34_T_WS_BLOCK7_NAMEDESC: "Olay, bir oyuncu maçtan çıktığında tetiklenir",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "Olayı tetikleyecek oyuncu",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "Tetikleyici oyuncu",
  T_34_T_WS_BLOCK8_NAMEDESC: "Olay, oyuncunun puanı değiştiğinde tetiklenir",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "Değişen skorun tipi",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "Değişiklikten sonraki puan değeri",
  T_34_T_WS_BLOCK9_NAMEDESC: "Bir takımın puanı değiştiğinde olay tetiklenir",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "Olayı tetikleyecek ekip",
  T_34_WT_WS_BORNENTITY_PARAM1: "Başlangıç noktası",
  T_34_WT_WS_BORNENTITY_PARAM2: "Mevcut koordinatlar",
  T_34_WT_WS_BORNENTITY_PARAM3: "Varsayılan başlangıç noktası olarak ayarla",
  T_34_WT_WS_BORNENTITY_PARAM4: "Parlayan sınırlar",
  T_34_WT_WS_BORNENTITY_PARAM5: "Kullanımda veya kullanımda değil",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "Kontrol Noktası Arayüzü",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "Açık durum",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "Durum tetikleyici",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "Haklama tetikleyicisi ya da değil",
  T_34_WT_WS_ENTITY_PARAM1: "Oyun varlığı",
  T_34_WT_WS_ENTITY_PARAM10: "# takım",
  T_34_WT_WS_ENTITY_PARAM11: "# takım üyesi",
  T_34_WT_WS_ENTITY_PARAM12: "Her turda ekipman sıfırlama",
  T_34_WT_WS_ENTITY_PARAM13: "Bölge dışı hasarı etkinleştir",
  T_34_WT_WS_ENTITY_PARAM14: "Bölge boyutu",
  T_34_WT_WS_ENTITY_PARAM15: "Bölge büzülme başlangıç zamanı",
  T_34_WT_WS_ENTITY_PARAM16: "Bölge küçültme süresi",
  T_34_WT_WS_ENTITY_PARAM17: "Bölge dışı hasar",
  T_34_WT_WS_ENTITY_PARAM18: "Hedef skor",
  T_34_WT_WS_ENTITY_PARAM19: "Haklama skoru",
  T_34_WT_WS_ENTITY_PARAM2: "Geçersiz Durum",
  T_34_WT_WS_ENTITY_PARAM20: "Diriltme tipi",
  T_34_WT_WS_ENTITY_PARAM21: "Yuvarlak puan sıralama kriterleri (oyuncu)",
  T_34_WT_WS_ENTITY_PARAM22: "Kriterler Önemi (Oyuncu)",
  T_34_WT_WS_ENTITY_PARAM23: "Yuvarlak Puan Sıralama Kriterleri (Takım)",
  T_34_WT_WS_ENTITY_PARAM24: "Kriterlerin önemi (ekip)",
  T_34_WT_WS_ENTITY_PARAM25: "Skor sıralama kriterleri (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "Kriter önemi (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "Yuvarlak sıralama puanı",
  T_34_WT_WS_ENTITY_PARAM28: "Sonuç sayfasında kriterleri göster",
  T_34_WT_WS_ENTITY_PARAM29: "Toplam # tur",
  T_34_WT_WS_ENTITY_PARAM3: "Oyun zamanı",
  T_34_WT_WS_ENTITY_PARAM4: "Mevcut tur indeksi",
  T_34_WT_WS_ENTITY_PARAM5: "Geçerli aşama dizini",
  T_34_WT_WS_ENTITY_PARAM6: "Mod şablonu kimliği",
  T_34_WT_WS_ENTITY_PARAM7: "Oyuncu canlandırmasını etkinleştir",
  T_34_WT_WS_ENTITY_PARAM8: "Bot diriltmesini etkinleştir",
  T_34_WT_WS_ENTITY_PARAM9: "Diriltme zamanı",
  T_34_WT_WS_ENTITY1_NAME: "Mevcut varlık",
  T_34_WT_WS_ENTITY1_NAMEDESC: "Mevcut Varlığa Dön",
  T_34_WT_WS_ENTITY10_NAME: "İkonu kaldır",
  T_34_WT_WS_ENTITY10_NAMEDESC: "Belirlenmiş bir simgeyi kaldırın",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "Kaldırmak istediğiniz simgeyi seçin",
  T_34_WT_WS_ENTITY11_NAME: "Metni Kaldır",
  T_34_WT_WS_ENTITY11_NAMEDESC: "Bir metin varlığı kaldırın",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "Kaldırmak istediğiniz metni seçin",
  T_34_WT_WS_ENTITY12_NAMEDESC: "Belirlenmiş oyuncular için bir öğe ekleyin",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "Öğeyi alacak oyuncu(lar)",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "Alınacak belirli öğe kimliği",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "Verilecek eşya miktarı",
  T_34_WT_WS_ENTITY12_PARAM3: "Miktar",
  T_34_WT_WS_ENTITY13_PARAM1: "Tip",
  T_34_WT_WS_ENTITY13_PARAM2: "Konum",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "Nesnenin koordinatları",
  T_34_WT_WS_ENTITY13_PARAM4: "Nesne",
  T_34_WT_WS_ENTITY14_NAME: "Nesneyi Kaldır",
  T_34_WT_WS_ENTITY14_NAMEDESC: "Belirlenmiş bir nesneyi kaldır",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "Objeyi sil",
  T_34_WT_WS_ENTITY15_NAMEDESC: "Tüm oyuncu varlıklarını edinin",
  T_34_WT_WS_ENTITY16_NAMEDESC: "Tüm ekip varlıklarını edinin",
  T_34_WT_WS_ENTITY17_NAMEDESC: "Belirlenmiş oyuncular için belirlenmiş miktarda CP kurtar. Kurtarma miktarı maksimum CP değerini aşarsa, CP yalnızca maksimuma kadar geri yüklenir.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "CP dalgalanmaları yapılandırılan oyuncular",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "Geri kazanılacak belirlenmiş CP miktarı",
  T_34_WT_WS_ENTITY18_NAME: "Rastgele başlangıç koordinatlarını al",
  T_34_WT_WS_ENTITY18_NAMEDESC: "Belirlenen oyuncuların ortaya çıkacağı ve geri döneceği konumu yapılandırın",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "Bu konumdan rastgele ortaya çıkacak oyuncu(lar)",
  T_34_WT_WS_ENTITY18_RETURNDESC: "Oyuncunun atanacağı yerin koordinatları",
  T_34_WT_WS_ENTITY19_NAME: "Oyuncu Puanı Al",
  T_34_WT_WS_ENTITY19_NAMEDESC: "Belirlenmiş oyuncuların belirli puanlarını alın",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "Bu oyuncunun/oyuncuların puan varlığını edinin",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "Puan türünü edinin",
  T_34_WT_WS_ENTITY19_RETURNDESC: "Elde edilecek belirli puan değeri",
  T_34_WT_WS_ENTITY2_NAME: "Özellik ayarla",
  T_34_WT_WS_ENTITY2_NAMEDESC: "Özellik türünün zaten seçilmiş olduğu bir özelliğin değerini yapılandırın",
  T_34_WT_WS_ENTITY2_PARAM1: "Varlık",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "Oyun varlığının özellik değeri",
  T_34_WT_WS_ENTITY2_PARAM3: "Özellik",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "Bu oyun varlığının belirli bir özelliği",
  T_34_WT_WS_ENTITY2_PARAM4: "Değer",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "Bir özelliğin belirli bir değeri. Özellik türünün seçilenle aynı hizada olduğundan ve ilgili bloklarda yapılandırılan türle eşleştiğinden emin olun.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "Belirli belirlenmiş oyuncuların belirli puanlarını yapılandırın",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "Bu oyuncunun puan varlığını yapılandırın",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "Puan türünü yapılandırın",
  T_34_WT_WS_ENTITY20_PARAM3: "Skor",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "Belirli puan değeri ayarlanan",
  T_34_WT_WS_ENTITY21_NAME: "Toplam takım puanı al",
  T_34_WT_WS_ENTITY21_NAMEDESC: "Belirli belirlenmiş takımların belirli toplam puanlarını edin",
  T_34_WT_WS_ENTITY21_PARAM1: "Takım",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "Bu ekibin puan varlığını elde edin(ler)",
  T_34_WT_WS_ENTITY22_NAME: "Takımın mevcut tur skorunu ayarla",
  T_34_WT_WS_ENTITY22_NAMEDESC: "Belirlenmiş takımların belirli bir tür mevcut tur puanlarını yapılandır",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "Bu takımların puanlarını yapılandırın",
  T_34_WT_WS_ENTITY23_NAME: "Oyuncu turu puanı al",
  T_34_WT_WS_ENTITY23_NAMEDESC: "Belirlenmiş oyuncular için belirli bir turun belirli puanlarını alın",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "Bu oyuncunun/oyuncuların tur puanlarını alın",
  T_34_WT_WS_ENTITY23_PARAM2: "Tur",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "Bu turdan puanı alın",
  T_34_WT_WS_ENTITY24_NAME: "Takım turu puanı al",
  T_34_WT_WS_ENTITY24_NAMEDESC: "Belirlenen takımlar için belirli bir turun belirli puanlarını al",
  T_34_WT_WS_ENTITY25_NAME: "Işınlan",
  T_34_WT_WS_ENTITY25_NAMEDESC: "Belirlenen oyuncuları belirlenmiş bir konuma ışınla",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "Işınlanacak oyuncu(lar)",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "Oyuncu (lar) ın nereye ışınlanacağı koordinatları",
  T_34_WT_WS_ENTITY26_NAMEDESC: "Belirlenmiş oyuncuların belirlenen hedeflere zarar vermesini sağlayın. Saldırı oyuncusu seçilmezse, belirlenen hedefler sistemden hasar alır.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Hasarı alacak kuruluşlar",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "Verilen hasar miktarı",
  T_34_WT_WS_ENTITY28_NAMEDESC: "Belirlenmiş oyuncuları canlandırın",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Yeniden canlandırılabilecek oyuncu varlıkları",
  T_34_WT_WS_ENTITY3_NAMEDESC: "Blok tipini ayarla",
  T_34_WT_WS_ENTITY3_PARAM1: "olarak",
  T_34_WT_WS_ENTITY4_NAME: "Özellik edin",
  T_34_WT_WS_ENTITY4_NAMEDESC: "Bir varlığın belirli bir özelliğini elde et",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "Özellik değerinin belirli oyun varlığını elde edin",
  T_34_WT_WS_ENTITY4_RETURNDESC: "Elde edilecek belirli özellik değeri",
  T_34_WT_WS_ENTITY5_NAMEDESC: "Tüm oyuncular için hareket etme yeteneğini yapılandırın",
  T_34_WT_WS_ENTITY6_NAME: "Simge Oluştur",
  T_34_WT_WS_ENTITY6_PARAM1: "İkon",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "HUD içinde görüntülenen bir görüntü. Çeşitli tasarımlar arasından seçim yapın.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "Tasarımın uygulanacağı simgeyi seçin",
  T_34_WT_WS_ENTITY7_NAMEDESC: "Belirlenmiş oyuncular için bir HUD simgesi oluşturun. Hiçbir oyuncu varlığı seçilmezse, tüm oyuncular için HUD oluşturulacaktır.",
  T_34_WT_WS_ENTITY7_PARAM1: "Oyuncu",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "Seçen oyuncu(lar) için bir HUD simgesi oluşturun",
  T_34_WT_WS_ENTITY8_NAME: "Yazı ekle",
  T_34_WT_WS_ENTITY8_PARAM1: "Yazı",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "Bu komuttan oluşturulacak belirli metin içeriği",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "Şu anda oluşturulan metin varlığı",
  T_34_WT_WS_ENTITY9_NAMEDESC: "Belirlenmiş oyuncular için bir satır HUD metni ekleyin. Hiçbir oyuncu varlığı seçilmezse, metin tüm oyuncuların HUD oluşturulacaktır.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "Seçilmiş oynatıcı(lar) için bir HUD metni ekleyin",
  T_34_WT_WS_ICONENTITY_PARAM1: "Simge varlığı",
  T_34_WT_WS_ICONENTITY_PARAM2: "Tasarım",
  T_34_WT_WS_ICONENTITY_PARAM3: "Renk",
  T_34_WT_WS_ICONENTITY_PARAM4: "Ölçek",
  T_34_WT_WS_ICONENTITY_PARAM5: "Ekran konumu",
  T_34_WT_WS_ICONENTITY_PARAM6: "Hedefi takip et",
  T_34_WT_WS_ICONENTITY_PARAM7: "Duvarlardan görülebilir",
  T_34_WT_WS_ICONENTITY_PARAM8: "Sürekli ekranda",
  T_34_WT_WS_ONETEAM_TAG: "Tek Takım",
  T_34_WT_WS_PHASEENTITY_PARAM1: "Sahne varlığı",
  T_34_WT_WS_PHASEENTITY_PARAM2: "Sahne endeksi",
  T_34_WT_WS_PHASEENTITY_PARAM3: "Başlangıç zamanı",
  T_34_WT_WS_PHASEENTITY_PARAM4: "Bitiş süresi",
  T_34_WT_WS_PHASEENTITY_PARAM5: "Süre",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Oyuncu varlığı",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "Canlandırma Noktası",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "Silah oranı",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "3B Karakter modeli",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "Kimlik",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "Mevcut CP",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Maks. CP",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "YZ",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "Oyuncu durumu",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "Hayatta kalma süresi",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "Yenilmez",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "Takım",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "Hedef kontrol noktası kimliği",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "Başlangıç noktası",
  T_34_WT_WS_PROCIRCLE_ICON: "Simge",
  T_34_WT_WS_PVEDESC1: "Süre dolmadan en az bir oyuncu bitiş çizgisine ulaşırsa takım kazanır. Tüm oyuncular aynı anda elenirse oyun biter.",
  T_34_WT_WS_PVEDESC2: "Kazanmak için belirlenmiş bir süre boyunca hayatta kal. Tüm oyuncular aynı anda elenirse oyun biter.",
  T_34_WT_WS_PVENAME1: "Acele",
  T_34_WT_WS_PVENAME2: "Dayanıklılık",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "Geçerli kontrol noktası kimliği",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Parkur modu kontrol noktası numarası",
  T_34_WT_WS_SKILLSET14: "Kılıç Ustasının Öfkesi (Kenta)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "Takım varlığı",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Mükemmel",
  T_34_WT_WS_TEAMENTITY_PARAM3: "Tüm üyeler",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "Normal tetik",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "Görünüm tipi",
  T_34_WT_WS_TXTENTITY_PARAM1: "Metin varlığı",
  T_34_WT_WS_TXTENTITY_PARAM2: "İçerik",
  T_34_WT_WS_VFXENTITY_PARAM1: "Görsel efektler varlık",
  T_34_WZ_WS_LOGIC10_NAME: "Sonrakine devam et",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "Geçerli döngü yinelemesini atla ve sonrakini yürüt",
  T_34_WZ_WS_LOGIC11_NAME: "Geri",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "Geçerli yürütmeyi sonlandırır ve ana programa geri döner. Dönerken verilerin geri gönderilmesine izin verir.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "Geri dönüş değeri",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "Ana programa geri gönderilecek veriler",
  T_34_WZ_WS_LOGIC2_NAME: "Karşılaştır",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "Belirlenmiş bir operatör kullanarak 2 değeri karşılaştırın",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "Sol Değer",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "Karşılaştırma için kullanılan sol taraftaki değer",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "Karşılaştırma işlevi",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "Değerlerin nasıl karşılaştırılmasını istediğinizi seçin. Desteklenen operatörler şunlardır: >, ≥, ==, ≠, ≤, <, AND (yalnızca Boolean), OR (yalnızca Boolean)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "Sağ değer",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "Karşılaştırma için kullanılan sağ taraf değeri",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "Karşılaştırma sonucu",
  T_34_WZ_WS_LOGIC3_NAME: "DEĞİL",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "Mantıksal bir değerin tersini verir",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "NOT operatörünü kullanmak istediğin değer",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "NOT operasyonu sonucu",
  T_34_WZ_WS_LOGIC4_NAME: "Kontrol boş",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "Bir varlığın boş/boş olup olmadığını kontrol et",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Varlık",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "Boşluğu kontrol edilecek varlık",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "Varlığın boş olup olmadığı",
  T_34_WZ_WS_LOGIC5_NAME: "Koşullu",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "Koşulların karşılanıp karşılanmadığına göre yürütülür. Alt süreçler, sonraki mantık dalları ile aynıdır.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "Değer",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "Koşul sayısı ve alt süreçlerin (mantık dalları) sayısı aynı olmalıdır.",
  T_34_WZ_WS_LOGIC6_NAME: "Tam sayı aralığı döngüsü",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "z'lik bir adımla x'ten y'ye döngü yap. Alt süreç döngünün kendisidir.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "Yerel bir değişkenin döngü indeksinin değerini çıkarmak için kullanılabilen döngü indeksinin adı",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "Başlangıç değeri",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "Döngünün başladığı değer",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "Bitiş değeri",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "Döngünün bittiği değer",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "Adım",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "Her döngünün adımı. Başlangıç değeri bitiş değerinden küçük olduğunda adım 0'dan büyük olmalıdır. Başlangıç değeri bitiş değerinden büyük olduğunda adım 0'dan küçük olmalıdır.",
  T_34_WZ_WS_LOGIC7_NAME: "Her öğeyi döngüye al",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "İçindeki her bir alt öğeyi çıkarmak için bir veri kapsayıcısının geçişini sağlar. Alt süreç döngünün kendisidir.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "Öğe",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "Bu isme geçiş, yerel değişkenin alt öğesinin değerini çıkaracaktır",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "Veri kapsayıcısı",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "Geçiş yapılacak veri kapsayıcısı. Şu anda liste türlerini destekliyor.",
  T_34_WZ_WS_LOGIC8_NAME: "Koşullu döngü",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "Bir koşullu döngü, bir koşul karşılanana kadar tekrarlanır. Koşul Yanlış olduğunda döngü durur.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "Koşul",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "Koşul Doğru ise döngüyü tekrarlar ve koşul Yanlış olana kadar durur",
  T_34_WZ_WS_LOGIC9_NAME: "Döngüyü kır",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "Mevcut döngü sürecini durdurur ve döngüden atlar",
  T_34_Y_B_DINOSAURS: "Dinozor İllüzyonu (Alt)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Saf Melek (K)",
  T_34_YS_F_B_PANDACATTLE: "Bayan Möö (Alt)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Su Haydutu (Üst)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Su Haydutu (Kafa)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Su Haydutu (Yüz Boyası)",
  T_34_YS_F_S_PANDACATTLE: "Bayan Möö (Ayakkabı)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Su Haydutu (Ayakkabı)",
  T_34_YS_F_T_PANDACATTLE: "Bayan Möö (Üst)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Su Haydutu (Üst)",
  T_34_YS_M_B_ANGEL_BW: "Saf Melek (E)",
  T_34_YS_M_B_PANDACATTLE: "Panda Pijaması (Alt)",
  T_34_YS_M_H_PANDACATTLE: "Panda Pijaması (Kafa)",
  T_34_YS_M_S_PANDACATTLE: "Panda Pijaması (Ayakkabı)",
  T_34_YS_M_T_PANDACATTLE: "Panda Pijaması (Üst)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Bir rakibi yere sererek [FFB300]{0} EP[-] kazan.",
  T_35_DY_PET_OWL_N: "Baykuş",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Yoldaş Görünümü: Uzay Gemisi Aylı",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Yoldaş Görünümü: Mavi Minik Miço",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Yoldaş Görünümü: Mavi Agui",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Yoldaş Görünümü: Yakan Kuş",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Yoldaş Görünümü: Gece Kuşu",
  T_35_DY_PETSKIN_OWL_STORM_N: "Yoldaş Görünümü: Buz Kuşu",
  T_35_JL_KNOCKEDDOWN: "yere serildi",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "[FFB300]{1}[-] saniye boyunca, Muhafız Duvara yapılan başarılı atışlar [FFB300]{3}m[-] içindeki düşmanları işaretler ve işaretlenen düşmanlara hasar vermek için Muhafız Duvarı delebilir (verilen hasar normalden daha düşük olacaktır). Maksimum [FFB300]{0}[-] Duvarda etkilidir. Bekleme süresi: [FFB300]{2}s[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Duvar Kavgası",
  T_35_KY_INFECTION_MAPNAME: "Çorak Arazi",
  T_35_M_WS_BUTTONCLICKDESC: "İlgili düğmeye basıldığında bu olayı tetikler. Tetik oynatıcı, parametreler kullanılarak elde edilir",
  T_35_M_WS_GETTEAMMATEPOS: "Yakındaki dostların yerini al",
  T_35_M_WS_ROUND2: "Mevcut dalga",
  T_35_PD_Infection_HUMANSELECT: "Bir silah seç",
  T_35_PD_INFECTION_MODENAME: "Droid Kıyameti",
  T_35_QX_WS_ICONTYPE_ITEM: "Obje",
  T_35_QX_WS_ICONTYPE_NATURE: "Doğal Şekiller",
  T_35_QX_WS_ICONTYPE_SHAPE: "Geometrik",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Sembol",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Silah",
  T_35_R_EMOTE_TAG_MUSIC_N: "Müzik",
  T_35_RW_SKILL_DESC_Singers: "[FFB300]{0}m[-] içindeki müttefikler ve yeteneği kullanan kişi, EP kullanarak[FFB300] %{1} [-]hasarı engelleyebilir. Bu durumda, müttefiklerden kesilen EP miktarı, beceri kullanıcısının EP değerine eklenecektir.",
  T_35_RW_SKILL_NAME_Singers: "Sessiz Nöbetçi",
  T_35_SP_WS_COMMENTKEY_01: "Uygun Zorluk",
  T_35_SP_WS_COMMENTKEY_02: "Yaratıcı",
  T_35_SP_WS_COMMENTKEY_03: "İlginç Oynanış",
  T_35_SP_WS_COMMENTKEY_04: "Tekrar Oynanabilir",
  T_35_SP_WS_COMMENTKEY_05: "İlgi çekici hikâye",
  T_35_SP_WS_COMMENTKEY_06: "Dengeli",
  T_35_SP_WS_COMMENTKEY_07: "Güzel Bir Tecrübe",
  T_35_SP_WS_COMMENTKEY_08: "Esnek",
  T_35_SP_WS_COMMENTKEY_09: "Görsel olarak zevk veriyor",
  T_35_SP_WS_COMMENTKEY_10: "Çok Zor",
  T_35_SP_WS_COMMENTKEY_11: "Çok Kolay",
  T_35_SP_WS_COMMENTKEY_12: "Sıkıcı",
  T_35_SP_WS_COMMENTKEY_13: "Fazla Uzun",
  T_35_SP_WS_COMMENTKEY_14: "Dengesiz",
  T_35_SP_WS_COMMENTKEY_15: "Hoş Olmayan Tecrübe",
  T_35_SP_WS_IMAGE03: "Doku",
  T_35_SP_WS_IMAGE04: "Çerçeve",
  T_35_SY_CHARGESHOT_TEARS_N: "Şarj Bozan - Lav Avizesi",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "El Bombası - Kristal Ürkünçlük",
  T_35_SY_GRENADE_PIRATES_N: "El Bombası - Korsan Kabadayısı",
  T_35_SY_GRENADE_RIDERS_N: "El Bombası - Acımasız Sürücü",
  T_35_SY_M24_KUN_N: "M24 - Akarsu Haydudu",
  T_35_SY_SCAR_PARKOUR_N: "SCAR - Serbest Koşucu",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Cip - Tekil Yapboz",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "Kutlamanın tadını çıkarın!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Motosiklet - Kristal Simetri",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Yapı & Dekor",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Yapılar",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Diğerleri",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Mimari",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Büyük Binalar",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Orta Büyüklükteki Evler",
  T_35_WT_WS_PREFAB_MENUBAR_3: "İşlevsel Nesneler",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "Mod Temelleri",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Müzik",
  T_35_WT_WS_PVEMODE_TAG: "Hayatta Kalma Modu",
  T_35_WZY_WS_BECRE_NAMEDESC: "Bu varlık oluşturulduğunda tetiklenir",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Bu varlık ortadan kaldırıldığında tetiklenir. Saldırının kaynağı, "Varlığı Tetikle" ve saldırı türü "Hasar Türü" kullanılarak tanımlanabilir.',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "Olayı tetikleyen varlık",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Belirli bir konumda bir öğe türü veya bir dizi öğe oluşturun. Bir tür eşya oluştururken, miktar o eşyanın sayısıdır. Bir eşya seti oluştururken, miktar, eşya listesine karşılık gelen miktar listesidir. Oluşturulan öeşyalar haritanın birimlerine bağlı olacaktır.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "Oluşturulacak eşyaları içeren bir liste. Ayrıca tek bir eşyadan da oluşabilir.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "Eşya listesine karşılık gelen bir miktar listesi. Yalnızca bir eşya türünün miktarını içerebilir.",
  T_35_WZY_WS_DAMTYPE_CAR: "Araç",
  T_35_WZY_WS_DAMTYPE_FALL: "Düşüş",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Tabanca",
  T_35_WZY_WS_DAMTYPE_GRENADE: "El Bombası",
  T_35_WZY_WS_DAMTYPE_MELEE: "Yakın",
  T_35_WZY_WS_DAMTYPE_ZONE: "Alan dışı",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Belirli oyuncuların belirli sayıda nesnesini sil",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Tetik bölgesine gir",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'Bir "Varlığı Tetikle", tetikleme alanına girdiğinde tetiklenir',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "Varlığı alacak olan oyuncu. Oyuncuya bağlandığında, varlık's bilgileri yalnızca söz konusu oyuncu için güncellenecektir. Hiçbir oyuncu bağlı olmadığında, tüm oyuncular varlık bilgisini alır.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Çatışma Varlığı",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Belirtilen türdeki tüm nesneleri edinin. Sonuç bir listedir.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Obje tipi",
  T_35_WZY_WS_HUDWIDGET_NAME: "UI Kontrolü",
  T_35_WZY_WS_HURT_NAMEDESC: 'Bu varlık hasar aldığında tetiklenir. Saldırının kaynağı "Varlığı Tetikle" kullanılarak belirlenebilir.',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "Eşya türü",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Sahne Objesi",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'Bu varlık başka bir varlığı ortadan kaldırdığında tetiklenir. Elenen varlığın türü, "Elenen Varlık" kullanılarak tanımlanabilir.',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "Elenen varlık",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Hasar verildiğinde tetiklenir",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "Hasar veren varlık",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Hedef varlık",
  T_35_WZY_WS_PREFABID_NAME: "Şablon ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "Mevcut SB",
  T_35_WZY_WS_PROPERTY_JUMP: "Zıplama yüksekliği",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Tetik bölgesinden çık",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'Bir "Varlığı Tetikle " tetikleme alanından çıktıktan sonra tetiklenir',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Diziden belirli bir öğe kaldır.[Liste] öğenin bulunduğu dizidir. [Öğe] kaldırılacak olan öğedir.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Öğe değeri",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "Öğenin değeri kaldırılacak",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Tur Varlığı",
  T_35_WZY_WS_TOWER_PARAM1: "Kule ve Kale",
  T_35_WZY_WS_TOWER_PARAM2: "Takım ID",
  T_35_WZY_WS_TOWER_PARAM3: "Mevcut CP",
  T_35_WZY_WS_TOWER_PARAM4: "Maks CP",
  T_35_WZY_WS_TOWER_PARAM5: "Hasar",
  T_35_WZY_WS_TOWER_PARAM6: "Saldırı Tamsayısı",
  T_35_WZY_WS_TOWER_PARAM7: "Saldırı mesafesi",
  T_35_WZY_WS_TOWER_PARAM8: "Defans %",
  T_35_XYL_PDM_REVENGE: "İntikam",
  T_35_XYL_WS_BISPARTERRE: "Grafitti Çiçekliği",
  T_35_XYL_WS_BISPARTERRE_DESC: "Tarzın İle Savaş temalı taştan çiçeklik",
  T_35_XYL_WS_BISWALL: "Grafitti Duvarı",
  T_35_XYL_WS_BISWALL_DESC: "Birleştirilebilen ve Tarzın İle Savaş temalı duvar",
  T_35_XYL_WS_BOTDROP: "Yağma düşmesini aç/kapat",
  T_35_XYL_WS_CUSTOMTRIGGER: "Varsayılan tetikleyici",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Bir oyuncu etkinleştirdiğinde belirli bir özelleştirilmiş özel efekti tetikleyen bir nesne yerleştirin. Efekt, komut dosyasında yapılandırılmalıdır. (Yalnızca FF Zanaat Modunda görünür)",
  T_35_XYL_WS_DOUBLEDOOR: "Kapı",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "Ağzı açık kapı",
  T_35_XYL_WS_RESET: "Her tur sıfırlanır",
  T_35_XYL_WS_RESETN: "Hayır",
  T_35_XYL_WS_RESETY: "Evet",
  T_35_XYL_WS_ROADBLOCK: "Barikat A",
  T_35_XYL_WS_ROADBLOCK_DESC: "İçinden geçilmesini engeller",
  T_35_XYL_WS_STAIRS: "Merdiven",
  T_35_XYL_WS_STAIRS_DESC: "İnişler ile yapılabilen merdivenler",
  T_35_XYL_WS_STAIRSL: "B İnişi",
  T_35_XYL_WS_STAIRSL_DESC: "Merdivenler ile yapılabilen bir platform",
  T_35_XYL_WS_STAIRSZ: "A İnişi",
  T_35_XYL_WS_STAIRSZ_DESC: "Merdivenler ile yapılabilen bir platform",
  T_35_XYL_WS_TBOOTH: "Telefon Kulübesi",
  T_35_XYL_WS_TBOOTH_DESC: "Sokaklarda oldukça sık rastlanır",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "Agui",
  T_35_YS_A_CUBBY: "Yavru Maskesi",
  T_35_YS_F_A_PANTOMIME: "Tekil Keder (Maske)",
  T_35_YS_F_A_RIDERS: "Ölümcül Sürücü (Maske)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Güzellik Birleştiren (Alt)",
  T_35_YS_F_B_GOLDCHAIN: "Refahlık Zırhı (Alt)",
  T_35_YS_F_B_PANTOMIME: "Tekil Keder (Alt)",
  T_35_YS_F_B_RIDERS: "Ölümcül Sürücü (Alt)",
  T_35_YS_F_H_BEAR_HW: "Yavru Şapkası",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Güzellik Birleştiren (Kafa)",
  T_35_YS_F_H_GOLDCHAIN: "Refahlık Zırhı (Kafa)",
  T_35_YS_F_H_PANTOMIME: "Tekil Keder (Kafa)",
  T_35_YS_F_H_RIDERS: "Ölümcül Sürücü (Kafa)",
  T_35_YS_F_HA_GOLDCHAIN: "Refahlık Zırhı (Yüz Boyası)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Güzellik Birleştiren (Ayakkabı)",
  T_35_YS_F_S_GOLDCHAIN: "Refahlık Zırhı (Ayakkabı)",
  T_35_YS_F_S_PANTOMIME: "Tekil Keder (Ayakkabı)",
  T_35_YS_F_S_RIDERS: "Ölümcül Sürücü (Ayakkabı)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Güzellik Birleştiren (Üst)",
  T_35_YS_F_T_GOLDCHAIN: "Refahlık Zırhı (Üst)",
  T_35_YS_F_T_PANTOMIME: "Tekil Keder (Üst)",
  T_35_YS_F_T_RIDERS: "Ölümcül Sürücü (Üst)",
  T_35_YS_ITEM_SUPERFAK: "Süper Med",
  T_35_YS_M_A_GOLDCHAIN: "Işığın Zincirleri (Maske)",
  T_35_YS_M_A_RIDERS: "Acımasız Sürücü (Maske)",
  T_35_YS_M_B_GOLDCHAIN: "Işığın Zincirleri (Alt)",
  T_35_YS_M_B_RIDERS: "Acımasız Sürücü (Alt)",
  T_35_YS_M_H_BEAR_HW: "Yavru Şapkası",
  T_35_YS_M_H_GOLDCHAIN: "Işığın Zincirleri (Kafa)",
  T_35_YS_M_H_RIDERS: "Acımasız Sürücü (Kafa)",
  T_35_YS_M_S_GOLDCHAIN: "Işığın Zincirleri (Ayakkabı)",
  T_35_YS_M_S_RIDERS: "Acımasız Sürücü (Ayakkabı)",
  T_35_YS_M_T_GOLDCHAIN: "Işığın Zincirleri (Üst)",
  T_35_YS_M_T_RIDERS: "Acımasız Sürücü (Üst)",
  T_35_YS_T_CHAMPION: "Şampiyon Tişörtü",
  T_35_YS_T_PAINTING: "Sıkma Tişört",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Maç başlarken para al",
  T_36_JH_WS_CESAYCLOSE: "Manuel kapatmayı devre dışı bırak veya aç",
  T_36_JH_WS_CHOOSEEDITSHOP: "Düzenlemek için bir mağaza seç",
  T_36_JH_WS_CHOOSESHOP: "Mağaza seç",
  T_36_JH_WS_COINCOUNT: "Para birimi miktarı",
  T_36_JH_WS_COINHUD: "Para miktarını görüntüle veya görüntüleme",
  T_36_JH_WS_CRAFTSHOP: "Mağazayı düzenle",
  T_36_JH_WS_CREATEGOLD: "Para Jeneratörü",
  T_36_JH_WS_CSHOPENTITY: "Mağaza varlığını bağla",
  T_36_JH_WS_CSHOPHUD: "Mağaza arayüzü",
  T_36_JH_WS_CURRENTLIMIT: "Kalan satın alım limiti",
  T_36_JH_WS_ECONOMIC: "Ekonomi",
  T_36_JH_WS_INGAMEECONOMI: "Oyun ekonomisi",
  T_36_JH_WS_ITEMINDEXID: "Ürün numarası",
  T_36_JH_WS_KILLMONEY: "Elediğinde para al",
  T_36_JH_WS_KILLMONEYTIP: "Acele ve Dayanıklılık modlarında zombileri eleyerek kazanılabilecek para miktarı",
  T_36_JH_WS_LISTINDEX: "Ürün türü listesi",
  T_36_JH_WS_NULL: "Boş",
  T_36_JH_WS_NUMBER: "Tutar",
  T_36_JH_WS_OPTIONNAME: "Droid Kıyameti Modu Özel",
  T_36_JH_WS_REALSHOPENTITY: "Mağaza varlığı",
  T_36_JH_WS_SEEORHIDE: "Otomat Makinesini göster",
  T_36_JH_WS_SHOPFRONT: "Mağaza",
  T_36_JH_WS_SHOPITEMLIST: "Ürün türü",
  T_36_JH_WS_SHOPOPENCON: "Durumu aç",
  T_36_JH_WS_SSHOPNAME: "Mağaza ismi",
  T_36_JH_WS_TOTALLIMIT: "Satın alım limiti",
  T_36_JH_WS_TRIGGERWIDE: "Tetiklenme mesafesi",
  T_36_JH_WS_VENDMACHINE: "Otomat Makinesi",
  T_36_JH_WS_WINMONEY: "Zafer kazandığında para al",
  T_36_JH_WS_WORTH: "Değer",
  T_36_JL_FOREGRIP_MR_N: "Nişancı Ön Kabzası",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Pompalı Kabzası",
  T_36_JL_STOCK_SR_N: "Nişancı Tüfeği Kabzası",
  T_36_KK_WS_MONTSTERDES: "Yüksek dayanıklılığa sahip 4 kişilik bir kamyon ve zorlu arazilerde seyahat edebilir",
  T_36_M_WS_SETTEMPVAR: "Geçici değişken ayarla",
  T_36_M_WS_TEMPVAR: "Geçici değişken",
  T_36_SY_AK47_MAMBAS_N: "AK47 - Mamba Alevi",
  T_36_SY_AN94_MAMBAS_N: "AN94 - Mamba Alevi",
  T_36_SY_AR15_MAMBAS_N: "Yalıçapkını - Mamba Alevi",
  T_36_SY_AUG_MAMBAS_N: "AUG - Mamba Alevi",
  T_36_SY_AWM_MAMBAS_N: "AWM - Mamba Alevi",
  T_36_SY_BLT_MAMBAS_N: "M28B - Mamba Alevi",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Şarj Bozan - Mamba Alevi",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle - Mamba Alevi",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS - Mamba Alevi",
  T_36_SY_G18_MAMBAS_N: "G18 - Mamba Alevi",
  T_36_SY_G36_MAMBAS_N: "G36 - Mamba Alevi",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "El Bombası - Donanma Şenliği",
  T_36_SY_GROZA_MAMBAS_N: "Groza - Mamba Alevi",
  T_36_SY_HAND_CANNON_MAMBAS_N: "El Topu - Mamba Alevi",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Şifa Tüfeği - Mamba Alevi",
  T_36_SY_ICE_GUN_MAMBAS_N: "Buz Tabancası - Mamba Alevi",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k - Mamba Alevi",
  T_36_SY_KORD_MAMBAS_N: "Kord - Mamba Alevi",
  T_36_SY_M1014_MAMBAS_N: "M1014 - Mamba Alevi",
  T_36_SY_M14_MAMBAS_N: "M14 - Mamba Alevi",
  T_36_SY_M1873_MAMBAS_N: "M1873 - Mamba Alevi",
  T_36_SY_M1887_MAMBAS_N: "M1887 - Mamba Alevi",
  T_36_SY_M1917_MAMBAS_N: "M1917 - Mamba Alevi",
  T_36_SY_M21A5_MAMBAS_N: "Ağaçkakan - Mamba Alevi",
  T_36_SY_M24_MAMBAS_N: "M24 - Mamba Alevi",
  T_36_SY_M249_MAMBAS_N: "M249 - Mamba Alevi",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 - Mamba Alevi",
  T_36_SY_M500_MAMBAS_N: "M500 - Mamba Alevi",
  T_36_SY_M60_MAMBAS_N: "M60 - Mamba Alevi",
  T_36_SY_M79_MAMBAS_N: "M79 - Mamba Alevi",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 - Mamba Alevi",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 - Mamba Alevi",
  T_36_SY_MINI_MAMBAS_N: "AC80 - Mamba Alevi",
  T_36_SY_MP40_MAMBAS_N: "MP40 - Mamba Alevi",
  T_36_SY_MP5_MAMBAS_N: "MP5 - Mamba Alevi",
  T_36_SY_P90_MAMBAS_N: "P90 - Mamba Alevi",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL - Mamba Alevi",
  T_36_SY_PP19_MAMBAS_N: "Bizon - Mamba Alevi",
  T_36_SY_PP19_POLICEMAN_N: "Bizon - Büyü Ajanı",
  T_36_SY_SCAR_MAMBAS_N: "SCAR - Mamba Alevi",
  T_36_SY_SKS_MAMBAS_N: "SKS - Mamba Alevi",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12 - Mamba Alevi",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLAZMA - Mamba Alevi",
  T_36_SY_SVD_MAMBAS_N: "SVD - Mamba Alevi",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson - Mamba Alevi",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Hançer - Mamba",
  T_36_SY_THROWINGKNIFE_MENA_N: "Hançer - Bohem",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Şifa Tabancası - Mamba Alevi",
  T_36_SY_UMP45_MAMBAS_N: "UMP - Mamba Alevi",
  T_36_SY_USP45_MAMBAS_N: "USP - Mamba Alevi",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi - Mamba Alevi",
  T_36_SY_VECTOR_MAMBAS_N: "Vektör - Mamba Alevi",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Canavar Kamyon - Altın Parıltısı",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Motosiklet - Hayali Gezinti",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Spor Araba - Asil Hız",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Tuk Tuk - Yeraltı Gezisi",
  T_36_SY_VSS_MAMBAS_N: "VSS - Mamba Alevi",
  T_36_SY_XM8_MAMBAS_N: "XM8 -  - Mamba Alevi",
  T_36_WZY_AFTERACCUMULATOR: "Geri toplayıcı",
  T_36_WZY_AVAILAB: "Kullanılabilir",
  T_36_WZY_BACKANDFORTH: "Gidiş dönüş",
  T_36_WZY_BASEMULTIPLIER: "Temel çarpan",
  T_36_WZY_BASIC: "Temel tür",
  T_36_WZY_BEFORACCUMULATOR: "Ön toplayıcı",
  T_36_WZY_CYLIC: "Geriye dönüş",
  T_36_WZY_GUNPRO_PARAM1: "Temel hasar",
  T_36_WZY_GUNPRO_PARAM10: "Mermi dağılması başladı",
  T_36_WZY_GUNPRO_PARAM11: "Maks. yayılma alanı",
  T_36_WZY_GUNPRO_PARAM12: "Seri Atış",
  T_36_WZY_GUNPRO_PARAM2: "Şarjördeki mermiler",
  T_36_WZY_GUNPRO_PARAM3: "Başlangıçtaki şarjör sayısı",
  T_36_WZY_GUNPRO_PARAM4: "Atış aralığı",
  T_36_WZY_GUNPRO_PARAM7: "Maks. hasar mesafesi",
  T_36_WZY_GUNPRO_PARAM8: "Min. hasar mesafesi",
  T_36_WZY_GUNPRO_PARAM9: "Minimum hasar",
  T_36_WZY_MULTIPLIR: "Çarpan",
  T_36_WZY_PRICE: "Fiyat",
  T_36_WZY_SUMMULTIPLIER: "Çarpan akümülatör",
  T_36_WZY_WS_3DZOOM: "3B Yakınlaştırma",
  T_36_WZY_WS_ABSRES: "Mutlak değer sonucu",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "[Kaynak listesi]'ndeki tüm öğeleri [Hedef listesi]'nin altına ekle",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "Öğelerin ekleneceği hedef liste",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "Eklenecek öğeleri içeren kaynak listesi",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Belirli bir cüzdana belirli bir miktarda belirlenmiş para birimi ekle",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Cüzdan",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "Para biriminin ekleneceği cüzdan",
  T_36_WZY_WS_ADDSUB: "Değerleri ekle çıkar",
  T_36_WZY_WS_AIENTITY: "YZ Varlığı",
  T_36_WZY_WS_ALLSHOP_DESC: "Mağaza varlıklarını içeren liste",
  T_36_WZY_WS_ANGLE_DESC: "Açının ölçüsü",
  T_36_WZY_WS_ANYTYPE: "Herhangi bir tür",
  T_36_WZY_WS_ARILEFT: "İşlemde kalan değer",
  T_36_WZY_WS_ARIRES: "İşlem sonucu",
  T_36_WZY_WS_ARIRIGHT: "İşlemdeki doğru değer",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 aritmetik işlem",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "Temel tam sayı işlemleri toplama, çıkarma, çarpma, bölme ve kalanı destekler. Float işlemleri toplama, çıkarma, çarpma ve bölmeyi destekler.",
  T_36_WZY_WS_ARRAY_DESC: "Hedef liste",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Bir listenin belirlenmiş bir öğe içerip içermediğini kontrol et. Döndürülen değer Boole olur",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "Belirlenen liste",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "Listede aranacak öğe",
  T_36_WZY_WS_ARRCONELERES: "Bir listede belirlenmiş bir öğenin bulunup bulunmadığının sonucu. Değer Boole olur.",
  T_36_WZY_WS_ATTACK: "Dolaş ve saldır",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Bir oyuncu yere serildiğinde tetiklenir",
  T_36_WZY_WS_BIGFLOAT: "Büyük ondalık",
  T_36_WZY_WS_BIGTOYBALL: "Zar",
  T_36_WZY_WS_BOOLLIST: "Boole listesi",
  T_36_WZY_WS_CEIL_NAME_DESC: "Bir değeri kendisinden büyük en küçük tam sayıya yuvarla",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "Yukarı yuvarlanacak olan değer",
  T_36_WZY_WS_CEILRES: "Yukarı yuvarlama sonucu",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "Seçilen YZ, mesafeden bağımsız olarak bu varlığı takip edecektir. [Takip edilen varlık] herhangi bir varlık olabilir. [Takip edilen varlık] bir CP özelliğine sahip olmadığında, YZ varlığı herhangi bir hasar vermez.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "Kovalayan varlık",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "Takip edilen hedef varlık. Herhangi bir varlık olabilir.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "Nesneleri klonlamak için şablon. İmleci kullanarak seç. Klonun özelliği ve komut dosyası, seçilen nesneninkiyle aynı olacaktır.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "Klonlanacak olan nesne varlığı",
  T_36_WZY_WS_CONDITION: "Durum",
  T_36_WZY_WS_CONDITIONLIST: "Durum listesi",
  T_36_WZY_WS_CONOFHUD: "Kontrolün içinde bulunduğu HUD varlığı",
  T_36_WZY_WS_CONTROL_DESC: "Bir kontrolün tek indeksi",
  T_36_WZY_WS_COS_NAMEDESC: "Açının kosinüsünü bul",
  T_36_WZY_WS_COSRES: "Açının kosinüsü",
  T_36_WZY_WS_CREABLEOB: "Oluşturulabilir nesne",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Belirlenmiş bir konumda bir nesne varlığı oluştur. (Test sürümü)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "Oluşturulacak olan nesnenin koordinatları",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "Oluşturulacak nesnenin türü",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "Yaratılacak olan nesnenin varlığı",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Para birimi",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Ürün varlığı",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Bir ürün varlığı oluştur",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Bir cüzdan varlığı oluştur. [Bağlanan oyuncu] bu cüzdanı görebilen oyuncudur. [Sahip], cüzdanın ait olduğu oyuncudur. Zaten bir cüzdan varsa geçersizdir.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Bağlı oyuncu",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "Cüzdanın göründüğü oyuncu. Herhangi bir ayar yapılandırılmazsa, cüzdan herkes tarafından görülebilir.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "Cüzdan sahibi",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Cüzdan varlığı",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "Oluşturulan cüzdan varlığı",
  T_36_WZY_WS_CURRAMT: "Para birimi miktarı",
  T_36_WZY_WS_DATA_TYPE1: "Eklenen parametre",
  T_36_WZY_WS_DATA_TYPE2: "Temel ve mantık hesaplaması",
  T_36_WZY_WS_DATA_TYPE3: "Liste kontrolü",
  T_36_WZY_WS_DATA_TYPE4: "Vektör hesaplaması",
  T_36_WZY_WS_DESTITEM_NAME: "Oyuncu eşyasını imha et",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Belirlenmiş bir oyuncu için belirlenmiş bir eşya türünü yok et",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Kask, yelek, silah gibi imha edilebilir eşyalar",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "Seçilen öğe türünün yuva dizini. Varsayılan olarak silah indeksi [1,3] ve Yelek ve Kask 1.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Haklandığında ekipmanın kaybolur",
  T_36_WZY_WS_DESTOBJ: "Yok edilebilir nesneler",
  T_36_WZY_WS_DIRPOINT: "Yön noktası",
  T_36_WZY_WS_DIRPOINTDESC: "Oluşturulacak yön noktası",
  T_36_WZY_WS_ELEFINDRES: "Bir öğenin ilk pozisyonunun indeksi",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: "Bir oyuncu bir silahı başarıyla kuşandığında tetiklenir. [Tetikleyen oyuncu] bir silahı başarıyla kuşanan oyuncudur. [Silah türü] oyuncunun kuşandığı silahtır.",
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "Listede aranacak öğe",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'Listedeki bir öğenin son konumunun indeksini alır. Hedef öğe listede yoksa, sonuç "-1" değerini döndürür.',
  T_36_WZY_WS_ELELINDRES: "Bir öğenin son pozisyonunun indeksi",
  T_36_WZY_WS_ELEMENTSNUM: "Listedeki öğe #",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "[Tetikleyici varlık] bu tetikleyici ile çarpıştığında tetiklenir",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "Bu tetikleyicinin çarpıştığı varlık",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "[Tetikleyici varlık] aracı kullandığında tetiklenir",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "Aracı kullanan varlık",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Oyuncu tetikleyiciye girdiğinde tetiklenir",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "Girmek için gereken tetikleyici",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "[Tetikleyici varlık] araçtan indiğinde tetiklenir",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "Araçtan çıkan varlık",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "[Tetikleyici bir varlık] araca girdiğinde tetiklenir",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "Araca giren varlık",
  T_36_WZY_WS_ENTITY_TYPE1: "Sık kullanılan",
  T_36_WZY_WS_ENTITY_TYPE2: "Özellikler",
  T_36_WZY_WS_ENTITY_TYPE3: "Nesneler ve eşyalar",
  T_36_WZY_WS_ENTITY_TYPE4: "YZ",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "Değiştirilecek olan öğe değeri",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Hedef oyuncu",
  T_36_WZY_WS_ENTITYLIST: "Varlık listesi",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "[Tetikleyici varlık] tekerlekten sektiğinde tetiklenir",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "Tekerlekten seken varlık",
  T_36_WZY_WS_ENTTP_NAMEDESC: "[Tetikleyici varlık] bir geçide girdiğinde ve ışınlandığında tetiklenir",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "Işınlanan varlık",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "Yelek, kask ve çanta dahil olmak üzere kuşanılan zırh türü",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Bir oyuncu bir silahı başarıyla kuşandığında tetiklenir. [Tetikleyen oyuncu] bir silahı başarıyla kuşanan oyuncudur. [Silah varlığı] oyuncunun kuşandığı silahtır.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "Kuşanılan silah varlığı",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Silah türü",
  T_36_WZY_WS_EULERANGLE: "Euler açıları",
  T_36_WZY_WS_FACECAMERA: "Her zaman kameraya dön",
  T_36_WZY_WS_FLOATLIST: "Kayan liste",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Bir değeri kendisinden küçük en büyük tam sayıya yuvarla",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "Aşağı yuvarlanacak değer",
  T_36_WZY_WS_FLOORRES: "Aşağı yuvarlama sonucu",
  T_36_WZY_WS_FORMUENT: "Özellikleri formüle edilebilir varlık",
  T_36_WZY_WS_FORMUFACT: "Özellik formülü faktörü türü",
  T_36_WZY_WS_GAME_TYPE2: "Oynanış",
  T_36_WZY_WS_GAME_TYPE3: "Özel efektler",
  T_36_WZY_WS_GENENT_NAMEDESC: "Bir jeneratör birimleri ürettiğinde tetiklenir. [Birim varlığı listesi], oluşturucu tarafından oluşturulan birimlerin listesidir. [dalga # ], nesil tarafından üretilen dalgaların sayısıdır.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Birim varlığı",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "Bir jeneratör tarafından oluşturulan birim varlıklardan oluşan bir liste",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "Bir jeneratörün ürettiği dalga sayısı",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Maçtaki tüm mağazaları elde edin. Döndürülen değer, mağaza varlıklarından oluşan bir listedir.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Renk elde etmek için RGB kullan",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Belirli bir cüzdanda belirli bir para biriminin miktarını elde et",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "Para birimi tutarının alınacağı cüzdan",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "Alınacak para birimi tutarının para birimi türü",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Hedef varlığın varlık türünü edin",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "Türü elde edilecek olan varlık",
  T_36_WZY_WS_GETENTTYPERES: "Hedef varlığın varlık türü",
  T_36_WZY_WS_GETFOR_NAME: "Yön koordinatlarını al",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Belirlenmiş bir yön noktasının vektörünü elde et",
  T_36_WZY_WS_GETFORRES: "Yön noktasının vektörü",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Cüzdanda belirli bir para birimi türünün para birimi varlığını elde edin",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "Para biriminin bulunduğu cüzdan",
  T_36_WZY_WS_GETPOS_NAME: "Koordinatları al",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Belirlenmiş bir yön noktasının koordinatlarını al",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "Belirlenen yön noktası",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Ekipman türü",
  T_36_WZY_WS_GETWALLET_NAME: "Cüzdan edin",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Seçilen sahibin cüzdanını elde et",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Bağlanan cüzdanının var olup olmadığı",
  T_36_WZY_WS_GETWALLETRES: "Sahibin cüzdan varlığı",
  T_36_WZY_WS_HUDCONTROL_DESC: "Bir HUD'nin kontrol varlığı",
  T_36_WZY_WS_HUDTYPE: "HUD tipi",
  T_36_WZY_WS_INCIDENT_TYPE1: "Maç genelindeki olay",
  T_36_WZY_WS_INCIDENT_TYPE2: "Varlık olayı",
  T_36_WZY_WS_INDEX_DESC: "Bir listenin indeks değeri.0'dan başlar.",
  T_36_WZY_WS_INTLIST: "Tam sayı listesi",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Bir varlık türünün belirli bir alt kategoriye ait olup olmadığını kontrol et. Döndürülen sonuç Boole olur.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "Varlığın kendisine ait olup olmadığı kontrol edilecek olan üst kategori",
  T_36_WZY_WS_JENTSUBCLRES: "Üst kategori kontrolü sonucu",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Bir varlığın belirli bir varlık türüne aitliğini kontrol eder. Sonuç Boole olur.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "Kontrol edilecek varlık",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Varlık türüyle aynı olduğu anlamına gelir",
  T_36_WZY_WS_JENTTYPERES: "Varlık kontrolü sonucu",
  T_36_WZY_WS_JUSTPATROL: "Yalnızca dolaş",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Oyuncu tetikleyiciden çıktığında tetiklenir",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "Çıkmak için gereken tetikleyici",
  T_36_WZY_WS_LEVELOBLIST: "Obje listesi",
  T_36_WZY_WS_LEVOBJSLIST: "Bu maçtaki bütün harita nesnelerinin listesi",
  T_36_WZY_WS_LEVOBTYPE: "Obje tipi",
  T_36_WZY_WS_LISTT: "Herhangi bir liste",
  T_36_WZY_WS_LOGCONTEXT_DESC: "Yazdırılacak olan içerik",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "Bağlanacak sol dizi",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "Bağlanacak sağ dizi",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "Eklenecek öğe değeri",
  T_36_WZY_WS_LOGOPER: "Mantık işlemleri (ve & veya) yürütülürken: ve işlemi ve iki Boole değeri DOĞRU ise, sonuç DOĞRU olur ve veya işlem ve iki Boole değerinin her ikisi de YANLIŞ değilse, sonuç DOĞRU olur.",
  T_36_WZY_WS_LOOTPOINT: "Yağma noktası",
  T_36_WZY_WS_MAINWEAP: "Mevcut Silah",
  T_36_WZY_WS_MAX_DESC: "Oluşturulan tam sayının üst aralığı (açık aralık)",
  T_36_WZY_WS_MIN_DESC: "Oluşturulan tamsayının alt aralığı (kapalı aralık)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Silah varlığı",
  T_36_WZY_WS_MONENT: "Para birimi varlığı",
  T_36_WZY_WS_MONTYPE: "Para birimi türü",
  T_36_WZY_WS_MOVETO_NAMEDESC: "YZ'yi bir hedef noktaya doğru hareket ettir. YZ'nin orijinal konumuna geri dönüp dönmeyeceğini seçmek için [Geri Dön veya Dönme] düğmesini kullan. YZ'nin yolda düşmanları tarayıp taramayacağını seçmek için [Saldırı veya saldırma]yı kullan.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "Seyahat edecek YZ varlığı",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "Varış noktası",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "YZ'nin hedefe vardıktan sonra orijinal konumuna dönüp dönmeyeceğini ayarlamak için kullan. DOĞRU dönüş yap anlamına gelir; YANLIŞ, geri dönme anlamına gelir.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Saldır ya da saldırma",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "YZ' yol boyunca yakındaki düşmanlara saldırıp saldırmayacağını ayarlamak için kullan. DOĞRU, düşmanları taramak anlamına gelir; YANLIŞ, düşmanları taramamak anlamına gelir.",
  T_36_WZY_WS_MULVALUE: "Skaler",
  T_36_WZY_WS_MULVEC: "Skaler çarpma vektörü",
  T_36_WZY_WS_NEGRES: "Negatif değer sonucu",
  T_36_WZY_WS_NEUTRAL: "Nötr",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Belirlenen jeneratörü bir sonraki dalgayı oluşturmaya zorlar. Jeneratörler, Zombi başlangıç noktası ve eşya başlangıç noktasını içerir.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Jeneratör varlığı",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "Zombi başlangıç noktası ve eşya başlangıç noktası gibi belirlenmiş jeneratör varlık",
  T_36_WZY_WS_OBJENT: "Nesne varlığı",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Bir eşya alındığında tetiklenir. [Eşya tipi] alınan eşyanın tipidir.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Bir silah alındığında tetiklenir. [Silah varlığı] alınan silahtır.",
  T_36_WZY_WS_ONEWAY: "Tek yön",
  T_36_WZY_WS_OPENSTATE: "Durum",
  T_36_WZY_WS_OPERMETHOD_NAME: "İşlem",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "Temel aritmetik işlemler. Şu anda tam sayı işlemleri toplama, çıkarma, çarpma, bölme ve kalanı içerir ve float işlemleri toplama, çıkarma, çarpma ve bölmeyi içerir.",
  T_36_WZY_WS_OWNERENT_DESC: "Cüzdanını alacak olan varlık",
  T_36_WZY_WS_PERCENTAGE: "Yüzde ayarlaması",
  T_36_WZY_WS_PLACOLLIDE_NAME: "Bir oyuncu tetikleyici ile çarpıştığında",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "[Tetikleyici oyuncu] tetikleyici ile çarpıştığında tetiklenir",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "Tetikleyici ile çarpışan oyuncu",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "Oyuncunun çarpıştığı nesne varlığı",
  T_36_WZY_WS_PLADRIVEH_NAME: "Oyuncu aracı kullandığında",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "[Tetikleyici oyuncu] aracı kullandığında tetiklenir",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "Aracı kullanan oyuncu",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "Oyuncunun kullandığı araç varlığı",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "Oyuncu araçtan indiğinde",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "[Tetikleyici oyuncu] araçtan çıktığında tetiklenir",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "Araçtan çıkan oyuncu",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "Oyuncunun çıktığı araç varlığı",
  T_36_WZY_WS_PLAGETONVEH_NAME: "Oyuncu araca girdiğinde",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "[Tetikleyici oyuncu] bir araca girdiğinde tetiklenir",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "Oyuncunun girdiği araç",
  T_36_WZY_WS_PLAKNOFLY_NAME: "Oyuncu tekerlekten sektiğinde",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "[Tetikleyici oyuncu] bir tekerlekten sektiğinde tetiklenir",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "Tekerlekten seken oyuncu",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "Oyuncunun zıpladığı nesne varlığı",
  T_36_WZY_WS_PLATP_NAME: "Bir oyuncu ışınlandıktan sonra",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "Geçit kullanan oyuncu",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "Oyuncunun kullandığı geçit",
  T_36_WZY_WS_PLAYERLIST_DESC: "Maçtaki tüm oyuncuların listesi",
  T_36_WZY_WS_POINTPICKER: "Yol ekseni",
  T_36_WZY_WS_PORTALENT: "Geçit varlığı",
  T_36_WZY_WS_PREFAB: "Şablon",
  T_36_WZY_WS_PRODLIST: "Ürün listesi",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Sıralama düzeni",
  T_36_WZY_WS_PROPMOD: "Özellik değişimi metodu",
  T_36_WZY_WS_RANKABLEE: "Derecelendirilebilir varlık",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Belirlenmiş bir cüzdanda belirli miktarda belirlenmiş para birimi harca",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "Para birimini harcayan cüzdan",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "Harcanılan para birimi türü",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "Harcanan para birimi miktarı",
  T_36_WZY_WS_RNDFRES: "Üretilen rastgele kaydırma",
  T_36_WZY_WS_RNDIRES: "Rastgele tam sayı oluşturmanın sonucu",
  T_36_WZY_WS_ROUND_NAME_DESC: "Bir değeri en yakın tam sayıya yuvarla",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "Yuvarlanacak değer",
  T_36_WZY_WS_ROUNDRES: "Yuvarlama sonucu",
  T_36_WZY_WS_RUNAI_NAMEDESC: "Seçilen YZ'nin yürüteceği davranış ağacı",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "Varsayılan davranış ağacını durduran/çalışan birim varlığı",
  T_36_WZY_WS_SCOREABLEE: "Skorlandırılabilir varlık",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Skor değiştiğinde tetiklenir. [Skor tipi] değişen skorun tipidir. [Skor] yeni skordur.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Yön noktası oluştur",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Yeni oluşturulan bir yön noktası edin. Noktanın koordinatlarını ayarlamak için [Konum]u ve yön vektörünü ayarlamak için [Yön]ü kullan.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "Yön noktasının koordinatları",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Yön",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "Yön noktasının vektörü",
  T_36_WZY_WS_SETPATH_NAMEDESC: "YZ varlıkları burada ayarlanan sıraya göre seyahat eder. Mevcut seyahat türleri geriye dönüş, tek yön ve gidiş-dönüştür. YZ'nin yolda düşmanları tarayıp taramayacağını da seçebilirsin.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "Yapay zekanın seyahat etmesi gereken noktalardan oluşan bir liste",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "Seyahat türü",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "Bunlar seyahat türleridir. Tek yön, YZ'nin hedefe ulaştığında seyahat etmeyi bırakmasıdır. Geriye dönüş, YZ'nin hedefe ulaştığında bir geri dönüş yolu araması içindir. Gidiş-dönüş, YZ için yol listesinin geriye doğru sırasına göre orijinal konuma dönüş içindir.",
  T_36_WZY_WS_SHOPECON: "Mağaza ve ekonomi",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Ekranda kayan bildirimleri görüntülemek için kullan. İçeriği [Metin] kullanarak, metin rengini [Renk] kullanarak ve görüntüleme süresini [Süre] kullanarak yapılandır (birim milisaniyedir).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "Kayan bildirim içeriği",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "Kayan bildirim rengi",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "Kayan bildirimin milisaniye cinsinden görüntülenme süresi",
  T_36_WZY_WS_SIN_NAMEDESC: "Açının sinüsünü bul",
  T_36_WZY_WS_SINRES: "açının sinüsü",
  T_36_WZY_WS_SKIPKNODOWN: "Yere serildiğinde haklanıp haklanmadığı",
  T_36_WZY_WS_SQRTRES: "Karekök sonucu",
  T_36_WZY_WS_STRCONRES: "Dizi bağlanmasının sonucu",
  T_36_WZY_WS_STRINGLIST: "Dizi listesi",
  T_36_WZY_WS_STRLEN: "Dizi uzunluğu",
  T_36_WZY_WS_STRVAL: "Dizi sonucu",
  T_36_WZY_WS_TAN_NAMEDESC: "Açının tanjantını bul",
  T_36_WZY_WS_TANRES: "Açının tanjantı",
  T_36_WZY_WS_TEAMLIST: "Takım listesi",
  T_36_WZY_WS_TEAMLIST_DESC: "Bu maçtaki tüm takımların listesi",
  T_36_WZY_WS_TIMETWEENTIPS: "Geri sayım bildirim varlığı",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Hedef değeri bir diziye dönüştür",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "Bir diziye dönüştürülecek hedef değer",
  T_36_WZY_WS_TOSTRINGRES: "Dizi dönüştürmenin sonucu",
  T_36_WZY_WS_TOWERCAMP_DESC: "Taraf numarası ve takım numarası aynıdır. Tarafsız kuleler ve kaleler, menzil içindeki tüm oyunculara ve YZ'lere saldırır.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Belirli bir miktarda belirlenmiş para birimini bir cüzdandan diğerine aktar",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "Para biriminin alınacağı cüzdan",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "İşlemdeki para birimi türü",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "İşlemdeki para birimi miktarı",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "Para biriminin aktarılacağı cüzdan",
  T_36_WZY_WS_TWEENTIPS: "Kayan bildirim varlığı",
  T_36_WZY_WS_TYPEENUM: "Enum tipi",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Bir oyuncu bir öğe kullandığında tetiklenir. [Tetikleyen oyuncu] bir öğeyi kullanan oyuncudur. [Öğe türü], oyuncunun kullandığı öğedir",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "Oyuncu tarafından kullanılan eşya türü",
  T_36_WZY_WS_VECADDLEFT: "Vektör toplamanın sol değeri",
  T_36_WZY_WS_VECADDRES: "Vektör toplama sonucu",
  T_36_WZY_WS_VECADDRIGHT: "Vektör toplamanın doğru değeri",
  T_36_WZY_WS_VECANGLEFT: "Vektör açısının sol değeri",
  T_36_WZY_WS_VECANGRES: "2 vektör arasındaki açı",
  T_36_WZY_WS_VECANGRIGHT: "Vektör açısının sağ değeri",
  T_36_WZY_WS_VECCROLEFT: "Çapraz ürünün sol değeri",
  T_36_WZY_WS_VECCRORES: "Çapraz ürün sonucu",
  T_36_WZY_WS_VECCRORIGHT: "Çapraz ürünün doğru değeri",
  T_36_WZY_WS_VECDISLEFT: "Vektör mesafesinin sol değeri",
  T_36_WZY_WS_VECDISRES: "2 vektör arasındaki mesafe",
  T_36_WZY_WS_VECDISRIGHT: "Vektör mesafesinin doğru değeri",
  T_36_WZY_WS_VECDOCLEFT: "Nokta ürünün sol değeri",
  T_36_WZY_WS_VECDOCRES: "Nokta çarpım sonucu",
  T_36_WZY_WS_VECDOCRIGHT: "Nokta çarpımın doğru değeri",
  T_36_WZY_WS_VECMULRES: "Skaler çarpmanın sonucu",
  T_36_WZY_WS_VECNORRES: "Normalleştirilmiş vektör",
  T_36_WZY_WS_VECSIZERES: "Bir vektörün büyüklüğü",
  T_36_WZY_WS_VECSUBLEFT: "Vektör çıkarmanın sol değeri",
  T_36_WZY_WS_VECSUBRES: "Vektör çıkarma sonucu",
  T_36_WZY_WS_VECSUBRIGHT: "Vektör çıkarmanın doğru değeri",
  T_36_WZY_WS_VECTORLIST: "Vektör listesi",
  T_36_WZY_WS_VECX: "x bileşeni",
  T_36_WZY_WS_VECY: "y bileşeni",
  T_36_WZY_WS_VECZ: "z bileşeni",
  T_36_WZY_WS_VEHENT: "Araç varlığı",
  T_36_WZY_WS_WALLCONT: "Cüzdan içeriği",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Kesintisiz",
  T_36_XYL_WS_AIBOT: "Birim",
  T_36_XYL_WS_AIGENERATOR: "Birim Jeneratörü",
  T_36_XYL_WS_AIGENERATOR_DESC: "Sürekli olarak belirlenmiş birimler oluşturabilen bir jeneratör (örneğin zombiler)",
  T_36_XYL_WS_AIWAVE: "Dalga başına birim #",
  T_36_XYL_WS_ARROW: "Yön İşareti",
  T_36_XYL_WS_ARROW_DESC: "Yönü gösteren bir işaret",
  T_36_XYL_WS_BREAKBOX: "Kırılabilir Kutu",
  T_36_XYL_WS_BREAKBOX_DESC: "Saldırıya uğradığında kırılabilen tahta bir kutu",
  T_36_XYL_WS_FENCE: "Demir Çit",
  T_36_XYL_WS_FENCE_DESC: "Mermilerin içinden geçmesini sağlayan bir çit",
  T_36_XYL_WS_STAIRI: "C İnişi",
  T_36_XYL_WS_STAIRI_DESC: "Merdivenlerle birleşirilebilen bir platform",
  T_36_XYL_WS_ZOMBIEAI: "Zombi",
  T_36_XYL_WS_ZOMBIEAI_DESC: "Özelleştirilebilen ve Birim Jeneratöründe elde edilip çoğaltılabilen bir zombi",
  T_36_YF_CORRODE_GRENADE_N: "Pas Bombası",
  T_36_YF_SETTING_TYPE3: "Ön ayar 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF Okyanus Forması (Alt)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF Gün Işığı Forması (Alt)",
  T_36_YS_F_A_GHOSTHUNTER: "Şeytani Tilki Kuyruğu (Maske)",
  T_36_YS_F_B_GHOSTHUNTER: "Şeytani Tilki Kuyruğu (Alt)",
  T_36_YS_F_H_GHOSTHUNTER: "Şeytani Tilki Kuyruğu (Kafa)",
  T_36_YS_F_S_GHOSTHUNTER: "Şeytani Tilki Kuyruğu (Ayakkabı)",
  T_36_YS_SETTING_GRENADE: "Fırlatılanlar",
  T_36_YS_SETTING_MOVE: "Hareket",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF Okyanus Forması (Üst)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF Gün Işığı Forması (Üst)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Robokurt",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Yoldaş görünümü: Tatilci Miço",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Yoldaş Görünümü : Şimşek Şaho",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Yoldaş Görünümü: Robokurt Kıvılcımı",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Yoldaş görünümü: Hayali Rehber",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Yoldaş Görünümü: Robokurt Ayazı",
  T_37_B_WS_HIDE: "Saklambaç",
  T_37_HZ_WS_CATMODEDESC1: "Saklambaç",
  T_37_JH_WS_CREATEGOLD_DESC: "Oyuncuların eşya satın alabileceği bir Otomat. (Ekip Çarpışması, Takım Ölüm Oyunu, Oyun Alanı ve Droid Kıyameti modlarında geçerli değildir)",
  T_37_JH_WS_NAME1: "FF Bıçağı (Droid Kıyameti)",
  T_37_JH_WS_NAME10: "M1887-X (Droid Kıyameti)",
  T_37_JH_WS_NAME11: "SPAS12 (Droid Kıyameti)",
  T_37_JH_WS_NAME12: "M1014 (Droid Kıyameti)",
  T_37_JH_WS_NAME13: "MP40 (Droid Kıyameti)",
  T_37_JH_WS_NAME14: "MP5-III (Droid Kıyameti)",
  T_37_JH_WS_NAME15: "P90 (Droid Kıyameti)",
  T_37_JH_WS_NAME16: "M60-III (Droid Kıyameti)",
  T_37_JH_WS_NAME17: "Thompson (Droid Kıyameti)",
  T_37_JH_WS_NAME18: "UMP (Droid Kıyameti)",
  T_37_JH_WS_NAME19: "SVD  (Droid Kıyameti)",
  T_37_JH_WS_NAME2: "Groza (Droid Kıyameti)",
  T_37_JH_WS_NAME20: "AWM (Droid Kıyameti)",
  T_37_JH_WS_NAME21: "M82B (Droid Kıyameti)",
  T_37_JH_WS_NAME22: "M249-X (Droid Kıyameti)",
  T_37_JH_WS_NAME23: "Kar98k-III (Droid Kıyameti)",
  T_37_JH_WS_NAME3: "AK47 (Droid Kıyameti)",
  T_37_JH_WS_NAME4: "M4A1-III (Droid Kıyameti)",
  T_37_JH_WS_NAME5: "SCAR (Droid Kıyameti)",
  T_37_JH_WS_NAME6: "M14-III (Droid Kıyameti)",
  T_37_JH_WS_NAME7: "PARAFAL (Droid Kıyameti)",
  T_37_JH_WS_NAME8: "XM8 (Droid Kıyameti)",
  T_37_JH_WS_NAME9: "MAG-7 (Droid Kıyameti)",
  T_37_JH_WS_VENDMACHINE_DESC: "Haritadan toplanabilecek altın. (Ekip Çarpışması, Takım Ölüm Oyunu, Oyun Alanı ve Droid Kıyameti modlarında geçerli değildir)",
  T_37_JH_WS_X: "X Ekseni",
  T_37_JH_WS_Y: "Y Ekseni",
  T_37_JH_WS_Z: "Z Ekseni",
  T_37_JL_FOOTBALL_TIE: "Berabere",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "Kardan Adam Paytarz",
  T_37_LC_BP_ENTRANCE_GIFT: "Hediye!",
  T_37_M_WS_MISSING: "Kaynak eksik",
  T_37_M_WS_NAMEERROR: "Hassas karakterler içeriyor. Lütfen değiştir.",
  T_37_PD_HuntingGround_BOSSTITLE: "Kasap",
  T_37_QL_JUMPPAD_DES: "Yerde bir atlama alanı oluşturur. Havada yükseğe zıplamak için kullanılabilir ve havadan ateş etme imkanı sağlar.",
  T_37_QL_JUMPPAD_NAME: "Fırlatma Yastığı",
  T_37_R_TAILOR_LIMIT: "Sınırlı Süreli",
  T_37_RW_LOADOUT_BORNFIRETAG: "Maçın başında 2 Kamp Ateşi al. Kamp Ateşi [FFBA00]sen ve alandaki takım arkadaşların için saniyede 5 CP ve 20 EP[-] (10 saniyeye kadar) yeniler. Kamp ateşi etkileri birikmez.",
  T_37_RW_PROPCATAPULT_DESC: "Gerildiğinde, fırlatma rampası bir oyuncuyu havaya atmak için kullanılabilir. Ancak Güvenli Bölgede kaldığından emin ol!",
  T_37_RW_PROPCATAPULT_NAME: "Atış Rampaası",
  T_37_SP_WS_COLOR_02: "Renk",
  T_37_SP_WS_COLOR_03: "Görünüş",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "Varlık, özelliklerini alırken veya ayarlarken boş olur",
  T_37_SP_WS_LOG_PHASE_END: "Aşama {0} sona erdi.",
  T_37_SP_WS_LOG_PHASE_START: "Aşama {0} başlıyor",
  T_37_SP_WS_LOG_ROUND_END: "{0}. tur sona erdi.",
  T_37_SP_WS_LOG_ROUND_START: "{0}. tur başladı.",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "Değişkene bir değer atarken eşleşmeyen tür. Gerekli tür: {0}. Mevcut tür: {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Tanımsız veya kapsam dışı yerel değişken {0}",
  T_37_SP_WS_MAPACCESS_08: "Düzenle",
  T_37_SP_WS_RACEMODE_01: "Geri Sayım modu",
  T_37_SP_WS_RACEMODE_02: "Bekleme Süresi",
  T_37_SP_WS_RACEMODE_04: "Açık olduğunda, tüm takım bitiş noktasına ulaştığında bir geri sayım başlar. Geri sayım bittiğinde oyun biter.",
  T_37_SY_AR15_KABUKI_N: "Yalıçapkını - Çiçeğin Şarkısı",
  T_37_SY_BACKPACK_STRAW_N: "Çanta - Hasır Şapka",
  T_37_SY_GRENADE_FFWS2022_01_N: "El Bombası -Yıldız Donanması",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Kara Delik",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Mamba Alevi",
  T_37_SY_PET_FLYINGCREATURE_N: "Arvon",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Yoldaş Görünümü: Havalı Bereli",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Yoldaş görünümü: Küllü Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Yoldaş görünümü: Galaksi Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Yoldaş görünümü: Alevli Arvon",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Yoldaş Görünümü: Golcü Flaş",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Yoldaş Görünümü: Kış Diyarı Yeti",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Cip - Festival Turu",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Kamyonet - Galaksi Canavarı",
  T_37_WT_WS_PVE2DESC: `Oyuncuların belirli bir süre içinde belli sayıda zombiyi haklayarak ya da sona kadar hayatta kalarak kazandığı bir zombi hayatta kalma modudur.
Oyun kurallarını ve zombi ayarlarını, haklanacak zombi sayısı da dahil istediğin gibi düzenleyebilirsin.`,
  T_37_WT_WS_RULEDESC: "Kazanmak için zombi haklama hedefine ulaş.",
  T_37_WT_WS_RULETITLE: "Kale",
  T_37_WT_WS_TXT1: "Zombileri hakla",
  T_37_WT_WS_TXT1DESC: "Açık olduğunda, oyuncular belirtilen sayıda zombiyi ortadan kaldırarak kazanır. Kapalıyken, oyuncular sonuna kadar hayatta kalarak kazanır.",
  T_37_WT_WS_TXT2: "Haklama miktarı",
  T_37_WZY_FRIDPLA: "Arkadaş canlısı oyuncu",
  T_37_WZY_FRIDSIDE: "Dost Taraf",
  T_37_WZY_FRIDTEAM: "Dost Takım",
  T_37_WZY_HOSTPLA: "Rakip Oyuncu",
  T_37_WZY_HOSTSIDE: "Düşman Taraf",
  T_37_WZY_WS_ACCFRAMES: "Biriken çerçeveler",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Bir ürüne eşya ekleyin. Tek bir eşya veya bir grup eşya ekleyebilirsiniz. Miktar, tek tek eşyaların sayısı veya bu tutardaki eşyalardan oluşan bir liste olabilir.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "Eşyaların ekleneceği ürün varlığı",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "Eklenecek eşyalar. Tek bir eşya veya bir eşya grubu ekleyebilirsin.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "Tek tek eklenecek eşyaların miktarı veya bu miktardaki eşyalardan oluşan bir liste.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Seçilen varlık için bir etiket ekle",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "Etiketin ekleneceği varlık",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "Eklenecek metin içeriği",
  T_37_WZY_WS_AIMABLEENT: "Hedef alınabilir varlık",
  T_37_WZY_WS_AIMASSISTTYPE: "Nişan yardımı türü",
  T_37_WZY_WS_ALLOWDROP_NAME: "Eşya bırakmayı aç/kapa",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Bir oyuncunun eşya bırakıp bırakamayacağı",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "Eşyaların bırakılıp bırakılmayacağını yapılandırılacak oyuncu varlığı",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Bir oyuncunun eşya bırakıp bırakamayacağı. Boole değeridir.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Eşya toplamayı aç/kapa",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Oyuncunun eşya alıp alamayacağı",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "Eşyaların alınıp alınmayacağını yapılandırılacak oyuncu varlığı",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Bir oyuncunun eşya alıp alamayacağı. Boole değeridir.",
  T_37_WZY_WS_AMBIENTCOLOR: "Ambiyans ışığı rengi",
  T_37_WZY_WS_AMRORTOOL: "Zırhı tamir et",
  T_37_WZY_WS_ATTACK: "Saldır",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Oyuncunun kılığını iptal et böylece oyuncu normal görünüşüne döner",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "Kılığı iptal edilecek olan oyuncu varlığı",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Futbol topunun hızını arttır",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "Hızı arttırılacak futbol topu",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "Güçlendirmenin hız vektörü",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Futbol Topu Atıcısı topa vurduğunda tetiklenir. [Oyuncu varlığı], Futbol Topu Atıcısı sahibi olan oyuncudur. [Hız artışı], vurulduktan sonra topa eklenen hızıdır.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "Oyuncunun Futbol Topu Atıcısı varsa",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "Vurulduktan sonra futbol topunun hız vektörü",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "Futbol topu bir varlıkla çarpıştığında ve topun hızı arttığında tetiklenir. [Çarpışan varlık], futbol topuyla çarpışan varlıktır. [Hız artışı], çarpışmadan sonra topa eklenen hızdır.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "Varlık futbol topuyla çarpıştığında",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "Çarpışma anında futbol topuna eklenen hız vektörü",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Varlık bir oyuncu tarafından hedef alındığında tetiklenir",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "Varlığı hedef alan oyuncu",
  T_37_WZY_WS_BEHAVIORSTAT: "Oyuncu davranış durumu",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "Bu varlığı vuran silah varlığı",
  T_37_WZY_WS_BLOODBARENT: "Can çubuğu varlığı",
  T_37_WZY_WS_BOMBEND: "Patlamadan önce",
  T_37_WZY_WS_BOMBSTART: "Bomba göstergesi",
  T_37_WZY_WS_CHANENT: "Kanal varlığı",
  T_37_WZY_WS_CHEER: "Tezahürat",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Seçilen bir varlığın belirlenmiş etiketler içerip içermediğini kontrol edin",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "Etiketler içerip içermediğini kontrol edilecek varlık",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "Kontrol edilecek etiket",
  T_37_WZY_WS_CHELABELRES: "Etiket kontrolünün sonucu. Bu bir Boole değeridir.",
  T_37_WZY_WS_CJERSEY_NAME: "Forma değiştir",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "Forması değiştirilecek oyuncu",
  T_37_WZY_WS_CJERSEY_PARAM2: "Forma tasarımı",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "Değiştirilecek tasarım",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "Formadaki 1. bölümün rengi",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "Formanın 2. bölümünün rengi",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "Formanın 3. bölümünün rengi",
  T_37_WZY_WS_CJERSEYTYPE1: "Tasarım 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Tasarım 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Tasarım 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Listedeki bütün elemanları temizle",
  T_37_WZY_WS_CREABLEOB_DESC: "Blok kullanarak oluşturulabilen nesne türü",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Özelleştirilebilir bir ürün oluşturun ve bir ürün varlığını iade edin. Ürün içeriği, özellik ayarları aracılığıyla yapılandırılabilir.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Özelleştirilebilir bir ürün listesi oluşturun ve bir ürün listesi varlığı döndürün. Bu listenin içeriği, özellik ayarlarından değiştirilebilir.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "Oluşturulacak olan ürün listesi varlığı",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Taraf varlığı oluştur",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "Oluşturulacak olan taraf varlığı",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Özelleştirilebilir bir mağaza oluşturun ve bir mağaza varlığı döndürün. Mağazanın içeriği, özellik ayarlarından değiştirilebilir.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "Oluşturulan dükkan varlığı",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Oyunda gökyüzünün ortamını değiştirin. Seçenekler arasında gündüz, alacakaranlık ve gece bulunur.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "Değiştirilecek gökyüzü türü. Seçenekler arasında gündüz, alacakaranlık ve gece bulunur.",
  T_37_WZY_WS_DARKNESS: "Genel karanlık",
  T_37_WZY_WS_DELENT_NAMEDESC: "Belirlenmiş bir varlığı silin. Şu anda simge varlığını, metin varlığını, HUD varlığını, görsel efekt varlığını, silah varlığını ve diğer nesne varlıklarını destekler.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "Silinecek varlık",
  T_37_WZY_WS_DROP: "Hata",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Oyuncu bir eşyayı bıraktığında tetiklenir. [eşya türü] bırakılan eşyanın türüdür.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "Bırakılan eşyanın ID türü",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Oyuncu bir silahı bıraktığında tetiklenir. [silah türü] bırakılan silahın türüdür.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "Bırakılan silah",
  T_37_WZY_WS_DUMMYLEOBJ: "Normal sahne nesnesi",
  T_37_WZY_WS_DUST: "Alacakaranlık",
  T_37_WZY_WS_EMPTYCH: "Varsayılan boş kanal",
  T_37_WZY_WS_EMPTYCH1: "Boş kanal  1",
  T_37_WZY_WS_EMPTYCH2: "Boş kanal 2",
  T_37_WZY_WS_EMPTYCH3: "Boş kanal 3",
  T_37_WZY_WS_EMPTYCH4: "Boş kanal 4",
  T_37_WZY_WS_EMPTYCH5: "Boş kanal 5",
  T_37_WZY_WS_EMPTYCH6: "Boş kanal 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: '3 koşulu karşılayan tüm varlıkları içeren bir liste alın. "Tümünü içerir", "Hariç tutulanlar" ve "İçerir" için eklenen içerik; tek bir bileşen türü veya bileşen türleri listesidir. Döndürülen sonuç, koşulları karşılayan varlıkların bir listesidir.',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "Filtrelenen varlıklar, bu dizideki tüm bileşenleri içermelidir",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "Filtrelenen varlıklar, bu dizideki belirlenmiş bileşenleri içermemelidir",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "Filtrelenen varlıklar, bu diziden en az bir bileşen içermelidir",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "Bu varlığın değiştirilecek olan özellik türü",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "Değiştirilecek özellik değeri",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Oyuncunun mevcut kanalı terk etmesine izin verin, böylece herhangi bir kanalda olmayacaklar.",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "Kanaldan ayrılacak oyuncu",
  T_37_WZY_WS_FAKEENT: "Kılık varlığı",
  T_37_WZY_WS_FIND_STR_DESC: "Bir dize içinde belirlenmiş bir metnin konumunu bulun",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "Bulunacak karakter",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "0'dan başlayan başlangıç konumundan bir dize bulun.",
  T_37_WZY_WS_FINDSTRRES: "Dizenin göründüğü ilk konum. 0'dan başlar.",
  T_37_WZY_WS_FOGCOLOR: "Sis rengi",
  T_37_WZY_WS_FRICTIONCON: "Düzenli sürtünme çarpanı",
  T_37_WZY_WS_FRICTIONIMP: "Çarpışma sürtünme çarpanı",
  T_37_WZY_WS_FROMDEATH: "Diriltme",
  T_37_WZY_WS_FROMKNODOWN: "Yardım et",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Belirlenen oyuncunun bulunduğu kanalı edinin",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "Kanalı elde edilecek olan oyuncu",
  T_37_WZY_WS_GETCHANRES: "Oyuncunun bulunduğu mevcut kanal",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "Kanal ID 1 ila 8 arasında, oyunun başında varsayılan olarak oluşturulan boş kanalı alın",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "Varsayılan boş kanal ID",
  T_37_WZY_WS_GETEMPTYCH_RES: "Edinilen kanal varlığı",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Oyuncunun kılık varlığını edin.",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "Kılık varlığı alınacak olan nesne",
  T_37_WZY_WS_GETGAMEENT_NAME: "Küresel varlık al",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Bu maçın oyun varlığını edin",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Saldırılabilir oyuncu edin",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Taraf varlığı",
  T_37_WZY_WS_GOAL_NAMEDESC: "Bir futbol topu kaleye girdiğinde tetiklenir. [Kale] bu futbol topunun girdiği hedeftir. [Golcü] topa en son temas eden oyuncudur. [Asist] topla temas eden sondan ikinci oyuncudur.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "Bu futbol topunun girdiği kale",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "Topa en son temas eden oyuncu",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "Topa temas eden sondan ikinci oyuncu",
  T_37_WZY_WS_HEARTBEAT: "Kalp ritmi",
  T_37_WZY_WS_HEAVYWEAPON: "Ağır silah",
  T_37_WZY_WS_HIHGSHOOTANGLE: "En küçük atış açısı",
  T_37_WZY_WS_HOSTPLA: "Saldırıya açık oyuncuların listesi",
  T_37_WZY_WS_HOSTSIDE: "Saldırıya açık tarafların listesi",
  T_37_WZY_WS_HOSTTEAM: "Saldırıya açık takımların listesi",
  T_37_WZY_WS_ICON_CLOCK: "Geri sayım",
  T_37_WZY_WS_ICON_CLOTHES: "Kıyafetler",
  T_37_WZY_WS_ICON_QUIT: "Çık",
  T_37_WZY_WS_INSERT_ARR_DESC: "Listede belirlenmiş bir konuma yeni bir öğe ekleyin",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Dizin konumundan başlayarak belirlenmiş uzunlukta bir dize ayıklayın. Çıkarma uzunluğu dize uzunluğunu aşarsa, içeriği dizenin sonuna kadar çıkarır.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Çıkarma uzunluğu",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "Çıkarılan dizi",
  T_37_WZY_WS_INTORINTL: "Tam sayı veya tam sayı listesi",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Bir oyuncunun belirlenmiş bir fraksiyona katılmasına izin ver",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "Oyuncunun katılacağı taraf",
  T_37_WZY_WS_JUMP: "Zıpla",
  T_37_WZY_WS_LABEL: "Etiket",
  T_37_WZY_WS_LENSFLARE: "Mercek ışığı",
  T_37_WZY_WS_LENTH: "Uzunluk",
  T_37_WZY_WS_LIGHTATTACK: "Başarılı vuruş",
  T_37_WZY_WS_LIGHTCOLOR: "Işık kaynak rengi",
  T_37_WZY_WS_LIGHTINTENSITY: "Işık kaynak parlaklığı",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Yeni bir görünüm yükle",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "Yüklenecek manzaranın adı",
  T_37_WZY_WS_MOROBJECT: "Kılık nesnesi",
  T_37_WZY_WS_MOVEAXISX: "x ekseni boyunca ilerle",
  T_37_WZY_WS_MOVEAXISY: "y ekseni boyunca hareket et",
  T_37_WZY_WS_MOVEAXISZ: "Z ekseninde ilerle",
  T_37_WZY_WS_MOVEDISTITLE: "Hareketin uzaklığı",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Hızlı mesajlar açık-kapalı",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Hızlı mesajları açın veya kapatın. Kapalıyken, hızlı mesaj arayüzü kullanılamaz ve oyuncular hızlı mesaj gönderemez veya alamaz.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "Hızlı mesajların kapatılıp açılacağı oyuncu",
  T_37_WZY_WS_MUTEVOICE_NAME: "Sesli sohbeti aç-kapa",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Sesli sohbeti açın veya kapatın. Kapalıyken, sesli HUD kullanılamaz ve oyuncular sesli mesaj gönderemez veya alamaz.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "Sesli sohbetin açılıp/kapatılacağı oyuncu",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Boole. Doğru: kapalı, Yanlış: açık anlamına gelir.",
  T_37_WZY_WS_NIGHTMODE: "Gece modu",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Oyuncu nişan alabilen bir varlığı hedeflediğinde tetiklenir. [Hedef varlık] hedeflenen varlıktır. Hedeflenen bir varlık olmadığında, dönüş değeri boş olur.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Hedef alınan varlık",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "Silahın vurduğu varlık",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Manzara başarıyla yüklendiğinde tetiklenir",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "Yüklenecek manzaranın adı. Bu bir dizidir.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Manzara başarıyla değiştiğinde tetiklenir",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "Yeni manzaranın adı. Bu bir dizidir.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Oyuncunun kıyafetlerini varsayılan görünümüne geri yükleyin",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "Varsayılan kıyafetleri yenilenecek olan oyuncu",
  T_37_WZY_WS_PETSET: "Yoldaş ayarları",
  T_37_WZY_WS_PETSKILL: "Yoldaş yetenekleri",
  T_37_WZY_WS_PETSWITCH2: "Yoldaş becerilerinin kullanılıp kullanılamayacağı",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Oyuncunun hareketinin açılıp açılmayacağı. Boole değeridir.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Oyuncu davranış türü",
  T_37_WZY_WS_PRESS: "Nazik tık",
  T_37_WZY_WS_PROGRESS: "Mevcut İlerleme",
  T_37_WZY_WS_PROGRESSBAR: "İlerleme HUD varlığı",
  T_37_WZY_WS_RANKDOWN: "Seviye düş",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Seçilen varlık için etiketi kaldır",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "Kaldırılacak metin içeriği",
  T_37_WZY_WS_REPLACE_STR_DESC: "Bir dizinin içeriğini belirlenmiş bir içerikle değiştirin",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "Değiştirilecek karakter",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "Değiştirilecek yeni karakter",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Bu listedeki bütün öğeleri geri al",
  T_37_WZY_WS_REVIVEHERE: "Bu canlandırma noktasında arkadaşlarını dirilten oyuncu",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Bir oyuncu bu canlandırma noktasında takım arkadaşlarını canlandırdığında tetiklenir",
  T_37_WZY_WS_REVIVEWAYDESC: "Bir oyuncuyu elenmekten veya yere serilmekten kurtaran veya dirilten yöntem",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Oyuncular için farklı davranışların durumunu yapılandırın. Devre dışı bırakıldığında, HUD üzerindeki ilgili düğmeler kullanılamaz ve manuel ve otomatik hareketlere izin verilmez. Gizlendiğinde, ilgili düğmeler HUD'da görüntülenmez ve otomatik hareketlere izin verilirken manuel hareketlere izin verilmez. Etkinleştirildiğinde, ilgili düğmeler HUD'da görüntülenecek ve manuel ve otomatik hareketlere izin verilecektir.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "Davranış durumu ayarlanacak  olan oyuncu",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "Hareket, saldırı, zıplama ve koşma dahil olmak üzere oyuncunun davranışı",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "Durum, devre dışı, gizli ve etkin içerir. Gizlendiğinde, ilgili düğmeler HUD'da görüntülenmez ve otomatik hareketlere izin verilirken manuel hareketlere izin verilmez. Etkinleştirildiğinde, ilgili düğmeler HUD'da görüntülenecek ve manuel ve otomatik hareketlere izin verilecektir.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "Topun koordinatları",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Futbol topunun ön konfigürasyon hızını koruması gerekip gerekmediği. Bu bir Boole değeridir.",
  T_37_WZY_WS_SETPLAHOST_NAME: "Oyuncu saldırı ayarı",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "[Ayarlayan oyuncu]nun [Hedef oyuncu]ya saldırıp saldıramayacağını yapılandırın. Varsayılan ayar, hedef oyuncunun saldırıya uğrayabilecek bir takım ve tarafa ait olup olmamasına bağlıdır. Bu ayar, takım/taraf ayarından daha yüksek önceliğe sahiptir.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "Düşmanları yapılandırılacak olan oyuncu",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "Düşman olan oyuncu",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Saldırılabilir veya saldırılamaz",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"Evet" saldırıya açık anlamına gelir; "Hayır" saldırıya açık olmadığı anlamına gelir. Varsayılan ayar, hedef oyuncunun saldırıya uğrayabilecek bir takım ve tarada ait olup olmamasına bağlıdır.',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"Evet" saldırılabilir; "Hayır" saldırılamaz demektir',
  T_37_WZY_WS_SHADOWSTRENGTH: "Gölgeler",
  T_37_WZY_WS_SHOOTANGLE: "En dar vuruş açışı",
  T_37_WZY_WS_SKYBOX: "Gökyüzü",
  T_37_WZY_WS_SKYBOXENT: "Gökyüzü varlığı",
  T_37_WZY_WS_SKYBOXTYPE: "Temel gökyüzü türü",
  T_37_WZY_WS_STEPPED: "Tetikleyiciye bas",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Oyuncunun sesli sohbet kanalını değiştir",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "Kanalı değiştirilecek oyuncu",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "Geçilecek kanal",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Belirlenmiş bir manzaraya geç",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "Geçilecek manzaranın adı",
  T_37_WZY_WS_TARGETSTR_DESC: "Hedef dizi",
  T_37_WZY_WS_TEAMASIDE: "Takım ve Taraf",
  T_37_WZY_WS_TELEPORTN_AUTO: "Otomatik",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Işınlanabilir veya ışınlanamaz",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Manuel",
  T_37_WZY_WS_TELEPORTN_NO: "Hayır",
  T_37_WZY_WS_TELEPORTN_TITLE: "Işınlanma metodu",
  T_37_WZY_WS_TELEPORTN_YES: "Evet",
  T_37_WZY_WS_TERRAINWET: "Arazi nemi",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "[Oyuncu varlığı] görünümünü [Manzara nesnesi] görünümüyle değiştirin",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "Görünüşü değiştirilecek olan oyuncu",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "Kılık varlığı alınacak olan oyuncu",
  T_37_WZY_WS_TRANSP: "Saydamlık",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Belirlenmiş bir manzarayı kaldır",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "Kaldırılacak manzaranın adı",
  T_37_WZY_WS_VFX1: "Sembolik",
  T_37_WZY_WS_VFX2: "Dumanlı",
  T_37_WZY_WS_VFX3: "Lanet Patlaması",
  T_37_WZY_WS_VFX5: "Donmuş",
  T_37_WZY_WS_VFX6: "Sahne Işığı",
  T_37_WZY_WS_VFX7: "Yukarı Türbülans",
  T_37_WZY_WS_VFX8: "Atmosfer Patlaması",
  T_37_WZY_WS_VISABLE: "Görünürlük",
  T_37_WZY_WS_WEAOPEN: "Göster veya gösterme",
  T_37_WZY_WS_WEAPONENT: "Silah varlığı",
  T_37_WZY_WS_WEATARGETED: "Nişan yardımı ile hedeflenip hedeflenemeyeceği",
  T_37_XYL_CUSTOMJERSEY: "Forma Makinesi",
  T_37_XYL_CUSTOMJERSEY_DESC: "Hayalindeki formayı tasarlamak için Forma Makinesini kullan",
  T_37_XYL_FOOTGUN: "Futbol Topu Atıcı",
  T_37_XYL_SOCCER: "Futbol",
  "T_37_XYL_SOCCER_ RADIUS": "Etki alanı",
  T_37_XYL_SOCCER_DESC: "Özellikleri değiştirilebilir bir futbol topu",
  T_37_XYL_SOCCER_HIGHT1: "Düzenli açı",
  T_37_XYL_SOCCER_HIGHT2: "Atış Açısı",
  T_37_XYL_SOCCER_RESET: "Golden sonraki sıfırlanma süresi (sn)",
  T_37_XYL_SOCCER_RESIST1: "Sürtünme (Tekme Modu)",
  T_37_XYL_SOCCER_RESIST2: "Sürtünme (Silah Modu)",
  T_37_XYL_SOCCERGOAL: "Gol",
  T_37_XYL_SOCCERGOAL_DESC: "Kale burası. Gol atmak için futbol topunu kaleye at. (Yalnızca Puan Kazanmada geçerlidir.)",
  T_37_XYL_SOCCERITEM: "Eşya Bölgesi",
  T_37_XYL_SOCCERITEM_DESC: "Yerleştirildiğinde seçilen eşyayı üretir",
  T_37_XYL_SPAWN_PEOPLE: "Oyuncu sayısı",
  T_37_XYL_WS_AIRCONDITIONER001: "Klima B",
  T_37_XYL_WS_AMMUCHEST: "Savaş Sandığı A",
  T_37_XYL_WS_BAFFLE001: "Bariyer A",
  T_37_XYL_WS_BARREL001: "Variller",
  T_37_XYL_WS_BARREL001_DES: "Sık görülen tahta variller",
  T_37_XYL_WS_BOARD001: "Reklam Panosu B",
  T_37_XYL_WS_BOOK001: "Kitap Yığını A",
  T_37_XYL_WS_BOOK002: "Kutu Oyunu A",
  T_37_XYL_WS_BOUGAINVILLEA: "Begonvil",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Dekor - Ortamı aydınlatır!",
  T_37_XYL_WS_BOX001: "Kutu Yığını A",
  T_37_XYL_WS_BOX002: "Küçük Kutu",
  T_37_XYL_WS_BUSHCOVER: "Çalı",
  T_37_XYL_WS_BUSHCOVER_DES: "Saklanabileceğin bir çalı",
  T_37_XYL_WS_CABINET001: "Çekmece A",
  T_37_XYL_WS_CHAIR001: "Sandalye A",
  T_37_XYL_WS_COCONUTTREE: "Hindistancevizi Ağacı",
  T_37_XYL_WS_COCONUTTREE_DES: "Dekor - Sahil havası için!",
  T_37_XYL_WS_COMPUTER001: "Bilgisayar A",
  T_37_XYL_WS_DAMAGERATIO: "Hasar Oranı",
  T_37_XYL_WS_FIREEX: "Yangın Söndürücü",
  T_37_XYL_WS_GUIDEPOSE: "Yön İşareti",
  T_37_XYL_WS_HUGEHOUSE001: "3 Katlı Ev B",
  T_37_XYL_WS_HUGEHOUSE002: "2 Katlı Ev B",
  T_37_XYL_WS_JACKSTRAW: "Korkuluk",
  T_37_XYL_WS_LADDER001: "Merdiven A",
  T_37_XYL_WS_OILDRUM: "Benzin Bidonu",
  T_37_XYL_WS_ORNAMENT001: "Vazo A",
  T_37_XYL_WS_PACKBOX: "Yük Konteyneri",
  T_37_XYL_WS_PILLA001: "Beton Direk",
  T_37_XYL_WS_PRESENT: "Hediye Kutusu",
  T_37_XYL_WS_PRESENT_DES: "Tatil hediyeleri içerir",
  T_37_XYL_WS_PUMPKIN: "Kare Balkabağı Feneri",
  T_37_XYL_WS_PUMPKINCUT: "Balkabağı Feneri",
  T_37_XYL_WS_PUMPKINCUT_DES: "Ürkünç bir festival için dekorasyon",
  T_37_XYL_WS_ROADBLOCK001: "Barikat B",
  T_37_XYL_WS_SHELF001: "Kitap Rafı A",
  T_37_XYL_WS_SOFA001: "Koltuk A",
  T_37_XYL_WS_SPAWNTEAM: "Bütün takımlar",
  T_37_XYL_WS_SUPPLYBOX: "Mermi Sandığı",
  T_37_XYL_WS_TABLE001: "Masa A",
  T_37_XYL_WS_TABLE002: "Masa B",
  T_37_XYL_WS_TARGET001: "Hedef",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Portal Bitiş Noktası",
  T_37_XYL_WS_TELEPORTNEW: "Geçit A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "Oyuncuyu geçidin bitiş noktasına ışınlayabilen bir geçit",
  T_37_XYL_WS_TIRES001: "Tekerlek A",
  T_37_XYL_WS_TOOLRACK: "Alet Rafı",
  T_37_XYL_WS_WALL001: "Duvar",
  T_37_XYL_WS_WOOD001: "Kesilmiş Odun",
  T_37_XYL_WS_YELLOWDUCK001: "Şişme Ördek",
  T_37_XYL_WS_YELLOWDUCK001_DES: "Ördek şeklinde şişirilmiş bir yüzme simidi",
  T_37_YM_BOMBSQUAD_DEFUSER: "Etkisizleştirici",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF Beyaz Forma (Alt)",
  T_37_YS_F_B_VN_STREET: "Şanslı Kırmızı (Alt)",
  T_37_YS_F_H_VN_STREET: "Şanslı Kırmızı (Kafa)",
  T_37_YS_F_S_VN_STREET: "Şanslı Kırmızı (Ayakkabı)",
  T_37_YS_F_T_VN_STREET: "Şanslı Kırmızı (Üst)",
  T_37_YS_M_A_CRICKET_BLACK: "Atik Kriketçi (Maske)",
  T_37_YS_M_A_THKOL: "Alevli Sürgün (Maske)",
  T_37_YS_M_B_CRICKET_BLACK: "Atik Kriketçi (Alt)",
  T_37_YS_M_B_SILVERERA: "Korkusuz Tetikçi (Alt)",
  T_37_YS_M_B_THKOL: "Alevli Sürgün (Alt)",
  T_37_YS_M_H_SILVERERA: "Korkusuz Tetikçi (Kafa)",
  T_37_YS_M_H_THKOL: "Alevli Sürgün (Kafa)",
  T_37_YS_M_S_CRICKET_BLACK: "Atik Kriketçi (Ayakkabı)",
  T_37_YS_M_S_SILVERERA: "Korkusuz Tetikçi (Ayakkabı)",
  T_37_YS_M_S_THKOL: "Alevli Sürgün (Ayakkabı)",
  T_37_YS_M_T_CRICKET_BLACK: "Atik Kriketçi (Üst)",
  T_37_YS_M_T_SILVERERA: "Korkusuz Tetikçi (Üst)",
  T_37_YS_M_T_THKOL: "Alevli Sürgün (Üst)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF Beyaz Forma (Üst)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Minimum oyuncu",
  T_38_BQ_SKILL_NAME_DUMMY1: "Dublör",
  T_38_BQ_SKILL_NAME_DUMMY2: "Şekil Bölen",
  T_38_CJ_F_B_STREAMER_MUSIC: "Tekno Gönülçelen (Alt)",
  T_38_CJ_F_H_STREAMER_MUSIC: "Tekno Gönülçelen (Kafa)",
  T_38_CJ_F_S_STREAMER_MUSIC: "Tekno Gönülçelen (Ayakkabı)",
  T_38_CJ_F_T_STREAMER_MUSIC: "Tekno Gönülçelen (Üst)",
  T_38_JH_WS_CM1: "Anlaşılır kurallar",
  T_38_JH_WS_CM2: "Anlaşılmayan kurallar",
  T_38_JH_WS_CM3: "Sık Çıkış Yapan Oyuncular",
  T_38_JL_M79_AMMO_N: "M79 Mermisi",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs'in Mikroçipi",
  T_38_M_WS_VECTOR2: "2B Vektör",
  T_38_R_TACTICS_N: "Ön Ayar",
  T_38_RW_NIW_NIWNAME: "Duvar Üretici",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Çok fazla blok katmanı. Geçerli: {0}. Maks.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "Oluşturduğun öğe sayısı ({0}) sınırı ({1}) aştı.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "Aynı çerçeve ({0}) içinde alınan olay sayısı sınırı ({1}) aştı.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Kare başına dinamik varlık oluşturma sınırına ulaşıldı ({0}); {1} oluşturma denemesi reddedildi.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "Başlatılan listenin uzunluğu ({0}) sınırı ({1}) aştı. Maksimum kapasite listesini otomatik oluşturur",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "Döngü sayısı ({0}) sınırı ({1}) aştı. Döngü kesintiye uğradı",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "Eşyordam kapsamındaki eşzamanlı eşyordamların ({0}) sayısı sınırı ({1}) aştı.",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Öğe listeye eklenemedi. Liste {0} boş.",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Temel aritmetik işlemi yürütürken eşleşmeyen değer türleri. Soldaki değer türü {0} ve sağdaki değer türü {1}dir.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Tekrarlanan geçici değişken tanımı. Değişken adı: {0}.",
  T_38_SP_WS_REVIEW_01: "Kötü Niyetli",
  T_38_SP_WS_REVIEW_02: "Kaba",
  T_38_SP_WS_REVIEW_03: "Aşağılayıcı",
  T_38_SP_WS_REVIEW_04: "Son Derece Kötü Niyetli",
  T_38_SP_WS_REVIEW_05: "Tehditkar",
  T_38_SP_WS_REVIEW_06: "Saygısız",
  T_38_SP_WS_REVIEW_07: "İncelemede",
  T_38_SP_WS_REVIEW_08: "{0}{1} adı kurallara uymuyor. {2}.",
  T_38_SP_WS_REVIEW_09: "Dizi",
  T_38_SP_WS_REVIEW_10: "Mağaza",
  T_38_SP_WS_REVIEW_11: "Değişken",
  T_38_SP_WS_REVIEW_12: "Özellik",
  T_38_SP_WS_REVIEW_13: "Nesne",
  T_38_SP_WS_REVIEW_14: "Tanımlamaya git",
  T_38_SP_WS_REVIEW_15: "Objeleri Yönet bölümüne Git",
  T_38_SP_WS_REVIEW_16: "Yönlendirme yok.",
  T_38_SP_WS_REVIEW_17: "Harita İsmi",
  T_38_SP_WS_REVIEW_18: "Tanım",
  T_38_SP_WS_REVIEW_19: "Kapak Resmi",
  T_38_SP_WS_REVIEW_20: "Metin hassas kelimeler içeriyor.",
  T_38_SP_WS_REVIEW_21: "Kayıt başarısız. İncelenemiyor.",
  T_38_SP_WS_REVIEW_22: "İnceleme bekleme süresinde.",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Sopa - Kargaşa",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kaktüs",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Yoldaş Görünümü: Hayalet Kaktüs",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Yoldaş Görünümü: Neon Kaktüs",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Yoldaş Görünümü : Çöl Düşü Kaktüs",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Yoldaş Görünümü: Partici Arvon",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Yoldaş Görünümü: Havalı Rakunrol",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Gece Ateşi",
  T_38_SY_SICKLE_ES_N: "Tırpan - Pop-Pow",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Kamyonet - Mochi Kamyonu",
  T_38_WT_WS_MUITLEVEL: "Çoklu Seviye",
  T_38_WT_WS_SKILLSET15: "Savaş Heyecanı (A124)",
  T_38_WT_WS_SKILLSET16: "Şok Dalgası Duyuları (Homer)",
  T_38_WT_WS_SKILLSET17: "Duvar Kavgası (Iris)",
  T_38_WT_WS_SKILLSET18: "Asi Acelesi (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Manzarada kullanılabilir veya kullanılamaz",
  T_38_WZY_WS_ACTIVEB: "Mantık yenilemeyi aç veya açma",
  T_38_WZY_WS_ACTIVEVALUE: "Etkinlik durumu",
  T_38_WZY_WS_AIR: "Hava",
  T_38_WZY_WS_ALLOWMOVE: "Hareket edebilir veya edemez",
  T_38_WZY_WS_AMMOAMOUNT: "Mermi miktarı",
  T_38_WZY_WS_AMMONAME: "Mermi Varlığı",
  T_38_WZY_WS_ARMOR_DAMRED: "Hasar azaltma faktörü",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Patlama hasarı azaltma faktörü",
  T_38_WZY_WS_ARMOR_DURABILITY: "Mevcut dayanıklılık",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Maks. dayanıklılık",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Hasar verilebilir veya verilemez",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Yok edilebilir veya edilemez",
  T_38_WZY_WS_ARMOR_LEVEL: "Seviye",
  T_38_WZY_WS_ASSCONZOM: "Zombi haklama asisti.",
  T_38_WZY_WS_BAGNAME: "Çanta Varlığı",
  T_38_WZY_WS_BAGSPACEEX: "Fazladan çanta alanı",
  T_38_WZY_WS_BRIDGING: "Köprü oluşturma bileşeni",
  T_38_WZY_WS_BUBBLE: "Baloncuk",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "[oyuncu varlığının] sırt çantasındaki tüm öğeleri temizle",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Ganimet, atılabilir kalıntısı ve yağma kutuları gibi haritanın etrafındaki istenmeyen öğeleri temizle",
  T_38_WZY_WS_CLEARPRO: "Tek özellik faktörünü temizle",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Bir [oyuncu varlığının] konumunda bir [sahne nesnesi] varlığını klonlayın ve [varlığı gizleyin] döndürün",
  T_38_WZY_WS_COMPONENT: "Bileşen",
  T_38_WZY_WS_COSTAMMO: "Mermi harca",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Bir kamera oluşturun ve özellikleri özellik ayarları aracılığıyla değiştirilebilen bir [kamera varlığı] döndürün",
  T_38_WZY_WS_CYCLES: "Oynatılan",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Bir [varlığın] silindirin menzili içinde olup olmadığını kontrol edin. [Merkez] silindirin merkezidir, [yarıçap] silindirin yüzeyinin yarıçapıdır, [yükseklik] silindirin yüksekliğidir, [Euler açıları] direğin 3D oryantasyonunun açılarıdır.",
  T_38_WZY_WS_CYLINDERJUD_RES: "Dairesel kutup kapsamı kontrolünün sonucu. Bu bir Boole değeridir.",
  T_38_WZY_WS_DAMSUMZOM: "Zombilere verilen hasar",
  T_38_WZY_WS_DARKNESS: "Karanlık",
  T_38_WZY_WS_DIFCOLOR: "Yüzey rengi",
  T_38_WZY_WS_DIFTEXTURE: "Yüzey dokusu",
  T_38_WZY_WS_DRUMMUSIC: "Bileşen türü: bateri",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "Bağlantısı kesilen oyuncu",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "Tekrar bağlanan oyuncu",
  T_38_WZY_WS_EUIANCHOR: "HUD bağlantı türü sıralaması",
  T_38_WZY_WS_FEATHER: "Tüy",
  T_38_WZY_WS_FLAMEAMMO: "Alev Silahı Mermisi",
  T_38_WZY_WS_FLOWER: "Çiçek",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "[varlığı] her zaman [takip edilen varlığı] takip edecek şekilde ayarlayın. [Ofset koordinatları], iki varlık arasındaki mesafedir.",
  T_38_WZY_WS_FOLLOWENT: "Takip edilen varlık",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Şu anda bir [oyuncu varlığı] tarafından kullanılmakta olan kamera varlığını edinin",
  T_38_WZY_WS_GETCURCAMDESC: "Oyuncu tarafından kullanılmakta olan kamera",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Bir [oyuncunun] sahip olduğu [belirtilen öğe türü]ndeki bir öğenin miktarını elde edin",
  T_38_WZY_WS_GETITEMNUM_RES: "Oyuncunun sahip olduğu belirlenen öğenin miktarı",
  T_38_WZY_WS_GETVEC_NAME: "Vektör al",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Bir dizi koordinatın x, y ve z bileşenlerini kullanarak bir vektör elde edin",
  T_38_WZY_WS_GETVECRES: "x, y ve z bileşenlerinden elde edilen vektör",
  T_38_WZY_WS_GHOST: "Hayalet",
  T_38_WZY_WS_GRENADEFROZENNAME: "Donuk Flaş Varlığı",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Donma etki alanı",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Donma süresi",
  T_38_WZY_WS_GRENADENAME: "El Bombası Varlığı",
  T_38_WZY_WS_GRENADEPARAM1: "Min. Hasar",
  T_38_WZY_WS_GRENADEPARAM2: "Maks. Hasar",
  T_38_WZY_WS_GRENADEPARAM4: "Patlama etki alanı",
  T_38_WZY_WS_GRENADEPARAM5: "Fırlatma Hızı",
  T_38_WZY_WS_GRENADEPARAM6: "Patlama gecikmesi",
  T_38_WZY_WS_GRENADEPARAM7: "Kendine zarar verme faktörü",
  T_38_WZY_WS_GRENADEPARAM8: "Takım arkadaşı hasar faktörü",
  T_38_WZY_WS_GRENADEPARAM9: "Araç hasar fakötrü",
  T_38_WZY_WS_GUNFIRE: "Silah sesi",
  T_38_WZY_WS_GUNPRO_PARAM2: "Doldurma Hızı",
  T_38_WZY_WS_GUNPRO_PARAM3: "Vücut atışları DMG oranı",
  T_38_WZY_WS_GUNPRO_PARAM4: "Kafadan vuruş hasar oranı",
  T_38_WZY_WS_GUNPRO_PARAM5: "Uzuv atışları DMG oranı",
  T_38_WZY_WS_GUNPRO_PARAM7: "Ekstra Hasar",
  T_38_WZY_WS_HELMET_NAME: "Kask Varlığı",
  T_38_WZY_WS_ICON1: "Taç",
  T_38_WZY_WS_ICON2: "Düello",
  T_38_WZY_WS_INITPOS: "Başlama konumu",
  T_38_WZY_WS_ISRESET: "Karşılıklı Hareket",
  T_38_WZY_WS_KILLCONZOM: "Haklanan zombi sayısı",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Bir savaş varlığı türü olması gereken seçilen [varlığı] ortadan kaldırın. Yenilmez durumunu yok sayar.",
  T_38_WZY_WS_LABELPARAM: "Metin içeriği parametre listesi",
  T_38_WZY_WS_LEADMUSICA: "Bileşen türü: piyano (soprano)",
  T_38_WZY_WS_LEADMUSICB: "Bileşen türü: piano (alto)",
  T_38_WZY_WS_LEADMUSICC: "Bileşen türü: piyano (bas)",
  T_38_WZY_WS_LINE: "Çizgi",
  T_38_WZY_WS_LIQUID: "Sıvı",
  T_38_WZY_WS_LOCALKEY: "Çevrilen anahtar",
  T_38_WZY_WS_LOCALPOS: "İlgili konum",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Her zaman [hedeflenen varlık]ın karşısında duracak bir [varlık] ayarlayın. [Ofset koordinatları], hedeflenen noktanın koordinatları ile varlığın konumunun farkıdır.",
  T_38_WZY_WS_MAINWEAPONA: "Ana Silah 1",
  T_38_WZY_WS_MAINWEAPONB: "Ana Silah 2",
  T_38_WZY_WS_MOTIONTIME: "Hareket süresi",
  T_38_WZY_WS_MOTIONTYPE: "Hareket metodu",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "Değiştirilen EP",
  T_38_WZY_WS_MUSHROOMNAME: "Mantar Varlığı",
  T_38_WZY_WS_OBFACTION: "Tarafı izle",
  T_38_WZY_WS_OBGLOBAL: "Herkesi izle",
  T_38_WZY_WS_OBSERVER: "İzleyici Seçenekleri",
  T_38_WZY_WS_OBTEAM: "Takımı izle",
  T_38_WZY_WS_OFFSETVEC: "Ofset koordinatları",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Bir oyuncu bu Otomat Makinesinden eşya satın aldığında tetiklenir. [Oyuncu varlığı], satın alma işlemini gerçekleştiren oyuncudur. [Ürün varlığı], satın alınan öğedir.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "[oyuncu varlığı] tarafından kuşanıldığında tetiklenir",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Oyuncu zıplama eylemini tamamladığında tetiklenir",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Oyuncu sürünme pozisyonunu tamamladığında tetiklenir",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Silah yeniden doldurulduğunda tetiklenir",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Oyuncu koşma eylemini tamamladığında tetiklenir",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Oyuncu çömelme eylemini tamamladığında tetiklenir",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Silah bir birimi ortadan kaldırdığında tetiklenir. [Elenen varlık], elenen birimdir.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Silah bir savaş varlığına hasar verdiğinde tetiklenir. [Vuruş hedefi], hasarın verildiği savaş varlığıdır. [Hasar], verilen hasardır.",
  T_38_WZY_WS_OWNER: "Sahip",
  T_38_WZY_WS_PARAMLIST: "Parametre listesi",
  T_38_WZY_WS_PARTICALMAP: "Parçacık Haritalama",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'Bir [oyuncu varlığı] için mevcut ifadeyi duraklatın veya devam ettirin. [Duraklat ya da duraklatma] bir Boole değeridir. "Evet" ara vermek demektir. quot;Hayırquot; devam et demektir.',
  T_38_WZY_WS_PLAENTTRI_DESC: "Tetiğe giren oyuncu tarafından etkinleştirildi",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Tetiği terk eden oyuncu tarafından etkinleştirildi",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "[Oyuncu varlığını] belirlenen [ifadeyi] bir kez oynatmaya ve bittiğinde orijinal konumuna geri dönmeye zorlayın",
  T_38_WZY_WS_PLAYSPEED: "Oynatma hızı yüzdesi",
  T_38_WZY_WS_PREHUD_NAME: "Ön ayar simgesi",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "[oyuncu varlığının] mevcut taraftan ayrılmasına izin ver",
  T_38_WZY_WS_RESETENT: "Her tur bileşenleri sıfırla",
  T_38_WZY_WS_RESUUID: "Kaynak UUID",
  T_38_WZY_WS_RIMCOLOR: "Kenar rengi",
  T_38_WZY_WS_RIMTEXTURE: "Kenar Dokusu",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Bir [varlığın] bir koninin içinde olup olmadığını kontrol edin. [merkez] ve [yarıçap], koninin merkezi ve yarıçapıdır. [Çıkartılan yarıçap], koni içindeki daha küçük sektörün yarıçapıdır. Yükseklik, 3B yapının yüksekliğidir. [açı] koninin merkez açısıdır. [yön açısı], merkezi eksenin yön vektörüdür.",
  T_38_WZY_WS_SECTORJUD_RES: "Yelpaze şeklindeki kapsam kontrolünün sonucu. Bu bir Boole değeridir.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Bir [hedef varlığın] etkinlik durumunu ayarlayın. [Aktivite durumu] bir Boole değeridir ve varlığın kullanılabilirliğini, görünürlüğünü ve çakışabilirliğini etkiler.",
  T_38_WZY_WS_SETROUNDSCORE: "Oyuncunun tur skorunu ayarla",
  T_38_WZY_WS_SHOOTANGMAX: "Maks vuruş açısı",
  T_38_WZY_WS_SHOWMAPINFO: "Aynı taraf için harita bilgisi göster",
  T_38_WZY_WS_SHOWNAMEHUD: "Aynı taraf için arayüz ismini göster",
  T_38_WZY_WS_SOUND1: "İvme",
  T_38_WZY_WS_SOUND10: "Tur Başlangıcı",
  T_38_WZY_WS_SOUND11: "Zombiler",
  T_38_WZY_WS_SOUND12: "Korku",
  T_38_WZY_WS_SOUND13: "Dönüşüm",
  T_38_WZY_WS_SOUND14: "Hızlı Kalp Atışı",
  T_38_WZY_WS_SOUND15: "Orta Hızlı Kalp Atışı",
  T_38_WZY_WS_SOUND16: "Yavaş Kalp Atışı",
  T_38_WZY_WS_SOUND17: "Kaçış Zamanı",
  T_38_WZY_WS_SOUND18: "Tıklama",
  T_38_WZY_WS_SOUND19: "Yetenek Doldurma",
  T_38_WZY_WS_SOUND2: "Kaybolma Bildirimi",
  T_38_WZY_WS_SOUND20: "Oyuna Katıl",
  T_38_WZY_WS_SOUND3: "Görsel Efektler",
  T_38_WZY_WS_SOUND4: "Gece Cıvıltıları",
  T_38_WZY_WS_SOUND5: "Vuruş (Küt)",
  T_38_WZY_WS_SOUND6: "Reaksiyon",
  T_38_WZY_WS_SOUND7: "Sürpriz Keşif",
  T_38_WZY_WS_SOUND8: "Görünme",
  T_38_WZY_WS_SOUNDENT: "Müzik varlığı",
  T_38_WZY_WS_SPAWNPOS: "Eski Başlangıç Noktası",
  T_38_WZY_WS_SPHERENAME: "Temel küre",
  T_38_WZY_WS_SPHERERADIUS: "Küre yarıçapı",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Bir [varlığın] küresel bir kapsam içinde olup olmadığını kontrol edin. [merkez] ve [yarıçap] küresel yapının merkezi ve yarıçapıdır.",
  T_38_WZY_WS_SPHERICALJUD_RES: "Küresel kapsam kontrolünün sonucu. Bu bir Boole değeridir.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Bir [varlığın] bir küpün kapsamı içinde olup olmadığını kontrol edin. [merkez] küpün merkezidir, [uzunluk], [genişlik] ve [yükseklik] küpün uzunluğu, genişliği ve yüksekliğidir ve [Euler açıları] küpün 3B yönlendirme açılarıdır.",
  T_38_WZY_WS_SQUAREJUD_RES: "Kübik kapsam kontrolünün sonucu. Bu bir Boole değeridir.",
  T_38_WZY_WS_STARTGENTIME: "Başlangıç zamanı",
  T_38_WZY_WS_STAYTIME: "Bekleme süresi",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Bir oyuncunun kamerasını [kamera varlığına] değiştirin. [Geçiş modu] animasyonsuz veya aşamalı hareket olabilir. [Geçiş süresi], aşamalı mod sırasında geçiş zamanıdır.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Kamera modunu değiştirin. Animasyon Yok ve Aşamalı Hareket arasında seçim yapabilirsiniz.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'Aşamalı hareket modu sırasında geçiş süresi. "Animasyon yok "seçildiğinde, bu ayar geçersizdir.',
  T_38_WZY_WS_TEXTHUD: "Arayüz metin bileşeni",
  T_38_WZY_WS_TEXTTYPE: "Yazi Tipi Boyutu",
  T_38_WZY_WS_TEXTUREID: "Doku türü",
  T_38_WZY_WS_TRANDIST: "Maks. mesafe",
  T_38_WZY_WS_TWEENERENABLED: "UITweener komut dosyasını aç",
  T_38_WZY_WS_TYPELIST: "Tür listesi",
  T_38_WZY_WS_TYPELISTORLIST: "Tür veya tür listesi",
  T_38_WZY_WS_VEST_NAME: "Yelek Varlığı",
  T_38_WZY_WS_VFX1: "Saklanan Haklaması",
  T_38_WZY_WS_VFX10: "Döngüsel Yanma",
  T_38_WZY_WS_VFX11: "Zehirli Gaz",
  T_38_WZY_WS_VFX13: "Kalp",
  T_38_WZY_WS_VFX15: "Kapı",
  T_38_WZY_WS_VFX2: "Hücum",
  T_38_WZY_WS_VFX3: "Klon Haklama",
  T_38_WZY_WS_VFX4: "Vuruş Geri Bildirimi",
  T_38_WZY_WS_VFX5: "Klon",
  T_38_WZY_WS_VFX6: "Kılık",
  T_38_WZY_WS_VFX7: "Flaş Bombası Kıvılcımları",
  T_38_WZY_WS_VFX8: "Hareket İzi",
  T_38_WZY_WS_VFX9: "Ateş Şarjı",
  T_38_WZY_WS_VFXENT: "VFX Örneği",
  T_38_WZY_WS_VFXTYPEA_NAME: "Özelleştirilebilir haritalandırma VFXi",
  T_38_WZY_WS_VFXTYPEB_NAME: "Özelleştirilemeyen eşleme VFXi",
  T_38_WZY_WS_VISIBILITY: "Görünürlük türü",
  T_38_WZY_WS_VOLUME: "Ses Yüksekliği",
  T_38_WZY_WS_WEAPONGEN: "Silah Üretici",
  T_38_WZY_WS_WHECYCLE: "Tekrar Oynat",
  T_38_XXJ_WS_BLOCKMODE: "Engellenen Mod",
  T_38_XXJ_WS_CUSTOMCAMARA: "Özel Kamera",
  T_38_XXJ_WS_FFCLASSIC: "Klasik FF (Ateş ederken)",
  T_38_XXJ_WS_FOV: "Görüş Alanı",
  T_38_XXJ_WS_FOVDESC: "Görüş alanı, kameranın gözlemlenebilir aralığıdır.",
  T_38_XXJ_WS_FPS: "Birinci Şahıs (Atış)",
  T_38_XXJ_WS_HORIZONTALANGLE: "Yatay Açı",
  T_38_XXJ_WS_INVISICAM: "Yarı Saydam",
  T_38_XXJ_WS_OFFSET: "Ofset",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Ortografik",
  T_38_XXJ_WS_PERSPECTIVE: "Bakış Açısı",
  T_38_XXJ_WS_PROJECTIONMODE: "Projeksiyon Modu",
  T_38_XXJ_WS_STABLE: "Sabit",
  T_38_XXJ_WS_STARTCAMERA: "Varsayılan Kamera",
  T_38_XXJ_WS_STARTCAMERAMODE: "Varsayılan Kamera Modu",
  T_38_XXJ_WS_THIRD: "Takip Kamerası",
  T_38_XXJ_WS_TOPVIEW: "Yüksek Açı",
  T_38_XXJ_WS_TPS: "Üçüncü Şahıs",
  T_38_XXJ_WS_TRANSVERSE: "Yatay Hareket",
  T_38_XXJ_WS_VERTICALANGLE: "Dikey Açı",
  T_38_XXJ_WS_ZOOM: "Yakınlaştır",
  T_38_XYL_WS_AISTARTTIME: "Başlama zamanı (s)",
  T_38_XYL_WS_ARMORDESTROY: "Zırh Hasarı faktörü",
  T_38_XYL_WS_BONFIRE: "Kamp Ateşi",
  T_38_XYL_WS_CANDLE01: "Mum A",
  T_38_XYL_WS_CANNON01: "Mekanik Top",
  T_38_XYL_WS_CLIPAMMOSIZE: "Şarjör Deposu",
  T_38_XYL_WS_DAMAGEDTRUCK: "Hasarlı Kamyon",
  T_38_XYL_WS_DOLL01: "Ürkünç Bebek",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Tuğla Ev A",
  T_38_XYL_WS_FENCE002: "Demir Çit B",
  T_38_XYL_WS_FIREWORK01: "Havai Fişek A",
  T_38_XYL_WS_GENERATOR: "Jeneratör",
  T_38_XYL_WS_GRAVITY: "Yerçekimi İvmesi",
  T_38_XYL_WS_GRAVITYAREA: "Anormal Yerçekimi Alanı",
  T_38_XYL_WS_GRAVITYAREA_DESC: "Oyuncuların yerçekimini değiştirebilecekleri bir alan",
  T_38_XYL_WS_HOLDWEAPON: "Silah Durumu",
  T_38_XYL_WS_INDOORFURNITURE: "İç Mekan Mobilyası",
  T_38_XYL_WS_LIGHTTUBE001: "Tüp Işık A",
  T_38_XYL_WS_LOVEBALLOON01: "Sevgili Balonu A",
  T_38_XYL_WS_LOVELAMP01: "Kalpli Sokak Lambası",
  T_38_XYL_WS_LOVESIGN01: "Aşkı Neon Işıklar",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Yağ Varili Hasar Oranı",
  T_38_XYL_WS_OUTDOORPROPS: "Dış Mekan Eşyaları",
  T_38_XYL_WS_PIPEANDBOX: "Borular ve Konteynerler",
  T_38_XYL_WS_PLANT: "Bitkiler",
  T_38_XYL_WS_ROSE01: "Gül",
  T_38_XYL_WS_ROSEN: "Gül Buketi",
  T_38_XYL_WS_SMALLBUILDING: "Küçük Binalar",
  T_38_XYL_WS_SOFA002: "Koltuk B",
  T_38_XYL_WS_TOWNHOUSE01: "Eski 2 Katlı Ev",
  T_38_XYL_WS_TV001: "Eski TV",
  T_38_ZP_CC_EXCHANGESTATUS: "Durum",
  T_39_BQ_SKILL_NAME_VILLAIN: "Kızıl Harekat",
  T_39_CJ_A_BURN: "Zafer İşareti",
  T_39_HJ_WS_Arrow002: "Ok 2",
  T_39_HJ_WS_LIKERATE2: "{0} dk",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} dk",
  T_39_HJ_WS_SOUND10: "Adım",
  T_39_HJ_WS_SOUND11: "Görev Tamamlandı 1",
  T_39_HJ_WS_SOUND13: "Tehlike Uyarısı 1",
  T_39_HJ_WS_SOUND14: "Tehlike Uyarısı 2",
  T_39_HJ_WS_SOUND15: "Geri Sayım 3",
  T_39_HJ_WS_SOUND16: "İpucu Sesi",
  T_39_HJ_WS_SOUND17: "Karga Sesi",
  T_39_HJ_WS_SOUND18: "Yanlış alana ışınlanma sesi",
  T_39_HJ_WS_SOUND19: "Doğru alana ışınlanma sesi",
  T_39_HJ_WS_SOUND2: "Geri Sayım 1",
  T_39_HJ_WS_SOUND20: "Işınlan",
  T_39_HJ_WS_SOUND21: "Elektrik Şoku",
  T_39_HJ_WS_SOUND23: "Eşya Al",
  T_39_HJ_WS_SOUND24: "Elektro Sevimli Fon Müziği",
  T_39_HJ_WS_SOUND25: "Eğlenceli Oyun Fon Müziği",
  T_39_HJ_WS_SOUND4: "Mekanik Cihaz Ekosu",
  T_39_HJ_WS_SOUND5: "Sivrisinek",
  T_39_HJ_WS_SOUND6: "Ding Ding Ding 1",
  T_39_HJ_WS_SOUND7: "Ding Ding Ding 2",
  T_39_HJ_WS_SOUND8: "Dişli Açık",
  T_39_HJ_WS_SOUND9: "Hücum 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Sınırsız Muhafız Duvar",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Sınırsız Fırlatılabilirler",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Özel Ateş Etme Sesi",
  T_39_HQ_UGC_CUSTOMRES: "Özelleştirilmiş Kaynaklar",
  T_39_M_ACCOUNTID: "Hesap",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Çift tıkladıktan sonra çalıştır",
  T_39_MF_SKILLTAG_4: "Hareket",
  T_39_PD_HuntingGroundSnow_MYNAME: "Bay V",
  T_39_QL_SKILL_OTHO_DES: "Bir düşmanı yere serdikten sonra, yere serilen düşmanın [FFB300]{0}m[-] etrafındaki takım arkadaşlarını işaretle ve hareket hızlarını [FFB300]%{1} [-]yavaşlat. [FFB300]{2} saniye [-]sürer. Düştüğünde, saldıran düşmanı ve onun takım arkadaşlarını işaretler ve yavaşlatır.",
  T_39_QL_SKILL_WOLFRAHH_DES: "Bir düşmanı ortadan yere serdikten sonra sonra, ateş hızını [FFB300]%{0}[-] ve hareket hızını[FFB300] %{1} [-]artıran ancak daha sonra hızla azalan Vurgu moduna gir. [FFB300]{2}[-] saniye sürer. Vurgu modu sırasında, arka arkaya düşmanları yere sermek, geri sayımı sıfırlar ve ateş hızını [FFB300]%{3}[-] ve hareket hızını [FFB300]%{4}[-] artırır.",
  T_39_QL_SKILL_XAYNE_DES1: "Aşırı Mod: [FFB300]{1} [-]saniyeliğine [FFB300]{0}[-] geçici CP al. Bu süre boyunca, CP iyileştirme etkileri [FFB300]%{2}[-] artar. Bekleme Süresi: [FFB300]{3} sn[-].",
  T_39_RW_GM_DEFEAT: "Başarısız",
  T_39_RW_SKILL_DESC_FORD: "Hasar alırken, [FFB300]{0} saniye[-] boyunca [FFB300]{1} CP/s[-] kazan. Aktif bir beceri kullanıldığında bu pasif beceri sıfırlanır. Bekleme süresi: [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "Eşya varlığı",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: '"Öfke Patlaması" Alvaro',
  T_39_SY_CHARACTER_VILLAIN_N: "Orion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana - 1001 Gece",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Yoldaş Görünümü: Yeşil Arvon",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Yoldaş Görünümü: Asil Kaplan",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Yoldaş Görünümü: Akrep Robokurt",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Canavar Kamyon - Yeşil Dev",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk - Çiçek Arabası",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Uyanış: Patlamadan [FFB300]{0} sn[-] önce, el bombası [FFB300]{1}[-] el bombası daha üreterek orijinalinin [FFB300]%{2}[-] hasarına neden olabilir.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Bölünen Saldırı",
  T_39_WT_WS_EMPTYMAP_TAG: "Boş alan",
  T_39_WT_WS_FEMAPMODE: "Mod Başlığı",
  T_39_WT_WS_FEMAPTAG: "Harita Etiketi",
  T_39_WT_WS_MAPPLAYER: "Oyuncu Sayısı",
  T_39_WT_WS_MEDENTERNUM: "Oyun ortasında katılan oyuncu sınırı",
  T_39_WT_WS_MIDENTER: "Oyun ortası katılım",
  T_39_WT_WS_MIDENTERCOUNT: "Oyunun ortasında katılma kotası",
  T_39_WT_WS_MIDENTERTIME1: "Oyun ortasında katılmanın zaman sınırı",
  T_39_WT_WS_MIDENTERTIME2: "Oyun ortasında katılma süresi",
  T_39_WT_WS_MIDENTERTIMETIP: "Harita oyuncu sayısı sınırına ulaşılmadığında, oyuncuların maç başladıktan sonra N saniye içinde katılmasını sağlar. Oyuncular N snden sonra katılamazlar.",
  T_39_WT_WS_MIDENTERTIP: "Etkinleştirildiğinde, oyuncular oyunun ortasında bu haritaya katılabilir",
  T_39_WT_WS_PLAYERCOUNT: "Başlangıçtaki oyuncu sayısı",
  T_39_WT_WS_PLAYERCOUNTTIP: "Maç başladığındaki oyuncu sayısı. Harita sınırına ulaşana kadar daha fazla oyuncu oyunun ortasına katılabilir.",
  T_39_WT_WS_TAG1: "Herkes Tek",
  T_39_WT_WS_TAG10: "Kolay",
  T_39_WT_WS_TAG11: "Orta",
  T_39_WT_WS_TAG12: "Zor",
  T_39_WT_WS_TAG13: "İmkansız",
  T_39_WT_WS_TAG14: "Kaçış",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Özelleştirilmiş Kaynaklar",
  T_39_WT_WS_TAG18: "Bulmaca",
  T_39_WT_WS_TAG19: "Yarış",
  T_39_WT_WS_TAG2: "Silah Kavgası",
  T_39_WT_WS_TAG20: "Müzik",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Macera",
  T_39_WT_WS_TAG23: "Zombi Avı",
  T_39_WT_WS_TAG24: "PVP",
  T_39_WT_WS_TAG25: "Takım Oyunu",
  T_39_WT_WS_TAG26: "Takım Ölüm Oyunu",
  T_39_WT_WS_TAG27: "Taret Savunması",
  T_39_WT_WS_TAG28: "Eğitim",
  T_39_WT_WS_TAG3: "Silah Kralı",
  T_39_WT_WS_TAG4: "Canlanma",
  T_39_WT_WS_TAG5: "Keskin Nişancı",
  T_39_WT_WS_TAG6: "Hayatta Kalma",
  T_39_WT_WS_TAG7: "Tekli",
  T_39_WT_WS_TAG8: "Korku",
  T_39_WT_WS_TAG9: "Eğlence",
  T_39_WT_WS_TAGMAXTIP: "{0} etiket seç",
  T_39_WT_WS_TAGTYPE1: "Oyun Türü",
  T_39_WT_WS_TAGTYPE2: "Harita Türü",
  T_39_WT_WS_TAGTYPE3: "Mod Türü",
  T_39_WT_WS_TAGTYPE4: "Takım Boyutu",
  T_39_WZY_WS_ACCSPEED: "Hızlanma",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "[Varlık] için komut dosyası [Komut Dosyası Adı] ekleyin",
  T_39_WZY_WS_ASC: "Yükselen",
  T_39_WZY_WS_ASCIGZERO: "Yükseleni kullanırken sıfırı yok say",
  T_39_WZY_WS_BALLISTMOVENT: "Balistik Hareket Varlığı",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Eşya [Oyuncu Varlığı] tarafından kullanıldığında olayı tetikler",
  T_39_WZY_WS_BODYSCALE: "Vücut ölçeği",
  T_39_WZY_WS_BRAKETORQUE: "Fren Beygir Gücü",
  T_39_WZY_WS_CAMTRANTYPE: "Kamera geçiş türü",
  T_39_WZY_WS_CARVEHICLE: "4 Tekerlekli",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "[Varlık] içinde belirtilen bir komut dosyasının [Komut Dosyası Adı] olup olmadığını kontrol edin. (Döndürülen değer Boole olmalıdır)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Varlığın belirtilen komutun(Boolean) bir sonucuna sahip olup olmadığını kontrol edin",
  T_39_WZY_WS_COMBINEALL: "Çift Kullanım (Farklı silahlar)",
  T_39_WZY_WS_COMBINESELF: "Çift Kullanım (Aynı silah)",
  T_39_WZY_WS_CONENAME: "Temel Koni",
  T_39_WZY_WS_COORSYS: "Koordinasyon sistemi",
  T_39_WZY_WS_CRASHMAXD: "Maks Çarpışma Hasarı",
  T_39_WZY_WS_CRASHMIND: "Minimum Çarpışma Hasarı",
  T_39_WZY_WS_CRAWLSPEED: "Hareket hızı yüzdesi (Sürünürken)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "[Hedef Varlık] için Balistik Hareket Oluşturun. [Başlangıç Hızı], [İvmelenme] ve [Maks Mesafe] hedef varlık için başlangıç hızı yönünde birikmiş olarak düzenlenebilir ve [Balistik Hareket Varlığı] döndürülebilir.",
  T_39_WZY_WS_CRETWEEN_NAME: "Enterpolasyon Hareketi Oluştur",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "[Varlık] için bir İnterpolasyon Hareketi oluşturun, varlığın [Öznitelikleri] [Başlangıç Değeri]nden [Hedef Değer]e [Zaman] içinde sorunsuz bir şekilde hareket ederek. [Yöntem], [Tek Yön], [PingPong], [Döngü] dahil olmak üzere hareket tarzını temsil eder. [Eğri] hareketin eğrisidir. Hareket oluşturulduktan sonra [İnterpolasyon Hareket Objesi] döndürülür.",
  T_39_WZY_WS_CURVE: "Eğri",
  T_39_WZY_WS_CUSTRESULT: "Özel Maç Sonucu",
  T_39_WZY_WS_CYLINDERNAME: "Temel Sütun",
  T_39_WZY_WS_DEFAULT: "Animasyon yok (Varsayılan)",
  T_39_WZY_WS_DESC: "Alçalan",
  T_39_WZY_WS_DIFFUSEALPHA: "Yüzey Saydamlığı",
  T_39_WZY_WS_DISCONNECT: "Bağlantıyı Kes",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Saniye başı enerji yenileme",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Enerji Harca",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Maks ikinci atlama yüksekliği",
  T_39_WZY_WS_ENABLEJOIN: "Yarı yolda katılmaya izin ver",
  T_39_WZY_WS_ENDPOS: "Bitiş noktası koordinatları",
  T_39_WZY_WS_ENGINETORQUE: "Motor Beygir Gücü",
  T_39_WZY_WS_EXPLODED: "Patlama Hasarı",
  T_39_WZY_WS_FEELDSPEED: "Hareket hızı yüzdesi (Düştüğünde)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Merkez flaş zamanı",
  T_39_WZY_WS_FLASH_CRANGE: "Merkez mesafesi",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Kenar flaş zamanı",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Flaş bombası vuruş efekti",
  T_39_WZY_WS_FLASH_RANGE: "Patlama mesafesi",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Alçalma hızı",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Maks. rakım",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Yatay süzülme hızı",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Dikey süzülme hızı",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Minimum son yükseklik",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Minimum kalkış yüksekliği",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Süper yüksekten sonraki iniş hızı",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Dönüş hızı",
  T_39_WZY_WS_FOLMOVENT: "Konum Takip Hareket Objesi",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "[Oyuncu Varlığının] Beceri Listesini Elde Edin",
  T_39_WZY_WS_HB_BOOSTCD: "Hızlanma bekleme süresi",
  T_39_WZY_WS_HB_BOOSTDURATION: "Hızlanma süresi",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Göktahtasında hızlanma bekleme süresi",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Göktahtasında hızlanma bekleme süresi",
  T_39_WZY_WS_HB_BOOSTSPEED: "Hızlanma hızı",
  T_39_WZY_WS_HB_HOVERBCD: "Göktahtası bekleme süresi",
  T_39_WZY_WS_HB_JUMPCD: "Atlama bekleme süresi",
  T_39_WZY_WS_HB_JUMPH: "Göktahtası atlama yüksekliği",
  T_39_WZY_WS_HEADSCALE: "Kafa ölçeği",
  T_39_WZY_WS_HEADSHOTDESCALE: "Kafadan vuruş hasar azaltması",
  T_39_WZY_WS_INTITALSPEED: "Başlangıç Hızı",
  T_39_WZY_WS_INVENTORYBASE: "Temel eşya türleri",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Saniye başı enerji tüketimi",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Temel yatay hız",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Temel dikey hız",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Saniye başına öne atılma enerji tüketimi",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Yatay hızlanma hızı",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Hızlanma mesafesi",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Saniye başına hızlanma enerji tüketimi",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Dikey hızlanma hızı",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Saniye başına artan enerji maliyeti",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Saldırılabilir",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Kendini tetikleyebilir",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Takım arkadaşları tarafından tetiklenip tetiklenemeyeceği",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Araç tarafından tetiklenebilir",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Süre",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Aktivasyon zamanı",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Tetikleme çapı",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Tetikleme zamanı",
  T_39_WZY_WS_LEAVE: "Çıkış",
  T_39_WZY_WS_LIMBSCALE: "Uzuv ölçeği",
  T_39_WZY_WS_LISTLOCSTR: "Yerelleştirilmiş metin listesi",
  T_39_WZY_WS_LOADRESULT_NAME: "Savaş sonucunu yükle",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "[Rütbe], [Sonuç], [Puan Adı], [Puan Değeri] dahil olmak üzere [Oyuncu] savaş sonucunu yükleyin. Sonuç türü bir tam sayıdır. Galibiyet için 1, yenilgi için 2, Booyah için 3 ve beraberlik için 4.",
  T_39_WZY_WS_LOOKMOVENT: "Bakışları Takip Eden Hareket Objesi",
  T_39_WZY_WS_MAXCOUNT: "Maksimum Sayı",
  T_39_WZY_WS_MAXDISTANCE: "Maks. Uzaklık",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Taretin Alçalma Açısı",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Taretin Açısal Hızı",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Taretin Yükselme Açısı",
  T_39_WZY_WS_MINISENTRY_DAM: "Taret Hasarı",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Hasar Azaltma Oranı",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Ateş Etme Açısı",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Taret Atış Oranı",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Taret Saldırı Sıklığı",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Maks Taret Sayısı",
  T_39_WZY_WS_MINISENTRY_RANGE: "Taret Saldırı Menzili",
  T_39_WZY_WS_MOVEENT: "Hareket Varlığı",
  T_39_WZY_WS_NOCOMBINE: "Çift kullanıma uygun değil",
  T_39_WZY_WS_ONCE: "1 Kez",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Eşya [Oyuncu Varlığı] tarafından bırakıldığında olayı tetikler",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Eşya [Oyuncu Varlığı] tarafından kuşanıldığında olayı tetikler",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Kanca Silahı ateşlendiğinde olayı tetikler",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Mayın aktif olduğunda olayı tetikler",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "[Oyuncu Varlığı] tarafından Mayın tetiklendiğinde olayı tetikler",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Varlık hareketi durduğunda tetiklenir",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Varlık duraklamadan hareket etmeye yeniden başladığında tetiklenir",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Varlık hareket etmeye başladığında tetiklenir",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Eşya [Oyuncu Varlığı] tarafından alındığında olayı tetikler",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Fırlatılabilir hedefi vurduğunda olayı tetikler",
  T_39_WZY_WS_OPENATTACK: "Saldırının etkinleştirilip etkinleştirilmeyeceği",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Hareket Objesi veya Hareket Objesi Listesini Duraklat",
  T_39_WZY_WS_PAUSESOUND_NAME: "Ses efektini durdur",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Ses Varlığını veya Ses Varlığı Listesini Duraklat",
  T_39_WZY_WS_PIANOTYPE: "Müzik Bileşeni Türü",
  T_39_WZY_WS_PINGPONG: "PingPong",
  T_39_WZY_WS_PLAYABLELIST: "Hareket Varlığı Listesi",
  T_39_WZY_WS_PLAYINGSTATUE: "Durum",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Duraklatılan Hareket Objesi veya Hareket Objesi Listesini geri yükleyin. Devam etmeyi veya yeniden başlatmayı seçebilirsiniz.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Ses efektini çal",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Duraklatılan Ses Varlığı veya Ses Varlığı Listesini geri yükleyin. Devam etmeyi veya yeniden başlatmayı seçebilir",
  T_39_WZY_WS_PROCIRCLE_NAME: "İlerleme Çemberi",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "[İlk Koordinatlar]dan [Yön] boyunca bir ışın yayar, [Mesafe] içinde isabet alan ilk varlığı algılar ve [Vurulan Varlıkların Listesi] ile [İsabet edilen Koordinatların Listesi]'ni döndürür",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "[Başlangıç Koordinatları]ndan [Yön] boyunca bir ışın yayar, [Mesafe] içinde isabet alan ilk varlığı algılar ve [Varlık Vuruşu] ve [İsabet Koordinatları] döndürür",
  T_39_WZY_WS_REAHEALHP: "Zırh yenilenme değeri",
  T_39_WZY_WS_REAHEALTIME: "Etki süresi aralığı",
  T_39_WZY_WS_RELATCOORSYS: "Bağıl koordinat sistemi",
  T_39_WZY_WS_REPAIRARM: "Tamir Kiti",
  T_39_WZY_WS_REVERSE: "Tersi",
  T_39_WZY_WS_RIMALPHA: "Kenar Saydamlığı",
  T_39_WZY_WS_SCORENAME: "Skor İsmi",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Hedef Varlığa bir sinyal gönderin, yüklenen parametreler önceden tanımlanmış sinyal parametreleri tarafından tanımlanır. Tanımlama sırasında varlık tipinin seçimi, karşılık gelen sinyal kabul olayını üretecektir.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "[Hedef Varlık] için hareketi takip eden bir pozisyon oluşturun. [Hedef Varlık], [Takip Eden Varlık]ı takip eder. [Kayma Koordinatları], [Hedef Varlık] ve [Takip Eden Varlık] arasındaki koordinat kaymasıdır. [Koordinat Sistemi], Takip Eden Varlığın yönüne bağlı olarak Dünya Koordinat Sistemini ve Bağıl Koordinat Sistemini seçebilir. Hareket oluşturulduktan sonra [Pozisyon Takip Hareket Objesi] döndürülür.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Hedef Varlık] için Bakış Takip Hareketi oluşturun. [Hedef Varlık], [Takip Eden Varlık]'ı takip eder. [Kayma Koordinatları], [Hedef Varlık] ve [Takip Eden Varlık] arasındaki koordinat kaymasıdır. [Koordinat Sistemi], Takip Eden Varlığın yönüne bağlı olarak Dünya Koordinat Sistemini ve Bağıl Koordinat Sistemini seçebilir. [Bakışları izleyen Hareket Objesi], hareket oluşturulduktan sonra döndürülür.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Düşme hasarı yüzdesi",
  T_39_WZY_WS_SHOE_MAXENERGY: "Maks Enerji",
  T_39_WZY_WS_SKILLLIST: "Yetenek Listesi",
  T_39_WZY_WS_SKILLTYPE: "Karakter Yeteneği",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Sis efekti süresi",
  T_39_WZY_WS_SMOOTH: "Kamera değişimi",
  T_39_WZY_WS_SOUNDENTL: "Ses Efekti Varlık Listesi",
  T_39_WZY_WS_SOUNDENTLORSENT: "Ses Efekti Varlığı veya Listesi",
  T_39_WZY_WS_SPRINTSPEED: "Koşma hızı yüzdesi",
  T_39_WZY_WS_SQUATSPEED: "Hareket hızı yüzdesi (Çömelirken)",
  T_39_WZY_WS_STARTCOO: "Başlangıç Koordinatları",
  T_39_WZY_WS_STATE: "Oynama durumu",
  T_39_WZY_WS_TARGETVAL: "Hedef değer",
  T_39_WZY_WS_THROWSPEED: "Kanca fırlatma hızı",
  T_39_WZY_WS_TOWER_PARAM10: "Dönme açısı",
  T_39_WZY_WS_TOWER_PARAM11: "Taret durumu",
  T_39_WZY_WS_TOWER_PARAM12: "Varlık ID",
  T_39_WZY_WS_TOWER_PARAM9: "Hedefe Saldır",
  T_39_WZY_WS_TOWSPEED: "Oyuncu seyahat hızı",
  T_39_WZY_WS_TWEENCURVE_NAME: "Özel Eğri",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "Enterpolasyon Hareketi için Özel Eğri kullanılabilir",
  T_39_WZY_WS_TWEENENT: "Enterpolasyon Hareket Objesi",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Hareket Metotları",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Enterpolasyon Hareketi Yöntemleri",
  T_39_WZY_WS_TWEENSTYLE: "Metot",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "[Varlık] için [Komut Dosyası Adı] komut dosyasını silin",
  T_39_WZY_WS_UPSET_NAMEDESC: "Listelenmiş öğeleri rastgele seç",
  T_39_WZY_WS_VISIBLEONBACK: "Arkada görünür",
  T_39_WZY_WS_WEAPCOMBINET: "Çift Kullanımlı Silah Tipi",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Düşürdüğünde ekstra hasar",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Bir seferde atılan mermi sayısı",
  T_39_WZY_WS_WEAREPLAY: "Hareket tekrar başlatılsın mı?",
  T_39_WZY_WS_WORLDCOORSYS: "Dünya koordinasyon sistemi",
  T_39_XXJ_WS_ADDFRIEND: "Arkadaş ekle",
  T_39_XXJ_WS_ALLOWZ: "Oyuncu x ekseni hareketini etkinleştir",
  T_39_XXJ_WS_BLOCKMODEDESC: "Kamera ile hedef arasında bir nesne olduğunda kameranın hareketi",
  T_39_XXJ_WS_CAMERADISTANCE: "Hedefe olan uzaklık",
  T_39_XXJ_WS_CAMERATYPEDESC: "Birden çok ön ayarlı ve özel kamera türü sağlanır",
  T_39_XXJ_WS_CAMERAUSER: "Kamera kullanıcısı",
  T_39_XXJ_WS_CURENTCAMERA: "Kullanılan kamera",
  T_39_XXJ_WS_DETAILS: "Maç Detayları",
  T_39_XXJ_WS_FFECONOMY: "Ekonomi",
  T_39_XXJ_WS_FOCUSTARGET: "İzlenen nesne",
  T_39_XXJ_WS_FOLLOWTARGET: "Takip edilen hedef",
  T_39_XXJ_WS_GAMERESULT: "Maç Sonucu",
  T_39_XXJ_WS_GAMETITLE1: "Maç 1",
  T_39_XXJ_WS_GAMETITLE2: "Maç 2",
  T_39_XXJ_WS_GIFT: "Hediye",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Kameranın yatay dönüş açısı",
  T_39_XXJ_WS_INVISICAM: "Yarı Saydam",
  T_39_XXJ_WS_INVISICAMDESC: "Kamera ve hedef arasındaki nesne yarı saydam hale gelir",
  T_39_XXJ_WS_LEFTSCORE: "Sol Takım Skoru",
  T_39_XXJ_WS_LIKE: "Beğen",
  T_39_XXJ_WS_LOBBY: "Lobi",
  T_39_XXJ_WS_MAINSCORENAME: "Toplam Skor İsmi",
  T_39_XXJ_WS_MAINSCORENUM: "Toplam Skor Sayısı",
  T_39_XXJ_WS_MAPEVALUATE: "Harita Puanı",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Çoklu Takım Sonucu",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Gözlem noktası ofseti",
  T_39_XXJ_WS_OFFSET2DESC: "Tipik olarak, oyuncunun orijinal konumuna göre kamera odak noktasının kaymasını ifade eder. (Anlamı kamera türüne göre değişir)",
  T_39_XXJ_WS_OFFSETDESC: "Tipik olarak, oynatıcının orijinal konumuna göre kamera konumunun sapmasına atıfta bulunur. (Anlamı kamera türüne göre değişir)",
  T_39_XXJ_WS_ORTHOGONAL: "Ortogonal",
  T_39_XXJ_WS_ORTHOGONALDESC: "Kamera, uzaktaki ve yakındaki hedefleri aynı boyutta gösterir",
  T_39_XXJ_WS_PERSPECTIVE: "Bakış Açısı",
  T_39_XXJ_WS_PERSPECTIVEDESC: "Kamera, hedefi gözlemlemek için perspektif projeksiyonu kullanır",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "İşleme sırasında kameranın görüntü oluşumu",
  T_39_XXJ_WS_RANK1: "Takım Derecesi",
  T_39_XXJ_WS_RANK2: "Oyuncu Derecesi",
  T_39_XXJ_WS_REPORT: "Raporla",
  T_39_XXJ_WS_REVIEW: "Tekrar Oynat",
  T_39_XXJ_WS_RIGHTSCORE: "Sağ Takım Skoru",
  T_39_XXJ_WS_SCORENUM1: "Skor 1",
  T_39_XXJ_WS_SCORENUM2: "Skor 2",
  T_39_XXJ_WS_SCORENUM3: "Skor 3",
  T_39_XXJ_WS_SCORENUM4: "Skor 4",
  T_39_XXJ_WS_SCORENUM5: "Skor 5",
  T_39_XXJ_WS_SCORETITLELIST: "Skor İsim Listesi",
  T_39_XXJ_WS_SHARE: "Paylaş",
  T_39_XXJ_WS_SPECTATORSWITCH: "İzleyici",
  T_39_XXJ_WS_STABLE: "Sabit",
  T_39_XXJ_WS_STABLEDESC: "Kamera ile takip edilen varlık arasında bir nesne varsa kamera sabit kalır",
  T_39_XXJ_WS_TEAMNAME1: "Sol Takım İsmi",
  T_39_XXJ_WS_TEAMNAME2: "Sağ Takım İsmi",
  T_39_XXJ_WS_TEAMRANK: "Takım Derecesi",
  T_39_XXJ_WS_TRANSITIONTIME: "Kamera geçiş süresi",
  T_39_XXJ_WS_TRANSITIONTYPE: "Kamera geçiş türü",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "2 Takımın Sonucu",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Kameranın dikey hareket açısı",
  T_39_XXJ_WS_ZOOM: "Yakınlaştır",
  T_39_XXJ_WS_ZOOMDESC: "Kamera ile izlenen varlık arasında bir nesne varsa kamera yakınlaştırır",
  T_39_XYL_WS_LIGHTINTENSITY: "Işık Yoğunluğu",
  T_39_XYL_WS_LIGHTRANGE: "Işık menzili",
  T_39_XYL_WS_POINTLIGHT: "Nokta Işığı",
  T_39_XYL_WS_WATERZONE: "Özelleştirilmiş su alanı",
  T_40_B_DISABLE_RECONNECT: "Otomatik tekrar bağlanmayı kapat",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Gece Yarısı Forması",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Kutup Soğuğu Forması",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Kızıl Kömür Forması",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Güneşli Gök Forması",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Alevli Forma",
  T_40_DYEING_CLEAR: "Boyama Durumunu Temizle",
  T_40_HJ_WS_EFFECT32: "Ayakkabı",
  T_40_HJ_WS_EFFECT33: "Patlama",
  T_40_HJ_WS_EFFECT34: "Başlangıç Noktası",
  T_40_HJ_WS_EFFECT35: "Lazer",
  T_40_HJ_WS_EFFECT36: "Mermi",
  T_40_HJ_WS_EFFECT37: "Vuruş Efekti",
  T_40_HJ_WS_EFFECT38: "Ateşleme Efekti",
  T_40_HJ_WS_EFFECT43: "Örümcek Ağı",
  T_40_HJ_WS_EFFECT44: "Yeteneği serbest bırakırken",
  T_40_HJ_WS_SOUND69: "Kutu Açarken",
  T_40_HJ_WS_SOUND70: "Seviye Atla",
  T_40_HJ_WS_SOUND71: "Maks Seviye",
  T_40_HJ_WS_SOUND72: "Düğmeye Dokunurken",
  T_40_HJ_WS_SOUND73: "Geri Sayım 1",
  T_40_HJ_WS_SOUND74: "Islık",
  T_40_HJ_WS_SOUND75: "Oyun Bitti",
  T_40_HJ_WS_SOUND76: "İleri",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Kontrol Noktası",
  T_40_HJ_WS_SOUND79: "Geri Sayım 2",
  T_40_HJ_WS_SOUND80: "Maç Başlıyor",
  T_40_HJ_WS_SOUND81: "Birçok Para Alınca",
  T_40_HJ_WS_SOUND82: "Para Alınca",
  T_40_HJ_WS_SOUND83: "Bir Miktar Para Alınca",
  T_40_HJ_WS_SOUND84: "Oyuna Katıldı",
  T_40_HJ_WS_SOUND85: "Klan İkmali Açarken",
  T_40_HJ_WS_SOUND86: "Korna",
  T_40_HJ_WS_SOUND87: "Bir Boss Hakla",
  T_40_HJ_WS_SOUND88: "Savaş Sandığı Açılırken",
  T_40_HJ_WS_SOUND89: "Patlayıcı Boya Yeteneği",
  T_40_HJ_WS_SOUND90: "Mermi Vuruşu",
  T_40_HJ_WS_SOUND91: "Boya Kalkanı Yeteneği",
  T_40_HJ_WS_SOUND92: "Devre Dışı Bırakılan Bir Düğmeye Dokunma",
  T_40_HJ_WS_SOUND93: "Yetenek Yükleme Tamamlandı",
  T_40_HJ_WS_SOUND95: "Lazer Yeteneği",
  T_40_HJ_WS_SOUND96: "Eşya 2 Al",
  T_40_HJ_WS_SOUND97: "Oyun Bitti 2",
  T_40_HJ_WS_SOUND98: "Haklama Bildirimi",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Arka Plan Müziği",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "Maç İçi Ses Efekti",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI Aracı Ses Efekti",
  T_40_JH_WS_MAPTAG1: "Renk Oyunu",
  T_40_JH_WS_MAPTAG10: "Renkli Saklambaç",
  T_40_JH_WS_MAPTAG11: "Yıl Dönümü",
  T_40_JH_WS_MAPTAG12: "Rol Yapma",
  T_40_JH_WS_MAPTAG13: "Simülasyon",
  T_40_JH_WS_MAPTAG14: "Asimetrik",
  T_40_JH_WS_MAPTAG15: "Kaynak Savaşı",
  T_40_JH_WS_MAPTAG16: "Yük Taşıma",
  T_40_JH_WS_MAPTAG17: "Resmi Harita",
  T_40_JH_WS_MAPTAG18: "Mini Oyun",
  T_40_JH_WS_MAPTAG19: "Hız Mücadelesi",
  T_40_JH_WS_MAPTAG2: "Renk Spreyi",
  T_40_JH_WS_MAPTAG20: "Roguelike",
  T_40_JH_WS_MAPTAG3: "Renk Savaşı",
  T_40_JH_WS_MAPTAG4: "Renk Dalaşı",
  T_40_JH_WS_MAPTAG5: "Oyun Alanını Boya",
  T_40_JH_WS_MAPTAG6: "Oyun Alanı Boyama",
  T_40_JH_WS_MAPTAG7: "Renk Partisi",
  T_40_JH_WS_MAPTAG8: "Renk Parkuru",
  T_40_JH_WS_MAPTAG9: '"Örümcek-Evreni"  Parkuru',
  T_40_JH_WS_TAG30: "Ticari",
  T_40_JH_WS_TAG31: "Talan",
  T_40_JH_WS_TAG32: "Mistik Kasaba",
  T_40_JH_WS_TAG33: "Şafak Krizi",
  T_40_JH_WS_TAG34: "Hortlak Ayaklanması",
  T_40_JH_WS_TAG35: "Yumruk Dalaşı",
  T_40_JH_WS_TAG36: "Eski Fabrika Çatı",
  T_40_JH_WS_UGCTOKENNAME: "Üretim Diyarı Jetonu",
  T_40_L_QUICKMESSAGE_MODE2: "Ekip Çarpışması",
  T_40_M_WS_HIS: "ile ilgili",
  T_40_SP_WS_DYEING: "Boya",
  T_40_SP_WS_DYEING_AREA: "Bölge Boyama",
  T_40_SP_WS_DYEING_COLOR: "Renk numarası",
  T_40_SP_WS_DYEING_COUNT: "Boyama Sayısı",
  T_40_SP_WS_DYEING_DIR: "Boyama Yönü",
  T_40_SP_WS_DYEING_DIS: "Boyama Mesafesi",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Sabit Boyama Bölgesi",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Uçak Alanı Boyama",
  T_40_SP_WS_DYEING_POSITION: "Koordinat",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Rastgele Boyama Oranı Azalması",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Rastgele Boyama Oranı",
  T_40_SP_WS_DYEING_RANGE: "Boyama Bölgesi",
  T_40_SP_WS_DYEING_STATE: "Boyama Durumu",
  T_40_SP_WS_FACTIONTIPS_11: "Mor",
  T_40_SP_WS_SHOE_CURENERGY: "Mevcut Enerji",
  T_40_SW_SKILL_Name_Nanoscientist: "Nano Can Kalkanı",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Paytarz Mucizesi",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Uyanmış Alok",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Paytarz Mucizesi",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Paytarz Mucizesi",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Paytarz Mucizesi",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Paytarz Mucizesi",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Yoldaş Görünümü: "Örümcek-Evreni" Aylı',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Yoldaş Görünümü: Yıldırım Arvon",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Yoldaş Görünümü: Lazer Gözlü Pug",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Yoldaş Görünümü: Tatilci Pug",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Yoldaş Görünümü: Kaplan Pug",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Paytarz Mucizesi",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Paytarz Mucizesi",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Paytarz Mucizesi",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Paytarz Mucizesi",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - Paytarz Mucizesi",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Metin İçeriğini Etkinleştir",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Yer Tutucu Metin İçeriği",
  T_40_W_DJMALE_AWAKENING_D: "Uyanış: Aura aktifken, [FFB300]{2}[-] saniye süren müzik notaları her [FFB300]{0}[-] saniyede bir beceri kullanıcısının [FFB300]{1}m[-] arkasına düşecektir. Müzik notasını alan takım arkadaşları, aura ile aynı etkiyi alacak.",
  T_40_W_DJMALE_AWAKENING_N: "Parti Remix",
  T_40_W_NURSE_D: "Tekli iyileştirme etkilerinin(yetenek, Sağlık Kiti, şifa tabancası vb. [FFB300]%{0}[-] kısmını [FFB300]{1}m[-] içindeki takım arkadaşlarına yay.",
  T_40_WH_MP_BOXING_NAME: "Boks Maçı",
  T_40_WH_MP_C_PACK: "Kanunsuz Çanta",
  T_40_WH_MP_EXCH_COIN: "Nakit",
  T_40_WH_MP_EXCH_TEMPCOIN: "Kanunsuz Para",
  T_40_WH_MP_PAYCHECK: "Maaş",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "Takım arkadaşlarına yardım etme hızı[FFB300] % {0} [-]artırıldı. Bekleme Süresi: [FFB300]{3} sn[-]. Yardım edilen takım arkadaşı, [FFB300]{1} sn[-] içinde [FFB300]{2} CP[-] yeniler.",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "[FFB300]{0}m yarıçaplı[-] bir iyileştirme bölgesi oluşturur. İçeride, kullanıcı ve müttefikler [FFB300]{1} CP/s[-] doldurur. Yardım gerektiğinde otomatik olarak tetiklenecektir. Bölge [FFB300]{2} saniye [-]sürer. Takım arkadaşlarına yardım etmenin etkileri diğer becerilerle geliştirilebilir. Bekleme Süresi: [FFB300]{3} sn.[-]",
  T_40_WT_WS_ICONENTITY_PARAM6: "Görüntüleme yöntemi",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Kapsül",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Yükseklik",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Çap",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Küre",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Basitleştirilmiş Arapça",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "Renk",
  T_40_WZY_WS_ICONENTITY_FILLED: "Aşamalı",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Görüntü Kaynakları",
  T_40_WZY_WS_ICONENTITY_NAME: "Simge nesnesi",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Görüntüleme yöntemi",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Basit",
  T_40_WZY_WS_ICONENTITY_SLICED: "9- Parça",
  T_40_WZY_WS_ICONENTITY_TILED: "Döşeme",
  T_40_WZY_WS_NEWMAPTAG: "Yeni Harita Simgesi",
  T_40_WZY_WS_NEWVFX1: "Hale",
  T_40_WZY_WS_NEWVFX10: "Lanet",
  T_40_WZY_WS_NEWVFX11: "Donma Bölgesi",
  T_40_WZY_WS_NEWVFX12: "Soğuk Hava",
  T_40_WZY_WS_NEWVFX13: "Kar Tanesi",
  T_40_WZY_WS_NEWVFX14: "Alev",
  T_40_WZY_WS_NEWVFX15: "Işık Huzmesi",
  T_40_WZY_WS_NEWVFX16: "Zehirli Gaz Yayılımı",
  T_40_WZY_WS_NEWVFX17: "Zehirli Gaz",
  T_40_WZY_WS_NEWVFX18: "Patlayıcı Alev",
  T_40_WZY_WS_NEWVFX19: "Işık Efekti",
  T_40_WZY_WS_NEWVFX2: "Baloncuk",
  T_40_WZY_WS_NEWVFX20: "Yıldız",
  T_40_WZY_WS_NEWVFX3: "Kül",
  T_40_WZY_WS_NEWVFX4: "Taş Sıçraması",
  T_40_WZY_WS_NEWVFX5: "Çizgi",
  T_40_WZY_WS_NEWVFX6: "Titreşim",
  T_40_WZY_WS_NEWVFX7: "Çark",
  T_40_WZY_WS_NEWVFX8: "Yükselen Parçacık",
  T_40_WZY_WS_NEWVFX9: "Duman",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Yazı Tipi Boyutu",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Yazı Tipi Tarzı",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Yazı Tipi",
  T_40_WZY_WS_TEXTENTITY_NAME: "Metin nesnesi",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Etkileşim düğmesi HUD bileşeni",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'Manzarada kullanılıp kullanılamayacağı. Bu salt okunurdur ve "Üst öğenin müsait olup olmamasına"  ve "Etkinlik durumu"na bağlıdır.',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Tüm üst öğelerin aktif olup olmadığı. Bu salt okunurdur ve oyuncular tarafından görülmez.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Üst öğe mevcut veya değil",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Açık durum doğru olduğunda göster, aksi halde kapalı",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'Kendi kendine aktif olup olamayacağı. Dekorda kullanmak için "Dekorda aktif veya değil" seçeneğini kullanmalısınız. Bu salt okunurdur ve bir API kullanılarak yapılandırılır.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Kameranın temizleme maskesinin belirli bir katman tarafından görülüp görülmediği",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Belirli bir yerde jeton üret",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "Oyuncuya verilecek yağmalanabilir öğe",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Oyuncunun mevcut yönü",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Yön",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "AI varlığa saldırıyor",
  T_40_XXJ_WS_AITARGET_DESCKEY: "Saldıran Yapay Zeka",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "Hizalama türü",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Yatay hizalama",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Dikey hizalama",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Saydamlık",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "Kalan mermi sayısı",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Kalan mermi",
  T_40_XXJ_WS_ANCHORMAX: "Maksimum Bağlantı Noktası",
  T_40_XXJ_WS_ANCHORMIN: "Minimum Bağlantı Noktası",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Oyuncunun mevcut konumu",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Konum",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Zırh HUD anahtarı",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "Yapılandırılmış varlık kimliği",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "Öğe Kimliği",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Saldırı hedefi",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Saldırı fırlatılabilirleri",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "Yapay zekanın saldırdığı varlık",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Saldırılan hedef",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "Başlangıç noktalarının mevcut koordinatları",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Mevcut koordinatlar",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "Alt görsel",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Arka plan",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Çanta",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Arka plan saydamlığı",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Arkaplan rengi",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Arka plan rengi",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Arka planın doldurulup doldurulmayacağı",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Arka plan doldurma",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Arka plan ismi",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Arka plan ismi",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Arka plan boyutu deltası",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Arka plan boyutu deltası",
  T_40_XXJ_WS_BLUE: "Mavi",
  T_40_XXJ_WS_BODY_DESCKEY: "Gövde",
  T_40_XXJ_WS_BODY_NAMEKEY: "Gövde",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "İskelet ölçeği",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "Oyuncunun başlangıç noktası",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Başlangıç noktası",
  T_40_XXJ_WS_BOTH: "İkisi de",
  T_40_XXJ_WS_BUTTONNAME: "Düğme bileşen adı",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Kamera",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "İstemci kamerasının baktığı yön",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "Kamera konumu",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "İstemcinin kamera hattını algıla",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Kamera ışını algılama",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Görüntü alanıyla çakışırken sürüklemeyi durdurun",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Sığdırdıktan sonra sürüklemeden çık",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "Hap şeklindeki yarım dairelerin merkezleri arasındaki mesafe. Kürenin yarıçapının iki katından küçük olamaz.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Hücre boyutu",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Alt öğe hücre yüksekliği",
  T_40_XXJ_WS_CELLVALUE: "Belirli bir hücrenin içeriğini okuyun ve bir nesne döndürün",
  T_40_XXJ_WS_CENTER_DESCKEY: "Mini haritanın merkezine karşılık gelen dünya koordinatları. varsayılan olarak 0.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Mini harita merkezi",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "Düğmenin konumunun ofseti",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Pozisyon ofseti",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "Yerel koordinatlara göre kütle merkezi",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Kütle merkezi",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Orta çizginin görüntülenip görüntülenmeyeceği",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Orta çizgiyi göster ya da gösterme",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Orta hat konumu [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Orta hat konumu",
  T_40_XXJ_WS_CHASERANGE: "Takip Aralığı",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "Yapay Zeka tarafından takip edilen varlık",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Takip edilen hedef",
  T_40_XXJ_WS_CHILD_DESCKEY: "Alt öğe varlığı",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Üst öğelerin alt öğeleri",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "Kamera çizgisinin çarptığı nokta",
  T_40_XXJ_WS_CHOOSECARHUD: "Kart HUD varlığını seçin",
  T_40_XXJ_WS_CLAMP_DESCKEY: "Parametre, minimum ve maksimum değerler arasındaki sayısal aralık içindeyse, işlev, parametrenin değerini döndürür; parametre aralıktan büyükse, işlev maksimum değeri döndürür; bağımsız değişken aralıktan küçükse işlev minimum değeri döndürür",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Yalnızca Dönüştür bileşenine sahip varlıkları destekler. Şu anda tüm nesnelerle kısıtlı.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "Tıklama alanı büyüklüğü",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Tıklama boyutu",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Kırpma türü",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Kırpma türü",
  T_40_XXJ_WS_CLONEENT_D: "Orijinal üst öğe korurken seçili varlığı ve niteliklerini klonlayın. Düzey Nesnesi seçilirse, Düzey Nesnesi Oluşturu temel alacaktır.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "Kıyafet listesi",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "Kıyafet ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "Kıyafet ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "Kıyafet ID",
  T_40_XXJ_WS_COL_DESC: "Okunacak sütun.",
  T_40_XXJ_WS_COLNAME_DESC: "Okunacak olan sütunun adı.",
  T_40_XXJ_WS_COLOR_DESCKEY: "Renk",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Değer",
  T_40_XXJ_WS_COLOR1_DESCKEY: "RGBA renk kanalını kullanarak renk katmanları ekleyin. Bir kanal değeri 0 ile 255 arasındadır ve bir Int32de depolanır. Varsayılan olarak Beyaz (255, 255, 255, 255).",
  T_40_XXJ_WS_COLOR2_DESCKEY: "İlerleme çubuğu rengi",
  T_40_XXJ_WS_COLOR3_DESCKEY: "0 ile 255 arasında değişen RGBA renk kanalının türü",
  T_40_XXJ_WS_COLOR4_DESCKEY: "Metin rengi",
  T_40_XXJ_WS_COLOR5_DESCKEY: "HUD rengi",
  T_40_XXJ_WS_COLOR6_DESCKEY: "Işık rengi",
  T_40_XXJ_WS_COLORA_DESCKEY: "A renginin değeri",
  T_40_XXJ_WS_COLORB_DESCKEY: "B renginin değeri",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "İlerleme çubuğu rengi",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Boya varili",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Boya Varili",
  T_40_XXJ_WS_COLORG_DESCKEY: "G renginin değeri",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "RGBA kanalını edinin",
  T_40_XXJ_WS_COLORGUN: "Renkli Püskürtme Tüfeği",
  T_40_XXJ_WS_COLORGUN_01: "Renkli Püskürtme Tüfeği (Kırmızı)",
  T_40_XXJ_WS_COLORGUN_02: "Renkli Püskürtme Tüfeği (Sarı)",
  T_40_XXJ_WS_COLORGUN_03: "Renkli Püskürtme Tüfeği (Mavi)",
  T_40_XXJ_WS_COLORGUN_04: "Renkli Püskürtme Tüfeği (Yeşil)",
  T_40_XXJ_WS_COLORGUN_05: "Renkli Püskürtme Tüfeği (Mor)",
  T_40_XXJ_WS_COLORR_DESCKEY: "R renginin değeri",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Metin rengi",
  T_40_XXJ_WS_COLVALUE: "Sütun İçeriği",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "Genel bir HUD anahtarının HUD varlığı",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "Genel HUD anahtarının HUD öğesi",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Kısıtlama",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Kısıtlama",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "Kısıtlama sayısı",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Kısıtlama sayısı",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Orijinal içerik",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Varsayılan yön",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "Kaydırmanın başlangıç noktası. Varsayılan olarak sol üst köşe.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Haritadaki belirli bir nesne için statik bir piksel oluşturun. Piksel, nesneyle birlikte hareket etmez.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Mini harita simgesi oluştur",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Bir zaman damgası için yerelleştirilmiş bir dize tanımlayın",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Belirlenen özel HUD ve ana bileşende özel bir UI bileşeni oluşturun",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Sürün",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Doğru olduğunda göster, aksi halde kapalı",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Çömel",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "Bu, kameranın cullingMask oluşturma katmanıdır. Görünür katmanın seviyesini kullanarak işleme varlığını filtreleyebilirsiniz.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "Üst ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Üst",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "Yüz Boyası ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "Ayakkabı ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Ayakkabı",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "Kafa ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Kafa",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "Yüz Boyası ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Maske",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "Alt ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Alt",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Yüz Boyası",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "Paket ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Tulum",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "xy yönündeki sürükleme miktarı",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY sürüklemesi",
  T_40_XXJ_WS_DB: "Tablo Değerini Oku",
  T_40_XXJ_WS_DB_DESC: "Veritabanındaki belirli bir tablodaki belirli bir tanımlayıcının karşılık gelen değerini okuyun.",
  T_40_XXJ_WS_DBDELETE_DESC: "Veri tabanındaki belirli bir tablodaki belirli bir tanımlayıcının karşılık gelen değerini silin.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "Veriyi tanımlayan özel bir isim",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Tanımlayıcı",
  T_40_XXJ_WS_DBTABLENAME: "Veri Tabanı Tablo Adı",
  T_40_XXJ_WS_DBTABLENAME_DESC: "Veri tabanındaki tablonun adı",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "Yazılacak değer",
  T_40_XXJ_WS_DBWRITE: "Tablo Değeri Yaz",
  T_40_XXJ_WS_DBWRITE_DESC: "Veri tabanındaki belirli bir tabloya belirli bir tanımlayıcının karşılık gelen değerini yazın.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Savunma fırlatılabilirleri",
  T_40_XXJ_WS_DEFULT: "Varsayılan",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Veritabanındaki belirli bir liderlik tablosunda belirli bir anahtarın karşılık gelen değerini silin.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Veritabanındaki belirli bir liderlik tablosunda belirli bir sıralamaya karşılık gelen değeri silin.",
  T_40_XXJ_WS_DEPTH: "HUD katmanı",
  T_40_XXJ_WS_DEPTH_D: "HUD temel katmanı",
  T_40_XXJ_WS_DICTANDLIST: "Liste ve Sözlük",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "Hedeflenen sözlüğün değeri",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "Yüzey saydamlığı",
  T_40_XXJ_WS_DIR_DESCKEY: "Vektör",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "Hazır ve Canlandırma noktası vb. olarak kullanılabilen bir nokta.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Koordinatlar",
  T_40_XXJ_WS_DISABLEALL: "Hiçbirini Seçme",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Renk devre dışı",
  T_40_XXJ_WS_DISTANT_DESCKEY: "Kamera hattı algılama mesafesi",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Projeksiyon mesafesi",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Çoklu sürükleme yönünü destekler",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Sürükleme efekti",
  T_40_XXJ_WS_DRIVER_DESCKEY: "Aracın sürücüsü",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Sürücü",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Bir değeri düzenle",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Özel efektleri göster",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Özel efektleri göster",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Efekt rengi",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "Özel efekt varlığı, görüntülenecek özel efekti temsil eder.",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "Özel efekt nesnesi",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "İfade HUD değişimi",
  T_40_XXJ_WS_ENABLEALL: "Tümünü seç",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Mantık güncellemesinin açılıp açılmayacağı. Kapalı olduğunda, bu varlık üzerindeki bloklar her kareyi güncellemeyi durduracaktır.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "Silah özelliklerine yazıldığında, silahın temel istatistikleri silah görünümünden etkilenecektir.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Silah görünümü özelliği yaz",
  T_40_XXJ_WS_ENTITY_DESCKEY: "Bir varlık, etkinleştirilmesi için varlıklara eklenmesi gereken tüm bileşenleri tutan bir araçtır.",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Varlık türü",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "Bir varlığın temel bileşeni. Tüm bileşenler bu bileşeni birleştirecektir.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "Dönüşülecek olan varlık",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "Yeni eklenen özel kullanıcı arabirimi denetiminin varlığını temsil etmek için kodda kullanılan parametre adı. Karşılık gelen yerel değişken değeri, yeni eklenen özel UI kontrolünün varlığıdır.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "Varlık değişkeninin adı",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "Oluşturulan simgenin varlığını temsil etmek için kodda kullanılan parametre adı. Karşılık gelen yerel değişken değeri, oluşturulan simgenin varlığıdır.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP çubuğu HUD anahtarı",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Euler açıları",
  T_40_XXJ_WS_FACINFECTION: "Taraf (Droid Kıyameti)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Oyuncunun tarafı. 1= İnsan, 2= Droid.",
  T_40_XXJ_WS_FEMALE: "Kadın",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Doldurma yönü",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Sıralama yönü",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Ateş",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "Floatın değeri",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "Takip edilecek hedef varlık. Varsayılan olarak boş.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "Metin boyutu",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Yazı tipi boyutu",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "Yazı tipi tarzı",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Futbol Muhafız Duvarı",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "Formatlama türü",
  T_40_XXJ_WS_FORWARD_DESCKEY: "Oyuncunu yönü",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "Işınlanacak yön",
  T_40_XXJ_WS_FREE_DESCKEY: "Oyuncu tarafından kontrol edilebilen ve serbestçe hareket ettirilebilen bir kamera",
  T_40_XXJ_WS_FREE_NAMEKEY: "Serbest Kamera",
  T_40_XXJ_WS_GENDER: "Cinsiyet",
  T_40_XXJ_WS_GENDER_DESCKEY: "Cinsiyet",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Cinsiyet sıralaması",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Kameranın temizleme maskesini edinin",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Yalnızca Dönüştür bileşenine sahip varlıkları destekler. Şu anda tüm nesnelerle kısıtlı.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Yalnızca Dönüştür bileşenine sahip varlıkları destekler. Şu anda tüm nesnelerle kısıtlı.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Yalnızca Dönüştür bileşenine sahip varlıkları destekler. Şu anda tüm nesnelerle kısıtlı.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Bir oyuncu kıyafetinin ID al",
  T_40_XXJ_WS_GETPLAYERRANK: "Oyuncu Derecesini Al",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Oyuncu Derecesini Al",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Oyuncu Tur Derecesini Al",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Oyuncuya Özel Tur Derecesini Al",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Oyuncunun jeton verisini ara",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Bir oyuncu silahının ID al",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Rastgele başlangıç noktaları tarafından işgal edilmemiş bir dizi koordinat elde edin",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Bir sahnenin gökyüzü kutusunu elde edin",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Bir sunucunun bölgesini al",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Bir sunucunun zaman damgasını alma",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Oyuncuların üzerinde duramayacağı alanlardan kaçınarak takım arkadaşına yakın bir yer bul",
  T_40_XXJ_WS_GETTEAMRANK: "Takım Derecesini Al",
  T_40_XXJ_WS_GETTEAMRANK_D: "Takım Toplam Derecesini Al",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Takım Tur Derecesi Al",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Takıma Özel Tur Derecesi Al",
  T_40_XXJ_WS_GREEN: "Yeşil",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "3 boyutlu bir şeklin boyutlarının yarısı",
  T_40_XXJ_WS_HEAD_DESCKEY: "Kafa",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Kafa",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "Kalp ritmi etkisi varlığı",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Kalp ritmi etkisi varlığı",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "Yükseklik",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "İpucu düğmesi",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Tüyo düğmesi",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "Hedef konumda görüntülenecek varlık",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Hedeflenen varlık",
  T_40_XXJ_WS_HITPOS_DESCKEY: "Vurulan nokta",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "Yatay görüntüleme türü",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Yatay görüntüleme türü",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "Bir varlığı takip eden varlık",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "Başka bir varlığa bakan varlık",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Sağlık çubuğu HUD anahtarı",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "HUD ekleme varlığı. Bu, oyuncuların editörden değiştirdiği gösterge panelidir.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Boş HUD paneli bileşeni",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "Ait olduğu HUD varlığı",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "HUD ekleme varlığı. Oyuncunun düzenleyiciyi kullanarak düzenlediği HUDdur.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "HUD ızgara bileşeni",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "HUD ekleme varlığı. Oyuncunun düzenleyiciyi kullanarak düzenlediği HUDdur.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "HUD paneli bileşeni",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "HUD ekleme varlığı. Oyuncunun düzenleyiciyi kullanarak düzenlediği HUDdur.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "HUD kaydırma görünümü bileşeni",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "İnsan model ID",
  T_40_XXJ_WS_ICON_DESCKEY: "Simgenin kaynak adı",
  T_40_XXJ_WS_ICON_NAMEKEY: "Simge",
  T_40_XXJ_WS_ICON1_DESCKEY: "Bir simge seç",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "Gösterilecek olan simgeyi temsil eden simge varlığı",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "Kaynak yolu, yerleşik kaynak girişi:yol, özel kaynak çıkışı:yol, varsayılan değer boştur",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Simge adı",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Simge adı",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "Kaynak yolu. Varsayılan olarak boştur.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Tetikleyicileri tarayıp tarayamayacağı",
  T_40_XXJ_WS_INDEX_DESCKEY: "Üst öğenin altındaki öğe dizini",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Başlangıç değeri [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "Tam sayının değeri",
  T_40_XXJ_WS_IS3D: "3B ses efekti",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Her zaman kameraya dönük",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Kalın",
  T_40_XXJ_WS_ISBYORDER_D: "Oyuncuların seviye nesnelerini kronolojik sırayla tetikleyip tetiklemeyeceklerini tespit edin",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Is FirEditor düğmesi",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Kamera hattının varlığa çarpıp çarpmadığı",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Belirli bir katmana görünür olup olmadığı",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "İtalik",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Tarama tarafından işaretlendi",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Tarandı veya taranmadı",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Pin düğmesiyle işaretlenip işaretlenmediği",
  T_40_XXJ_WS_ISTRIGGER: "Is trigger",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Altı Çizili",
  T_40_XXJ_WS_ITEMID_DESCKEY: "Varlığın karşılık gelen eşya ID",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "Eşya ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "Öğe kimliği (mevcut sürümde yalnızca silah kimliği mevcuttur)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "Silahın eşya ID",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "Eşya ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Metropol alanı",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Metropol alanı",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Zıpla",
  T_40_XXJ_WS_KEY_DESCKEY: "Anahtar değeri",
  T_40_XXJ_WS_KEY_NAMEKEY: "Anahtar",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "Geçiş yapılacak anahtarın adı. Yerel bir değişkendeki bir anahtarın değerini elde etmek için bunu kullanabilirsiniz.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Haklama duyurusu",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Metin rengi",
  T_40_XXJ_WS_LANDMINEOBJ: "Kara mayını oluşturulduktan sonra varlık",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "Çarpışan katmanın maskesi. Seçilmeyen katmanlar taramaya dahil edilmeyecektir. Boş olduğunda, tüm katmanlar taramaya dahil edilecektir.",
  T_40_XXJ_WS_LAYERSEDIT: "Katmanları Düzenle",
  T_40_XXJ_WS_LAYERSETTING: "Görünen katman ayarları",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "Kamera hattı algılamasının çarpışma katmanı",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Katman",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Düzen türü",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Düzen türü",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Puan tablosu HUD bileşeni",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "Puan tablosu HUD varlığı. Varlığın özelliklerinin değiştirilmesi, ilgili kullanıcı arayüzünde görüntülenecek içeriği etkileyecektir.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Liderlik Tablosu Adı",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "Veri tabanındaki liderlik tablosu tablosunun adı.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "Sallanırken hızlanma",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Ayrılma hızı",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Sol kol",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Sol kol",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "Sol renk",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Sol renk",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Solda özel efektlerin gösterilip gösterilmeyeceği",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Sol efekti göster ya da gösterme",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Sol ayak",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Sol ayak",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Sol el",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Sol el",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Sol simge",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Sol simge",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Sol bacak",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Sol bacak",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Sol skor metni",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Sol skor metni",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Sol metin",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Sol metin",
  T_40_XXJ_WS_LERP_DESCKEY: 't, 0 ile 1 arasında yer alır. t=0 olduğunda, ".from". değerini döndürün. t=1 olduğunda, ".to".ya dönün. t=0.5 olduğunda, "from" ve "to" nun ortalama değerini döndürür.',
  T_40_XXJ_WS_LEVELOBJECT: "Sahne Nesnesi",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Satır aralığı",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Listedeki değerleri karşılaştır ve büyük olanı döndür",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Bir listedeki değerleri karşılaştır ve en küçük olanı döndür",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "Liste veya Sözlük",
  T_40_XXJ_WS_LOCALPOSITION: "Yerel pozisyon",
  T_40_XXJ_WS_LOCALROTA: "Yerel Euler açıları",
  T_40_XXJ_WS_LOCALROTATIONQ: "Yerel kuaterniyon dönüşü",
  T_40_XXJ_WS_LOCALSACLE: "Yerel ölçek",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Yerelleştirme anahtarı",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "Geçiş yapılacak konteyner",
  T_40_XXJ_WS_MALE: "Erkek",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Sözlüğü sil",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Sözlüğün uzunluğunu elde et",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Sözlük öğesinde belirlenen anahtarın değerini elde edin",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Sözlükte belirtilen anahtar/değer çiftini kaldırın",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Sözlükte belirlenmiş bir anahtarın değerini yapılandırın",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "Mini haritanın boyutu. Genişliği ve yüksekliği eşittir.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Harita boyutu",
  T_40_XXJ_WS_MAPT: "Sözlük şablonu",
  T_40_XXJ_WS_MAPT_D: "Sözlük için veri şablonu. İçerik türünü T1 ve T2 üzerinden belirleyebilirsiniz.",
  T_40_XXJ_WS_MAPVALUE_D: "Sözlük için bir veri veri konteyneri. Öğe, bir anahtar ve bir değerden oluşan bir çifttir.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "Hedef sözlük",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Sözlük",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "Maske tipi, maskeleme sırasında kullanılan görüntü adıdır.",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Maske adı",
  T_40_XXJ_WS_MASS_DESCKEY: "Kütle (kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Kütle (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "2 değeri karşılaştır ve büyük olanı döndür",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Maks. uzunluk",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "Maksimum değer",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "En büyük bileşen ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "Maks. widget kimliği",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "İyileştirme eşyaları",
  T_40_XXJ_WS_MIN_DESCKEY: "2 değeri karşılaştır ve küçük olanı döndür",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Mini harita bileşeni",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Mini harita pikseli",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Mini harita simgesi",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Mini Harita",
  T_40_XXJ_WS_MINNUM_DESCKEY: "Minimum değer",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "Momentum faktörü. Değer ne kadar büyük olursa kaydırma sırasındaki momentum da o kadar büyük olur.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Momentum faktörü",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Hareket kolu",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Maç sonucu",
  T_40_XXJ_WS_NEWENTITY_D: "Oluşturulduktan sonraki yeni öğe varlığı (null olabilir)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Yeni bir sözlük oluştur",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "Yeni Sözlük",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "Vuruş normali",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD konumu [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "HUD konumu",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "İndeksleri sayılara dönüştürmek için liste",
  T_40_XXJ_WS_OBJECT_DESCKEY: "Püskürtme tabancasının çarptığı nesne",
  T_40_XXJ_WS_OBSOLETE: "Silindi, güvenlik nedeniyle lütfen bu bloğu değiştirin.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "Ekran konumu. Takip edilen bir hedef olduğunda, yeni konum ile orijinal konum arasındaki uzaklıktır. İzlenen hedef olmadığında, ekran koordinatlarıdır (varsayılan Vector3(0)dır).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "Ekran koordinatları (varsayılan Vector3(0)dır).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "Ekran konumu. Takip edilen bir hedef olduğunda, yeni konum ile orijinal konum arasındaki uzaklıktır. İzlenen hedef olmadığında, ekran koordinatlarıdır (varsayılan Vector3(0)dır).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Görüntüleme konumu (bağlantı noktası sağ üst köşedir)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Yatay ofset",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Yatay ofset",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "Dikey ofset",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Dikey ofset",
  T_40_XXJ_WS_OK_DESCKEY: "Dönüştürme başarılı",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Varlık saldırı çevresine girdiğinde bu olayı tetikleyin",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Varlık takip çevresine girdiğinde bu olayı tetikleyin",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Varlık yakınlarda saldırı alanında ayrıldığında bu olayı tetikle",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Varlık takip çevresinden ayrıldığında bu olayı tetikleyin",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "İstemci aracılığıyla bir kamera hattı algılamasını tetikleyin",
  T_40_XXJ_WS_ONCOLLISION_D: "Yalnızca Collider bileşeni eklenmiş varlıklar bu olayı destekler",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Püskürtme tabancası bir varlığa çarptığında bu olayı tetikleyin",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "Ateş etme durduğunda",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "Bir oyuncu manzara alanını değiştirdiğinde",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Açık durum doğru olduğunda göster, aksi halde kapalı",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Açık durum",
  T_40_XXJ_WS_ORANGE: "Turuncu",
  T_40_XXJ_WS_ORDER_DESC: "Liderlik tablosundaki derece",
  T_40_XXJ_WS_ORDER1: "Başlangıç Derecesi",
  T_40_XXJ_WS_ORDER2: "Bitiş Derecesi",
  T_40_XXJ_WS_ORIGINAL: "Orijinal mantığı koru",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Taşma yöntemi",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "Öncelik verildiğinde, oyuncunun silahının nitelikleri, silahın orijinal niteliklerinin yerini alacaktır.",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Oyuncu silah görünümüne öncelik ver",
  T_40_XXJ_WS_OWNER_DESCKEY: "Bu varlığa sahip olan oyuncu",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "Ait olduğu alt sahnenin global UIDsi",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "Alt sahne GUID",
  T_40_XXJ_WS_PARENT_DESCKEY: "Üst öğe varlığı",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Üst Öğe",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "Üst öğe bileşen varlığı ID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "Üst bileşenin dosya kimliği",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "Tüm yolcular araçta",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Yolcu",
  T_40_XXJ_WS_PHYSICALLAYER: "Fiziksel Katman",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Fiziksel Katman Matrisi",
  T_40_XXJ_WS_PHYSICALTIP1: "İsim Alınmış",
  T_40_XXJ_WS_PHYSICALTIP2: "Bir katman adını kaldırın ve Fiziksel Katman Matrisi ve Katman Enumda görünmez yapın, ancak bu katmandaki varlık nesneleri etkilenmeyecektir.",
  T_40_XXJ_WS_PHYSICS: "Fizik",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Yağma listesi HUD anahtarı",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "Oynanabilir bir varlık",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "Bir varlık her zaman başka bir varlıkla karşı karşıyadır",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "Bir varlığı takip eden varlık",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "Mermi izi animasyonu, mermi izinin simüle edilmiş bir animasyonudur.",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "Mesajı alacak olan oyuncu",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "Oyuncu tarafından kullanılan avatar",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "Oyuncunun kuşandığı kıyafet",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Oyuncu kıyafeti",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "Oyuncunun HUD türü",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Oyuncu HUD türü",
  T_40_XXJ_WS_PLAYERIDINFAC: "Taraf Seri No.",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "Günlüğe kaydedilecek oyuncu",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Belirli bir oyuncunun jetonunu harca",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "Oyuncunun yetenek listesi",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "Oyuncunun durumu; hayatta, yere serildi veya haklandı.",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Çalma hızı",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Çalma hızı",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "Örneğin, 1.25 orijinalden % 25 daha hızlı anlamına gelir",
  T_40_XXJ_WS_POS_DESCKEY: "Işınlanılacak koordinatlar",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "Özel efekt çıkartması türü",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Basılan renk",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Anahtar/değer çiftini elde etmek için bir kapsayıcının geçişini yürütür. Döngü olan bir alt süreç içerir.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Sözlük döngüsü erişimi",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "İlerleme [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "İlerleme [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "Beceri ilerlemesi için düğme",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Yetenek ilerleme düğmesi",
  T_40_XXJ_WS_QUATERNION: "Kuaterniyon dönüşü",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Hızlı mesaj HUD anahtarı",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Takım listesinin yanındaki mesajlar",
  T_40_XXJ_WS_RADIUS_DESCKEY: "Bir hap şeklinin iki yarım dairesinin yarıçapı",
  T_40_XXJ_WS_READCELL: "Bir Hücreyi Oku",
  T_40_XXJ_WS_READCSV: "Tablo İçeriğini Oku",
  T_40_XXJ_WS_READCSV_DESC: "Tüm tablodaki içeriği oku. İki boyutlu bir dizi döndürür.",
  T_40_XXJ_WS_READCSVCELL: "Satır # ve sütun adına göre oku",
  T_40_XXJ_WS_READCSVCOL_DESC: "Tablodaki belirli bir sütunun içeriğini oku. Bir dizi döndürür.",
  T_40_XXJ_WS_READCSVROW_DESC: "Tablodaki belirli bir satırın içeriğini okuyun. Bir dizi döndürür.",
  T_40_XXJ_WS_READLEADERBOARD: "Liderlik Tablosu Değeri Oku",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Belirli bir tanımlayıcının karşılık gelen değerini, veri tabanındaki bir liderlik tablosunda oku.",
  T_40_XXJ_WS_READLEADERBOARD2: "Derece Aralığına göre Oku",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Belirli bir sıralama ile belirli bir sıralama arasındaki farkın değerini bir veri tabanındaki skor tablosunda oku.",
  T_40_XXJ_WS_RED: "Kırmızı",
  T_40_XXJ_WS_RELOAD: "Yeniden Yükle",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Görüntüleme metodu",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Oyuncunu varsayılan kıyafetini geri yükle",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Oyuncunun varsayılan silah görünümünü geri yükle",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Sürüklemenin görüntü alanıyla sınırlı olup olmadığı. Varsayılan olarak seçilidir.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Sürüklemeyi kısıtla veya kısıtlama",
  T_40_XXJ_WS_RESULT_DESCKEY: "Okunacak sonuç",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Sonuç",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Listedeki en büyük sayının bulunup bulunmadığı",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Listedeki en küçük sayının bulunup bulunmayacağı",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Listedeki en küçük sayıyı bul",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Listedeki en büyük sayıyı bul",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "Bir oyuncunun Canlandırma noktası. Kontrol noktası yoksa, bir başlangıç noktası kullan. Aksi takdirde kontrol noktalarını kullan.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Canlandırma noktası",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Sağ kol",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Sağ kol",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "Sağ renk",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Sağ renk",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Özel efektlerin sağda gösterilip gösterilmeyeceği",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Sağ efekti göster ya da gösterme",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Sağ ayak",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Sağ ayak",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Sağ el",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Sağ el",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Sağ simge",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Sağ simge",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Sağ bacak",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Sağ bacak",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Sağ skor metni",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Sağ skor metni",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Sağ metin",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Sağ metin",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "Sert gövde tipinin bileşeni",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Sert gövde bileşeni",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "Sert gövde tipinin sıralaması",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Sert gövde tipi sıralaması",
  T_40_XXJ_WS_ROW_DECS: "Okunacak satır.",
  T_40_XXJ_WS_ROWVALUE: "Satır İçeriği",
  T_40_XXJ_WS_SCALE_DESCKEY: "Nesnenin yakınlaştırma ölçeğini yapılandırın",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Ölçek",
  T_40_XXJ_WS_SCALE0_DESCKEY: "Dünyadaki koordinat serisinin yakınlaştırma oranı",
  T_40_XXJ_WS_SCALE1_DESCKEY: "Yakınlaştırma oranı. Varsayılan olarak 1.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "Ölçek değeri",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "Bölgenin adı",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Skor çubuğu",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Skor çubuğu",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Çoklu kaydırma yönünü destekler",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Kaydırma yönü",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "Kaydırmanın faktörü. Değer ne kadar büyük olursa kaydırma o kadar hızlı olur.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Kaydırma faktörü",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Kameranın cullingMaskını yapılandırın",
  T_40_XXJ_WS_SETGLOBAL: "Küresel Ayarla",
  T_40_XXJ_WS_SETPARENT_D: "Yalnızca Dönüşüm bileşeni olan varlıkları destekler",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Oyuncunun kıyafet ID yapılandır",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Çoklu oyuncu kıyafetini düzenle",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Oyuncu Yönünü Ayarla",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Bir oyuncunun HUD anahtarını yapılandır",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Oyuncunun silah görünümünü yapılandır",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Varlıkların hedef konumda görüntülenip görüntülenmeyeceği",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Hedefteki varlığı görüntüle",
  T_40_XXJ_WS_SHOWPLAYER: "Varlığı görüntüle",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Tek oyunculu maç ayrıntıları HUD varlığı",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "Tek oyunculu maçlar için bir HUD varlığı. Varlığın özelliklerinin değiştirilmesi, ilgili kullanıcı arayüzünde görüntülenecek içeriği etkileyecektir.",
  T_40_XXJ_WS_SIZEDELTA: "Çapa kutusu ve bileşenin boyut deltası",
  T_40_XXJ_WS_SKELETON: "İskelet",
  T_40_XXJ_WS_SKELETON_D: "İskelet maskesine erişmek için kullanılan pivot",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "İskelet Parçası",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Beceri düğmesi HUD varlığı",
  T_40_XXJ_WS_SLOT_DESCKEY: "Silah yuvası",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "Seçildiğinde, sürüklenirken yavaş bir hareket olacaktır. Seçim kaldırıldığında, sürükleme farenin hızına karşılık gelir.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Akıcı hareket veya değil",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Yumuşaklık",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Yumuşaklık",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Ses varlığı",
  T_40_XXJ_WS_SPACE_DESCKEY: "Boşluk",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Alt öğe hücre boşluğu",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "Yapay zekanın başlangıç noktası koordinatları",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Başlangıç noktası koordinatları",
  T_40_XXJ_WS_SPEED_DESCKEY: "Hız",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Hız",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Koş",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "Kürenin çapı",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "Spreyin rengi",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Sprey rengi",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "Sprey sonucu",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Sprey sonucu",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "Püskürtme tabancası (saldırı tüfeği)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Püskürtme Tüfeği",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Başlangıç Hızı",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Çıkartmayı çevir",
  T_40_XXJ_WS_SPRITEID: "Hareketli varlık kimliği",
  T_40_XXJ_WS_SPRITEID_D: "Figür varlığını tanımlamak için kullanılan kimlik",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Çıkartma türü",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "Statik bir piksele dönüştürülecek hedef varlık",
  T_40_XXJ_WS_STARTPOSITION_D: "Şeklin geometrik merkezinin koordinatları",
  T_40_XXJ_WS_STAY_D: "Alt öğenin mevcut dünya konumu, dönüşü ve ölçeklenmesi korunsun mu? Bu genellikle doğru olarak ayarlanır ve kullanıcı arabirimi ayarları bu seçenek için etkisizdir.",
  T_40_XXJ_WS_STRING_NAMEKEY: "Dizi",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Bir dizeyi bir kayan noktaya dönüştürme",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Bir diziyi bir tam sayıya dönüştürme",
  T_40_XXJ_WS_STYLE_DESCKEY: "Enterpolasyonun oynatma yöntemi. Seçenekler arasında bir kez oynat, tekrar oynat ve tekrar oynat yer alır.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Oyuncunun bölgesini değiştir",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Anahtar değeri",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Oyuncu yuvasına göre silah değiştir",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Eşya yuvasını değiştir",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Eşya anahtarı",
  T_40_XXJ_WS_TABLENAME_DESC: "Tablo adı olarak gösterilir ancak gerçekte UIDdir.",
  T_40_XXJ_WS_TABLEVALUE: "Tablo içeriği",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "Etiket listesi",
  T_40_XXJ_WS_TARGET_DESCKEY: "Harita pikseli oluşturmak için hedef varlık. Varsayılan olarak boş.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Harita pikseli üretecek varlık",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Hedefe saldır",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "Hedef varlık",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Varlık",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "Özelleştirilmiş işlevin bulunduğu varlık",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "Yapay Zeka tarafından saldırılan varlık",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "Takip edilecek varlık",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "Eşya varlığı (boş olabilir)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "Bakılacak olan hedef varlık",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "Durdurulacak olan ses varlığı",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "Durduktan sonra başlayacak olan ses varlığı",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "Silinecek ses varlığı",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Takım arkadaşı bilgisi",
  T_40_XXJ_WS_TELEPORTA_D: "Oyuncuyu belirlenmiş bir yön ile belirlenmiş bir noktaya ışınlayın",
  T_40_XXJ_WS_TEXT_NAMEKEY: "İpucu metni",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Bildirim metin rengi",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "Metin varlığı, görüntülenecek metni temsil eder",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "Görüntülenecek metin anahtarları",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Metin anahtarı",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "Zaman damgası",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "Yerelleştirilmiş bir dizenin görüntü stili",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Zaman damgası görüntüleme tarzı",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "Bir zaman damgası için yerelleştirilmiş dize",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Yerel dize zaman damgası",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "İpucu",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Tüyo",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "Yağmalanabilir eşya miktarı",
  T_40_XXJ_WS_TOKENID_DESCKEY: "Yağmalanabilir eşya ID",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "Bir oyuncunun çekme hızı",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Çeviri türü",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "Enterpolasyon animasyon varlığı",
  T_40_XXJ_WS_TYPE_DESCKEY: 'Açıklamanın türü budur. "türü" türünü döndürür.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "Sert gövde tipi",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Farklı rijit gövde türleri farklı işlevlere sahiptir",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Mevcut sürümde yalnızca temel para birimi desteklenmektedir.",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Mini harita derinlik gösteriminin etkinleştirilip etkinleştirilmeyeceği",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Derinlik haritası kullan",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Yerçekimi yasasına uyup uymadığı",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Yerçekimsel ya da değil",
  T_40_XXJ_WS_UUID_DESCKEY: "Bir oyuncunun benzersiz tanımlayıcısı",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "Değer",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Değer",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Değer [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "İlk değer",
  T_40_XXJ_WS_VALUE2_DESCKEY: "İkinci değer",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Değer [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "Başlangıç değeri",
  T_40_XXJ_WS_VALUEB_DESCKEY: "Hedef değer",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "Geçiş yapılacak değerin adı. Yerel bir değişkendeki değeri elde etmek için bunu kullanabilirsiniz.",
  T_40_XXJ_WS_VALUET_DESCKEY: "Enterpolasyon ilerlemesi. 0 ile 1 arasında yer alır.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Değişken türü",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "Dikey görüntüleme türü",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Dikey görüntüleme türü",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "Nesnenin görülebilirlik seviyesi",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Görünür katman",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Kıyafetler paket, kafa, maske, yüz boyası, üst, alt ve ayakkabıları içerir",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Kıyafet türü",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Kıyafet yuvası",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Silahlar",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "Silah görünümü ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "Silah görünümü ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "Silah görünümü ID",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "Oyuncunun silah görünümü",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Bileşen türü sıralaması",
  T_40_XXJ_WS_WIDTH_DESCKEY: "Genişlik",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Kelime Kaydırma",
  T_40_XXJ_WS_WRITELEADERBOARD: "Skor Tablosu Değerini Yaz",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Belirli bir anahtarın karşılık gelen değerini veri tabanındaki belirli bir liderlik tablosu tablosuna yaz.",
  T_40_XYL_WS_BUMPERFACTORY: "Çarpışan Araba Fabrikası",
  T_40_XYL_WS_BURNDAMAGE: "Yanma Hasarı",
  T_40_XYL_WS_BURNINTERVAL: "Yanma Hasarı Sıklığı (sn)",
  T_40_XYL_WS_BURNTIME: "Patlamadan Sonra Yanma Süresi",
  T_40_XYL_WS_COLORFULSKY: "Renkli Gök",
  T_40_XYL_WS_CRANEMACHINE: "Yakalama Makinesi",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Maksimum Çarpışma Hasarı",
  T_40_XYL_WS_CRASHMAXSPEED: "Maksimum Çarpışma Hasarı Hız Limiti",
  T_40_XYL_WS_CRASHMESS: "Çarpışma Sırasında Kütle Parametresi",
  T_40_XYL_WS_CRASHMINDAMAGE: "Minimum Çarpışma Hasarı",
  T_40_XYL_WS_DISPLAYBOARD: "İlan Panosu",
  T_40_XYL_WS_EXPLODEDAMAGE: "Patlama Hasarı",
  T_40_XYL_WS_EXPLODEDELAY: "Patlama Gecikme Süresi",
  T_40_XYL_WS_EXPLODERANGE: "Patlama Mesafesi",
  T_40_XYL_WS_FERRISWHEEL: "Dönmedolap",
  T_40_XYL_WS_FOODTRUCK002: "Yemek Kamyonu B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Ekipman Değiştirme Süresi (sn)",
  T_40_XYL_WS_ICAROUSEL001: "Atlıkarınca Bileşeni A",
  T_40_XYL_WS_ICAROUSEL002: "Atlıkarınca Bileşeni B",
  T_40_XYL_WS_ICAROUSEL003: "Atlıkarınca",
  T_40_XYL_WS_ICEDANCEDOOL: "Mavi Bebek",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Kontrolsüz Park Beygir Gücü Oranı",
  T_40_XYL_WS_LOLLIPOP: "Dev Lolipop",
  T_40_XYL_WS_NEWHOOKGUN: "Süper Kanca Silahı",
  T_40_XYL_WS_OPENSWING: "Sallanma Düğmesi",
  T_40_XYL_WS_OPENTRACTION: "Çekme tuşu",
  T_40_XYL_WS_PODIUM: "Podyum",
  T_40_XYL_WS_SKYCITY: "Şehir",
  T_40_XYL_WS_SKYSCRAPER_A001: "Gökdelen A Bileşen A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Gökdelen A Bileşen B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Gökdelen A Bileşen C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Gökdelen B Bileşen A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Gökdelen B Bileşen B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Gökdelen B Bileşen C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Gökdelen C Bileşen A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Gökdelen C Bileşen B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Gökdelen C Bileşen C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Gökdelen D Bileşen A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Gökdelen D Bileşen B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Gökdelen D Bileşen C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Gökdelen E Bileşen A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Gökdelen E Bileşen B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Gökdelen E Bileşen C",
  T_40_XYL_WS_STEERANGLE: "Yüksek Hızlı Dönüş Yarıçapı",
  T_40_XYL_WS_STEERSPEED: "Yüksek Hızlı Dönüş Esnasında Maksimum Hız",
  T_40_XYL_WS_SWINGSPEED: "Sallanma Hızı",
  T_40_XYL_WS_TARGETOBJECT: "Hareket Bağlantı Noktası",
  T_40_XYL_WS_TRACTIONSPEED: "Çekme hızı",
  T_40_XYL_WS_TRIGGERCAPSULE: "Özel Kapsül Tetiği",
  T_40_XYL_WS_TRIGGERSPHERE: "Özel Küre Tetikleyici",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Özel Nesne",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "Oluşturma bileşeni ve çarpışma bileşeni ile kullanılabilen boş bir nesne bileşeni.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Özel İşleme Bileşeni",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "Özel model kaynaklarıyla işlemek için kullanılan özel bir işleme bileşeni.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Düşman işaretlerinin ödül değeri vardır. Müttefik ekipte işaretli bir düşmanı ortadan kaldıran herkes, [FFB300]{0} maç içi para birimi[-] kazanacaktır. Bir düşmanı yok ettiğinde fazladan [FFB300]100[-] kazanırsın. BR maçlarında ekstra [FFB300]{1} FF Parası[-] kazanırsın",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Para İzi",
  T_41_CJ_A_ESPORTS_TH: "FFTC Pro (Maske)",
  T_41_CJ_B_ESPORTS_TH: "FFTC Pro (Alt)",
  T_41_CJ_H_ESPORTS_TH: "FFTC Pro (Kafa)",
  T_41_CJ_S_ESPORTS_TH: "FFTC Pro (Ayakkabı)",
  T_41_CJ_T_ESPORTS_TH: "FFTC Pro (Üst)",
  T_41_CJ_T_FFSI: "FFSI Şampiyon Forması",
  T_41_CJ_T_FOOTBALL_EU01: "Güneş Kuşu Forması",
  T_41_CJ_T_FOOTBALL_EU02: "Koyu Kırmızı Forma",
  T_41_CJ_T_FOOTBALL_EU03: "Asil Taç Forması",
  T_41_CJ_T_FOOTBALL_EU04: "Görkemli Titan Forması",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Eşya",
  T_41_R_CD_COIL: "Alan Küçülmesi",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Bu cihazın etkinleştirilip etkinleştirilmeyeceği",
  T_41_SJ_WS_SPECIALITEM_NAME: "Cihaz",
  T_41_SW_SKILL_DESC_DELIVERY: "Düşman tarafından [FFB300]{0}m[-] içerisinden vurulduğu zaman, söz konusu saldırgan [FFB300]{1}s[-] süreyle işaretlenir (bilgi ekip arkadaşlarıyla paylaşılır). Maks. [FFB300]{2} işaret[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Maçın başında [FFB300]{0}ekstra Kalkan Puanı [-] al. Savaştan çıktığında Kalkan Puanları yenilenir.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "Aktif bir yetenek kullanırken, kendine ve [FFB300]{0}m[-] içindeki takım arkadaşlarına [FFB300]{1} Kalkan Puanı [-]verir. Kalkan Puanları, [FFB300]{2}s[-] sonra azalır ve ardından oyuncular, etkileri tekrar elde edebilir. Bekleme Süresi: [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Yerleştirilen Muhafız Duvarlar, darbe aldıklarında saniyede [FFB300]{0}[-] dayanıklılık yeniler; bu sırada, [FFB300]{1}m[-] mesafe içindeki takım arkadaşları [FFB300]{2} CP/s[-] yeniler. Her Muhafız Duvardan takım arkadaşı başına maks. [FFB300]{3} CP[-].",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Yoldaş Görünümü: Akılda Kalan Kaktüs",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Yoldaş Görünümü: Mürekkep Şaho",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Tür",
  T_41_WT_SKILL_DESC_FIREBOY: "[FFB300]{1}m[-] genişliğinde bir alev perde yerleştirir ve bu perde [FFB300]{0}sn[-] süre boyunca ileri doğru [FFB300]{2}m/sn[-] hızında hareket eder, en fazla [FFB300]{3}sn[-] sürer. Etkin olduğu süre içinde yeteneği tekrar kullanarak perdeyi durdurabilirsin. [FFB300]Dokunduğu düşmanlar (veya Muhafız Duvarlar)[-] anında [FFB300]{4} (veya {5}) hasar[-] alır ve ardından saniye başına [FFB300]{6} (veya {7})hasar[-] alır. [FFB300]{8}sn[-] süre devam eder. Bekleme süresi: [FFB300]{9}sn[-]. En fazla [FFB300]{10}[-] yetenek kullanımı depolanabilir ve her kullanım arasında [FFB300]{11} saniyelik[-] bir bekleme süresi vardır.",
  T_41_WT_SKILL_NAME_FIREBOY: "Alevden Serap",
  T_41_WZY_WS_CHARGEMAX: "Maks. Duvar Üretici Şarjı",
  T_41_WZY_WS_CROSSBOWNAME: "Arbalet",
  T_41_WZY_WS_DECELERATIONRATIO: "Sudaki yavaşlama yüzdesi",
  T_41_WZY_WS_DEICEWALLPARAM1: "Erime alanı çapı",
  T_41_WZY_WS_DEICEWALLPARAM2: "Erime süresi",
  T_41_WZY_WS_EXPPERCHIP: "Duvar Çipi için EXP",
  T_41_WZY_WS_EXPPERDAMAGE: "Verilen HSR için EXP",
  T_41_WZY_WS_EXPPERMOVEMILE: "Gidilen her metre için EXP",
  T_41_WZY_WS_EXPPERSECOND: "Saniye başına EXP",
  T_41_WZY_WS_GRENADEEXPTIME: "Patlama gecikmesi",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Patlayıcılar",
  T_41_WZY_WS_GRENADEMAX: "Maksimum HSR",
  T_41_WZY_WS_GRENADEMIN: "Minimum HSR",
  T_41_WZY_WS_GRENADERANGE: "Patlama mesafesi",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "Araç hasar faktörü",
  T_41_WZY_WS_GRENADERATIOSELF: "Kendine zarar verme faktörü",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "Takım arkadaşı hasar faktörü",
  T_41_WZY_WS_GRENADTHROWSPEED: "Patlayıcı hızı",
  T_41_WZY_WS_HANDCANNONNAME: "El Topu",
  T_41_XXJ_WS_ACCELERATION: "Hızlanma",
  T_41_XXJ_WS_ACCELERATION_D: "Belirlenmiş bir hızlandırma efekti oluştur",
  T_41_XXJ_WS_ACTION: "Eylem düğümü",
  T_41_XXJ_WS_ACTION_D: "Eylem Pivotu",
  T_41_XXJ_WS_ADDHP: "İyileşme eşyaları",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Maks. CP ekle",
  T_41_XXJ_WS_AICASTSKILL_D: "AI yetenek kullanma",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Nişan yardımı merkez ofseti",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Nişan yardımı mesafesi",
  T_41_XXJ_WS_AIMASSISTENTITY: "Nişan yardımı varlığı",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Nişan yardımı alabilen varlık",
  T_41_XXJ_WS_AISKILLTYPE: "Zombi yetenek türü",
  T_41_XXJ_WS_AISKILLTYPE_D: "Zombi yeteneği türü",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "Tüm eşyalar",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "Tüm eşyalar",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Şarjör boyutunu düzenle",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Şarjördeki mermiler",
  T_41_XXJ_WS_ANCHORPOSITION_D: "Ana öğeye göre bağlantı koordinatları",
  T_41_XXJ_WS_ANGLE_D: "z ekseni dönüş açısı",
  T_41_XXJ_WS_ANGULARDRAG: "Açısal sürükleme",
  T_41_XXJ_WS_ANGULARVELOCITY: "Açısal ivme",
  T_41_XXJ_WS_ANIMATIONCLIP: "Animasyon durumu",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Animasyon Kumandası",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Animasyon varlığı",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "Animasyon kumandasını yönetmek için kullanılan dosya ve kaynak",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "Animasyon kumanda kaynağı UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Döngü türü sıralaması",
  T_41_XXJ_WS_ANIMATIONSTATE: "Animasyon durumu",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Her tür değer atamasının desteklendiği işlem ve dijital türler ayrıca kendi kendine artırmayı, kendi kendine çıkarma, kendi kendine çarpma ve kendi kendine bölmeyi destekler",
  T_41_XXJ_WS_ATTACHMENT: "Ek",
  T_41_XXJ_WS_ATTACHMENT_D: "Ek",
  T_41_XXJ_WS_ATTACHTARGET: "Bağlantılı varlık",
  T_41_XXJ_WS_BAG: "Çanta",
  T_41_XXJ_WS_BAG_D: "Çanta Bileşeni",
  T_41_XXJ_WS_BANNERID: "Sancak ID",
  T_41_XXJ_WS_BANNERID_D: "Sancak ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "Davranış ağacı",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Davranış Ağacı",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Davranışa monte edilebilir ağaç varlığı",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "Bağlanabilecek bir davranış ağacı varlığı",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Davranış ağacı özel düğümü",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Davranış Ağacı Özel Pivot",
  T_41_XXJ_WS_BODY: "Vücut",
  T_41_XXJ_WS_BORDERLR: "Kenarlık (sol ve sağ)",
  T_41_XXJ_WS_BORDERLR_D: "Sol ve sağ kenarlık",
  T_41_XXJ_WS_BORDERTB: "Kenarlık (üst ve alt)",
  T_41_XXJ_WS_BORDERTB_D: "Üst ve alt kenarlık",
  T_41_XXJ_WS_BRPEAKRANK: "En yüksek BR derecesi",
  T_41_XXJ_WS_BRPEAKRANK_D: "En yüksek BR derecesi",
  T_41_XXJ_WS_BRRANK: "BR derecesi",
  T_41_XXJ_WS_BRRANK_D: "BR Derecesi",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Davranış ağacı düğümü türü",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Davranış Ağacı Pivot Türü",
  T_41_XXJ_WS_BTREE: "Davranış ağacı",
  T_41_XXJ_WS_BTREENODESTATE: "Davranış ağacı düğümü durumu",
  T_41_XXJ_WS_BTREENODESTATE_D: "Davranış Ağacı Pivot Çalışma Durumu",
  T_41_XXJ_WS_BUFFABLEENTITY: "Güçlendirilebilir varlık",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Güçlendirme eklemeyi, güçlendirme kaldırmayı ve güçlendirme listeleri eklemeyi sağlar",
  T_41_XXJ_WS_BUILDINGICEWALL: "Muhafız Duvar",
  T_41_XXJ_WS_CAMOUFLAGE: "İşlevsel eşyalar",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Gök Tahtası, Kamuflaj...",
  T_41_XXJ_WS_CAPICITY_D: "Başlangıç Kapasitesi",
  T_41_XXJ_WS_CENTERINVISIBLE: "Ortada görünmez",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Merkeze görünmez",
  T_41_XXJ_WS_COLOR: "Renk",
  T_41_XXJ_WS_COLOR_D: "Renk",
  T_41_XXJ_WS_CONDITION: "Koşul düğümü",
  T_41_XXJ_WS_CONDITION_D: "Koşullar özel bir Boole tipidir",
  T_41_XXJ_WS_CONDITION1_D: "Durum Pivotu",
  T_41_XXJ_WS_CONSTRAIN: "RigidBody kısıtlaması",
  T_41_XXJ_WS_CONSTRAIN_D: "RigidBody'ye kısıtlamalar ekleyin. Bu, RigidBody kısıtlama türünün bir derlemesidir.",
  T_41_XXJ_WS_COUNT_D: "Miktar",
  T_41_XXJ_WS_CROSSBOW_D: "Arbalet",
  T_41_XXJ_WS_CSPEAKRANK: "En Yüksek EÇ Derecesi",
  T_41_XXJ_WS_CSPEAKRANK_D: "En yüksek EÇ derecesi",
  T_41_XXJ_WS_CSRANK: "EÇ derecesi",
  T_41_XXJ_WS_CSRANK_D: "EÇ Derecesi",
  T_41_XXJ_WS_CSVNAME_D: "SceneData altındaki moda karşılık gelen csv dosyası. .csv ile biter. Başlıklar küçük harflerle yazılır.",
  T_41_XXJ_WS_CURCAPACITY: "Kullanılan kapasite",
  T_41_XXJ_WS_CURPROGRESS: "Mevcut ilerleme",
  T_41_XXJ_WS_CURRENTCLIP: "Geçerli klip",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Geçerli klip ilerlemesi",
  T_41_XXJ_WS_CURRENTSTATE: "Mevcut durum",
  T_41_XXJ_WS_CUSTOMHUDID: "Özel Arayüz ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "Özel bir HUD varlığını tanımlamak için kullanılan kimlik",
  T_41_XXJ_WS_DASHATTACK: "Hızlı saldırı",
  T_41_XXJ_WS_DEBUG: "Hata ayıklamayı başlat",
  T_41_XXJ_WS_DEBUG_D: "Düzelt",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "Yavaşlama % : Bir nesnenin sudaki yavaşlaması (aralık geçici olarak 0-100 olarak ayarlanır)",
  T_41_XXJ_WS_DEPTH_D: "Derinlik",
  T_41_XXJ_WS_DRAG: "Sürükleme katsayısı",
  T_41_XXJ_WS_DRAG_D: "Katsayı ne kadar büyük olursa, hareket hızı yavaşlaması o kadar hızlı olur",
  T_41_XXJ_WS_DUMMY: "Kukla",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Düşük grafik modunu etkinleştir",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "Düşük fps açıkken oyun 15 fps seviyesinde çalışır; yoksa 30 fps kullanılır",
  T_41_XXJ_WS_ENTITYLIST: "Oluşturulan döndürme varlığı listesi",
  T_41_XXJ_WS_ENTITYNAME: "Nesne ismi",
  T_41_XXJ_WS_ENTITYNAME_D: "Oyuncu tarafından özelleştirilen eşya adı",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "Mantıksal Varlık veya Prefabrik Kimliği",
  T_41_XXJ_WS_EQUIPANDBAG: "Zırh ve Çanta",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Ekipman yuvası sıralaması",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Ekipman Yuvası Sıralaması",
  T_41_XXJ_WS_EXPLODE: "Kendini patlatma",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Patlayıcı Silah",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Oto doldurma hızı",
  T_41_XXJ_WS_FILEID: "Dahili Kimlik",
  T_41_XXJ_WS_FILEID_D: "Prefabrikte kontrolün dahili kimliği",
  T_41_XXJ_WS_FILLAMOUNT: "Doldurma miktarı",
  T_41_XXJ_WS_FILLAMOUNT_D: "Doldurma değeri",
  T_41_XXJ_WS_FILLDIR: "Doldurma yönü",
  T_41_XXJ_WS_FILLDIR_D: "Dolgu yönü",
  T_41_XXJ_WS_FILLDIR_D1: "Doldurma yönü sıralaması",
  T_41_XXJ_WS_FILLTYPE: "Doldurma türü",
  T_41_XXJ_WS_FILLTYPE_D: "Dolgu türü",
  T_41_XXJ_WS_FILLTYPE_D1: "Dolgu türü sıralaması",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Yol bul",
  T_41_XXJ_WS_FINISH: "Tamamla",
  T_41_XXJ_WS_FIREINTERVAL: "Ateş etme sıklığı",
  T_41_XXJ_WS_FIREINTERVAL_D: "Saldırı Sıklığı",
  T_41_XXJ_WS_FLIP: "Çevirme yöntemi",
  T_41_XXJ_WS_FLIP_D: "Çevirme metodu",
  T_41_XXJ_WS_FLYBOMBBEE: "Uçan Zombi",
  T_41_XXJ_WS_FORCE: "Kuvvet",
  T_41_XXJ_WS_FORCE_D: "Belirli bir yoğunlukta bir kuvvet oluşturun",
  T_41_XXJ_WS_FORCETYPE: "Kuvvet türü",
  T_41_XXJ_WS_FORCETYPE_D: "RigidBody üzerindeki farklı kuvvet türleri. Not: Yalnızca dinamik RigidBody tiplerinde etkilidir.",
  T_41_XXJ_WS_FREEZEALL: "Hareketi ve dönüşü dondur",
  T_41_XXJ_WS_FREEZEPOSITION: "Doğrusal hareketi dondur",
  T_41_XXJ_WS_FREEZEPOSITIONX: "x eksenini dondur",
  T_41_XXJ_WS_FREEZEPOSITIONY: "y eksenini dondur",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "z eksenini dondur",
  T_41_XXJ_WS_FREEZEROTATION: "Tüm rotasyonu dondur",
  T_41_XXJ_WS_FREEZEROTATIONX: "x dönüşü dondur",
  T_41_XXJ_WS_FREEZEROTATIONY: "y dönüşünü dondur",
  T_41_XXJ_WS_FREEZEROTATIONZ: "z dönüşünü dondur",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Maks. hasar mesafesi",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Maks. hasar mesafesi",
  T_41_XXJ_WS_GAMEID_D: "Görev ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Metropol eşyası ver",
  T_41_XXJ_WS_GRADIENT: "Gradyan",
  T_41_XXJ_WS_GRADIENT_D: "Gradyan",
  T_41_XXJ_WS_GRADIENTBOTTOM: "alttaki gradyan",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "Alt kısımdaki gradyan",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Alttaki saydamlık",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Alt Saydamlık",
  T_41_XXJ_WS_GRADIENTTOP: "Üstteki gradyan",
  T_41_XXJ_WS_GRADIENTTOP_D: "Üstteki gradyan",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Üstteki saydamlık",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Üst Saydamlık",
  T_41_XXJ_WS_GRAPHID: "Komut Dosyası Kimliği",
  T_41_XXJ_WS_GRAPHID_D: "Bir komut dosyası varlığını açıklamak için kullanılan kimlik",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Pas Bombası Bileşeni",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Patlama Gecikmesi",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Fırlatılabilir",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Maks. HSR",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Min HSR",
  T_41_XXJ_WS_GRENADERANGE_D: "Patlama Menzili",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Kendine verilen hasar çarpanı",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Müttefik HSR çarpanı",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Araç HSR çarpanı",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Fırlatma Hızı",
  T_41_XXJ_WS_GRENADEWEAPON: "Fırlatılabilir kategorisi",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Temel Fırlatılabilir Türleri",
  T_41_XXJ_WS_HANDCANNON_D: "Fırlatılabilirler",
  T_41_XXJ_WS_HEAD: "Kafa",
  T_41_XXJ_WS_HEADID: "Avatar ID",
  T_41_XXJ_WS_HEADID_D: "Avatar ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Ağır Silah",
  T_41_XXJ_WS_HELMET_D: "Mevcut kask",
  T_41_XXJ_WS_HELMET1_D: "Kask",
  T_41_XXJ_WS_HELMET2_D: "Kask Varlığı",
  T_41_XXJ_WS_HITBODYPART_D: "Vurulan vücut bölümü",
  T_41_XXJ_WS_HITBPDYPART: "Vücut bölgesini vur",
  T_41_XXJ_WS_HITENTITY_D: "Vuruş Varlığı",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "Ait olduğu HUD varlığı",
  T_41_XXJ_WS_HUD3DCONTAINER: "3B içerik kapsayıcı",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "HUD 3B kapsayıcı varlığı. Bu, oyuncuların editörden değiştirdiği gösterge panelidir.",
  T_41_XXJ_WS_HUDGRID: "Özel Düzen(Panel) kontrolü",
  T_41_XXJ_WS_HUDLAYOUT: "Düzen kontrolü",
  T_41_XXJ_WS_HUDLAYOUT_D: "HUD ekleme varlığı. Bu, oyuncuların editörden değiştirdiği gösterge panelidir.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Özel avatar kontrolü",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "HUD profil bilgisi varlığı. Bu, oyuncuların editörden değiştirdiği gösterge panelidir.",
  T_41_XXJ_WS_HUDTEXTURE: "Doku kontrolü",
  T_41_XXJ_WS_HUDTEXTURE_D: "HUD doku varlığı. Bu, oyuncuların editörden değiştirdiği gösterge panelidir.",
  T_41_XXJ_WS_HUDTRANSFORM: "UITransform kontrol bileşeni",
  T_41_XXJ_WS_HUDTRANSFORM_D: "UITransform denetim varlığı",
  T_41_XXJ_WS_IMPULSE: "Darbe",
  T_41_XXJ_WS_IMPULSE_D: "Belirli bir yoğunlukta bir darbe oluşturun",
  T_41_XXJ_WS_INITIALWORLDPOS: "İlk dünya koordinatları",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Güçlendirme sıralaması",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "BuffData.csv dosyasındaki kimlik sütununa karşılık gelir. Yeni içerik eklemeden önce lütfen GPP ile uyumluluğu kontrol edin.",
  T_41_XXJ_WS_INVERTFILL: "Dolguyu ters çevir",
  T_41_XXJ_WS_INVERTFILL_D: "Dolguyu ters çevir",
  T_41_XXJ_WS_ISLOOP: "Döngü",
  T_41_XXJ_WS_ISLOOP_D: "Döngü olsun ya da olmasın. Varsayılan yanlıştır.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Statik NavMesh üretimi",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Statik nesneler yüklenirken yalnızca statik NavMesh oluşumunu kontrol etmek için kullanılır",
  T_41_XXJ_WS_ISSUCCESS_D: "Yıkılmış ya da değil",
  T_41_XXJ_WS_ITEMENTITY_D: "Eşya Varlığı",
  T_41_XXJ_WS_ITEMID: "Eşya ID",
  T_41_XXJ_WS_ITEMID_D: "Eşya ID",
  T_41_XXJ_WS_ITEMID_D1: "Eke karşılık gelen eşya ID",
  T_41_XXJ_WS_ITEMLIST: "Eşya listesi",
  T_41_XXJ_WS_ITEMTYPE_D: "Eşya Türü",
  T_41_XXJ_WS_JUMPATTACK: "Atlama saldırısı",
  T_41_XXJ_WS_LANDMINE: "Mayın",
  T_41_XXJ_WS_LENGTH: "Klip uzunluğu",
  T_41_XXJ_WS_LENGTH_D: "İlerleme çubuğunun uzunluğu. Varsayılan değer, prefabrik kullanıcı arabirimindeki uzunluktur.",
  T_41_XXJ_WS_LIMB: "Uzuvlar",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Liste uzunluğu kapasiteyi aştığı için öğe eklenemedi",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Güçlendirme listesi",
  T_41_XXJ_WS_LOOP: "Döngü",
  T_41_XXJ_WS_LOOP_D: "Döngü",
  T_41_XXJ_WS_MAXCAPACITY: "Kapasite",
  T_41_XXJ_WS_MAXCAPACITY_D: "Çanta kapasitesi",
  T_41_XXJ_WS_MAXPROGRESS: "Maks. ilerleme",
  T_41_XXJ_WS_MELEEWEAPON_D: "Yakın Dövüş Silahı",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Min. hasar mesafesi",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Min. hasar mesafesi",
  T_41_XXJ_WS_MINISENTRY: "Oto Taret",
  T_41_XXJ_WS_NAME: "İsim",
  T_41_XXJ_WS_NAME_D: "Yetenek düğmesinin adı. OnClick olayları sırasında parametre göndermek için kullanılır, dolayısıyla benzersizliğin garanti edilmesi gerekir.",
  T_41_XXJ_WS_NAME1_D: "Ürün Adı",
  T_41_XXJ_WS_NAME2_D: "Ürün Listesi Adı",
  T_41_XXJ_WS_NAME3_D: "Otomat Makinesi Adı",
  T_41_XXJ_WS_NICKNAME: "Takma Ad",
  T_41_XXJ_WS_NICKNAME_D: "Oyuncu Adı",
  T_41_XXJ_WS_NOCHANGE: "Değişiklik yok",
  T_41_XXJ_WS_NONE: "Kısıtlama yok",
  T_41_XXJ_WS_NONE1: "Hiçbiri",
  T_41_XXJ_WS_OFFSET: "Ofset",
  T_41_XXJ_WS_OFFSET_D: "Ofset",
  T_41_XXJ_WS_OFFSET1_D: "Yazılı Ofset Değeri",
  T_41_XXJ_WS_ONCE: "1 kez",
  T_41_XXJ_WS_ONCE_D: "Bir Kez",
  T_41_XXJ_WS_ONHIDE: "Arayüz kapandığında",
  T_41_XXJ_WS_ONHIDE_D: "Arayüz kapandığında",
  T_41_XXJ_WS_ONNODEENTER_D: "Pivot girerken",
  T_41_XXJ_WS_ONSHOW: "Arayüz açıldığında",
  T_41_XXJ_WS_ONSHOW_D: "Arayüz açıldığında",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Metin kutusu değiştiğinde tetiklenir",
  T_41_XXJ_WS_PERSONALUAV: "Hafif İHA",
  T_41_XXJ_WS_PINID: "İşaret ID",
  T_41_XXJ_WS_PINID_D: "İşaret ID",
  T_41_XXJ_WS_PLAYERBAG: "Oyuncu çanta varlığı",
  T_41_XXJ_WS_PLAYERBAG_D: "Oyuncunun çanta varlığı",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Oyuncu çantası",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Oyuncunun çantası",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Dürbünlüyken değiştirilmiş hız katsayısı",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Ateş ederken hareket hızının etkisi",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Ateş ederken hareket hızının etkisi",
  T_41_XXJ_WS_PREFABID: "Prefab ID",
  T_41_XXJ_WS_PREFABID_D: "Bir prefabrik varlığı tanımlamak için kullanılan kimlik",
  T_41_XXJ_WS_PREFABID1_D: "Bu kimliğin temsil ettiği HUD şablon varlığı",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Ana Silah 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Ana Silah 2",
  T_41_XXJ_WS_PROFILEINFO: "Oyuncu profili",
  T_41_XXJ_WS_PROFILEINFO_D: "Oyuncu bilgisi",
  T_41_XXJ_WS_PROGRESSICON_D: "İlerleme simgesi",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "İlerleme simgesi adı",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Metropol mini oyunundan çık",
  T_41_XXJ_WS_RANGE: "Ateş etme menzili",
  T_41_XXJ_WS_RANGE_D: "Saldırı Menzili",
  T_41_XXJ_WS_RANGE_D1: "Patlama Menzili",
  T_41_XXJ_WS_RANGE_D2: "Taret Menzili",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Tüm tablodaki içeriği okuyun. İki boyutlu bir dizi döndürür.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Belirli bir hücrenin içeriğini oku",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Belirli bir satırın içeriğini okuyun. Bir dizi döndürür.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Belirli bir satırın içeriğini okuyun. Bir dizi döndürür.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Birikmiş veritabanını oku",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Birikmiş veritabanındaki bir tablodaki bir anahtara karşılık gelen değeri oku",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Devamlı olarak CP doldur",
  T_41_XXJ_WS_RELOADSPEED: "Doldurma hızı",
  T_41_XXJ_WS_RELOADSPEED_D: "Doldurma Hızı (Temel Hız x Çarpan)",
  T_41_XXJ_WS_RESOURCEID: "Kaynak UUID",
  T_41_XXJ_WS_RESOURCEID_D: "Kaynak UUID",
  T_41_XXJ_WS_RESUUID: "Kaynak ID",
  T_41_XXJ_WS_RESUUID_D: "Oluşturulacak belirlenmiş kaynak UUID",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "RigidBody kısıtlama türü",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Her kısıtlama, bir bit işaretiyle tanımlanır ve bir kombinasyon olarak kullanılabilir",
  T_41_XXJ_WS_ROTATION: "Rotasyon",
  T_41_XXJ_WS_ROTATION_D: "Dünya koordinatlarındaki dönüş açısı. x, y, z sırasıyla sapma açısı, eğim açısı ve yuvarlanma açısıdır.",
  T_41_XXJ_WS_ROTATION1_D: "Rotasyon",
  T_41_XXJ_WS_RUNNING: "Koşma",
  T_41_XXJ_WS_SCALE: "Ölçek",
  T_41_XXJ_WS_SCALE_D: "Ölçek",
  T_41_XXJ_WS_SCALE1_D: "Belirli bir eksen boyunca ölçekler. Üç eksenin bir kombinasyonu olabilir.",
  T_41_XXJ_WS_SCATTERMAX: "Maks. mermi yayılımı",
  T_41_XXJ_WS_SCATTERMAX_D: "Mermi yayılmasının başladığı değer",
  T_41_XXJ_WS_SCATTERMOVE1: "Hareket halindeyken yayılma boyutu",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Yayılma düzelme hızı",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Yayılma düzelme hızı",
  T_41_XXJ_WS_SCATTERSPEED: "Yayılma hızı artışı",
  T_41_XXJ_WS_SCATTERSPEED_D: "Yayılma hızı artışı (0,1 = Nişangah, her bir patlama artışı için % 10 genişler)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Yüzüstü ve çömelirken daha az yayılma",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "İkincil Silah",
  T_41_XXJ_WS_SHADERNAME: "Gölgelendirici adı",
  T_41_XXJ_WS_SHADERNAME_D: "Gölgelendirici adı",
  T_41_XXJ_WS_SHIELDBROKEN: "Kalkan kırma saldırısı",
  T_41_XXJ_WS_SHIELDUP: "Kalkan saldırısı",
  T_41_XXJ_WS_SHOCKWAVE: "Şok Dalgası",
  T_41_XXJ_WS_SHOWNAME: "Takma adı göster",
  T_41_XXJ_WS_SHOWNAME_D: "Takma Adı Göster",
  T_41_XXJ_WS_SHOWPIN: "İşareti göster",
  T_41_XXJ_WS_SHOWPIN_D: "Görüntüleme İşareti",
  T_41_XXJ_WS_SHOWRANK: "Dereceyi göster",
  T_41_XXJ_WS_SHOWRANK_D: "Dereceyi Göster",
  T_41_XXJ_WS_SHOWTYPE: "Tasarım",
  T_41_XXJ_WS_SHOWTYPE_D: "Tür",
  T_41_XXJ_WS_SHRINKSPEED: "Küçülme hızı",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Dürbünde nişan alma yardımını etkinleştir",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Mesafe ile nişan alma yardımcısı nişangah hassasiyeti (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Nişan alma yardımı için mesafeye öncelik verilirken katsayı (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Nişan alma yardımıyla mesafeye öncelik vermek için maks. mesafe",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Nişan alma yardımıyla mesafeye öncelik vermek için min. mesafe",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Nişan alma yardımı için mesafeye öncelik ver",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Nişan yardımlı nişangah hassasiyeti (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Dürbün yakınlaştırma faktörü",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV yakınlaştırma faktörü",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Dürbün dönüş hassasiyeti katsayısı",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Dürbün kullanırken hasarın değiştirilmiş katsayısı x",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Dürbünle ateş ederken UI yakınlaştırma süresi (sn)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Dürbünle ateş ederken UI yakınlaştırma faktörü",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Dürbünle ateş ederken UI devam etme süresi (sn)",
  T_41_XXJ_WS_SPEED: "Çalma hızı",
  T_41_XXJ_WS_SPEEQUIP: "İşlevsel ekipman",
  T_41_XXJ_WS_SPEITEM: "Cihazlar",
  T_41_XXJ_WS_STATICGRAPHID: "Statik komut dosyası kimliği",
  T_41_XXJ_WS_STATICGRAPHID_D: "Statik bir komut dosyasını açıklamak için kullanılan kimlik",
  T_41_XXJ_WS_STATICWAINING: "Statik Rigidbody türü değiştirilemedi",
  T_41_XXJ_WS_TARGETTREE: "Davranış ağacı varlığı",
  T_41_XXJ_WS_TARGETTREE_D: "Davranış ağacı varlığı",
  T_41_XXJ_WS_TEAMINDEX: "Takım seri no.",
  T_41_XXJ_WS_TEAMINDEX_D: "Odadaki takım indeksi ile çakışan takım indeksi",
  T_41_XXJ_WS_TEAMINDEX_D1: "Takım Grup Numarası",
  T_41_XXJ_WS_TEMPLATEPREFABID: "Şablon ID",
  T_41_XXJ_WS_TEXT_D: "İçerik",
  T_41_XXJ_WS_TEXTURENAME: "Doku ismi",
  T_41_XXJ_WS_TEXTURENAME_D: "Doku adı",
  T_41_XXJ_WS_THROWATTACK: "El Bombası",
  T_41_XXJ_WS_TICKINTERVAL: "Yenileme aralığı",
  T_41_XXJ_WS_TICKINTERVAL_D: "Yenileme aralığı. Sayı ne kadar büyük olursa, yenileme o kadar uzun sürer.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Oyuncunun çantasındaki özel cihazları etkinleştir",
  T_41_XXJ_WS_UVRECTWH: "UV genişliği & yükseklik",
  T_41_XXJ_WS_UVRECTWH_D: "UV genişliği ve yüksekliği",
  T_41_XXJ_WS_UVRECTXY: "UV ofseti",
  T_41_XXJ_WS_UVRECTXY_D: "UV ofseti",
  T_41_XXJ_WS_VELOCITY: "Sürat",
  T_41_XXJ_WS_VELOCITY_D: "RigidBody'nin hızını doğrudan değiştirmekten kaçının. İlgili API'leri kullanarak değiştirebilirsiniz.",
  T_41_XXJ_WS_VEST_D: "Mevcut yelek",
  T_41_XXJ_WS_VEST1_D: "Yelek",
  T_41_XXJ_WS_WIDGETID: "Kontrol ID",
  T_41_XXJ_WS_WIDGETID_D: "Arayüz varlıklarındaki bir kontrolü tanımlamak için kullanılan kimlik. Eşsiz bir kontrol kimliğine karşılık geldiğinden emin olmak için özel bir HUD kimliği ile eşleştirilmelidir.",
  T_41_XXJ_WS_WINDATTACK: "Kasırga saldırısı",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Birikmiş veritabanı ofsetini yaz",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Birikmiş veritabanındaki bir tablodaki bir anahtara karşılık gelen ofseti yazın",
  T_41_XXJ_WS_ZONEDURATION_D: "Donma süresi",
  T_41_XXJ_WS_ZONEDURATION1_D: "Pas Bombası Süresi",
  T_41_XXJ_WS_ZONERADIUS_D: "Donma alanı çapı",
  T_41_XXJ_WS_ZONERADIUS1_D: "Pas Bombası Çapı",
  T_41_XYL_WS_BOT12: "Sondajcı",
  T_41_XYL_WS_BOT9: "Mutasyona Uğramış Zombi",
  T_41_XYL_WS_ITEM262: "Donuş Çelik Panel A",
  T_41_XYL_WS_ITEM263: "Donmuş Konteyner A",
  T_41_XYL_WS_ITEM264: "Donmuş Yük Konteyneri",
  T_41_XYL_WS_ITEM265: "Donmuş Demir Kapı",
  T_41_XYL_WS_ITEM266: "Donmuş Konteyner B",
  T_41_XYL_WS_ITEM267: "Donmuş Taş A",
  T_41_XYL_WS_ITEM268: "Donmuş Taş B",
  T_41_XYL_WS_ITEM269: "Donmuş Taş C",
  T_41_XYL_WS_ITEM270: "Donmuş Taş D",
  T_41_XYL_WS_ITEM271: "Terk Edilmiş Metro Vagonu",
  T_41_XYL_WS_MODELMATCHNAME: "Yarışma Tuvali",
  T_41_XYL_WS_NAVMESH: "Dinamik Navmesh",
  T_41_XYL_WS_REFCUBE: "Yansıma Küpü",
  T_41_XYL_WS_SNOWSKY: "Ayaz Galaksi",
  T_41_XYL_WS_TOYCUBE: "Oyuncak Küp",
  T_42_CJ_F_B_VOCATIONAL: "Dişli Şablonu (Alt)",
  T_42_CJ_F_H_VOCATIONAL: "Dişli Şablonu (Kafa)",
  T_42_CJ_F_S_VOCATIONAL: "Dişli Şablonu (Ayakkabı)",
  T_42_CJ_F_T_VOCATIONAL: "Dişli Şablonu (Üst)",
  T_42_CJ_HA_THUNDER_GOLD: "Yıldırım Yüz Boyası",
  T_42_CJ_M_B_VOCATIONAL: "Mekanik Plan (Alt)",
  T_42_CJ_M_H_VOCATIONAL: "Mekanik Plan (Kafa)",
  T_42_CJ_M_S_VOCATIONAL: "Mekanik Plan (Ayakkabı)",
  T_42_CJ_M_T_VOCATIONAL: "Mekanik Plan (Üst)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Muhafız Duvar - Kaplanın Öfkesi",
  T_42_H_GRENADE_SMUDGE_N: "El Bombası - Kedi Gölgesi",
  T_42_H_M1917_EMPIRE_N: "M1917 - Taçlı Fatih",
  T_42_HJ_WS_VFX_INK: "Mürekkep",
  T_42_JH_WS_BANMATCHMAKING: "Bu haritada eşleştirme yapılamaz",
  T_42_JH_WS_BANROOMCREATE: "Oda oluşturulamadı",
  T_42_JH_WS_FPS: "1. Şahıs Nişancı",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Parti Remix (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Ateşten Duvar (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Şekil Bölen (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Nano Can Kalkanı (Sonia)",
  T_42_JH_WS_TAG1: "Kutup Kavgası",
  T_42_JH_WS_TAG10: "Sonsuz Yarışçı",
  T_42_JH_WS_TAG11: "Hızlı Yarış",
  T_42_JH_WS_TAG12: "Araba Yarışı",
  T_42_JH_WS_TAG13: "Popülerden Hariç Tut",
  T_42_JH_WS_TAG14: "Cephe Hattı",
  T_42_JH_WS_TAG15: "Zombi Savaşı",
  T_42_JH_WS_TAG16: "Yaşayan Efsane",
  T_42_JH_WS_TAG2: "Sosyal Ada 1.0",
  T_42_JH_WS_TAG3: "Sosyal Ada 2.0",
  T_42_JH_WS_TAG4: "Birlikte Oyna",
  T_42_JH_WS_TAG5: "Harabezede",
  T_42_JH_WS_TAG6: "Av Partisi",
  T_42_JH_WS_TAG7: "Av Partisi",
  T_42_JH_WS_TAG8: "Kale Kuşatma 2.0",
  T_42_JH_WS_TAG9: "Ödül Avı",
  T_42_RW_PORTALSFORPERSONAL_DESC: "İstediğin yere geçit yerleştir hemen ışınlan!",
  T_42_RW_PORTALSPERSONAL_NAME: "Geçit",
  T_42_SJ_WS_ACCESSORIESITEM: "Eklentiyi kuşan",
  T_42_SJ_WS_AUTOPLAY: "Otomatik oynatma",
  T_42_SJ_WS_CLIMB: "Tırman",
  T_42_SJ_WS_CLOCK_EVENTS: "Etkinlik derlemesi",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Geri sayım ya da değil",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Döngüler",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Etkinliği duraklat",
  T_42_SJ_WS_CLOCK_START_EVENT: "Etkinliği başlat",
  T_42_SJ_WS_CLOCK_START_TIME: "Geri sayım başlangıç zamanı",
  T_42_SJ_WS_CLOCK_STATE: "Kronometre durumu",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Etkinliği durdur",
  T_42_SJ_WS_DAMRATIOHEAD: "Kafadan vuruş hasarı katsayısı değişimi",
  T_42_SJ_WS_DAMRATIOLIMB: "Uzuv hasarı katsayı değişimi",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Patlayıcı hasarın azalma katsayısı",
  T_42_SJ_WS_DRIVE: "Sür",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Katmanları göster",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Fazladan çanta kapasitesi",
  T_42_SJ_WS_EXTRAHPRATIO: "CP oranı",
  T_42_SJ_WS_GETOFF_DRIVE: "Araçtan çık",
  T_42_SJ_WS_GETON_DRIVE: "Araca gir",
  T_42_SJ_WS_KNIFEITEM: "Hançer",
  T_42_SJ_WS_KNIFEITEMPICK: "Hançer (yerden alınan)",
  T_42_SJ_WS_MARKBTNHUD: "Ara yüzdeki işaret düğmesi",
  T_42_SJ_WS_MARKBTNHUD_D: "İşaret düğmesini açabilir veya kapatabilirsin",
  T_42_SJ_WS_MAXDISTANCE: "Maks. mesafe",
  T_42_SJ_WS_MAXDURARATIO: "Maks. dayanıklılık oranı",
  T_42_SJ_WS_MICBTNHUD: "Ara yüzdeki mikrofon düğmesi",
  T_42_SJ_WS_MICBTNHUD_D: "Mikrofon düğmesini açabilir veya kapatabilirsin",
  T_42_SJ_WS_MINDISTANCE: "Min. mesafe",
  T_42_SJ_WS_OPE_VEHICLE: "Aracı kullan",
  T_42_SJ_WS_PLANE_DESC: "Boyutu serbestçe ayarlanabilen temel bir ağ",
  T_42_SJ_WS_PLANENAME: "Temel Uçak",
  T_42_SJ_WS_PRIORITY: "Öncelik",
  T_42_SJ_WS_REPLACEPRIORITY: "Değişim önceliği",
  T_42_SJ_WS_SETBTNHUD: "Ara yüzdeki ayarlar düğmesi",
  T_42_SJ_WS_SETBTNHUD_D: "Ayarlar düğmesini açabilir veya kapatabilirsin",
  T_42_SJ_WS_SIGNALBTNHUD: "Ara yüzdeki ağ bağlantısı düğmesi",
  T_42_SJ_WS_SIGNALBTNHUD_D: "Ağ bağlantısı düğmesini açabilir veya kapatabilirsin",
  T_42_SJ_WS_SPEAKERBTNHUD: "Ara yüzdeki mikrofon düğmesi",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "Korna düğmesini açabilir veya kapatabilirsin",
  T_42_SJ_WS_START_TIME: "Başlama zamanı (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Bomba Atar hariç, cephane için ek [FFB300]{0}[-] sırt çantası kapasitesi elde edin. ([FFB300]{1}[-] AR Cephanesi, [FFB300]{2}[-] Hafif Makineli Silah Cephanesi, [FFB300]{3}[-] Keskin Nişancı Cephanesi, [FFB300]{4}[-] PT Cephanesi)",
  T_42_SW_SKILL_DESC_Bodyguard: "Doldurma hızı [FFB300]%{0}[-] artar. Yetenek kullanıcısı bir düşmana her vurduğunda, söz konusu hedef, [FFB300]{3}s[-] boyunca süren bir [FFB300]%{1}[-] iyileştirme azalması yaşar (maks. kesinti: [FFB300]%{2} [-]).",
  T_42_SW_SKILL_DESC_Playboy: "Yetenek bozan etkilere karşı gel (örn, yavaşlatma, işaretleme, susturma) ve [FFB300]{2}s[-] boyunca [FFB300]%{1}[-] hareket hızı artışı kazan. Bekleme Süresi: [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "Bir rakibi düşürdükten veya aktif bir yetenek kullandıktan sonra, silahın şarjörü [FFB300]{0}%[-] miktarda otomatik olarak dolar.",
  T_42_SW_SKILL_NAME_Playboy: "Gümüş Kaşık",
  T_42_SY_BACKPACK_EMPIRE_N: "Çanta - Taçlı Hükümdar",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Yoldaş Görünümü: Donuk Zıp",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Motosiklet - Şehir Tekeri",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Siyah Veneno",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Kırmızı Veneno",
  T_42_TYC_CST_LOSE_MONEY_1: "Bir turu kaybettikten sonra elde edilen EÇ Parası miktarı",
  T_42_TYC_CST_LOSE_MONEY_2: "2 turluk mağlubiyet serisi sonrasında elde edilen EÇ Parası miktarı",
  T_42_TYC_CST_LOSE_MONEY_3: "3 turluk mağlubiyet serisi sonrasında elde edilen EÇ Parası miktarı",
  T_42_WH_ITEM_HEALUAV: "Şifalı Hafif İHA",
  T_42_WH_ITEM_HEALUAV_DESC: "İleriye doğru giden ve aşağıdaki menzil içindeki takım arkadaşlarını sürekli olarak iyileştiren bir Hafif İHA gönderir",
  T_42_WH_ITEM_SKILLCARD: "Yetenek: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Aktif [ffba00]{0}[-] yeteneğini serbest bırakmak için kullan: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Mermi Türü",
  T_42_XXJ_WS_AMMOTYPE_D: "Mermi Türü",
  T_42_XXJ_WS_ASSETCONFIGID: "Görünüm ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Görünüm",
  T_42_XXJ_WS_ATTACKSTATUS: "Saldırma durumu",
  T_42_XXJ_WS_AUTOPLAY: "Otomatik oynatma",
  T_42_XXJ_WS_AUTOPLAY_D: "Otomatik oynatma",
  T_42_XXJ_WS_AVATARABLE: "Düzenlenebilir görünüm bileşeni",
  T_42_XXJ_WS_AVATARABLE_D: "Görünümü parçalara göre değiştir",
  T_42_XXJ_WS_AVATARRESUUID: "Görünüm kaynağı UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Bir döndürmenin eksen-açı gösterimini Kuaterniyonlara dönüştürme",
  T_42_XXJ_WS_B_D: "B renk değeri",
  T_42_XXJ_WS_BASEVALUE_D: "Logaritma tabanı",
  T_42_XXJ_WS_BEZIERCURVE: "Bézier eğrisi",
  T_42_XXJ_WS_BEZIERCURVE_D: "Bézier eğrisi",
  T_42_XXJ_WS_BOTDIFFICULTY: "Bot Zorluğu",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Sekebilirlik Kombinasyonu Yöntemi",
  T_42_XXJ_WS_BOUNCINES: "Sekebilirlik",
  T_42_XXJ_WS_BTREEID: "Davranış ağacı ID",
  T_42_XXJ_WS_BTREEID_D: "Davranış ağacı ID",
  T_42_XXJ_WS_CANPURCHAS: "Satın Alınabilir veya Satın Alınamaz",
  T_42_XXJ_WS_CANPURCHAS_D: "Satın alınabilir veya satın alınamaz",
  T_42_XXJ_WS_CLIMBSTATUS: "Tırmanma davranışı",
  T_42_XXJ_WS_CLOCK: "Zamanlayıcı Nesnesi",
  T_42_XXJ_WS_CLOCK_D: "Zamanlayıcı Nesnesi",
  T_42_XXJ_WS_CLOCK_D1: "Zamanlayıcı",
  T_42_XXJ_WS_CONTAINER: "Konteyner",
  T_42_XXJ_WS_CONTROLPOINTS: "Kontrol puanları",
  T_42_XXJ_WS_CONTROLPOINTS_D: "Kontrol noktaları",
  T_42_XXJ_WS_COROUTINEID: "Koroutin tanıtıcısı",
  T_42_XXJ_WS_COROUTINEID_D: "Coroutine ID, belirli bir koroutinin tanıtıcısını ifade eder. Sap üzerinde çeşitli işlemlerin yapılmasına olanak sağlar.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Self-relative oluştur",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Self-relative oluştur",
  T_42_XXJ_WS_CREATESOUND: "Ses Efekti Oluştur",
  T_42_XXJ_WS_CREATESOUND_D: "Belirlenen ses efektini çal. Ayarlanacak daha fazla özellik varsa varlık özelliklerini yapılandırarak bunu yapabilirsin.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Özel görevi tamamla",
  T_42_XXJ_WS_DAMAGELIST_D: "Hasar artış listesi",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Kafadan vuruş hasar oranı",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Patlama Hasarı azaltma çarpanı",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Varsayılan Fizik Materyali",
  T_42_XXJ_WS_DEFAULTFIST_D: "Varsayılan yumruk",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Mantıksal çerçeve aralığı",
  T_42_XXJ_WS_DELTATIME_D: "GSnin 2 mantıksal çerçeve güncellemesi arasındaki aralık",
  T_42_XXJ_WS_DEPTH: "Katman",
  T_42_XXJ_WS_DEPTH_D: "Simgedeki katmanları göster",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "Yerden alınamayan eşya listesi",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "Yerden alınamayan eşyaların listesi",
  T_42_XXJ_WS_DRIVER: "Sürücü koltuğu",
  T_42_XXJ_WS_DRIVINGSTATUS: "Sür",
  T_42_XXJ_WS_DURATION_D1: "Saniye cinsinden geri sayım süresi",
  T_42_XXJ_WS_DURATION_D2: "Saniye cinsinden süre",
  T_42_XXJ_WS_DURATION_D3: "Süre",
  T_42_XXJ_WS_DURATION_D4: "Saniye cinsinden hasar görmezlik süresi",
  T_42_XXJ_WS_DURATIONTIMES: "Zaman Aralığı",
  T_42_XXJ_WS_DURATIONTIMES_D: "Saniye cinsinden süre",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Dinamik Sürtünme",
  T_42_XXJ_WS_EASY: "Çok Kolay",
  T_42_XXJ_WS_ENDTIMES: "Bitiş Zamanı",
  T_42_XXJ_WS_ENDTIMES_D: "Zamanlayıcının saniye cinsinden bitiş zamanı",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Küresel Enerji Eşiği",
  T_42_XXJ_WS_ENTITYVARNAME_D: "self-relative varlık",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Eklenti kuşan",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Verilen Euler açılarını Kuaterniyonlara dönüştürün",
  T_42_XXJ_WS_EXPONENTIATION_D: "Üs alma",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Fazladan çanta kapasitesi",
  T_42_XXJ_WS_FIST: "Yumruk",
  T_42_XXJ_WS_FONTTYPE: "Yazı tipi numaralandırması",
  T_42_XXJ_WS_FONTTYPE_D: "Yazı tipi numaralandırması",
  T_42_XXJ_WS_FORCESYNCVALUE: "GS durumunu senkronize etmeye zorla",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "Zorunlu senkronizasyon değeri",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "Konum bilgisi. GS kuvvet senkronizasyonundan",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Zorunlu senkronizasyondan konum bilgisi",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "Özellikleri formüle edebilen bir varlık",
  T_42_XXJ_WS_FORWARD_D: "Yön vektörü",
  T_42_XXJ_WS_FRICTION_COMBINE: "Sürtünme Kombinasyonu Yöntemi",
  T_42_XXJ_WS_FUNCPOINT: "İşlev İşaretçisi",
  T_42_XXJ_WS_FUNCPOINT_D: "Bir işlevin örneğini işaret eden bir işaretçi. Sanal işlevleri uygulamak veya mekanizmaları devretmek için kullanılır.",
  T_42_XXJ_WS_GETMAPID_D: "Harita ID Al",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Araçtan çık",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Araca gir (sürücü)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Araca gir (yolcu)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Bugünün oyuncu jetonu verilerini ara",
  T_42_XXJ_WS_GRAVITY: "Küresel Yer Çekimi",
  T_42_XXJ_WS_HANDHELDITEM: "Mevcut el cihazı",
  T_42_XXJ_WS_HANDHELDITEM_D: "Mevcut el cihazı",
  T_42_XXJ_WS_HARD: "Zor",
  T_42_XXJ_WS_HASCOMPONENT_D: "Bir bileşenin olup olmadığı",
  T_42_XXJ_WS_HEIGHTLIST_D: "Yükseklik artış listesi",
  T_42_XXJ_WS_INDEXLIST_D: "Dizenin dizin listesine erişin",
  T_42_XXJ_WS_INSCENE: "Sahnede",
  T_42_XXJ_WS_INSCENE_D: "Sahnede",
  T_42_XXJ_WS_IS3D_D: "3B müzik olup olmadığı",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Geri sayım veya kronometre",
  T_42_XXJ_WS_ISLOOP: "Döngü ya da değil",
  T_42_XXJ_WS_ISLOOP_D: "IsLoop komutu",
  T_42_XXJ_WS_ISREPLAY_D: "En baştan başlayıp başlanmayacağı",
  T_42_XXJ_WS_ISSWITCH_D: "True olarak ayarlandığında göreceli hareketle birleştirilebilir. False olarak ayarlandığında mutlak hareketle birleştirilebilir.",
  T_42_XXJ_WS_JEEP: "Cip",
  T_42_XXJ_WS_JUMPSTATUS: "Zıplama durumu",
  T_42_XXJ_WS_LEFTVALUE: "Sol Değer",
  T_42_XXJ_WS_LEFTVALUE_D: "Taban",
  T_42_XXJ_WS_LOGARITHM_D: "Logaritma",
  T_42_XXJ_WS_LOOPABLE: "Döngülenebilir",
  T_42_XXJ_WS_LOOPABLE_D: "Döngülenebilir",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Sözlükteki tüm anahtarları al",
  T_42_XXJ_WS_MAPVALUE_D: "Hedef Sözlük",
  T_42_XXJ_WS_MARKBTNHUD: "Arayüzdeki işaretleme düğmesi",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "Maksimum mesafe",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "Arayüzdeki mikrofon düğmesi",
  T_42_XXJ_WS_MINDISTANCE_D: "Minimum mesafe",
  T_42_XXJ_WS_MISSIONID_D: "Görev ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "İlerleme (negatif bir sayı olamaz)",
  T_42_XXJ_WS_MODERATE: "Orta",
  T_42_XXJ_WS_MONSTERTRUCK: "Canavar Kamyon",
  T_42_XXJ_WS_MOTORBIKE: "Motosikleet",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Hareket durumu",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "İki kuaterniyonun çarpımı (rotasyon süperpozisyonunu temsil eder)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Atılan",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Oyuncu bakış açısını etkinleştir",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Oyuncu bakışını etkinleştir",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Silah Türü",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Silah Türü",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Oyuncu Yapılandırmasına öncelik ver",
  T_42_XXJ_WS_PARAMSARRAY: "Parametre Dizisi",
  T_42_XXJ_WS_PARAMSARRAY_D: "Parametre Dizisi çıktıda yer alan parametrelerin bir listesidir. Biçim açıklamasındaki %v sayısıyla eşleşmesi gerekiyor.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "Özel işlevlere iletilen gerçek parametrelerin listesi.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Parça görünürlük maskesi 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Parça görünürlük maskesi 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Parça görünürlük maskesi 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Parça görünürlük maskesi 4",
  T_42_XXJ_WS_PASSENGER1: "Yolcu koltuğu 1",
  T_42_XXJ_WS_PASSENGER2: "Yolcu koltuğu 2",
  T_42_XXJ_WS_PASSENGER3: "Yolcu koltuğu 3",
  T_42_XXJ_WS_PHYMAT: "Fizik Materyali",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Varlık",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Her karede kendine göre hareket",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Her karede kendine göre hareket",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Self-relative hareket",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "Kendisine göre hareket",
  T_42_XXJ_WS_PLAYER_D: "Araca girmesi gereken oyuncu",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Oyuncu davranışı özelliği senkronizasyonunun varlığı",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "Oynatıcı davranışı özelliği senkronizasyonunun varlığı",
  T_42_XXJ_WS_PRIORITY_D: "Öncelik",
  T_42_XXJ_WS_PROPID_D: "Özellik ID",
  T_42_XXJ_WS_QUATERNION: "Kuaterniyon",
  T_42_XXJ_WS_QUATERNION_D: "Kuaterniyon, yalnızca bir dönüşü temsil etmek için kullanılan özel bir dört boyutlu vektördür",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Verilen Kuaterniyonları eksen açısı gösterimine dönüştürün",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Verilen Kuaterniyonları Euler açılarına dönüştürün. Kuaterniyonlar standardı karşılamıyorsa (0,0,0) değerini döndürün.",
  T_42_XXJ_WS_REPEATTIMES_D: "Oynanma sayısı. Varsayılan 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Sıfırla",
  T_42_XXJ_WS_RIGHTVALUE: "Sağ Değer",
  T_42_XXJ_WS_RIGHTVALUE_D: "Katı",
  T_42_XXJ_WS_SEATTYPE: "Araç koltuğu sırası",
  T_42_XXJ_WS_SEPSTR_D: "Ayırma için kullanılan dize",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Oyuncu düşme hasarını ayarla",
  T_42_XXJ_WS_SETTINGSBTNHUD: "Arayüzdeki ayarlar düğmesi",
  T_42_XXJ_WS_SHOWPOSITION: "Konumu Göster",
  T_42_XXJ_WS_SHOWPOSITION_D: "Konumu Göster",
  T_42_XXJ_WS_SIGNALICOHUD: "Arayüzdeki ağ bağlantısı düğmesi",
  T_42_XXJ_WS_SIMPLE: "Kolay",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Adan Bye küresel kuaterniyon enterpolasyonu",
  T_42_XXJ_WS_SOUNDENTITY_D: "Ses efekti varlığı, çalınan bir ses efektini temsil eder",
  T_42_XXJ_WS_SPEAKERBTNHUD: "Arayüzdeki korna düğmesi",
  T_42_XXJ_WS_SPLITSTRING_D: "Dizeyi bir dilime bölmek için belirli bir dizeyi sınırlayıcı olarak kullanın",
  T_42_XXJ_WS_SPORTSCAR: "SporAraba",
  T_42_XXJ_WS_SPRINTSTATUS: "Koşma durumu",
  T_42_XXJ_WS_SRCVAL_D: "Kaynak değeri",
  T_42_XXJ_WS_STARTTICKCOUNT: "GSnin işlemeye başladığı an",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "GSnin ilerlemeye başladığı an",
  T_42_XXJ_WS_STARTTIME_D: "Başlama zamanı",
  T_42_XXJ_WS_STARTTIME_D1: "Başlama zamanı",
  T_42_XXJ_WS_STATE_D: "Bir oyuncunun durumu: aktif, yere serilmiş veya elenmiş",
  T_42_XXJ_WS_STATE_D1: "Bu ses efektinin çalınıp çalınmadığını kontrol et",
  T_42_XXJ_WS_STATIC_FRICTION: "Statik Sürtünme",
  T_42_XXJ_WS_STRELEMS_D: "Hedef dize seti",
  T_42_XXJ_WS_STRINGFINDAT_D: "Dizin listesine göre son birleştirilmiş dizeyi döndürün",
  T_42_XXJ_WS_STRINGJOIN_D: "Belirtilen tanımlayıcıyı kullanarak dizeleri birleştirme",
  T_42_XXJ_WS_STRINGLOWER_D: "Dizideki tüm karakterleri küçük harf yap",
  T_42_XXJ_WS_STRINGSTRIP_D: "Dizenin her iki tarafındaki boşluk karakterlerini kaldırın",
  T_42_XXJ_WS_STRINGUPPER_D: "Dizideki tüm karakterleri büyük harf yap",
  T_42_XXJ_WS_STYLE_D: "Nasıl oynanır",
  T_42_XXJ_WS_SUV: "Kamyonet",
  T_42_XXJ_WS_SWITCH: "Düğme",
  T_42_XXJ_WS_SWITCH_D: "True olarak ayarlandığında göreceli hareketle birleştirilebilir. False olarak ayarlandığında mutlak hareketle birleştirilmesi gerekir, aksi takdirde özellikler doğru şekilde etkili olmaz.",
  T_42_XXJ_WS_TARGETENTITY_D: "Hedef varlık",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Takımın Tur Skoru Sancağı",
  T_42_XXJ_WS_TEAMSEQ_D: "Ekip varlığının seri numarası özelliğine karşılık gelen ekip seri numarası",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Geçici Kalkan Puanı",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Geçici kalkan puanları",
  T_42_XXJ_WS_TEXT_D: "Metin sansürü uygulanacak orijinal metin",
  T_42_XXJ_WS_THREESTATESWITCH: "3-Durum Anahtarı",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Hançer (yerden alınır)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Hançer",
  T_42_XXJ_WS_TUKTUK: "Tuk Tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Takımların Maç Detayları",
  T_42_XXJ_WS_UNIQUEID: "Eşsiz ID",
  T_42_XXJ_WS_UNIQUEID_D: "Eşsiz ID",
  T_42_XXJ_WS_VALUE_D: "Değer",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Euler açılarına yön vektörü",
  T_42_XXJ_WS_VEHICLEID: "Araç ID",
  T_42_XXJ_WS_VEHICLESKINID: "Araç görünümü ID",
  T_42_XXJ_WS_VERYHARD: "Çok Zor",
  T_42_XXJ_WS_VOLUME_D: "Ses ayarı. Varsayılan: 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Silahın Ana Türü",
  T_42_XXJ_WS_WORKSHOPCODE: "Harita kodu",
  T_42_XXJ_WS_WORKSHOPCODE_D: "Veritabanındaki bir veriye karşılık gelen harita kodu",
  T_42_XXJ_WS_WORLDPOSITION: "Dünya koordinatları",
  T_42_XXJ_WS_WORLDPOSITION_D: "Dünya koordinatları",
  T_42_XYL_WS_ITEM275: "Benzin Tankı",
  T_42_XYL_WS_ITEM276: "Kum Torbası A",
  T_42_XYL_WS_ITEM277: "Kum Torbası B",
  T_42_XYL_WS_ITEM278: "Kum Torbası C",
  T_42_XYL_WS_ITEM279: "Kum Torbası",
  T_42_XYL_WS_ITEM280: "Çift Katlı Villa",
  T_42_XYL_WS_ITEM281: "Silah Fabrikası",
  T_42_XYL_WS_ITEM282: "Taş Duvar  A",
  T_42_XYL_WS_ITEM283: "Taş Duvar B",
  T_42_XYL_WS_ITEM284: "Taş Duvar C",
  T_42_XYL_WS_ITEM285: "Taş Duvar D",
  T_42_XYL_WS_ITEM286: "Askeri Yük Kutusu A",
  T_42_XYL_WS_ITEM287: "Bakır Para",
  T_42_XYL_WS_ITEM288: "Gümüş Para",
  T_42_XYL_WS_ITEM289: "Altın Para",
  T_42_XYL_WS_ITEM290: "Elmas",
  T_42_XYL_WS_ITEM291: "Elmas Parçası",
  T_42_XYL_WS_ITEM292: "Yakut",
  T_42_XYL_WS_ITEM293: "Zümrüt",
  T_42_XYL_WS_ITEM294: "Safir",
  T_42_XYL_WS_ITEM295: "Uyarı Levhası",
  T_42_XYL_WS_ITEM297: "Harabe",
  T_42_XYL_WS_ITEM297TRUE: "Kontrol Cihazı",
  T_42_XYL_WS_ITEM298: "Yük Konteyneri B",
  T_42_XYL_WS_ITEM299: "Kar Yığını",
  T_42_XYL_WS_ITEM300: "Yüksek Teknolojili Duvar A",
  T_42_XYL_WS_ITEM301: "Yüksek Teknolojili Duvar B",
  T_42_XYL_WS_ITEM302: "Donmuş Taş F",
  T_42_XYL_WS_ITEM303: "Donmuş Taş E",
  T_42_XYL_WS_ITEM304: "Yüksek Teknolojili Platform A",
  T_42_XYL_WS_ITEM305: "Yüksek Teknolojili Merdiven A",
  T_42_XYL_WS_ITEM306: "Keşif Lambası A",
  T_42_XYL_WS_ITEM307: "Harabe Bölmesi A",
  T_42_XYL_WS_ITEM308: "Harabe Bölmesi B",
  T_42_XYL_WS_ITEM309: "Harabe Çelik Destek A",
  T_42_XYL_WS_ITEM310: "Harabe Taşı A",
  T_42_XYL_WS_ITEM311: "Harabe Taşı B",
  T_42_XYL_WS_ITEM312: "Harabe Taşı C",
  T_42_XYL_WS_ITEM313: "Fener A",
  T_42_XYL_WS_ITEM314: "Harabe İnşaat Demiri A",
  T_42_XYL_WS_LOGICALOBJECT: "Mantık",
  T_42_XYL_WS_THEMEHIGHTECH: "Fütüristik",
  T_42_XYL_WS_THEMEICE: "Buzlu",
  T_42_XYL_WS_THEMEMILITARY: "Askeri",
  T_42_XYL_WS_THEMEOBJECTS: "Temalı Nesne",
  T_42_XYL_WS_TIMERCONTINUE: "Zamanlayıcıyı Devam Ettirme Olayı",
  T_42_XYL_WS_TIMERCYCLE: "döngü Sayısı",
  T_42_XYL_WS_TIMERDOWN: "Geri Sayım",
  T_42_XYL_WS_TIMEREND: "Zamanlayıcı bitiş olayı",
  T_42_XYL_WS_TIMEREVENT: "Özelleştirilmiş Zamanlayıcı Olayı",
  T_42_XYL_WS_TIMEREVENT1: "Zamanlayıcı Kontrolü",
  T_42_XYL_WS_TIMEREVENT2: "Zamanlayıcı Olaylarını Ayarla",
  T_42_XYL_WS_TIMERORDER: "Zamanlama Yöntemi",
  T_42_XYL_WS_TIMERPAUSE: "Zamanlayıcıyı Duraklatma Olayı",
  T_42_XYL_WS_TIMERSTART1: "Zamanlayıcı Başlangıç Zamanı",
  T_42_XYL_WS_TIMERSTART2: "Zamanlayıcı Başlatma Olayı",
  T_42_XYL_WS_TIMERUP: "Zamanlama",
  T_42_XYL_WS_TRIGGERTIME_MS: "Tetiklenme Süresi (milisaniye cinsinden)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "Birden fazla oyuncu taşıyabilir bir gökkanat.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Bireysel Skor",
  T_42_ZZ_GUILDWAR_SCORE: "Skor",
  T_43_B_SKILL_DESC_MONKEYGOD: "[FFB300]{1}s[-] boyunca bir çalıya dönüşür. Bekleme Süresi: [FFB300]{0}sn[-]. Saldırdığında ve saldırıya uğradığında dönüşüm sona erer. Bir düşmanı alt ettiğinde bekleme süresi sıfırlanır.",
  T_43_B_SKILL_DESC_Nanoscientist: "Ölümcül hasar aldıktan sonra, [FFB300]{0}s[-] boyunca dokunulmaz ve hareketsiz bir duruma gir. Ardından, [FFB300]{2}s[-] boyunca süren bir adet [FFB300]{1} CP kalkanı[-] kazanırsın. Kalkan kaybolduğunda beceri kullanıcısı elenecektir. Bekleme Süresi: [FFB300]{3}sn[-].",
  T_43_B_SKILL_DESC_ORION: "EPyi [FFB300]{0} Kızıl Enerji[-] ile değiştirir. Korumasını etkinleştirmek için [FFB300]{1} Kızıl Enerji[-] tüketir; bu sırada hasar alamazsın veya düşmanlara saldıramazsın ve [FFB300]{3}m[-] içindeki düşmanlardan [FFB300]{4} CP[-] emersin (düşmanın Kalkan Puanlarını göz ardı ederek). [FFB300]{2}s[-] sürer ve bu süre zarfında hareket hızın [FFB300]%{6}[-] azalır. Bekleme Süresi: [FFB300]{5}sn[-].",
  T_43_CJ_F_A_RACER: "Süratli Yarışçı (Maske)",
  T_43_CJ_F_B_RACER: "Süratli Yarışçı (Alt)",
  T_43_CJ_F_H_RACER: "Süratli Yarışçı (Kafa)",
  T_43_CJ_F_HA_RACER: "Süratli Yarışçı (Yüz Boyası)",
  T_43_CJ_F_S_RACER: "Süratli Yarışçı (Ayakkabı)",
  T_43_CJ_F_T_RACER: "Süratli Yarışçı (Üst)",
  T_43_CJ_M_A_RACER: "Turbo Yarışçı (Maske)",
  T_43_CJ_M_B_MACHINERY: "Teknik Turkuaz (Alt)",
  T_43_CJ_M_B_RACER: "Turbo Yarışçı (Alt)",
  T_43_CJ_M_H_MACHINERY: "Teknik Turkuaz (Kafa)",
  T_43_CJ_M_H_RACER: "Turbo Yarışçı (Kafa)",
  T_43_CJ_M_HA_MACHINERY: "Teknik Turkuaz (Yüz Boyası)",
  T_43_CJ_M_S_MACHINERY: "Teknik Turkuaz (Ayakkabı)",
  T_43_CJ_M_S_RACER: "Turbo Yarışçı (Ayakkabı)",
  T_43_CJ_M_T_MACHINERY: "Teknik Turkuaz (Üst)",
  T_43_CJ_M_T_RACER: "Turbo Yarışçı  (Üst)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Mamba Alevi",
  T_43_HJ_WS_OPTION8: "Diğer",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bambu",
  T_43_HJ_WS_TEXTURE_BEACH: "Sahil",
  T_43_HJ_WS_TEXTURE_BRICK1: "Tuğla Duvar A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Tuğla Duvar B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Tuğla Duvar C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Beton Zemin",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Beton",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Kristal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Çimen A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Çimen B",
  T_43_HJ_WS_TEXTURE_ICE: "Buz Parçası",
  T_43_HJ_WS_TEXTURE_IRON: "Metal Zemin",
  T_43_HJ_WS_TEXTURE_IRON2: "Konteyner",
  T_43_HJ_WS_TEXTURE_LAVA: "Lavaa",
  T_43_HJ_WS_TEXTURE_MARBLE: "Mermer Zemin",
  T_43_HJ_WS_TEXTURE_NONE: "Boş",
  T_43_HJ_WS_TEXTURE_STONE: "Taş",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Masa Örtüsü A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Masa Örtüsü B",
  T_43_HJ_WS_TEXTURE_WOOD: "Ağaç",
  T_43_HJ_WS_TEXTURE_WOODEN: "Tahta Zemin A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Tahta Zemin B",
  T_43_JH_WS_MAPTAG1: "Çaylak Dostu",
  T_43_JH_WS_MAPTAG10: "Sıkıcı yeni içerik",
  T_43_JH_WS_MAPTAG11: "Düşük ödül hissi",
  T_43_JH_WS_MAPTAG12: "Ödüller dengesiz",
  T_43_JH_WS_MAPTAG13: "İlerleme hissi yetersiz",
  T_43_JH_WS_MAPTAG14: "Çaylak Dostu Değil",
  T_43_JH_WS_MAPTAG15: "Kafa karıştıran öğretici",
  T_43_JH_WS_MAPTAG16: "Öğretici yok",
  T_43_JH_WS_MAPTAG17: "Oyuncular çıkıyor",
  T_43_JH_WS_MAPTAG18: "Kontroller karışık",
  T_43_JH_WS_MAPTAG19: "Dağınık kullanıcı arayüzü",
  T_43_JH_WS_MAPTAG2: "Tercih edilen yeni içerik",
  T_43_JH_WS_MAPTAG20: "Harita tasarımı zayıf",
  T_43_JH_WS_MAPTAG21: "Heyecan Verici Nişancı",
  T_43_JH_WS_MAPTAG22: "Tempolu",
  T_43_JH_WS_MAPTAG23: "Açık Dünya",
  T_43_JH_WS_MAPTAG24: "Zengin Hikaye",
  T_43_JH_WS_MAPTAG25: "İlerleme Sistemi",
  T_43_JH_WS_MAPTAG26: "Spor Simülasyonu",
  T_43_JH_WS_MAPTAG27: "Eş Zamanlı Görev",
  T_43_JH_WS_MAPTAG28: "Sosyal",
  T_43_JH_WS_MAPTAG29: "Çeşitli Olaylar",
  T_43_JH_WS_MAPTAG3: "Aktif oyuncular",
  T_43_JH_WS_MAPTAG30: "Serbest Keşif",
  T_43_JH_WS_MAPTAG31: "Derece Görevi",
  T_43_JH_WS_MAPTAG32: "Başarı Görevi",
  T_43_JH_WS_MAPTAG33: "Para Telafisi",
  T_43_JH_WS_MAPTAG4: "İyi Tasarlanmış Harita",
  T_43_JH_WS_MAPTAG40: "Sayısız ödül",
  T_43_JH_WS_MAPTAG41: "Tatmin edici ilerleme",
  T_43_JH_WS_MAPTAG42: "Popüler Eğitim Alanı",
  T_43_JH_WS_MAPTAG43: "Popüler Tekli Kule",
  T_43_JH_WS_MAPTAG44: "Popüler Savaş Bölgesi",
  T_43_JH_WS_MAPTAG5: "Akıcı Değil",
  T_43_JH_WS_MAPTAG6: "Zor eş zamanlı",
  T_43_JH_WS_MAPTAG7: "Hatalı",
  T_43_JH_WS_MAPTAG8: "Az güncelleme",
  T_43_JH_WS_MAPTAG9: "Sıkıcı maç içi etkinlikler",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Örümcek Tuzağı (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Destek Eşyaları",
  T_43_SJ_WS_AIRDROP_NAME: "Malzeme Desteği",
  T_43_SJ_WS_AIRDROP_TIME: "Destek Süresini Başlat",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Destek Eşyaları",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Otomatik Oynatmadır",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Merkez Pozisyonudur",
  T_43_SJ_WS_ANITRIGGER_CLIP: "Animasyon Klibi ID",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Döngüdür",
  T_43_SJ_WS_ANITRIGGER_NAME: "Animasyon Tetikleyici HUD",
  T_43_SJ_WS_RESET_ROUND: "Her Tur Sıfırla",
  T_43_SJ_WS_START_DROPTIME: "Drop Süresini Başlat (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Animasyon Tetikleyici",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Yoldaş Görünümü: Pisi Pisi Miço",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Motosiklet - Kavuran Hız",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Cephane ve tıbbi eşyalar gibi temel savaş malzemelerini içerir",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Malzeme Kutusu",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "[FFB300]{0}s[-] boyunca bağımsız olarak hareket eden bir [FFB300]{1} HP[-] kukla oluşturur. Kukla [FFB300]{3}m[-] yakınındayken, onunla konum değiştirmek için yeteneği tekrar kullan. Toplamda en fazla [FFB300]{2} zamana[-] kadar [FFB300]{4}s[-] içinde yalnızca bir kez geçiş yapabilirsin. Kuklayı yok eden oyuncu, [FFB300]{5}s[-] boyunca işaretlenecektir. Bekleme Süresi: [FFB300]{6}sn[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Aktif Yetenek",
  T_43_XXJ_WS_AIRDROP: "Malzeme Desteği ve Zombi",
  T_43_XXJ_WS_ALPHA: "Alfa",
  T_43_XXJ_WS_ALPHA_D: "HUDun 0dan 1e kadar olan genel şeffaflığı.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "Animasyon Kumandası ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "Bir animasyon kumandası varlığını tanımlamak için kullanılan ID",
  T_43_XXJ_WS_AUDIOID: "Ses ID",
  T_43_XXJ_WS_AUDIOID_D: "Bir ses öğesini tanımlamak için kullanılan ID",
  T_43_XXJ_WS_BACKGRCOLOR: "Arka Plan Rengi",
  T_43_XXJ_WS_BACKGRCOLOR_D: "Sağlık çubuğu sınırının rengi ve bulanık arka plan",
  T_43_XXJ_WS_BURNING: "Yanma",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "Bir konfigürasyon tablosu varlığını tanımlamak için kullanılan ID",
  T_43_XXJ_WS_CURRENTHP: "Mevcut CP",
  T_43_XXJ_WS_CURRENTHP_D: "Mevcut CP değeri",
  T_43_XXJ_WS_DAMAGEMAKER_D: "Hasar veren oyun varlığı",
  T_43_XXJ_WS_DAMAGEZONE: "Hasar Bölgesi",
  T_43_XXJ_WS_DEFAULT: "Varsayılan",
  T_43_XXJ_WS_DEFAULT_D: "Varsayılan",
  T_43_XXJ_WS_EFFECTID: "Efekt ID",
  T_43_XXJ_WS_EFFECTID_D: "Özel efekt varlığını tanımlamak için kullanılan ID",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "Savaşabilen bir varlık (örn. saldırabilen, saldırılabilen veya haklanabilen)",
  T_43_XXJ_WS_FOLLOWTARGET: "Hedefi Takip Et",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Dönüşüm bileşeni olan bir varlığı takip etmelidir",
  T_43_XXJ_WS_GAINHPCOLOR: "CP Rengi Al",
  T_43_XXJ_WS_GAINHPCOLOR_D: "CPnin artan kısmı kısa bir süre için bu renkte gösterilecek",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Düşme Hasarı Yok",
  T_43_XXJ_WS_ISOPENTWEEN: "Şekil Değiştirmeye Açık",
  T_43_XXJ_WS_ISOPENTWEEN_D: "CP değişikliklerini farklı renklerde göstermek için bunu etkinleştir",
  T_43_XXJ_WS_KNOCKDOWN_D1: "Oyuncu yere serilmiş durumda",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Ortadan kaldırıldığında yere serilme durumuna verilecek yanıta ilişkin ayarlar",
  T_43_XXJ_WS_KNOCKDOWN_D3: "Diriltme kaynağı türü. Bir oyuncu yere serildiğinde yeniden canlandırılabilir.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Yere Serilme Durumu",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Yere Serilme Durumu Türü",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "Yere serilme durumuna yanıt: varsayılan mantığı koru, yere serilme durumunu atla veya yere serilmeye zorla.",
  T_43_XXJ_WS_LEVEL: "Seviye",
  T_43_XXJ_WS_LEVEL_D: "Seviye",
  T_43_XXJ_WS_LEVEL_D1: "Mevcut zombi seviyesi",
  T_43_XXJ_WS_LINESPACING: "Satır Aralığı",
  T_43_XXJ_WS_LINESPACING_D: "İki bölücü arasındaki bölümlenmiş CP ≤ 0 olduğunda görüntülenmez",
  T_43_XXJ_WS_LOSEHPCOLOR: "CP Rengini Kaldır",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "CPnin azaltılmış kısmı kısa bir süre için bu renkte gösterilecek",
  T_43_XXJ_WS_MAINCOLOR: "Ana Renk",
  T_43_XXJ_WS_MAINCOLOR_D: "CP, seviye ve ana hatların rengi",
  T_43_XXJ_WS_MINISENTRY: "Taret",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "Bir taretin saldırabileceği hedef türlerinin listesi",
  T_43_XXJ_WS_MISSILEEXPLODE: "Füze Patlaması",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Zorunlu Yere Serilme",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Zorla yere ser",
  T_43_XXJ_WS_OFFSET: "Ofset",
  T_43_XXJ_WS_OFFSET_D: "Takip edilen hedefe göre sapma",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Yağ Varilinin Patlaması",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Yalnızca kumanda hareketi başlattığında tetiklenir",
  T_43_XXJ_WS_PLAYER_D: "Oyun içi oyuncu varlığı. Her oyuncuda bulunur.",
  T_43_XXJ_WS_PLAYERHEADHUD: "Oyuncu Üzeri HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "Oyuncunun başının üzerinde gösterilen bilgi",
  T_43_XXJ_WS_PLAYERNAME: "Oyuncu Adı",
  T_43_XXJ_WS_PLAYERNAME_D: "Mevcut can çubuğu sahibinin adını gösterir",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Oyuncu veya Araç",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "Oyuncu/araç varlık türünün takma adı",
  T_43_XXJ_WS_SCALE: "Ölçek",
  T_43_XXJ_WS_SCALE_D: "Yazı tipinin eşleşecek şekilde ölçeklendirilmesiyle genel HUD ölçek boyutunu belirler.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Hasar Sayısını Göster",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "Varsayılan olarak doğrudur. Hasar sayısını görüntüler.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Yere Serilmeyi Atla",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Yere serilme durumunu atla ve anında ele",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Kademeli Animasyonu Atlar",
  T_43_XXJ_WS_TEAM_D: "(Kullanımdan kaldırıldı. Lütfen Takım ID kullan.)",
  T_43_XXJ_WS_TERRAIN: "Arazi",
  T_43_XXJ_WS_TERRAIN_D: "Nitelikleri değiştirilemeyen bir arazi bileşeni. Yalnızca işlevleri test etmek için kullanılır.",
  T_43_XXJ_WS_TOTALHP: "Toplam CP",
  T_43_XXJ_WS_TOTALHP_D: "Toplam CP değeri",
  T_43_XXJ_WS_TWEENENTITY: "Ara Varlığı",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Araç Patlaması",
  T_43_XXJ_WS_WIDTH: "Genişlik",
  T_43_XXJ_WS_WIDTH_D: "Görüntülenen can çubuğunun genişliği",
  T_43_XXJ_WS_ZOMBIE: "Zombi",
  T_43_XYL_WS_DROIDFIST: "Yumruk (Droid Kıyameti)",
  T_43_XYL_WS_DROIDFLAME: "Alev Silahı (Droid Kıyameti)",
  T_43_XYL_WS_JAPANESE: "Japon-Stili",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Maç olay günlüklerini özelleştir. Kullanıcı deneyimi analizi için kullanılır",
  T_43_YU_WS_AIRDROPSTATE: "Malzeme Desteği Durumu",
  T_43_YU_WS_AIRDROPSTATE_D: "Malzeme desteği durumu (1: hazır, 2: düşüyor, 3: indi)",
  T_43_YU_WS_ANIMATIONCLIPID: "Animasyon Klibi ID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Animasyon klip kimliğini özelleştir",
  T_43_YU_WS_ASKBUYTARGET: "Satın Alma Hedefini Sor",
  T_43_YU_WS_ASKBUYTARGET_D: "Hedefi belirler ve satın alma isteği gönderir",
  T_43_YU_WS_ASKEDLIST: "İstenen Liste",
  T_43_YU_WS_ASKEDLIST_D: "İstenen eşyaların listesi",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Arka Plan Rengi 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "Üst arka plan rengi",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Arka Plan Rengi 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "Alt arka plan rengi",
  T_43_YU_WS_BATCHCOMBINERENDER: "Toplu Birleştirme İşleme",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Para Varlık Listesini Bağla",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "Bağlı para birimlerinin listesi",
  T_43_YU_WS_BINDWALLETENTITYID: "Cüzdan Varlık Kimliğini Bağla",
  T_43_YU_WS_BINDWALLETENTITYID_D: "Bağlı cüzdan varlığının kimliği",
  T_43_YU_WS_CENTEROFFSET: "Merkez Ofseti",
  T_43_YU_WS_CENTEROFFSET_D: "Kapsül çarpıştırıcısının ofset değeri",
  T_43_YU_WS_COLLECTIONID: "Koleksiyon ID",
  T_43_YU_WS_COLLECTIONID_D: "Varlık bilgilerinin toplanması için kullanılan Koleksiyon Kimliği",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Malzeme desteği oluştur",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Hasar numarası oluşturun",
  T_43_YU_WS_CROSSPLATFORM_D: "Seçildiğinde, sunucuda çağrılırsa istemciye gönderir ve bunun tersi de geçerlidir.",
  T_43_YU_WS_CSROUNDRESULTHUD: "EÇ Tur Sonuç HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Sonuçlar her turun sonunda gösterilir",
  T_43_YU_WS_CURRENTEMOTECLIP: "Mevcut İfade Klibi",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "Mevcut ifade klibi ID",
  T_43_YU_WS_DAMAGE_D: "Bölge dışı hasarı",
  T_43_YU_WS_DICTIONARY: "Sözlük",
  T_43_YU_WS_DIRECTIONRULERHUD: "Yön Cetveli HUD",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "Üstteki pusula",
  T_43_YU_WS_DOTWEEN_D: "Ara animasyonlarının gerçekleştirilip gerçekleştirilmeyeceği",
  T_43_YU_WS_DROPITEMS_D: "Malzeme desteğindeki eşyalar",
  T_43_YU_WS_DURATION: "Süre",
  T_43_YU_WS_ENERGY: "Enerji",
  T_43_YU_WS_ENERGY_D: "EP modifikasyon değeri",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Çömel",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Çömel",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Koşma",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Dur",
  T_43_YU_WS_EVENTID: "Etkinlik ID",
  T_43_YU_WS_EVENTID_D: "Bir etkinliği temsil eder",
  T_43_YU_WS_FACTION: "Taraf",
  T_43_YU_WS_FACTION_D: "Taraf varlığı",
  T_43_YU_WS_FACTION_D1: "Gruptan satın alma konusunda yardım iste",
  T_43_YU_WS_FINALRADIUS_D: "Güvenli bölgenin son çapı",
  T_43_YU_WS_FIRSTAIDKIT: "Sağlık Kiti",
  T_43_YU_WS_FIRSTAIDKIT_D: "Sağlık Kiti",
  T_43_YU_WS_FIRSTPERSONMODEL: "Birinci Şahıs Modeli",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "Birinci şahıs kamerası",
  T_43_YU_WS_FONTCOLOR_D: "Yazı rengi",
  T_43_YU_WS_FONTSIZE_D: "Yazı boyutu",
  T_43_YU_WS_FORBIDEN: "İzin Yok",
  T_43_YU_WS_FORBIDEN_D: "Satın alma isteği için HUDu devre dışı bırakın",
  T_43_YU_WS_FREEZINGTIME: "Donma Süresi",
  T_43_YU_WS_FREEZINGTIME_D: "Vurulan hedefin donup kaldığı süre",
  T_43_YU_WS_GRAVITY: "Yer Çekimi",
  T_43_YU_WS_GRAVITY_D: "Yerçekimi ivmesi. Yalnızca oyuncu denetleyicisini etkiler.",
  T_43_YU_WS_HANDCATAPULT: "Atış Rampası",
  T_43_YU_WS_HANDCATAPULT_D: "Atış Rampası",
  T_43_YU_WS_HEALTH: "Can",
  T_43_YU_WS_HEALTH_D: "Zırh dayanıklılığı yenilenme değeri",
  T_43_YU_WS_HEIGHT: "Yükseklik",
  T_43_YU_WS_HELPEDPLAYER_D: "Yardım edilen oyuncu",
  T_43_YU_WS_HELPPLAYER_D: "Satın almaya yardım eden oyuncu",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Maks. Yatay Açı",
  T_43_YU_WS_HORIZONTALMINANGLE: "Yatay Min Açı",
  T_43_YU_WS_HUDTOGGLE: "HUD Geçişi",
  T_43_YU_WS_HUDTOGGLE_D: "Oyuncuların HUD düzenleyicide düzenleyebileceği HudToggle varlığı",
  T_43_YU_WS_INHALER: "Soluk Cihazı",
  T_43_YU_WS_INHALER_D: "Soluk Cihazı",
  T_43_YU_WS_INITRADIUS_D: "Güvenli bölgenin başlangıç çapı",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "64 bitlik işaretli bir tamsayı",
  T_43_YU_WS_ISAPPLYSHADOW: "Gölge Uygular",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Alt Çarpışma",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Mevcut İfade Döngüsüdür",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Mevcut İfade animasyonunun döngüye alınıp alınmayacağı",
  T_43_YU_WS_ISSIDECOLLIDING: "Yan Çarpışmasıdır",
  T_43_YU_WS_ISSLIDING: "Kayıyor",
  T_43_YU_WS_ISTOPCOLLIDING: "Üst Çarpışması",
  T_43_YU_WS_ITEM331: "Fütüristik Cihaz A",
  T_43_YU_WS_ITEM332: "Parlayan Taş A",
  T_43_YU_WS_ITEM333: "Fütüristik Ekran A",
  T_43_YU_WS_ITEM334: "Fütüristik Konteyner A",
  T_43_YU_WS_ITEM335: "Fütüristik Konteyner A",
  T_43_YU_WS_ITEM336: "Taş Koltuk A",
  T_43_YU_WS_ITEM337: "Fütüristik Düğme A",
  T_43_YU_WS_ITEM338: "Fütüristik Boru A",
  T_43_YU_WS_ITEM339: "Metal Platform A",
  T_43_YU_WS_ITEM340: "Fütüristik Masa A",
  T_43_YU_WS_ITEM341: "Fütüristik Masa B",
  T_43_YU_WS_ITEM342: "Fütüristik Masa C",
  T_43_YU_WS_ITEM343: "Fütüristik Bilgisayar A",
  T_43_YU_WS_ITEM344: "Taş A",
  T_43_YU_WS_ITEM345: "Taş B",
  T_43_YU_WS_ITEM346: "Taş C",
  T_43_YU_WS_ITEM347: "Taş D",
  T_43_YU_WS_ITEM348: "Taş E",
  T_43_YU_WS_ITEM349: "Taş F",
  T_43_YU_WS_ITEM350: "Taş G",
  T_43_YU_WS_ITEM351: "Japon-Stili Perde A",
  T_43_YU_WS_ITEM352: "Japon-Stili Perde B",
  T_43_YU_WS_ITEM353: "Japon-Stili Perde C",
  T_43_YU_WS_ITEM354: "Japon-Stili Merdiven A",
  T_43_YU_WS_ITEM355: "Japon-Stili Çit A",
  T_43_YU_WS_ITEM356: "Japon-Stili Çit B",
  T_43_YU_WS_ITEM357: "Japon-Stili Çit C",
  T_43_YU_WS_ITEM358: "Japon-Stili Platform A",
  T_43_YU_WS_ITEM359: "Japon-Stili Duvar B",
  T_43_YU_WS_ITEM360: "Japon-Stili Kapı B",
  T_43_YU_WS_ITEM361: "Fütüristik Duvar D",
  T_43_YU_WS_ITEM362: "Fütüristik Duvar B",
  T_43_YU_WS_ITEM363: "Fütüristik Açılı Süpürgelik",
  T_43_YU_WS_LEFTCOLOR: "Sol Renk",
  T_43_YU_WS_LEFTCOLOR_D: "Sol taraf rengi",
  T_43_YU_WS_LEFTPLAYERARRAY: "Sol Oyuncu Dizini",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "Sol oyuncu dizisi",
  T_43_YU_WS_LEFTSCORE: "Sol Skor",
  T_43_YU_WS_LEFTSCORE_D: "Sol taraf skoru",
  T_43_YU_WS_LEFTSCOREAFTER: "Sonraki Sol Skor",
  T_43_YU_WS_LEFTSCOREAFTER_D: "Sol tarafın son skoru. Skor geçiş animasyonlarında kullanılır.",
  T_43_YU_WS_LEVELOBJECTID: "Seviye Nesnesi ID",
  T_43_YU_WS_LEVELOBJECTID_D: "Nesne türünü açıklar. Yüklemeden önce SceneEditPrefab yapılandırma tablosunun ayrıştırılmasını gerektirir.",
  T_43_YU_WS_LOCALPOSITION_D: "Yerel koordinat sistemindeki koordinatlar",
  T_43_YU_WS_LOCALPOSITION_D1: "Göreceli konum",
  T_43_YU_WS_LOCALPOSITION_D2: "Sağ alt bağlantıya göre konum",
  T_43_YU_WS_LOCALPOSITION_D3: "Bağlantı noktasına göre konum",
  T_43_YU_WS_LOCALROTATION_D: "Yerel koordinat sistemindeki dönüş açıları (X: sapma, Y: eğim ve Z: dönüş)",
  T_43_YU_WS_LOCALROTATIONQ_D: "Yerel koordinat sistemindeki kuaterniyon",
  T_43_YU_WS_LOCALSCALE_D: "Dünya koordinat sistemindeki ölçek boyutu",
  T_43_YU_WS_MASS: "Kütle",
  T_43_YU_WS_MATERIALS: "Materyaller",
  T_43_YU_WS_MATERIALS_D: "Render için kullanılan malzemelerin listesi",
  T_43_YU_WS_MAXSPEED: "Maks. Hız",
  T_43_YU_WS_MAXSPEED_D: "Azami hıza ulaşıldıktan sonra artık beygir gücü üretilmeyecektir ancak araç hızı sınırı aşabilir (örneğin yokuş aşağı inerken hızlanma nedeniyle).",
  T_43_YU_WS_MESHID: "Mesh ID",
  T_43_YU_WS_MESHID_D: "Mesh tipini açıklar",
  T_43_YU_WS_MESHID1: "Mesh ID",
  T_43_YU_WS_MESHID1_D: "Oluşturma için kullanılacak ağ",
  T_43_YU_WS_MINMOVEDISTANCE: "Min. Hareket Mesafesi",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Bu değerden daha kısa mesafeli hareket gerçekleştirilmeyecektir. Özel gereksinimler olmadığı sürece 0 olarak ayarlanması önerilir.",
  T_43_YU_WS_MODULE_AI: "Yapay Zeka",
  T_43_YU_WS_MODULE_AIRDROP: "Malzeme Desteği",
  T_43_YU_WS_MODULE_ANIMATION: "Animasyon",
  T_43_YU_WS_MODULE_AVATAR: "Avatar",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Temel Özellikler",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Davranış Ağacı",
  T_43_YU_WS_MODULE_BUFF: "Güçlendirme",
  T_43_YU_WS_MODULE_CAMERA: "Kamera",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Sohbet Kanalı",
  T_43_YU_WS_MODULE_CHECKPOINT: "Kontrol Noktası",
  T_43_YU_WS_MODULE_COLLECTION: "Koleksiyon",
  T_43_YU_WS_MODULE_COMBAT: "Savaş",
  T_43_YU_WS_MODULE_COMPONENT: "Bileşen",
  T_43_YU_WS_MODULE_CONVERT: "Dönüştür",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Oda Parametrelerini Özelleştir",
  T_43_YU_WS_MODULE_DATABASE: "Veri Deposu",
  T_43_YU_WS_MODULE_DYEING: "Boyama",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Dinamik NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "Ekonomi",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF Platformu",
  T_43_YU_WS_MODULE_FOOTBALL: "Futbol",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Kare Hızı Modu",
  T_43_YU_WS_MODULE_GAMERESULT: "Maç Sonucu",
  T_43_YU_WS_MODULE_GLOBAL: "Küresel",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Küresel Komut Dosyaları",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & Hile",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Giriş Sistemi",
  T_43_YU_WS_MODULE_ITEMS: "Eşyalar",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Seviye Nesnesi",
  T_43_YU_WS_MODULE_LIST: "Liste",
  T_43_YU_WS_MODULE_MAP: "Harita",
  T_43_YU_WS_MODULE_MATCHING: "Maç",
  T_43_YU_WS_MODULE_MATH: "Matematik",
  T_43_YU_WS_MODULE_MECHANISM: "Mekanizma Parametreleri",
  T_43_YU_WS_MODULE_MINIMAP: "Mini Harita",
  T_43_YU_WS_MODULE_MORPH: "Biçim",
  T_43_YU_WS_MODULE_OTHER: "Diğer",
  T_43_YU_WS_MODULE_PET: "Yoldaş",
  T_43_YU_WS_MODULE_PHYSICS: "Fizik",
  T_43_YU_WS_MODULE_PLAYABLE: "Oynanabilir",
  T_43_YU_WS_MODULE_PLAYER: "Oyuncu",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Oyuncu Komut Dosyaları",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Ön Ayarlı Karakter",
  T_43_YU_WS_MODULE_PROFILE: "Profil",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Özellik Formülü",
  T_43_YU_WS_MODULE_SAFEZONE: "Güvenli Bölge",
  T_43_YU_WS_MODULE_SCENE: "Sahne",
  T_43_YU_WS_MODULE_SKILL: "Yetenek",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Statik Komut Dosyaları",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Rapor",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD Kütüphanesi",
  T_43_YU_WS_MODULE_STRINGS: "Diziler",
  T_43_YU_WS_MODULE_TEAM: "Takım",
  T_43_YU_WS_MODULE_WORKFLOW: "İş Akışı",
  T_43_YU_WS_MONEYICON: "Para Simgesi",
  T_43_YU_WS_MONEYICON_D: "Para birimi simgesi",
  T_43_YU_WS_MONEYICONCOLOR: "Para Simgesi Rengi",
  T_43_YU_WS_MONEYICONCOLOR_D: "Para birimi simgesi rengi",
  T_43_YU_WS_MOVESAFEZONE_D: "Güvenli bölgeyi başlangıç konumundan bitiş konumuna sorunsuz bir şekilde taşır. Bölgenin dışındaki oyuncular belirli miktarda hasar alacaktır.",
  T_43_YU_WS_NEWVECTOR2: "Yeni Vector2",
  T_43_YU_WS_NEWVECTOR2_D: "Yeni bir 2B vektör alır",
  T_43_YU_WS_OFFSET_D: "Hedef varlığa göre dünya konumu dengesi",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "Oyuncu satın alma talebi karşılandığında",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "Bir oyuncu mağazadan satın alma konusunda yardım istediğinde",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Geçiş bileşeni durumu değiştiğinde tetiklenir",
  T_43_YU_WS_OPENSTATE: "Açık Durum",
  T_43_YU_WS_OPENSTATE_D: "Doğru olarak ayarlandığında görüntülenir, ayarlanmadığında gizlenir",
  T_43_YU_WS_PACEMAKER: "Ufuk Aşısı",
  T_43_YU_WS_PACEMAKER_D: "Ufuk Aşısı",
  T_43_YU_WS_PARAMS_D: "Parametrelerin listesi",
  T_43_YU_WS_PARENT_D: "Serileştirme sırasında kaydedilen varlık kimliği",
  T_43_YU_WS_PHYSICALCCT: "Fiziksel CCT",
  T_43_YU_WS_PHYSICALCCT_D: "Fiziksel efektlere sahip oynatıcı denetleyicisi",
  T_43_YU_WS_PLAYER_D: "Satın alan oyuncu",
  T_43_YU_WS_PLAYERDATAID: "Oyuncu Veri ID",
  T_43_YU_WS_PLAYERDATAID_D: "Karakter varlığı kimliğini özelleştir",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Oyuncu PhysX Poz Türü",
  T_43_YU_WS_POSITION: "Pozisyon",
  T_43_YU_WS_POSITION_D: "Dünya koordinat sistemindeki koordinatlar",
  T_43_YU_WS_POSITION_D1: "Dünya koordinat sistemindeki koordinatlar. Yalnızca 3B müzik için etkilidir.",
  T_43_YU_WS_PRESSEDSPRITE: "Sıkıştırılmış Resim",
  T_43_YU_WS_PRESSEDSPRITE_D: "Sıkıştırılmış resim",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Sıkıştırılmış Resim Türü",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "Sıkıştırılmış resim türü",
  T_43_YU_WS_PRETIME: "Ön zaman",
  T_43_YU_WS_RADIUS: "Çap",
  T_43_YU_WS_RANDOMRANGE_D: "Rastgele bir aralığa göre ayarlanan konumu düzeltin",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Satın Alma Türü Talep Et",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Mağazada satın alma talebi",
  T_43_YU_WS_REQUESTTYPE: "İstek Türü",
  T_43_YU_WS_REQUESTTYPE_D: "Mevcut HUD oynatıcısının talep ettiği hedefin türü",
  T_43_YU_WS_RESPLAYERUUID: "Önceden Ayarlanmış Oyuncu Türü",
  T_43_YU_WS_RESPLAYERUUID_D: "Oyuncu varlık kimliği",
  T_43_YU_WS_RESUUID: "Varlık UUID",
  T_43_YU_WS_RESUUID_D: "İşlenecek Toplu varlığın UUIDsini belirtir",
  T_43_YU_WS_RIGHTCOLOR: "Sağ Renk",
  T_43_YU_WS_RIGHTCOLOR_D: "Sağ taraf rengi",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Sağ Oyuncu Dizisi",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "Doğru oyuncu dizisi",
  T_43_YU_WS_RIGHTSCORE: "Sağ Skor",
  T_43_YU_WS_RIGHTSCORE_D: "Sağ taraf skoru",
  T_43_YU_WS_RIGHTSCOREAFTER: "Sonraki Sağ Skor",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "Sağ tarafın son puanı. Skor geçiş animasyonlarında kullanılır.",
  T_43_YU_WS_ROTATIONQ_D: "Dünya koordinat sistemindeki kuaterniyon",
  T_43_YU_WS_ROUNDINFOHUD: "Tur Bilgisi HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "Turun başında görüntülenen bilgi",
  T_43_YU_WS_SELECTEDCOLOR: "Seçilen Renk",
  T_43_YU_WS_SELECTEDCOLOR_D: "Seçilen resim rengi",
  T_43_YU_WS_SELECTEDSPRITE: "Seçilen Resim",
  T_43_YU_WS_SELECTEDSPRITE_D: "Seçilen resim",
  T_43_YU_WS_SELECTEDTYPE: "Seçilen Tür",
  T_43_YU_WS_SELECTEDTYPE_D: "Seçilen resim türü",
  T_43_YU_WS_SHADOWCOLOR: "Gölge Rengi",
  T_43_YU_WS_SHADOWOFFSET: "Gölge Offseti",
  T_43_YU_WS_SHOWTAG: "Etiketi Göster",
  T_43_YU_WS_SHOWTAG_D: "Takım/taraf işaretlerini göster",
  T_43_YU_WS_SHRINKDURATION_D: "Güvenli bölgenin küçülme süresi",
  T_43_YU_WS_SIMPLERENDER_D: "Yerleşik modellerle işleme için kullanılan köprü oluşturma bileşeni",
  T_43_YU_WS_SKINWIDTH: "Görünüm Genişliği",
  T_43_YU_WS_SKINWIDTH_D: "Karakterin sıkışmasını veya titremesini önlemek için kapsülün içine nüfuz etme derinliği",
  T_43_YU_WS_SLOPELIMIT: "Eğim Sınırı",
  T_43_YU_WS_SLOPELIMIT_D: "Bu açıyı aşan eğime yerleştirilen nesneler aşağıya doğru kayacaktır.",
  T_43_YU_WS_SPEED: "Hız",
  T_43_YU_WS_STARTDROPTIME_D: "Milisaniye cinsinden malzeme desteği varış süresi",
  T_43_YU_WS_STARTPOS_D: "Güvenli bölgenin başlangıç pozisyonu",
  T_43_YU_WS_STATICICONCOLORS: "Sabit Simge Renkleri",
  T_43_YU_WS_STATICICONCOLORS_D: "Cetvelde gösterilen simge renkleri",
  T_43_YU_WS_STATICICONS: "Statik Simgeler",
  T_43_YU_WS_STATICICONS_D: "Cetvelde gösterilen simgeler",
  T_43_YU_WS_STEPOFFSET: "Adım Ofseti",
  T_43_YU_WS_STEPOFFSET_D: "Yalnızca bu yüksekliği aşan engeller engelleme etkisine sahip olacaktır",
  T_43_YU_WS_SUBTITLE: "Altyazı",
  T_43_YU_WS_SUBTITLE_D: "Altyazı",
  T_43_YU_WS_TARGET: "Hedef",
  T_43_YU_WS_TARGET_D: "Görüntülenen hasar numarası için hedef varlık",
  T_43_YU_WS_TARGETICONCOLORS: "Hedef Simge Renkleri",
  T_43_YU_WS_TARGETICONCOLORS_D: "İşaretli hedef tarafından gösterilen simge renkleri",
  T_43_YU_WS_TARGETICONS: "Hedef Simgeleri",
  T_43_YU_WS_TARGETICONS_D: "İşaretli hedeflerin gösterdiği simgeler",
  T_43_YU_WS_TARGETPOS_D: "Güvenli bölgenin hedef bitiş pozisyonu",
  T_43_YU_WS_TEAM: "Takım",
  T_43_YU_WS_TEAM_D: "Oyundaki takım varlığı. Her takımın bir varlığı vardır.",
  T_43_YU_WS_TEAM_D1: "Ekipten satın alma konusunda yardım iste",
  T_43_YU_WS_TIMEOFSTAY_D: "Milisaniye cinsinden görüntüleme süresi",
  T_43_YU_WS_TITLE: "Unvan",
  T_43_YU_WS_TITLE_D: "Ana başlık",
  T_43_YU_WS_TRANSFORM_D: "Döndürme, ölçeklendirme ve üst-alt öğe kaydı",
  T_43_YU_WS_UNSELECTEDCOLOR: "Seçilmemiş Renk",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "Seçilmemiş resim rengi",
  T_43_YU_WS_UNSELECTEDSPRITE: "Seçilmemiş Resim",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "Seçilmemiş resim",
  T_43_YU_WS_UNSELECTEDTYPE: "Seçilmemiş Tür",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Seçilmemiş resim türü",
  T_43_YU_WS_USEPHYSICALCCT: "Fiziksel CCTyi kullanın",
  T_43_YU_WS_VALUE_D: "Gösterilen içerik",
  T_43_YU_WS_VECTOR2ADD: "Vektör2 Ekle",
  T_43_YU_WS_VECTOR2GETX: "Vector2 Xi Alın",
  T_43_YU_WS_VECTOR2GETY: "Vector2 Yyi Alın",
  T_43_YU_WS_VECTOR2SCALE: "Vektör2 Ölçeği",
  T_43_YU_WS_VECTOR2SETX: "Vektör2 Set X",
  T_43_YU_WS_VECTOR2SETY: "Vector2 Yyi ayarla",
  T_43_YU_WS_VECTOR2SUB: "Vektör2 Alt",
  T_43_YU_WS_VELOCITY: "Hız",
  T_43_YU_WS_VERTICALMAXANGLE: "Dikey Maks Açı",
  T_43_YU_WS_VERTICALMINANGLE: "Dikey Min. Açı",
  T_43_YU_WS_VISIBILITY_D: "Görünürlüğün ayarlanıp ayarlanamayacağını gösterir",
  T_43_YU_WS_VISIBLE_D: "Görünürlük ayarı. Görünmez olarak ayarlanırsa istemci hedefi oluşturmayı durdurur.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Fütüristik Duvar A",
  T_43_ZY_WS_ITEM320: "Fütüristik Duvar C",
  T_43_ZY_WS_ITEM321: "Fütüristik Pencere",
  T_43_ZY_WS_ITEM322: "Fütüristik Kapı",
  T_43_ZY_WS_ITEM323: "Fütüristik Dik Çatı",
  T_43_ZY_WS_ITEM324: "Fütüristik Dairesel Çatı",
  T_43_ZY_WS_ITEM325: "Fütüristik Süpürgelik",
  T_43_ZY_WS_ITEM326: "Fütüristik Dairesel Süpürgelik",
  T_43_ZY_WS_ITEM327: "Fütüristik Merdiven",
  T_43_ZY_WS_ITEM328: "Fütüristik Dekorasyon A",
  T_43_ZY_WS_ITEM329: "Fütüristik Bina A",
  T_43_ZY_WS_ITEM330: "Fütüristik Bina B",
  T_44_CJ_M_B_SPORT_TH: "Spor Forması (Alt)",
  T_44_CJ_M_H_SPORT_TH: "Spor Forması (Kafa)",
  T_44_CJ_M_S_SPORT_TH: "Spor Forması (Ayakkabı)",
  T_44_CJ_M_T_SPORT_TH: "Spor Forması (Üst)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Alev Saldırısı",
  T_44_H_USP45_CARNIVORE_N: "USP - Zehirli Diş",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Motosiklet - Gök Gürültüsü",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Minimum Oyuncuyla Başlamaya Zorla",
  T_44_JH_WS_HALFWAYKEY1: "Dolu Takımla Başlamaya Öncelik Ver",
  T_44_PD_PVE_DRAGON_NAME: "Mekanik Ejder",
  T_44_QL_GRENADE_DRAGON: "Ejder Flaş",
  T_44_QL_GRENADE_DRAGON_DES: "Çarpma anında art arda üç kez patlayacak yükseltilmiş bir Donuk Flaş",
  T_44_QL_JUMPSHOESX: "Ejderha Koşucusu",
  T_44_QL_JUMPSHOESX_DES: "Çift atlama sırasında havada hızlanmayı sağlayan bir çift özel atlama ayakkabısı",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Güvenli Bölge Kapanma Zamanı",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Güvenli Bölgenin kaybolduğu zaman. Güvenli Bölge Kapanma Süresi Güvenli Bölge Başlangıç Süresinden azsa Güvenli Bölge oluşturulmayacaktır.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Güvenli Bölge Rengi",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Hasar Aralığı",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Hasar aralığı",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Hasar Değeri",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "Tek bir durumda bölge dışındaki bir oyuncuya verilen hasar",
  T_44_SJ_WS_SAFEZONE_DESC: "A placeable out-of-zone object",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Bölge Dışı Son Yarıçapı",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "Bölge dışı alanın uç yarıçapı",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Güvenli Bölge Oyuncu Listesi",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Güvenli Bölgedeki oyuncuların listesini al",
  T_44_SJ_WS_SAFEZONE_NAME: "Bölge dışı alan",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Küçülme Süresi (sn)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Bölge daralmasının ne kadar süreceği",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Bölge Dışı Başlangıç Yarıçapı",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Bölge dışı alanın başlangıç yarıçapı",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Küçültme Süresi Başlangıcı",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Bölge daralmasının başladığı zaman",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Güvenli Bölge Başlama Zamanı",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Güvenli bölgenin maç içinde her turda göründüğü süre. Varsayılan 0dır.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLAZMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Etkinleştirilmiş Alfa",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Etkinleştirilmiş Alfa",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Aktif Yetenek Düğmesi HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Bir varlığa bileşen ekleyin. Yalnızca özel bileşenleri destekler. (Bir bileşen zaten mevcutsa tekrar eklenmeyecektir.)",
  T_44_XXJ_WS_ALLMEMBERS: "Tüm Üyeler",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Dışarıda Basılmasına İzin Ver",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Belirlenen alanın dışında tetiklemeye izin ver",
  T_44_XXJ_WS_ARROWIMAGE: "Ok Görseli",
  T_44_XXJ_WS_ARROWIMAGE_D: "Ok görseli",
  T_44_XXJ_WS_ARROWOFFSET: "Ok Ofseti",
  T_44_XXJ_WS_ARROWOFFSET_D: "Ok ofseti",
  T_44_XXJ_WS_ARROWSIZE: "Ok Boyutu",
  T_44_XXJ_WS_ARROWSIZE_D: "Ok boyutu",
  T_44_XXJ_WS_AUTOPLAY_D: "Oluşturulduğunda otomatik olarak oynat",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Arka Plan Görseli",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Temel resim",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Arka Plan Çapı",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Taban yarıçapı",
  T_44_XXJ_WS_BAGSKINID: "Çanta Görünümü ID",
  T_44_XXJ_WS_BAGSKINID_D: "Çanta görünümü ID",
  T_44_XXJ_WS_BONEPOSITION: "Kemik Konumu",
  T_44_XXJ_WS_BONEPOSITION_D: "Kemik düğümünün dünya koordinatları",
  T_44_XXJ_WS_CCTMOVE: "CCT Taşı",
  T_44_XXJ_WS_COLLIDER: "Çarpıştırıcı",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Çarpıştırıcı Koleksiyonu",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "Çarpışma şeklini tanımlamak için kullanılan bileşen",
  T_44_XXJ_WS_COLOR: "Renk",
  T_44_XXJ_WS_CONTENT: "İçerik",
  T_44_XXJ_WS_CONTENT_D: "Cüzdan içeriği para birimlerinin bir koleksiyonudur",
  T_44_XXJ_WS_CONTEXT_D: "Yazdırılacak içerik",
  T_44_XXJ_WS_CROSSHAIRSHUD: "Nişangah HUD",
  T_44_XXJ_WS_CURVE_D: "Eğri",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Yüzey dokusunun rengi",
  T_44_XXJ_WS_ENABLE: "Etkinleştir",
  T_44_XXJ_WS_ENTITY_D: "Varlık",
  T_44_XXJ_WS_GETBAGSKINID_D: "Oyuncu çanta görünümü yapılandırmasını al",
  T_44_XXJ_WS_GETFACTION_D: "Taraf al",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Kaldırılmamış yüklü sahneleri al",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Yerel oyuncuyu al",
  T_44_XXJ_WS_GROUPID: "Grup ID",
  T_44_XXJ_WS_GROUPID_D: "Dahili mantık için",
  T_44_XXJ_WS_HUDJOYSTICK: "HUD Kumanda Aracı",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Kumanda varlığı. Oyuncular HUDu HUD Editörü aracılığıyla düzenleyebilirler.",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD Dokunmatik Yüzey Aleti",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "Oyuncuların HUD düzenleyicide düzenleyebileceği HUD Dokunmatik Yüzey Aracı",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "Özel HUD veya HUD Aracı",
  T_44_XXJ_WS_ICON: "Simge",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Her Zaman İşareti Göster",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Pusuladaki işaretleri her zaman göster",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Etkinleştirilmemiş Alfa",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Etkinleştirilmemiş alfa",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "Çağrırken, gerçek parametrelerin sayısı resmi parametrelerin sayısıyla eşleşmiyor. Beklenen sayı {0}, gerçek sayı ise {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Dinamik Engel",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "NavMesh için dinamik bir engeldir",
  T_44_XXJ_WS_ISEND: "Son",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Sunucu Odaklıdır",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "Yanlışsa özel nesneler API tarafından kontrol edilemez.",
  T_44_XXJ_WS_ISSUC_D: "Yürütme sonucunu döndür",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Kumanda Sürükleme Yarıçapı",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Kumanda sürükleme yarıçapı",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Kumanda Görseli",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Kumanda görseli",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Kumanda Yarıçapı",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Kumanda çapı",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Karakter Yetenek ID Listesi",
  T_44_XXJ_WS_LOOPTYPE_D: "Döngü türü",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Yarıda Çıkma Yapılandırması",
  T_44_XXJ_WS_MOUNTABLE: "Hiyerarşik",
  T_44_XXJ_WS_MOUNTABLE_D: "Alt düğümleri bağlayabilen varlık",
  T_44_XXJ_WS_MOVEMENT: "Hareket",
  T_44_XXJ_WS_NAME_D: "İsim",
  T_44_XXJ_WS_NATURALCONST: "Doğal Sabit",
  T_44_XXJ_WS_NATURALCONST_D: "Gereksiz tanımları azaltmak için doğal sabitlerin listesi",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Simge animasyonunu oynat",
  T_44_XXJ_WS_OFFSET_D: "Varsayılan temel ofset",
  T_44_XXJ_WS_ONFIRE_D: "Oyuncu her ateş ettiğinde, yumruklarıyla saldırdığında veya yakın dövüş silahlarıyla saldırdığında olayı tetikler.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Oyuncu yüzüstü/çömelme durumundan ayağa kalktığında olayı tetikler",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Oyuncu ateş etme düğmesine dokunduğunda etkinlik tetiklenir",
  T_44_XXJ_WS_OPTION: "Seçenekler",
  T_44_XXJ_WS_PASSIVESKILLHUD: "Pasif Yetenek HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "Fiziksel Taşıyıcı",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Bu platformdaki oyuncular hareketi ve dönüşü otomatik olarak takip edecek",
  T_44_XXJ_WS_PHYSICALOBJECT: "Fiziksel Varlık",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Can apply force to it",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "Matematiksel sabit π (Pi)",
  T_44_XXJ_WS_PLAYERS: "Oyuncu Listesi",
  T_44_XXJ_WS_PLAYERS_D: "Oyuncu listesi",
  T_44_XXJ_WS_PLAYERSKILLID: "Karakter Yetenek ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "AvatarSkill.csvdeki karakter beceri kimliği",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "Oyuncu ayağa kalkmadan önceki önceki poz",
  T_44_XXJ_WS_PRINT: "Yazdır",
  T_44_XXJ_WS_PRINTERROR: "Yazdırma Hatası",
  T_44_XXJ_WS_PRINTERROR_D: "Hedef verileri konsola hata olarak yazdır",
  T_44_XXJ_WS_PRINTWARNING: "Yazdırma Uyarısı",
  T_44_XXJ_WS_PRINTWARNING_D: "Hedef verileri konsola uyarı olarak yazdır",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Oyuncu Görünümü Yapılandırmasına Öncelik Ver",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Maç dışı oyuncu görünümü yapılandırmasına öncelik ver",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Bir satırın hücrelerindeki içeriği sütun numarasına ve anahtara göre oku",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Oyuncu çanta görünümü yapılandırmasını temizle",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Bir varlıktan bir bileşeni kaldırın. Yalnızca özel bileşenleri destekler.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Oyuncu sırt çantası görünümü yapılandırmasını maç dışı yapılandırmaya sıfırlayın",
  T_44_XXJ_WS_SETBAGSKINID_D: "Oyuncu çanta görünümü yapılandırmasını belirle",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Transform, SkeletonPart, Player ve MountPoint bileşenlerini destekleyen varlık",
  T_44_XXJ_WS_SHOWBACKGROUND: "Arka Planı Göster",
  T_44_XXJ_WS_SKINID_D: "Çanta görünümü ID ve görünüm yapılandırması",
  T_44_XXJ_WS_SPEED_D: "Çalma hızı",
  T_44_XXJ_WS_TARGET: "Hedef",
  T_44_XXJ_WS_TARGET_D: "Hedef nesne",
  T_44_XXJ_WS_TITLE: "Başlık",
  T_44_XXJ_WS_TYPEID_D: "Bileşen türü ID. Yalnızca özel bileşenleri destekler.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Özel maç sonuçlarını yükle",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Tür uyumsuzluğu. Tablo içeriği okunamıyor.",
  T_44_XXJ_WS_X_D: "X ekseni koordinatı",
  T_44_XXJ_WS_Y_D: "Y ekseni koordinatı",
  T_44_XYL_WS_CTZSAFEZONE: "Özel Güvenli Bölge",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Ayarlanan konumlara ve özelliklere göre Güvenli Bölgenin başlangıç ve bitiş noktasını oluşturur",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Yarım Küre Kabuk",
  T_44_XYL_WS_QUARTERCYLINDER: "Çeyrek Silindir",
  T_44_XYL_WS_SQUAREPYRAMID: "Kare Piramit",
  T_44_XYL_WS_TORUS: "Simit",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Üçgen Piramit",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Oyun Olay Günlüğü Haritası Ekle",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Kullanıcı Olay Günlüğü Ekle",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "UX veri analizi için kullanılan özel eşleşme olay günlüğü",
  T_44_YU_WS_ITEM366: "Askeri Duvar A",
  T_44_YU_WS_ITEM367: "Askeri Duvar B",
  T_44_YU_WS_ITEM368: "Askeri Duvar C",
  T_44_YU_WS_ITEM369: "Askeri Duvar D",
  T_44_YU_WS_ITEM370: "Askeri Pencere A",
  T_44_YU_WS_ITEM371: "Askeri Pencere B",
  T_44_YU_WS_ITEM372: "Askeri Pencere C",
  T_44_YU_WS_ITEM373: "Askeri Kapı A",
  T_44_YU_WS_ITEM374: "Asker Kapı B",
  T_44_YU_WS_ITEM375: "Askeri Dik Çatı A",
  T_44_YU_WS_ITEM376: "Askeri Dik Çatı B",
  T_44_YU_WS_ITEM377: "Askeri Merdiven A",
  T_44_YU_WS_ITEM378: "Askeri Merdiven B",
  T_44_YU_WS_ITEM379: "Askeri Sütun A",
  T_44_YU_WS_ITEM380: "Askeri Tırabzan A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Özelleştir",
  T_45_CJ_TREATMENTGUN_Y_N: "Şifa Tabancası-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Şampiyon Adımları",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "İncele",
  T_45_HL_Moderation_fail_1: "Ne yazık ki gönderdiğin proje incelemeyi geçemedi.",
  T_45_HL_Moderation_fail_2: "içeren",
  T_45_HL_Moderation_fail_3: "Nedenler:",
  T_45_HL_Moderation_fail_Location_1: "Oyun İçeriği",
  T_45_HL_Moderation_fail_reason_1: "Toksik İçerik",
  T_45_HL_Moderation_fail_reason_10: "Topluluk Kurallarının İhlali",
  T_45_HL_Moderation_fail_reason_11: "Oyun İçi Ekonomiler ve Sanal Mülkiyet İhlalleri Üzerindeki Olumsuz Etkiler",
  T_45_HL_Moderation_fail_reason_2: "Uygunsuz İçerik",
  T_45_HL_Moderation_fail_reason_3: "Siyasi Hassasiyet",
  T_45_HL_Moderation_fail_reason_4: "Yanlış Bilgi",
  T_45_HL_Moderation_fail_reason_5: "Telif Hakkı İhlali",
  T_45_HL_Moderation_fail_reason_6: "Gizlilik İhlali",
  T_45_HL_Moderation_fail_reason_7: "Güvenlik Endişeleri",
  T_45_HL_Moderation_fail_reason_8: "Nefret Söylemi",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Diğer Konular",
  T_45_JH_WS_CLEMPTYOBJECT: "Nesne Grubu",
  T_45_JH_WS_PETSWITCH1: "Maçta yoldaşların görünüp görünmeyeceği",
  T_45_QL_CSFPP_DES: "Bu özel EÇ modunda birinci şahıs bakış açısıyla tüm rakipleri ortadan kaldır!",
  T_45_QL_CSFPP_NAME: "Ekip Çarpışması: FFP",
  T_45_QL_CSFPP_RANKNAME: "Birinci Şahıs",
  T_45_SJ_WS_REVIEW_23: "Oyun İçeriği",
  T_45_SJ_WS_REVIEW_24: "{0}, {1}'i içeriyor",
  T_45_SJ_WS_REVIEW_25: "{0} {1}, {2}'yi içeriyor",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Detayları görmek için dokun >>[-]",
  T_45_SJ_WS_REVIEW_27: "Onaylanmadı",
  T_45_SJ_WS_REVIEW_28: "Geri Bildirimi İncele",
  T_45_SJ_WS_REVIEW_29: "İçerik {0} ihlal içeriyor",
  T_45_SJ_WS_REVIEW_31: "Onaylanmadı",
  T_45_SJ_WS_REVIEW_32: "Sunucu istisnaları nedeniyle inceleme başarısız oldu",
  T_45_SJ_WS_REVIEW_TITLE: "İhlal Ayrıntıları",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Atlamayı tetikler (engellerin üzerinden atlamak)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Atlama Mesafesi",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Atlama mesafesini değiştirir",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Atlama Yüksekliği",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Atlama sırasında yukarı ve aşağı hareket yüksekliğini kontrol eder",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Atlama Tetikleyicisi",
  T_45_TYC_CL_TEMPLATE_WS: `Oyuncuların tüm rakip takımları kaotik bir savaşta eleyerek kazandığı bir eleme modudur.
Oyun kurallarını ve oyun parametrelerini istediğin gibi ayarlayabilirsin.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Gök Delici",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = otomatik saldırı, 1 = savunma saldırısı, 2 = saldırma",
  T_45_XXJ_WS_ADDFRIEND: "Arkadaş Ekle",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Otomatik",
  T_45_XXJ_WS_BASEDATA: "Temel Veri",
  T_45_XXJ_WS_BOTH: "İkisi De",
  T_45_XXJ_WS_BYHIERARCHY: "Hiyerarşiye göre",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "By Priority High to Low",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "Önceliğe Göre Düşükten Yükseğe",
  T_45_XXJ_WS_CAMERA: "Kamera",
  T_45_XXJ_WS_CAMERATYPE: "Kamera Türü",
  T_45_XXJ_WS_CENTERINVISIBLE: "Merkez Görünmez",
  T_45_XXJ_WS_CLIENT: "İstemci",
  T_45_XXJ_WS_COLLIDERID: "Çarpışan ID",
  T_45_XXJ_WS_COLLIDERID_D: "Çarpışan ID",
  T_45_XXJ_WS_COMPONENT: "Bileşen",
  T_45_XXJ_WS_CURRENTCAMERA: "Mevcut Kamera",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Özel İtme Gücü",
  T_45_XXJ_WS_DOUBLE: "Çift",
  T_45_XXJ_WS_DUMP: "At",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Havada Hareketi Etkinleştir",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Yerçekimiyle Döndürmeyi Etkinleştir",
  T_45_XXJ_WS_ENUM: "Sıralama",
  T_45_XXJ_WS_EVENT: "Etkinlik",
  T_45_XXJ_WS_FILLAMOUNT: "Doldurma Miktarı",
  T_45_XXJ_WS_FILLDIR: "Doldurma Yönü",
  T_45_XXJ_WS_FIRETYPE: "Ateş Türü",
  T_45_XXJ_WS_FIRETYPE_D: "Ateş etme türü",
  T_45_XXJ_WS_FIXEDDELTATIME: "Sabit Delta Zamanı",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "Kare güncellemeleri için milisaniye cinsinden sabit zaman aralığı",
  T_45_XXJ_WS_FORWARD: "İleri",
  T_45_XXJ_WS_FORWARD_D: "Yerel koordinat sisteminde z ekseninin yönü",
  T_45_XXJ_WS_FUNCTIONTYPE: "Fonksiyon Türü",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "Fonksiyon Türü",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "Yerel oyuncunun nişan alma yönü",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Yerel zaman damgasını al",
  T_45_XXJ_WS_GRADIENT: "Gradyan",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Degrade Alt",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Degrade Alt Alfa",
  T_45_XXJ_WS_GRADIENTTOP: "Degrade Üst",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Degrade Üst Alfa",
  T_45_XXJ_WS_HITPOSITION_D: "Mermilerin vurduğu hedefin dünya konumu",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "UI Sosyal Tuş Aracı",
  T_45_XXJ_WS_INVERTFILL: "Dolguyu Ters Çevir",
  T_45_XXJ_WS_ISGROUNDED: "Çakılı",
  T_45_XXJ_WS_ISSILENCE: "Sessiz",
  T_45_XXJ_WS_ISSILENCE_D: "Susturulmuş olup olmadığı",
  T_45_XXJ_WS_ISSINGLESHOT: "Tek Atış",
  T_45_XXJ_WS_ISSINGLESHOT_D: "Tek atış olup olmadığı",
  T_45_XXJ_WS_JUMPHEIGHT: "Atlama Yüksekliği",
  T_45_XXJ_WS_JUMPHEIGHT_D: "Zıplama yüksekliği",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Düzen Sıralama Türü",
  T_45_XXJ_WS_LIGHT_D: "Işıklar",
  T_45_XXJ_WS_LOCAL: "Yerel",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Maks. Atlama Sayısı",
  T_45_XXJ_WS_MODULE: "Modül",
  T_45_XXJ_WS_NONE: "Hiçbiri",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Varlık hasar vermeden önce her defasında komutu yürüt",
  T_45_XXJ_WS_ONDISABLE_D: "Varlık devre dışı bırakıldığında çalıştır",
  T_45_XXJ_WS_ONEACHLOOP_D: "Oynanabilir olan her döngülendiğinde yürütülür. Ses Efekti ve Özel Efekt gibi varlıklar için yalnızca istemci tarafında etkilidir.",
  T_45_XXJ_WS_ONENABLE_D: "Varlık etkinleştirildiğinde çalıştır",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "Sabit 30 FPS hızında bir kareye girerken",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Oyuncu bir arkadaş eklediğinde veya sildiğinde istemci olayını tetikle",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Çağrılan API nedeniyle oyun duraklatıldığında etkinliği tetikle",
  T_45_XXJ_WS_ONGAMERESUME_D: "Çağrılan API nedeniyle oyun devam ettiğinde olayı tetikle",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "Oyuncu koşmayı bıraktığında",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "Oyuncu sörf yapmayı bıraktığında",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "Oyuncu sörf yaparken",
  T_45_XXJ_WS_PHYSICALLAYER_D: "0 ila 31 aralığındaki özel fiziksel katman",
  T_45_XXJ_WS_PLATFORMTYPE: "Platform Türü",
  T_45_XXJ_WS_PLATFORMTYPE_D: "Platform türü",
  T_45_XXJ_WS_PLAYER: "Oyuncu",
  T_45_XXJ_WS_PLAYERCCT: "Oyuncu CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "Fiziksel efektlere sahip ve yalnızca Free Fire karakterleri için kullanılan bir karakter denetleyicisi",
  T_45_XXJ_WS_PRIORITY: "Öncelik",
  T_45_XXJ_WS_REMAINMULTINUM: "Kalan Atlama Sayısı",
  T_45_XXJ_WS_REPORT: "Bildir",
  T_45_XXJ_WS_RIGHT: "Sağ",
  T_45_XXJ_WS_RIGHT_D: "Yerel koordinat sisteminde x ekseninin yönü",
  T_45_XXJ_WS_SERVER: "Sunucu",
  T_45_XXJ_WS_SINGLE: "Tek",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Sosyal Tuş Tarzı Türü",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "Sosyal düğme tarzı",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Sosyal Tuş Türü",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "Sosyal düğme tarzı",
  T_45_XXJ_WS_SORTTYPE_D: "Sıralama türleri: sıfır olmayan artan, azalan ve artan",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Nişan Alırken Hareket Hızı",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "Aşağıya doğru nişan alırken hareket hızı",
  T_45_XXJ_WS_STRINGORLOCSTRING: "Dizi veya Yerelleştirilmiş Dizi",
  T_45_XXJ_WS_TRIPLE: "Üçlü",
  T_45_XXJ_WS_UP: "Yukarı",
  T_45_XXJ_WS_UP_D: "Yerel koordinat sisteminde y ekseninin yönü",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Özel İtme Gücü Kullan",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Rastgele bir araç çağırmak için belirtilen alana bir işaret fişeği fırlat",
  T_45_ZD_VEHICLEDROP_R_NAME: "Gizemli Araç",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Oynama Süresi",
  T_46_HJ_WS_SHAREBY: "{0} tarafından",
  T_46_HJ_WS_SHAREGAMEMODE: "Oyun Modu",
  T_46_HJ_WS_SHARETEAM: "Takım",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "Çalışkan Öğrenci (Alt)",
  T_46_HX_H_SCHOOL_VN: "Çalışkan Öğrenci (Kafa)",
  T_46_HX_S_SCHOOL_VN: "Çalışkan Öğrenci (Ayakkabı)",
  T_46_HX_T_SCHOOL_VN: "Çalışkan Öğrenci (Üst)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Öğretici",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Diğerleri",
  T_46_XXJ_WS_ACTUALPOSITION: "Asıl Pozisyon",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Görüş hattının ötesinde AOI senkronizasyonuyla izlenecek nesneyi ekleyin",
  T_46_XXJ_WS_APPEARANCE: "Görünüm",
  T_46_XXJ_WS_APPEARANCERES: "Görünüm Kaynağı",
  T_46_XXJ_WS_BECOME: "Etkinleştir",
  T_46_XXJ_WS_BRAKETORQUE_D: "Fren/Geri vites kullanıldığında araca verilen beygir gücü",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Kamera Rotasyon Açısı Kısıtlama Türü",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Hedefin tüm denetlenen nesnelerini temizle",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "Hasar hesaplaması için kullanılan maksimum çarpışma hasarı",
  T_46_XXJ_WS_CRASHMAXSPEED: "Maks. Çarpışma Hızı",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Çarpışma hasarı hesaplaması için kullanılır. Bu hız aşıldığında daha fazla hasar eklenmez.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Çarpışma Kütle Faktörü",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "Çarpışma hasarının hesaplanmasında hasar formülünde kullanılan bir parametre",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "Hasar hesaplama",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Veri yazma ve okuma deposu limiti aşıldı",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Parametre istisnası",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Veri depolama zaman aşımı. Şu anda esas olarak okuma ve yazma için geçerli.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Görünümü Düzenle",
  T_46_XXJ_WS_ENDVALUE_D: "Hedef değer",
  T_46_XXJ_WS_ENGINETORQUE_D: "Gaz pedalı kullanıldığında araca verilen beygir gücü",
  T_46_XXJ_WS_ERRORCODE_D: "Hata kodu sıralaması",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Euler Açısı Vector3'e",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Euler açısını 3 boyutlu vektöre dönüştürün",
  T_46_XXJ_WS_EXPIRE: "Bitiş",
  T_46_XXJ_WS_FEMALEAVATAR: "Kadın Karakter",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Üyelik Bitişi Tarihi Al",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "Gözlemci bir nesneyi izleyip izlemediği",
  T_46_XXJ_WS_HELICOPTER: "Gök Delici",
  T_46_XXJ_WS_HELICOPTER_D: "Bir tür uçan araç",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "Yüksek Hızlı Direksiyon Kısıtlaması",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "Yüksek hızdayken maksimum direksiyon açısı",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "Yüksek Hızlı Direksiyon Açısı Hızda",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "Maksimum yüksek hızlı direksiyon açısı için hız eşiği",
  T_46_XXJ_WS_IDLE: "Boşta Animasyonu",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Rölanti Fren Girişi",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "Aracınızı kullanmadığınız zamanlarda (Rölanti Fren Girişi) x (Fren Torku) oranında yavaşlat.",
  T_46_XXJ_WS_INTTOFLOAT: "Int'den Float'a",
  T_46_XXJ_WS_INTTOFLOAT_D: "Bir tam sayıyı kayan noktalı sayıya dönüştürün",
  T_46_XXJ_WS_ISPREMIUM: "Üyelik",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "Veri tabanındaki liderlik tablosu ismi",
  T_46_XXJ_WS_MALEAVATAR: "Erkek Karakter",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "Yapay Zeka Kişisi",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "Yeni UMA Görünümü",
  T_46_XXJ_WS_NONE_D: "Hata yok",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "NPC nesne",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "İpuçları: İnsanoid NPC'ler genellikle 1,4 m yüksekliğinde ve 0,25 m yarıçapında bir kapsül içeren bir çarpışma modeline sahiptir. Yoldaş NPC'ler genellikle 1 m yüksekliğinde ve 0,4 m yarıçapında bir kapsül içeren bir çarpışma modeline sahiptir.",
  T_46_XXJ_WS_OBSERVER_D: "Nesneleri denetleyen gözlemci",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "Üretim Diyarı Üyeliğine Girildiğinde",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "Üretim Diyarı Üyeliğinden Çıkıldığında",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Üretim Diyarı Üyeliğini Aç",
  T_46_XXJ_WS_PERSONA: "Şahıs",
  T_46_XXJ_WS_PERSONACENTER: "Şahıs Merkezi",
  T_46_XXJ_WS_PET: "Yoldaş",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Oyuncu veya Dönüşüm",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "Oyuncu ve Dönüşüm varlığı için bir takma ad",
  T_46_XXJ_WS_PREMIUM: "Üyelik",
  T_46_XXJ_WS_PREMIUMSTATUS: "Üyelik Durumu",
  T_46_XXJ_WS_PROXYOBSERVER: "Proxy Gözlemcisi",
  T_46_XXJ_WS_PROXYOBSERVER_D: "Proxy gözlemcisi",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "İzlenen nesneyi kaldırın ve AOI senkronizasyonunu görüş hattının ötesinde iptal edin",
  T_46_XXJ_WS_RENEWAL: "Yenile",
  T_46_XXJ_WS_ROTATEVECTOR: "Dönüş Vektörü",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Bir vektörü kuaterniyonlara göre döndürün",
  T_46_XXJ_WS_SKIN: "Teçhizat",
  T_46_XXJ_WS_STARTVALUE_D: "Kaynak değeri",
  T_46_XXJ_WS_STATUS: "Durum",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Kullanıcının proxy gözlemcisini değiştir",
  T_46_XXJ_WS_TARGET_D: "Denetlenen hedef",
  T_46_XXJ_WS_USER_D: "Kullanıcı",
  T_46_XXJ_WS_VALUE: "Değer",
  T_46_XXJ_WS_VALUE_D: "Vektör",
  T_46_XYL_WS_CTZSAFEZONEEND: "Güvenli Bölge Bitiş Noktası",
  T_46_XYL_WS_RESOURCETYPE1: "Temel Yapılar",
  T_46_XYL_WS_RESOURCETYPE1_1: "Geometrik",
  T_46_XYL_WS_RESOURCETYPE1_2: "Ses ve Görüntü",
  T_46_XYL_WS_RESOURCETYPE2: "Sahne Eşyaları",
  T_46_XYL_WS_RESOURCETYPE2_2: "Savaş Malzemeleri",
  T_46_XYL_WS_RESOURCETYPE3: "Doğa",
  T_46_XYL_WS_RESOURCETYPE4: "Modüler Bileşen",
  T_46_XYL_WS_TYPEOTHERPROP: "Çeşitli",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Konteynerler ve Kutular",
  T_47_CJ_FOREGRIP_SOFT_N: "Hafif Ön Kabza",
  T_47_CJ_MAGEZINE_FAST_N: "Hızlı Şarjör",
  T_47_CJ_STOCK_FAST_N: "Performans Kabzası",
  T_47_GT_WS_USERMANUAL: "Kullanıcı El Kitabı",
  T_47_HJ_WS_VFX_FOG: "Sis VFX",
  T_47_HJ_WS_VFX_LIGHTING: "IAydınlatma VFX",
  T_47_HJ_WS_VFX_TRAILING: "İzleme VFX",
  T_47_HL_CL_CREATOR_LABEL1: "Topluluk Yeteneği",
  T_47_HL_CL_MAP_LABEL1: "Topluluk Yetenekleri tarafından Seçilmiş İşler",
  T_47_JH_WS_MODERATION_REASON12: "Kumarla İlgili",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "NARUTO SHIPPUDEN iş birliği",
  T_47_SD_RES_MATERIAL: "Malzeme dosyası",
  T_47_SD_RES_MESH: "File",
  T_47_SD_WS_MAPTAG_AI: "Yapay Zeka ile Harita Oluştur",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "Bu özel bıçak atıldığında hedefine saplanır ve kısa bir süre sonra patlayarak yanma hasarı verir.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Ateşli Ninja Bıçağı",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "Bu özel bıçak atıldığında hedefine saplanır ve kısa bir süre sonra yıldırım çarpması tetikleyerek hedefi felç eder.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Şimşek Ninja Bıçağı",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "Bu özel bıçak atıldığında hedefine saplanır ve kısa bir süre sonra bir fırtına başlatarak hedefi yavaşlatıp merkezine doğru çeker.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Rüzgar Ninja Bıçağı",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "Orta ve uzun menzilli savaşlar için uygun bir ninja yıldızı. Tek atışta hızlı bir şekilde bir parça fırlatılır ve büyük miktarda hasar verir.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Ağır Ninja Yıldızı",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "Yakın ve orta menzilli savaşlar için uygun, iki saldırı moduna sahip bir ninja yıldızı. Tek atışta üç parça fırlatılır ve küçük miktarda hasar verir.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Hafif Ninja Yıldızı",
  T_47_XXJ_WS_ACTION: "Hareket",
  T_47_XXJ_WS_AOISETTING: "AOI Seçenekleri",
  T_47_XXJ_WS_BAGSKINTYPE: "Çanta Görünüm Türü",
  T_47_XXJ_WS_CLEARMEMORY: "Hafızayı Temizle",
  T_47_XXJ_WS_CLNPC: "Gelişmiş NPC",
  T_47_XXJ_WS_CLOTHTYPE: "Kıyafet Görünüm Türü",
  T_47_XXJ_WS_COMMON_ERROR: "Yaygın Hata",
  T_47_XXJ_WS_CONTENT: "İçerik",
  T_47_XXJ_WS_CREATERANDOMSEED: "Rastgele bir Tohum Oluştur",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Geçen Sürenin Yüzdesi",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Sis Özelliğini Aç",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Hafif Rotasyon Özelliğini Aç",
  T_47_XXJ_WS_ERRORCODE: "Hata Kodu",
  T_47_XXJ_WS_EXPONENTIAL: "Üstel",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Üstel Karesi",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Oda oluşturulamadı: geçerli Kişi ID'si yok",
  T_47_XXJ_WS_FOG: "Sis",
  T_47_XXJ_WS_FOGDENSITY: "Sis Yoğunluğu",
  T_47_XXJ_WS_FOGENDDISTANCE: "Sis Bitiş Mesafesi",
  T_47_XXJ_WS_FOGMODE: "Sis Modu",
  T_47_XXJ_WS_FOGMODETYPE: "Sis Modu Türü",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Sis Başlangıç Mesafesi",
  T_47_XXJ_WS_HEIGHTSCALE: "Yükseklik Ölceği",
  T_47_XXJ_WS_ISVISIBLE: "Görünür",
  T_47_XXJ_WS_JOINNEWTEAM: "Yeni Takıma Katıl",
  T_47_XXJ_WS_JOINTEAM: "Takıma Katıl",
  T_47_XXJ_WS_LIGHTROTATE: "Hafif Rotasyon",
  T_47_XXJ_WS_LINEAR: "Doğrusal",
  T_47_XXJ_WS_LLMCHATHUD: "Kişi UI Sohbeti",
  T_47_XXJ_WS_NEWTEAM: "Yeni Takım",
  T_47_XXJ_WS_NEXT: "Sonraki",
  T_47_XXJ_WS_NPC_TIP: "NPC'nin görünüşünü düzenleyebilir, NPC'ye animasyon oynatabilirsin",
  T_47_XXJ_WS_OBSERVERS: "Gözlemciler",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "UI Kişi Sohbeti ile Oyuncu'ya Mesaj At",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "Üyelik Durumu Değişti",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "Kişiden Hareket Al",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "Kişiden İçerik Al",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "Kişiden Almayı Bitir",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "Kişiden Durum Al",
  T_47_XXJ_WS_PARTICLESID: "Parçacık ID",
  T_47_XXJ_WS_PERSONAAVATAR: "Kişi Avatarı",
  T_47_XXJ_WS_PERSONAID: "Kişi ID",
  T_47_XXJ_WS_PERSONANICKNAME: "Kişi Kullanıcı Adı",
  T_47_XXJ_WS_PLAYERORNPC: "Oyuncu veya NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Üyelik kapalı.",
  T_47_XXJ_WS_RANDOM: "Rastgele",
  T_47_XXJ_WS_SEED: "Tohum",
  T_47_XXJ_WS_SENDER: "Gönderen",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Set Kişi Gözlemcisi",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Oyuncu Maçın Yarısında Çıkabilir",
  T_47_XXJ_WS_SHOULDREPLY: "Cevap Vermeli",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Sistem Cevabını Görüntüle",
  T_47_XXJ_WS_SPOTANGLE: "Nokta Açısı",
  T_47_XXJ_WS_SPOTLIGHT: "Sahne Işığı",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Kişiye bir Sistem Mesajı Gönder",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Sistem Mesajlarını Kişiye Aktar",
  T_47_XXJ_WS_TARGETTEAM: "Hedef Takım",
  T_47_XXJ_WS_THISENTITY: "Bu Varlık",
  T_47_XXJ_WS_USERAVATAR: "Kullanıcı Avatarı",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Kişiye bir Kullanıcı Mesajı Gönder",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Kullanıcı Mesajlarını Kişiye Aktar",
  T_47_XXJ_WS_USERNICKNAME: "Kullanıcı Adı",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Araç Görünüm Türü",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Silah Görünüm Türü",
  T_47_XYL_NB_UGC_EFFECT001: "Rasengan VFX",
  T_47_XYL_NB_UGC_EFFECT002: "Chidori VFX",
  T_47_XYL_NB_UGC_EFFECT003: "Kiraz Çiçeği Vuruşu VFX",
  T_47_XYL_NB_UGC_EFFECT004: "Ateş Topu Tekniği VFX",
  T_47_XYL_NB_UGC_EFFECT005: "Su Ejderi Tekniği VFX",
  T_47_XYL_NB_UGC_EFFECT006: "Büyük Darbe VFX",
  T_47_XYL_NB_UGC_EFFECT007: "Kuyruklu Canavar Bombası VFX",
  T_47_XYL_NB_UGC_EFFECT008: "Yeniden Canlandırma Lanetli İşaret VFX",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Varlık Mağazası",
  T_47_XYL_UGC_DONKEYCART: "Eşek Arabası",
  T_47_XYL_UGC_SPOTLIGHT: "Sahne Işığı",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Sahne Işığı Açısı",
  T_48_H_EMOTE_WATERFEST25_N: "Hızlı Adımlar",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Motosiklet - Deniz Köpüğü",
  T_48_HJ_AC_STATENOTEXIST: "Animasyon denetleyicisinde {0} durumu mevcut değil",
  T_48_HL_CODESCRIPT: "Kod Scripti",
  T_48_HL_GLOBAL_VAR: "Küresel Değişken Adı",
  T_48_HL_GRAPH: "Engelle",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Liderlik Tablosu",
  T_48_HL_LOCAL_VAR: "Yerel Değişken İsmi",
  T_48_HL_LOCALIZATION: "Yerelleştirme Adı",
  T_48_HL_OPEN_ATTRIBUTES: "Açık Özellik Adı",
  T_48_HX_A_WATERFEST25: "Deniz Köpüğü (Maske)",
  T_48_HX_B_WATERFEST25: "Deniz Köpüğü (Alt)",
  T_48_HX_F_B_BLACKDRESS: "Karşıt Madde (Alt)",
  T_48_HX_F_H_BLACKDRESS: "Karşıt Madde (Başlık)",
  T_48_HX_F_HA_BLACKDRESS: "Karşıt Madde (Yüz Boyası)",
  T_48_HX_F_S_BLACKDRESS: "Karşıt Madde (Ayakkabı)",
  T_48_HX_F_T_BLACKDRESS: "Karşıt Madde (Yüz)",
  T_48_HX_H_WATERFEST25: "Deniz Köpüğü (Başlık)",
  T_48_HX_HA_WATERFEST25: "Deniz Köpüğü (Yüz Boyası)",
  T_48_HX_M_A_BLACKDRESS: "Karanlık Madde (Maske)",
  T_48_HX_M_B_BLACKDRESS: "Karanlık Madde (Alt)",
  T_48_HX_M_H_BLACKDRESS: "Karanlık Madde (Başlık)",
  T_48_HX_M_HA_BLACKDRESS: "Karanlık Madde (Yüz Boyası)",
  T_48_HX_M_S_BLACKDRESS: "Karanlık Madde (Ayakkabı)",
  T_48_HX_M_T_BLACKDRESS: "Karanlık Madde (Üst)",
  T_48_HX_S_WATERFEST25: "Deniz Köpüğü (Ayakkabı)",
  T_48_HX_T_WATERFEST25: "Deniz Köpüğü (Üst)",
  T_48_JH_WS_STRINGDESC: 'Bir paragraf metin veya diğer dizeleri gir. Bazı araçlar zengin metin gösterebilir. Aşağıdaki formatı kullanarak zengin metinle metne renk ekle: [#XXXXXX] metin metin [-]. "#XXXXXX", göstermek istediğin rengi ifade eder. İlgili aracın metin renginin beyaz olarak ayarlanmış olması gerektiğini lütfen unutma.',
  T_48_M_WS_P_ICON: "Avatar",
  T_48_META_API_10001: "Varlığı ID üzerinden bul",
  T_48_META_API_10001_P0: "Varlık ID",
  T_48_META_API_1098: "Veritabanı Sayfası Değerlerini Toplu Oku",
  T_48_META_API_1098_D: "Belirli bir veritabanı sayfasından, benzersiz oyuncu kimlikleri ile anahtarların birbirine denk geldiği veri girişlerini topluca oku.",
  T_48_META_API_1098_P1: "Hesap ID'leri",
  T_48_META_API_1098_P1_D: "Anahtar listesindeki aynı indeksteki anahtarlara karşılık gelen verileri okuyan benzersiz oyuncu kimlikleri listesi.",
  T_48_META_API_1098_P2: "Anahtarlar",
  T_48_META_API_1098_P2_D: "ID listesindeki benzersiz oyuncu kimliklerine karşılık gelen verileri okuyan anahtarlar listesi.",
  T_48_META_API_1098_P5: "Durum Kodları",
  T_48_META_API_1098_P5_D: "Durum kodu listesi",
  T_48_META_API_1105: "Başlangıç Konusunu Bildir",
  T_48_META_API_1105_D: "Tetikleyen oyuncu için belirtilen olay örgüsünü oynatmaya başla",
  T_48_META_API_1105_P1_D: "Konu ID",
  T_48_META_API_1108: "Yerel Dili Al",
  T_48_META_API_1500_P0: "Vektör",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Vücut Parçası Ağırlığını Belirle",
  T_48_META_API_3300_D: "Hedef vücut parçasının ağırlığını, diğer düşük öncelikli animasyonlarla karıştırırken ayarla",
  T_48_META_API_3300_P0_D: "Vücut parçasının ait olduğu eklenebilir animasyon denetleyicisi parçacığı",
  T_48_META_API_3300_P1: "Vücut Parçası Adı",
  T_48_META_API_3300_P1_D: "Vucüt parçası ismi",
  T_48_META_API_3300_P2: "Ağırlık",
  T_48_META_API_3300_P2_D: "Daha düşük öncelikli animasyonlarla karışım derecesini temsil eden, [0, 1] değer aralığında bir ağırlık.",
  T_48_META_API_3315: "Karakter Animasyon Klibi Geçersiz Kılma Oynat",
  T_48_META_API_3315_D: "Oyunun varsayılan animasyonunu geçersiz kılma seçeneğiyle bir karakter animasyon klibi oynat",
  T_48_META_API_3315_P3: "Oynanış Kontrolünü Geçersiz Kıl",
  T_48_META_API_3315_P3_D: "Oyunun varsayılan animasyonunun geçersiz kılınıp kılınmayacağı",
  T_48_META_API_3316: "Animasyonu Durdur",
  T_48_META_API_3316_D: "Belirtilen durumdaki hedef için animasyonu oynatmayı durdur",
  T_48_META_API_90_P1: "Ortasında",
  T_48_META_API_93: "Yol Boyunca Hareket Oluştur",
  T_48_META_API_93_D: "Belirtilen yola göre nesnenin hareket etmesini sağlamak için bir yolda ara değerli bir hareket oluşturun",
  T_48_META_API_93_P1: "Yol",
  T_48_META_API_93_P1_D: "Hareket yolu",
  T_48_META_API_93_P3_D: "Hızın büyüklüğü",
  T_48_META_API_93_P4: "Tanjant'a Doğru",
  T_48_META_API_93_P4_D: "Nesnenin hareket yönüne bakıp bakmadığı. Bu özellik, nesnenin yönelimi başka yollarla zorla değiştirilse bile değişmez",
  T_48_META_API_96: "Prefab Oluştur",
  T_48_META_API_96_D: "Prefab örneği oluştur ve bunu asenkron olarak işleme seçeneğiyle yap",
  T_48_META_API_96_P2: "Asenkron Yükle",
  T_48_META_API_96_P2_D: "Yüklemenin asenkron olup olmadığı",
  T_48_META_EVT_3140: "Takım Değişikliğinde",
  T_48_META_EVT_3140_D: "Mevcut varlığın takımı değiştiğinde tetiklenir",
  T_48_META_EVT_3140_P0: "Eski Takım",
  T_48_META_EVT_3140_P0_D: "Değişmeden önce ait olunan takım",
  T_48_META_EVT_3140_P1: "Mevcut Takım",
  T_48_META_EVT_3140_P1_D: "Değişiklikten sonra ait olunan takım",
  T_48_META_EVT_3141: "Konu Başlangıcı",
  T_48_META_EVT_3141_D: "Konu oynamaya başladığında tetiklenir",
  T_48_META_EVT_3141_P1: "Konu ID",
  T_48_META_EVT_3141_P1_D: "Konu ID",
  T_48_META_EVT_3142: "Konu Bitişi",
  T_48_META_EVT_3142_D: "Konu bittiğinde tetiklenir",
  T_48_META_EVT_3142_P0_D: "Tetikleyici oyuncu",
  T_48_META_EVT_3142_P1_D: "Konu ID",
  T_48_META_EVT_3143: "Tetikleme Konusu Seçeneği",
  T_48_META_EVT_3143_D: "Konuda bir seçenek seçildiğinde tetiklenir",
  T_48_META_EVT_3143_P1_D: "Konu ID",
  T_48_META_EVT_3143_P2: "Seçenek ID",
  T_48_META_EVT_3143_P2_D: "Seçilen opsiyon ID'si",
  T_48_META_TYP_409_I10: "Takım Değiştirme Başarısız_Takım Bulunamadı",
  T_48_META_TYP_409_I11: "Takım Değiştirme Başarısız_Haklandın",
  T_48_META_TYP_409_I12: "Takım Değiştirme Başarısız_Araçta",
  T_48_META_TYP_409_I7: "Takım Değiştirme Başarısız_Desteklenmiyor",
  T_48_META_TYP_409_I8: "Takım Değiştirme Başarısız_Zaten Takımda",
  T_48_META_TYP_409_I9: "Takım Değiştirme Başarısız_Hedef Bulunamadı",
  T_48_META_TYP_41_I19: "Çarpıştırıcıyı Devre Dışı Bırak",
  T_48_META_TYP_417: "Parçacıklar",
  T_48_META_TYP_428: "Oyuncu Dönüşümü veya NPC Kıyafeti",
  T_48_META_TYP_431: "Yol Boyunca Hareket",
  T_48_META_TYP_431_I1: "Yol",
  T_48_META_TYP_432: "Özel Eğri Yol Noktası",
  T_48_META_TYP_432_I0: "Yuvarla",
  T_48_META_TYP_432_I1: "Tanjant",
  T_48_META_TYP_433: "Özel Eğri Yol Türü",
  T_48_META_TYP_433_I0: "Doğrusal",
  T_48_META_TYP_433_I1: "Pürüzsüz",
  T_48_META_TYP_433_I2: "Özel",
  T_48_META_TYP_434: "Özel Eğri Yol",
  T_48_META_TYP_434_I2: "Kapalı Döngü",
  T_48_META_TYP_434_I3: "Yol Noktaları",
  T_48_META_TYP_437_I5: "Puan Tipi İsimleri",
  T_48_META_TYP_437_I6: "Sol Puan İçeriği",
  T_48_META_TYP_437_I7: "Sağ Puan İçeriği",
  T_48_META_TYP_438_I1: "Oyuncular",
  T_48_META_TYP_438_I2: "Dereceler",
  T_48_META_TYP_438_I3: "Toplam Puan",
  T_48_META_TYP_438_I4: "Puan Tipi İsimleri",
  T_48_META_TYP_438_I5: "Renkler",
  T_48_META_TYP_438_I6: "Puanlar",
  T_48_META_TYP_439: "Grup",
  T_48_META_TYP_442_I1: "Sol Puan",
  T_48_META_TYP_442_I10: "Sağ Haklanma Simgesi",
  T_48_META_TYP_442_I2: "Sağ Puanı",
  T_48_META_TYP_442_I3: "Sol Hayatta Numarası",
  T_48_META_TYP_442_I4: "Sağ Hayatta Sayısı",
  T_48_META_TYP_442_I5: "Sol Haklanma Sayısı",
  T_48_META_TYP_442_I6: "Sağ Haklanma Sayısı",
  T_48_META_TYP_442_I7: "Sol Hayatta Simgesi",
  T_48_META_TYP_442_I8: "Sağ Hayatta Simgesi",
  T_48_META_TYP_442_I9: "Sol Haklanma Simgesi",
  T_48_META_TYP_444: "Dil Türü",
  T_48_META_TYP_444_I0: "İngilizce",
  T_48_META_TYP_444_I1: "Basit Çince",
  T_48_META_TYP_444_I10: "Fransızca",
  T_48_META_TYP_444_I11: "Almanca",
  T_48_META_TYP_444_I12: "Türkçe",
  T_48_META_TYP_444_I13: "Hintçe",
  T_48_META_TYP_444_I14: "Japonca",
  T_48_META_TYP_444_I15: "Rumence",
  T_48_META_TYP_444_I16: "Arapça",
  T_48_META_TYP_444_I17: "Burmaca",
  T_48_META_TYP_444_I18: "Urduca",
  T_48_META_TYP_444_I19: "Bengalce",
  T_48_META_TYP_444_I2: "Geleneksel Çince",
  T_48_META_TYP_444_I3: "Tayca",
  T_48_META_TYP_444_I4: "Vietnamca",
  T_48_META_TYP_444_I5: "Endonezce",
  T_48_META_TYP_444_I6: "Portekizce",
  T_48_META_TYP_444_I7: "İspanyolca",
  T_48_META_TYP_444_I8: "Rusça",
  T_48_META_TYP_444_I9: "Korece",
  T_48_SD_ERROR_DIVISOR: "Bölen 0 olamaz",
  T_48_SD_ERROR_KEY_NOTINMAP: "Belirtilen anahtar haritada bulunmuyor: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "Liste dizini aralık dışında: {0}",
  T_48_SD_SK_WARNING: "{1}, {0} içinde bulunamadı",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: `Üretim Diyarı karakter denetleyicisi {0} için "IsServerDriven" özelliği devre dışı olduğundan, ilgili sunucu API'si etkili olmuyor.`,
  T_48_XXJ_WS_PARENTERROR: "Üst öğe ayarlanamadı",
  T_48_XXJ_WS_PERFORMANCE: "Performans",
  T_48_XXJ_WS_TANGENT: "Tanjant",
  T_48_XXJ_WS_WAYPOINT: "Yol Noktası",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "Nesne listesi",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Özel Mini Harita Kullan",
  T_48_XYL_UGC_HIDEMINIMAP: "HUD Mini Harita'yı gizle",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Temel Özel Yüzey",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Silindir Kesiti",
  T_48_XYL_WS_BASICHEMISPHERE: "Temel Yarım Küre",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Çeyrek Simit",
  T_48_XYL_WS_BASICQUARTERTORUS: "Çeyrek Kare Simidi",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Simit",
  T_48_XYL_WS_BASICTRIANGLE: "Üçgen Yüzey",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Maç oyuncuları = Takım sayısı x Takım başına oyuncu sayısı. Ne kadar çok maç oyuncusu, daha uzun eşleştirme süresi",
  T_48_XYL_WS_MAPPLAYERSWARNING: "Yüksek maç oyuncusu sayısı daha uzun bir eşleştirme süresine neden olabilir",
  T_49_HL_CL_CREATOR_LABEL2: "Üretim Diyarı Topluluk Yeteneği",
  T_49_HL_CL_MAPS_LABEL2: "Harita Kazananı",
  T_49_HL_CL_MAPS_LABEL3: "Oyun Modu Kazananı",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Gidişat",
  T_49_JH_WS_SKILLKASSIE: "Elektro Terapi (Kassie)",
  T_49_JH_WS_SKILLKODA: "Kuzey Işığı Görüşü (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Cesur Atılma (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Yapay Zeka ile Üret",
  T_49_META_API_10065: "Özel Kamerayı Değiştir",
  T_49_META_API_10067: "Mevcut Özel Kamerayı Al",
  T_49_META_API_10069: "Özel Kamera Oluştur",
  T_49_META_API_10070: "Özel Kamera Ayıklama Maskesini Ayarla",
  T_49_META_API_10070_D: "Tüm katmanlardaki görünürlüğü kontrol etmek için hedef kameranın ayıklama maskesi ayarını yap",
  T_49_META_API_10071: "Özel Kamera Ayıklama Maskesini Al",
  T_49_META_API_10071_D: "Hedef kameranın ayıklama maskesini al",
  T_49_META_API_10072: "Özel Kamera Ayıklama Maskesi Katmanını Ayarla",
  T_49_META_API_10072_D: "Belirli bir katman için hedef kameranın görünürlüğünü ayarla",
  T_49_META_API_10073: "Ekran Görüntüsü Al",
  T_49_META_API_10073_D: "Ekran görüntüsü al (iç testler için)",
  T_49_META_API_106: "Sunucu Zaman Damgasını Al (ms)",
  T_49_META_API_106_D: "Sunucu zaman damgasını milisaniye hassasiyetinde al",
  T_49_META_API_107: "Zaman Damgasını Yerelleştirilmiş Metne Çevir (ms)",
  T_49_META_API_107_D: "Zaman damgalarını (milisaniye cinsinden) belirli formatlara göre metinlere dönüştür",
  T_49_META_API_107_P0: "Zaman Damgası (ms)",
  T_49_META_API_107_P0_D: "Milisaniye zaman damgası",
  T_49_META_API_108: "Lerp Vektör3",
  T_49_META_API_108_D: "3D vektör A ile B arasında doğrusal geçiş yap",
  T_49_META_API_1089_P2: "İstek ID",
  T_49_META_API_109: "Bağlamı Kişiliğe Güncelle",
  T_49_META_API_109_D: "Mavcut odadaki belirli bir kişinin model bağlamını güncelle ve yürütmeden sonra orijinal bağlamın üzerine yaz. Bu bağlam, kişinin arka planı, geçmişi veya mevcut diyaloğa ait belirli parametreleri yorumlamasını etkileyecektir.",
  T_49_META_API_109_P1: "Bağlam",
  T_49_META_API_109_P1_D: "Bağlamın Detayları",
  T_49_META_API_110: "Kişi Yanıtı Hakkında Geri Bildirim",
  T_49_META_API_110_D: "Bir kişinin yanıt içeriğiyle ilgili geri bildirim gönder. Bu geri bildirim, modelimizi optimize etmek için kullanılacaktır.",
  T_49_META_API_110_P1: "Beğeniliyor",
  T_49_META_API_110_P1_D: "Yanıtın beğenilip beğenilmediğini belirtir. Doğru = beğeni.",
  T_49_META_API_1109: "Yerel Oyuncunun Konumunu Ayarla",
  T_49_META_API_1109_D: "Oyuncu klasik oyun karakterlerini kullanırken, bu API oyuncunun konumunu ayarlayabilir.",
  T_49_META_API_1109_P0_D: "Hedef konum",
  T_49_META_API_111: "Slerp Vektör3",
  T_49_META_API_111_D: "A vektöründen B vektörüne yumuşak dönüş yapmak için küresel geçiş kullan",
  T_49_META_API_1110: "Yerel Oyuncunun İleri Vektörünü Ayarla",
  T_49_META_API_1110_D: "Oyuncu klasik oyun karakterlerini kullanırken, bu API oyuncunun baktığı yönü ayarlayabilir.",
  T_49_META_API_1110_P0_D: "İleri vektör",
  T_49_META_API_112: "Kişi Hafızasında Geri Git",
  T_49_META_API_112_D: "Bir karakterin belleğini, belirli bir yanıt IDsinden öncesine geri al. Bu yanıttan itibaren olan tüm diyaloglara ait bellek silinir.",
  T_49_META_API_113: "Tek Seferlik Bir Ses Efekti Çal",
  T_49_META_API_113_D: "Ayarlanabilir ses seviyesine sahip tek seferlik bir ses efekti çal",
  T_49_META_API_113_P0_D: "Çalınacak ses efekti kaynağı ID",
  T_49_META_API_113_P1: "Ses",
  T_49_META_API_113_P1_D: "Ses efekti için oynatma ses seviyesi, 0 ile 1 arasında değişir.",
  T_49_META_API_97: "İskelet Parçası Bakış Kumandası Üret",
  T_49_META_API_97_D: "Bir iskelet parçası bakış kumandası varlığı oluşturduktan sonra, bu varlıkla belirli bir iskelet parçasını kontrol edebilir ve her zaman belirli bir hedefe bakmasını sağlayabilirsin.",
  T_49_META_API_97_P0_D: "İskelet parçası bakış kumandası varlığı. Bu varlık yok edilirse, bakış işlevi durur.",
  T_49_META_API_97_P1_D: "Kontrol edilen iskelet parçası",
  T_49_META_API_97_P2_D: "Hedef inceleniyor",
  T_49_META_API_98: "Projeksiyon",
  T_49_META_API_98_D: "Vektör A'nın, vektör B üzerine izdüşümünü hesapla",
  T_49_META_API_99: "Yerel Zaman Damgasını Al (ms)",
  T_49_META_API_99_D: "Milisaniye hassasiyetinde yerel zaman damgası al",
  T_49_META_EVT_16_P1_D: "0'dan başlayarak, her giden istek sırasıyla artan sayısal bir ID tüketecektir; bu, örneğin oda oluşturma ve belleği temizleme işlemleri için geçerlidir.",
  T_49_META_EVT_16_P2: "Yanıt ID",
  T_49_META_EVT_16_P2_D: "Her tamamlanmış yanıtın özgün bir IDsi olacak",
  T_49_META_TYP_122_I19: "Özel Malzeme",
  T_49_META_TYP_122_I19_D: "Gökyüzü kutusunun özel bir malzeme ile değiştirilmesine izin ver",
  T_49_META_TYP_14_I78_D: "Oyuncunun istemcisinde sahneyi şu anda işleyen kamera varlığını al veya ayarla. Not: Kamera varlığı, istemci tarafındaki kamerayı kontrol eden yapılandırma verilerini temsil eder.",
  T_49_META_TYP_335_I9: "Geçen Süre (ms)",
  T_49_META_TYP_335_I9_D: "Oynama Süresi",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Başarısız",
  T_49_META_TYP_409_I14_D: "LLM_Başarısız",
  T_49_META_TYP_409_I15: "LLM_Zamanaşımı",
  T_49_META_TYP_409_I15_D: "LLM_Zaman_Aşımı",
  T_49_META_TYP_409_I16: "LLM_Geçersiz_Kişi",
  T_49_META_TYP_409_I16_D: "LLM_Geçersiz_KişiVeyaOda",
  T_49_META_TYP_409_I17: "LLM_Jeton_Limiti",
  T_49_META_TYP_409_I17_D: "LLM_Jeton_Limiti",
  T_49_META_TYP_409_I18: "LLM_İhlali",
  T_49_META_TYP_409_I18_D: "LLM_Sık_İstek",
  T_49_META_TYP_409_I19: "LLM_Sık_İstek",
  T_49_META_TYP_409_I19_D: "LLM_Sık_İstek",
  T_49_META_TYP_441: "Performans ID",
  T_49_META_TYP_445: "Oynatılabilir Kumanda ID",
  T_49_META_TYP_446: "Oynanabilir Kumanda Eklenebilir",
  T_49_META_TYP_446_I0: "Oynanabilir Kontroller",
  T_49_META_TYP_447: "İskelet Parçası Kumandası",
  T_49_META_TYP_448: "İskelet Parçası Bakış Kumandası",
  T_49_META_TYP_448_I0: "Kontrol Edilen Hedef",
  T_49_META_TYP_448_I1: "Hedefe Bak",
  T_49_META_TYP_449: "Özel Kamera",
  T_49_META_TYP_449_I2: "Ortografik Boyut",
  T_49_META_TYP_449_I2_D: "Kameranın görebildiği alanın boyutunu kontrol et",
  T_49_META_TYP_450: "Zaman Damgası Yerelleştirilmiş Metin (ms)",
  T_49_META_TYPE_449_D: "Özel bir kamera tamamen geliştirici tarafından kontrol edilir ve oyuncunun oyun sırasında ne göreceğini belirler",
  T_49_META_TYPE_450_D: "Milisaniye düzeyindeki bir zaman damgasını okunabilir metin formatına dönüştür",
  T_49_SD_SEARCH_ICONDESC: "Akıllı Eşleştirme",
  T_49_SD_SEARCHKEY_ACTION: "Aksiyon",
  T_49_SD_SEARCHKEY_ANICLIPID: "Animasyon klip ID",
  T_49_SD_SEARCHKEY_AS: "Olarak",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "Eklenti ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Ses efekti türü",
  T_49_SD_SEARCHKEY_BAGSKINID: "Çanta görünüm ID",
  T_49_SD_SEARCHKEY_BEZIER: "Bezier eğrisi",
  T_49_SD_SEARCHKEY_BOOL: "Boolean",
  T_49_SD_SEARCHKEY_BREAK: "Ara",
  T_49_SD_SEARCHKEY_BTREEID: "Davranış ağacı ID",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "Açma Tuşuna tıklandı",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "Açma tuşuna iki kere tıklandı",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "Açma Tuşuna basıldı",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "Açma tuşu serbest",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Kıyafet türü",
  T_49_SD_SEARCHKEY_COLOR: "Renk",
  T_49_SD_SEARCHKEY_COMMENT: "Yorum ekle",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Bileşen sabiti",
  T_49_SD_SEARCHKEY_CONCANT: "Bağlan",
  T_49_SD_SEARCHKEY_CONTINUE: "Devam",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "Özel HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Özel hud aracı",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "Nesne türünde dinamik seviye oluştur",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Görsel efekt türü",
  T_49_SD_SEARCHKEY_ENTITY: "Sahne nesnesi seç",
  T_49_SD_SEARCHKEY_FLOAT: "Süzül",
  T_49_SD_SEARCHKEY_FOR: "Dizin için",
  T_49_SD_SEARCHKEY_FOREACH: "Her biri için",
  T_49_SD_SEARCHKEY_FUNCTION: "Fonksiyon",
  T_49_SD_SEARCHKEY_GETCSV: "CSV Al",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Anahtara göre kayıtlı varlığı al",
  T_49_SD_SEARCHKEY_GETVALUE: "Özellik değeri al",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Küresel değişkeni al",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Küresel Değişken Belirle",
  T_49_SD_SEARCHKEY_IF: "Eğer",
  T_49_SD_SEARCHKEY_IFELSE: "Eğer başka",
  T_49_SD_SEARCHKEY_IMGENUM: "Resim Türü",
  T_49_SD_SEARCHKEY_INT: "Tam Sayı",
  T_49_SD_SEARCHKEY_INTERNALHUD: "HUD türü",
  T_49_SD_SEARCHKEY_ITEMENUM: "Eşya Türü",
  T_49_SD_SEARCHKEY_LISTAPPEND: "Listeye ekle",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "Liste ekleme menzili",
  T_49_SD_SEARCHKEY_LISTCLEAR: "Liste temizle",
  T_49_SD_SEARCHKEY_LISTCLONE: "Kopya listele",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "Liste içerir",
  T_49_SD_SEARCHKEY_LISTCREATE: "Liste yarat",
  T_49_SD_SEARCHKEY_LISTDELETE: "Listeyi Sil",
  T_49_SD_SEARCHKEY_LISTGET: "Listeyi al",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "Dizini listele",
  T_49_SD_SEARCHKEY_LISTINSERT: "Liste ekle",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "Son dizini listele",
  T_49_SD_SEARCHKEY_LISTLENGTH: "Liste uzunluğu",
  T_49_SD_SEARCHKEY_LISTREVERSE: "Liste döndür",
  T_49_SD_SEARCHKEY_LISTSET: "Liste belirle",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "Liste karıştır",
  T_49_SD_SEARCHKEY_LOCALKEY: "Çevrilen anahtar",
  T_49_SD_SEARCHKEY_LOCALVAR: "Yerel değişken",
  T_49_SD_SEARCHKEY_LOGICAL: "ve veya",
  T_49_SD_SEARCHKEY_LOGINFO: "Giriş bilgisi yaz",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "sözlükteki tüm anahtarları al haritadaki tüm anahtarları al",
  T_49_SD_SEARCHKEY_MAPCLEAR: "sözlüğü temizle haritayı temizle",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "sözlük anahtar içerir harita anahtar içerir",
  T_49_SD_SEARCHKEY_MAPCREATE: "Sözlük yarat harita yarat",
  T_49_SD_SEARCHKEY_MAPGET: "anahtara göre sözlük değeri al anahtara göre harita değeri al",
  T_49_SD_SEARCHKEY_MAPLENGTH: "sözlük uzunluğu harita uzunluğu",
  T_49_SD_SEARCHKEY_MAPREMOVE: "sözlüğü sil haritayı sil",
  T_49_SD_SEARCHKEY_MAPSET: "sözlük değerini ayarla harita değerini ayarla",
  T_49_SD_SEARCHKEY_MATH: "Topla, çıkar, çarp, böl",
  T_49_SD_SEARCHKEY_NEWLIST: "Yeni liste",
  T_49_SD_SEARCHKEY_NULL: "Null",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Sayıyı metne çevir",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Parçacık özellikleri",
  T_49_SD_SEARCHKEY_PERSONA: "Kişi",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "Oyuncu Veri ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Karakter yetenek türü",
  T_49_SD_SEARCHKEY_PREEFFECT: "Özel çıkartma türü",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "Ham ID",
  T_49_SD_SEARCHKEY_READSTATIS: "Birikmiş verileri oku",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "Kaynak UID",
  T_49_SD_SEARCHKEY_RETURN: "Dönüş",
  T_49_SD_SEARCHKEY_SCENEENUM: "Sahne dosyası",
  T_49_SD_SEARCHKEY_SCRIPTID: "Senaryo",
  T_49_SD_SEARCHKEY_SETVALUE: "Özellik değeri belirle",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Özel eşya ID türü",
  T_49_SD_SEARCHKEY_TEXT: "Metin",
  T_49_SD_SEARCHKEY_TEXTUREID: "Doku türü",
  T_49_SD_SEARCHKEY_THISENTITY: "Bu Varlık",
  T_49_SD_SEARCHKEY_TIMELINE: "Zaman Çizelgesi",
  T_49_SD_SEARCHKEY_TYPEENUM: "Her tür",
  T_49_SD_SEARCHKEY_V2VCREATE: "Vektör2 yarat",
  T_49_SD_SEARCHKEY_V2VGET: "Vektör2 bileşenlerini al",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Vector2 işlemi topla çıkar çarp nokta çarpımı mesafe açı",
  T_49_SD_SEARCHKEY_V2VSET: "Vektör2 içeriklerini belirle",
  T_49_SD_SEARCHKEY_V3VCREATE: "Vektör3 yarat",
  T_49_SD_SEARCHKEY_V3VGET: "Vektör3 bileşenleri",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Vector3 işlemi topla çıkar çarp nokta çarpımı vektörel çarpım mesafe açı",
  T_49_SD_SEARCHKEY_V3VSET: "Vektör3 bileşenleri belirle",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "Araç görünüm ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "Silah Görünüm ID",
  T_49_SD_SEARCHKEY_WHILE: "Bu sırada",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Birikmiş veritabanı konumunu yaz",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Harita koduna göre birikmiş veritabanı konumunu yaz",
  T_49_XXJ_WS_DURATIONS: "Süre  (sn)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Performansı Düzenle",
  T_49_XXJ_WS_PERFORMANCE: "Performans",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Performansı Sil",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Silinen performans geri getirilemez, devam edilsin mi?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Düzenleniyor {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "Bu isim zaten kullanılmış, lütfen değiştirip tekrar dene",
  T_49_XXJ_WS_PERFORMANCENAME: "Performans İsmi",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Ana Kare Ekle",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Alt Parça Ekle",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Parça Ekle",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Parçayı Sil",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Oyuncu Parçası",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Etkinlik Parçası",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Ana kare zaten mevcut",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "İlgili oyuncu parçası zaten mevcut",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "İçerik",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Tekrar eden parça adları tespit edildi. Lütfen adları değiştirip tekrar dene",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Lütfen önce kaydı başlat veya bir ana kare seç",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Kaydediliyor...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Ana Kare'yi Sil",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Sahne Görüntüsü",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: 'Bir parça oluşturmak için bir nesne seç ya da doğrudan "parça ekle" düğmesine dokun',
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: 'Yeni bir parça oluşturmak için "parça ekle" düğmesine dokun',
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Alt Parça",
  T_49_XXJ_WS_TIMELINE_TRACK: "Parça",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Parça Görüntüsü",
  T_49_XYL_WS_DAILYPROPS: "Temel",
  T_49_XYL_WS_STOREGAMPLAY: "Oyun Modu",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Bela Akademisi",
  T_50_H_MACHETE_VA_N: "Pala - Bela Akademisi",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Liderlik Tablosu Alanları",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Taşma",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Satır kaydırma",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Yazıyı küçült",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Demet Oluştur",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Demet Al",
  T_50_HJ_SEARCHKEY_TUPLESET: "Demet Belirle",
  T_50_HJ_TEXTOBGJ_H: "Boy",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Taşma Seçenekleri",
  T_50_HJ_TEXTOBGJ_W: "En",
  T_50_HZY_REVIEW_TEXTOBJ: "Metin nesnesi içeriği",
  T_50_JH_WS_HIDEMAPERROR: "Özel bir kapak görseli olmadan mini harita gizlenemez",
  T_50_JH_WS_HIDEMAPTIP: "Mini harita gizlendiğinde, artık kapak görseli olarak kullanılmayacaktır",
  T_50_JH_WS_HIDEMINIMAP: "Mini Haritayı Gizle",
  T_50_META_API_10073_P0: "Dosya adı",
  T_50_META_API_10073_P0_D: "Dosya adı",
  T_50_META_API_10073_P1_D: "İşlemin sonucu. Durum Kodu sabitini kontrol et.",
  T_50_META_API_1102: "Veritabanı Sayfası Sütun Değerini Oku",
  T_50_META_API_1102_D: "Standart bir veritabanı tablosundan belirli bir anahtara ait sütun değerini oku",
  T_50_META_API_1102_P3: "Sütun İndeksi",
  T_50_META_API_1102_P3_D: "Veritabanı tablosunun sütun indeksi (0 = ilk sütun)",
  T_50_META_API_1106: "Performans Yarat",
  T_50_META_API_1106_D: "Bir performans varlığı oluştur",
  T_50_META_API_1106_P0_D: "Performans varlığı",
  T_50_META_API_1111: "Veritabanından Liderlik Bağlantı Değerini Oku",
  T_50_META_API_1111_D: "Liderlik tablosu ve ilişkili veritabanı tablosundan değerlerin birleşimini oku",
  T_50_META_API_1111_P5: "Bağlantı Durum Kodu",
  T_50_META_API_1111_P5_D: "Bağlantı Hata Kodu",
  T_50_META_API_1112: "Veritabanından Liderlik Bağlantı Değerlerini Aralığa Göre Oku",
  T_50_META_API_1112_D: "Belirli bir sıralama aralığındaki liderlik tablosundan değerleri oku, ilişkili tablodan anahtarlarla eşleşen değerleri al ve birleştir",
  T_50_META_API_1112_P6: "Bağlantı Durum Kodu",
  T_50_META_API_1112_P6_D: "Bağlantı Hata Kodu",
  T_50_META_API_1113: "Veritabanına Liderlik Bağlantı Değeri Yaz",
  T_50_META_API_1113_D: "Belirli bir anahtar için değeri liderlik tablosuna ve ilişkili veritabanı tablosuna yaz",
  T_50_META_API_1113_P5: "Bağlantı Durum Kodu",
  T_50_META_API_1113_P5_D: "Bağlantı Hata Kodu",
  T_50_META_API_114_D: "Özel İsim Oluştur",
  T_50_META_API_114_P0_D: "Kod, bir arayüz varlığı oluştururken parametre adı olarak kullanılır ve karşılık gelen yerel değişken, oluşturulan arayüz varlığını temsil eder",
  T_50_META_API_114_P1_D: "Yalnızca oyuncunun görebildiği, ait olduğu oyuncu varlığı.",
  T_50_META_API_114_P2: "Arayüz Varlık ID",
  T_50_META_API_114_P2_D: "Özel arayüz varlığı kimliği",
  T_50_META_API_115_D: "Belirtilen özel arayüzü oluştur",
  T_50_META_API_116: "Seviye Nesnesi Öne Çıkan Belirle",
  T_50_META_API_116_D: "Nesnenin vurgulama durumunu ayarla. Diğer oyun içi mantıklardan etkilenebilir.",
  T_50_META_API_116_P0_D: "Hedef Nesne",
  T_50_META_API_116_P1_D: "Öne çıkan durumu",
  T_50_META_API_117: "Bit düzeyinde Ortak",
  T_50_META_API_117_D: "Bit düzeyinde ve/veya/xor/sola kaydır/sağa kaydır işlemleri",
  T_50_META_API_117_P0_D: "Sol değer",
  T_50_META_API_117_P1_D: "Doğru değer",
  T_50_META_API_117_P2_D: "İşlem Türü",
  T_50_META_API_118: "Bit Düzeyinde Değil",
  T_50_META_API_118_D: "Bit düzeyinde DEĞİL, diğer adıyla bit düzeyinde tümleyeni.",
  T_50_META_API_118_P0_D: "Değer",
  T_50_META_API_119: "Bit Dizesini Tamsayıya Dönüştür",
  T_50_META_API_119_D: "Listedeki tüm öğelere bit düzeyinde VEYA işlemi uygula ve sonucu tamsayıya dönüştür.",
  T_50_META_API_119_P0: "Bit Dizisi",
  T_50_META_API_119_P0_D: "Bit düzeyinde dizi",
  T_50_META_API_120: "Bit Düzeyinde Tamsayıyı Listeye Dönüştür",
  T_50_META_API_120_D: "Bir tam sayının ikili biçiminde 1. bit konumunda temsil edilen ondalık değerleri bir listeye dönüştür",
  T_50_META_API_120_P0_D: "Tam sayı",
  T_50_META_API_121: "Quaternion Açı",
  T_50_META_API_121_D: "İki quaternion arasındaki açıyı hesapla",
  T_50_META_API_121_P0_D: "Quaternion 1",
  T_50_META_API_121_P1_D: "Quaternion 2",
  T_50_META_API_122: "Quaternion Nokta Çarpımı",
  T_50_META_API_122_D: "İki quaternionun nokta çarpımını hesapla",
  T_50_META_API_123: "Quaternion Tersi",
  T_50_META_API_123_D: "Bir quaternionun tersini hesapla",
  T_50_META_API_123_P0_D: "Quaternion",
  T_50_META_API_124: "Quaternion'dan Hedefe Dönüş",
  T_50_META_API_124_D: '"Başlangıç"tan "hedef"e dönüş quaternionunu hesapla',
  T_50_META_API_124_P0_D: "Başlangıç noktası",
  T_50_META_API_124_P1_D: "Bitiş noktası",
  T_50_META_API_125: "Quaternion ile Hedefe Doğru Döndür",
  T_50_META_API_125_D: '"Başlangıç"tan "hedef"e dönüş quaternion’unu hesapla. Maksimum Derece Delta, izin verilen en büyük dönüş açısıdır',
  T_50_META_API_125_P0: "'dan",
  T_50_META_API_125_P0_D: "Başlangıç quaternion'u",
  T_50_META_API_125_P1: "'a",
  T_50_META_API_125_P1_D: "Hedef quaternion",
  T_50_META_API_125_P2: "Maksimum Açı Değişimi",
  T_50_META_API_125_P2_D: "Maksimum dönüş açısı",
  T_50_META_API_126: "Jiroskop Eğitimini Al",
  T_50_META_API_126_D: "Cihazın 3D uzaydaki yönelimi, üç eksen etrafındaki dönüş açılarını temsil eder.",
  T_50_META_API_127: "Jiroskop Yer Çekimini Al",
  T_50_META_API_127_D: "Cihazındaki sensör tarafından algılanan yerçekimi bileşeni",
  T_50_META_API_128: "Jiroskop Dönüş Oranını Al",
  T_50_META_API_128_D: "Bu, bir cihazın dönüş hızını ifade eder. Jiroskop sensörleriyle ilgili bir terim olup, cihazın üç boyutlu uzaydaki dönme hareketinin hızını tanımlar.",
  T_50_META_API_129: "Sapmasız Jiroskop Dönüşünü Al",
  T_50_META_API_129_D: "Cihazın dönüş hızını tanımlar ve sensörlerin gürültü veya sapmalarını telafi ederek daha hassas sonuçlar sağlar",
  T_50_META_API_130: "Jiroskop Kullanıcı İvmesini Al",
  T_50_META_API_130_D: "Yerçekimi bileşeni çıkarılmış cihaz ivmesi; yani kullanıcının eylemlerinden veya dış kuvvetlerden kaynaklanan ivme.",
  T_50_META_API_131: "Dokunma Bilgisini Al",
  T_50_META_API_131_D: "Belirtilen indeksli ekran dokunma bilgilerini al (konum, yer değiştirme ve değişim süresi dahil)",
  T_50_META_API_131_P0_D: "Dokunma noktası kimliklerini dağıtır, 0'dan başlar",
  T_50_META_API_131_P1_D: "Dokunma konumu",
  T_50_META_API_131_P2: "Ses Seviyesi",
  T_50_META_API_131_P2_D: "Son kareye kıyasla pozisyon değişimi",
  T_50_META_API_131_P3: "Delta Zamanı",
  T_50_META_API_131_P3_D: "Son kareden bu yana geçen süre",
  T_50_META_API_132: "Ekrandaki Dokunma Sayısını Al",
  T_50_META_API_132_D: "Ekrandaki mevcut dokunma noktalarının sayısını al",
  T_50_META_API_133: "Cihazı Titreştir",
  T_50_META_API_133_D: "Cihazı bir kez titreştir",
  T_50_META_API_134_D: "Hedef oyuncu cihazına sesi çalması için bildirim gönder",
  T_50_META_API_134_P0_D: "Hedef oyuncu",
  T_50_META_API_134_P1_D: "Ses varlığı",
  T_50_META_API_134_P2_D: "Oynatma hızı (geçerli aralık: 0.1~3.0; 1 = normal, <1 = yavaşlat, >1 = hızlandır)",
  T_50_META_API_135_D: "Tek seferlik ses dosyasını oynat",
  T_50_META_API_135_P0_D: "Ses Kaynakları",
  T_50_META_API_135_P1_D: "Oynatma Hızı",
  T_50_META_API_136: "Format Dizesi",
  T_50_META_API_136_D: "Dizeleri biçimlendir",
  T_50_META_API_136_P0_D: "Gidiş formatlama kalıplarını kullanan biçimlendirilmiş dizeler",
  T_50_META_API_136_P1: "Parametreler Dizisi",
  T_50_META_API_136_P1_D: "Parametre Listesi",
  T_50_META_API_137: "Bileşeni Yapıştır",
  T_50_META_API_137_D: "Bileşen verisini kopyala veya ekle",
  T_50_META_API_137_P0: "Kaynak",
  T_50_META_API_137_P0_D: "Kaynak varlık",
  T_50_META_API_137_P1_D: "Hedef Varlık",
  T_50_META_API_137_P2: "Bileşen Türü",
  T_50_META_API_137_P2_D: "İçerik Türü",
  T_50_META_API_137_P3: "Başarılı",
  T_50_META_API_137_P3_D: "Başarılı olup olmadığı",
  T_50_META_API_138: "Sonraki Karede Dirilt",
  T_50_META_API_138_D: "Sonraki Karede Dirilt",
  T_50_META_API_139: "Sonraki Çerçevede Hakla",
  T_50_META_API_139_D: "Savaş varlığını bir sonraki karede hakla",
  T_50_META_API_139_P0_D: "Savaş varlığı",
  T_50_META_API_140: "Sonraki Sahnede Oyundan Çık",
  T_50_META_API_140_D: "Bir sonraki karede oyundan çık",
  T_50_META_API_141: "Mikrofon Ses Seviyesini Al",
  T_50_META_API_141_D: "Mikrofon ses seviyesini al. Mikrofon kapalıysa ya da erişim izni yoksa durumu döndür.",
  T_50_META_API_141_P0: "Ses Seviyesi",
  T_50_META_API_141_P0_D: "Mikrofon sesi seviyesi",
  T_50_META_API_141_P1_D: "Mikrofon açık veya kapalı",
  T_50_META_API_142: "Görüntü Kalitesini Al",
  T_50_META_API_142_D: "Mevcut görüntü işleme kalitesini al (seçenekler: Düşük/Orta/Yüksek/Ultra)",
  T_50_META_API_143: "Görüntüleme Çözünürlüğünü Al",
  T_50_META_API_143_D: "Mevcut render çözünürlüğünü al",
  T_50_META_API_144: "Özel Oyuncuyu Bağla",
  T_50_META_API_144_D: "Bu oyuncunun bağlanacağı hedefi dinamik olarak ayarla; mevcut bağlantıların üzerine yazılır. Başarısız olursa hatalı döner.",
  T_50_META_API_144_P0: "Özel Oyuncu",
  T_50_META_API_144_P0_D: "Bu Özel Oyuncu, gerçek oyuncuya bağlandıktan sonra konum ve yön gibi veriler otomatik olarak senkronize edilir",
  T_50_META_API_144_P1_D: "Hedef Oyuncu",
  T_50_META_API_145: "Özel Oyuncunun Bağlantısını Kaldır",
  T_50_META_API_145_D: "Bağlantıyı iptal et. Başarısız olursa yanlış döner.",
  T_50_META_API_145_P0: "Özel Oyuncu",
  T_50_META_API_145_P0_D: "Bu hedef için tüm bağlantıları kaldır. Bağlantı kesildikten sonra konum ve yön gibi veriler otomatik olarak senkronize edilmeyecek.",
  T_50_META_API_146_P0_D: "Özel bir oyuncu",
  T_50_META_API_147: "Özel Oyuncu Durumu Belirle",
  T_50_META_API_147_D: "Sunucuya otomatik olarak yüklenir ve tüm istemcilerle senkronize edilir. Başarısız olursa yanlış döner.",
  T_50_META_API_147_P0: "Özel Oyuncu",
  T_50_META_API_147_P1: "Durum",
  T_50_META_API_147_P1_D: "Genellikle animasyon durumlarını kaydetmek için kullanılır. 'Özel Oyuncu Durumunu Al' ile senkronize edilmiş durumu al",
  T_50_META_API_148: "Özel Oyuncu Durumunu Al",
  T_50_META_API_148_D: "Durum verisi otomatik olarak sunucuya senkronize edilir. Başarısız olursa yanlış döner.",
  T_50_META_API_148_P0: "Özel Oyuncu",
  T_50_META_API_148_P1: "Durum",
  T_50_META_API_148_P1_D: "'Özel Oyuncu Durumunu Belirle' ile durumu ayarla",
  T_50_META_API_149: "Mesafe Tabanlı Ses Seviyelerini Ayarla",
  T_50_META_API_149_D: "Oyuncular arasındaki mesafe aralıklarını ayarlayarak ses seviyesini dinamik olarak ayarla.",
  T_50_META_API_149_P0: "Mesafe Listesi",
  T_50_META_API_149_P0_D: "Her biri ses seviyesi listesinde bir öğeye karşılık gelen mesafe listesi",
  T_50_META_API_149_P1: "Ses Seviyesi Listesi",
  T_50_META_API_149_P1_D: "Mesafe listesinde her bir öğeye karşılık gelen ses seviyelerinin listesi.",
  T_50_META_API_150: "Arkadaşları Al",
  T_50_META_API_150_D: "Oyuncunun arkadaş kimliklerinin listesini al",
  T_50_META_API_151: "Varsayılan Arayüz Bilgisini Al",
  T_50_META_API_151_D: "Oyuncunun varsayılan arayüz konumunu al",
  T_50_META_API_151_P0_D: "Varsayılan arayüz",
  T_50_META_API_151_P1_D: "Durum",
  T_50_META_API_151_P2_D: "Arayüz Konumu",
  T_50_META_API_151_P3: "Boyut",
  T_50_META_API_151_P3_D: "Arayüz boyutu",
  T_50_META_API_152: "Özel Etkinliği Yayınla",
  T_50_META_API_152_D: "Herhangi bir varlığın bu olayı alabilmesi için özel bir olayı yayınla",
  T_50_META_API_153: "Etkinliği Varlığa Gönder",
  T_50_META_API_153_D: "Özel etkinliği hedef varlığa gönder",
  T_50_META_EVT_17: "Ekrana Dokunma Başlangıcı",
  T_50_META_EVT_17_D: "Ekrana dokunulduğunda etkinliği başlat",
  T_50_META_EVT_17_P0: "Dokunma İndeksi",
  T_50_META_EVT_17_P0_D: "Dokunma noktası indeksi",
  T_50_META_EVT_17_P1_D: "Dokunma konumu",
  T_50_META_EVT_18: "Ekrana Dokunma Bitişi",
  T_50_META_EVT_18_D: "Ekrana dokunulduğunda etkinliği sonlandır",
  T_50_META_EVT_18_P0: "Dokunma İndeksi",
  T_50_META_EVT_18_P0_D: "Dokunma noktası indeksi",
  T_50_META_EVT_18_P1_D: "Ekrandaki dokunma konumları",
  T_50_META_EVT_19: "Kişisel Oda Oluşturma Sonucunu Al",
  T_50_META_EVT_19_D: "Kişisel sohbet odası oluşturma başarısız olduğunda ilgili sonucu al",
  T_50_META_EVT_19_P1: "Oda Kimliği",
  T_50_META_EVT_19_P1_D: "Oda kimliği",
  T_50_META_EVT_20: "Kullanıcı Oyunu Bıraktığında veya Maç Bittiğinde",
  T_50_META_EVT_20_D: "Oyuncu maçtan çıktığında veya maç sona erdiğinde tetiklenir",
  T_50_META_TYP_11_I44: "Mesafe Ses Seviyeleri",
  T_50_META_TYP_11_I44_D: "Oyuncular arasındaki mesafeye göre ses seviyesini dinamik olarak ayarla",
  T_50_META_TYP_22_I9_D: "Kullanıcı Arayüzünü oluşturmak için kullanılan varlık kimliği",
  T_50_META_TYP_244_I12_D: "Metin kutusu eni",
  T_50_META_TYP_244_I13_D: "Metin kutusu boyu",
  T_50_META_TYP_244_I14_D: "Taşma tipi",
  T_50_META_TYP_335_I10_D: "Oynatma hızı (geçerli değer > 0, varsayılan = 1)",
  T_50_META_TYP_409_I20: "G/Ç_Hata_Dosya_Oluşturulamadı",
  T_50_META_TYP_409_I20_D: "G/Ç işlemi başarısız oldu: Dosya oluşturulurken bir hata oluştu.",
  T_50_META_TYP_409_I21: "G/Ç_Hatalı_Dosya_Adı",
  T_50_META_TYP_409_I21_D: "G/Ç işlemi başarısız oldu. Geçersiz dosya adı.",
  T_50_META_TYP_448_I0_D: "Kontrol edilen iskelet parçası",
  T_50_META_TYP_448_I1_D: "İskelet parçasının baktığı hedef",
  T_50_META_TYP_451: "Taşma Tipi",
  T_50_META_TYP_451_D: "Metin taşmasını yönetme metodu",
  T_50_META_TYP_452: "Özel Arayüz Varlık ID",
  T_50_META_TYP_452_D: "Özel HUD varlığını tanımlayan kimlik",
  T_50_META_TYP_453: "Görüntü Kalitesi Türü",
  T_50_META_TYP_453_D: "Görüntü işleme kalitesi listesi",
  T_50_META_TYPE_448_D: "Bu varlık, iskelet parçasının bir hedefe bakmasını kontrol etmek için kullanılır",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D Nesne Üretme Haritası",
  T_50_SD_WS_MAPTAG_AIRACING: "Yarış Yapay Zekayla Üretme Haritası",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Animasyon durum adı sabitleri",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Adım sesi titreşimini devre dışı bırak",
  T_50_XXJ_WS_NOPERFORMANCE: "Henüz performans dosyası yok",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Beta sürümü",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Sevgili yaratıcılar, performans editörü hala test aşamasındadır. Hatalar içerebilir veya bazı temel özelliklerden yoksun olabilir. Lütfen dikkatli kullanın.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Performans Ekle",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Anahtar Klip Ekle",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Yol Takip Parçası",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Animasyon",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Animasyon Parçası",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Ses Parçası",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Tut",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Sonsuz Döngü",
  T_50_XXJ_WS_TIMELINE_DURATION: "Süre: {0}sn",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Animasyon ile model arasında uyumsuzluk var",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Anahtar klibi çakışması",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Bağlı varlık eksik",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "Parça ismi boş bırakılamaz",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC Yolu",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Özelliği Takip Et",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Anahtar Klibini Kaldır",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0} sn",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Parça sayısı limiti aşıldı",
  T_50_XYL_WS_AIGETERATESHOW: "Yapı Blokları",
  T_50_YU_F_B_VA_WITCH: "Mistik Bela (Alt)",
  T_50_YU_F_H_VA_WITCH: "Mistik Bela (Başlık)",
  T_50_YU_F_HA_VA_WITCH: "Mistik Bela (Yüz Boyası)",
  T_50_YU_F_S_VA_WITCH: "Mistik Bela (Ayakkabı)",
  T_50_YU_F_T_VA_WITCH: "Mistik Bela (Üst)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Özel Etkinlik",
  T_51_GT_WS_BASIC: "Temel",
  T_51_GT_WS_GLOBALEVENT: "Küresel Etkinlik",
  T_51_GT_WS_PRIVATEEVENT: "Özel Etkinlik",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "Oyun başlamadan önceki hazırlık süresi",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Sadece okunabilir içerik",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Siyah Deri Ceket (Kadın)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Mantar Avcısı",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Siyah Spor Giyim (Ayakkabılar)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "GW2018 Kısa Şortu (Kadın)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "GW2018 Eteği (Kadın)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Siyah Spor Giyim (Kapüşonlu)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Songkran Üstü (Siyah)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Tesisatçı Üstü (Kadın)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "GW2018 Atleti (Kadın)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "Beyaz Refah (Alt)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Siyah Eşofman Altı (Erkek)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Kaçak Avcı",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Hayatta Kalan Pantolonu",
  TXT_AVATAR_MALE_PANTS_MARIO: "Mamamia!",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Hayatta Kalan Ayakkabıları",
  TXT_AVATAR_MALE_SHOE_RED: "Kırmızı Botlar (Erkek)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "Beyaz Refah (Üst)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Siyah Beyzbol Forması (Erkek)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Asi Kapüşonlusu",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Havalı Spor Giyim (Kapüşonlu)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Kafatası Kralı Yeleği",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Hayatta Kalan Tişörtü",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Tesisatçı Üstü (Erkek)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Yarışçı Ceketi (Kadın)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Gece Palyaçosu (Kafa)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Yarışçı Ceketi (Erkek)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Kolsuz Ceket (Yeşil)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "Bay Mürekkepbalığı",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Zombileşmiş Samuray (Maske)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Tam Kol Dövmesi",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Kucakla",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Victoria",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Stil Sahibi Retro.",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Kitsune Altı",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Kitsune Ayakkabıları",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Spor Ayakkabıları (Mavi)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Kot Şort (Kadın)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Kitsune Kaftanı",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Çatışma Pantolonu (Erkek)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Melek Pantolonu",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Buşido Altı",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Fermuarlı Gri Kapüşonlu",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Hipster Ayakkabıları",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Buşido Ayakkabıları",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Astro Ayakkabılar",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Kot Şort (Erkek)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Çatışma Yeleği (Erkek)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Hipster Üstü",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Buşido Yolu",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "Beyaz Kasırga",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Beyzbolcu (Tayt)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Sürücü Ceketi (Kadın)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Beyzbolcu (Ceket)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Havalı Kaptan (Pantolon)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "Sokaklar (Kafa)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Havalı Kaptan (Ayakkabı)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Sürücü Ceketi (Erkek)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Havalı Kaptan (Ceket)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Dino",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "Gümüş Botlar",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Üç Aslan",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Smokin (Maske)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Smokin (Kafa)",
  TXT_AVATAR_PARACHUTE_8: "Paraşüt - Gülen Yüz",
  TXT_AVATAR_SHIRT_PLAID_2: "Programcıların Favorisi (Kırmızı)",
  TXT_AVATAR_SHOES_1: "Spor Ayakkabılar (Beyaz)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Öğrenci Kız (Turuncu)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Öğrenci Kız (Kırmızı)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Öğrenci Kız (Sarı)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Öğrenci Kız (Pembe)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Öğrenci Kız (Yasemin)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Öğrenci Kız (Mavi)",
  TXT_AVATAR_TSHIRT_WEEK_007: "YILDIZLI PAZAR",
  TXT_BANNER_NAME_MISHA: "Hız",
  TXT_CHARACTER_ADAM_NAME: "Primis",
  TXT_CHARACTER_BODYGUARD_NAME: "Nikita",
  TXT_CHARACTER_COP_NAME: "Andrew",
  TXT_CHARACTER_EVA_NAME: "Nulla",
  TXT_CHARACTER_NURSE_NAME: "Olivia",
  TXT_CHARACTER_RACERGIRL_NAME: "Misha",
  TXT_CHARACTER_RUNNER_NAME: "Kelly",
  TXT_CHARACTER_SEAMAN_NAME: "Ford",
  TXT_CLAN_NAME: "İsim",
  TXT_COLLECTION_DESCRIPTION: "Açıklama",
  TXT_COLLECTION_HEADPORTRAIT: "Avatar",
  TXT_INVENTORY_TITLE_EQUIPMENT: "Ekipman",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "TT Cephanesi",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "Svy.1 Çanta",
  TXT_ITEM_BAG2: "Svy.2 Çanta",
  TXT_ITEM_BAG3: "Svy.3 Çanta",
  TXT_ITEM_BASEBALLPOLE: "Beyzbol Sopası",
  TXT_ITEM_BOWAMMO: "Arbalet Oku",
  TXT_ITEM_CHANGUO: "Tava",
  TXT_ITEM_CROSSBOW: "Arbalet",
  TXT_ITEM_DESC_FLASH: "Kısa bir süreliğine düşmanların duyularını karıştıran patlayıcı bir cihaz.",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "Sağlık Kiti",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "Yumruk",
  TXT_ITEM_FLASH: "Flaş Bombası",
  TXT_ITEM_FOREGRIP1: "Svy.1 Ön Kabza",
  TXT_ITEM_FOREGRIP2: "Svy.2 Ön Kabza",
  TXT_ITEM_FOREGRIP3: "Svy.3 Ön Kabza",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "El Bombası",
  TXT_ITEM_GROZA: "Groza",
  TXT_ITEM_HANDCANNON: "El Topu",
  TXT_ITEM_HEATSIGHT: "Termal Dürbün",
  TXT_ITEM_HELMET1: "Svy.1 Kask",
  TXT_ITEM_HELMET2: "Svy.2 Kask",
  TXT_ITEM_HELMET3: "Svy.3 Kask",
  TXT_ITEM_HGAMMO: "TA Cephanesi",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmKN",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Pala",
  TXT_ITEM_MAGEZINE1: "Svy.1 Şarjör",
  TXT_ITEM_MAGEZINE2: "Svy.2 Şarjör",
  TXT_ITEM_MAGEZINE3: "Svy.3 Şarjör",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "Svy.1 Namlu Ağzı",
  TXT_ITEM_MUZZLE2: "Svy.2 Namlu Ağzı",
  TXT_ITEM_MUZZLE3: "Svy.3 Namlu Ağzı",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "PT Cephanesi",
  TXT_ITEM_SIGHT2: "2x Dürbün",
  TXT_ITEM_SIGHT4: "4x Dürbün",
  TXT_ITEM_SILENCER1: "Susturucu",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "HMT Cephanesi",
  TXT_ITEM_SNAMMO: "Dürbünlü Tüfek Cephanesi",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "Svy.1 Yelek",
  TXT_ITEM_VEST2: "Svy.2 Yelek",
  TXT_ITEM_VEST3: "Svy.3 Yelek",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "Sonuç",
  TXT_MESSAGEBOX_ERROR: "Hata",
  TXT_OB10_HQW_ITEM_BIPOD: "Çatal Ayak",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "Yağ Varili",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Miguel",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "Çılgın Katil",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Sopa - Meksika Usulü Kızarmış Mısır",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "Patlama Menzili",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "Pala - Cellat",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "Mayın",
  TXT_OB11_HQW_LANDMINE_DESC: "Zemine yerleştirilebilen bir mayın. Dikkat et de kendin basma!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Caroline",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Alkış",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Hip-Hop",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Tavuk",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "Merhaba!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "Hahaha",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Tahrik",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "Pompalı tüfek tutarken hareket hızın[FFB300] %{0}[-] artar.",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "Çeviklik",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "Çita: Diş",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "Fütürist",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "Tamir Kiti",
  TXT_OB5_HISTORY_HEADSHOOT: "Kafadan Vuruş",
  TXT_OB5_HISTORY_LIVE: "Hayatta Kalma",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Maxim",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "Mantarları ve sağlık kitlerini [FFB300]%{0}[-] daha hızlı kullanırsın.",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Oburluk",
  TXT_OB7_ZC_CLAN_NICKNAME: "Takma Ad",
  TXT_OB7_ZJS_HISTORY_TIME: "Süre",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "Kamp Ateşi",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Paraşüt - Şimşek",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Kla",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "Yumruk hasarı [FFB300]%{0} [-]arttı.",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "Muay Thai",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "Mor Çayırlar",
  TXT_OB8_ZXR_G18_CAMO_NAME: "Atom Ayrıştırıcı",
  TXT_OB8_ZXR_M249_CAMO_NAME: "Pörsük",
  TXT_OB8_ZXR_M79_CAMO_NAME: "Gök Yaran",
  TXT_OB8_ZXR_USP_CAMO_NAME: "Kar Leoparı",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "Paloma",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "Silah Kaçakçılığı",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Gök Tahtası - Yeşil Yıldız",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "Muhafız Duvar",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "Dijital Kamuflaj",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "Kanlı Mary",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "Çöl Avcısı",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "Mavi Alev",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "Mor Gösteri",
  TXT_OB9_ZXR_M14_CAMO_NAME: "Can Akışı",
  TXT_OB9_ZXR_M1873_NAME: "Derin Mavi Deniz",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "Pala - Kılıçbalığı",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "Biçerdöver",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "Mor Kuvars",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "Kavrulmuş Dünya",
  TXT_OPTION_HIGH_BRIGHTNESS: "Parlak",
  TXT_PLAYER_RANK: "DERECE",
  TXT_ROOM_LOBBY_ID: "Kimlik",
  TXT_ROOM_MAP_PARADISE: "Bermuda",
  TXT_SETTING_CHANGEWEAPON: "Hızlı Silah Değiştirme Tuşu",
  TXT_SETTING_OB4_NOTREAL: "Koyu",
  TXT_SKILL_DESC_COP: "Zırh dayanıklılık kaybı [FFB300]%{0}[-] azalır.",
  TXT_SKILL_DESC_RUNNER: "Depar hızı [FFB300]% {0}[-] artar.",
  TXT_SKILL_NAME_COP: "Zırh Ustası",
  TXT_SKILL_NAME_NURSE: "Şifalı Dokunuş",
  TXT_SKILL_NAME_RACERGIRL: "Nitro Desteği",
  TXT_SKILL_NAME_RUNNER: "Atılma",
  TXT_SKILL_NAME_SEAMAN: "Sağlam İrade",
  TXT_TUTORIAL_HUD: "Arayüz",
  TXT_TUTORIAL_HUD_LABEL10: "Depar",
  TXT_TUTORIAL_PICKUP_LABEL0: "Silah",
  T_34_M_WS_VFXTYPE: "VFX Türü",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "Saldırı Hedefi",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "Oyuncu UI Türü",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "Canavar Beceri Türü",
  T_45_META_WS_DESCRIPTIVECOLOR: "Tanımlayıcı Renk",
  T_45_META_WS_GAMETIME: "Oyun Zamanı",
  T_45_META_WS_PROPERTY: "Özellik",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "Buton stil türü",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "Buton türü",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "İvme",
  T_46_META_WS_A_ACCOUNTID: "Hesap ID",
  T_46_META_WS_A_ACTIONTYPE: "Eylem Türü",
  T_46_META_WS_A_ACTIVE: "Aktif",
  T_46_META_WS_A_ANGLE: "Açı",
  T_46_META_WS_A_ANY: "Herhangi",
  T_46_META_WS_A_APPEARANCEGROUP: "Görünüm Grubu",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "Doğrulama İfadesi",
  T_46_META_WS_A_ATTACHMENT: "Ek Parça",
  T_46_META_WS_A_ATTACHMENTS: "Ek Parça Listesi",
  T_46_META_WS_A_ATTACKABLE: "Saldırılabilir",
  T_46_META_WS_A_ATTACKER: "Saldırgan",
  T_46_META_WS_A_ATTACKTARGET: "Saldırı Hedefi",
  T_46_META_WS_A_AUTOPLAY: "Otomatik Oynat",
  T_46_META_WS_A_AXIS: "Eksen",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "Taban",
  T_46_META_WS_A_BOUNDTARGET: "Bağlı Hedef",
  T_46_META_WS_A_BTREE: "Davranış Ağacı",
  T_46_META_WS_A_BUFF: "Güçlendirme (Buff)",
  T_46_META_WS_A_CAMERA: "Kamera",
  T_46_META_WS_A_CAPICITY: "Kapasite",
  T_46_META_WS_A_CENTER: "Merkez",
  T_46_META_WS_A_CHANGEROTATION: "Dönüşü Değiştir",
  T_46_META_WS_A_CHANNEL: "Kanal",
  T_46_META_WS_A_CHASEENEMY: "Düşmanı Takip Et",
  T_46_META_WS_A_CHILD: "Alt Düğüm",
  T_46_META_WS_A_COLOR: "Renk",
  T_46_META_WS_A_COLUMN: "Sütun",
  T_46_META_WS_A_COLUMNNAME: "Sütun Adı",
  T_46_META_WS_A_COMEBACK: "Geri Dön",
  T_46_META_WS_A_COMPONENT: "Bileşen",
  T_46_META_WS_A_CONTENT: "İçerik",
  T_46_META_WS_A_COORDINATESYSTEM: "Koordinat Sistemi",
  T_46_META_WS_A_COUNT: "Miktar",
  T_46_META_WS_A_COUNTS: "Miktarlar",
  T_46_META_WS_A_CREATEDENTITY: "Oluşturulan Varlık",
  T_46_META_WS_A_CROSSPLATFORM: "Çoklu Platform",
  T_46_META_WS_A_CULLINGMASK: "Kesme Maskesi",
  T_46_META_WS_A_CURVE: "Eğri",
  T_46_META_WS_A_CUSTOMTAG: "Özel Etiket",
  T_46_META_WS_A_CUTRADIUS: "Kesim Yarıçapı",
  T_46_META_WS_A_DAMAGE: "Hasar",
  T_46_META_WS_A_DAMAGESEGMENTS: "Hasar Segmentleri",
  T_46_META_WS_A_DEGREE: "Derece",
  T_46_META_WS_A_DELTA: "Delta",
  T_46_META_WS_A_DEPTH: "Derinlik",
  T_46_META_WS_A_DESTVAL: "Hedef Değer",
  T_46_META_WS_A_DIFFICULTY: "Zorluk",
  T_46_META_WS_A_DIRECTION: "Yön",
  T_46_META_WS_A_DISABLE: "Devre Dışı",
  T_46_META_WS_A_DISPLACEMENT: "Yer Değiştirme",
  T_46_META_WS_A_DISTANCE: "Mesafe",
  T_46_META_WS_A_DIVINGMAXSPEED: "Dalış Maks. Hız",
  T_46_META_WS_A_DOTWEEN: "Tween Uygula",
  T_46_META_WS_A_DURATION: "Süre (s)",
  T_46_META_WS_A_EMOTE: "Emote",
  T_46_META_WS_A_ENABLE: "Etkinleştir",
  T_46_META_WS_A_ENDAREACENTER: "Bitiş Bölgesi Merkezi",
  T_46_META_WS_A_ENDAREARANGE: "Bitiş Bölgesi Aralığı",
  T_46_META_WS_A_ENDPOSITION: "Bitiş Pozisyonu",
  T_46_META_WS_A_ENDRANK: "Bitiş Sıralaması",
  T_46_META_WS_A_EQUIPMENTS: "Ekipmanlar",
  T_46_META_WS_A_EVENTID: "Olay Kimliği",
  T_46_META_WS_A_EXPONENT: "Üs",
  T_46_META_WS_A_FACTION: "Fraksiyon",
  T_46_META_WS_A_FACTORTYPE: "Faktör Türü",
  T_46_META_WS_A_FILTERTYPE: "Filtre Türü",
  T_46_META_WS_A_FINALRADIUS: "Son Yarıçap",
  T_46_META_WS_A_FINDVALUE: "Değer Bul",
  T_46_META_WS_A_FIXEDRANGE: "Sabit Menzil",
  T_46_META_WS_A_FOLLOWTARGET: "Hedefi Takip Et",
  T_46_META_WS_A_FONTCOLOR: "Yazı Tipi Rengi",
  T_46_META_WS_A_FONTSIZE: "Yazı Tipi Boyutu",
  T_46_META_WS_A_FOOTBALL: "Futbol Topu",
  T_46_META_WS_A_FORCE: "Kuvvet",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "Zorunlu Paraşüt Yüksekliği",
  T_46_META_WS_A_FORCEMODE: "Kuvvet Modu",
  T_46_META_WS_A_FORWARD: "Yön",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "Oyun ID",
  T_46_META_WS_A_HALFEXTENTS: "Yarı Boyut",
  T_46_META_WS_A_HEIGHT: "Yükseklik",
  T_46_META_WS_A_HEIGHTSEGMENTS: "Yükseklik Segmentleri",
  T_46_META_WS_A_HITDISTANCE: "Vuruş Mesafesi",
  T_46_META_WS_A_HITDISTANCES: "İsabet Mesafeleri",
  T_46_META_WS_A_HITENTITIES: "İsabet Eden Varlıklar",
  T_46_META_WS_A_HITENTITY: "Vuruş Varlığı",
  T_46_META_WS_A_HITNORMAL: "Vuruş Normali",
  T_46_META_WS_A_HITNORMALS: "İsabet Normalleri",
  T_46_META_WS_A_HITPOINTS: "İsabet Noktaları",
  T_46_META_WS_A_HITPOSITION: "Vuruş Pozisyonu",
  T_46_META_WS_A_INCLUDETRIGGER: "Tetikleyici Dahil Et",
  T_46_META_WS_A_INDEX: "İndeks",
  T_46_META_WS_A_INDEXS: "İndeksler",
  T_46_META_WS_A_INITIALVELOCITY: "Başlangıç Hızı",
  T_46_META_WS_A_INITRADIUS: "Başlangıç Yarıçapı",
  T_46_META_WS_A_INWALLET: "Giriş Cüzdanı",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "Alt Çarpışma Var mı",
  T_46_META_WS_A_ISEXIST: "Mevcut mu",
  T_46_META_WS_A_ISLOOP: "Döngü Var",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "Ekranda Haritalı mı",
  T_46_META_WS_A_ISPAUSE: "Duraklat",
  T_46_META_WS_A_ISSIDECOLLIDING: "Yan Çarpışma Var mı",
  T_46_META_WS_A_ISSUCCESS: "Başarılı mı",
  T_46_META_WS_A_ISTOPCOLLIDING: "Üst Çarpışma Var mı",
  T_46_META_WS_A_ITEM: "Öğe",
  T_46_META_WS_A_ITEMID: "Öğe ID",
  T_46_META_WS_A_ITEMS: "Öğeler",
  T_46_META_WS_A_ITEMTYPE: "Öğe Türü",
  T_46_META_WS_A_JERSEYTYPE: "Forma Türü",
  T_46_META_WS_A_KEEPVELOCITY: "Hızı Koru",
  T_46_META_WS_A_KEY: "Anahtar",
  T_46_META_WS_A_KEYCOLUMN: "Anahtar Sütun",
  T_46_META_WS_A_KEYS: "Anahtarlar",
  T_46_META_WS_A_LAYER: "Katman",
  T_46_META_WS_A_LAYERMASK: "Katman Maskesi",
  T_46_META_WS_A_LEFT: "Sol",
  T_46_META_WS_A_LEFTVALUE: "Sol Değer",
  T_46_META_WS_A_LENGTH: "Uzunluk",
  T_46_META_WS_A_LEVELOBJECT: "Seviye Nesnesi",
  T_46_META_WS_A_LOG: "Günlük",
  T_46_META_WS_A_LOOKATTARGET: "Hedefe Bak",
  T_46_META_WS_A_LOOPTYPE: "Döngü Türü",
  T_46_META_WS_A_MAINCOLOR1: "Ana Renk1",
  T_46_META_WS_A_MAINCOLOR2: "Ana Renk2",
  T_46_META_WS_A_MAPCODE: "Harita Kodu",
  T_46_META_WS_A_MAPPEDPOSITION: "Haritalı Pozisyon",
  T_46_META_WS_A_MAX: "Maksimum",
  T_46_META_WS_A_MAXDISPLACEMENT: "Maks. Yer Değiştirme",
  T_46_META_WS_A_MAXDISTANCE: "Maksimum Mesafe",
  T_46_META_WS_A_MIN: "Minimum",
  T_46_META_WS_A_MISSIONID: "Görev Kimliği",
  T_46_META_WS_A_MISSIONPROGRESS: "Görev İlerlemesi",
  T_46_META_WS_A_MODIFYTYPE: "Değişiklik Türü",
  T_46_META_WS_A_MONEYTYPE: "Para Birimi Türü",
  T_46_META_WS_A_MUST: "Gerekli",
  T_46_META_WS_A_NAME: "İsim",
  T_46_META_WS_A_NEWVALUE: "Yeni Değer",
  T_46_META_WS_A_NODE: "Düğüm",
  T_46_META_WS_A_NORMAL: "Normal",
  T_46_META_WS_A_NOT: "Hayır",
  T_46_META_WS_A_OBSERVER: "Gözlemci",
  T_46_META_WS_A_OFFSET: "Ofset",
  T_46_META_WS_A_OLDVALUE: "Eski Değer",
  T_46_META_WS_A_OPERATIOMETHOD: "İşlem Yöntemi",
  T_46_META_WS_A_OPTIONS: "Seçenekler",
  T_46_META_WS_A_OTHERCOLOR: "Diğer Renk",
  T_46_META_WS_A_OUTFIT: "Kıyafet",
  T_46_META_WS_A_OUTFITS: "Kıyafetler",
  T_46_META_WS_A_OUTWALLET: "Çıkış Cüzdanı",
  T_46_META_WS_A_OWNER: "Sahip",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "Paraşüt Maks. Hız",
  T_46_META_WS_A_PARAMS: "Parametreler",
  T_46_META_WS_A_PARENT: "Üst Düğüm",
  T_46_META_WS_A_PARENTWIDGET: "Üst Widget",
  T_46_META_WS_A_PATH: "Yol",
  T_46_META_WS_A_PATHPOINTS: "Yolu Noktaları",
  T_46_META_WS_A_PHASEINDEX: "Aşama İndeksi",
  T_46_META_WS_A_PLATFORM: "Platform",
  T_46_META_WS_A_PLAYER: "Oyuncu",
  T_46_META_WS_A_PLAYSPEED: "Oynatma Hızı",
  T_46_META_WS_A_POSITION: "Pozisyon",
  T_46_META_WS_A_POSITIONS: "Pozisyonlar",
  T_46_META_WS_A_POSTION: "Pozisyon",
  T_46_META_WS_A_PREFAB: "Prefab",
  T_46_META_WS_A_PROPERTY: "Özellik",
  T_46_META_WS_A_PROPERTYID: "Özellik Kimliği",
  T_46_META_WS_A_PURSUITTARGET: "Takip Hedefi",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "Yarıçap",
  T_46_META_WS_A_RANDOMDECAY: "Rastgele Azalma",
  T_46_META_WS_A_RANDOMRANGE: "Rastgele Aralık",
  T_46_META_WS_A_RANDOMRATIO: "Rastgele Oran",
  T_46_META_WS_A_RANGE: "Menzil",
  T_46_META_WS_A_RANK: "Rütbe",
  T_46_META_WS_A_REALCOIN: "Gerçek Para",
  T_46_META_WS_A_REALNUMBER: "Gerçek Sayı",
  T_46_META_WS_A_RESET: "Sıfırla",
  T_46_META_WS_A_RESOURCE: "Kaynak",
  T_46_META_WS_A_RESULT: "Sonuç",
  T_46_META_WS_A_RIGHT: "Sağ",
  T_46_META_WS_A_RIGHTVALUE: "Sağ Değer",
  T_46_META_WS_A_ROTATION: "Dönme",
  T_46_META_WS_A_ROW: "Satır",
  T_46_META_WS_A_SAMPLEPOINT: "Örnekleme Noktası",
  T_46_META_WS_A_SCALE: "Ölçek",
  T_46_META_WS_A_SCENEID: "Sahne Kimliği",
  T_46_META_WS_A_SCORE: "Skor",
  T_46_META_WS_A_SCORENAME: "Skor Adı",
  T_46_META_WS_A_SCREENPOSITION: "Ekran Pozisyonu",
  T_46_META_WS_A_SCRIPT: "Komut Dosyası",
  T_46_META_WS_A_SEAT: "Koltuk",
  T_46_META_WS_A_SEP: "Ayırıcı",
  T_46_META_WS_A_SEPSTR: "Ayırıcı",
  T_46_META_WS_A_SHEETNAME: "Sayfa Adı",
  T_46_META_WS_A_SHOPITEM: "Mağaza Ürünü",
  T_46_META_WS_A_SHOWBACKGROUND: "Arka Planı Göster",
  T_46_META_WS_A_SHOWMATCHRESULT: "Oyun Sonucu Göster",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "İptal Edildiğinde Mesaj Göster",
  T_46_META_WS_A_SKILL: "Beceri",
  T_46_META_WS_A_SKILLS: "Yetenekler",
  T_46_META_WS_A_SKILLTARGET: "Beceri Hedefi",
  T_46_META_WS_A_SKIN: "Çanta Görünümü",
  T_46_META_WS_A_SLOT: "Slot",
  T_46_META_WS_A_SRCVAL: "Kaynak Değer",
  T_46_META_WS_A_SRCVALUE: "Kaynak Değeri",
  T_46_META_WS_A_STARTAREACENTER: "Başlangıç Bölgesi Merkezi",
  T_46_META_WS_A_STARTAREARANGE: "Başlangıç Bölgesi Aralığı",
  T_46_META_WS_A_STARTINDEX: "Başlangıç İndeksi",
  T_46_META_WS_A_STARTPOSITION: "Başlangıç Pozisyonu",
  T_46_META_WS_A_STARTRANK: "Başlangıç Sıralaması",
  T_46_META_WS_A_STATE: "Durum",
  T_46_META_WS_A_STATUS: "Durum",
  T_46_META_WS_A_STATUSCODE: "Durum Kodu",
  T_46_META_WS_A_STYLE: "Stil",
  T_46_META_WS_A_SURFINGMAXSPEED: "Sörf Maks. Hız",
  T_46_META_WS_A_TARGET: "Hedef",
  T_46_META_WS_A_TARGETPOSITION: "Hedef Pozisyonu",
  T_46_META_WS_A_TEAMSEQ: "Takım Sırası",
  T_46_META_WS_A_THRESHOLD: "Eşik Değeri",
  T_46_META_WS_A_TIMESTAMP: "Zaman Damgası",
  T_46_META_WS_A_TIPS: "İpuçları",
  T_46_META_WS_A_TITLE: "Başlık",
  T_46_META_WS_A_TOKENCOUNT: "Jeton Sayısı",
  T_46_META_WS_A_TOKENID: "Jeton Kimliği",
  T_46_META_WS_A_TORQUE: "Tork",
  T_46_META_WS_A_TOUCHPOINT: "Dokunma Noktası",
  T_46_META_WS_A_TRANSITIONTIME: "Geçiş Süresi (ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "Geçiş Türü",
  T_46_META_WS_A_TRIGGER: "Tetikleyici",
  T_46_META_WS_A_TYPE: "Tür",
  T_46_META_WS_A_UI: "Arayüz",
  T_46_META_WS_A_UIID: "UI Kimliği",
  T_46_META_WS_A_UPWARD: "Yukarı",
  T_46_META_WS_A_VALUE: "Değer",
  T_46_META_WS_A_VALUEA: "Değer A",
  T_46_META_WS_A_VALUEB: "Değer B",
  T_46_META_WS_A_VALUES: "Değerler",
  T_46_META_WS_A_VALUET: "Değer T",
  T_46_META_WS_A_VALUETYPE: "Değer Türü",
  T_46_META_WS_A_VEHICLE: "Araç",
  T_46_META_WS_A_VEHICLESKIN: "Araç Kıyafeti",
  T_46_META_WS_A_VELOCITY: "Hız",
  T_46_META_WS_A_VELOCITYXZ: "XZ Eksen Hızı",
  T_46_META_WS_A_VELOCITYY: "Y Eksen Hızı",
  T_46_META_WS_A_VISIBLE: "Görünür",
  T_46_META_WS_A_WAITTIME: "Bekleme Süresi (s)",
  T_46_META_WS_A_WALLET: "Cüzdan",
  T_46_META_WS_A_WEAPON: "Silah",
  T_46_META_WS_A_WEAPONSKIN: "Silah Kaplaması",
  T_46_META_WS_A_WIDGETID: "Widget Kimliği",
  T_46_META_WS_A_WIDGETTYPE: "Widget Türü",
  T_46_META_WS_A_WIDTH: "Genişlik",
  T_46_META_WS_A_WORLDPOSITION: "Dünya Pozisyonu",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "Dünya Pozisyonunu Koru",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Mutlak Değer",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "AOI Özel Takip Ekle",
  T_46_META_WS_ADDATTACHMENTS: "Ek Parçalar Ekle",
  T_46_META_WS_ADDBUFF: "Buff Ekle",
  T_46_META_WS_ADDCOMPONENT: "Bileşen Ekle",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "Futbol Hızı Ekle",
  T_46_META_WS_ADDFORCE: "Kuvvet Ekle",
  T_46_META_WS_ADDFORCEATPOSITION: "Belirli Bir Noktada Kuvvet Ekle",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "Formül Özellik Faktörü Ekle",
  T_46_META_WS_ADDGAMEEVENTLOG: "Oyun Olayı Günlüğü Ekle",
  T_46_META_WS_ADDHP: "HP Ekle",
  T_46_META_WS_ADDITEM: "Öğeyi Ekle",
  T_46_META_WS_ADDITEMINSCENE: "Sahneye Öğeyi Oluştur",
  T_46_META_WS_ADDITEMTOSHOPITEM: "Ürüne Ürün Ekle",
  T_46_META_WS_ADDMONEY: "Para Ekle",
  T_46_META_WS_ADDSCRIPT: "Betik Ekle",
  T_46_META_WS_ADDTAG: "Etiket Ekle",
  T_46_META_WS_ADDTOKEN: "Token Ekle",
  T_46_META_WS_ADDTORQUE: "Tork Ekle",
  T_46_META_WS_ADDUSEREVENTLOG: "Kullanıcı Olayı Günlüğü Ekle",
  T_46_META_WS_ANGEL: "Açı",
  T_46_META_WS_APPEND: "Ekle",
  T_46_META_WS_APPENDRANGE: "Aralık Ekle",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "Ara Durum UI Yapılandırmasını Uygula",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "Onayla",
  T_46_META_WS_ASSISTPLAYER: "Destekleyen Oyuncu",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "Saldırgan",
  T_46_META_WS_ATTACKTARGET: "Saldırı Hedefi",
  T_46_META_WS_AXISANGLETOQUATERNION: "Eksen Açısını Quaternion'a Dönüştür",
  T_46_META_WS_BOXCAST: "Kutu Cast",
  T_46_META_WS_BOXOVERLAP: "Kutu Çakışması",
  T_46_META_WS_BUTTONNAME: "Düğme Adı",
  T_46_META_WS_C_ACTIONTYPE: "Eylem Türü",
  T_46_META_WS_C_AIMABLE: "Hedeflenebilir Bileşen",
  T_46_META_WS_C_AIMASSISTABLE: "Yardımcı Hedefleme Bileşeni",
  T_46_META_WS_C_AIMASSISTTYPE: "Nişan Yardım Türü",
  T_46_META_WS_C_AIRDROP: "Hava Düşüşü",
  T_46_META_WS_C_AMMO: "Mühimmat",
  T_46_META_WS_C_AMMOTYPE: "Mermi Türü",
  T_46_META_WS_C_AMPHIBIAN: "Amfibik Araç",
  T_46_META_WS_C_ANIMATIONCLIP: "Animasyon Klibi",
  T_46_META_WS_C_ANIMATIONCLIPID: "Animasyon Klip ID",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "Animasyon Kontrolcüsü",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "Bağlanabilir Animasyon Kontrolcüsü",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "Animasyon Kontrolörü ID",
  T_46_META_WS_C_ANIMATIONSTATE: "Animasyon Durumu",
  T_46_META_WS_C_ANIMATIONTRIGGER: "Animasyon Tetikleyici",
  T_46_META_WS_C_APPEARENCE: "Görünüm",
  T_46_META_WS_C_ASSETCONFIGID: "Varlık Yapılandırma ID",
  T_46_META_WS_C_ASSETID: "Varlık ID",
  T_46_META_WS_C_ATTACHMENT: "Eklenti",
  T_46_META_WS_C_ATTACKABLETYPE: "Saldırılabilir Tür",
  T_46_META_WS_C_AUDIOID: "Ses ID",
  T_46_META_WS_C_BACKPACK: "Sırt Çantası",
  T_46_META_WS_C_BACKPACKSKINID: "Sırt Çantası Kaplama ID",
  T_46_META_WS_C_BASEDATAALIAS: "Temel Veri Takma Adı",
  T_46_META_WS_C_BASICAPPEARANCE: "Temel Görünüm",
  T_46_META_WS_C_BASICCYLINDER: "Temel Silindirin veya Koni",
  T_46_META_WS_C_BASICSCALABLE: "Temel Ölçeklenebilir",
  T_46_META_WS_C_BASICSPHERE: "Temel Küre",
  T_46_META_WS_C_BATCHCOMBINERENDER: "Toplu Kombinasyon Render Bileşeni",
  T_46_META_WS_C_BEVTREE: "Davranış Ağacı",
  T_46_META_WS_C_BEVTREEATTACHABLE: "Takılabilir Davranış Ağacı",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "Davranış Ağacı Özel Düğüm",
  T_46_META_WS_C_BEVTREEID: "Davranış Ağacı Kimliği",
  T_46_META_WS_C_BEVTREENODESTATUS: "Davranış Ağacı Düğüm Durumu",
  T_46_META_WS_C_BEVTREENODETYPE: "Davranış Ağacı Düğüm Türü",
  T_46_META_WS_C_BEZIERCURVE: "Bezier Eğrisi",
  T_46_META_WS_C_BOOL: "Bool",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Bot Zorluk Türü",
  T_46_META_WS_C_BOUNCINGTIRE: "Zıplayan Lastik",
  T_46_META_WS_C_BUFFABLE: "Bufflanabilir",
  T_46_META_WS_C_BUFFGENERATOR: "Buff Üretici",
  T_46_META_WS_C_BUFFTYPE: "Buff Türü",
  T_46_META_WS_C_BUILTINRENDER: "Dahili Görüntüleme",
  T_46_META_WS_C_BUILTINUI: "Yerleşik UI",
  T_46_META_WS_C_BUILTINUITYPE: "Yerleşik UI Türü",
  T_46_META_WS_C_CAMERA: "Kamera",
  T_46_META_WS_C_CAMERABLOCKMODE: "Kamera Engelleme Modu",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "Kamera Projektör Modu",
  T_46_META_WS_C_CAMERARAYCASTUI: "Kamera RayCast UI",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "Kamera Geçiş Türü",
  T_46_META_WS_C_CAMERATYPE: "Kamera Türü",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Kamera Görüş Açısı Kısıtlama Türü",
  T_46_META_WS_C_CAPSULETRIGGER: "Kapsül Tetikleyici",
  T_46_META_WS_C_CAR: "Araba",
  T_46_META_WS_C_CHARACTERCONTROLLER: "Karakter Denetleyici",
  T_46_META_WS_C_CHATCHANNEL: "Sohbet Kanalı",
  T_46_META_WS_C_CHATCHANNELTYPE: "Sohbet Kanalı Türü",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "Kontrol Noktası Tetikleyici",
  T_46_META_WS_C_COINGENERATOR: "Madeni Para Üretici",
  T_46_META_WS_C_COLLECTIONID: "Koleksiyon ID",
  T_46_META_WS_C_COLLIDER: "Çarpışma Nesnesi",
  T_46_META_WS_C_COLLIDERCOLLECTION: "Çarpışma Şekli",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "Çarpışma Koleksiyonu ID",
  T_46_META_WS_C_COLORDRUM: "Renkli Davul",
  T_46_META_WS_C_COMBATABLE: "Savaşabilir",
  T_46_META_WS_C_COMPONENT: "Bileşen",
  T_46_META_WS_C_CONDITION: "Koşul",
  T_46_META_WS_C_CONTAINER: "Konteyner",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "Koordinat Sistemi Türü",
  T_46_META_WS_C_CROSSBOW: "Okçuluk Bombası",
  T_46_META_WS_C_CSVID: "CSV Kimliği",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "Özelleştirilebilir Tetikleyici",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "Özel Nesne",
  T_46_META_WS_C_CUSTOMPATH: "Özel Yol",
  T_46_META_WS_C_CUSTOMUI: "Özelleştirilmiş UI",
  T_46_META_WS_C_CUSTOMUIID: "Özel UI ID",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "Özelleştirilmiş UI veya Widget",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "Özel UI Widget ID",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "Hasar Görmüş Vücut Bölgesi Türü",
  T_46_META_WS_C_DAMAGETYPE: "Hasar Türü",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "Ölüm veya Dokunulmazlık Tetikleyici",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "Yıkılabilir Nesne",
  T_46_META_WS_C_DICE: "Zarlı",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "İkili Zıplama Ayakkabıları",
  T_46_META_WS_C_DRUMMUSIC: "Davul Müziği",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "Çift Ellerle Silah Türü",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "Genel Seviye Nesnesi",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "Dinamik Olarak Oluşturulabilir Seviye Nesnesi Türü",
  T_46_META_WS_C_DYNAMICFENCE: "Dinamik Çit",
  T_46_META_WS_C_EFFECT: "Etki",
  T_46_META_WS_C_EFFECTCONTAINER: "Etki Konteyneri",
  T_46_META_WS_C_EFFECTID: "Efekt ID",
  T_46_META_WS_C_EMOTETYPE: "Emote Türü",
  T_46_META_WS_C_ENDPOINTTRIGGER: "Bitiş Noktası Tetikleyici",
  T_46_META_WS_C_ENTITY: "Varlık",
  T_46_META_WS_C_ENTITYORPREFABID: "Varlık veya Prefab ID",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "Ekipman Aksesuarı",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "Ekipman Slot Türü",
  T_46_META_WS_C_EQUIPMENTTYPE: "Ekipman Türü",
  T_46_META_WS_C_EVENTID: "Olay Kimliği",
  T_46_META_WS_C_FACTION: "Fraksiyon",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "Doldurma Yönü Türü",
  T_46_META_WS_C_FILLTYPE: "Doldurma Türü",
  T_46_META_WS_C_FIRETYPE: "Ateş Türü",
  T_46_META_WS_C_FLOAT: "Ondalık",
  T_46_META_WS_C_FOLDWING: "Katlanabilir Kanatlar",
  T_46_META_WS_C_FOLLOW: "Takip Et",
  T_46_META_WS_C_FONTTYPE: "Yazı Tipi Türü",
  T_46_META_WS_C_FOOTBALL: "Futbol",
  T_46_META_WS_C_FORCETYPE: "Kuvvet Türü",
  T_46_META_WS_C_FORMULABLE: "Formülable",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Çerçeve Kendi Göreceli",
  T_46_META_WS_C_GAMERESULTTYPE: "Oyun Sonucu Türü",
  T_46_META_WS_C_GENDERTYPE: "Cinsiyet Türü",
  T_46_META_WS_C_GENERALSPAWNPOINT: "Genel Spawn Noktası",
  T_46_META_WS_C_GRENADEDEICEWALL: "DeIce Duvarı Grenadı",
  T_46_META_WS_C_GRENADEFLASHBANG: "Patlayıcı",
  T_46_META_WS_C_GRENADEFROZEN: "Dondurucu Grenat",
  T_46_META_WS_C_GRENADELAUNCHER: "El Bombası Fırlatıcı",
  T_46_META_WS_C_GRENADESMOKE: "Duman Grenadı",
  T_46_META_WS_C_GRENADEWEAPON: "El Bombası Temeli",
  T_46_META_WS_C_GRID: "Izgara",
  T_46_META_WS_C_HANDCANNON: "El Bombası El",
  T_46_META_WS_C_HELMET: "Kask",
  T_46_META_WS_C_HIERARCHICAL: "Hiyerarşik",
  T_46_META_WS_C_HOOKGUN: "Kanca Tabancası",
  T_46_META_WS_C_HORIZALINE: "Yatay Çizgi",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UI Dönüştürücü",
  T_46_META_WS_C_HUMANMODELID: "İnsan Modeli ID",
  T_46_META_WS_C_ICEWALL: "Buz Duvarı",
  T_46_META_WS_C_ICEWALLCREATED: "Oluşturulan Buz Duvarı",
  T_46_META_WS_C_ICEWALLMAKER: "Buz Duvarı Yapıcısı",
  T_46_META_WS_C_ICON: "Simge Varlığı",
  T_46_META_WS_C_ICONTYPE: "Simge Türü",
  T_46_META_WS_C_INHALER: "Inhalatör",
  T_46_META_WS_C_INT: "Tam Sayı",
  T_46_META_WS_C_INT64: "64 Bit Tam Sayı",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "Tam Sayı Şablonu",
  T_46_META_WS_C_INTORINTLIST: "Tam Sayı veya Tam Sayı Listesi",
  T_46_META_WS_C_INVENTORYTYPE: "Envanter Türü",
  T_46_META_WS_C_ITEMBASE: "Eşya Temeli",
  T_46_META_WS_C_ITEMCONTAINER: "Ürün Konteyneri",
  T_46_META_WS_C_ITEMID: "Öğenin ID",
  T_46_META_WS_C_ITEMIDTYPE: "Ürün ID Türü",
  "T_46_META_WS_C_JERSEY STYLE": "Forma Stili",
  T_46_META_WS_C_JERSEYMACHINE: "Forma Makinesi",
  T_46_META_WS_C_JETSHOES: "Roketli Ayakkabılar",
  T_46_META_WS_C_KEYBOARD: "Klavye",
  T_46_META_WS_C_KNOCKDOWNTYPE: "Nakavt Türü",
  T_46_META_WS_C_LANDMINE: "Mayın",
  T_46_META_WS_C_LANDMINECREATED: "Oluşturulan Mayın",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "Fırlatma Rampası Seviye Nesnesi",
  T_46_META_WS_C_LAUNCHPAD: "Fırlatma Rampası",
  T_46_META_WS_C_LAYOUTSORTTYPE: "Düzenleme Sıralama Türü",
  T_46_META_WS_C_LEAD1MUSIC: "Lead1 Müziği",
  T_46_META_WS_C_LEAD2MUSIC: "Lead2 Müziği",
  T_46_META_WS_C_LEAD3MUSIC: "Lead3 Müziği",
  T_46_META_WS_C_LEVELOBJECTID: "Seviye Nesnesi ID",
  T_46_META_WS_C_LEVELOBJECTTYPE: "Seviye Nesne Türü",
  T_46_META_WS_C_LIST: "Liste",
  T_46_META_WS_C_LISTORMAP: "Liste veya Harita",
  T_46_META_WS_C_LISTT: "Liste Şablonu",
  T_46_META_WS_C_LISTT_BOOL: "Bool Listi",
  T_46_META_WS_C_LISTT_CONDITION: "Koşul Listesi",
  T_46_META_WS_C_LISTT_ENTITY: "Varlık Listesi",
  T_46_META_WS_C_LISTT_FLOAT: "Kayan Nokta Listesi",
  T_46_META_WS_C_LISTT_INT: "Tam Sayı Listesi",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "Eşya Listesi",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "Seviye Nesne Listesi",
  T_46_META_WS_C_LISTT_LOCKEY: "Yerelleştirme Anahtar Listesi",
  T_46_META_WS_C_LISTT_PLAYABLE: "Oynanabilir Liste",
  T_46_META_WS_C_LISTT_PLAYER: "Oyuncu Listesi",
  T_46_META_WS_C_LISTT_SKILLID: "Yetenek Kimliği Listesi",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "Ses Efektleri Listesi",
  T_46_META_WS_C_LISTT_STRING: "Dize Listesi",
  T_46_META_WS_C_LISTT_TEAM: "Takım Listesi",
  T_46_META_WS_C_LISTT_TYPE: "Tür Listesi",
  T_46_META_WS_C_LISTT_VECTOR3: "Vektör3 Listesi",
  T_46_META_WS_C_LOCKEY: "Yerelleştirme Anahtarı",
  T_46_META_WS_C_LOOKAT: "Bak",
  T_46_META_WS_C_LOOPABLE: "Döngüsel",
  T_46_META_WS_C_LOOPTYPE: "Döngü Türü",
  T_46_META_WS_C_LOOTAMMOTYPE: "Ganimet Mermi Türü",
  T_46_META_WS_C_LOOTARMOR: "Ganimet Zırhı",
  T_46_META_WS_C_LOOTARMORTYPE: "Ganimet Zırh Türü",
  T_46_META_WS_C_LOOTCONSUMABLE: "Ganimet Tüketim Malzemesi",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Ganimet Tüketim Malzemesi Türü",
  T_46_META_WS_C_LOOTIAMMO: "Ganimet Mermi",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Loot Futbol Kutusu",
  T_46_META_WS_C_LOOTSCOPE: "Ganimet Dürbün",
  T_46_META_WS_C_LOOTSCOPETYPE: "Ganimet Dürbün Türü",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Loot Futbol Türü",
  T_46_META_WS_C_LOOTTHROWABLE: "Ganimet Atılabilir",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Ganimet Atılabilir Türü",
  T_46_META_WS_C_LOOTWEAPON: "Ganimet Silahı",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Ganimet Silah Türü",
  T_46_META_WS_C_LOWGRAVITY: "Düşük Yerçekimi Bölgesi",
  T_46_META_WS_C_MAP: "Harita",
  T_46_META_WS_C_MAPT: "Harita Şablonu",
  T_46_META_WS_C_MATERIALID: "Malzeme ID",
  T_46_META_WS_C_MEDKIT: "İlk Yardım Kiti",
  T_46_META_WS_C_MESHID: "Izgara ID",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "Oyun Ortası Çıkış Yapılandırması",
  T_46_META_WS_C_MINIMAP: "Mini Harita",
  T_46_META_WS_C_MINIMAPICON: "Mini Harita Simgesi",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "Minimap Piksel Oluşturucu",
  T_46_META_WS_C_MINISENTRY: "Mini Sentry",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Mini Sentry Saldırı Menzil Türü",
  T_46_META_WS_C_MINISENTRYCREATED: "Mini Sentry Oluşturuldu",
  T_46_META_WS_C_MONEY: "Para",
  T_46_META_WS_C_MONEYTYPE: "Para Türü",
  T_46_META_WS_C_MONSTER: "Canavar",
  T_46_META_WS_C_MONSTERSPAWN: "Canavar Doğma",
  T_46_META_WS_C_MONSTERTYPE: "Canavar Türü",
  T_46_META_WS_C_MORPHABLEOBJECT: "Morf Edilebilir Nesne",
  T_46_META_WS_C_MORPHOBJECT: "Morf Nesnesi",
  T_46_META_WS_C_MOTOBIKE: "Motoiklet",
  T_46_META_WS_C_MOVEPLATFORM: "Hareketli Platform",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "Hareketli Platform Türü",
  T_46_META_WS_C_MUSHROOM: "Mantar",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "Doğal Sabit",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "Numara",
  T_46_META_WS_C_OBJECT: "Nesne",
  T_46_META_WS_C_OILDRUM: "Yağ Fıçısı",
  T_46_META_WS_C_OUTFITID: "Kıyafet ID",
  T_46_META_WS_C_OUTFITSLOTTYPE: "Kıyafet Yuvası Türü",
  T_46_META_WS_C_PATHPOINT: "Yol Noktası",
  T_46_META_WS_C_PATROLSTYLETYPE: "Devriye Stili Türü",
  T_46_META_WS_C_PATROLTYPE: "Devriye Türü",
  T_46_META_WS_C_PERSONA: "Persona",
  T_46_META_WS_C_PHASE: "Aşama",
  T_46_META_WS_C_PHYSICALMOVER: "Fiziksel Taşıyıcı",
  T_46_META_WS_C_PHYSICALOBJECT: "Fiziksel Nesne",
  T_46_META_WS_C_PLATFORMTYPE: "Platform Türü",
  T_46_META_WS_C_PLAYABLE: "Oynanabilir",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Oynanabilir veya Oynanabilirler Dizisi",
  T_46_META_WS_C_PLAYER: "Oyuncu",
  T_46_META_WS_C_PLAYERBACKPACK: "Oyuncu Sırt Çantası",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "Oyuncu Davranış Durum Türü",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "Oyuncu Davranış Türü",
  T_46_META_WS_C_PLAYERCCT: "FF Karakterleri için Karakter Denetleyici",
  T_46_META_WS_C_PLAYERDATAID: "Öntanımlı Karakter Türü",
  T_46_META_WS_C_PLAYERORTRANSFORM: "Oyuncu veya Dönüşüm",
  T_46_META_WS_C_PLAYERORVEHICLE: "Oyuncu veya Araç",
  T_46_META_WS_C_PLAYEROUTFIT: "Oyuncu Kıyafeti",
  T_46_META_WS_C_PLAYERPOSETYPE: "Oyuncu Poz Türü",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "Oyuncu Diriliş Kaynağı Türü",
  T_46_META_WS_C_PLAYERSTATETYPE: "Oyuncu Durum Türü",
  T_46_META_WS_C_POINTLIGHT: "Nokta Işığı",
  T_46_META_WS_C_PORTAL: "Portal",
  T_46_META_WS_C_PREFABID: "Prefab ID",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "Etki Oluşturucu",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "Efekt Doku Türü",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "Profil Resmi Widget'ı",
  T_46_META_WS_C_PROPERTY: "Özellik",
  T_46_META_WS_C_PROPERTYFORMULA: "Özellik Formülü",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "Özellik Formülü Faktör Türü",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "Özellik Değiştirme Türü",
  T_46_META_WS_C_QUATERNION: "Quaternion",
  T_46_META_WS_C_RANKABLE: "Sıralanabilir",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "Işın Çizme Katmanı Türü",
  T_46_META_WS_C_REPAIRKIT: "Onarım Kiti",
  T_46_META_WS_C_RESETABLE: "Sıfırlanabilir",
  T_46_META_WS_C_RIGIDBODY: "RigidBody",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "RigidBody Kısıtlama Türü",
  T_46_META_WS_C_RIGIDBODYTYPE: "RigidBody Türü",
  T_46_META_WS_C_ROUND: "Tur",
  T_46_META_WS_C_SAFEZONE: "Güvenli Bölge",
  T_46_META_WS_C_SCOREABLE: "Skorlanabilir",
  T_46_META_WS_C_SCRIPTID: "Betik ID",
  T_46_META_WS_C_SEATTYPE: "Koltuk Türü",
  T_46_META_WS_C_SELFRELATIVE: "Kendi Göreceli",
  T_46_META_WS_C_SHOP: "Mağaza",
  T_46_META_WS_C_SHOPITEM: "Mağaza Ürünü",
  T_46_META_WS_C_SHOPSHELF: "Mağaza Rafı",
  T_46_META_WS_C_SKATEBOARD: "Kaykay",
  T_46_META_WS_C_SKELETON: "İskelet",
  T_46_META_WS_C_SKELETONPART: "Kemik Parçası",
  T_46_META_WS_C_SKILLID: "Yetenek Kimliği",
  T_46_META_WS_C_SKYBLASTER: "Uçan araç",
  T_46_META_WS_C_SKYBOX: "Gökyüzü Kutusu",
  T_46_META_WS_C_SKYBOXTYPE: "Gökyüzü Tipi",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "Sosyal Ada Kar Topu",
  T_46_META_WS_C_SORTTYPE: "Sıralama Türü",
  T_46_META_WS_C_SOUNDDRUMTYPE: "Davul Sesi Türü",
  T_46_META_WS_C_SOUNDEFFECT: "Ses Efekleri",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "Ses Efekti veya Ses Efekti Listesi",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "Ses Efekti Türü",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Ses Lead1 Türü",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Ses Lead2 Türü",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Ses Lead3 Türü",
  T_46_META_WS_C_SOUNDPIANOTYPE: "Piyano Sesi Türü",
  T_46_META_WS_C_SPAWN: "Spawn",
  T_46_META_WS_C_SPAWNABLE: "Oluşturulabilir",
  T_46_META_WS_C_SPAWNBOX: "Başlangıç Alanı",
  T_46_META_WS_C_SPAWNPOSITION: "Doğma Noktası",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "Özel Ürün ID Türü",
  T_46_META_WS_C_SPHERETRIGGER: "Küre Tetikleyici",
  T_46_META_WS_C_SPORTSCAR: "Spor Araba",
  T_46_META_WS_C_SPRAYCOLOR: "Sprey Rengi",
  T_46_META_WS_C_SPRAYGUN: "Sprey Tabancası",
  T_46_META_WS_C_SPRAYRESULTUI: "Sprey Sonuç UI",
  T_46_META_WS_C_SPRAYRIFLE: "Sprey Tüfeği",
  T_46_META_WS_C_SPRITEID: "Sprite ID",
  T_46_META_WS_C_STATICSCRIPTID: "Statik Betik ID",
  T_46_META_WS_C_STRING: "Dize",
  T_46_META_WS_C_STRINGORLOCSTRING: "Dize veya Yerelleştirilmiş Dize",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "Tedarik Kutusu Tetikleyici",
  T_46_META_WS_C_SWINGGUN: "Salınım Tabancası",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "Ekipman Yuvasını Değiştir",
  T_46_META_WS_C_TEAM: "Takım",
  T_46_META_WS_C_TERRAIN: "Arazi",
  T_46_META_WS_C_TEXT: "Metin Varlığı",
  T_46_META_WS_C_TEXTUREID: "Doku ID",
  T_46_META_WS_C_TEXTURETYPE: "Nesne Dokusu",
  T_46_META_WS_C_TIMER: "Zamanlayıcı",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "Zaman Damgası Format Stili Türü",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "Zaman Damgası Yerelleştirme Dizesi",
  T_46_META_WS_C_TRAJECTORY: "Yörünge",
  T_46_META_WS_C_TRANSFORM: "Dönüştür",
  T_46_META_WS_C_TUKTUK: "Tuk Tuk",
  T_46_META_WS_C_TURRET: "Kule",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Tween Eğrisi",
  T_46_META_WS_C_TWEENSTYLE: "Tween Tarzı Türü",
  T_46_META_WS_C_TYPE: "Tür",
  T_46_META_WS_C_TYPEENUM: "Tür Enum",
  T_46_META_WS_C_TYPEORTYPELIST: "Tür veya Tür Listesi",
  T_46_META_WS_C_UIADDSCORE: "UI Skor Ekleme",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI Animasyon Tetikleyici HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "UI Dahili Anahtar",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "UI Dahili UI Anahtar Kontrolü",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI Kart Seçim Paneli",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI Kontrol Noktası Göstergesi",
  T_46_META_WS_C_UICOMPASS: "UI Pusula",
  T_46_META_WS_C_UICOUNTDOWN5: "UI 5 Saniyelik Geri Sayım",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI Geri Sayım İpucu",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI Geri Sayım Hatırlatıcısı",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "Karakterin başının üzerinde sağlık çubuğu",
  T_46_META_WS_C_UIHEALTHBAR: "UI Sağlık Çubuğu",
  T_46_META_WS_C_UIHEARTBEAT: "UI Kalp Atışı",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI Simge Bildirimi",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI Kimlik Bildirimi",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI Etkileşim Düğmesi",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI Liderlik Tablosu Düğmesi",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI Maç Altyazısı",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI Canavar Seviyesi",
  T_46_META_WS_C_UIMONSTERUI: "UI Canavar UI",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI Çoklu Takım Liderlik Tablosu",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI Çoklu Takım Sonuç Paneli",
  T_46_META_WS_C_UIOPENINGBANNER: "UI Açılış Afişi",
  T_46_META_WS_C_UIPANEL: "UI Panel",
  T_46_META_WS_C_UIPANELEMPTY: "Boş UI Panel",
  T_46_META_WS_C_UIPHASETIMER: "UI Aşama Zamanlayıcı",
  T_46_META_WS_C_UIPROGRESSBAR: "UI İlerleme Çubuğu",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI İlerleme Çemberi",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI İlerleme Beceri Düğmesi",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI Satın Alma İsteği Türü",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI Tur Bilgisi Afişi",
  T_46_META_WS_C_UIROUNDNUMBER: "UI Tur Numarası",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI Tur Sonucu Afişi",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI Tur Başlangıç Afişi",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI Tur Geçişi",
  T_46_META_WS_C_UISCOREBAR: "UI Skor Çubuğu",
  T_46_META_WS_C_UISCROLLPANEL: "UI Kaydırma Paneli",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI Basit Tur Skor Afişi",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI Basit Tur Başlangıç Afişi",
  T_46_META_WS_C_UISIMPLETIP: "Basit UI İpucu",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI Basit Karşılaşma Afişi",
  T_46_META_WS_C_UISKILLBUTTON: "UI Beceri Düğmesi",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "Sosyal işlev düğmesi widget'ı",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI Solo Liderlik Tablosu",
  T_46_META_WS_C_UISTORE: "UI Mağaza UI",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI Takım Maçı Bilgisi",
  T_46_META_WS_C_UITEXTTIP: "UI Metin İpucu",
  T_46_META_WS_C_UITIMERINFO: "UI Zamanlayıcı Bilgisi",
  T_46_META_WS_C_UITIPBUTTON: "UI İpucu Düğmesi",
  T_46_META_WS_C_UITITLEBANNER: "UI Başlık Afişi",
  T_46_META_WS_C_UITWEENTIP: "UI Tween İpucu",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI İki Takım Kısa Bilgisi",
  T_46_META_WS_C_UITWOTEAMINFO: "UI İki Takım Bilgisi",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI İki Takım Liderlik Tablosu",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI İki Takım Sonuç Paneli",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI İki Takım Tur Skor Afişi",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI İki Takım Skor Paneli",
  T_46_META_WS_C_UIVERSUSBANNER: "UI Karşılaşma Afişi",
  T_46_META_WS_C_UIWIDGET: "UI Widget",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI Widget Düğmesi",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI Widget Kabı",
  T_46_META_WS_C_UIWIDGETEMPTY: "Boş UI Widget",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI Widget Görüntüsü",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI Widget Giriş Etiketi",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI Widget Joystick",
  T_46_META_WS_C_UIWIDGETLABEL: "UI Widget Etiketi",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI Widget Düzeni",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI Widget Profili",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI Widget Dokusu",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI Widget Geçiş Anahtarı",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI Widget Dokunmatik Yüzey",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI Kazan-Kaybet Afişi",
  T_46_META_WS_C_UNITSPAWN: "Birim Üretici",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "Pencere Tırmanma Mantığı Nesnesi",
  T_46_META_WS_C_VECTOR2: "Vektör2",
  T_46_META_WS_C_VECTOR3: "Vektör3",
  T_46_META_WS_C_VEHICLE: "Araç",
  T_46_META_WS_C_VEHICLEIDTYPE: "Araç ID Türü",
  T_46_META_WS_C_VEHICLESKINID: "Araç Kaplama ID",
  T_46_META_WS_C_VENDINGMACHINE: "Satış Makinesi",
  T_46_META_WS_C_VEST: "Yelek",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "Değiştirilebilir Doku VFX Varlığı",
  T_46_META_WS_C_VFXTEXTURE: "VFX Dokusu",
  T_46_META_WS_C_VISIBILITY: "Görünürlük",
  T_46_META_WS_C_WALLET: "Cüzdan",
  T_46_META_WS_C_WALLETHUD: "Cüzdan UI",
  T_46_META_WS_C_WATERZONE: "Su Bölgesi",
  T_46_META_WS_C_WAVECOUNTTYPE: "Dalga Sayısı Türü",
  T_46_META_WS_C_WAVEINTERVALTYPE: "Dalga Aralığı Türü",
  T_46_META_WS_C_WEAPON: "Silah",
  T_46_META_WS_C_WEAPONGENERATOR: "Silah Üretici",
  T_46_META_WS_C_WEAPONSKINID: "Silah Kaplaması ID",
  T_46_META_WS_C_WEAPONTYPE: "Silah Türü",
  T_46_META_WS_C_WIDGETTYPE: "Widget Türü",
  T_46_META_WS_C_ZIPLINE: "Teleferik",
  T_46_META_WS_CAMERADIRECTION: "Kamera Yönü",
  T_46_META_WS_CAMERAPOSITION: "Kamera Pozisyonu",
  T_46_META_WS_CAPSULECAST: "Kapsül Cast",
  T_46_META_WS_CAPSULEOVERLAP: "Kapsül Çakışması",
  T_46_META_WS_CEIL: "Yukarı Yuvarla",
  T_46_META_WS_CHATCHANNEL: "Sohbet Kanalı",
  T_46_META_WS_CHECKTRIGGERBYORDER: "Sıralamaya Göre Tetikleyiciyi Kontrol Et",
  T_46_META_WS_CLAMP: "Sıkıştır",
  T_46_META_WS_CLEAR: "Temizle",
  T_46_META_WS_CLEARALLCHILDREN: "Tüm Çocukları Sil",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "AOI Özel Takibi Temizle",
  T_46_META_WS_CLEARBACKPACK: "Çantayı Boşalt",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "Formül Özellik Faktörünü Temizle",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "Kalan Seviye Nesnelerini Temizle",
  T_46_META_WS_CLIPNAME: "Klip Adı",
  T_46_META_WS_CLONE: "Kopyala",
  T_46_META_WS_COLLIDEDENTITY: "Çarpışan Varlık",
  T_46_META_WS_COLORGET: "Renk Al",
  T_46_META_WS_COMPLETECUSTOMMISSION: "Özel Görevi Tamamla",
  T_46_META_WS_CONNECT: "Bağla",
  T_46_META_WS_CONSUMABLEID: "Eşya Kimliği",
  T_46_META_WS_CONTAIN: "İçeriyor",
  T_46_META_WS_CONTAINKEY: "Anahtar Var mı",
  T_46_META_WS_COPYTOMORPH: "Dönüşümü Kopyala",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "Para Harca",
  T_46_META_WS_COSTTOKEN: "Token Harca",
  T_46_META_WS_CREATEAIRDROP: "Hava Düşüşü Kutusu Oluştur",
  T_46_META_WS_CREATEBOT: "Bot Oluştur",
  T_46_META_WS_CREATEBUILTINUI: "Yerleşik UI Oluştur",
  T_46_META_WS_CREATEBUILTINUICLIENT: "Yerleşik UI Oluştur",
  T_46_META_WS_CREATECAMERA: "Kamera Oluştur",
  T_46_META_WS_CREATECURVE: "Eğri Oluştur",
  T_46_META_WS_CREATECUSTOMUI: "Özelleştirilmiş UI Oluştur",
  T_46_META_WS_CREATECUSTOMUICLIENT: "Özelleştirilmiş UI Oluştur",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "Özelleştirilmiş UI Widget Oluştur",
  T_46_META_WS_CREATEDAMAGENUM: "Hasar Sayısı Oluştur",
  T_46_META_WS_CREATEEFFECT: "Etki Oluştur",
  T_46_META_WS_CREATEEFFECTCLIENT: "Etki Oluştur",
  T_46_META_WS_CREATEFACTION: "Fraksiyon Oluştur",
  T_46_META_WS_CREATEFOLLOW: "Takip Oluştur",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "Her Karede Kendi Kendine Göre Yarat",
  T_46_META_WS_CREATEFROMPREFAB: "Prefab'tan Oluştur",
  T_46_META_WS_CREATELEVELOBJECT: "Seviye Nesnesi Oluştur",
  T_46_META_WS_CREATELOOKAT: "Bakış Oluştur",
  T_46_META_WS_CREATEMINIMAPICON: "Mini Harita İkonu Oluştur",
  T_46_META_WS_CREATEMINIMAPPIXEL: "Mini Harita Pikselleri Oluştur",
  T_46_META_WS_CREATEMONSTER: "Canavar Oluştur",
  T_46_META_WS_CREATEMORPH: "Dönüşüm Oluştur",
  T_46_META_WS_CREATESELFRELATIVE: "Kendi Kendine Göre Yarat",
  T_46_META_WS_CREATESHOP: "Mağaza Oluştur",
  T_46_META_WS_CREATESHOPITEM: "Ürün Oluştur",
  T_46_META_WS_CREATESHOPSHELF: "Mağaza Rafı Oluştur",
  T_46_META_WS_CREATESOUND: "Ses Oluştur",
  T_46_META_WS_CREATESOUNDCLIENT: "Ses Oluştur",
  T_46_META_WS_CREATETOKENINSCENE: "Sahneye Token Oluştur",
  T_46_META_WS_CREATETRAJECTORY: "Yörünge Oluştur",
  T_46_META_WS_CREATETWEEN: "Tween Oluştur",
  T_46_META_WS_CREATEWALLET: "Cüzdan Oluştur",
  T_46_META_WS_CROSS: "Çarpışma",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "CSV Sütun Adını Tam Sayıya Dönüştür",
  T_46_META_WS_CURRENTAMMOCOUNT: "Mevcut Mermi Sayısı",
  T_46_META_WS_DAMAGE: "Hasar",
  T_46_META_WS_DAMAGEDBODYPART: "Hasar Gören Vücut Parçası",
  T_46_META_WS_DAMAGEDPLAYERS: "Hasar Gören Oyuncular",
  T_46_META_WS_DAMAGETYPE: "Hasar Türü",
  T_46_META_WS_DEALDAMAGE: "Hasar Ver",
  T_46_META_WS_DELETE: "Sil",
  T_46_META_WS_DELETEAT: "Belirli Bir Yerden Sil",
  T_46_META_WS_DELETECUSTOMUI: "Özelleştirilmiş UI'yi Sil",
  T_46_META_WS_DELETEFROMDATABASE: "Veritabanından Sil",
  T_46_META_WS_DELETEFROMDATASTORE: "Veri Deposundan Sil",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "Anahtarla Sıralama Veritabanından Sil",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "Sıralamaya Göre Sıralama Veritabanından Sil",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Veri Deposundan Anahtara Göre Sil (Sıralama)",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "Veri Deposundan Sıralamaya Göre Sil",
  T_46_META_WS_DELETETAG: "Etiketi Sil",
  T_46_META_WS_DELTA: "Delta",
  T_46_META_WS_DESTROY: "Yok Et",
  T_46_META_WS_DESTROYBOT: "Botu Yok Et",
  T_46_META_WS_DESTROYBUILTINUI: "Yerleşik UI'yi Yok Et",
  T_46_META_WS_DESTROYEQUIPMENT: "Ekipmanı Yok Et",
  T_46_META_WS_DESTROYITEM: "Öğeyi Yok Et",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "Yönü Euler Açısına Dönüştür",
  T_46_META_WS_DISABLESAFEZONE: "Güvenli Bölgeyi Devre Dışı Bırak",
  T_46_META_WS_DISPATCHEVENT: "Olay Gönder",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "Platform ile Olay Gönder",
  T_46_META_WS_DISTANCE: "Mesafe",
  T_46_META_WS_DOT: "Nokta",
  T_46_META_WS_DROPITEM: "Eşyayı Bırak",
  T_46_META_WS_DYEATAREA: "Alanı Boya",
  T_46_META_WS_DYEATPLANE: "Düzlemde Boya",
  T_46_META_WS_DYEATPOSITION: "Konumda Boya",
  T_46_META_WS_E_ABNORMALGRAVZONE: "Düşük Yerçekimi Alanı",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "İvme",
  T_46_META_WS_E_ACTIONNODE: "EylemDüğümü",
  T_46_META_WS_E_ACTIVE: "Aktif",
  T_46_META_WS_E_ACTIVESKILL: "Aktif Beceri",
  T_46_META_WS_E_ADBOARD: "Reklam Panosu",
  T_46_META_WS_E_ADD: "Ekle",
  T_46_META_WS_E_ADDFRIEND: "Arkadaş Ekle",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "Hedefleme",
  T_46_META_WS_E_AIR: "Hava",
  T_46_META_WS_E_AIRCONDITIONERA: "Klima",
  T_46_META_WS_E_AIRDROP: "Hava Düşüşü, Zombi İntiharı",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "Canlı",
  T_46_META_WS_E_AMMO: "Mermi VFX",
  T_46_META_WS_E_AMPHIBIANCAR: "Amfibi Araç",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "Çocuklar Oynuyor",
  T_46_META_WS_E_AR: "Tüfek",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "AR Mermisi",
  T_46_META_WS_E_ARMAGAZINE: "AR Şarjör",
  T_46_META_WS_E_ARMOR: "Zırh",
  T_46_META_WS_E_ARMORBUFF: "Zırh Buff",
  T_46_META_WS_E_ARMORLV1: "Zırh Lv1",
  T_46_META_WS_E_ARMORLV2: "Zırh Lv2",
  T_46_META_WS_E_ARMORLV3: "Zırh Lv3",
  T_46_META_WS_E_ARMORPIERCING: "Zırh Kırma",
  T_46_META_WS_E_ARMORSPECIALIST: "Yetenek 1",
  T_46_META_WS_E_ARROW: "Ok",
  T_46_META_WS_E_ASC: "Artan Sıralama",
  T_46_META_WS_E_ASCIGNOREZERO: "Artan Sıralama Sıfırları Hariç Tut",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "Gaz Patlaması",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Uyumluluk İçin Aksesuar1",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Uyumluluk İçin Aksesuar4",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Uyumluluk İçin Aksesuar5",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Uyumluluk İçin Aksesuar6",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Uyumluluk İçin Aksesuar8",
  T_46_META_WS_E_ATTACK: "Saldırı",
  T_46_META_WS_E_ATTACKGRENADE: "Saldırı Bombası",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "Otomatik",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "Geri Dön",
  T_46_META_WS_E_BACKANDFORTH: "Gidiş Dönüş",
  T_46_META_WS_E_BAG: "Çanta",
  T_46_META_WS_E_BAG1: "Çanta1",
  T_46_META_WS_E_BAG2: "Çanta2",
  T_46_META_WS_E_BAG3: "Çanta3",
  T_46_META_WS_E_BAMBOOA: "Bambu A",
  T_46_META_WS_E_BANANATREE: "Muz Ağacı",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "Temel Katsayı",
  T_46_META_WS_E_BASIC: "Temel",
  T_46_META_WS_E_BASICCONE: "Temel Konik",
  T_46_META_WS_E_BASICCYLINDER: "Temel Silindir",
  T_46_META_WS_E_BASICSPHERE: "Temel Küre",
  T_46_META_WS_E_BATTLEINSTYLE: "Tarzda Savaş",
  T_46_META_WS_E_BELL: "Zil",
  T_46_META_WS_E_BENCH: "Bank",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "Büyük Ekran",
  T_46_META_WS_E_BIPOD: "İki Ayak",
  T_46_META_WS_E_BISGRAFFITIWALL: "BIS Temalı Duvar",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "Kara Delik Patlama VFX",
  T_46_META_WS_E_BLACKHOLEBOOM: "Kristal Top VFX",
  T_46_META_WS_E_BLAST: "Patlama",
  T_46_META_WS_E_BLOCK: "Kare",
  T_46_META_WS_E_BLOODBALL: "Kara Delik VFX",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "Mavi",
  T_46_META_WS_E_BLUEDOLL: "Buz Bebek",
  T_46_META_WS_E_BOARD: "Hareketli Platform",
  T_46_META_WS_E_BODY: "Gövde",
  T_46_META_WS_E_BOMBINDICATION: "Bombalarmı",
  T_46_META_WS_E_BOMBPLIERS: "Bomba Pense",
  T_46_META_WS_E_BONFIRE: "Yanmakta Olan Ateş",
  T_46_META_WS_E_BOOM: "Patlama",
  T_46_META_WS_E_BOOYAH: "Zafer",
  T_46_META_WS_E_BOTH: "İkisi de",
  T_46_META_WS_E_BOUNCETIRE: "Lastik",
  T_46_META_WS_E_BOWAMMO: "Yaylı Mermi",
  T_46_META_WS_E_BREAKABLEBOX: "Yıkılabilir Ahşap Kasa",
  T_46_META_WS_E_BREAKABLECONTAINER: "Yıkılabilir Konteyner",
  T_46_META_WS_E_BREAKABLEFENCE: "Yıkılabilir Çit",
  T_46_META_WS_E_BRICKA: "Tuğla A",
  T_46_META_WS_E_BRICKB: "Tuğla B",
  T_46_META_WS_E_BRICKC: "Tuğla C",
  T_46_META_WS_E_BRICKHOUSEA: "Küçük Ev A",
  T_46_META_WS_E_BRIGHT: "Açık",
  T_46_META_WS_E_BUBBLE: "Baloncuk",
  T_46_META_WS_E_BUFFGENERATOR: "Buff Üretici",
  T_46_META_WS_E_BULLETBUFF: "Mermi Buff",
  T_46_META_WS_E_BULLETHITTING: "Kurşun Iskalamak",
  T_46_META_WS_E_BUMPERCAR: "Pandalı Araba",
  T_46_META_WS_E_BUMPERCARFACTORY: "Bumper Car Üreticisi",
  T_46_META_WS_E_BURNING: "Araç Patlamasında Yanma Hasarı",
  T_46_META_WS_E_BUSHES: "Çalılar",
  T_46_META_WS_E_BUSSTOP: "Otobüs Durağı",
  T_46_META_WS_E_BUTTOM: "Alt Giysi",
  T_46_META_WS_E_BUTTONWIDGET: "Düğme Araç",
  T_46_META_WS_E_BYHIERARCHY: "Hiyerarşiye Göre",
  T_46_META_WS_E_CABINET: "Dolap",
  T_46_META_WS_E_CACTUS: "Kaktüs",
  T_46_META_WS_E_CAMOUFLAGE: "Yetenek 6",
  T_46_META_WS_E_CAPSULETRIGGER: "Kapsül Tetikleyici",
  T_46_META_WS_E_CARDIOTONIC: "Kardiyotonik",
  T_46_META_WS_E_CASUALGAMEBGM: "Rahat Oyun BGM",
  T_46_META_WS_E_CEMENTA: "Çimento A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "Kanal A",
  T_46_META_WS_E_CHANNELB: "Kanal B",
  T_46_META_WS_E_CHANNELC: "Kanal C",
  T_46_META_WS_E_CHANNELD: "Kanal D",
  T_46_META_WS_E_CHANNELE: "Kanal E",
  T_46_META_WS_E_CHANNELF: "Kanal F",
  T_46_META_WS_E_CHARACTERSKILL: "Karakter Yetenekleri",
  T_46_META_WS_E_CHARACTOR: "Karakter",
  T_46_META_WS_E_CHARGE: "Şarj 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "Kontrol Noktası",
  T_46_META_WS_E_CHEER: "Teşvik",
  T_46_META_WS_E_CHERRYBLOSSOM: "Kiraz Ağacı",
  T_46_META_WS_E_CIRCLE: "Çember",
  T_46_META_WS_E_CIRCLEBACK: "Döngü",
  T_46_META_WS_E_CIRCLEOFHEAT: "Ayak Işığı",
  T_46_META_WS_E_CITY: "Şehir",
  T_46_META_WS_E_CLAPS: "Alkış",
  T_46_META_WS_E_CLEAR: "Temizle",
  T_46_META_WS_E_CLIENT: "İstemci",
  T_46_META_WS_E_CLONE: "Görünüş Değiştirici",
  T_46_META_WS_E_CLONEKILL: "Klon Ölümü",
  T_46_META_WS_E_CLOSE: "Kapat",
  T_46_META_WS_E_CLOTHES: "Kıyafet",
  T_46_META_WS_E_COINGENERATOR: "Altın Üreteci",
  T_46_META_WS_E_COLDAIR: "Sis",
  T_46_META_WS_E_COLORBLOCK: "Boyanmış Blok",
  T_46_META_WS_E_COLOROILBARREL: "Boyanmış Yağ Varili",
  T_46_META_WS_E_COMBINEALL: "Hepsiyle Birleştir",
  T_46_META_WS_E_COMBINESELF: "Kendinle Birleştir",
  T_46_META_WS_E_COMBOKEYA1: "Müzik Notları - Synthesizer A",
  T_46_META_WS_E_COMBOKEYA2: "Müzik Notları - Synthesizer A",
  T_46_META_WS_E_COMBOKEYB1: "Müzik Notları - Synthesizer B",
  T_46_META_WS_E_COMBOKEYB2: "Müzik Notları - Synthesizer B",
  T_46_META_WS_E_COMBOKEYC1: "Müzik Notları - Synthesizer C",
  T_46_META_WS_E_COMBOKEYC2: "Müzik Notları - Synthesizer C",
  T_46_META_WS_E_CONCRETEPILLAR: "Beton Direk",
  T_46_META_WS_E_CONDITIONNODE: "KoşulDüğümü",
  T_46_META_WS_E_CONTAINERA: "Konteyner A",
  T_46_META_WS_E_CONTAINERB: "Konteyner B",
  T_46_META_WS_E_CONTAINERC: "Konteyner C",
  T_46_META_WS_E_CONTAINERWIDGET: "Konteyner Araç",
  T_46_META_WS_E_CONTINUOUS: "Sürekli",
  T_46_META_WS_E_COUNTDOWN: "Geri Sayım",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "Geri Sayım",
  T_46_META_WS_E_COUNTDOWNDIDI: "Geri Sayım Bip Sesi",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "Geri Sayım",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "Geri Sayım 3",
  T_46_META_WS_E_CROSS: "Çarpı",
  T_46_META_WS_E_CROSSBOW: "Okçuluk",
  T_46_META_WS_E_CROSSHAIR: "Nişangah",
  T_46_META_WS_E_CROSSHAIRS: "Nişangah",
  T_46_META_WS_E_CROUCH: "Çömel",
  T_46_META_WS_E_CROUCHING: "Çömelmiş",
  T_46_META_WS_E_CROWCAW: "Karga Ötüşü",
  T_46_META_WS_E_CROWN: "Taç",
  T_46_META_WS_E_CUBE: "Blok Mekanizması",
  T_46_META_WS_E_CURSE: "Tılsım",
  T_46_META_WS_E_CURSEEXPLOSION: "Tılsım Patlaması",
  T_46_META_WS_E_CUSTOM: "Özelleştirilmiş Kamera",
  T_46_META_WS_E_CUSTOMTRIGGER: "Özelleştirilmiş Tetikleyici",
  T_46_META_WS_E_CUSTOMWATERZONE: "Özel Su Alanı",
  T_46_META_WS_E_CYCLICCOMBUSTION: "Döngüsel Yanma",
  T_46_META_WS_E_CYLIC: "Döngüsel",
  T_46_META_WS_E_DAGGER: "Atma Bıçağı",
  T_46_META_WS_E_DAMAGEDTRUCK: "Hasarlı Kamyon",
  T_46_META_WS_E_DAMAGEZONE: "Hasar Bölgesi",
  T_46_META_WS_E_DANGERALARM: "Tehlike 2",
  T_46_META_WS_E_DANGERVIBRATING: "Tehlike 1",
  T_46_META_WS_E_DARK: "Koyu",
  T_46_META_WS_E_DARKNESS: "Karanlık",
  T_46_META_WS_E_DASHATTACK: "Yüksek Hızlı Saldırı",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "Veri Depolama Limiti Aşıldı",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "Veri Depolama Parametre Hatası",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "Veri Depolama Zaman Aşımı",
  T_46_META_WS_E_DATETIME: "Tarih ve Saat",
  T_46_META_WS_E_DAY: "Gün",
  T_46_META_WS_E_DEAD: "Ölü",
  T_46_META_WS_E_DEATH: "Ölü",
  T_46_META_WS_E_DEFAULT: "Varsayılan",
  T_46_META_WS_E_DEFAULTFIST: "Yumruk",
  T_46_META_WS_E_DEFENCEGRENADE: "Savunma Bombası",
  T_46_META_WS_E_DESC: "Azalan Sıralama",
  T_46_META_WS_E_DIALOGUE: "Diyalog",
  T_46_META_WS_E_DIAMOND: "Elmas",
  T_46_META_WS_E_DIRECTIONSIGN: "İşaret",
  T_46_META_WS_E_DIRVEVEHICLE: "Aracı Sür",
  T_46_META_WS_E_DISABLE: "Devre Dışı Bırak",
  T_46_META_WS_E_DISABLED: "Devre Dışı",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "Kaybolma Uyarısı",
  T_46_META_WS_E_DISCONNECT: "Bağlantı Kesildi",
  T_46_META_WS_E_DISGUISE: "Klon",
  T_46_META_WS_E_DOGHOUSE: "Köpek Evi",
  T_46_META_WS_E_DOOR: "Kapı",
  T_46_META_WS_E_DOUBLE: "Çiftli",
  T_46_META_WS_E_DOUBLEDOOR: "Çift Kapı",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "Çift Zıplama Ayakkabısı",
  T_46_META_WS_E_DOUBLEMAGEZINE: "Çift Şarjör",
  T_46_META_WS_E_DRAW: "Beraberlik",
  T_46_META_WS_E_DRILLZOMBIE: "Matkap Zombisi",
  T_46_META_WS_E_DRIVE: "Sürmek",
  T_46_META_WS_E_DRIVER: "Şoför",
  T_46_META_WS_E_DROPBEAT: "Yetenek 4",
  T_46_META_WS_E_DRUMKEY1: "Müzik Notları - Davul",
  T_46_META_WS_E_DRUMKEY2: "Müzik Notları - Davul",
  T_46_META_WS_E_DUEL: "Savaş",
  T_46_META_WS_E_DUMMY: "Kukla",
  T_46_META_WS_E_DUMMYGRENADE: "Sahte El Bombası",
  T_46_META_WS_E_DUMP: "Boşalt",
  T_46_META_WS_E_DUSK: "Alacakaranlık",
  T_46_META_WS_E_DUST: "Duman ve Toz",
  T_46_META_WS_E_DYNAMIC: "Dinamik",
  T_46_META_WS_E_E: "Doğal Sabit",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "Kolay",
  T_46_META_WS_E_ELECTRICSHOCK: "Elektrik Şoku",
  T_46_META_WS_E_ELECTRICSURFBOARD: "Elektrikli Sörf Tahtası",
  T_46_META_WS_E_ELECTRICZONE: "Elektrik Bölgesi",
  T_46_META_WS_E_ELECTRONICBGM: "Sevimli Elektronik Fantezi BGM",
  T_46_META_WS_E_ELIMINATEDBOSS: "Lonca Liderini Görevden Alma",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "Öldürme İpucu",
  T_46_META_WS_E_EMOTE: "Duygu İfadesi",
  T_46_META_WS_E_ENABLE: "Etkinleştir",
  T_46_META_WS_E_ENERGETIC: "Enerjik",
  T_46_META_WS_E_ENTERVEHICLE: "Araca Gir",
  T_46_META_WS_E_EP: "Enerji Puanı (EP)",
  T_46_META_WS_E_EXCLAMATIONMARK: "Ünlem İşareti",
  T_46_META_WS_E_EXIT: "Çıkış",
  T_46_META_WS_E_EXITVEHICLE: "Araçtan Çık",
  T_46_META_WS_E_EXPLODE: "Kendini Patlatma",
  T_46_META_WS_E_EXPLOSION: "Patlama VFX",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "Patlama Alevleri",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "Enerji Küresi Yetenek",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "Patlayıcı Zombi",
  T_46_META_WS_E_EYE: "Gözlük",
  T_46_META_WS_E_FACEPAINT: "Yüz Boyası",
  T_46_META_WS_E_FACTION: "Taraf",
  T_46_META_WS_E_FALLING: "Düşme",
  T_46_META_WS_E_FALLINGSTAR: "Tüketilebilir Eşyayı Al",
  T_46_META_WS_E_FALSE: "Hayır",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "Pervane Mekanizması",
  T_46_META_WS_E_FAR: "Uzak",
  T_46_META_WS_E_FEATHER: "Tüy",
  T_46_META_WS_E_FEMALE: "Kadın",
  T_46_META_WS_E_FENCE: "Çit",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "SavaşBirimi",
  T_46_META_WS_E_FILLED: "Dolgulu",
  T_46_META_WS_E_FINISH: "Bitir",
  T_46_META_WS_E_FINISHINGPOINT: "Bitiş Noktası",
  T_46_META_WS_E_FINISHLINEARCH: "Finisher Afişi",
  T_46_META_WS_E_FIRE: "Ateş",
  T_46_META_WS_E_FIRECHARGE: "Ateş Topu",
  T_46_META_WS_E_FIREWORK: "Havai Fişek",
  T_46_META_WS_E_FIRINGEFFECT: "Ateş Etme VFX",
  T_46_META_WS_E_FIRSTPERSON: "Birinci Şahıs Kamerası",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "Birinci Şahıs Kamerası (Klasik)",
  T_46_META_WS_E_FIST: "Yumruk",
  T_46_META_WS_E_FIT: "Uygun",
  T_46_META_WS_E_FLAG: "Bayrak",
  T_46_META_WS_E_FLAME: "Ateş",
  T_46_META_WS_E_FLAMEGUN: "Alev Silahı",
  T_46_META_WS_E_FLAMETHROWER: "Alev Silahı",
  T_46_META_WS_E_FLASH: "El Flaşbang",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "El Feneri Dumanı",
  T_46_META_WS_E_FLASHFREEZE: "Anlık Dondurma",
  T_46_META_WS_E_FLEXWALL: "Çekilebilir Duvar",
  T_46_META_WS_E_FLICKER: "Titreme",
  T_46_META_WS_E_FLOWER: "Çiçek",
  T_46_META_WS_E_FLYBOMBBEE: "Uçan Bomba Arı",
  T_46_META_WS_E_FLYPAN: "Kızartma Tavası Mekanizması",
  T_46_META_WS_E_FLYSHOE: "Uçan Ayakkabı",
  T_46_META_WS_E_FOLDER: "Klasör",
  T_46_META_WS_E_FOLDWINGS: "Katlanır Kanatlar",
  T_46_META_WS_E_FOODTRUCK: "Yiyecek Kamyonu",
  T_46_META_WS_E_FOODTRUCKB: "Yiyecek Kamyonu B",
  T_46_META_WS_E_FOOTBALL: "Futbol",
  T_46_META_WS_E_FOOTBALLGUN: "Futbol Tabancası",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "Futbolcu",
  T_46_META_WS_E_FORCE: "Kuvvet",
  T_46_META_WS_E_FOREGRIP_MR: "MR Ön Tutma Yeri",
  T_46_META_WS_E_FOREGRIP1: "Ön Tutma Yeri1",
  T_46_META_WS_E_FOREGRIP2: "Ön Tutma Yeri2",
  T_46_META_WS_E_FOREGRIP3: "Ön Tutma Yeri3",
  T_46_META_WS_E_FORWARD: "İleri",
  T_46_META_WS_E_FOUNTAIN: "Şelale",
  T_46_META_WS_E_FREE: "Serbest Kamera",
  T_46_META_WS_E_FREEZEALL: "Her Şey Dondur",
  T_46_META_WS_E_FREEZEPOSITION: "Dondur",
  T_46_META_WS_E_FREEZEPOSITIONX: "X Dondur",
  T_46_META_WS_E_FREEZEPOSITIONY: "Y Dondur",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Z Dondur",
  T_46_META_WS_E_FREEZEROTATION: "Dondur",
  T_46_META_WS_E_FREEZEROTATIONX: "X Dondur",
  T_46_META_WS_E_FREEZEROTATIONY: "Y Dondur",
  T_46_META_WS_E_FREEZEROTATIONZ: "Z Dondur",
  T_46_META_WS_E_FREEZEZONE: "Donmuş Alan",
  "T_46_META_WS_E_FROST GALAXY": "Donmuş Galaksi",
  T_46_META_WS_E_FROZEN: "Donma",
  T_46_META_WS_E_FROZENGRENADE: "Donma Granatı",
  T_46_META_WS_E_FUNCTIONALITEMS: "Fonksiyonel Öğeler",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "Oyun",
  T_46_META_WS_E_GAMEOVER: "Oyun Sonu 2",
  T_46_META_WS_E_GAMESTART: "Oyun Başlangıcı",
  T_46_META_WS_E_GARAGE: "Garaj",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "Mekanizma Etkinleştirildi",
  T_46_META_WS_E_GENTLETAP: "Hafif Dokunuş",
  T_46_META_WS_E_GETITEM: "Tüketilebilir Eşya 2 Al",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "Hayalet",
  T_46_META_WS_E_GIANTDICE: "Zar",
  T_46_META_WS_E_GIANTLOLLIPOP: "Dev Şekerleme",
  T_46_META_WS_E_GIFT: "Hediye",
  T_46_META_WS_E_GLOOWALL: "Jel Duvarı",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS Temalı Çiçek Yatakları",
  T_46_META_WS_E_GRAFFITIWALL: "Grafiti Duvarı",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "Kanca Silahı",
  T_46_META_WS_E_GREATCONDUCTOR: "Büyük Şef",
  T_46_META_WS_E_GREEN: "Yeşil",
  T_46_META_WS_E_GRENADE: "El Bombası",
  T_46_META_WS_E_GRID: "Izgara",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "Gözetleme Kulesi",
  T_46_META_WS_E_GUILD: "Lonca",
  T_46_META_WS_E_GUN: "Silah",
  T_46_META_WS_E_GUNFIRE: "Silah sesi",
  T_46_META_WS_E_HALO: "Halka",
  T_46_META_WS_E_HAMMER: "Dev Çekiç Mekanizması",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "Kuru Raf",
  T_46_META_WS_E_HARD: "Zor",
  T_46_META_WS_E_HATTRICK: "Yetenek 8",
  T_46_META_WS_E_HAYSTACK: "Saman Yığını",
  T_46_META_WS_E_HEAD: "Baş Aksesuarı",
  T_46_META_WS_E_HEADSHOOT: "Baş vuruşu",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "Şifa Tabancası",
  T_46_META_WS_E_HEART: "Kalp",
  T_46_META_WS_E_HEARTBEAT: "Kalp Atışı",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "Ağır Silah",
  T_46_META_WS_E_HELL: "Çok zor",
  T_46_META_WS_E_HELMET: "Kask",
  T_46_META_WS_E_HELMET1: "Kask1",
  T_46_META_WS_E_HELMET2: "Kask2",
  T_46_META_WS_E_HELMET3: "Kask3",
  T_46_META_WS_E_HEXAGON: "Altıgen",
  T_46_META_WS_E_HGAMMO: "HG Mermisi",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "Saklambaç Alev Silahı",
  T_46_META_WS_E_HIDERKILL: "Saklanan Öldürüldü",
  T_46_META_WS_E_HIHATS: "Hi-Hat",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "Donuk Darbe",
  T_46_META_WS_E_HITEFFECT: "Mermi Çarpma VFX",
  T_46_META_WS_E_HITFEEDBACK: "Ateş Etme Geri Bildirimi",
  T_46_META_WS_E_HOOK: "Kanca",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "Kanca Silahı Mermisi",
  T_46_META_WS_E_HORIZALINE: "Yatay",
  T_46_META_WS_E_HORIZONTAL: "Yatay",
  T_46_META_WS_E_HORN: "Hoparlör",
  T_46_META_WS_E_HORROR: "Korku",
  T_46_META_WS_E_HOURGLASS: "Kum Saati",
  T_46_META_WS_E_HOUSE: "Ev",
  T_46_META_WS_E_HOUSEA: "Tek Katlı Ev",
  T_46_META_WS_E_HOUSEB: "İki Katlı Ev",
  T_46_META_WS_E_HOUSEC: "Üç Katlı Ev",
  T_46_META_WS_E_HP: "Sağlık Puanı (HP)",
  T_46_META_WS_E_HPBUFF: "HP Buff",
  T_46_META_WS_E_HUT: "Kabin",
  T_46_META_WS_E_ICEA: "Buz A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "Buz Duvarı Yapıcı",
  T_46_META_WS_E_ICONOBJECT: "Simge",
  T_46_META_WS_E_IMAGEWIDGET: "Görsel Araç",
  T_46_META_WS_E_IMPULSE: "Darbe",
  T_46_META_WS_E_INHALER: "Sprey",
  T_46_META_WS_E_INJUREDFEMALE: "Kadın Vurulma Çığlığı",
  T_46_META_WS_E_INJUREDMALE: "Erkek Vurulma Çığlığı",
  T_46_META_WS_E_INK: "Mürekkep VFX",
  T_46_META_WS_E_INPUTLABLEWIDGET: "Giriş Etiketi Araç",
  T_46_META_WS_E_INSECTCHIRPING: "Böcek Cıvıltısı",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 Saniye",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 Saniye",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 Saniye",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 Saniye",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 Saniye",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 Saniye",
  T_46_META_WS_E_INVISIBLE: "Görünmez",
  T_46_META_WS_E_IPIPE: "I Boru",
  T_46_META_WS_E_IRONFENCE: "Çit",
  T_46_META_WS_E_IRONFENCEB: "Çit B",
  T_46_META_WS_E_IRONPLATFORM: "Demir Platformu",
  T_46_META_WS_E_ITEMENTITY: "Tüketilebilir Üretici",
  T_46_META_WS_E_JEEP: "Jeep",
  T_46_META_WS_E_JERRYCAN: "Yağ Varili",
  T_46_META_WS_E_JERSEYMACHINE: "Forman Makinesi",
  T_46_META_WS_E_JOINEDGAMEDULL: "Çatışmaya Katıl",
  T_46_META_WS_E_JOINGAME: "Oyuna Katıl",
  T_46_META_WS_E_JOYSTICKWIDGET: "Joystick Araç",
  T_46_META_WS_E_JUMP: "Zıpla",
  T_46_META_WS_E_JUMPATTACK: "Zıplama Saldırısı",
  T_46_META_WS_E_JUSTPATROL: "Sadece Devriye",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "Anahtar",
  T_46_META_WS_E_KICK: "Bas Davulu",
  T_46_META_WS_E_KILLINGTIPS: "Öldürme İpuçları",
  T_46_META_WS_E_KILLZONE: "Ölüm Bölgesi",
  T_46_META_WS_E_KINEMATIC: "Kinematik",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "Yere Serildi",
  T_46_META_WS_E_KNOCKEDDOWN: "Yere Düşmüş",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "Etiket Araç",
  T_46_META_WS_E_LANDINGA: "Merdiven Durağı A",
  T_46_META_WS_E_LANDINGB: "Merdiven Durağı B",
  T_46_META_WS_E_LANDINGC: "Merdiven Durağı C",
  T_46_META_WS_E_LANDMINE: "Kara Mayını",
  T_46_META_WS_E_LANUNCHERAMMO: "Fırlatıcı Mermisi",
  T_46_META_WS_E_LASER: "Lazer VFX",
  T_46_META_WS_E_LASERSKILL: "Lazer Yetenek",
  T_46_META_WS_E_LATTICESCREEN: "Ekran",
  T_46_META_WS_E_LAWNA: "Çimen A",
  T_46_META_WS_E_LAWNB: "Çimen B",
  T_46_META_WS_E_LAYOUTWIDGET: "Yerleşim Araç",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "Ölü Ağaç",
  T_46_META_WS_E_LEVELMAXED: "Maks. Seviye",
  T_46_META_WS_E_LEVELUP: "Seviye Atlama",
  T_46_META_WS_E_LEVELUPDISCARDED: "Sıralama Artışı",
  T_46_META_WS_E_LIGHTBEAM: "Işık Işını",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "Işık Işını",
  T_46_META_WS_E_LIGHTEFFECT: "Işık Efekti",
  T_46_META_WS_E_LIGHTNING: "Şimşek",
  T_46_META_WS_E_LIMB: "Uzuv",
  T_46_META_WS_E_LINE: "Çizgi",
  T_46_META_WS_E_LIQUID: "Sıvı",
  T_46_META_WS_E_LOCAL: "Yerel",
  T_46_META_WS_E_LOCALPOSITION: "Yerel Konum",
  T_46_META_WS_E_LOCK: "Kilit",
  T_46_META_WS_E_LONGBOX: "Uzun Ahşap Kutu",
  T_46_META_WS_E_LOOP: "Döngü",
  T_46_META_WS_E_LOOTITEMBOX: "Eşya - Silah",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Eşya - Mühimmat",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Eşya - Zırh",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Eşya - Tükenebilir Ürün",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Eşya - Fırlatılabilir Ürün",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Eşya - Dürbün",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "Buz El Bombası",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "Rastgele Futbol Yağması",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "Futbol Kalkanı",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "Rastgele Silah Loot",
  T_46_META_WS_E_LOSE: "Yenilgi",
  T_46_META_WS_E_LOUDSPEAKER: "Hoparlör",
  T_46_META_WS_E_LOWFALLING: "Düşüşte",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "M79 El Bombası",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "M79 Özel El Bombası",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "MP5",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "Şarjör1",
  T_46_META_WS_E_MAGEZINE2: "Şarjör2",
  T_46_META_WS_E_MAGEZINE3: "Şarjör3",
  T_46_META_WS_E_MAGMAA: "Magma A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "Büyüteç",
  T_46_META_WS_E_MALE: "Erkek",
  T_46_META_WS_E_MARK: "İşaret",
  T_46_META_WS_E_MARKER: "İşaret",
  T_46_META_WS_E_MASK: "Yüz Aksesuarı",
  T_46_META_WS_E_MAXVALUE: "Maksimum",
  T_46_META_WS_E_MECHANICAL: "Hızlı Tıklama 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "Mekanik Cihaz Yankısı",
  T_46_META_WS_E_MEDICALPROPS: "Tıbbi Eşyalar",
  T_46_META_WS_E_MEDICALTENT: "Medikal Çadır",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "Orta Kalp Atışı",
  T_46_META_WS_E_MEDKIT: "İlk Yardım Kiti",
  T_46_META_WS_E_MELEE: "Yakın Dövüş Silahı",
  T_46_META_WS_E_MELEEWEAPONS: "Yakın Dövüş Silahı",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "Mikrofon",
  T_46_META_WS_E_MIDDLE: "Orta",
  T_46_META_WS_E_MINIHANDLE: "Mini Tutma Yeri",
  T_46_META_WS_E_MINIMAP: "Mini Harita",
  T_46_META_WS_E_MINISENTRY: "Mini Gözcü",
  T_46_META_WS_E_MINVALUE: "Minimum",
  T_46_META_WS_E_MISSILEEXPLODE: "Füze Türü Silah",
  T_46_META_WS_E_MISSIONCOMPLETE: "Görev Başarısı 1",
  T_46_META_WS_E_MISTAKE: "Hata",
  T_46_META_WS_E_MODERATE: "Orta",
  T_46_META_WS_E_MONEY: "Para",
  T_46_META_WS_E_MONSTER: "Canavar",
  T_46_META_WS_E_MONSTERSPAWN: "Canavar Doğma Noktası",
  T_46_META_WS_E_MONSTERTRUCK: "Canavar Kamyonu",
  T_46_META_WS_E_MOON: "Ay",
  T_46_META_WS_E_MOSQUITO: "Sivrisinek",
  T_46_META_WS_E_MOTIONTRAIL: "Arkadan Çarpma",
  T_46_META_WS_E_MOTOBIKE: "Motosiklet",
  T_46_META_WS_E_MOTORBIKE: "Motosiklet",
  T_46_META_WS_E_MOVE: "Hareket Et",
  T_46_META_WS_E_MOVEMENT: "Hareket Et",
  T_46_META_WS_E_MOVINGJOYSTICK: "Hareket Kumandası",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "Bay V",
  T_46_META_WS_E_MULTIPLIER: "Çarpan",
  T_46_META_WS_E_MULTIPLY: "Çarpma",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "Çarp ve Topla",
  T_46_META_WS_E_MUSHROOM1: "Mantar1",
  T_46_META_WS_E_MUSHROOM2: "Mantar2",
  T_46_META_WS_E_MUSHROOM3: "Mantar3",
  T_46_META_WS_E_MUSHROOM4: "Mantar4",
  T_46_META_WS_E_MUSHSHADE: "Dev Mantar Kümesi",
  T_46_META_WS_E_MUSIC: "Müzik",
  T_46_META_WS_E_MUZZLE1: "Namlu1",
  T_46_META_WS_E_MUZZLE2: "Namlu2",
  T_46_META_WS_E_MUZZLE3: "Namlu3",
  T_46_META_WS_E_NEAR: "Yakın",
  T_46_META_WS_E_NIGHT: "Gece",
  T_46_META_WS_E_NOATTACK: "Saldırı Yok",
  T_46_META_WS_E_NODUALWIELDING: "Çift Silah Kullanılamaz",
  T_46_META_WS_E_NOERROR: "Hata Yok",
  T_46_META_WS_E_NONE: "Yok",
  T_46_META_WS_E_NORMAL: "Normal",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "Düşme Atlama Yok",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "Yetenek 7",
  T_46_META_WS_E_OBTAINEDCOINS: "Orta Altın Al",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "Büyük Altın Al",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "Küçük Altın Al",
  T_46_META_WS_E_OILDRUMEXPLODE: "Yağ Varili Patlaması",
  T_46_META_WS_E_ONCE: "Bir kez",
  T_46_META_WS_E_ONEWAY: "Tek Yön",
  T_46_META_WS_E_OPENFOLDER: "Açık Klasör",
  T_46_META_WS_E_OPENHIHATS: "Açık Hi-Hat",
  T_46_META_WS_E_OPENINGBOX: "Kutu Aç",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Lonca Tedariki",
  T_46_META_WS_E_OPENINGWARCHEST: "Depo Kaydet",
  T_46_META_WS_E_ORANGE: "Turuncu",
  T_46_META_WS_E_ORTHOGONAL: "Ortogonal",
  T_46_META_WS_E_OUTPOST: "Bekçi Evi",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "Boyanmış Duvar",
  T_46_META_WS_E_PAINTSHIELDSKILL: "Kan Havuzu Yetenek",
  T_46_META_WS_E_PALM: "Kağıt",
  T_46_META_WS_E_PANEL: "Panel",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "Yolcu A",
  T_46_META_WS_E_PASSENGERB: "Yolcu B",
  T_46_META_WS_E_PASSENGERC: "Yolcu C",
  T_46_META_WS_E_PASSIVE: "Pasif",
  T_46_META_WS_E_PASSIVESKILL: "Pasif Beceri",
  T_46_META_WS_E_PATROLWHILEATTACK: "Devriye ve Saldırı",
  T_46_META_WS_E_PERSONALUAV: "Kişisel UAV",
  T_46_META_WS_E_PERSPECTIVE: "Perspektif",
  T_46_META_WS_E_PETTABBG: "Evcil Hayvan",
  T_46_META_WS_E_PHASESTART: "Aşama Başlangıcı",
  T_46_META_WS_E_PHONEBOOTH: "Telefon Kulübesi",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "Müzik Notları - Piyano",
  T_46_META_WS_E_PIANOKEY2: "Müzik Notları - Piyano",
  T_46_META_WS_E_PICKUPS: "Eşyalar",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "Beton Direği",
  T_46_META_WS_E_PIN: "Çağrı",
  T_46_META_WS_E_PINGPONG: "Masa tenisi",
  T_46_META_WS_E_PIPECORNER: "Dirsek Boru",
  T_46_META_WS_E_PIPEINTERSECTION: "Çapraz Boru",
  T_46_META_WS_E_PISTOL: "Tabanca",
  T_46_META_WS_E_PISTOLAMMO: "Tabanca Mermisi",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "Kareli Lunapark Bloku",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Oyuncu",
  T_46_META_WS_E_PLUS: "Artı",
  T_46_META_WS_E_PODIUM: "Podyum",
  T_46_META_WS_E_POISONGAS: "Zehirli Gaz",
  T_46_META_WS_E_POISONGASPREDISCARDED: "Zehirli Gaz",
  T_46_META_WS_E_PORTAL: "Portal",
  T_46_META_WS_E_POSTACCUMULATOR: "Son Toplayıcı",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "Hızlı Kalp Atışı",
  T_46_META_WS_E_PREACCUMULATOR: "Ön Toplayıcı",
  T_46_META_WS_E_PRIMARYWEAPONA: "Birincil Silah A",
  T_46_META_WS_E_PRIMARYWEAPONB: "Birincil Silah B",
  T_46_META_WS_E_PRIOREXPLOSION: "Bombanın Patlamasından Önce",
  T_46_META_WS_E_PROFILEWIDGET: "Profil Araç",
  T_46_META_WS_E_PRONE: "Yatmış",
  T_46_META_WS_E_PUMPKIN: "Kabak",
  T_46_META_WS_E_PURPLE: "Mor",
  T_46_META_WS_E_QUADRILATERAL: "Dörtgen",
  T_46_META_WS_E_QUESTIONMARK: "Soru İşareti",
  T_46_META_WS_E_QUICKCHAT: "Hızlı Sohbet",
  T_46_META_WS_E_QUICKCHATSHOW: "Hızlı Sohbet Göster",
  T_46_META_WS_E_RADIAL180: "Radyal 180°",
  T_46_META_WS_E_RADIAL360: "Radyal 360°",
  T_46_META_WS_E_RADIAL90: "Radyal 90°",
  T_46_META_WS_E_RAMPAGE: "Çılgınlık",
  T_46_META_WS_E_RANDOM: "Rastgele",
  T_46_META_WS_E_RANDOMBUFF: "Rastgele Buff",
  T_46_META_WS_E_RANKDOWN: "Sıralama Düşüşü",
  T_46_META_WS_E_REACTION: "Yanıtla",
  T_46_META_WS_E_RECOVER: "Kurtarma",
  T_46_META_WS_E_RECYCLE: "Geri Dönüşüm",
  T_46_META_WS_E_RED: "Kırmızı",
  T_46_META_WS_E_REFINERYTANK: "Su Kovası",
  T_46_META_WS_E_REFLECTIVECUBE: "Yansıtan Düz Renk Temel Blok 1",
  T_46_META_WS_E_REFRESH: "Yenile",
  T_46_META_WS_E_RELEASINGSKILL: "Yetenek Kullanma VFX",
  T_46_META_WS_E_RELOAD: "Şarjör Değiştir",
  T_46_META_WS_E_REMINDER: "Hatırlatma",
  T_46_META_WS_E_REPAIR: "Onarım",
  T_46_META_WS_E_REPAIREQUIP: "Ekipman Onarma",
  T_46_META_WS_E_REPAIRKIT: "Onarım Kiti",
  T_46_META_WS_E_REPLACER: "Yedek Parça",
  T_46_META_WS_E_REPORT: "Rapor Et",
  T_46_META_WS_E_REST: "Dinlenme",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "Ride",
  T_46_META_WS_E_RIDICULE: "Alay",
  T_46_META_WS_E_RIDICULEFUNNY: "Komik Alay",
  T_46_META_WS_E_RIFLE: "Tüfek",
  T_46_META_WS_E_RIFLEAMMO: "Tüfek Mermisi",
  T_46_META_WS_E_RIGHT: "Doğru",
  T_46_META_WS_E_RIGHTTRAPEZOID: "Dik Üçgen Trapez",
  T_46_META_WS_E_RING: "Yüzük Mekanizması",
  T_46_META_WS_E_RINGPREDISCARDED: "Yüzük",
  T_46_META_WS_E_RIPTIDERHYTHM: "Yetenek 9",
  T_46_META_WS_E_RISINGPARTICLE: "Yükselen Partiküller",
  T_46_META_WS_E_ROADBLOCK: "Barikat",
  T_46_META_WS_E_ROTATE: "Dönme",
  T_46_META_WS_E_RUNNING: "Koşma",
  T_46_META_WS_E_RUSHTIME: "Çılgınlık",
  T_46_META_WS_E_SAMURAI: "Samuray",
  T_46_META_WS_E_SANDA: "Kum A",
  T_46_META_WS_E_SANDSTRUCTURE: "Kum Heykel",
  T_46_META_WS_E_SCALE: "Ölçek",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "Korkuluk",
  T_46_META_WS_E_SCISSORS: "Makas",
  T_46_META_WS_E_SCOPE2X: "2x Kapsama",
  T_46_META_WS_E_SCOPE4X: "4x Kapsama",
  T_46_META_WS_E_SCROLLPANEL: "Kaydırma Paneli",
  T_46_META_WS_E_SECONDARYWEAPON: "İkincil Silah",
  T_46_META_WS_E_SENSESSHOCKWAVE: "Yetenek 10",
  T_46_META_WS_E_SERVER: "Sunucu",
  T_46_META_WS_E_SET: "Tulum",
  T_46_META_WS_E_SETTING: "Ayarlar",
  T_46_META_WS_E_SETTINGS: "Ayarlar",
  T_46_META_WS_E_SG: "Pompalı Tüfek",
  T_46_META_WS_E_SGAMMO: "SN Mermisi",
  T_46_META_WS_E_SHARPMECHANICAL: "Hızlı Tıklama 1",
  T_46_META_WS_E_SHIELD: "Savunma",
  T_46_META_WS_E_SHIELDBROKEN: "Kalkan Kırıldı",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "Kalkanı Yükselt",
  T_46_META_WS_E_SHOCKWAVE: "Şok Dalgası",
  T_46_META_WS_E_SHOES: "Ayakkabılar",
  T_46_META_WS_E_SHOOTINGTARGET: "Hareketli Hedef",
  T_46_META_WS_E_SHORTDATE: "Kısa Tarih",
  T_46_META_WS_E_SHORTDATETIME: "Kısa Tarih ve Saat",
  T_46_META_WS_E_SHORTTIME: "Kısa Süre",
  T_46_META_WS_E_SHOTGUN: "Pompalı Tüfek",
  T_46_META_WS_E_SHOTGUNAMMO: "Pompalı Tüfek Mermisi",
  T_46_META_WS_E_SHOTGUNMUZZLE: "Pompalı Tüfek Namlu",
  T_46_META_WS_E_SHOW: "Göster",
  T_46_META_WS_E_SHRUB: "Çalılık Kapatılmış Uzun Ahşap Kutu",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "Yan Kaydırma Kamerası",
  T_46_META_WS_E_SIGNAL: "Sinyal",
  T_46_META_WS_E_SIGNOUT: "Çıkış",
  T_46_META_WS_E_SILENCER: "Susturucu",
  T_46_META_WS_E_SIMPLE: "Basit",
  T_46_META_WS_E_SIMPLEWIDGET: "Basit Araç",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "Tekli",
  T_46_META_WS_E_SITEHUT: "Konteyner Ev",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "Yetenek Şarjı Tamamlandı",
  T_46_META_WS_E_SKILLRECOVER: "Yetenek Yenileme",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Düşme Atla",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "Dilimlenmiş",
  T_46_META_WS_E_SLOPE: "Eğim",
  T_46_META_WS_E_SLOWHEARTBEAT: "Yavaş Kalp Atışı",
  T_46_META_WS_E_SMG: "SMG",
  T_46_META_WS_E_SMGAMMO: "SMG Mermisi",
  T_46_META_WS_E_SMGMUZZLE: "SMG Namlu",
  T_46_META_WS_E_SMILEY: "Gülümseyen Yüz",
  T_46_META_WS_E_SMOKE: "Duman",
  T_46_META_WS_E_SMOKEGRENADE: "Duman Bombası",
  T_46_META_WS_E_SMOKEY: "Duman",
  T_46_META_WS_E_SMOOTH: "Pürüzsüz",
  T_46_META_WS_E_SNAMMO: "SN Mermisi",
  T_46_META_WS_E_SNARES: "Davul",
  T_46_META_WS_E_SNEAKERS: "Koşu Ayakkabısı VFX",
  T_46_META_WS_E_SNIPER: "Keskin Nişancı Tüfeği",
  T_46_META_WS_E_SNIPERAMMO: "Keskin Nişancı Tüfeği Mermisi",
  T_46_META_WS_E_SNOWA: "Kar A",
  T_46_META_WS_E_SNOWFLAKE: "Kar Tanesi",
  T_46_META_WS_E_SOCCER: "Futbol",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "Sosyal Buton Araç",
  T_46_META_WS_E_SOLARPANEL: "Güneş Paneli",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "Öncelikten Düşüğe",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "Öncelikten Yükseğe",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "Yeniden Doğma Noktası VFX",
  T_46_META_WS_E_SPEAKER: "Hoparlör",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "Özel Silah Sesi",
  T_46_META_WS_E_SPECIALGUN: "Özel Silah",
  T_46_META_WS_E_SPHERE: "Küre",
  T_46_META_WS_E_SPHERETRIGGER: "Küre Çarpışma Tetikleyici",
  T_46_META_WS_E_SPIDERWEB: "Yetenek VFX",
  T_46_META_WS_E_SPORTSCAR: "Spor Araba",
  T_46_META_WS_E_SPOTLIGHT: "Işık",
  T_46_META_WS_E_SPREADOFPOISONGAS: "Zehirli Gaz Yayılması",
  T_46_META_WS_E_SPRINT: "Koşarak",
  T_46_META_WS_E_SQUARE: "Kare",
  T_46_META_WS_E_SQUAREBOX: "Kare Ahşap Kutu",
  T_46_META_WS_E_SR: "Keskin Nişancı Tüfeği",
  T_46_META_WS_E_STABLE: "Kıl Çatı Kulübe",
  T_46_META_WS_E_STAIRS: "Merdiven",
  T_46_META_WS_E_STANDING: "Ayakta",
  T_46_META_WS_E_STAR: "Yıldız",
  T_46_META_WS_E_STATIC: "Statik",
  T_46_META_WS_E_STATUSTRIGGER: "Ölüm veya Dokunulmazlık Tetikleyicisi",
  T_46_META_WS_E_STEP: "Ayak Sesi",
  T_46_META_WS_E_STEPTRIGGER: "Mekanizma Aktifleştirme",
  T_46_META_WS_E_STOCK_S: "Dipçik S",
  T_46_META_WS_E_STOCK_SR: "Dipçik SR",
  T_46_META_WS_E_STOCK1: "Dipçik1",
  T_46_META_WS_E_STOCK2: "Dipçik2",
  T_46_META_WS_E_STOCK3: "Dipçik3",
  T_46_META_WS_E_STONE: "Kaya",
  T_46_META_WS_E_STONEBRIDGE: "Taş Kemeri Köprü",
  T_46_META_WS_E_STONELANTERN: "Saray Feneri",
  T_46_META_WS_E_STONESPLASH: "Uçan Parçacıklar",
  T_46_META_WS_E_STORE: "Mağaza",
  T_46_META_WS_E_STREETLAMP: "Sokak Lambası",
  T_46_META_WS_E_STYLEA: "Stil A",
  T_46_META_WS_E_STYLEB: "Stil B",
  T_46_META_WS_E_STYLEC: "Stil C",
  T_46_META_WS_E_SUBMACHINEGUN: "SMG",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "SMG Mermisi",
  T_46_META_WS_E_SUCCESSFULHIT: "Vuruş",
  T_46_META_WS_E_SUN: "Güneş",
  T_46_META_WS_E_SUNSHADE: "Şemsiye Seti",
  T_46_META_WS_E_SUPERCAR: "Spor Arabası",
  T_46_META_WS_E_SUPERMARKET: "Süpermarket",
  T_46_META_WS_E_SURPRISEFIND: "Sürpriz Keşfet",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "Hızlı Silah Değiştir",
  T_46_META_WS_E_SWIMRING: "Yüzme Halkası",
  T_46_META_WS_E_SWORD: "Kılıç",
  T_46_META_WS_E_SYMBOLIC: "Zemin İşareti",
  T_46_META_WS_E_TANKZOMBIE: "Tank Zombisi",
  T_46_META_WS_E_TAP: "Dokunma",
  T_46_META_WS_E_TAPPINGBUTTON: "Düğmeye Dokun",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "Devre Dışı Bırakma Düğmesine Dokun",
  T_46_META_WS_E_TEAM: "Takım",
  T_46_META_WS_E_TEAMMATESINFO: "Takım Arkadaşı Bilgisi",
  T_46_META_WS_E_TELEPORT: "Teleport",
  T_46_META_WS_E_TELEPORTCORRECT: "Doğru Noktaya İşaretleme",
  T_46_META_WS_E_TELEPORTWRONG: "Yanlış Noktaya İşaretleme",
  T_46_META_WS_E_TEXT: "Metin",
  T_46_META_WS_E_TEXTOBJECT: "Metin",
  T_46_META_WS_E_TEXTUREWIDGET: "Doku Araç",
  T_46_META_WS_E_THERMALSCOPE: "Termal Dürbün",
  T_46_META_WS_E_THIRDPERSON: "Üçüncü Şahıs Kamerası",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "Üçüncü Şahıs Kamerası (Klasik)",
  T_46_META_WS_E_THIRDPERSONLOCK: "Üçüncü Şahıs Kilitli Kamera",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "Uyumluluk İçin Atma Bıçağı2",
  T_46_META_WS_E_THRILLBATTLE: "Yetenek 5",
  T_46_META_WS_E_THROWATTACK: "El Bombası At",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "Kırmızı Fırlatma Zombisi",
  T_46_META_WS_E_THROWZOMBIE: "Fırlatma Zombisi",
  T_46_META_WS_E_THUMBSUP: "Beğen",
  T_46_META_WS_E_THUNDER: "Elektrik Şoku",
  T_46_META_WS_E_TILEA: "Fayans A",
  T_46_META_WS_E_TILEB: "Fayans B",
  T_46_META_WS_E_TILEC: "Fayans C",
  T_46_META_WS_E_TILED: "Döşenmiş",
  T_46_META_WS_E_TIPSSOUND: "İpucu Göster",
  T_46_META_WS_E_TOGGLEWIDGET: "Anahtar Araç",
  T_46_META_WS_E_TOILETBOWL: "Tuvalet",
  T_46_META_WS_E_TONEA: "Ton A",
  T_46_META_WS_E_TOP: "Üst Giysi",
  T_46_META_WS_E_TOPDOWN: "Yukarıdan Aşağıya Kamera",
  T_46_META_WS_E_TORII: "Torii",
  T_46_META_WS_E_TOUCHPADWIDGET: "Dokunmatik Paneli",
  T_46_META_WS_E_TOWER: "Kale",
  T_46_META_WS_E_TPIPE: "T Boru",
  T_46_META_WS_E_TRACINGSTEPS: "Yetenek 3",
  T_46_META_WS_E_TRAILER: "Römork",
  T_46_META_WS_E_TRANSFORMATION: "Görünüm Değiştirici",
  T_46_META_WS_E_TRANSPARENT: "Şeffaf",
  T_46_META_WS_E_TRAPEZOID: "Trapez",
  T_46_META_WS_E_TRASHCAN: "Çöp Kutusu",
  T_46_META_WS_E_TRIANGLE: "Üçgen",
  T_46_META_WS_E_TRIGGERS: "Tetikleyici",
  T_46_META_WS_E_TRIPLE: "Üçlü",
  T_46_META_WS_E_TROPHY: "Kupa",
  T_46_META_WS_E_TRUE: "Evet",
  T_46_META_WS_E_TUKTUK: "Tuk Tuk",
  T_46_META_WS_E_TUTUCAR: "Tuk-Tuk",
  T_46_META_WS_E_TYRANTZOMBIE: "Zorba Zombi",
  T_46_META_WS_E_UAVLITE: "Hafif İHA",
  T_46_META_WS_E_UIFINISH: "Bitir",
  T_46_META_WS_E_UITAP: "UI Dokunuşu",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "Ünite Üreteci",
  T_46_META_WS_E_UPWARDTURBULENCE: "Yükselen Akıntı",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "Aşmak",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "Araç",
  T_46_META_WS_E_VEHICLEEXPLODE: "Araç Patlaması",
  T_46_META_WS_E_VELOCITY: "Hız",
  T_46_META_WS_E_VENDINGMACHINE: "Otomatik Satış Makinesi",
  T_46_META_WS_E_VERTICAL: "Dikey",
  T_46_META_WS_E_VEST: "Yelek",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "Yelek4",
  T_46_META_WS_E_VISUALEFFECTS: "Görsel Efektler",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "Duvar A",
  T_46_META_WS_E_WALLBRAWL: "Yetenek 2",
  T_46_META_WS_E_WARNING: "Uyarı",
  T_46_META_WS_E_WATERRING: "Su Sıçraması",
  T_46_META_WS_E_WAVE1: "Dalga1",
  T_46_META_WS_E_WAVE2: "Dalga2",
  T_46_META_WS_E_WAVE3: "Dalga3",
  T_46_META_WS_E_WEAPONGENERATOR: "Silah",
  T_46_META_WS_E_WEAPONSLOT: "Silah Yuvası",
  T_46_META_WS_E_WHISTLE: "Düşmanı Yen",
  T_46_META_WS_E_WIDERANGE: "Geniş Aralık",
  T_46_META_WS_E_WIN: "Zafer",
  T_46_META_WS_E_WINDATTACK: "Rüzgar Saldırısı",
  T_46_META_WS_E_WOODA: "Ahşap A",
  T_46_META_WS_E_WOODCUTZOMBIE: "Ağaç Kesme Zombisi",
  T_46_META_WS_E_WOODENPLANK: "Ahşap Köprü",
  T_46_META_WS_E_WORLDPOSITION: "Dünya Koordinatları",
  T_46_META_WS_E_WRECKEDBUS: "Hurda Otobüs",
  T_46_META_WS_E_WRECKEDCAR: "Hurda Araç",
  T_46_META_WS_E_WRONG: "Yanlış",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "Zombi",
  T_46_META_WS_E_ZOMBIES: "Zombi",
  T_46_META_WS_E_ZOOM: "Yakınlaştır",
  T_46_META_WS_ELIMINATE: "Ortadan Kaldır",
  T_46_META_WS_ELIMINATEDENTITY: "Elenen Varlık",
  T_46_META_WS_ELIMINATEDPLAYER: "Elenen Oyuncu",
  T_46_META_WS_ENABLEDEFAULTBTREE: "Varsayılan Davranış Ağacını Etkinleştir",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "Hareketli Güvenli Bölgeyi Etkinleştir",
  T_46_META_WS_ENABLESAFEZONE: "Güvenli Bölgeyi Etkinleştir",
  T_46_META_WS_ENDCURRENTPHASE: "Mevcut Aşamayı Sonlandır",
  T_46_META_WS_ENDMORPH: "Dönüşümü Bitir",
  T_46_META_WS_ENDPOSITION: "Bitiş Konumu",
  T_46_META_WS_ENTERVEHICLE: "Araçla Gir",
  T_46_META_WS_ENTITY: "Varlık",
  T_46_META_WS_EQUIPMENTID: "Ekipman Kimliği",
  T_46_META_WS_EULERANGLETOQUATERNION: "Euler Açısını Quaternion'a Dönüştür",
  T_46_META_WS_EXITVEHICLE: "Araçtan Çık",
  T_46_META_WS_EXPONENTIATION: "Üs Hesaplama",
  T_46_META_WS_FILTERENTITY: "Varlıkları Filtrele",
  T_46_META_WS_FILTERLEVELOBJECTS: "Seviye Nesnelerini Filtrele",
  T_46_META_WS_FIND: "Bul",
  T_46_META_WS_FINDAT: "Bulma Yeri",
  T_46_META_WS_FINDPATH: "Yolu Bul",
  T_46_META_WS_FLOOR: "Aşağı Yuvarla",
  T_46_META_WS_FOOTBALLGOAL: "Futbol Golü",
  T_46_META_WS_FORMAT: "Format",
  T_46_META_WS_GETALLKEYS: "Tüm Anahtarları Al",
  T_46_META_WS_GETALLPLAYERS: "Tüm Oyuncuları Al",
  T_46_META_WS_GETALLSHOPS: "Tüm Mağazaları Al",
  T_46_META_WS_GETALLTEAMS: "Tüm Takımları Al",
  T_46_META_WS_GETATTACKABLEENTITY: "Saldırılabilir Varlığı Al",
  T_46_META_WS_GETATTACKABLEFACTIONS: "Saldırılabilir Fraksiyonları Al",
  T_46_META_WS_GETBACKPACKSKIN: "Sırt Çantası Kaplamasını Al",
  T_46_META_WS_GETBLACKBOARDVALUE: "Karatahta Değerini Al",
  T_46_META_WS_GETBUFFS: "Buff'ları Al",
  T_46_META_WS_GETCHATCHANNEL: "Sohbet Kanalını Al",
  T_46_META_WS_GETCHILDBYINDEX: "İndekse Göre Çocuk Al",
  T_46_META_WS_GETCHILDBYNAME: "İsmine Göre Çocuk Al",
  T_46_META_WS_GETCHILDREN: "Tüm Çocukları Al",
  T_46_META_WS_GETCOLORCHANNEL: "Renk Kanalını Al",
  T_46_META_WS_GETCONSUMABLES: "Tüketilebilirleri Al",
  T_46_META_WS_GETCULLINGMASK: "Kapatma Maskesini Al",
  T_46_META_WS_GETCURRENTCAMERA: "Mevcut Kamerayı Al",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "Mevcut Sohbet Kanalını Al",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "Özelleştirilmiş Görev İlerlemesini Al",
  T_46_META_WS_GETDYEDCOUNT: "Boyama Sayısını Al",
  T_46_META_WS_GETDYEDSTATUS: "Boyama Durumunu Al",
  T_46_META_WS_GETEQUIPMENTS: "Ekipmanları Al",
  T_46_META_WS_GETFACTION: "Fraksiyonu Al",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "Küresel Uyku Eşiğini Al",
  T_46_META_WS_GETITEMCOUNT: "Öğelerin Sayısını Al",
  T_46_META_WS_GETLOADEDSCENES: "Yüklenen Sahneyi Al",
  T_46_META_WS_GETLOCALAIMDIRECTION: "Yerel Nişan Alma Yönünü Al",
  T_46_META_WS_GETLOCALPLAYER: "Yerel Oyuncuyu Al",
  T_46_META_WS_GETLOCALTIMESTAMP: "Yerel Zaman Damgasını Al",
  T_46_META_WS_GETMAPID: "Harita ID'sini Al",
  T_46_META_WS_GETMINIMAP: "Mini Haritayı Al",
  T_46_META_WS_GETMONEY: "Para Al",
  T_46_META_WS_GETMONEYCOUNT: "Para Miktarını Al",
  T_46_META_WS_GETMORPH: "Dönüşümü Al",
  T_46_META_WS_GETNODEVARIABLE: "Düğüm Değerini Al",
  T_46_META_WS_GETOUTFIT: "Kıyafet Al",
  T_46_META_WS_GETOWNER: "Sahibi Al",
  T_46_META_WS_GETPARENT: "Üstünü Al",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "Takım Arkadaşının Yakınındaki Yeri Al",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "Rastgele Doğuş Noktasını Al",
  T_46_META_WS_GETRESULTFROMCURVE: "Eğriden Sonuç Al",
  T_46_META_WS_GETSCENESKYBOX: "Sahne Gökyüzü Kutusu Al",
  T_46_META_WS_GETSERVERREGION: "Sunucu Bölgesini Al",
  T_46_META_WS_GETSERVERTIMESTAMP: "Sunucu Zaman Damgasını Al",
  T_46_META_WS_GETSKELETONPARTBYNAME: "Kemik Parçasını İsimle Al",
  T_46_META_WS_GETSKILLS: "Becerileri Al",
  T_46_META_WS_GETSLEEPTHRESHOLD: "Uyku Eşiğini Al",
  T_46_META_WS_GETTOKENCOUNT: "Token Sayısını Al",
  T_46_META_WS_GETTOKENCOUNTTODAY: "Bugünkü Token Sayısını Al",
  T_46_META_WS_GETTYPE: "Türü Al",
  T_46_META_WS_GETVEHICLESKIN: "Araç Kaplamasını Al",
  T_46_META_WS_GETWALLET: "Cüzdanı Al",
  T_46_META_WS_GETWEAPONSKIN: "Silah Kaplamasını Al",
  T_46_META_WS_GETWIDGETBYPATH: "Yolu Kullanarak Widget Al",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "Özelleştirilmiş UI'dan Widget Al",
  T_46_META_WS_GIVEJAILBREAKITEM: "Hapis Eşyası Ver",
  T_46_META_WS_GIVEJAILBREAKREWARD: "Hapis Ödülü Ver",
  T_46_META_WS_HASAOISPECIALFOLLOW: "AOI Özel Takip Var mı",
  T_46_META_WS_HASCOMPONENT: "Bileşen Var mı",
  T_46_META_WS_HASSCRIPT: "Betik Var mı",
  T_46_META_WS_HASTAG: "Etiket Var mı",
  T_46_META_WS_HELPEDPLAYER: "Destek Alan Oyuncu",
  T_46_META_WS_HELPPLAYER: "Destekleyen Oyuncu",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "Görünüm Grubunu Gizle",
  T_46_META_WS_HITENTITY: "Vurulan Varlık",
  T_46_META_WS_HITFLY: "Uçur",
  T_46_META_WS_HITNORMAL: "Vuruş Normali",
  T_46_META_WS_HITOBJECT: "Vurulan Nesne",
  T_46_META_WS_HITPOSITION: "Vuruş Pozisyonu",
  T_46_META_WS_INDEXOF: "Öğenin İlk Görünme Yerini Al",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "Enfekte Zombinin Büyümesi",
  T_46_META_WS_INSERT: "Ekle",
  T_46_META_WS_ISATTACKABLE: "Saldırılabilir mi",
  T_46_META_WS_ISCHATCHANNELEMPTY: "Sohbet Kanalı Boş mu",
  T_46_META_WS_ISEQUAL: "Eşit mi",
  T_46_META_WS_ISFRIEND: "Arkadaş mı",
  T_46_META_WS_ISHIT: "Vuruldu mu",
  T_46_META_WS_ISINSIDEBOX: "Kutu İçinde mi",
  T_46_META_WS_ISINSIDECYLINDER: "Silindir İçinde mi",
  T_46_META_WS_ISINSIDESECTOR: "Sektör İçinde mi",
  T_46_META_WS_ISINSIDESPHERE: "Küre İçinde mi",
  T_46_META_WS_ISSLEEPING: "Uyuyor Mu",
  T_46_META_WS_ISSUBTYPEOF: "Alt Tür",
  T_46_META_WS_ITEM: "Varlık",
  T_46_META_WS_ITEMID: "Eşya Kimliği",
  T_46_META_WS_JOIN: "Birleştir",
  T_46_META_WS_JOINCHATCHANNEL: "Sohbet Kanalına Katıl",
  T_46_META_WS_JOINFACTION: "Fraksiyona Katıl",
  T_46_META_WS_LASTINDEXOF: "Öğenin Son Görünme Yerini Al",
  T_46_META_WS_LENGTH: "Uzunluk",
  T_46_META_WS_LERP: "Interpolasyon",
  T_46_META_WS_LOADSCENE: "Sahneyi Yükle",
  T_46_META_WS_LOGARITHM: "Logaritma",
  T_46_META_WS_LOGERROR: "Hata Günlüğü",
  T_46_META_WS_LOGINFO: "Bilgiyi Günlüğe Kaydet",
  T_46_META_WS_LOGWARNING: "Uyarı Günlüğü",
  T_46_META_WS_LOOKROTATION: "Görünüm Dönüşü",
  T_46_META_WS_MAGNITUDE: "Büyüklük",
  T_46_META_WS_MAKER: "Yaratıcı",
  T_46_META_WS_MAX: "Maksimum",
  T_46_META_WS_MECHANISM: "Mekanizma",
  T_46_META_WS_MIN: "Minimum",
  T_46_META_WS_MONSTERUSESKILL: "Beceri Kullan",
  T_46_META_WS_MORPHOBJECT: "Dönüşüm Nesnesi",
  T_46_META_WS_MORPHTO: "Dönüştür",
  T_46_META_WS_MORPHTOBYITEMID: "Ürün ID'si ile Dönüştür",
  T_46_META_WS_MOVECCT: "CCT'yi Taşı",
  T_46_META_WS_MOVEPOSITION: "Pozisyonu Taşı",
  T_46_META_WS_MOVEROTATION: "Rotasyonu Taşı",
  T_46_META_WS_MULTIPLYQUATERNION: "Quaternion Çarpma",
  T_46_META_WS_MULTIRAYCAST: "Çoklu Raycast",
  T_46_META_WS_NEGATE: "Negatif",
  T_46_META_WS_NEW: "Yeni",
  T_46_META_WS_NODENAME: "Düğüm Adı",
  T_46_META_WS_NORMALIZE: "Normalleştir",
  T_46_META_WS_NOTIFYPLAYEFFECT: "Etki Oynatma Bildir",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "İkon Animasyonunu Bildir",
  T_46_META_WS_NOTIFYPLAYSOUND: "Ses Oynatma Bildir",
  T_46_META_WS_NOTIFYSHOWTIPS: "İpucu Gösterme Bildir",
  T_46_META_WS_NUMTOSTRING: "Sayıyı Dizeye Çevir",
  T_46_META_WS_ONACCESSEQUIPMENT: "Ekipmana Erişim",
  T_46_META_WS_ONACCESSITEM: "Eşyaya Eriş",
  T_46_META_WS_ONACCESSWEAPON: "Silaha Erişim",
  T_46_META_WS_ONACE: "ACE",
  T_46_META_WS_ONAIMED: "Nişan Alındı",
  T_46_META_WS_ONAIMING: "Nişan Alınıyor",
  T_46_META_WS_ONASSIST: "Asist",
  T_46_META_WS_ONATTACK: "Saldırı",
  T_46_META_WS_ONATTACKSTOP: "Saldırı Durduruldu",
  T_46_META_WS_ONAWAKE: "Uyan",
  T_46_META_WS_ONBEKNOCKEDDOWN: "Düşürüldü",
  T_46_META_WS_ONBOUNCEDBYTIRE: "Lastikle Sekti",
  T_46_META_WS_ONBOUNCEENTITY: "Varlık Sektirildi",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "Yerleşik UI Düğmesine Tıklandı",
  T_46_META_WS_ONBULLETHIT: "Mermi Vurdu",
  T_46_META_WS_ONCAMERARAYCAST: "Kamera Işın Demeti",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "Karakter Kontrolcüsü Vuruldu",
  T_46_META_WS_ONCHASE: "Takip",
  T_46_META_WS_ONCHASESTOP: "Takip Durduruldu",
  T_46_META_WS_ONCLIPEND: "Klip Bitti",
  T_46_META_WS_ONCOLLISIONENTER: "Çarpışma Başladı",
  T_46_META_WS_ONCOLLISIONEXIT: "Çarpışma Bitti",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "Geri Sayım Bitti",
  T_46_META_WS_ONCREEP: "Sürün",
  T_46_META_WS_ONCROUCH: "Çömel",
  T_46_META_WS_ONDEALDAMAGE: "Hasar Ver",
  T_46_META_WS_ONDESTROY: "Yok Et",
  T_46_META_WS_ONDISABLE: "Devre Dışı Bırak",
  T_46_META_WS_ONDISCONNECT: "Bağlantı Kesildi",
  T_46_META_WS_ONDOUBLETAPPED: "Çift Tıklandı",
  T_46_META_WS_ONDRAG: "Sürükle",
  T_46_META_WS_ONDRAGEND: "Sürükleme Bitti",
  T_46_META_WS_ONDRAGSTART: "Sürüklemeye Başla",
  T_46_META_WS_ONDRIVED: "Sürüldü",
  T_46_META_WS_ONDRIVEVEHICLE: "Araç Sür",
  T_46_META_WS_ONDROPCONSUMABLE: "Tüketilebilir Düşür",
  T_46_META_WS_ONDROPPED: "Bırakıldı",
  T_46_META_WS_ONDROPWEAPON: "Silahı Düşür",
  T_46_META_WS_ONEACHLOOP: "Her Döngü",
  T_46_META_WS_ONELIMINATE: "Ele",
  T_46_META_WS_ONELIMINATED: "Elendi",
  T_46_META_WS_ONENABLE: "Etkinleştir",
  T_46_META_WS_ONEND: "Bitiş",
  T_46_META_WS_ONENTERED: "Girdi",
  T_46_META_WS_ONENTERVEHICLE: "Araca Bin",
  T_46_META_WS_ONENTITYENTER: "Tetikleyici Girdiğinde",
  T_46_META_WS_ONENTITYEXIT: "Tetikleyici Çıktığında",
  T_46_META_WS_ONEQUIPARMOR: "Zırh Ekip",
  T_46_META_WS_ONEQUIPED: "Kuşanıldı",
  T_46_META_WS_ONEQUIPWEAPON: "Silah Ekip",
  T_46_META_WS_ONEXPLODE: "Patlama",
  T_46_META_WS_ONFALL: "Düşüşte",
  T_46_META_WS_ONFALLSTOP: "Düşüş Durduğunda",
  T_46_META_WS_ONFIRE: "Ateş Et",
  T_46_META_WS_ONFIXEDUPDATE: "Sabit Güncelleme",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "Futbolla Çarpıştı",
  T_46_META_WS_ONFRIENDSUPDATE: "Arkadaşlık Durumu Güncelleme ",
  T_46_META_WS_ONGAMEEND: "Oyun Bitiş",
  T_46_META_WS_ONGAMEPAUSE: "Oyun Duraklat",
  T_46_META_WS_ONGAMERESUME: "Oyun Devam Et",
  T_46_META_WS_ONGAMESTART: "Oyun Başlat",
  T_46_META_WS_ONGOAL: "Gol",
  T_46_META_WS_ONHITBYBULLET: "Mermiyle Vuruldu",
  T_46_META_WS_ONHITFLY: "Uçarken Vur",
  T_46_META_WS_ONHITFLYENTITY: "Uçan Varlığa Vur",
  T_46_META_WS_ONHOOKGUNFIRE: "Kanca Silah Ateşlendi",
  T_46_META_WS_ONIDLE: "Boşta",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "Kaçış Alanı Başladı",
  T_46_META_WS_ONJAILBREAKAREAEND: "Kaçış Alanı Bitti",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "Kaçış Oyuncusu Katıldı",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "Kaçış Oyuncusu Ayrıldı",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "Sohbet Kanalına Başarıyla Katıldı",
  T_46_META_WS_ONJOYSTICKMOVE: "Joystick Hareket Ettirildi",
  T_46_META_WS_ONJOYSTICKPRESSED: "Basıldı",
  T_46_META_WS_ONJOYSTICKRELEASED: "Bırakıldı",
  T_46_META_WS_ONJUMP: "Zıpla",
  T_46_META_WS_ONJUMPSTOP: "Atlama Durduğunda",
  T_46_META_WS_ONLANDMINEACTIVE: "Kara Mayını Etkin",
  T_46_META_WS_ONLANDMINETRIGGER: "Kara Mayını Tetiklendi",
  T_46_META_WS_ONLEAVECHATCHANNEL: "Sohbet Kanalından Ayrıl",
  T_46_META_WS_ONLEAVEVEHICLE: "Araçtan İn",
  T_46_META_WS_ONLEFT: "Çıktı",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "Seviye Nesnesi Değiştirildi",
  T_46_META_WS_ONMOVE: "Hareket",
  T_46_META_WS_ONNODEENTER: "Düğüm Giriş",
  T_46_META_WS_ONNODEEXIT: "Düğüm Çıkış",
  T_46_META_WS_ONPAUSE: "Duraklat",
  T_46_META_WS_ONPHASEEND: "Aşama Bitiş",
  T_46_META_WS_ONPHASESTART: "Aşama Başlat",
  T_46_META_WS_ONPICKEDUP: "Alındı",
  T_46_META_WS_ONPLAYERASSIST: "Oyuncu Asist",
  T_46_META_WS_ONPLAYERBEELIMINATED: "Oyuncu Elendi",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "Oyuncu Düşürüldü",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "Oyuncu Hasar Verdi",
  T_46_META_WS_ONPLAYERELIMINATE: "Oyuncu Eledi",
  T_46_META_WS_ONPLAYERENTER: "Oyuncu Giriş Yaptı",
  T_46_META_WS_ONPLAYERJOIN: "Oyuncu Katıldı",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "Sohbet Kanalına Katılma Başarısız",
  T_46_META_WS_ONPLAYERLEAVE: "Oyuncu Ayrıldı",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "Oyuncu Satın Alma Talep Etti",
  T_46_META_WS_ONPLAYERQUIT: "Oyuncu Maçın Yarısında Çıktığında",
  T_46_META_WS_ONPLAYERRANKCHANGE: "Oyuncu Rütbesi Değiştir",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "Oyuncu Satın Alma Talebi Karşılandı",
  T_46_META_WS_ONPLAYERREVIVED: "Oyuncu Canlandı",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "Oyuncu Spawn Konumunda Canlandı",
  T_46_META_WS_ONPLAYERSCORECHANGE: "Oyuncu Skoru Değiştir",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "Oyuncu Sahneyi Değiştirdi",
  T_46_META_WS_ONPREDEALDAMAGE: "Hasar Vermeden Önce",
  T_46_META_WS_ONPREPURCHASE: "Satın Alma Öncesi",
  T_46_META_WS_ONPRESSED: "Basıldı",
  T_46_META_WS_ONPRETAKEDAMAGE: "Hasar Almadan Önce",
  T_46_META_WS_ONPURCHASE: "Satın Al",
  T_46_META_WS_ONRANKCHANGED: "Varlık Rütbesi Değiştir",
  T_46_META_WS_ONRECONNECT: "Tekrar Bağlan",
  T_46_META_WS_ONRELEASED: "Bırakıldı",
  T_46_META_WS_ONRELOAD: "Yeniden Doldur",
  T_46_META_WS_ONRESUME: "Devam Et",
  T_46_META_WS_ONREVIVED: "Canlandı",
  T_46_META_WS_ONROUNDEND: "Tur Bitiş",
  T_46_META_WS_ONROUNDSTART: "Tur Başlat",
  T_46_META_WS_ONSCENELOAD: "Sahne Yüklendi",
  T_46_META_WS_ONSCENESWITCH: "Sahne Değiştirildi",
  T_46_META_WS_ONSCORECHANGE: "Varlık Skoru Değiştir",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "Futbol Şutörü Tarafından Vuruldu",
  T_46_META_WS_ONSLEEP: "Uyku",
  T_46_META_WS_ONSPAWN: "Spawn Oldu",
  T_46_META_WS_ONSPRAY: "Sprey",
  T_46_META_WS_ONSPRAYED: "Spreylendi",
  T_46_META_WS_ONSPRINT: "Hız Koşusu",
  T_46_META_WS_ONSPRINTSTOP: "Hız Koşusu Durduruldu",
  T_46_META_WS_ONSTANDUP: "Ayağa Kalk",
  T_46_META_WS_ONSTART: "Başlat",
  T_46_META_WS_ONSTARTFIRE: "Saldırı",
  T_46_META_WS_ONSTATEEND: "Durum Bitti",
  T_46_META_WS_ONSURFING: "Sörf Yap",
  T_46_META_WS_ONSURFINGSTOP: "Sörf Durduruldu",
  T_46_META_WS_ONSWITCHHANDHELD: "Elde Taşınabilir Değiştir",
  T_46_META_WS_ONTAKEDAMAGE: "Hasar Al",
  T_46_META_WS_ONTAPPED: "Tıklandı",
  T_46_META_WS_ONTEAMACE: "Takım As",
  T_46_META_WS_ONTEAMADD: "Takım Eklendi",
  T_46_META_WS_ONTEAMREMOVE: "Takım Kaldırıldı",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "Takım Tur Rütbesi Değiştir",
  T_46_META_WS_ONTEAMSCORECHANGE: "Takım Skoru Değiştir",
  T_46_META_WS_ONTELEPORTENTITY: "Varlığı Teleport Et",
  T_46_META_WS_ONTEXTCHANGE: "Metin Değiştirildi",
  T_46_META_WS_ONTHROWABLEEXPLODE: "Fırlatılabilir Patladı",
  T_46_META_WS_ONTOGGLE: "Geçiş",
  T_46_META_WS_ONTOUCHDOWN: "Aşağı Dokun",
  T_46_META_WS_ONTOUCHUP: "Yukarı Dokun",
  T_46_META_WS_ONUIHIDE: "UI Gizle",
  T_46_META_WS_ONUISHOW: "UI Göster",
  T_46_META_WS_ONUPDATE: "Güncelleme",
  T_46_META_WS_ONUSEAVATARSKILL: "Avatar Yeteneği Kullan",
  T_46_META_WS_ONUSECONSUMABLE: "Tüketilebilir Kullanıldı",
  T_46_META_WS_ONUSED: "Kullanıldı",
  T_46_META_WS_ONUSEPORTAL: "Portal Kullan",
  T_46_META_WS_ONWAKEUP: "Uyan",
  T_46_META_WS_ONWEAPONBEEQUIPED: "Silah Kuşanıldı",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "Silah Hasar Verdi",
  T_46_META_WS_ONWEAPONELIMINATE: "Silah Eledi",
  T_46_META_WS_ONWEAPONSTOPFIRING: "Silah Ateşi Durduruldu",
  T_46_META_WS_OWNER: "Sahip",
  T_46_META_WS_P_ACCELERATE: "Hızlanma",
  T_46_META_WS_P_ACCELERATION: "İvme",
  T_46_META_WS_P_ACCOUNTID: "Hesap ID",
  T_46_META_WS_P_ACCURACY: "Doğruluk",
  T_46_META_WS_P_ACTIONTYPE: "Aksiyon Türü",
  T_46_META_WS_P_ACTIVATEDALPHA: "Etkin Alfa",
  T_46_META_WS_P_ACTIVE: "Aktif",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Hiyerarşide Aktif",
  T_46_META_WS_P_ACTIVESELF: "Aktif Kendi",
  T_46_META_WS_P_ACTIVETEXT: "Aktif Metin",
  T_46_META_WS_P_ACTUALPOSITION: "Gerçek Konum",
  T_46_META_WS_P_AFTERACCUMULATOR: "Son Akümülatör",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "Nişan Yardım Merkezi Ofseti",
  T_46_META_WS_P_AIMASSISTDISTANCE: "Nişan Yardım Mesafesi",
  T_46_META_WS_P_AIMASSISTTYPE: "Nişan Yardımcısı",
  T_46_META_WS_P_AIRDROPSTATE: "Hava Düşüş Durumu",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "Yatay Hizalama",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "Dikey Hizalama",
  T_46_META_WS_P_ALLITEMS: "Tüm Ürünler",
  T_46_META_WS_P_ALLMEMBERS: "Tüm Üyeler",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "Nişan Yardımcısı ile Kilitlenme İzni",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "Dışarıda Basmayı İzin Ver",
  T_46_META_WS_P_ALLPLAYERS: "Tüm Oyuncular",
  T_46_META_WS_P_ALLTEAMMATES: "Tüm Takım Üyeleri",
  T_46_META_WS_P_ALPHA: "Alfa",
  T_46_META_WS_P_ALWAYSSHOWMARK: "İşareti Her Zaman Göster",
  T_46_META_WS_P_AMBIENTCOLOR: "Çevre Rengi",
  T_46_META_WS_P_AMMOCLIPSIZE: "Şarjör Boyutu",
  T_46_META_WS_P_AMMOMAGSIZE: "Mermi Şarjör Boyutu",
  T_46_META_WS_P_AMMOPERSHOT: "Mermi Başına Miktar",
  T_46_META_WS_P_AMMOTYPE: "Mermi Türü",
  T_46_META_WS_P_ANCHORMAX: "Çapa Max",
  T_46_META_WS_P_ANCHORMIN: "Çapa Min",
  T_46_META_WS_P_ANCHOROBJECT: "Çapa Nesnesi",
  T_46_META_WS_P_ANCHORPOSITION: "Çapa Konumu",
  T_46_META_WS_P_ANCHORTYPE: "UITweener Script'i Aktif",
  T_46_META_WS_P_ANGLE: "Açı",
  T_46_META_WS_P_ANGLEDOWN: "Aşağı Açı",
  T_46_META_WS_P_ANGLEUP: "Yukarı Açı",
  T_46_META_WS_P_ANGULARDRAG: "Açısal Sürüklenme",
  T_46_META_WS_P_ANGULARSPEED: "Açısal Hız",
  T_46_META_WS_P_ANGULARVELOCITY: "Açısal Hız (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "Animasyon Adı",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "Animasyon Kontrolcüsü",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "Animasyon Kontrolcü Kaynağı ID",
  T_46_META_WS_P_ARMORPENETRATION: "Zırh Delme",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "Zırh Delme Faktörü",
  T_46_META_WS_P_ARMORTYPE: "Zırh Türü",
  T_46_META_WS_P_ARROWOFFSET: "Ok Kaydırması",
  T_46_META_WS_P_ARROWSIZE: "Ok Boyutu",
  T_46_META_WS_P_ARROWSPRITE: "Ok Sprite'ı",
  T_46_META_WS_P_ASKBUYTARGET: "Satın Alma Hedefi İsteği",
  T_46_META_WS_P_ATTACHTARGET: "Ekleme Hedefi",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "Saldırılabilir Birlikler",
  T_46_META_WS_P_ATTACKDAMAGE: "Saldırı Hasarı",
  T_46_META_WS_P_ATTACKINTERVAL: "Saldırı Aralığı",
  T_46_META_WS_P_ATTACKRANGE: "Saldırı Menzili",
  T_46_META_WS_P_ATTACKTARGET: "Saldırı Hedefi",
  T_46_META_WS_P_ATTTACKABLETARGETS: "Saldırılabilir Hedefler",
  T_46_META_WS_P_AUTOPLAY: "Otomatik Oynatma Durumu",
  T_46_META_WS_P_AVAILABLEPOINT: "Kullanılabilir Nokta",
  T_46_META_WS_P_AVATAR: "Avatar",
  T_46_META_WS_P_AVATARID: "Avatar ID",
  T_46_META_WS_P_BACKGROUND: "Arka Plan",
  T_46_META_WS_P_BACKGROUNDALPHA: "Arka Plan Alfa",
  T_46_META_WS_P_BACKGROUNDCOLOR: "Arka Plan Rengi",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "Arka Plan Rengi 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "Arka Plan Rengi 2",
  T_46_META_WS_P_BACKGROUNDFILL: "Arka Plan Doldurma",
  T_46_META_WS_P_BACKGROUNDICONNAME: "Arka Plan İkon Adı",
  T_46_META_WS_P_BACKGROUNDNAME: "Arka Plan Adı",
  T_46_META_WS_P_BACKGROUNDOFFSET: "Arka Plan Kaydırması",
  T_46_META_WS_P_BACKGROUNDRADIUS: "Arka Plan Yarıçapı",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "Arka Plan Boyut Değişimi",
  T_46_META_WS_P_BACKGROUNDSPRITE: "Arka Plan Sprite",
  T_46_META_WS_P_BACKPACK: "Sırt Çantası",
  T_46_META_WS_P_BACKPACKSKINID: "Sırt Çantası Cilt ID'si",
  T_46_META_WS_P_BACKWARDSPEED: "Geri Hız",
  T_46_META_WS_P_BANNERID: "Afiş ID",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "Temel Yatay Hız",
  T_46_META_WS_P_BASEMULTIPLIER: "Temel Çarpan",
  T_46_META_WS_P_BASETIME: "Temel Zaman",
  T_46_META_WS_P_BASEVERTICALSPEED: "Temel Dikey Hız",
  T_46_META_WS_P_BEFOREACCUMULATOR: "Ön Akümülatör",
  T_46_META_WS_P_BEVTREEID: "Davranış Ağacı Kimliği",
  T_46_META_WS_P_BINDPROPERTYID: "Bağlı Özellik ID",
  T_46_META_WS_P_BODY: "Gövde",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "Gövde Hasar Katsayısı",
  T_46_META_WS_P_BONEPOSITION: "Kemik Pozisyonu",
  T_46_META_WS_P_BONESCALE: "Kemik Ölçeklendirme",
  T_46_META_WS_P_BOOSTCD: "Boost CD",
  T_46_META_WS_P_BOOSTDURATION: "Boost Süresi",
  T_46_META_WS_P_BOOSTSPEED: "Boost Hızı",
  T_46_META_WS_P_BORDERLR: "Sol Sağ Kenar",
  T_46_META_WS_P_BORDERTB: "Üst Alt Kenar",
  T_46_META_WS_P_BOTTOMALPHA: "Alt Alfa",
  T_46_META_WS_P_BOUNDWALLET: "HUD Sabitleyici Türü",
  T_46_META_WS_P_BRAKEHORSEPOWER: "Fren Gücü",
  T_46_META_WS_P_BRAKETORQUE: "Fren Torku",
  T_46_META_WS_P_BRRANK: "BR Rütbesi",
  T_46_META_WS_P_BUFFTYPE: "Buff Türü",
  T_46_META_WS_P_BURNDAMAGE: "Yanma Hasarı",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "Yanma Hasarı Aralığı",
  T_46_META_WS_P_BURNTIME: "Yanma Süresi",
  T_46_META_WS_P_BUTTOM: "Alt",
  T_46_META_WS_P_BUTTONCOLORS: "Buton Renkleri",
  T_46_META_WS_P_BUTTONNAMES: "Buton İsimleri",
  T_46_META_WS_P_BUTTONSTYLE: "Düğme Stili",
  T_46_META_WS_P_CAMERABLOCKMODE: "Kamera Blokaj Modu",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "Kamera Projeksiyon Modu",
  T_46_META_WS_P_CAMERATYPE: "Kamera",
  T_46_META_WS_P_CANCELDRAGIFFITS: "Uygun Olursa Sürüklemeyi İptal Et",
  T_46_META_WS_P_CANCOSTDURABILITY: "Dayanıklılık Harcanabilir mi",
  T_46_META_WS_P_CANDAMAGED: "Hasar Alabilir",
  T_46_META_WS_P_CANDESTROY: "Yok Edilebilir mi",
  T_46_META_WS_P_CANDESTROYED: "Yok Edilebilir",
  T_46_META_WS_P_CANSELFTRIGGER: "Kendiniz tetikleyebilir mi?",
  T_46_META_WS_P_CANTEAMTRIGGER: "Takım tarafından tetiklenebilir",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "Kendi Kendine Tetiklenebilir mi",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "Takım Tarafından Tetiklenebilir mi",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "Araç Tarafından Tetiklenebilir mi",
  T_46_META_WS_P_CANVEHICLETRIGGER: "Araç tarafından tetiklenebilir",
  T_46_META_WS_P_CELLSIZE: "Hücre Boyutu",
  T_46_META_WS_P_CELLSPACE: "Hücre Boşluğu",
  T_46_META_WS_P_CENTER: "Merkez",
  T_46_META_WS_P_CENTERINVISIBLE: "Merkezi Görünmez",
  T_46_META_WS_P_CENTEROFFSET: "Merkez Ofseti",
  T_46_META_WS_P_CENTEROFMASS: "Kütle Merkezi",
  T_46_META_WS_P_CENTERRANGE: "Merkez Menzili",
  T_46_META_WS_P_CENTRALFLASHTIME: "Kenar Patlama Süresi",
  T_46_META_WS_P_CENTRALLINEACTIVE: "Merkez Çizgi Aktif",
  T_46_META_WS_P_CENTRALLINEPOSITION: "Merkez Çizgi Konumu",
  T_46_META_WS_P_CHANNELID: "Sohbet Kanalı ID'si",
  T_46_META_WS_P_CHARGEMAX: "Maks. Yük",
  T_46_META_WS_P_CHASETARGET: "Takip Hedefi",
  T_46_META_WS_P_CHATCHANNEL: "Sohbet Kanalı",
  T_46_META_WS_P_CHECKPOINTID: "Kontrol Noktası ID",
  T_46_META_WS_P_CHILDINDEX: "Çocuk İndeksi",
  T_46_META_WS_P_CHIPEXP: "Çip Deneyimi",
  T_46_META_WS_P_CLICKSIZE: "Tıklama Boyutu",
  T_46_META_WS_P_CLIPLENGTH: "Klip Uzunluğu",
  T_46_META_WS_P_CLIPPINGTYPE: "Kırpma Türü",
  T_46_META_WS_P_COLLIDERID: "Çarpışma ID'si",
  T_46_META_WS_P_CONSTRAIN: "Kısıtlama",
  T_46_META_WS_P_CONSTRAINT: "Kısıtlama",
  T_46_META_WS_P_CONSTRAINTCOUNT: "Kısıtlama Sayısı",
  T_46_META_WS_P_CONSUMABLETYPE: "Tüketilebilir Tür",
  T_46_META_WS_P_CONTENT: "İçerik",
  T_46_META_WS_P_CONTENTORIGIN: "İçerik Kökeni",
  T_46_META_WS_P_CONTROLPOINTS: "Kontrol Noktaları",
  T_46_META_WS_P_COORDINATESYSTEM: "Koordinat Sistemi",
  T_46_META_WS_P_COUNT: "Sayı",
  T_46_META_WS_P_COUNTDOWNENDTIME: "Geri Sayım Bitiş Zamanı (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "Geri Sayım Anahtarı",
  T_46_META_WS_P_COUNTDOWNTIME: "Geri Sayım Süresi",
  T_46_META_WS_P_COUNTPERWAVE: "Dalga Başına Miktar",
  T_46_META_WS_P_CRASHMAXDAMAGE: "Maksimum Çarpışma Hasarı",
  T_46_META_WS_P_CRASHMAXSPEED: "Çarpışma Maksimum Hızı",
  T_46_META_WS_P_CRASHMESSFACTOR: "Çarpışma Kitle Faktörü",
  T_46_META_WS_P_CRASHMINDAMAGE: "Minimum Çarpışma Hasarı",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Emekleme hareket hız ölçeği",
  T_46_META_WS_P_CREATEDENTITY: "Oluşturulan Varlık",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "Çömelme hareket hız ölçeği",
  T_46_META_WS_P_CSRANK: "CS Rütbesi",
  "T_46_META_WS_P_CURRENT AMMO": "Mevcut Mermi",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "Mevcut Animasyon Kaynağı",
  T_46_META_WS_P_CURRENTCLIP: "Mevcut Klip",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "Mevcut Klip İlerlemesi",
  T_46_META_WS_P_CURRENTDURABILITY: "Mevcut Dayanıklılık",
  T_46_META_WS_P_CURRENTENERGY: "Mevcut Enerji",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "Mevcut Taşınabilir Eşya",
  T_46_META_WS_P_CURRENTHP: "Mevcut HP",
  T_46_META_WS_P_CURRENTPHASEINDEX: "Mevcut Aşama İndeksi",
  T_46_META_WS_P_CURRENTPROGRESS: "Mevcut İlerleme",
  T_46_META_WS_P_CURRENTROUNDINDEX: "Mevcut Tur İndeksi",
  T_46_META_WS_P_CURRENTSTATE: "Mevcut Durum",
  T_46_META_WS_P_CURRENTVALUE: "Mevcut Değer",
  T_46_META_WS_P_CURRENTWAVE: "Mevcut Dalga",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "Özel Karakter Kaynağı",
  T_46_META_WS_P_CUSTOMGAMERESULT: "Özel Oyun Sonucu",
  T_46_META_WS_P_CUSTOMGRAVITY: "Özelleştirilmiş Yerçekimi",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "Özel İtme Kuvveti",
  T_46_META_WS_P_CUSTOMXY: "Özelleştirilmiş XY",
  T_46_META_WS_P_DAMAGE: "Hasar",
  "T_46_META_WS_P_DAMAGE RANGE": "Menzil",
  T_46_META_WS_P_DAMAGEFACTOR: "Hasar Faktörü",
  T_46_META_WS_P_DAMAGEINTERVAL: "Hasar Aralığı (s)",
  T_46_META_WS_P_DAMAGERADIUS: "Hasar Yarıçapı",
  T_46_META_WS_P_DAMAGERATIOHEAD: "Kafa Hasar Oranı",
  T_46_META_WS_P_DAMAGERATIOLIMB: "Uzuv Hasar Oranı",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "Hasar Azaltma Faktörü",
  T_46_META_WS_P_DAMAGETAKENPCT: "Alınan Hasar Yüzdesi",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "Alınan Hasar Yüzdesi",
  T_46_META_WS_P_DAMAGEVALUE: "Hasar Değeri",
  T_46_META_WS_P_DARKNESS: "Karanlık",
  T_46_META_WS_P_DECELERATIONPERCENT: "Yavaşlama Yüzdesi",
  T_46_META_WS_P_DEFAULTTEXT: "Varsayılan Metin",
  T_46_META_WS_P_DEFENSE: "Savunma Oranı",
  T_46_META_WS_P_DEFENSERATE: "Savunma Oranı",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "Delta Zamanı",
  T_46_META_WS_P_DELTAVALUE: "Delta Değeri",
  T_46_META_WS_P_DEPTH: "Derinlik",
  T_46_META_WS_P_DESC: "Açıklama",
  T_46_META_WS_P_DESCRIPTION: "Açıklama",
  T_46_META_WS_P_DESCRIPTIONKEY: "Açıklama Anahtarı",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "İpucu Açıklama Parametreleri",
  T_46_META_WS_P_DESTVAL: "Hedef Değer",
  T_46_META_WS_P_DETECTRANGE: "Tespit Menzili",
  T_46_META_WS_P_DIFFUSEALPHA: "Dağıtıcı Alfa",
  T_46_META_WS_P_DIFFUSECOLOR: "Dağıtıcı Renk",
  T_46_META_WS_P_DIFFUSETEXTURE: "Dağıtıcı Doku",
  T_46_META_WS_P_DISABLECOLOR: "Rengi Devre Dışı Bırak",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "Düşme Hasarını Devre Dışı Bırak",
  T_46_META_WS_P_DISABLEITEMDROP: "Eşyaların Bırakılmasını Devre Dışı Bırak",
  T_46_META_WS_P_DISABLEITEMPICKUP: "Eşyaların Alımını Devre Dışı Bırak",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "Manuel Kapatmayı Devre Dışı Bırak",
  T_46_META_WS_P_DISABLEQUICKCHAT: "Hızlı Sohbeti Devre Dışı Bırak",
  T_46_META_WS_P_DISABLERECIPROCATING: "Karşılıklı Hareketi Devre Dışı Bırak",
  T_46_META_WS_P_DISABLEVOICECHAT: "Sesli Sohbeti Devre Dışı Bırak",
  T_46_META_WS_P_DISTANCE: "Mesafe",
  T_46_META_WS_P_DOUBLEGUNTYPE: "Çift Tabanca Türü",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "Emekleme hareket hız ölçeği",
  T_46_META_WS_P_DOWNSPEED: "Aşağı Hız",
  T_46_META_WS_P_DRAG: "Sürüklenme",
  T_46_META_WS_P_DRIVER: "Sürücü",
  T_46_META_WS_P_DROPITEMS: "Düşen Eşyalar",
  T_46_META_WS_P_DURABILITY: "Dayanıklılık",
  T_46_META_WS_P_DURABILITYRECOVERY: "Dayanıklılık Kurtarma",
  T_46_META_WS_P_DURATION: "Süre",
  T_46_META_WS_P_EDGEFLASHTIME: "Flashbang Etki Anahtarı",
  T_46_META_WS_P_EFFECTACTIVE: "Etki Aktif",
  T_46_META_WS_P_EFFECTCOLOR: "Etki Rengi",
  T_46_META_WS_P_EFFECTDURATION: "Tetikleme Zamanı",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "Etkili Zaman Aralığı",
  T_46_META_WS_P_EFFECTRESID: "Efekt Kaynak Yolu",
  T_46_META_WS_P_ENABLE: "Etkinleştir",
  T_46_META_WS_P_ENABLEATTACK: "Saldırıyı Etkinleştir",
  T_46_META_WS_P_ENABLEBOTREVIVE: "Bot Canlandırmayı Etkinleştir",
  T_46_META_WS_P_ENABLEDEPTHMAP: "Derinlik Haritasını Etkinleştir",
  T_46_META_WS_P_ENABLEDROPONDEATH: "Ölümde Düşürme Aktif mi",
  T_46_META_WS_P_ENABLELOCALIZATION: "Yerelleştirmeyi Etkinleştir",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "Havada Yatay Hareket Etme",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "Oyuncu Yeniden Canlandırma Açık",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "Oyuncu Görünümünü Etkinleştir",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "Yerçekimi ile Döndürmeyi Etkinleştir",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "Kapak Özelliklerini Etkinleştir",
  T_46_META_WS_P_ENABLESWINGING: "Sallanmayı Etkinleştir",
  T_46_META_WS_P_ENABLETRACTION: "Çekişi Etkinleştir",
  T_46_META_WS_P_ENDPOSITION: "Bitiş Pozisyonu",
  T_46_META_WS_P_ENDRADIUS: "Bitiş Yarıçapı",
  T_46_META_WS_P_ENDTIME: "Bitiş Zamanı (ms)",
  T_46_META_WS_P_ENDTIMES: "Bitiş Zamanı",
  T_46_META_WS_P_ENDVALUE: "Bitiş Değeri",
  T_46_META_WS_P_ENERGY: "Enerji",
  T_46_META_WS_P_ENERGYCOST: "Enerji Maliyeti",
  T_46_META_WS_P_ENERGYRECOVERY: "Enerji Yenileme",
  T_46_META_WS_P_ENGINEHORSEPOWER: "Motor Gücü",
  T_46_META_WS_P_ENGINETORQUE: "Motor Torku",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "Maks. EP",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "EP Kurtarma Miktarı",
  T_46_META_WS_P_EVENTS: "Olaylar",
  T_46_META_WS_P_EXPLODEDAMAGE: "Patlama Hasarı",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "Patlama Hasarı Azaltma Faktörü",
  T_46_META_WS_P_EXPLODEDELAY: "Patlama Gecikmesi",
  T_46_META_WS_P_EXPLODERANGE: "Patlama Aralığı",
  T_46_META_WS_P_EXPLOSIONDELAY: "Merkez Patlama Süresi",
  T_46_META_WS_P_EXPLOSIONRANGE: "Patlama Menzili",
  T_46_META_WS_P_EXPLOSIONTIME: "Patlama Gecikmesi",
  T_46_META_WS_P_EXPPERDAMAGE: "Hasar Başına Deneyim Puanı",
  T_46_META_WS_P_EXPPERMOVEMILE: "Hareket Edilen Mesafe Başına Deneyim Puanı",
  T_46_META_WS_P_EXPPERSECOND: "Saniye Başına Deneyim Puanı",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "Ekstra Sırt Çantası Kapasitesi",
  T_46_META_WS_P_EXTRABAGCAPACITY: "Ekstra Sırt Çantası Alanı",
  T_46_META_WS_P_EXTRAHPRATIO: "Ekstra HP Oranı",
  T_46_META_WS_P_FACEPAINT: "Yüz Boyası",
  T_46_META_WS_P_FACTION: "Taraf",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "Düşüş Hasar Oranı",
  T_46_META_WS_P_FALLSPEED: "Düşüş Hızı",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "Otomatik Yeniden Doldurma Hızı",
  T_46_META_WS_P_FILEID: "Dosya ID",
  T_46_META_WS_P_FILL: "Doldurma",
  T_46_META_WS_P_FILLAMOUNT: "Doldurma Değeri",
  T_46_META_WS_P_FILLDIRECTION: "Doldurma Yönü",
  T_46_META_WS_P_FILLTYPE: "Doldurma Türü",
  T_46_META_WS_P_FIREANGLELIMIT: "Ateş Açısı Sınırlaması",
  T_46_META_WS_P_FIRETYPE: "Ateş Türü",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "Birinci Skor Parametreleri",
  T_46_META_WS_P_FIRSTSCORETITLE: "Birinci Skor Başlığı",
  T_46_META_WS_P_FIRSTSCOREVALUE: "Birinci Skor Değeri",
  T_46_META_WS_P_FIXEDDELTATIME: "Sabit Delta Süresi",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "Etki Süresi",
  T_46_META_WS_P_FLIP: "Çevirme",
  T_46_META_WS_P_FLIPTYPE: "Çevirme Türü",
  T_46_META_WS_P_FLYMAXHEIGHT: "Maksimum Uçuş Yüksekliği",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "Yatay Uçuş Hızı",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "Dikey Uçuş Hızı",
  T_46_META_WS_P_FOGCOLOR: "Sis Rengi",
  T_46_META_WS_P_FOLLOWTARGET: "Hedef Takip",
  T_46_META_WS_P_FONT: "Yazı Tipi",
  T_46_META_WS_P_FONTSIZE: "Yazı Tipi Boyutu",
  T_46_META_WS_P_FONTSTYLE: "Yazı Stili",
  T_46_META_WS_P_FONTTYPE: "Yazı Tipi",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "İstemciye Zorla Senkronizasyon",
  T_46_META_WS_P_FORWARD: "İleri",
  T_46_META_WS_P_FORWARDSPEED: "İleri Hız",
  T_46_META_WS_P_FOV: "Görüş Alanı",
  T_46_META_WS_P_FREEZEDURATION: "Dondurma Süresi (s)",
  T_46_META_WS_P_FRIENDFACTIONS: "Dost Birlikler",
  T_46_META_WS_P_FRIENDLYPLAYERS: "Dost Canlılar",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "Tam Hasar Mesafesi",
  T_46_META_WS_P_FUNCTIONTYPE: "İşlev Türü",
  T_46_META_WS_P_GAINHPCOLOR: "HP Kazanma Rengi",
  T_46_META_WS_P_GAMEFRAMECOUNT: "Toplam Kare Sayısı",
  T_46_META_WS_P_GAMETIMECOUNT: "Oyun Süresi",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "Dişli Değiştirme Gecikmesi",
  T_46_META_WS_P_GENDER: "Cinsiyet",
  T_46_META_WS_P_GETONBOOSTCD: "Boost'e Binme CD",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "Boost'e Binme CD Anahtarı",
  T_46_META_WS_P_GETONSKATEBOARDCD: "Kaykay CD",
  T_46_META_WS_P_GRADIENT: "Gradyan",
  T_46_META_WS_P_GRADIENTBOTTOM: "Alt Gradyan",
  T_46_META_WS_P_GRADIENTTOP: "Üst Gradyan",
  T_46_META_WS_P_GRAVITY: "Yerçekimi",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "El Bombası Maksimum Hasar",
  T_46_META_WS_P_GRENADEMINDAMAGE: "El Bombası Minimum Hasar",
  T_46_META_WS_P_GRENADERANGE: "El Bombası Menzili",
  T_46_META_WS_P_GROUPID: "Grup ID'si",
  T_46_META_WS_P_HEAD: "Başlık",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "Kafa Hasar Katsayısı",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "Kafadan Aldığı Hasar Azaltma",
  T_46_META_WS_P_HEIGHT: "Yükseklik",
  T_46_META_WS_P_HELMET: "Kask",
  T_46_META_WS_P_HIGHESTBRRANK: "En Yüksek BR Rütbesi",
  T_46_META_WS_P_HIGHESTCSRANK: "En Yüksek CS Rütbesi",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "Minimum Yükseklik Açısı",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "Yüksek Hızlı Direksiyon Sınırlaması",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "Yüksek Hızlı Direksiyon Sınırlama Eşiği",
  T_46_META_WS_P_HITPOINTEFFECT: "Vuruş Noktası Efekti",
  T_46_META_WS_P_HORIZONTALBAR: "Yatay Çubuk",
  T_46_META_WS_P_HORIZONTALOFFSET: "Yatay Kaydırma",
  T_46_META_WS_P_HOSTILETEAMS: "Düşman Takımları",
  T_46_META_WS_P_HOSTTEAM: "Ev Sahibi Takımı",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "Maks. HP",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "HP Kurtarma Miktarı",
  T_46_META_WS_P_HPRECOVERYSPEED: "HP Kurtarma Hızı (ms)",
  T_46_META_WS_P_ICON: "İkon",
  T_46_META_WS_P_ICONCOLOR: "İkon Rengi",
  T_46_META_WS_P_ICONNAME: "İkon Adı",
  T_46_META_WS_P_ICONRESOURCE: "İkon Kaynağı",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "Hasar Aralığı (sn)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "Boşta Fren Girdisi",
  T_46_META_WS_P_INACTIVATEDALPHA: "Etkin Olmayan Alfa",
  T_46_META_WS_P_INDEX: "Dizin",
  T_46_META_WS_P_INITIALMAGCOUNT: "İlk Şarjör Sayısı",
  T_46_META_WS_P_INITIALSPEED: "İlk Hız",
  T_46_META_WS_P_INITIALVALUE: "Başlangıç Değeri",
  T_46_META_WS_P_INITIALWORLDPOSITION: "Başlangıç Dünya Konumu",
  T_46_META_WS_P_INSCENE: "Sahnede",
  T_46_META_WS_P_INSTANCEID: "Instance ID'si",
  T_46_META_WS_P_INTENSITY: "Yoğunluk",
  T_46_META_WS_P_INVERTFILL: "Doldurmayı Ters Çevir",
  T_46_META_WS_P_INVINCIBLE: "Yenilmez",
  "T_46_META_WS_P_IS SHOW": "Görüntüle",
  T_46_META_WS_P_IS3D: "3D Mi",
  T_46_META_WS_P_ISACE: "ACE mi?",
  T_46_META_WS_P_ISACED: "Tamamen Yok Edilme",
  T_46_META_WS_P_ISAI: "AI mı?",
  T_46_META_WS_P_ISALWAYSINSCREEN: "Her Zaman Ekranda",
  T_46_META_WS_P_ISAPPLYSHADOW: "Gölge Uygula",
  T_46_META_WS_P_ISATTACKABLE: "Saldırılabilir",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "Düşmanı Otomatik Takip Etme",
  T_46_META_WS_P_ISAUTOPLAY: "Otomatik Oynat",
  T_46_META_WS_P_ISAUTOTELEPORT: "Otomatik Taşınma mı",
  T_46_META_WS_P_ISBILLBOARD: "Her Zaman Videoda",
  T_46_META_WS_P_ISBOLD: "Kalın",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "Alt Çarpışma Durumu",
  T_46_META_WS_P_ISCENTERPOS: "Merkez Pozisyonu",
  T_46_META_WS_P_ISCONSUMEAMMO: "Mermi Tüketimi",
  T_46_META_WS_P_ISCONTINUOUS: "Sürekli mi",
  T_46_META_WS_P_ISCOUNTDOWN: "Geri Sayım",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "Mevcut Animasyon Döngüsü mü?",
  T_46_META_WS_P_ISDEADDROP: "Ölüm Düşüş Desteği",
  T_46_META_WS_P_ISDEATHTRIGGER: "Ölüm Tetikleyicisi mi",
  T_46_META_WS_P_ISDEBUG: "BTree Hata Ayıklamayı Etkinleştir",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "Varsayılan Doğuş Noktası mı",
  T_46_META_WS_P_ISDROPONELIMINATED: "Ölünce Eşyalar Düşer",
  T_46_META_WS_P_ISEND: "Bitiş",
  T_46_META_WS_P_ISFEBUTTON: "FE Düğmesi mi",
  T_46_META_WS_P_ISGREY: "Gri mi",
  T_46_META_WS_P_ISGROUNDED: "Zemine Temas",
  T_46_META_WS_P_ISIGNOREDEPTH: "Derinliği Yoksay",
  T_46_META_WS_P_ISINVINCIBLE: "Yenilmez mi",
  T_46_META_WS_P_ISITALIC: "İtalik",
  T_46_META_WS_P_ISLASTROUND: "Son Tur mu",
  T_46_META_WS_P_ISLOCALPOS: "Yerel Koordinat Sistemi Etkinleştir",
  T_46_META_WS_P_ISLOOP: "Döngüleme",
  T_46_META_WS_P_ISMATCHPOINT: "Maç Puanı mı",
  T_46_META_WS_P_ISMOVEABLE: "Hareket Edilebilir",
  T_46_META_WS_P_ISOCCUPIED: "İşgal Edildi mi",
  T_46_META_WS_P_ISOPENTWEEN: "HP Değişiklik Efektlerini Etkinleştir",
  T_46_META_WS_P_ISPLAYING: "Oynatılıyor mu",
  T_46_META_WS_P_ISPURCHASABLE: "Mağaza Ürünleri",
  T_46_META_WS_P_ISREVERSE: "Ters Çevir",
  T_46_META_WS_P_ISSERVERDRIVEN: "Sunucu Tabanlı",
  T_46_META_WS_P_ISSHOW: "Göster",
  T_46_META_WS_P_ISSHOWHUDNAME: "HUD Adını Göster",
  T_46_META_WS_P_ISSHOWMAPINFO: "Harita Bilgilerini Göster",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "Hızlı Mesajı Göster",
  T_46_META_WS_P_ISSHOWSCAN: "Tarama Göster",
  T_46_META_WS_P_ISSHOWTAG: "Etiketi Göster",
  T_46_META_WS_P_ISSIDECOLLIDING: "Yan Çarpışma Durumu",
  T_46_META_WS_P_ISSILENCE: "Sessiz",
  T_46_META_WS_P_ISSINGLESHOT: "Tek Atış Midir",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "Düşüş Animasyonunu Atla",
  T_46_META_WS_P_ISSLIDING: "Kayma Durumu",
  T_46_META_WS_P_ISTOPCOLLIDING: "Üst Çarpışma Durumu",
  T_46_META_WS_P_ISUNDERLINE: "Altı Çizili",
  T_46_META_WS_P_ISVISIBLE: "Görünür mü",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "Kart Arka Plan Renkleri",
  T_46_META_WS_P_ITEMBACKGROUNDS: "Kart Arka Planları",
  T_46_META_WS_P_ITEMCOUNTS: "Satın Alınabilir mi",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "Kart Açıklamaları",
  T_46_META_WS_P_ITEMICONS: "Kart İkonları",
  T_46_META_WS_P_ITEMID: "Eşya ID'si",
  T_46_META_WS_P_ITEMIDS: "Ürün Kimlikleri",
  T_46_META_WS_P_ITEMNAMES: "Kart İsimleri",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "Yasaklı Eşya Listesi",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "Joystick Kap Sürükleme Yarıçapı",
  T_46_META_WS_P_JOYSTICKIMAGE: "Joystick Kap Resmi",
  T_46_META_WS_P_JOYSTICKRADIUS: "Joystick Kap Yarıçapı",
  T_46_META_WS_P_JUMPCD: "Zıplama CD",
  T_46_META_WS_P_JUMPHEIGHT: "Zıplama Yüksekliği",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "Sıçrama Yüksekliği Ölçeği",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "Yıkılma Hasar Bonusu",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "Düşme Durumu",
  T_46_META_WS_P_LABEL: "Etiket",
  T_46_META_WS_P_LABELCOLOR: "Etiket Rengi",
  T_46_META_WS_P_LABELKEY: "Etiket Anahtarı",
  T_46_META_WS_P_LABELPARAMS: "Etiket Parametreleri",
  T_46_META_WS_P_LASTCHECKPOINTID: "Mevcut Kontrol Noktası ID",
  T_46_META_WS_P_LASTSURVIVALTIME: "Son Hayatta Kalma Süresi",
  T_46_META_WS_P_LAYERTYPE: "Katman Türü",
  T_46_META_WS_P_LAYOUTTYPE: "Düzen Türü",
  T_46_META_WS_P_LEFTARM: "Sol Kol",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "Sol Arka Plan Rengi",
  T_46_META_WS_P_LEFTCOLOR: "Sol Renk",
  T_46_META_WS_P_LEFTDESCRIPTION: "Sol Açıklama",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "Sol Etki Aktif",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "Sol Ateş Açısı",
  T_46_META_WS_P_LEFTFOOT: "Sol Ayak",
  T_46_META_WS_P_LEFTHAND: "Sol El",
  T_46_META_WS_P_LEFTICON: "Sol İkon",
  T_46_META_WS_P_LEFTICONNAME: "Sol İkon Adı",
  T_46_META_WS_P_LEFTLEG: "Sol Bacak",
  T_46_META_WS_P_LEFTPLAYERS: "Sol Oyuncular",
  T_46_META_WS_P_LEFTSCORE: "Sol Skor",
  T_46_META_WS_P_LEFTSCOREAFTER: "Sol Nihai Skor",
  T_46_META_WS_P_LEFTSCORETEXT: "Sol Skor",
  T_46_META_WS_P_LEFTTEAM: "Sağ Takım",
  T_46_META_WS_P_LEFTTEAMINDEX: "Sol Takım Endeksi",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "Sol Takım Üyesi Hayatta Sayısı",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "Sol Takım Üyesi Bayrak Sayısı",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "Sol Takım Üyesi Durumları",
  T_46_META_WS_P_LEFTTEAMNAME: "Sol Takım Adı",
  T_46_META_WS_P_LEFTTEAMSCORE: "Sol Takım Skoru",
  T_46_META_WS_P_LEFTTEXT: "Sol Metin",
  T_46_META_WS_P_LENGTH: "Uzunluk",
  T_46_META_WS_P_LENSFLARE: "Lens Flare",
  T_46_META_WS_P_LEVEL: "Seviye",
  T_46_META_WS_P_LIFETIME: "Ömür Süresi (sn)",
  T_46_META_WS_P_LIGHTCOLOR: "Işık Rengi",
  T_46_META_WS_P_LIGHTINTENSITY: "Işık Şiddeti",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "Uzuv Hasar Katsayısı",
  T_46_META_WS_P_LINESPACING: "Satır Aralığı",
  T_46_META_WS_P_LOCALPOSITION: "Yerel Konum",
  T_46_META_WS_P_LOCALROTATION: "Yerel Dönüşüm",
  T_46_META_WS_P_LOCALROTATIONQ: "Yerel Dönme Kuaterniyon",
  T_46_META_WS_P_LOCALSCALE: "Yerel Ölçek",
  T_46_META_WS_P_LOCKEY: "Yerelleştirme Anahtarı",
  T_46_META_WS_P_LOOPCOUNT: "Döngü Sayısı",
  T_46_META_WS_P_LOOTSOCCER: "Loot Futbol",
  T_46_META_WS_P_LOSEHPCOLOR: "HP Kaybı Rengi",
  T_46_META_WS_P_LOSEMVPS: "Kaybeden MVP'ler",
  T_46_META_WS_P_LOSETEXT: "Kaybetme Metni",
  "T_46_META_WS_P_MAIN CAMERA": "Ana Kamera",
  T_46_META_WS_P_MAINCOLOR: "Ana Renk",
  T_46_META_WS_P_MAINSCORELIST: "Ana Skorlar",
  T_46_META_WS_P_MAINSCORETITLE: "Ana Skor Başlığı",
  T_46_META_WS_P_MAINWEAPON: "Ana Silah",
  T_46_META_WS_P_MAPSIZE: "Harita Boyutu",
  T_46_META_WS_P_MASK: "Maske",
  T_46_META_WS_P_MASKNAME: "Maske Adı",
  T_46_META_WS_P_MASS: "Kütle (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "Maç Başlığı Sol",
  T_46_META_WS_P_MATCHTITLERIGHT: "Maç Başlığı Sağ",
  T_46_META_WS_P_MAXCAPACITY: "Maksimum Kapasite",
  T_46_META_WS_P_MAXCOUNT: "Maks. Sayı",
  T_46_META_WS_P_MAXDAMAGE: "Maksimum Hasar",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "Maksimum İniş Açısı",
  T_46_META_WS_P_MAXDISPLACEMENT: "Maks. Yer Değiştirme",
  T_46_META_WS_P_MAXDISTANCE: "Maks. Mesafe",
  T_46_META_WS_P_MAXDURABILITY: "Maksimum Dayanıklılık",
  T_46_META_WS_P_MAXDURABILITYRATIO: "Maksimum Dayanıklılık Oranı",
  T_46_META_WS_P_MAXENERGY: "Maksimum Enerji",
  T_46_META_WS_P_MAXEP: "Maks. EP",
  T_46_META_WS_P_MAXHP: "Maks. HP",
  T_46_META_WS_P_MAXJUMPCOUNT: "Maksimum Zıplama Sayısı",
  T_46_META_WS_P_MAXJUMPHEIGHT: "Maks. Atlama Yüksekliği",
  T_46_META_WS_P_MAXLENGTH: "Maksimum Uzunluk",
  T_46_META_WS_P_MAXPROGRESS: "Maksimum İlerleme",
  T_46_META_WS_P_MAXSCATTERRATIO: "Maksimum Dağılma Oranı",
  T_46_META_WS_P_MAXSPEED: "Maksimum Hız",
  T_46_META_WS_P_MAXTURRETCOUNT: "Maks. Kule Sayısı",
  T_46_META_WS_P_MAXVALUE: "Maksimum Değer",
  T_46_META_WS_P_MAXWIDGETID: "MaxWidgetID",
  T_46_META_WS_P_MINDAMAGE: "Minimum Hasar",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "Minimum Hasar Mesafesi",
  T_46_META_WS_P_MINDISTANCE: "Min. Mesafe",
  T_46_META_WS_P_MINELEVATIONANGLE: "Minimum Yükselme Açısı",
  T_46_META_WS_P_MINENDHEIGHT: "Minimum Son Yüksekliği",
  T_46_META_WS_P_MINFLYHEIGHT: "Minimum Uçuş Yüksekliği",
  T_46_META_WS_P_MINMOVEDISTANCE: "Minimum Hareket Mesafesi",
  T_46_META_WS_P_MINVALUE: "Minimum Değer",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "Füze Maksimum Hasarı",
  T_46_META_WS_P_MISSILEMINDAMAGE: "Füze Minimum Hasarı",
  T_46_META_WS_P_MISSILERANGE: "Füze Menzili",
  T_46_META_WS_P_MODEL: "Model",
  T_46_META_WS_P_MODELVISIBILITY: "Model Görünürlüğü",
  T_46_META_WS_P_MODELVISIBLE: "Model Görünürlük",
  T_46_META_WS_P_MONEY: "Para",
  T_46_META_WS_P_MONEYLIST: "Para Listesi",
  T_46_META_WS_P_MONEYS: "Bağlı Cüzdan",
  T_46_META_WS_P_MONEYTYPE: "Para Türü",
  T_46_META_WS_P_MONSTERTYPE: "Canavar Türü",
  T_46_META_WS_P_MOTIONTYPE: "Hareket Türü",
  T_46_META_WS_P_MOTIONVALUEX: "X Yönü Hareket Değeri",
  T_46_META_WS_P_MOTIONVALUEY: "Y Yönü Hareket Değeri",
  T_46_META_WS_P_MOTIONVALUEZ: "Z Yönü Hareket Değeri",
  T_46_META_WS_P_MOVEMENTDURATION: "Hareket Süresi",
  T_46_META_WS_P_MULTIPLIER: "Çarpan",
  T_46_META_WS_P_MUSICELEMENTTYPE: "Müzik Unsur Türü",
  T_46_META_WS_P_MUZZLEVELOCITY: "Namlu Hızı",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "Adı",
  T_46_META_WS_P_NEXTROUNDINDEX: "Bir Sonraki Tur Endeksi",
  T_46_META_WS_P_NICKNAME: "Takma Ad",
  T_46_META_WS_P_NORMALCOLOR: "Normal Renk",
  T_46_META_WS_P_NORMALIZEDPOSITION: "Normalleştirilmiş Konum",
  T_46_META_WS_P_NUMBERINFACTION: "Fraksiyondaki Numarası",
  T_46_META_WS_P_OBJECTID: "Nesne ID",
  T_46_META_WS_P_OFFSET: "Ofset",
  T_46_META_WS_P_OPTIONS: "Seçenekler",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "Diğer Hasar Katsayısı",
  T_46_META_WS_P_OUTFIT: "Kıyafet",
  T_46_META_WS_P_OVERFLOW: "Taşma",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "Fazla Yükseklik Düşüş Hızı",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "Oyuncu Konfigürasyon Önceliği",
  T_46_META_WS_P_OWNER: "Sahip",
  T_46_META_WS_P_PARAMS: "Parametreler",
  T_46_META_WS_P_PARENT: "Ebeveyn",
  T_46_META_WS_P_PARENTID: "Ana ID",
  T_46_META_WS_P_PARENTUI: "Ana UI",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "Üst Widget Varlık Kimliği",
  T_46_META_WS_P_PARENTWIDGETFILEID: "Ebeveyn Widget Dosya Kimliği",
  T_46_META_WS_P_PARTMASKA: "Parça Maskesi 1",
  T_46_META_WS_P_PASSENGERS: "Yolcular",
  T_46_META_WS_P_PATHID: "Yol ID'si",
  T_46_META_WS_P_PAUSEEVENT: "Olayı Duraklat",
  T_46_META_WS_P_PERSONAID: "Persona ID",
  T_46_META_WS_P_PHASEDURATION: "Süre (ms)",
  T_46_META_WS_P_PHASEENDTIME: "Bitiş Zamanı (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "Fizik Katmanı",
  T_46_META_WS_P_PINID: "Rozet ID",
  T_46_META_WS_P_PITCH: "Yükselme Açısı",
  T_46_META_WS_P_PIVOT: "Pivot",
  T_46_META_WS_P_PLAYER: "Oyuncu",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "Oyuncu Nişan Alma Hızı Faktörü",
  T_46_META_WS_P_PLAYERLIST: "Oyuncu Listesi",
  T_46_META_WS_P_PLAYERNAME: "Oyuncu Adı",
  T_46_META_WS_P_PLAYERRANK: "Oyuncu Sıralaması",
  T_46_META_WS_P_PLAYERRANKS: "Oyuncu Sıralamaları",
  T_46_META_WS_P_PLAYERS: "Oyuncular",
  T_46_META_WS_P_PLAYERSCORETYPES: "Oyuncu Skor Türleri",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "Oyuncu Hızı Faktörü",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "Ateş Edilirken Oyuncu Hızı Faktörü",
  T_46_META_WS_P_PLAYERSTATUS: "Oyuncu Durumu",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "Oyuncu Çekiş Hızı",
  T_46_META_WS_P_PLAYINGSTATUS: "Oynatma Durumu",
  T_46_META_WS_P_PLAYSPEED: "Oynatma Hızı",
  T_46_META_WS_P_POINTPOSITION: "Nokta Konumu",
  T_46_META_WS_P_POINTS: "Puanlar",
  T_46_META_WS_P_POSITION: "Konum",
  T_46_META_WS_P_PREFABID: "Prefab ID",
  T_46_META_WS_P_PRESSEDCOLOR: "Basılı Renk",
  T_46_META_WS_P_PRESSEDSPRITE: "Basılı Sprite",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "Basılı Sprite Türü",
  T_46_META_WS_P_PRICE: "Fiyat",
  T_46_META_WS_P_PRIORITY: "Öncelik",
  T_46_META_WS_P_PROFILEINFO: "Profil Bilgisi",
  T_46_META_WS_P_PROGRESS: "İlerleme [0,1]",
  T_46_META_WS_P_PROGRESSICON: "İlerleme İkonu",
  T_46_META_WS_P_PROGRESSICONNAME: "İlerleme İkonu Adı",
  T_46_META_WS_P_PROPID: "Özellik ID'si",
  T_46_META_WS_P_PURCHASELIMIT: "Satın Alma Sınırı",
  T_46_META_WS_P_RADIUS: "Yarıçap",
  T_46_META_WS_P_RANGE: "Menzil",
  T_46_META_WS_P_RANK: "Sıralama",
  T_46_META_WS_P_RATIOSELFFACTOR: "Kendi Hasar Katsayısı",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "Takım Arkadaşı Hasar Katsayısı",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "Araç Hasar Katsayısı",
  T_46_META_WS_P_REFRESHTIME: "Buff Yenileme Süresi (s)",
  T_46_META_WS_P_RELOADSPEED: "Yeniden Doldurma Hızı",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "Şarjör Yenileme Hızı Faktörü",
  T_46_META_WS_P_REMAINJUMPCOUNT: "Kalan Zıplama Sayısı",
  T_46_META_WS_P_REMAINQUANTITY: "Kalan Miktar",
  T_46_META_WS_P_RENDERTYPE: "Render Türü",
  T_46_META_WS_P_REPEATTIMES: "Tekrarlama Sayısı",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "Değiştirme Önceliği",
  T_46_META_WS_P_REQUESTEDITEMLIST: "Tetiklenen Varlık ID",
  T_46_META_WS_P_REQUESTTYPE: "İstenen Ürün Listesi",
  T_46_META_WS_P_RESETPERROUND: "Raund Başına Sıfırla",
  T_46_META_WS_P_RESETPOSITION: "Sıfırlama Konumu",
  T_46_META_WS_P_RESETTIME: "Sıfırlama Süresi",
  T_46_META_WS_P_RESOURCE: "Kaynak",
  T_46_META_WS_P_RESOURCEID: "Kaynak ID",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "Panel İçinde Kısıtlama",
  T_46_META_WS_P_RESULT: "Sonuç",
  T_46_META_WS_P_RESULTTYPE: "Sonuç Türü",
  T_46_META_WS_P_REVIVALPOINT: "Yeniden Doğuş Noktası",
  T_46_META_WS_P_REVIVECD: "Canlandırma Süresi",
  T_46_META_WS_P_RIGHT: "Sağ",
  T_46_META_WS_P_RIGHTARM: "Sağ Kol",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "Sağ Arka Plan Rengi",
  T_46_META_WS_P_RIGHTCOLOR: "Sağ Renk",
  T_46_META_WS_P_RIGHTDESCRIPTION: "Sağ Açıklama",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "Sağ Etki Aktif",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "Sağ Ateş Açısı",
  T_46_META_WS_P_RIGHTFOOT: "Sağ Ayak",
  T_46_META_WS_P_RIGHTHAND: "Sağ El",
  T_46_META_WS_P_RIGHTICON: "Sağ İkon",
  T_46_META_WS_P_RIGHTICONNAME: "Sağ İkon Adı",
  T_46_META_WS_P_RIGHTLEG: "Sağ Bacak",
  T_46_META_WS_P_RIGHTPLAYERS: "Sağ Oyuncular",
  T_46_META_WS_P_RIGHTSCORE: "Sağ Skor",
  T_46_META_WS_P_RIGHTSCOREAFTER: "Sağ Nihai Skor",
  T_46_META_WS_P_RIGHTSCORETEXT: "Sağ Skor",
  T_46_META_WS_P_RIGHTTEAM: "Başlıklar",
  T_46_META_WS_P_RIGHTTEAMINDEX: "Sağ Takım Endeksi",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "Sağ Takım Üyesi Hayatta Sayısı",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "Sağ Takım Bayrağı Sayısı",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "Sağ Takım Üyesi Durumları",
  T_46_META_WS_P_RIGHTTEAMNAME: "Sağ Takım Adı",
  T_46_META_WS_P_RIGHTTEAMSCORE: "Sağ Takım Skoru",
  T_46_META_WS_P_RIGHTTEXT: "Sağ Metin",
  T_46_META_WS_P_RIMALPHA: "Kenar Alfa",
  T_46_META_WS_P_RIMCOLOR: "Kenar Rengi",
  T_46_META_WS_P_RIMTEXTURE: "Kenar Doku",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "Sürtünme Katsayısı",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "Acele Edilme Sürtünme Katsayısı",
  T_46_META_WS_P_ROTATION: "Dönüş",
  T_46_META_WS_P_ROTATIONANGLE: "Dönüş Açısı",
  T_46_META_WS_P_ROTATIONQ: "Rotasyon Kuaterniyon",
  T_46_META_WS_P_ROUNDINCOME: "Tur Geliri",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "Tur Geliri Detay Sayıları",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "Tur Geliri Detay Başlıkları",
  T_46_META_WS_P_ROUNDINCOMETITLE: "Tur Geliri Başlığı",
  T_46_META_WS_P_ROUNDNUM: "Tur Numarası",
  T_46_META_WS_P_ROUNDNUMKEY: "Tur Numara Anahtarı",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "Tur Numara Yerelleştirme Anahtarı Parametreleri",
  T_46_META_WS_P_RUNSPEED: "Koşu Hızı",
  T_46_META_WS_P_RUNSPEEDSCALE: "Koşu Hızı Ölçeği",
  T_46_META_WS_P_RUSHDISTANCE: "Rush Mesafe",
  T_46_META_WS_P_RUSHENERGYCOST: "Rush Enerji Maliyeti",
  T_46_META_WS_P_RUSHVERTICALSPEED: "Rush Dikey Hız",
  T_46_META_WS_P_SCALE: "Ölçek",
  T_46_META_WS_P_SCATTERINCREASESPEED: "Dağılma Artış Hızı",
  T_46_META_WS_P_SCATTERMAX: "Maksimum Dağılma",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "Hareket Halindeyken Dağılma Çarpanı",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "Dağılma Kurtarma Hızı",
  T_46_META_WS_P_SCATTERSPEED: "Dağılma Hızı",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "Çömelme/Yere Yatmada Dağılma Hızı",
  T_46_META_WS_P_SCATTERTHRESHOLD: "Dağılma Eşiği",
  T_46_META_WS_P_SCOPETYPE: "Kapsama Türü",
  T_46_META_WS_P_SCORE: "Skor",
  T_46_META_WS_P_SCORES1: "Skorlar 1",
  T_46_META_WS_P_SCORES2: "Skorlar 2",
  T_46_META_WS_P_SCORES3: "Skorlar 3",
  T_46_META_WS_P_SCORES4: "Skorlar 4",
  T_46_META_WS_P_SCORES5: "Skorlar 5",
  T_46_META_WS_P_SCORETEXTKEY: "Skor Metin Anahtarı",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "Skor Metin Anahtarı Parametreleri",
  T_46_META_WS_P_SCROLLCONTINUITY: "Kaydırma Sürekliliği",
  T_46_META_WS_P_SCROLLDIRECTION: "Kaydırma Yönü",
  T_46_META_WS_P_SCROLLEFFECT: "Kaydırma Etkisi",
  T_46_META_WS_P_SCROLLWHEELSPEED: "Kaydırma Tekerleği Hızı",
  T_46_META_WS_P_SECONDSCORETITLE: "İkinci Skor Başlığı",
  T_46_META_WS_P_SECONDSCOREVALUE: "İkinci Skor Değeri",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "İkinci Skor Parametreleri",
  T_46_META_WS_P_SELECTEDCOLOR: "Seçili Renk",
  T_46_META_WS_P_SELECTEDINDEX: "Seçilen İndeks",
  T_46_META_WS_P_SELECTEDSPRITE: "Seçili Sprite",
  T_46_META_WS_P_SELECTEDTYPE: "Seçili Tür",
  T_46_META_WS_P_SELF: "Kendisi",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "Kendi Hasar Faktörü",
  T_46_META_WS_P_SET: "Takım Elbisesi",
  T_46_META_WS_P_SHADERNAME: "Shader Adı",
  T_46_META_WS_P_SHADOWCOLOR: "Gölge Rengi",
  T_46_META_WS_P_SHADOWOFFSET: "Gölge Kaydırması",
  T_46_META_WS_P_SHADOWSTRENGTH: "Gölge Gücü",
  T_46_META_WS_P_SHELFS: "Manuel Kapatma Devre Dışı mı",
  T_46_META_WS_P_SHOES: "Ayakkabı",
  T_46_META_WS_P_SHOOTANGLEMAX: "Maksimum Atış Açısı",
  T_46_META_WS_P_SHOOTANGLEMIN: "Minimum Atış Açısı",
  T_46_META_WS_P_SHOP: "Mağaza",
  T_46_META_WS_P_SHOPITEMS: "Raflar",
  T_46_META_WS_P_SHOWADDFRIEND: "Arkadaş Ekleme Göster",
  T_46_META_WS_P_SHOWATTACKGRENADE: "Saldırı Bombası Göster",
  T_46_META_WS_P_SHOWBACKGROUND: "Arka Planı Göster",
  T_46_META_WS_P_SHOWCROUCH: "Çömelme Göster",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "Hasar Numarasını Göster",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "Savunma Bombası Göster",
  T_46_META_WS_P_SHOWECCONOMY: "Ekonomi Göster",
  T_46_META_WS_P_SHOWECONOMY: "Ekonomi Göster",
  T_46_META_WS_P_SHOWFIRE: "Ateş Göster",
  T_46_META_WS_P_SHOWFRAME: "Çerçeveyi Göster",
  T_46_META_WS_P_SHOWGIFT: "Hediyeyi Göster",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "Vuruş Noktası Efektini Göster",
  T_46_META_WS_P_SHOWJUMP: "Zıplama Göster",
  T_46_META_WS_P_SHOWLIKE: "Beğenileri Göster",
  T_46_META_WS_P_SHOWLOBBY: "Lobiye Dönüşü Göster",
  T_46_META_WS_P_SHOWMAPEVALUATE: "Harita Değerlendirmesini Göster",
  T_46_META_WS_P_SHOWMATCHDETAIL: "Maç Detayını Göster",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "Hareketli Joystick Göster",
  T_46_META_WS_P_SHOWNAME: "Takma Adı Göster",
  T_46_META_WS_P_SHOWPIN: "Pin Göster",
  T_46_META_WS_P_SHOWPRONE: "Yatış Göster",
  T_46_META_WS_P_SHOWRANK: "Sıralamayı Göster",
  T_46_META_WS_P_SHOWREPLAY: "Tekrarı Göster",
  T_46_META_WS_P_SHOWREPORT: "Raporu Göster",
  T_46_META_WS_P_SHOWSHARE: "Paylaşımı Göster",
  T_46_META_WS_P_SHOWSPRINT: "Sprint Göster",
  T_46_META_WS_P_SHOWTAG: "Etiketi Göster",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "Takım Arkadaşları Bilgisi Göster",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "Takım Üyesi Durumunu Göster",
  T_46_META_WS_P_SHOWTEAMSCORE: "Takım Skorunu Göster",
  T_46_META_WS_P_SHOWTIMETYPE: "Zaman Türü Göster",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "İki Takımın Skorunu Göster",
  T_46_META_WS_P_SHRINKDURATION: "Küçülme Süresi (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "Küçülme Bitiş Zamanı (ms)",
  T_46_META_WS_P_SHRINKSPEED: "Yakınsama Oranı",
  T_46_META_WS_P_SHRINKSTARTTIME: "Küçülme Başlangıç Zamanı (s)",
  T_46_META_WS_P_SIGHTAIMASSIST: "ADS Nişan Yardımını Etkinleştir",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "Nişan Yardımı Mesafe Azaltma Katsayısı (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "Nişan Yardımı Mesafe Etki Katsayısı (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "Nişan Yardımı Maksimum Mesafe Önceliği",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "Nişan Yardımı Minimum Mesafe Önceliği",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "Nişan Yardımı Mesafesi Önceliğini Etkinleştir",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "Nişan Yardımı Ekran Alanı Çekim Oranı (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "Görüş Büyütme Oranı",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "FOV Büyütme",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "ADS Döndürme Hassasiyeti",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "ADS Minimum Hasar Mesafesi Düzeltme Katsayısı",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "ADS Büyütme Süresi (s)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "ADS Büyütme",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "ADS Kurtarma Süresi (s)",
  T_46_META_WS_P_SIZE: "Boyut",
  T_46_META_WS_P_SIZEDELTA: "Boyut Değişikliği",
  T_46_META_WS_P_SKELETON: "İskelet",
  T_46_META_WS_P_SKIN: "Deri",
  T_46_META_WS_P_SKINID: "Kaplama Kimliği",
  T_46_META_WS_P_SKINWIDTH: "Deri Kalınlığı",
  T_46_META_WS_P_SKYBOXENV: "Gökyüzü Kutusu",
  T_46_META_WS_P_SKYBOXRESOURCE: "Gökyüzü Kutusu Kaynağı",
  T_46_META_WS_P_SLOPELIMIT: "Eğim Sınırı",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "Düzgün Kaydırma Başlangıcı",
  T_46_META_WS_P_SOFTNESS: "Yumuşaklık",
  T_46_META_WS_P_SORTTYPE: "Sıralama Türü",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "Dalga Başına Üretim Miktarı",
  T_46_META_WS_P_SPAWNPOINT: "Yeniden Doğuş Noktası",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "Doğuş Noktası Sayısı",
  T_46_META_WS_P_SPAWNPOSITION: "Doğuş Pozisyonu",
  T_46_META_WS_P_SPEED: "Hız",
  T_46_META_WS_P_SPEEDWHILEAIMING: "Kapsama Hız Oranı",
  T_46_META_WS_P_SPRAYCOLOR: "Sprey Rengi",
  T_46_META_WS_P_SPRINTENERGYCOST: "Sprint Enerji Maliyeti",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "Sprint Yatay Hız",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "Sprint hareket hız ölçeği",
  T_46_META_WS_P_SPRITENAME: "Sprite Şekli",
  T_46_META_WS_P_SPRITERESOURCE: "Sprite Kaynağı",
  T_46_META_WS_P_SRCVAL: "Kaynak Değer",
  T_46_META_WS_P_STARTDROPTIME: "Düşüş Başlangıç Süresi (ms)",
  T_46_META_WS_P_STARTEVENT: "Olay Başlat",
  T_46_META_WS_P_STARTPOSITION: "Başlangıç Pozisyonu",
  T_46_META_WS_P_STARTRADIUS: "Başlangıç Yarıçapı",
  T_46_META_WS_P_STARTSPAWNTIME: "Doğuş Başlangıç Zamanı (s)",
  T_46_META_WS_P_STARTTIME: "Başlangıç Zamanı (s)",
  T_46_META_WS_P_STARTVALUE: "Başlangıç Değeri",
  T_46_META_WS_P_STATICICONCOLORS: "Statik İkon Renkleri",
  T_46_META_WS_P_STATICICONS: "Statik İkonlar",
  T_46_META_WS_P_STATUS: "Mini Sentry Durumu",
  T_46_META_WS_P_STEPOFFSET: "Adım Ofseti",
  T_46_META_WS_P_STOPDURATION: "Durma Süresi",
  T_46_META_WS_P_STOPEVENT: "Olay Durdur",
  T_46_META_WS_P_STORE: "Mağaza",
  T_46_META_WS_P_STROPID: "Strop ID'si",
  T_46_META_WS_P_STYLE: "Stil",
  T_46_META_WS_P_SUBTITLE: "Altyazı",
  T_46_META_WS_P_SUMMULTIPLIER: "Toplam Çarpan",
  T_46_META_WS_P_SWINGEXITACCELERATION: "Sallanma Çıkış İvmesi",
  T_46_META_WS_P_SWINGINGSPEED: "Sallanma Hızı",
  T_46_META_WS_P_TAGS: "Etiketler",
  T_46_META_WS_P_TARGETCHECKPOINTID: "Hedef Kontrol Noktası ID",
  T_46_META_WS_P_TARGETICONCOLORS: "Hedef İkon Renkleri",
  T_46_META_WS_P_TARGETICONS: "Hedef İkonları",
  T_46_META_WS_P_TARGETID: "Hedef ID",
  T_46_META_WS_P_TARGETITEMID: "Hedef Öğesi ID'si",
  T_46_META_WS_P_TARGETROTATION: "Hedef Dönüşü",
  T_46_META_WS_P_TARGETSCALE: "Hedef Ölçeği",
  T_46_META_WS_P_TEAMCOLOR: "Takım Renk",
  T_46_META_WS_P_TEAMCOLORS: "Takım Renkleri",
  T_46_META_WS_P_TEAMINDEXS: "Takım Endeksleri",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "Takım Üyesi Hasar Faktörü",
  T_46_META_WS_P_TEAMMEMBERNUM: "Takım Üyesi Sayısı",
  T_46_META_WS_P_TEAMNUM: "Takım Sayısı",
  T_46_META_WS_P_TEAMRANK: "Takım Sıralaması",
  T_46_META_WS_P_TEAMRANKDISPLAY: "Takım Sıralama Görüntüleme",
  T_46_META_WS_P_TEAMRANKS: "Takım Sıralamaları",
  T_46_META_WS_P_TEAMSCORES: "Takım Skorları",
  T_46_META_WS_P_TEAMSEQ: "Takım Sırası",
  T_46_META_WS_P_TEMPLATEENTITY: "Şablon Varlığı",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "Geçici Kalkan Puanları",
  T_46_META_WS_P_TERRAINWETNESS: "Arazi Nemliliği",
  T_46_META_WS_P_TEXT: "Metin",
  T_46_META_WS_P_TEXTCOLOR: "Metin Rengi",
  T_46_META_WS_P_TEXTKEY: "Metin Anahtarı",
  T_46_META_WS_P_TEXTKEYPARAMS: "Metin Anahtarı Parametreleri",
  T_46_META_WS_P_TEXTURERESOURCE: "Doku Kaynağı",
  T_46_META_WS_P_THEMECOLOR: "Tema Rengi",
  T_46_META_WS_P_THROWABLETYPE: "Atılabilir Tür",
  T_46_META_WS_P_THROWINGSPEED: "Atış Hızı",
  T_46_META_WS_P_THROWSPEED: "Atış Hızı",
  T_46_META_WS_P_TICKINTERVAL: "Tik Aralığı",
  T_46_META_WS_P_TIMEREQUIRED: "Gerekli Süre (ms)",
  T_46_META_WS_P_TIPSTYPE: "İpucu Türü",
  T_46_META_WS_P_TITLE: "Başlık",
  T_46_META_WS_P_TITLELIST: "Başlıklar",
  T_46_META_WS_P_TITLES: "Skorlar 1",
  T_46_META_WS_P_TOP: "Üst",
  T_46_META_WS_P_TOPALPHA: "Üst Alfa",
  T_46_META_WS_P_TOTALHP: "Toplam HP",
  T_46_META_WS_P_TOTALLEVEL: "Toplam Seviye",
  T_46_META_WS_P_TOTALROUNDCOUNT: "Toplam Tur Sayısı",
  T_46_META_WS_P_TOWSPEED: "Çekme Hızı",
  T_46_META_WS_P_TRANSITIONSTAGE: "Geçiş Aşaması",
  T_46_META_WS_P_TRANSITIONTYPE: "Geçiş Türü",
  T_46_META_WS_P_TRIGGERPLAYERID: "Para",
  T_46_META_WS_P_TRIGGERRADIUS: "Tetikleme Menzili",
  T_46_META_WS_P_TRIGGERRANGE: "Tetikleme Aralığı",
  T_46_META_WS_P_TRIGGERTIME: "Tetikleme Zamanı",
  T_46_META_WS_P_TURNSPEED: "Dönüş Hızı",
  T_46_META_WS_P_TWEENERENABLED: "Sol Takım",
  T_46_META_WS_P_TWEENSTYLE: "Geçiş Stili",
  T_46_META_WS_P_TYPE: "Tür",
  T_46_META_WS_P_UNSELECTEDCOLOR: "Seçilmemiş Renk",
  T_46_META_WS_P_UNSELECTEDSPRITE: "Seçilmemiş Sprite",
  T_46_META_WS_P_UNSELECTEDTYPE: "Seçilmemiş Tür",
  T_46_META_WS_P_UP: "Yukarı",
  T_46_META_WS_P_UPDATETYPE: "Güncelleme Türü",
  T_46_META_WS_P_UPENERGYCOST: "Yukarı Enerji Maliyeti",
  T_46_META_WS_P_UPSPEED: "Yukarı Hız",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "Özel İtme Kuvveti Kullanımı",
  T_46_META_WS_P_USECUSTOMRESOURCE: "Özel Kaynak Kullan",
  T_46_META_WS_P_USEDCAPACITY: "Kullanılan Kapasite",
  T_46_META_WS_P_USEGRAVITY: "Yerçekimi Kullanımı",
  T_46_META_WS_P_USEPHYSICALCCT: "Fiziksel CCT Kullanımı",
  T_46_META_WS_P_USERUID: "Kullanıcı UID",
  T_46_META_WS_P_UVOFFSET: "UV Kaydırma",
  T_46_META_WS_P_UVSIZE: "UV Boyutu",
  T_46_META_WS_P_VALUE: "Değer",
  T_46_META_WS_P_VAULTDISTANCE: "Engelleri Aşma Mesafesi",
  T_46_META_WS_P_VAULTHEIGHT: "Engelleri Aşma Yüksekliği",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "Araç Hasar Faktörü",
  T_46_META_WS_P_VEHICLESKINID: "Araç Kaplama ID",
  T_46_META_WS_P_VEHICLESKINIDS: "Araç Kaplama ID'si",
  T_46_META_WS_P_VELOCITY: "Hız (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "XZ Yönü Hızı",
  T_46_META_WS_P_VELOCITYY: "Y Yönü Hızı",
  T_46_META_WS_P_VERTICALBAR: "Dikey Çubuk",
  T_46_META_WS_P_VERTICALOFFSET: "Dikey Kaydırma",
  T_46_META_WS_P_VEST: "Yelek",
  T_46_META_WS_P_VFXTEXTURETYPE: "VFX Doku Türü",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "Görüş Açısı Sınırlaması",
  T_46_META_WS_P_VISIBILITYLAYER: "Görünürlük Katmanı",
  T_46_META_WS_P_VISIBLE: "Görünür",
  T_46_META_WS_P_VISIBLEONBACK: "Sırtında Görünür",
  T_46_META_WS_P_VISIBLEPLAYERS: "Görünür Oyuncular",
  T_46_META_WS_P_VOLUME: "Ses Seviyesi",
  T_46_META_WS_P_WALLETID: "Cüzdan Kimliği",
  T_46_META_WS_P_WANDERRANGE: "Göçme Mesafesi",
  T_46_META_WS_P_WAVECOUNT: "Dalga Sayısı",
  T_46_META_WS_P_WAVEINTERVAL: "Dalga Aralığı",
  T_46_META_WS_P_WEAPONDAMAGERATE: "Silah Hasar Oranı",
  T_46_META_WS_P_WEAPONSKINIDS: "Silah Kaplama ID'leri",
  T_46_META_WS_P_WEAPONSUBTYPE: "Silah Alt Türü",
  T_46_META_WS_P_WEAPONTYPE: "Silah Türü",
  T_46_META_WS_P_WIDTH: "Genişlik",
  T_46_META_WS_P_WINMVPS: "Kazanan MVP'ler",
  T_46_META_WS_P_WINTEXT: "Kazanma Metni",
  T_46_META_WS_P_WORDWRAP: "Kelime Kaydırma",
  T_46_META_WS_P_WORLDPOSITION: "Dünya Pozisyonu",
  T_46_META_WS_P_YAW: "Yaw",
  T_46_META_WS_PATROLALONG: "Devriye Yolu",
  T_46_META_WS_PATROLTO: "Devriye Git",
  T_46_META_WS_PAUSE: "Duraklat",
  T_46_META_WS_PAUSEEMOTE: "Emote'u Durdur",
  T_46_META_WS_PAUSEFIXEDUPDATE: "Sabit Güncellemeyi Durdur",
  T_46_META_WS_PHASE: "Aşama",
  T_46_META_WS_PLAY: "Oynat",
  T_46_META_WS_PLAYANIMATION: "Animasyonu Oynat",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "Karakter Animasyon Klibini Oynat",
  T_46_META_WS_PLAYEMOTE: "Emote Çal",
  T_46_META_WS_PLAYER: "Oyuncu",
  T_46_META_WS_PORTAL: "Portal",
  T_46_META_WS_POSE: "Duruş",
  T_46_META_WS_POSITION: "Konum",
  T_46_META_WS_PREPOSE: "Önceki Duruş ",
  T_46_META_WS_PROFANITYFILTER: "Küfür Filtreleyici",
  T_46_META_WS_PURSUITTARGET: "Takip Hedefi",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "Quaternion'ı Eksen Açısına Dönüştür",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Quaternion'ı Euler Açısına Dönüştür",
  T_46_META_WS_QUITCHATCHANNEL: "Sohbet Kanalından Ayrıl",
  T_46_META_WS_QUITFACTION: "Fraksiyondan Ayrıl",
  T_46_META_WS_QUITGAME: "Oyundan Çık",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "Hapis Mini Oyundan Çık",
  T_46_META_WS_RANDOMFLOAT: "Rastgele Ondalık",
  T_46_META_WS_RANDOMINT: "Rastgele Tam Sayı",
  T_46_META_WS_RANK: "Sıralama",
  T_46_META_WS_READCSV: "CSV Oku",
  T_46_META_WS_READCSVCELL: "CSV Hücresini Oku",
  T_46_META_WS_READCSVCELLBYNAME: "CSV Hücresini Satır ve Sütun Adıyla Oku",
  T_46_META_WS_READCSVCELLFROMSERVER: "Sunucudan CSV Hücresini Oku",
  T_46_META_WS_READCSVCOLUMN: "CSV Sütununu Oku",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "Sunucudan CSV Sütununu Oku",
  T_46_META_WS_READCSVFROMSERVER: "Sunucudan CSV Oku",
  T_46_META_WS_READCSVROW: "CSV Satırını Oku",
  T_46_META_WS_READCSVROWBYKEY: "Anahtarla CSV Satırını Oku",
  T_46_META_WS_READCSVROWFROMSERVER: "Sunucudan CSV Satırını Oku",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "Birikmiş Veri Deposundan Oku",
  T_46_META_WS_READFROMDATASTORE: "Veri Deposundan Oku",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "Sıralama Veri Deposundan Oku",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "Sıralamaya Göre Veri Deposundan Oku",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "AOI Özel Takibi Kaldır",
  T_46_META_WS_REMOVEBACKPACKSKIN: "Sırt Çantası Kaplamasını Kaldır",
  T_46_META_WS_REMOVEBUFF: "Buff Kaldır",
  T_46_META_WS_REMOVECOMPONENT: "Bileşen Kaldır",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "Formül Özellik Faktörünü Kaldır",
  T_46_META_WS_REMOVEOUTFIT: "Kıyafeti Çıkar",
  T_46_META_WS_REMOVESCRIPT: "Betiği Kaldır",
  T_46_META_WS_REMOVEVEHICLESKIN: "Araç Kaplamasını Kaldır",
  T_46_META_WS_REMOVEWEAPONSKIN: "Silah Kaplamasını Çıkar",
  T_46_META_WS_REPLACE: "Değiştir",
  T_46_META_WS_REQUESTMATCHMAKING: "Eşleştirme İsteği",
  T_46_META_WS_RESET: "Sıfırla",
  T_46_META_WS_RESETBACKPACKSKIN: "Sırt Çantası Kaplamasını Sıfırla",
  T_46_META_WS_RESETDYEING: "Boyamayı Sıfırla",
  T_46_META_WS_RESETJERSEY: "Formayı Sıfırla",
  T_46_META_WS_RESETOUTFIT: "Kıyafeti Sıfırla",
  T_46_META_WS_RESETVEHICLESKIN: "Araç Kaplamasını Sıfırla",
  T_46_META_WS_RESETWEAPONSKIN: "Silah Kaplamasını Sıfırla",
  T_46_META_WS_RESUMEFIXEDUPDATE: "Sabit Güncellemeyi Devam Ettir",
  T_46_META_WS_REVERSE: "Ters Çevir",
  T_46_META_WS_REVIVALSOURCE: "Diriltme Kaynağı",
  T_46_META_WS_REVIVE: "Yeniden Canlandır",
  T_46_META_WS_ROUND: "Yuvarla",
  T_46_META_WS_ROUNDINDEX: "Tur İndeksi",
  T_46_META_WS_SAMPLEONCURVE: "Eğride Örnekleme",
  T_46_META_WS_SCENENAME: "Sahne Adı",
  T_46_META_WS_SCORE: "Puan",
  T_46_META_WS_SCORER: "Gol Atan",
  T_46_META_WS_SCORETYPE: "Puan Türü",
  T_46_META_WS_SCREENMULTIRAYCAST: "Ekran Çoklu Işın İzleme",
  T_46_META_WS_SCREENSINGLERAYCAST: "Ekran Tek Işın İzleme",
  T_46_META_WS_SCREENTOUCHRAY: "Ekran Dokunma Işını",
  T_46_META_WS_SCREENTOWORLDPOINT: "Ekran'dan Dünya'ya",
  T_46_META_WS_SENDEVENT: "Olay Gönder",
  T_46_META_WS_SETACTIVE: "Aktif Durum Ayarla",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "Tüm Oyuncuların Hareket Durumunu Ayarla",
  T_46_META_WS_SETATTACKABLEENTITY: "Saldırılabilir Varlığı Ayarla",
  T_46_META_WS_SETATTACKABLEFACTION: "Saldırılabilir Fraksiyonu Ayarla",
  T_46_META_WS_SETATTACKABLETEAM: "Saldırılabilir Takımı Ayarla",
  T_46_META_WS_SETBACKPACKSKIN: "Sırt Çantası Kaplamasını Ayarla",
  T_46_META_WS_SETBEHAVIORSTATUS: "Davranış Durumunu Ayarla",
  T_46_META_WS_SETBLACKBOARDVALUE: "Karatahta Değerini Ayarla",
  T_46_META_WS_SETBUNDLE: "Paket Ayarla",
  T_46_META_WS_SETCAMERAFOCUS: "Kameranın Odak Noktasını Ayarla",
  T_46_META_WS_SETCAMERAFOLLOW: "Kamerayı Takip Et Ayarla",
  T_46_META_WS_SETCHARACTER: "Karakteri Ayarla",
  T_46_META_WS_SETCULLINGMASK: "Kapatma Maskesi Ayarla",
  T_46_META_WS_SETCULLINGMASKLAYER: "Kapatma Maskesi Katmanı Ayarla",
  T_46_META_WS_SETDEFAULTUISTATUS: "Varsayılan UI Durumunu Ayarla",
  T_46_META_WS_SETDROPSTATUS: "Bırakma Durumunu Ayarla",
  T_46_META_WS_SETFALLINGDAMAGE: "Düşme Hasarını Ayarla",
  T_46_META_WS_SETFOOTBALLPOSITION: "Futbol Pozisyonunu Ayarla",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "Formül Özelliğini Mutlak Olarak Ayarla",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "Formül Özelliğini Göreli Olarak Ayarla",
  T_46_META_WS_SETFORWARD: "Yönü Ayarla",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "Küresel Uyku Eşiğini Ayarla",
  T_46_META_WS_SETINVINCIBILITY: "Dokunulmazlık Durumunu Ayarla",
  T_46_META_WS_SETJERSEY: "Formayı Ayarla",
  T_46_META_WS_SETOUTFIT: "Kıyafeti Ayarla",
  T_46_META_WS_SETPARENT: "Üstünü Ayarla",
  T_46_META_WS_SETPARENTCLIENT: "Üst Düğümü Ayarla",
  T_46_META_WS_SETPICKUPSTATUS: "Alım Durumunu Ayarla",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "Oyuncu Hızlı Mesaj Durumunu Ayarla",
  T_46_META_WS_SETPLAYERVOICESTATUS: "Oyuncu Ses Durumunu Ayarla",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "Özelliği Akıcı Bir Şekilde Ayarla",
  T_46_META_WS_SETSKILLS: "Becerileri Ayarla",
  T_46_META_WS_SETSKYBOX: "Gökyüzü Kutusunu Ayarla",
  T_46_META_WS_SETSLEEPTHRESHOLD: "Uyku Eşiğini Ayarla",
  T_46_META_WS_SETSPECIALITEMSTATUS: "Özel Öğenin Durumunu Ayarla",
  T_46_META_WS_SETVEHICLESKIN: "Araç Kaplamasını Ayarla",
  T_46_META_WS_SETWEAPONSKIN: "Silah Kaplamasını Ayarla",
  T_46_META_WS_SETWIDGETPARENT: "Widget'ın Üstünü Ayarla",
  T_46_META_WS_SHOPITEM: "Mağaza Öğesi",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "Görünüm Grubunu Göster",
  T_46_META_WS_SHUFFLE: "Karıştır",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "Tek Raycast",
  T_46_META_WS_SKILL: "Yetenek",
  T_46_META_WS_SLEEP: "Uyku",
  T_46_META_WS_SLERPQUATERNION: "Quaternion Slerp",
  T_46_META_WS_SPAWNABLES: "Oluşan Nesneler",
  T_46_META_WS_SPAWNEDITEM: "Oluşan Eşya",
  T_46_META_WS_SPAWNNEXTWAVE: "Sonraki Dalgayı Oluştur",
  T_46_META_WS_SPHERECAST: "Küre Cast",
  T_46_META_WS_SPHEREOVERLAP: "Küre Çakışması",
  T_46_META_WS_SPLIT: "Böl",
  T_46_META_WS_SQRT: "Karekök",
  T_46_META_WS_STARTPARACHUTE: "Paraşütü Başlat",
  T_46_META_WS_STARTPOSITION: "Başlangıç Konumu",
  T_46_META_WS_STATENAME: "Durum Adı",
  T_46_META_WS_STATUS: "Durum",
  T_46_META_WS_STRINGTOFLOAT: "Metni Kesirli Sayıya Çevir",
  T_46_META_WS_STRINGTOINT: "Metni Tam Sayıya Çevir",
  T_46_META_WS_STRIP: "Boşlukları Kaldır",
  T_46_META_WS_SUB: "Çıkar",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "AOI Proxy Gözlemcisini Değiştir",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "Görünüm Grubunu Değiştir",
  T_46_META_WS_SWITCHAREA: "Bölgeyi Değiştir",
  T_46_META_WS_SWITCHCAMERA: "Kamerayı Değiştir",
  T_46_META_WS_SWITCHPHASE: "Aşamayı Değiştir",
  T_46_META_WS_SWITCHSCENE: "Sahneyi Değiştir",
  T_46_META_WS_SWITCHWEAPON: "Silah Değiştir",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "Hedef",
  T_46_META_WS_TEAM: "Takım",
  T_46_META_WS_TELEPORT: "Teleport Et",
  T_46_META_WS_TELEPORTCCT: "CCT'yi Teleport Et",
  T_46_META_WS_TEXT: "Metin",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "Zaman Damgasını Yerelleştirme Metnine Çevir",
  T_46_META_WS_TIRE: "Tekerlek",
  T_46_META_WS_TOLOWER: "Küçük Harfe Çevir",
  T_46_META_WS_TOSTRING: "Dizeye Çevir",
  T_46_META_WS_TOUPPER: "Büyük Harfe Çevir",
  T_46_META_WS_TRANSFERMONEY: "Para Transferi",
  T_46_META_WS_TRIGGER: "Tetikleyici",
  T_46_META_WS_TYPEIS: "Tür Şu",
  T_46_META_WS_UNLOADSCENE: "Sahneyi Boşalt",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "Hapis Görevini Güncelle",
  T_46_META_WS_UPLOADGAMERESULT: "Oyun Sonuçlarını Yükle",
  T_46_META_WS_VALUE: "Hasar",
  T_46_META_WS_VECTOR2ANGLE: "2D Vektör Açısı",
  T_46_META_WS_VECTOR2DISTANCE: "2D Vektör Mesafesi",
  T_46_META_WS_VECTOR2DOT: "2D Vektör Noktası",
  T_46_META_WS_VECTOR2MAGNITUDE: "2D Vektör Büyüklüğü",
  T_46_META_WS_VECTOR2NORMALIZE: "2D Vektör Normalleştir",
  T_46_META_WS_VECTOR2REFLECT: "2D Vektör Yansıması",
  T_46_META_WS_VECTOR2TOVECTOR3: "2D Vektörü 3D Vektöre Dönüştür",
  T_46_META_WS_VECTOR3REFLECT: "3D Vektör Yansıması",
  T_46_META_WS_VECTOR3TOVECTOR2: "3D Vektörü 2D Vektöre Dönüştür",
  T_46_META_WS_VEHICLE: "Araç",
  T_46_META_WS_VELOCITY: "Hız",
  T_46_META_WS_WAITFORMILESECOND: "Milisaniye Bekle",
  T_46_META_WS_WAITFORNEXTFRAME: "Bir Sonraki Kareyi Bekle",
  T_46_META_WS_WAKEUP: "Uyandır",
  T_46_META_WS_WAVES: "Dalgalar",
  T_46_META_WS_WEAPON: "Silah",
  T_46_META_WS_WORLDTOSCREENPOINT: "Dünya'dan Ekran'a",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "Birikmiş Veri Deposuna Yaz",
  T_46_META_WS_WRITETODATASTORE: "Veri Deposuna Yaz",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "Sıralama Veri Deposuna Yaz",
  T_48_META_API_1_D: "Geçerli oyundaki tüm oyuncuları alır ve bir oyuncu listesi döndürür.",
  T_48_META_API_1_R_D: "Oyuncu Listesi",
  T_48_META_API_10_D: "Sahne Nesnelerini Alma",
  T_48_META_API_10_P0_D: "Ne tür sahne nesnelerinin filtreleneceği",
  T_48_META_API_10_R_D: "Sahne Nesnesi Listesi",
  T_48_META_API_100_D: "Önceden yüklenmiş senaryoları otomatik olarak boşaltmadan senaryoları yükleme",
  T_48_META_API_100_P0_D: "Yüklenecek sahne kimliği",
  T_48_META_API_10000_D: "Geçerli kodun bağlı olduğu varlığı döndürür",
  T_48_META_API_10000_R_D: "Geçerli kodun bağlı olduğu varlık",
  T_48_META_API_10001_D: "İlgili varlığı bulmak için varlık kimliğini kullanın, bu API yalnızca editör kullanımı içindir, bu API'nin kullanıcı tarafında kullanılması uyumluluğunu garanti etmez, örneğin",
  T_48_META_API_10001_P0_D: "Hedef varlık kimliği",
  T_48_META_API_10001_R_D: "maddi bir varlığa sahip olan şey (kavramsal, sanal veya çevrimiçi bir varlığın aksine)",
  T_48_META_API_10002_D: "Oyun için küresel varlığı alın",
  T_48_META_API_10002_R_D: "küresel varlık",
  T_48_META_API_10003_D: "Oyuncuları belirli koordinatlara ışınlar (kullanımdan kaldırılmıştır, Teleport kullanın)",
  T_48_META_API_10003_P0_D: "Işınlanan oyuncular",
  T_48_META_API_10003_P1_D: "Taşınan noktanın koordinatları",
  T_48_META_API_10004_D: "Takım arkadaşlarının yakınındaki konumu alır, ayakta duramayan oyuncuların konumunu atlatır (kullanımdan kaldırılmıştır, GetTeammateNearPosition kullanın)",
  T_48_META_API_10004_P0_D: "hedef oyuncu",
  T_48_META_API_10004_R_D: "Takım arkadaşlarına yakın koordinatlar",
  T_48_META_API_10005_D: "Devralan kuruluşa ait oyuncular",
  T_48_META_API_10005_P0_D: "Hedef varlık, varlık yalnızca ait olduğu oyuncu ile senkronize olur",
  T_48_META_API_10005_R_D: "Hedef kuruluşa ait oyuncular",
  T_48_META_API_10006_D: "Oyuncuyu yenilmez yapın",
  T_48_META_API_10006_P0_D: "hedef oyuncu",
  T_48_META_API_10006_P1_D: "Saniye cinsinden zarar görmezlik etkisinin süresi",
  T_48_META_API_10007_D: "Seçili varlığı ve tüm özelliklerini orijinal konumunda klonlayın",
  T_48_META_API_10007_P0_D: "Oluşturulan varlıklar",
  T_48_META_API_10007_P1_D: "klonlanacak varlık",
  T_48_META_API_10008_D: "Oyuncuya hasar verir, herhangi bir hasar kaynağı seçilmezse hedef sistemden hasar alır",
  T_48_META_API_10008_P0_D: "Yaralanan oyun kuruluşları",
  T_48_META_API_10008_P1_D: "Hasara neden olan oyun varlıkları",
  T_48_META_API_10008_P2_D: "Hasar türü",
  T_48_META_API_10008_P3_D: "hasar miktarı",
  T_48_META_API_10009_D: "Belirlenmiş Oyuncuyu Diriltme",
  T_48_META_API_10009_P0_D: "Dirilen oyuncular",
  T_48_META_API_1001_D: "Koşul yerine getirilirse, IF altındaki düğüm çalıştırılır. Koşul karşılanmazsa, bir ELSE varsa ELSE altındaki düğüm çalıştırılır, aksi takdirde IF deyimi sonlandırılır.",
  T_48_META_API_1001_P0_D: "Koşul listesinin alt prosedür listelerinin (mantıksal dal listeleri) sayısı ile tutarlı olması gerekir.",
  T_48_META_API_10010_D: "Belirtilen konumda bir öğe veya öğe listesi oluşturur.",
  T_48_META_API_10010_P0_D: "Öğe oluşturma konumu",
  T_48_META_API_10010_P1_D: "Oluşturulan öğeler veya öğe listeleri",
  T_48_META_API_10010_P2_D: "Oluşturulacak öğe sayısı. Bir öğe listesi oluştururken, öğe listesinin sırasına karşılık gelen öğe sayısını içeren bir liste doldurmanız gerekir.",
  T_48_META_API_10011_D: "Hedef noktalara devriye gezen yapay zeka varlıkları",
  T_48_META_API_10011_P0_D: "Hedeflenen yapay zeka varlıkları",
  T_48_META_API_10011_P1_D: "Hareketli hedef noktası",
  T_48_META_API_10011_P2_D: "Kalkış noktasına geri dönülüp dönülmeyeceği",
  T_48_META_API_10011_P3_D: "Devriye sırasında düşman hedeflerin tespit edilip edilmediği ve saldırıya uğrayıp uğramadığı",
  T_48_META_API_10012_D: "AI varlıkları koordinat listesi sırasına göre devriye gezer",
  T_48_META_API_10012_P0_D: "Hedeflenen yapay zeka varlıkları",
  T_48_META_API_10012_P1_D: "Hareketli Koordinat Noktaları Listesi",
  T_48_META_API_10012_P2_D: "Tek, gidiş-dönüş döngüsü veya döngü seçeneği ile devriye tipi",
  T_48_META_API_10012_P3_D: "Devriye sırasında düşman hedeflerin tespit edilip edilmediği ve saldırıya uğrayıp uğramadığı",
  T_48_META_API_10013_D: "Jeneratör bir sonraki birim varlık dalgasını hemen yeniler",
  T_48_META_API_10013_P0_D: "jeneratör varlığı",
  T_48_META_API_10014_D: "Nihai sonucu üretmek için faktörlerden oluşan bir formülle hesaplanacak olan hesaplanabilir nitelikleri hesaplamak için bir faktör ekleyin.",
  T_48_META_API_10014_P0_D: "hedef varlık",
  T_48_META_API_10014_P1_D: "Hesaplanabilir Öznitelik Türleri",
  T_48_META_API_10014_P2_D: "Hesaplama faktörü tipi",
  T_48_META_API_10014_P3_D: "Faktör değerlerinin hesaplanması",
  T_48_META_API_10015_D: "Hesaplanabilir nitelikler için hesaplama faktörünü temizleyin",
  T_48_META_API_10015_P0_D: "hedef varlık",
  T_48_META_API_10015_P1_D: "Hesaplanabilir Öznitelik Türleri",
  T_48_META_API_10016_D: "Hedef varlığın tüm hesaplanabilir nitelikleri için tüm hesaplama faktörlerini temizleyin",
  T_48_META_API_10016_P0_D: "hedef varlık",
  T_48_META_API_10017_D: "Öznitelikleri değiştirin",
  T_48_META_API_10017_P0_D: "hedef varlık",
  T_48_META_API_10017_P1_D: "Öznitelik Türü",
  T_48_META_API_10017_P2_D: "Modifikasyon yöntemi",
  T_48_META_API_10017_P3_D: "(olmak) değer",
  T_48_META_API_10018_D: "Hesaplanabilir bir özelliğin değerini ayarlama",
  T_48_META_API_10018_P0_D: "hedef varlık",
  T_48_META_API_10018_P1_D: "Öznitelik Türü",
  T_48_META_API_10018_P2_D: "(olmak) değer",
  T_48_META_API_10019_D: "Bireysel hesaplanabilir özellik değişikliklerinin temizlenmesi",
  T_48_META_API_10019_P0_D: "hedef varlık",
  T_48_META_API_10019_P1_D: "Öznitelik Türü",
  T_48_META_API_1002_D: "Parametre i minimum değerden başlar ve aşağıdaki düğüm her çalıştırıldığında i maksimum değere eşit veya daha büyük olana kadar adım değeri artar.",
  T_48_META_API_1002_P0_D: "Yerel bir değişken üzerindeki döngüsel indeksin değerini almak için kullanılabilecek döngüsel indeksin adı.",
  T_48_META_API_1002_P1_D: "Döngüsel başlangıç değeri",
  T_48_META_API_1002_P2_D: "döngü sonu değeri",
  T_48_META_API_1002_P3_D: "Döngü adım boyutu, başlangıç değeri bitiş değerinden küçük olduğunda, adım boyutu 0'dan büyük olmalıdır; başlangıç değeri bitiş değerinden büyük olduğunda, adım boyutu 0'dan küçük olmalıdır",
  T_48_META_API_10020_D: "Oyunda filtre kriterlerini karşılayan tüm varlıkları alın",
  T_48_META_API_10020_P0_D: "Filtre sonucu bu parametrede girilen türü içermelidir",
  T_48_META_API_10020_P1_D: "Filtre sonucu bu parametrede girilen türü içermemelidir",
  T_48_META_API_10020_P2_D: "Filtre sonuçları, bu parametrede girilen türlerden en az birini içerir",
  T_48_META_API_10020_R_D: "Sonuçlanan Varlık Listesini Filtreleme",
  T_48_META_API_10021_D: "Futbol topuna bir hız eklendiğinde, hız aynı yönde ivme ile değişecektir",
  T_48_META_API_10021_P0_D: "Goal Futbol",
  T_48_META_API_10021_P1_D: "3D uzay hızı eklendi",
  T_48_META_API_10022_D: "Belirlenmiş kuruluşların imhası",
  T_48_META_API_10022_P0_D: "İmha edilecek hedef varlıklar",
  T_48_META_API_10023_D: "Varlıklara etiket ekleme",
  T_48_META_API_10023_P0_D: "hedef varlık",
  T_48_META_API_10023_P1_D: "Özel etiketler",
  T_48_META_API_10024_D: "Varlıklar için etiketleri kaldırma",
  T_48_META_API_10024_P0_D: "hedef varlık",
  T_48_META_API_10024_P1_D: "Özel etiketler",
  T_48_META_API_10025_D: "Hedef varlığın belirtilen etiketi içerip içermediğini belirler",
  T_48_META_API_10025_P0_D: "hedef varlık",
  T_48_META_API_10025_P1_D: "Özel etiketler",
  T_48_META_API_10025_R_D: "Belirtilen etiketin dahil edilip edilmeyeceği",
  T_48_META_API_10026_D: "Futbol pozisyonunun ayarlanması",
  T_48_META_API_10026_P0_D: "futbol kuruluşu",
  T_48_META_API_10026_P1_D: "yerleştirme",
  T_48_META_API_10026_P2_D: "Hızın korunması",
  T_48_META_API_10027_D: "Hedef oyuncu tarafından o anda kullanılan kamera varlığını alır",
  T_48_META_API_10027_P0_D: "hedef oyuncu",
  T_48_META_API_10027_R_D: "Şu anda kullanılan kamera varlığı",
  T_48_META_API_10028_D: "Hedef oyuncunun kamerasını hedef kameraya geçirerek",
  T_48_META_API_10028_P0_D: "hedef oyuncu",
  T_48_META_API_10028_P1_D: "hedef kamera",
  T_48_META_API_10028_P2_D: "Anahtarlama yöntemi, orijinal mantığı korumayı veya aşamalı olmayı seçebilirsiniz",
  T_48_META_API_10028_P3_D: "Anahtarlama süresi, aşamalı modda kameraları değiştirme süresidir",
  T_48_META_API_10029_D: "Bir kamera oluşturun",
  T_48_META_API_10029_P0_D: "Oluşturulan kamera türü",
  T_48_META_API_10029_P1_D: "Oluşturulan Kamera Varlığı",
  T_48_META_API_1003_D: "Alt prosedürler içeren her bir alt öğeye ulaşmak için bir veri kabının çapraz geçişini uygulayın, döngü gövdesi alt prosedürdür",
  T_48_META_API_1003_P0_D: "Yerel değişkendeki alt öğenin değerine ulaşmak için kullanılabilecek alt öğenin adı üzerinde yineleme",
  T_48_META_API_1003_P1_D: "Yerel bir değişken üzerindeki döngüsel indeksin değerini almak için kullanılabilecek döngüsel indeksin adı.",
  T_48_META_API_1003_P2_D: "Geçilecek veri kapsayıcısı, şu anda aşağıdaki türler desteklenmektedir: dizi türü",
  T_48_META_API_10030_D: "Savaşılabilir varlıkları öldürün",
  T_48_META_API_10030_P0_D: "Savaşa hazır olması gereken hedef varlık",
  T_48_META_API_10031_D: "Hedef varlığın ve alt düğümlerinin etkin durumunu ayarlayın; etkin olmayan nesneler için kullanılabilirlik, görünürlük, çarpışmalar vb. kapatılır",
  T_48_META_API_10031_P0_D: "hedef varlık",
  T_48_META_API_10031_P1_D: "Aktif veya inaktif",
  T_48_META_API_10032_D: "Kamera varlığının konumunu her zaman hedef varlığı takip edecek şekilde ayarlayın",
  T_48_META_API_10032_P0_D: "hedef kamera varlığı",
  T_48_META_API_10032_P1_D: "Takip edilecek hedef kuruluş",
  T_48_META_API_10032_P2_D: "Hedef varlık koordinatlarından ofset",
  T_48_META_API_10032_P3_D: "Ofsetler için koordinat sistemi",
  T_48_META_API_10033_D: "Kamera varlığını her zaman hedef varlığa bakacak şekilde ayarlama",
  T_48_META_API_10033_P0_D: "hedef kamera varlığı",
  T_48_META_API_10033_P1_D: "hedef varlık",
  T_48_META_API_10033_P2_D: "Bakış noktasının hedef koordinatlardan ofseti",
  T_48_META_API_10033_P3_D: "Ofsetler için koordinat sistemi",
  T_48_META_API_10034_D: "Ara Oluştur",
  T_48_META_API_10034_P0_D: "hedef varlık",
  T_48_META_API_10034_P1_D: "Mülk Kimliği",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Stil",
  T_48_META_API_10034_P5_D: "Eğri",
  T_48_META_API_10034_P6_D: "Süre",
  T_48_META_API_10034_P7_D: "varlıklar arasında",
  T_48_META_API_10035_D: "Üst düğümün ayarlanması için hem üst hem de alt düğümün Transform bileşenine sahip olması gerekir",
  T_48_META_API_10035_P0_D: "ana düğüm",
  T_48_META_API_10035_P1_D: "çocuk düğümü",
  T_48_META_API_10035_P2_D: "Alt düğümlerin mevcut dünya konumunun, dönüşünün ve ölçeklendirmesinin korunup korunmayacağı, bu öğe UI ayarlanırken geçersizdir.",
  T_48_META_API_10036_D: "NewCurve (kullanımdan kaldırılmıştır, lütfen CreateTweenCurve kullanın)",
  T_48_META_API_10036_P0_D: "Kontrol Noktaları",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "Oynatılabilir bir bileşene sahip olması gereken hedef varlığı oynatmaya çalışır",
  T_48_META_API_10037_P0_D: "Hedef Oynanabilir Varlık",
  T_48_META_API_10037_P1_D: `Yeniden oynatılıp oynatılmayacağı 
true: yeniden oynat 
false: oynatmaya devam et`,
  T_48_META_API_10038_D: "Oynatılabilir varlıkları duraklat",
  T_48_META_API_10038_P0_D: "Hedef Oynanabilir Varlık",
  T_48_META_API_10039_D: "Hedef varlığa ilk hızı ve yön ile ivmeyi veren balistik bir hareket oluşturur",
  T_48_META_API_10039_P0_D: "hedef varlık",
  T_48_META_API_10039_P1_D: "ilk hız",
  T_48_META_API_10039_P2_D: "hareket ivmesi",
  T_48_META_API_10039_P3_D: "Maksimum yer değiştirme mesafesi",
  T_48_META_API_10039_P4_D: "Balistik hareket varlıkları oluşturuldu",
  T_48_META_API_10039_P5_D: "Oluşturulduktan sonra oynatmanın otomatik olarak başlayıp başlamayacağı",
  T_48_META_API_1004_D: "Geçerli döngü sürecini keser ve döngüden çıkar",
  T_48_META_API_10040_D: "Hedef varlığın belirtilen nesneyi takip ettiği bir konum takip hareketi oluşturur.",
  T_48_META_API_10040_P0_D: "hedef varlık",
  T_48_META_API_10040_P1_D: "Hareketi takip eden nesne varlıkları",
  T_48_META_API_10040_P2_D: "Mesafe, hedef koordinatların ofsetini takip eder",
  T_48_META_API_10040_P3_D: "Kullanılan koordinat sistemi",
  T_48_META_API_10040_P4_D: "Oluşturulan Hareket Takip Varlığı",
  T_48_META_API_10040_P5_D: "Oluşturulduktan sonra oynatmanın otomatik olarak başlayıp başlamayacağı",
  T_48_META_API_10041_D: "Hedef varlığın belirtilen nesneye doğru yönlendirildiği bir bakış takip hareketi oluşturur.",
  T_48_META_API_10041_P0_D: "hedef varlık",
  T_48_META_API_10041_P1_D: "kabul edilen varlık",
  T_48_META_API_10041_P2_D: "Bakış noktasının nesne varlığından uzaklığı",
  T_48_META_API_10041_P3_D: "Kullanılan koordinat sistemi",
  T_48_META_API_10041_P4_D: "Bakışları takip eden hareket varlıkları oluşturuldu",
  T_48_META_API_10041_P5_D: "Oluşturulduktan sonra oynatmanın otomatik olarak başlayıp başlamayacağı",
  T_48_META_API_10042_D: "terkedilmiş",
  T_48_META_API_10042_P0_D: "oyuncu varlığı",
  T_48_META_API_10042_P1_D: "yarışma sonuçları",
  T_48_META_API_10042_P2_D: "terkedilmiş",
  T_48_META_API_10042_P3_D: "terkedilmiş",
  T_48_META_API_10042_P4_D: "terkedilmiş",
  T_48_META_API_10043_D: "Yumuşatma hedef varlığın özelliklerini ayarlar, özellikler hemen değişir, ancak istemci yumuşak bir geçiş performansı sergiler",
  T_48_META_API_10043_P0_D: "hedef varlık",
  T_48_META_API_10043_P1_D: "Hedef varlığın bir niteliği",
  T_48_META_API_10043_P2_D: "Özellik tanımlandığında gereken türle eşleşmesi gereken hedef değer",
  T_48_META_API_10044_D: "Bir ışın tespiti gerçekleştirin ve ışın yönünde vurulan ilk objeyi geri gönderin. Vurulan objenin bir çarpışma bileşenine ihtiyacı vardır. Boş alan doldurulursa arazi tespit edilebilir.",
  T_48_META_API_10044_P0_D: "Başlangıç konumu koordinatları",
  T_48_META_API_10044_P1_D: "Radyasyon algılama yönü",
  T_48_META_API_10044_P2_D: "Radyasyon algılama mesafesi, sadece pozitif değerler kabul edilir",
  T_48_META_API_10044_P3_D: "Işın algılama katmanı maskesi, yalnızca dolu katmanlar taramaya katılacaktır, boş bırakılması tüm katmanların taramaya katılması anlamına gelir",
  T_48_META_API_10044_P4_D: "Tetikleyiciler için tarama yapmak mümkün mü",
  T_48_META_API_10044_P5_D: "varlık vurmak",
  T_48_META_API_10044_P6_D: "vuruş noktası koordinatları",
  T_48_META_API_10044_P7_D: "Vuruş noktasının başlangıç noktasına uzaklığı",
  T_48_META_API_10044_P8_D: "yüzey normaline çarptı",
  T_48_META_API_10045_D: "Bir ışın tespiti gerçekleştirin ve ışın yönünde vurulan tüm varlıkları yakından uzağa döndürün. Boş alan seviye parametresi doldurulursa arazi tespit edilebilir.",
  T_48_META_API_10045_P0_D: "Başlangıç konumu koordinatları",
  T_48_META_API_10045_P1_D: "Radyasyon algılama yönü",
  T_48_META_API_10045_P2_D: "Radyasyon algılama mesafesi, sadece pozitif değerler kabul edilir",
  T_48_META_API_10045_P3_D: "Katman maskesi, sadece dolu katmanlar taramaya katılacaktır, boş bırakılması tüm katmanların taramaya katılması anlamına gelir",
  T_48_META_API_10045_P4_D: "Tetikleyicinin tespit edilip edilemeyeceği",
  T_48_META_API_10045_P5_D: "İsabet alan kuruluşların listesi",
  T_48_META_API_10045_P6_D: "Hit Puan Listesi",
  T_48_META_API_10045_P7_D: "Vuruş noktalarının başlangıç noktasına olan uzaklıklarının listesi",
  T_48_META_API_10045_P8_D: "yüzey normaline çarptı",
  T_48_META_API_10046_D: "Prefabrik gövdeler kullanarak şablonlar için katılar oluşturma",
  T_48_META_API_10046_P0_D: "Oluşturulan varlıklar",
  T_48_META_API_10046_P1_D: "Prefabrik gövde kimliği",
  T_48_META_API_10047_D: "renksizleştirmek",
  T_48_META_API_10047_P0_D: "Nesne Normallerini Ayarlama",
  T_48_META_API_10047_P1_D: "Renklendirme noktasının ayarlanması",
  T_48_META_API_10047_P2_D: "renk",
  T_48_META_API_10048_D: "Renk durumu",
  T_48_META_API_10048_P0_D: "Renklendirme noktasının ayarlanması",
  T_48_META_API_10048_P1_D: "Yön belirleme",
  T_48_META_API_10048_P2_D: "Mesafe Ayarı",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "Renklendirme istatistikleri",
  T_48_META_API_10049_P0_D: "renk",
  T_48_META_API_10049_R_D: "Renk sayısı",
  T_48_META_API_1005_D: "Döngü gövdesinin geri kalanını atlayın ve doğrudan bir sonraki döngüye gidin.",
  T_48_META_API_10050_D: "Düz Aralık Renklendirme",
  T_48_META_API_10050_P0_D: "Nesne Normallerini Ayarlama",
  T_48_META_API_10050_P1_D: "Renklendirme noktasının ayarlanması",
  T_48_META_API_10050_P2_D: "Boyama aralığının ayarlanması",
  T_48_META_API_10050_P3_D: "renk",
  T_48_META_API_10050_P4_D: "Renk sayısı",
  T_48_META_API_10051_D: "bölgesel leke",
  T_48_META_API_10051_P0_D: "Nesne Normallerini Ayarlama",
  T_48_META_API_10051_P1_D: "Renklendirme noktasının ayarlanması",
  T_48_META_API_10051_P2_D: "Boyama aralığının ayarlanması",
  T_48_META_API_10051_P3_D: "renk",
  T_48_META_API_10051_P4_D: "Sabit boyama alanı",
  T_48_META_API_10051_P5_D: "rastgele katsayı (matematik)",
  T_48_META_API_10051_P6_D: "rastgele zayıflama katsayısı",
  T_48_META_API_10051_P7_D: "Renk sayısı",
  T_48_META_API_10052_D: "Hedef ana varlığın tüm çocuklarını alır",
  T_48_META_API_10052_P0_D: "ana kuruluş",
  T_48_META_API_10052_R_D: "çocuk düğüm listesi",
  T_48_META_API_10053_D: "İndekse göre hedef üst varlığın belirtilen alt düğümünü alır",
  T_48_META_API_10053_P0_D: "ana kuruluş",
  T_48_META_API_10053_P1_D: "Alt Düğüm Dizini",
  T_48_META_API_10053_R_D: "çocuk varlık",
  T_48_META_API_10054_D: "Hedef çocuk varlığın üst öğesini alır",
  T_48_META_API_10054_P0_D: "çocuk varlık",
  T_48_META_API_10054_R_D: "ana kuruluş",
  T_48_META_API_10055_D: "Belirtilen üst düğüm varlığı altındaki tüm alt düğümleri siler; düğümler Transform bileşenine sahip olmalıdır",
  T_48_META_API_10055_P0_D: "ana kuruluş",
  T_48_META_API_10056_D: "Hedefi belirtilen konuma ışınlayın",
  T_48_META_API_10056_P0_D: "taşıma birimi (örn. askeri)",
  T_48_META_API_10056_P1_D: "iletim noktasının koordinatları",
  T_48_META_API_10056_P2_D: "transfer sonrası birim oryantasyonu",
  T_48_META_API_10057_D: "Rastgele bir takım arkadaşınızın yakındaki konumunu alın ve bir takım arkadaşınız olmadığında kendi yakındaki koordinatlarınıza dönün, bu da ayağa kalkamayan oyuncuların konumunu önleyecektir",
  T_48_META_API_10057_P0_D: "hedef oyuncu",
  T_48_META_API_10057_R_D: "Hedef oyuncunun takım arkadaşlarına yakın koordinatlar",
  T_48_META_API_10058_D: "Renklendirme Durumunu Temizle",
  T_48_META_API_10059_D: "Belirtilen ses efektini çalın ve ayarlanacak daha fazla öznitelik varsa, varlık özniteliklerini varlık aracılığıyla daha fazla ayarlayın",
  T_48_META_API_10059_P0_D: "Kodda, ses efektini oluşturan varlığı temsil etmek için kullanılan resmi parametrenin adı ve buna karşılık gelen yerel değişken değeri, ses efektini oluşturan varlıktır",
  T_48_META_API_10059_P1_D: "Ait olduğu oyuncu varlığı, sadece o oyuncu tarafından görülebilir",
  T_48_META_API_10059_P2_D: "Ses türleri, oyuncunun seçebileceği ses efektleri türleri",
  T_48_META_API_1006_D: "Mevcut yürütme sürecini sonlandırın, doğrudan çağrı konumuna dönün, verileri dönüşle birlikte taşıyabilirsiniz",
  T_48_META_API_1006_P0_D: "Arama konumuna dönmek istediğiniz veri",
  T_48_META_API_10060_D: "Hedef oyuncuyu oyundan atma",
  T_48_META_API_10060_P0_D: "hedef oyuncu",
  T_48_META_API_10060_P1_D: "Uzlaşma bilgilerinin görüntülenip görüntülenmeyeceği",
  T_48_META_API_10061_D: "Hedef oyuncu belirli bir harita ile eşleştirilmeyi talep eder",
  T_48_META_API_10061_P0_D: "hedef oyuncu",
  T_48_META_API_10061_P1_D: "savaş alanı kodu",
  T_48_META_API_10061_P2_D: "Bir maç iptal edildiğinde orijinal oyuna yeniden katılmak için bir açılır pencere sorulup sorulmayacağı.",
  T_48_META_API_10062_D: "Oynatma sırasında ses varlığının kesilmesi",
  T_48_META_API_10062_P0_D: "Askıya alınması gereken ses varlıkları",
  T_48_META_API_10063_D: "İsteğe bağlı olarak baştan itibaren ses efektlerinin çalınmasına devam edilmesi",
  T_48_META_API_10063_P0_D: "Duraklatıldıktan sonra çalmaya devam etmesi gereken ses varlıkları",
  T_48_META_API_10063_P1_D: "Sıfırdan başlanıp başlanmayacağı",
  T_48_META_API_10064_D: "Bir damla oluşturun, damlanın üç aşaması vardır: 1. hazır, 2. düşüyor, 3. indi, yalnızca 1. durumda damlanın özelliklerini değiştirebilir",
  T_48_META_API_10064_P0_D: "Bırakılan kutu varlıkları oluşturuldu",
  T_48_META_API_1007_D: "Koşul yanlış olana ve döngü sona erene kadar koşulun doğru olup olmadığına bağlı olarak çalışmaya devam eden bir döngü uygulayın.",
  T_48_META_API_1007_P0_D: "Koşul doğru olduğunda döngü devam eder ve koşul yanlış olduğunda döngü sona erer.",
  T_48_META_API_1008_D: `Bir sonraki mantıksal karenin başlangıcına kadar bekleyin
Sunucuda, düşük kare hızı modunu açın, daha uzun süre bekleyecektir
İstemcide, bekleme süresi cihazın performansından ve mevcut karenin mantığının karmaşıklığından etkilenir
Bu API'yi kullanan i`,
  T_48_META_API_1009_D: "Belirli bir süre bekleyin, bu API'yi kullanan işlevlerin asenkron olarak bildirilmesi gerekir.",
  T_48_META_API_1009_P0_D: "Milisaniye cinsinden bekleme süresi",
  T_48_META_API_101_D: "Belirtilen Bir Sahneyi Kaldırma",
  T_48_META_API_101_P0_D: "Kaldırılacak Sahne Kimliği",
  T_48_META_API_1010: "Olay Geri Araması",
  T_48_META_API_1010_D: "Bir olay gerçekleştiğinde tetiklenen eylemler",
  T_48_META_API_1010_P0: "Olay Parametre Adları",
  T_48_META_API_1010_P0_D: "Yerel değişken üzerinde gerçek parametre değerinin elde edilebileceği olay parametresinin resmi parametresinin adı",
  T_48_META_API_1011: "Kod Bloğu",
  T_48_META_API_1011_D: "API'lerin bir kombinasyonunu barındırmak için bir kod bloğu",
  T_48_META_API_1011_P0: "Parametre Adları",
  T_48_META_API_1011_P0_D: "Kod bloğu özel bir işlev olduğunda resmi parametre adları",
  T_48_META_API_1012: "Serial ile Özel API'yi Bul ve Çağır",
  T_48_META_API_1012_D: "Özel işlevleri seri bir şekilde çağırır ve özel işlevde bir bekleme varsa, çağrı konumu da bekler",
  T_48_META_API_1012_P0_D: "Özel fonksiyonun bulunduğu varlık",
  T_48_META_API_1012_P1: "Grafik Kimliği",
  T_48_META_API_1012_P1_D: "Özel fonksiyonun bulunduğu kodun kod kimliği",
  T_48_META_API_1012_P2: "İşlev kimliği",
  T_48_META_API_1012_P2_D: "Hedef çağrının işlev kimliği",
  T_48_META_API_1012_P3_D: "Özel fonksiyona aktarılan gerçek parametrelerin listesi",
  T_48_META_API_1013: "Parallel ile Özel API'yi Bul ve Çağır",
  T_48_META_API_1013_D: "Özel işlevleri paralel bir şekilde çağırır, özel işlevde bir bekleme olup olmadığına bakılmaksızın satırda devam etmek için hemen çağrı konumuna döner",
  T_48_META_API_1013_P0_D: "Özel fonksiyonun bulunduğu varlık",
  T_48_META_API_1013_P1: "Grafik Kimliği",
  T_48_META_API_1013_P1_D: "Özel fonksiyonun bulunduğu kodun kod kimliği",
  T_48_META_API_1013_P2: "İşlev kimliği",
  T_48_META_API_1013_P2_D: "Hedef çağrının işlev kimliği",
  T_48_META_API_1013_P3_D: "Özel fonksiyona aktarılan gerçek parametrelerin listesi",
  T_48_META_API_1014: "Serial ile Kendi Özel API'nizi Bulun ve Çağırın",
  T_48_META_API_1014_D: "Geçerli koddaki özel bir işlevi seri bir şekilde çağırır ve özel işlevde bir bekleme varsa, çağrı konumu da bekler",
  T_48_META_API_1014_P0: "İşlev kimliği",
  T_48_META_API_1014_P0_D: "Hedef çağrının işlev kimliği",
  T_48_META_API_1014_P1_D: "Özel fonksiyona aktarılan gerçek parametrelerin listesi",
  T_48_META_API_1015: "Parallel ile Kendi Özel API'nizi Bulun ve Çağırın",
  T_48_META_API_1015_D: "Özel işlevleri paralel bir şekilde çağırır, özel işlevde bir bekleme olup olmadığına bakılmaksızın satırda devam etmek için hemen çağrı konumuna döner",
  T_48_META_API_1015_P0: "Yerel Değişkeni İndeksle Ayarla",
  T_48_META_API_1015_P0_D: "Hedef çağrının işlev kimliği",
  T_48_META_API_1015_P1_D: "Özel fonksiyona aktarılan gerçek parametrelerin listesi",
  T_48_META_API_1016_D: "Bu API'yi çağırırken hedefin türünü alın",
  T_48_META_API_1016_P0_D: "sorgulanan hedef",
  T_48_META_API_1016_R_D: "Değişken tip",
  T_48_META_API_1017_D: "Hedef değişkenin belirtilen türde olup olmadığını belirler",
  T_48_META_API_1017_P0_D: "sorgulanan hedef",
  T_48_META_API_1017_P1_D: "Karşılaştırma Türü",
  T_48_META_API_1017_R_D: "tutarlılık",
  T_48_META_API_1018_D: "Hedef değişkenin belirli bir türün alt sınıfı olup olmadığını belirler, dönüş değeri bir boolean değeridir",
  T_48_META_API_1018_P0_D: "Sorgulanan hedef değişken",
  T_48_META_API_1018_P1_D: "Karşılaştırma Türü",
  T_48_META_API_1018_R_D: "Bir alt sınıf olup olmadığı",
  T_48_META_API_1019_D: "Hedef varlığın belirtilen özel olayı tetiklemesine neden olur",
  T_48_META_API_1019_P0_D: "Gönderilen özel olay kimlikleri",
  T_48_META_API_1019_P1_D: "hedef varlık",
  T_48_META_API_1019_P2_D: "parametre listesi",
  T_48_META_API_102_D: "Belirli bir sahneye geçildiğinde diğer yüklü sahneler kaldırılır.",
  T_48_META_API_102_P0_D: "Geçiş yapılacak sahne kimliği",
  T_48_META_API_1020_D: "Her bir anahtar-değer çiftine ulaşmak için bir kapsayıcıyı çaprazlama uygulaması alt prosedürler içerir, döngü gövdesi alt prosedürdür",
  T_48_META_API_1020_P0_D: "Anahtarın adı üzerinde yineleme yapın ve yerel değişkendeki anahtarın değerini almak için kullanabilirsiniz",
  T_48_META_API_1020_P1_D: "Yerel değişkendeki değere ulaşmak için kullanılabilecek değerin adı üzerinde yineleme",
  T_48_META_API_1020_P2_D: "Geçilecek konteynerler",
  T_48_META_API_1021_D: "Belirtilen Botu yok et",
  T_48_META_API_1021_P0_D: "Yok edilmesi gereken bot oyuncular",
  T_48_META_API_1022_D: "Hedef oyuncuyu taşıyıcıdan ayrılmaya zorlayın",
  T_48_META_API_1022_P0_D: "hedef oyuncu",
  T_48_META_API_1023_D: "Yaralanma Jumper'ları Oluşturma",
  T_48_META_API_1023_P0_D: "kelime atlama içeriği",
  T_48_META_API_1023_P1_D: "yazı tipi boyutu",
  T_48_META_API_1023_P2_D: "yazı tipi rengi",
  T_48_META_API_1023_P3_D: "Milisaniye cinsinden bekleme süresi",
  T_48_META_API_1023_P4_D: "yaralanan kurum",
  T_48_META_API_1023_P5_D: "Hedef varlığın dünya koordinatlarına göre hasar atlama sözcüğünün ofseti",
  T_48_META_API_1023_P6_D: "Hasar atlama konumlarında rastgele konumsal düzeltmelerin aralık boyutu tekrar",
  T_48_META_API_1023_P7_D: "Doldurma animasyonunun yürütülüp yürütülmeyeceği",
  T_48_META_API_1024_D: "terkedilmiş",
  T_48_META_API_1024_P0_D: "terkedilmiş",
  T_48_META_API_1024_P1_D: "hedef varlık",
  T_48_META_API_1024_P2_D: "Seçildiğinde, sunucudan çağrılırsa istemciye, istemciden çağrılırsa sunucuya gönderilir.",
  T_48_META_API_1024_P3_D: "parametre listesi",
  T_48_META_API_1025_D: "Özel bir görevin ilerleme durumunu sorgulama",
  T_48_META_API_1025_P0_D: "hedef oyuncu",
  T_48_META_API_1025_P1_D: "Özel Görev Kimliği",
  T_48_META_API_1025_R_D: "Görevde ilerleme",
  T_48_META_API_1026_D: "Hedef oyuncunun sırt çantası görünümünü al",
  T_48_META_API_1026_P0_D: "hedef oyuncu",
  T_48_META_API_1026_R_D: "Sırt Çantası Cilt Kimliği",
  T_48_META_API_1027_D: "Hedef oyuncunun sırt çantası görünümünü ayarlama",
  T_48_META_API_1027_P0_D: "hedef oyuncu",
  T_48_META_API_1027_P1_D: "Sırt Çantası Cilt Kimliği",
  T_48_META_API_1028_D: "Hedef oyuncunun sırt çantası kaplamasını varsayılan büro dışı yapılandırmasına geri yükleyin",
  T_48_META_API_1028_P0_D: "hedef oyuncu",
  T_48_META_API_1029_D: "Hedef oyuncunun sırt çantası kaplamasını boşalt",
  T_48_META_API_1029_P0_D: "hedef oyuncu",
  T_48_META_API_103_D: "Oyunun gökyüzü kutusu ortam stilini gündüz, alacakaranlık, gece vb. seçeneklerle değiştirin.",
  T_48_META_API_103_P0_D: "Skybox Tipi",
  T_48_META_API_1030_D: "İskelet parçasını isme göre alma",
  T_48_META_API_1030_P0_D: "hedef varlık",
  T_48_META_API_1030_P1_D: "İskelet Asma Noktası Adı",
  T_48_META_API_1030_R_D: "İskelet Çerçeve Noktası",
  T_48_META_API_1031_D: "Üzerlerine Transform, SkeletonPart, Player, MountPoint bileşenleri monte edilmiş varlıkları destekleyen bir nesne varlığının üst düğümünü ayarlar.",
  T_48_META_API_1031_P0_D: "ana düğüm",
  T_48_META_API_1031_P1_D: "çocuk düğümü",
  T_48_META_API_1031_P2_D: "Alt düğümlerin mevcut dünya konumunun, rotasyonunun ve ölçeklendirmesinin korunup korunmayacağı, UI ayarı bu öğe geçersizdir",
  T_48_META_API_1032_D: "Simgenin oynatma hızında başlangıç konumundan bitiş konumuna kaydırıldığı animasyonlu bir simge efekti oynatır.",
  T_48_META_API_1032_P0_D: "Simge Kaynak Kimliği",
  T_48_META_API_1032_P1_D: "renk",
  T_48_META_API_1032_P2_D: "Simge Yakınlaştırma",
  T_48_META_API_1032_P3_D: "Başlangıç pozisyonu merkezi",
  T_48_META_API_1032_P4_D: "Bölgesel kapsamın başlatılması",
  T_48_META_API_1032_P5_D: "Son konum merkezi",
  T_48_META_API_1032_P6_D: "Son konum aralığı",
  T_48_META_API_1032_P7_D: "Oynatma hızı, simgenin saniye başına kat ettiği mesafedir",
  T_48_META_API_1033_D: "Açıyı elde etmek için ters tanjant işlemi gerçekleştirin",
  T_48_META_API_1033_P0_D: "Y ekseni koordinatları",
  T_48_META_API_1033_P1_D: "X ekseni koordinatları",
  T_48_META_API_1033_R_D: "Açı, aralık (-180, 180]",
  T_48_META_API_1034_D: "Varlıklara bileşen ekleme, yalnızca kullanıcı tarafından oluşturulan özel bileşenler desteklenir",
  T_48_META_API_1034_P0_D: "hedef varlık",
  T_48_META_API_1034_P1_D: "Bileşen türü kimliği, yalnızca kullanıcı tarafından oluşturulan özel bileşenler desteklenir",
  T_48_META_API_1034_P2_D: "Başarılı bir şekilde eklense de eklenmese de, mevcut bileşenler veya özel olmayan bileşenler eklenemeyecektir.",
  T_48_META_API_1035_D: "Bileşenleri varlıklardan kaldırın, yalnızca özel bileşenler desteklenir",
  T_48_META_API_1035_P0_D: "hedef varlık",
  T_48_META_API_1035_P1_D: "Bileşen türü kimliği, yalnızca kullanıcı tarafından oluşturulan özel bileşenler desteklenir",
  T_48_META_API_1035_P2_D: "Kaldırma işleminin başarılı olup olmadığına bakılmaksızın, mevcut olmayan bileşenler veya özel olmayan bileşenler kaldırılamayacaktır.",
  T_48_META_API_1036_D: "Oyuncu çıkış ekranını özelleştirme",
  T_48_META_API_1036_P0_D: "Başlık",
  T_48_META_API_1036_P1_D: "eleman",
  T_48_META_API_1036_P2_D: "seçenekler",
  T_48_META_API_1036_P3_D: "Arka planın gösterilip gösterilmeyeceği",
  T_48_META_API_1037_D: "Şu anda yüklü olan tüm sahneleri al",
  T_48_META_API_1037_R_D: "Sahne Listesi",
  T_48_META_API_1038_D: "Oyuncunun yerel hedefleme yönünü alın",
  T_48_META_API_1038_R_D: "doğru yönü hedefleyin",
  T_48_META_API_1039_D: "Yerel zaman damgasını al",
  T_48_META_API_1039_R_D: "zaman damgası",
  T_48_META_API_104_D: "Oynatıcıyı belirli bir sahnede belirli bir konuma geçirir, yüklenmemiş sahneler otomatik olarak yüklenir ve önceden yüklenmiş sahneleri otomatik olarak kaldırmaz",
  T_48_META_API_104_P0_D: "oyuncu",
  T_48_META_API_104_P1_D: "Yüklenecek sahne kimliği",
  T_48_META_API_104_P2_D: "Oyuncunun yeni senaryodaki konumu",
  T_48_META_API_104_P3_D: "Yeni senaryoda oyuncu oryantasyonu",
  T_48_META_API_1040_D: "Geçerli platform için sabit kare güncellemesini duraklatır ve bu platform için sabit kare güncelleme olayı duraklamadan sonra tetiklenmez.",
  T_48_META_API_1041_D: "Geçerli platform için sabit kare güncellemesini sürdürür ve bu platform için sabit kare güncelleme olayı yeniden başlatıldıktan sonra yeniden tetiklenmeye başlar",
  T_48_META_API_1042_D: "Hedef oyuncunun mevcut istemci oyuncu ile arkadaşlık ilişkisini belirler, mevcut istemcinin kendisi mevcut istemcinin arkadaşı değildir",
  T_48_META_API_1042_P0_D: "hedef oyuncu",
  T_48_META_API_1042_R_D: "Mevcut müşteriyle arkadaş olup olmadığınız",
  T_48_META_API_1043_D: "Özel olayları tetikleme",
  T_48_META_API_1043_P0_D: "Özel Etkinlik Kimliği",
  T_48_META_API_1043_P1_D: "hedef varlık",
  T_48_META_API_1043_P2_D: "Sunucu tarafı veya istemci tarafı platformlarda çalışır",
  T_48_META_API_1043_P3_D: "parametre listesi",
  T_48_META_API_1044_D: "Açık Skydive",
  T_48_META_API_1044_P0_D: "hedef oyuncu",
  T_48_META_API_1044_P1_D: "Bu irtifanın altında, paraşüt açılmaya zorlanacaktır.",
  T_48_META_API_1044_P2_D: "Süzülürken hız, X bileşeni yatay hızı, Y bileşeni dikey hızı temsil eder; Y bileşeni negatif olduğunda oyuncu aşağı doğru iner",
  T_48_META_API_1044_P3_D: "Dalıştaki hız, X bileşeni yatay hızı, Y bileşeni dikey hızı temsil eder; Y bileşeni negatif olduğunda oyuncu aşağı doğru iner",
  T_48_META_API_1044_P4_D: "Paraşüt açıldığında hız, X bileşeni yatay hızı, Y bileşeni dikey hızı temsil eder; Y bileşeni negatif olduğunda oyuncu aşağı doğru iner",
  T_48_META_API_1045_D: "Veri tablosunda belirtilen tanımlayıcıya karşılık gelen değeri okur.",
  T_48_META_API_1045_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_1045_P1_D: "Oyuncu Benzersiz Kimliği",
  T_48_META_API_1045_P2_D: "belirtilen tanımlayıcı",
  T_48_META_API_1045_P3_D: "Okumaların sonuçları",
  T_48_META_API_1045_P4_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_1045_P5_D: "hata kodu",
  T_48_META_API_1046_D: "Grafik veri tablosunda belirtilen tanımlayıcıya karşılık gelen değeri alır",
  T_48_META_API_1046_P0_D: "Veritabanındaki Leaderboard tablo adı",
  T_48_META_API_1046_P1_D: "belirtilen tanımlayıcı",
  T_48_META_API_1046_P2_D: "Okumaların sonuçları",
  T_48_META_API_1046_P3_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_1046_P4_D: "hata kodu",
  T_48_META_API_1047_D: "Leaderboards veri tablosunda belirtilen sıra aralığının değerini alır",
  T_48_META_API_1047_P0_D: "Veritabanındaki Leaderboard tablo adı",
  T_48_META_API_1047_P1_D: "Başlangıç ​​sıralaması bitiş sıralamasından küçük veya ona eşit olmalı ve sıralama 1'den başlamalıdır.",
  T_48_META_API_1047_P2_D: "bitirme pozisyonu",
  T_48_META_API_1047_P3_D: "Okumaların sonuçları",
  T_48_META_API_1047_P4_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_1047_P5_D: "hata kodu",
  T_48_META_API_1048_D: "Kümülatif veri tablosunda belirtilen tanımlayıcıya karşılık gelen değeri okur.",
  T_48_META_API_1048_P0_D: "Veritabanındaki kümülatif veri tablosunun adı",
  T_48_META_API_1048_P1_D: "belirtilen tanımlayıcı",
  T_48_META_API_1048_P2_D: "Okumaların sonuçları",
  T_48_META_API_1048_P3_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_1048_P4_D: "hata kodu",
  T_48_META_API_1049_D: "Veri tablosunda belirtilen tanımlayıcıya karşılık gelen değeri yazın.",
  T_48_META_API_1049_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_1049_P1_D: "Oyuncu Benzersiz Kimliği",
  T_48_META_API_1049_P2_D: "belirtilen tanımlayıcı",
  T_48_META_API_1049_P3_D: "Yazılan değer",
  T_48_META_API_1049_P4_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_1049_P5_D: "hata kodu",
  T_48_META_API_105_D: "Sahnenin gökyüzü kutusunu alın",
  T_48_META_API_105_P0_D: "Sahne Kimliği",
  T_48_META_API_105_R_D: "skybox",
  T_48_META_API_1050_D: "Listedeki öğe sayısını alır",
  T_48_META_API_1050_P0_D: "hedef listesi",
  T_48_META_API_1050_R_D: "Eleman sayısı",
  T_48_META_API_1051_D: "Listede belirtilen indisteki elemanın değerini alır",
  T_48_META_API_1051_P0_D: "hedef listesi",
  T_48_META_API_1051_P1_D: "0'dan başlayan dizin değerleri",
  T_48_META_API_1051_R_D: "temel değer",
  T_48_META_API_1052_D: "Listede belirtilen indise karşılık gelen elemanın değerini ayarlar",
  T_48_META_API_1052_P0_D: "hedef listesi",
  T_48_META_API_1052_P1_D: "0'dan başlayan dizin değerleri",
  T_48_META_API_1052_P2_D: "temel değer",
  T_48_META_API_1053_D: "Listenin sonuna öğe ekler",
  T_48_META_API_1053_P0_D: "hedef listesi",
  T_48_META_API_1053_P1_D: "Eklenecek unsurlar",
  T_48_META_API_1054_D: "Belirtilen indisteki elemanı listeden kaldırır",
  T_48_META_API_1054_P0_D: "hedef listesi",
  T_48_META_API_1054_P1_D: "0'dan başlayan dizin değerleri",
  T_48_META_API_1055_D: "Tüm öğelerin listesini boşaltın",
  T_48_META_API_1055_P0_D: "hedef listesi",
  T_48_META_API_1056_D: "Belirtilen listedeki öğelerin sırasını tersine çevirir.",
  T_48_META_API_1056_P0_D: "hedef listesi",
  T_48_META_API_1057_D: "Liste kopyalama",
  T_48_META_API_1057_P0_D: "hedef listesi",
  T_48_META_API_1057_R_D: "Yeni liste kopyalandı",
  T_48_META_API_1058_D: "Listede belirtilen indeks konumuna yeni bir eleman ekler ve bu indeks konumundaki ve sonraki elemanlar sırayla bir sıra geriye taşınır.",
  T_48_META_API_1058_P0_D: "hedef listesi",
  T_48_META_API_1058_P1_D: "Eklenecek dizin konumu, dizin 0'dan itibaren sayılır",
  T_48_META_API_1058_P2_D: "Eklenecek yeni elemanın değeri",
  T_48_META_API_1059_D: "Listenin öğelerini yeniden rastgele sıralayın",
  T_48_META_API_1059_P0_D: "hedef listesi",
  T_48_META_API_1060_D: "Argümanın her iki tarafını karşılaştırır ve doğru veya yanlış döndürür.",
  T_48_META_API_1060_P0_D: "Karşılaştırma için kullanılan sol değer",
  T_48_META_API_1060_P1_D: "Karşılaştırma yöntemleri, aşağıdakiler desteklenir: >,>=,==,! =,<=,<,Ve(nitelikli bool türü),Veya(nitelikli bool türü)",
  T_48_META_API_1060_P2_D: "Karşılaştırma için kullanılan sol değer",
  T_48_META_API_1060_R_D: "Karşılaştırmalı sonuçlar",
  T_48_META_API_1061_D: "Toplama, çıkarma, çarpma, bölme ve kalan dahil olmak üzere temel dört işlem. Kalan işlemi yalnızca tam sayıları destekler ve diğer işlemler tam sayıları veya ondalık sayıları destekler.",
  T_48_META_API_1061_P0_D: "bir işlemin sol değeri",
  T_48_META_API_1061_P1_D: "Ondalık sayıları desteklemeyen toplama, çıkarma, çarpma, bölme ve kalan dahil olmak üzere dört işlem türü",
  T_48_META_API_1061_P2_D: "bir işlemin doğru değeri",
  T_48_META_API_1061_R_D: "hesaplama sonucu",
  T_48_META_API_1062_D: "Minimum değer tamsayısı (dahil) ile maksimum değer tamsayısı (dahil değil) arasında rastgele bir tamsayı oluşturun",
  T_48_META_API_1062_P0_D: "Doldurulan değere rastgele ayarlama imkanı ile sol aralıkta rastgele aralık",
  T_48_META_API_1062_P1_D: "Rastgele aralık sağ aralık, doldurulan değere rastgele ayarlanmayacaktır",
  T_48_META_API_1062_R_D: "Rastgele sonuç, tamsayı",
  T_48_META_API_1063_D: "Minimum ondalık değer (dahil) ile maksimum ondalık değer (dahil değil) arasında rastgele bir ondalık oluşturun",
  T_48_META_API_1063_P0_D: "Sol aralıkta rastgele aralık, doldurulan değere rastgele gelme olasılığı düşük",
  T_48_META_API_1063_P1_D: "Rastgele aralık sağ aralık, doldurulan değere rastgele ayarlanmayacaktır",
  T_48_META_API_1063_R_D: "Rastgele sonuçlar, ondalık sayılar, 7 ondalık basamağa kadar",
  T_48_META_API_1064_D: "Bir nesnenin boş olup olmadığını belirleme",
  T_48_META_API_1064_P0_D: "değerlendirilecek boş nesne",
  T_48_META_API_1064_R_D: "Boş",
  T_48_META_API_1065_D: "Mantıksal ters, giriş değeri: doğru veya yanlış, dönüş değeri: yanlış veya doğru",
  T_48_META_API_1065_P0_D: "Olmayanlar için talep edilmesi gereken değerler",
  T_48_META_API_1065_R_D: "Nonce'un sonucu",
  T_48_META_API_1066_D: "Mutlak değerleri alır, tamsayıları ve ondalık sayıları destekler",
  T_48_META_API_1066_P0_D: "Mutlak değerlerin gerekli olduğu değerler",
  T_48_META_API_1066_R_D: "Mutlak değerlerin alınmasının sonucu",
  T_48_META_API_1067_D: "karekök hesaplama",
  T_48_META_API_1067_P0_D: "Karekök değerini sormanız gerekiyor",
  T_48_META_API_1067_R_D: "Karekökü bulmanın sonucu",
  T_48_META_API_1068_D: "Negatif değerlerin hesaplanması",
  T_48_META_API_1068_P0_D: "İstenecek negatif değerler",
  T_48_META_API_1068_R_D: "Olumsuz sonuçlar",
  T_48_META_API_1069_D: "İki dizgiyi birleştirme",
  T_48_META_API_1069_P0_D: "bir dizenin sol değeri",
  T_48_META_API_1069_P1_D: "bir dizenin sağ değeri",
  T_48_META_API_1069_R_D: "dize birleştirme sonucu",
  T_48_META_API_1070_D: "Dize uzunluğunu al",
  T_48_META_API_1070_P0_D: "string",
  T_48_META_API_1070_R_D: "dize uzunluğu",
  T_48_META_API_1071_D: "Belirtilen değeri en yakın tam sayıya yuvarlar.",
  T_48_META_API_1071_P0_D: "Aşağı yuvarlanacak değer",
  T_48_META_API_1071_R_D: "aşağı yuvarlama",
  T_48_META_API_1072_D: "Belirtilen değeri en yakın tam sayıya yuvarlar.",
  T_48_META_API_1072_P0_D: "Yukarı yuvarlanacak değerler",
  T_48_META_API_1072_R_D: "Yuvarlama sonuçları",
  T_48_META_API_1073_D: "Belirtilen değeri en yakın tam sayıya yuvarlar.",
  T_48_META_API_1073_P0_D: "Yuvarlanacak değer sayısı",
  T_48_META_API_1073_R_D: "yuvarlatılmış sonuç",
  T_48_META_API_1074_D: "Hedef dizede belirtilen tüm dizeleri değiştirdikten sonra yeni bir dize çıktısı verir",
  T_48_META_API_1074_P0_D: "hedef dize",
  T_48_META_API_1074_P1_D: "Değiştirilecek eski dize",
  T_48_META_API_1074_P2_D: "Değiştirilecek yeni dize",
  T_48_META_API_1074_R_D: "Tamamlanmış dizenin değiştirilmesi",
  T_48_META_API_1075_D: "Hedef dizede belirtilen dizenin ilk geçtiği yeri bulur.",
  T_48_META_API_1075_P0_D: "hedef dize",
  T_48_META_API_1075_P1_D: "Aranacak belirtilen dize",
  T_48_META_API_1075_P2_D: "Dizeyi başlangıç konumundan itibaren bulur, dize konumu 0'dan itibaren sayılır",
  T_48_META_API_1075_R_D: "Dizenin hedef dizedeki ilk oluşumunun konumunu belirtir, dize konumu 0'dan itibaren sayılır.",
  T_48_META_API_1076_D: "Belirtilen uzunluktaki bir dizeyi belirtilen konumdan yakaladıktan sonra yeni bir dize çıktısı verir.",
  T_48_META_API_1076_P0_D: "hedef dize",
  T_48_META_API_1076_P1_D: "Kesmeye başlanacak konum, dize konumu 0'dan itibaren sayılır",
  T_48_META_API_1076_P2_D: "Kesme uzunluğu, varsayılan olarak dizenin sonuna kadardır.",
  T_48_META_API_1076_R_D: "Yakalanan Dize",
  T_48_META_API_1077_D: "Aynı elemanlara sahip iki listeyi karşılaştırın, liste boyutu sonucu etkilemez.",
  T_48_META_API_1077_P0_D: "Karşılaştırma için kullanılan listenin sol değeri",
  T_48_META_API_1077_P1_D: "Karşılaştırma için kullanılan listenin sağ değeri",
  T_48_META_API_1077_R_D: "Sonuçları karşılaştırın, içerik tutarlılığı True, içerik tutarsızlığı False döndürür.",
  T_48_META_API_1078_D: "Belirtilen dizeyi ayırıcı olarak alır, hedef dizeyi bir dizi dilime keser ve yeni dizeyi çıkarır, N ardışık ayırıcı, dize listesi öğeleri çıktısı olarak N-1 yarım genişlikte boşluğa kesilecektir",
  T_48_META_API_1078_P0_D: "hedef dize",
  T_48_META_API_1078_P1_D: "sınırlayıcı dize",
  T_48_META_API_1078_R_D: "Her zaman yarım genişlikte bir boşluk öğesi ile biten bir dizgi listesi çıktısı verir",
  T_48_META_API_1079_D: "Dize konumları listesinden karakterleri ayıklayın ve bunları yeni bir dize çıktısında birleştirin",
  T_48_META_API_1079_P0_D: "hedef dize",
  T_48_META_API_1079_P1_D: "Dize konumları listesi, 0'dan itibaren sayılan dize konumları",
  T_48_META_API_1079_R_D: "Çıktı dizesi",
  T_48_META_API_1080_D: "Tüm hedef dize karakterlerini büyük harfe dönüştürür",
  T_48_META_API_1080_P0_D: "hedef dize",
  T_48_META_API_1080_R_D: "Çıktı dizesi",
  T_48_META_API_1081_D: "Tüm hedef dize karakterlerini küçük harfe dönüştürür",
  T_48_META_API_1081_P0_D: "hedef dize",
  T_48_META_API_1081_R_D: "Çıktı dizesi",
  T_48_META_API_1082_D: "Hedef dizenin ilk boşluksuz karakterinden önceki ve son boşluksuz karakterinden sonraki tüm boşlukları kaldırır.",
  T_48_META_API_1082_P0_D: "hedef dize",
  T_48_META_API_1082_R_D: "Çıktı dizesi",
  T_48_META_API_1083_D: "Belirtilen tanımlayıcı ile bağlandıktan sonra yeni bir dize çıktısı verir.",
  T_48_META_API_1083_P0_D: "Hedef Dize Listesi",
  T_48_META_API_1083_P1_D: "Dizeleri birleştirmek için kullanılan belirtilen tanımlayıcı",
  T_48_META_API_1083_R_D: "Çıktı dizesi",
  T_48_META_API_1084_D: "Lider tablosu veri tablosunda belirtilen tanımlayıcıya karşılık gelen değeri yazar",
  T_48_META_API_1084_P0_D: "Veritabanındaki Leaderboard tablo adı",
  T_48_META_API_1084_P1_D: "belirtilen tanımlayıcı",
  T_48_META_API_1084_P2_D: "Yazılan değer",
  T_48_META_API_1084_P3_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_1084_P4_D: "hata kodu",
  T_48_META_API_1085_D: "Kümülatif veri tablosunda belirtilen tanımlayıcıya karşılık gelen ofset değerini yazın",
  T_48_META_API_1085_P0_D: "Veritabanındaki kümülatif veri tablosunun adı",
  T_48_META_API_1085_P1_D: "belirtilen tanımlayıcı",
  T_48_META_API_1085_P2_D: "İkinci dereceden işlem türleri",
  T_48_META_API_1085_P3_D: "Yazılan ofset değeri",
  T_48_META_API_1085_P4_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_1085_P5_D: "hata kodu",
  T_48_META_API_1086_D: "Veri tablosunda belirtilen tanımlayıcıya karşılık gelen değeri siler.",
  T_48_META_API_1086_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_1086_P1_D: "Oyuncu Benzersiz Kimliği",
  T_48_META_API_1086_P2_D: "belirtilen tanımlayıcı",
  T_48_META_API_1086_P3_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_1086_P4_D: "hata kodu",
  T_48_META_API_1087_D: "Grafik veri tablosunda belirtilen tanımlayıcıya karşılık gelen değeri siler.",
  T_48_META_API_1087_P0_D: "Veritabanındaki Leaderboard tablo adı",
  T_48_META_API_1087_P1_D: "belirtilen tanımlayıcı",
  T_48_META_API_1087_P2_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_1087_P3_D: "hata kodu",
  T_48_META_API_1088_D: "Leaderboard tablosunda belirtilen sıralamaya karşılık gelen değeri siler.",
  T_48_META_API_1088_P0_D: "Veritabanındaki Leaderboard tablo adı",
  T_48_META_API_1088_P1_D: "prestijli bir pozisyon verildi",
  T_48_META_API_1088_P2_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_1088_P3_D: "hata kodu",
  T_48_META_API_1089_D: "Persona'ya bir kullanıcı mesajı gönderin",
  T_48_META_API_1089_P0_D: "Hedef PersonaID",
  T_48_META_API_1089_P1_D: "Mesaj",
  T_48_META_API_1090_D: "Persona'ya bir sistem mesajı gönderin",
  T_48_META_API_1090_P0_D: "Hedef PersonaID",
  T_48_META_API_1090_P1_D: "Mesaj",
  T_48_META_API_1091_D: "Persona'nın hafızasını temizleyin",
  T_48_META_API_1091_P0_D: "hata kodu",
  T_48_META_API_1092_D: "Evoke Üye Merkezi",
  T_48_META_API_1092_P0_D: "hata kodu",
  T_48_META_API_1093_D: "Üye sona erme zaman damgasını al",
  T_48_META_API_1093_P0_D: "hedef oyuncu",
  T_48_META_API_1093_P1_D: "zaman damgası",
  T_48_META_API_1093_P2_D: "hata kodu",
  T_48_META_API_1094_D: "Bir oyuncunun üye olup olmadığını belirleme",
  T_48_META_API_1094_P0_D: "hata kodu",
  T_48_META_API_1094_P1_D: "Üye olsanız da olmasanız da",
  T_48_META_API_1095_D: "Üye sona erme zaman damgasını al",
  T_48_META_API_1095_P0_D: "zaman damgası",
  T_48_META_API_1095_P1_D: "hata kodu",
  T_48_META_API_1096_D: "Bir oyuncunun üye olup olmadığını belirleme",
  T_48_META_API_1096_P0_D: "hedef oyuncu",
  T_48_META_API_1096_P1_D: "hata kodu",
  T_48_META_API_1096_P2_D: "Üye mi yoksa üye değil mi",
  T_48_META_API_1097_D: "Evoke Üye Merkezi",
  T_48_META_API_1097_P0_D: "hedef oyuncu",
  T_48_META_API_1097_P1_D: "hata kodu",
  T_48_META_API_1099_D: "Persona gözlemcilerinin ayarlanması, ardından Persona ile yapılan konuşmaların gözlemciye de gönderilmesi",
  T_48_META_API_1099_P0_D: "Hedef PersonaID",
  T_48_META_API_1099_P1_D: "izleme listesi",
  T_48_META_API_11_D: "Geçerli aşamayı sonlandırın ve bir sonraki aşamaya geçin",
  T_48_META_API_1100_D: "Akış Kullanarak Persona'ya Kullanıcı Mesajları Gönderme",
  T_48_META_API_1100_P0_D: "Hedef PersonaID",
  T_48_META_API_1100_P1_D: "Mesaj",
  T_48_META_API_1101_D: "Akış Kullanarak Persona'ya Sistem Mesajları Gönderme",
  T_48_META_API_1101_P0_D: "Hedef PersonaID",
  T_48_META_API_1101_P1_D: "Mesaj",
  T_48_META_API_1101_P2_D: "Cevap verip vermemek",
  T_48_META_API_1103_D: "Rastgele tohumlar oluşturma",
  T_48_META_API_1103_P0_D: "torrent",
  T_48_META_API_1103_R_D: "Rastgele Sayı Üreteci",
  T_48_META_API_1104_D: "Belirtilen rastgele sayı üretecinin bir sonraki rastgele sayısını alın, maksimum değer 32767",
  T_48_META_API_1104_P0_D: "Rastgele Sayı Üreteci",
  T_48_META_API_1104_P1_D: "Aralık Minimum",
  T_48_META_API_1104_P2_D: "Menzil Maksimum",
  T_48_META_API_1104_R_D: "rastgele sayı",
  T_48_META_API_1108_D: "Oyuncunun kullandığı istemci dilini al",
  T_48_META_API_12_D: "Günlükleri konsola yazdırma",
  T_48_META_API_12_P0_D: "Ne yazdırmalı",
  T_48_META_API_13_D: "Parametreleri içeren bir dize çıktısı verir",
  T_48_META_API_13_P0_D: "Bir parametre için %v yer tutucusunu kullanın, %v'lerin sayısı ile parametrelerin sayısı aynı olmalıdır.",
  T_48_META_API_13_P1_D: "Çıktıya katılan parametrelerin listesi, format açıklamasındaki %v sayısı ile tutarlı olmalıdır",
  T_48_META_API_13_R_D: "Çıktı dizesi",
  T_48_META_API_14_D: "Ölüm kutuları, oluşturulan nesneler, yerleştirilen nesneler, mermi kalıntıları vb. dahil olmak üzere harita nesnesi kalıntılarını temizleme.",
  T_48_META_API_15_D: "Kullanıcı deneyimi veri analizi için özel yarışma gömme günlükleri",
  T_48_META_API_15_P0_D: "Raporlanacak alan adlarının listesi",
  T_48_META_API_15_P1_D: "Raporlanacak alan değerlerinin listesi",
  T_48_META_API_1500_D: "3B vektörün x bileşenini alır",
  T_48_META_API_1500_P0_D: "3D vektör",
  T_48_META_API_1500_R_D: "3B vektör x bileşeni",
  T_48_META_API_1501_D: "3B vektörün y bileşenini alır",
  T_48_META_API_1501_P0_D: "3D vektör",
  T_48_META_API_1501_R_D: "3B vektörün Y bileşeni",
  T_48_META_API_1502_D: "3B vektörün z-bileşenini alır",
  T_48_META_API_1502_P0_D: "3D vektör",
  T_48_META_API_1502_R_D: "Üç boyutlu vektör z-bileşeni",
  T_48_META_API_1503_D: "3B vektörün x bileşenini ayarlayın",
  T_48_META_API_1503_P0_D: "3D vektör",
  T_48_META_API_1503_P1_D: "X bileşeni",
  T_48_META_API_1504_D: "3B vektörün Y bileşenini ayarlayın",
  T_48_META_API_1504_P0_D: "3D vektör",
  T_48_META_API_1504_P1_D: "Y bileşeni",
  T_48_META_API_1505_D: "3B vektörün z-bileşenini ayarlayın",
  T_48_META_API_1505_P0_D: "3D vektör",
  T_48_META_API_1505_P1_D: "Z-bileşeni",
  T_48_META_API_1506_D: "İki 3B vektörü birbirine ekleme",
  T_48_META_API_1506_P0_D: "Sol değer",
  T_48_META_API_1506_P1_D: "Sağ değer",
  T_48_META_API_1506_R_D: "3B vektör toplamı sonucu",
  T_48_META_API_1507_D: "İki 3B vektörü çıkarma",
  T_48_META_API_1507_P0_D: "Sol değer",
  T_48_META_API_1507_P1_D: "Sağ değer",
  T_48_META_API_1507_R_D: "3B vektörün sol değerinden sağ değerinin çıkarılmasının sonucu",
  T_48_META_API_1508_D: "3B vektörleri ölçekleme",
  T_48_META_API_1508_P0_D: "Ölçeklenecek 3B vektörler",
  T_48_META_API_1508_P1_D: "3D vektör deflasyonu",
  T_48_META_API_1508_R_D: "3B vektör ölçeklendirme sonuçları",
  T_48_META_API_1509_D: "İki 3B vektörü noktasal olarak çarpın, noktasal çarpmanın sonucu bir skalerdir",
  T_48_META_API_1509_P0_D: "Sol değer",
  T_48_META_API_1509_P1_D: "Sağ değer",
  T_48_META_API_1509_R_D: "Nokta çarpım sonucu",
  T_48_META_API_1510_D: "İki 3B vektörün çapraz çarpımı, çapraz çarpımın sonucu iki vektörün bulunduğu düzleme dik bir vektördür",
  T_48_META_API_1510_P0_D: "Sol değer",
  T_48_META_API_1510_P1_D: "Sağ değer",
  T_48_META_API_1510_R_D: "İşlemde yer alan iki vektörün bulunduğu düzleme dik olarak yönlendirilmiş çapraz çarpımın sonucu",
  T_48_META_API_1511_D: "3B vektörlerin normalizasyonu",
  T_48_META_API_1511_P0_D: "3D vektör",
  T_48_META_API_1511_R_D: "Yeni bir normalleştirilmiş vektör döndürür. Modül uzunluğu 1'dir",
  T_48_META_API_1512_D: "3B vektörlerin modellenmesi",
  T_48_META_API_1512_P0_D: "3D vektör",
  T_48_META_API_1512_R_D: "Modellemenin sonucu, vektör modülünün uzunluğu",
  T_48_META_API_1513_D: "İki 3B vektör arasındaki Öklid mesafesini hesaplayın",
  T_48_META_API_1513_P0_D: "Sol değer",
  T_48_META_API_1513_P1_D: "Sağ değer",
  T_48_META_API_1513_R_D: "İki vektörü çıkardıktan sonra, ortaya çıkan vektörün modülü",
  T_48_META_API_1514_D: "İki 3B vektör arasındaki açıyı hesaplama",
  T_48_META_API_1514_P0_D: "Sol değer",
  T_48_META_API_1514_P1_D: "Sağ değer",
  T_48_META_API_1514_R_D: "Vektör açısı, açı aralığı 0-180",
  T_48_META_API_1515_D: "3B vektör oluşturma",
  T_48_META_API_1515_P0_D: "3B vektörün X bileşeni",
  T_48_META_API_1515_P1_D: "3B vektörün Y bileşeni",
  T_48_META_API_1515_P2_D: "3B vektörün Z bileşeni",
  T_48_META_API_1515_R_D: "Oluşturulan 3B vektörler",
  T_48_META_API_1516_D: "Yeni bir yapının yönelim noktasını alır (kullanımdan kaldırılmıştır, lütfen kullanmayın)",
  T_48_META_API_1516_P0_D: "yerleştirme",
  T_48_META_API_1516_P1_D: "doğru dön",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "Yön noktası konumu al (kullanımdan kaldırılmıştır, lütfen kullanmayın)",
  T_48_META_API_1517_P0_D: "oryantasyon noktası",
  T_48_META_API_1517_R_D: "Pozisyon",
  T_48_META_API_1518_D: "Yön noktası oryantasyonu alma (eski, lütfen kullanmayın)",
  T_48_META_API_1518_P0_D: "oryantasyon noktası",
  T_48_META_API_1518_R_D: "İleri",
  T_48_META_API_1519_D: "Bir liste oluşturun",
  T_48_META_API_1519_P0_D: "Listenin başlangıç uzunluğu, başlangıç kapasitesine eşit veya daha az olmalıdır",
  T_48_META_API_1519_P1_D: "Listenin başlangıç kapasitesi başlangıç uzunluğundan büyük veya eşit olmalıdır. Kapasite dinamik olarak genişletilebilir, ancak bir miktar performans tüketecektir, bu nedenle oluşturulurken uygun bir değer ayarlanması önerilir.",
  T_48_META_API_1519_R_D: "Liste oluşturma",
  T_48_META_API_1520_D: "Listenin belirtilen elemanı içerip içermediğini kontrol eder",
  T_48_META_API_1520_P0_D: "hedef listesi",
  T_48_META_API_1520_P1_D: "Kontrol edilecek belirtilen öğe",
  T_48_META_API_1520_R_D: "Belirtilen öğeyi içerip içermediği",
  T_48_META_API_1521_D: "Hedef listenin sonuna birden fazla öğe ekleme",
  T_48_META_API_1521_P0_D: "hedef listesi",
  T_48_META_API_1521_P1_D: "Ek liste",
  T_48_META_API_1522_D: "Belirtilen öğeyi listeden kaldırır",
  T_48_META_API_1522_P0_D: "hedef listesi",
  T_48_META_API_1522_P1_D: "Kaldırılacak öğenin değeri",
  T_48_META_API_1523_D: "Listedeki elemanın ilk konumunun indeksini alır, listede hedef eleman yoksa -1 döndürülür.",
  T_48_META_API_1523_P0_D: "hedef listesi",
  T_48_META_API_1523_P1_D: "temel değer",
  T_48_META_API_1523_R_D: "konum endeksi",
  T_48_META_API_1524_D: "Listedeki elemanın son konumunun indeksini alır, listede hedef eleman yoksa -1 döndürür.",
  T_48_META_API_1524_P0_D: "hedef listesi",
  T_48_META_API_1524_P1_D: "temel değer",
  T_48_META_API_1524_R_D: "konum endeksi",
  T_48_META_API_1525_D: "Açının sinüsünü bulun",
  T_48_META_API_1525_P0_D: "Açı, 360 derece için 360",
  T_48_META_API_1525_R_D: "sinüs",
  T_48_META_API_1526_D: "Bir açının kosinüsünü bulma",
  T_48_META_API_1526_P0_D: "Açı, 360 derece için 360",
  T_48_META_API_1526_R_D: "kosinüs",
  T_48_META_API_1527_D: "Bir açının tanjantını bulma",
  T_48_META_API_1527_P0_D: "Açı, 360 derece için 360",
  T_48_META_API_1527_R_D: "tanjant",
  T_48_META_API_1528_D: "Saydamlığı ondalık 255'e sabitlenmiş bir renk değeri oluşturun, önce kanalı bir ikili sayıya dönüştürün, her 8 bit bir kanalı temsil eder, R, G, B ve saydamlığa göre eklenir ve ardından bu ikili sayıyı Int32 türüne dönüştürün return",
  T_48_META_API_1528_P0_D: "Rengin kırmızı kanalının değeri, [0,255] aralığında, aralığı aşarsa, yasal değere sıkıştırılacaktır.",
  T_48_META_API_1528_P1_D: "Rengin yeşil kanalının değeri, [0,255] aralığında, aralığı aşarsa, yasal değere sıkıştırılacaktır.",
  T_48_META_API_1528_P2_D: "Rengin mavi kanalının değeri, [0,255] aralığında, aralığı aşarsa, yasal değere sıkıştırılacaktır.",
  T_48_META_API_1528_R_D: "Oluşturulan renk değerleri",
  T_48_META_API_1529_D: "Açıyı elde etmek için ters sinüs işlemi gerçekleştirin",
  T_48_META_API_1529_P0_D: "Ters sinüs işleminin gerçekleştirildiği değer, [-1,1] aralığında.",
  T_48_META_API_1529_R_D: "perspektifler",
  T_48_META_API_1530_D: "Açıyı elde etmek için ters kosinüs işlemini gerçekleştirin",
  T_48_META_API_1530_P0_D: "Ters kosinüs işleminin [-1,1] aralığındaki değeri.",
  T_48_META_API_1530_R_D: "perspektifler",
  T_48_META_API_1531_D: "Açıyı elde etmek için ters tanjant işlemi gerçekleştirin",
  T_48_META_API_1531_P0_D: "Arctangent işleminin gerçekleştirildiği değer",
  T_48_META_API_1531_R_D: "perspektifler",
  T_48_META_API_1532_D: "Hedef varlığın belirtilen küre içinde olup olmadığını belirler, varlığın konumsal öznitelikleri yoksa false döndürür",
  T_48_META_API_1532_P0_D: "hedef varlık",
  T_48_META_API_1532_P1_D: "Kürenin merkezini belirtin",
  T_48_META_API_1532_P2_D: "Kürenin yarıçapını belirtin",
  T_48_META_API_1532_R_D: "Bulgular",
  T_48_META_API_1533_D: "Hedef varlığın belirtilen silindir aralığında olup olmadığını belirler, varlığın bir konum özniteliği yoksa false döndürür",
  T_48_META_API_1533_P0_D: "hedef varlık",
  T_48_META_API_1533_P1_D: "Silindirin merkezini belirtin",
  T_48_META_API_1533_P2_D: "Silindirin enine kesitinin yarıçapını belirtin",
  T_48_META_API_1533_P3_D: "Silindirin yüksekliğini belirtin",
  T_48_META_API_1533_P4_D: "Merkez noktası etrafında üç boyutta dönen bir silindirin Euler açısını belirtin",
  T_48_META_API_1533_R_D: "Bulgular",
  T_48_META_API_1534_D: "Hedef varlığın belirtilen küp aralığı içinde olup olmadığını belirleme",
  T_48_META_API_1534_P0_D: "hedef varlık",
  T_48_META_API_1534_P1_D: "Küpün merkezini belirtin",
  T_48_META_API_1534_P2_D: "Küpün uzunluğunu belirtin",
  T_48_META_API_1534_P3_D: "Küpün genişliğini belirtin",
  T_48_META_API_1534_P4_D: "Küpün yüksekliğini belirtin",
  T_48_META_API_1534_P5_D: "Küpün merkez noktası etrafında üç boyutlu dönüşü için Euler açılarını belirtin",
  T_48_META_API_1534_R_D: "Bulgular",
  T_48_META_API_1535_D: "Hedef varlığın belirtilen sektör sütunları içinde olup olmadığını belirleyin",
  T_48_META_API_1535_P0_D: "hedef varlık",
  T_48_META_API_1535_P1_D: "Sektör şeklindeki bir sütunun orta bölümünün dairesinin merkezini belirtin",
  T_48_META_API_1535_P2_D: "Sektör şeklindeki bir sütunun merkez bölümünün yarıçapını belirtin",
  T_48_META_API_1535_P3_D: "Merkez noktası daire olan fan şeklindeki kolonun tespit edilmeyecek kesitinin yarıçapı, bu küçük fan şeklindeki kolon bölgesinde tespit edilmeyecek, sadece öngörülen fan şeklindeki kolon ile küçük fan şeklindeki tema arasındaki fark tespit edilecektir",
  T_48_META_API_1535_P4_D: "Yelpaze şeklindeki sütunun yüksekliğini belirtin",
  T_48_META_API_1535_P5_D: "Merkez açının fan şeklindeki silindirik kesitinin tespiti, silindirik tespit edildiğinde 360'tan büyük, tespit alanının boyutu 0 olduğunda 0'dan küçük",
  T_48_META_API_1535_P6_D: "Yelpaze şeklindeki sütunun merkez nokta etrafındaki Euler dönüş açısını üç yerde belirtin",
  T_48_META_API_1535_R_D: "Bulgular",
  T_48_META_API_1536_D: "İki sayının değerini karşılaştırır ve büyük olanı döndürür",
  T_48_META_API_1536_P0_D: "Sol değer",
  T_48_META_API_1536_P1_D: "Sağ değer",
  T_48_META_API_1536_R_D: "daha büyük rakam",
  T_48_META_API_1537_D: "Listedeki maksimum değeri döndürür",
  T_48_META_API_1537_P0_D: "Hedef liste, yalnızca sayısal türdeki liste öğelerini kabul eder",
  T_48_META_API_1537_P1_D: "Sonuçları karşılaştırın, listede sayı olmayanlar varsa vb. karşılaştırma başarısız olur ve false döndürür.",
  T_48_META_API_1537_P2_D: "Karşılaştırma başarılı olursa listedeki en büyük değeri, başarısız olursa 0 değerini döndürür.",
  T_48_META_API_1538_D: "İki sayının değerini karşılaştırır ve küçük olanı döndürür",
  T_48_META_API_1538_P0_D: "Sol değer",
  T_48_META_API_1538_P1_D: "Sağ değer",
  T_48_META_API_1538_R_D: "Daha küçük rakamlar",
  T_48_META_API_1539_D: "Listedeki en küçük değeri döndürür.",
  T_48_META_API_1539_P0_D: "Hedef liste, yalnızca sayısal türdeki liste öğelerini kabul eder",
  T_48_META_API_1539_P1_D: "Sonuçları karşılaştırın, listede sayı olmayanlar varsa vb. karşılaştırma başarısız olur ve false döndürür.",
  T_48_META_API_1539_P2_D: "Karşılaştırma başarılı olursa listedeki en küçük değeri, başarısız olursa 0 değerini döndürür.",
  T_48_META_API_1540_D: "Doğrusal enterpolasyon, başlangıç değeri ile hedef değer arasındaki enterpolasyon ilerlemesine karşılık gelen değeri döndürür, enterpolasyon katsayıları [0,1]",
  T_48_META_API_1540_P0_D: "Enterpolasyon ilerlemesi 0 olduğunda döndürülen doğrusal enterpolasyon başlangıç değeri.",
  T_48_META_API_1540_P1_D: "Enterpolasyon ilerlemesi 1 olduğunda döndürülen doğrusal enterpolasyon hedef değeri",
  T_48_META_API_1540_P2_D: "Enterpolasyon ilerlemesi, değer aralığı [0,1], başlangıç değerine dönmek için 0 değeri, hedef değere dönmek için 1 değeri, başlangıç değeri ve hedef değerin ortalamasına dönmek için 0,5 değeri",
  T_48_META_API_1540_R_D: "Doğrusal enterpolasyon dönüş değeri",
  T_48_META_API_1541_D: "Hedef değer aralığını sınırlayın, üç girişin ortasındaki değeri alın; rolü hedef değeri belirtilen aralıkla sınırlamaktır, hedef değer en küçük değere dönmek için minimum değerden küçüktür, maksimum değere dönmek için maksimum değerden büyüktür, kendi ara",
  T_48_META_API_1541_P0_D: "hedef değer",
  T_48_META_API_1541_P1_D: "Limit aralığının minimum değeri",
  T_48_META_API_1541_P2_D: "Limit aralığının maksimum değeri",
  T_48_META_API_1541_R_D: "Kısıtlamadan sonra dönüş değeri",
  T_48_META_API_1542_D: "Hedef rengin kanal değerlerini alın",
  T_48_META_API_1542_P0_D: "hedef renk",
  T_48_META_API_1542_P1_D: "Rengin R-değeri, [0 , 255] aralığında.",
  T_48_META_API_1542_P2_D: "Rengin G-değeri, aralık [0 , 255].",
  T_48_META_API_1542_P3_D: "Rengin B-değeri, aralık [0 , 255].",
  T_48_META_API_1542_P4_D: "Rengin A değeri, [0 , 255] aralığında.",
  T_48_META_API_1543_D: "güç operasyonu",
  T_48_META_API_1543_P0_D: "taban",
  T_48_META_API_1543_P1_D: "üsler",
  T_48_META_API_1543_R_D: "hesaplama sonucu",
  T_48_META_API_1544_D: "logaritmik işlem",
  T_48_META_API_1544_P0_D: "taban",
  T_48_META_API_1544_P1_D: "logaritma",
  T_48_META_API_1544_R_D: "hesaplama sonucu",
  T_48_META_API_1545_D: "Yön vektöründen Euler açısına",
  T_48_META_API_1545_P0_D: "yön vektörü",
  T_48_META_API_1545_R_D: "Euler'in açısı",
  T_48_META_API_1546_D: "Euler açısı dönüş yönü vektörü",
  T_48_META_API_1546_P0_D: "Euler'in açısı",
  T_48_META_API_1546_R_D: "yön vektörü",
  T_48_META_API_1547_D: "tamsayıdan kayan nokta sayısına",
  T_48_META_API_1547_P0_D: "tamsayı",
  T_48_META_API_1547_R_D: "kayan nokta",
  T_48_META_API_1548_D: "Hedef vektörü kuaterniyona göre döndürün",
  T_48_META_API_1548_P0_D: "hedef vektör",
  T_48_META_API_1548_P1_D: "dönen kuaterniyon",
  T_48_META_API_1548_R_D: "döndürülmüş vektör",
  T_48_META_API_1549_D: "Hedef sayıyı dizeye dönüştürme",
  T_48_META_API_1549_P0_D: "Dönüştürülecek dizenin hedef numarası",
  T_48_META_API_1549_P1_D: "Çıktı sayısal dize biçimi",
  T_48_META_API_1549_R_D: "string",
  T_48_META_API_1598_D: "Sunucu zaman damgasını al",
  T_48_META_API_1598_R_D: "1 Ocak 1970 tarihinde 0:0:0'dan itibaren geçen saniye sayısını verir",
  T_48_META_API_1599_D: "Sunucu alanını al",
  T_48_META_API_1599_R_D: "Bölgesel Kısaltmalara Geri Dön (BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "Kullanıcı deneyimi veri analizi için özel kullanıcı gömme günlükleri",
  T_48_META_API_16_P0_D: "Rapor edilen oyuncuları takip etmek için",
  T_48_META_API_16_P1_D: "Raporlanacak alan adlarının listesi",
  T_48_META_API_16_P2_D: "Raporlanacak alan değerlerinin listesi",
  T_48_META_API_1601_D: "Sözlük Oluşturma",
  T_48_META_API_1601_R_D: "Sözlük oluşturuldu",
  T_48_META_API_1602_D: "Sözlükte belirtilen anahtara karşılık gelen değeri alır",
  T_48_META_API_1602_P0_D: "Hedef Sözlük",
  T_48_META_API_1602_P1_D: "Anahtar",
  T_48_META_API_1602_R_D: "Değer",
  T_48_META_API_1603_D: "Sözlükte belirtilen anahtara karşılık gelen değeri ayarlar",
  T_48_META_API_1603_P0_D: "Hedef Sözlük",
  T_48_META_API_1603_P1_D: "Anahtar",
  T_48_META_API_1603_P2_D: "Değer",
  T_48_META_API_1604_D: "Belirtilen anahtar-değer çiftini sözlükten kaldırır",
  T_48_META_API_1604_P0_D: "Hedef Sözlük",
  T_48_META_API_1604_P1_D: "Anahtar",
  T_48_META_API_1605_D: "Sözlükteki tüm anahtar-değer çiftlerini temizleyin",
  T_48_META_API_1605_P0_D: "Hedef Sözlük",
  T_48_META_API_1606_D: "Sözlükteki anahtar-değer çiftlerinin sayısını alır",
  T_48_META_API_1606_P0_D: "Hedef Sözlük",
  T_48_META_API_1606_R_D: "Sözlük uzunluğu",
  T_48_META_API_1607_D: "Sözlükte bir anahtarın var olup olmadığını belirleme",
  T_48_META_API_1607_P0_D: "Hedef Sözlük",
  T_48_META_API_1607_P1_D: "Anahtar",
  T_48_META_API_1607_R_D: "Var mı",
  T_48_META_API_1608_D: "Sözlüğün tüm anahtarlarını alır ve bunları bir liste olarak döndürür.",
  T_48_META_API_1608_P0_D: "Hedef Sözlük",
  T_48_META_API_1608_R_D: "Tüm anahtar değerlerin listesi",
  T_48_META_API_17_D: "Tespit için kutu şeklinde bir doğrusal hareket alanı kullanın ve kutu şeklindeki alanın güzergahı üzerinde karşılaşılan tüm varlıkları yakından uzağa doğru döndürün. Başlangıçta kutu şeklindeki aralık içindeyse, tespit edilmeyecektir; boşluklara hiyerarşik parametreler doldurulursa arazi tespit edilebilir.",
  T_48_META_API_17_P0_D: "Kutulu bölgenin üç kenarının uzunluğunun yarısı, sadece pozitif değerler kabul edilir",
  T_48_META_API_17_P1_D: "Kutulu alanın merkez noktası",
  T_48_META_API_17_P2_D: "Kutu alanı döndürme",
  T_48_META_API_17_P3_D: "Kutulu alanda seyahat yönü",
  T_48_META_API_17_P4_D: "Kutulu alanda kat edilen mesafe, sadece pozitif değerler kabul edilir",
  T_48_META_API_17_P5_D: "Katman maskesi, sadece dolu katmanlar taramaya katılacaktır, boş bırakılması tüm katmanların taramaya katılması anlamına gelir",
  T_48_META_API_17_P6_D: "Tetikleyicinin tespit edilip edilemeyeceği",
  T_48_META_API_17_P7_D: "İsabet alan kuruluşların listesi",
  T_48_META_API_1700_D: "Dizeyi tamsayıya dönüştürme",
  T_48_META_API_1700_P0_D: "hedef dize",
  T_48_META_API_1700_P1_D: "ortaya çıkan tamsayı",
  T_48_META_API_1700_P2_D: "Dönüşümün başarılı olup olmadığı",
  T_48_META_API_1701_D: "Bir dizeyi kayan noktalı sayıya dönüştürme",
  T_48_META_API_1701_P0_D: "hedef dize",
  T_48_META_API_1701_P1_D: "ortaya çıkan float",
  T_48_META_API_1701_P2_D: "Dönüşümün başarılı olup olmadığı",
  T_48_META_API_18_D: "Tespit için düz çizgide hareket eden bir küresel alan kullanın ve küresel alan rotasında karşılaşılan tüm varlıkları yakından uzağa doğru döndürün. Başlangıçta küresel alandalarsa, seviye parametresi boşluğa doldurulursa tespit edilmeyecektir; arazi tespit edilebilir",
  T_48_META_API_18_P0_D: "Küresel bölgenin yarıçapı, sadece pozitif değerler kabul edilir",
  T_48_META_API_18_P1_D: "küresel alanın merkez noktası",
  T_48_META_API_18_P2_D: "Küresel alanda seyahat yönü",
  T_48_META_API_18_P3_D: "Küresel alan seyahat mesafesi, sadece pozitif değerler kabul edilir",
  T_48_META_API_18_P4_D: "Katman maskesi, sadece dolu katmanlar taramaya katılacaktır, boş bırakılması tüm katmanların taramaya katılması anlamına gelir",
  T_48_META_API_18_P5_D: "Tetikleyicinin tespit edilip edilemeyeceği",
  T_48_META_API_18_P6_D: "İsabet alan kuruluşların listesi",
  T_48_META_API_19_D: "Tespit için doğrusal olarak hareket eden bir kapsül alanı kullanın ve kapsül alanı güzergahı üzerinde yakından uzağa doğru karşılaşılan tüm varlıkları geri getirin. Başlangıçta kapsül alanı içerisindeyseler, seviye parametresi doldurulduğunda tespit edilmeyecektir; arazi tespit edilebilir.",
  T_48_META_API_19_P0_D: "Kapsül gövdesi bölgesinin her iki ucundaki yarım kürenin yarıçapı, sadece pozitif değerler kabul edilir",
  T_48_META_API_19_P1_D: "Kapsül gövde bölgesinin her bir ucundaki yarım kürelerin küresel merkezleri arasındaki mesafe, her bir uçtaki yarım kürelerin yarıçapının iki katından daha büyük olmalıdır",
  T_48_META_API_19_P2_D: "Kapsül gövdesi bölgesinin merkez noktası",
  T_48_META_API_19_P3_D: "Kapsül gövdesi bölgesinin rotasyonu",
  T_48_META_API_19_P4_D: "Kapsül gövdesi bölgesinde hareket yönü",
  T_48_META_API_19_P5_D: "Kapsül alanındaki seyahat edilen mesafe, sadece pozitif değerler kabul edilir.",
  T_48_META_API_19_P6_D: "Katman maskesi, sadece dolu katmanlar taramaya katılacaktır, boş bırakılması tüm katmanların taramaya katılması anlamına gelir",
  T_48_META_API_19_P7_D: "Tetikleyicinin tespit edilip edilemeyeceği",
  T_48_META_API_19_P8_D: "İsabet alan kuruluşların listesi",
  T_48_META_API_2_D: "Geçerli oyundaki tüm takımları alır ve takımların listesini döndürür.",
  T_48_META_API_2_R_D: "Ekip Listesi",
  T_48_META_API_20_D: "Kutu şeklindeki alan içindeki tüm varlıkları tespit etmek ve geri döndürmek için statik kutu şeklinde bir alan kullanın. Boşluklar seviye parametresi doldurulursa arazi tespit edilebilir.",
  T_48_META_API_20_P0_D: "Kutulu bölgenin üç kenarının uzunluğunun yarısı, sadece pozitif değerler kabul edilir",
  T_48_META_API_20_P1_D: "Kutulu alanın merkez noktası",
  T_48_META_API_20_P2_D: "Kutu alanı döndürme",
  T_48_META_API_20_P3_D: "Katman maskesi, sadece dolu katmanlar taramaya katılacaktır, boş bırakılması tüm katmanların taramaya katılması anlamına gelir",
  T_48_META_API_20_P4_D: "Tetikleyicinin tespit edilip edilemeyeceği",
  T_48_META_API_20_P5_D: "İsabet alan kuruluşların listesi",
  T_48_META_API_2000_D: "Hedef varlığın bir özniteliğinin değerinin ayarlanması, özniteliğin önceden tanımlanmış olmasını gerektirir.",
  T_48_META_API_2000_P0_D: "hedef varlık",
  T_48_META_API_2000_P1_D: "Hedef varlığın bir niteliği",
  T_48_META_API_2000_P2_D: "Özellik tanımlandığında gereken türle eşleşmesi gereken hedef değer",
  T_48_META_API_2000_P3_D: "Tüm türler atamayı destekler ve sayısal türler kendi kendine toplama, kendi kendine eksiltme, kendi kendine çarpma, kendi kendine bölme ve kendi kendine kalanı destekler.",
  T_48_META_API_2001_D: "Bir varlığın özniteliğinin değerini alma",
  T_48_META_API_2001_P0_D: "hedef varlık",
  T_48_META_API_2001_P1_D: "Bu varlığın bir özniteliğinin kimliği",
  T_48_META_API_2001_R_D: "bir niteliğin değeri",
  T_48_META_API_2002: "Grafik Özelliğini Ayarla",
  T_48_META_API_2002_D: "Komut Dosyası Değişkenlerini Ayarlama",
  T_48_META_API_2002_P0_D: "hedef varlık",
  T_48_META_API_2002_P1: "Grafik Kimliği",
  T_48_META_API_2002_P1_D: "Hedef Komut Dosyası Kimliği",
  T_48_META_API_2002_P2: "Mülk Kimliği",
  T_48_META_API_2002_P2_D: "Kodda tanımlanan üye özelliğinin kimliği",
  T_48_META_API_2002_P3: "Emlak Değeri",
  T_48_META_API_2002_P3_D: "Özellik tanımlandığında gereken türle eşleşmesi gereken hedef değer",
  T_48_META_API_2002_P4_D: "Tüm türler atamayı destekler ve sayısal türler kendi kendine toplama, kendi kendine eksiltme, kendi kendine çarpma, kendi kendine bölme ve kendi kendine kalanı destekler.",
  T_48_META_API_2003: "Grafik Özelliğini Al",
  T_48_META_API_2003_D: "Komut Dosyası Değişkenlerini Alma",
  T_48_META_API_2003_P0_D: "hedef varlık",
  T_48_META_API_2003_P1: "Grafik Kimliği",
  T_48_META_API_2003_P1_D: "Hedef Komut Dosyası Kimliği",
  T_48_META_API_2003_P2: "Mülk Kimliği",
  T_48_META_API_2003_P2_D: "Hedef Öznitelik Kimliği",
  T_48_META_API_2003_R_D: "bir niteliğin değeri",
  T_48_META_API_2004_D: "Bildirim konumundan içinde bulunduğu deyim bloğunun sonuna kadar kapsamı olan bir yerel değişken tanımlayın ve başlatın.",
  T_48_META_API_2004_P0_D: "değişken adı",
  T_48_META_API_2004_P1_D: "değişken ilk değeri",
  T_48_META_API_2004_P2_D: "Değişken bildirim türü, atamanın bildirilen türle eşleşmesi gerekir",
  T_48_META_API_2005_D: "Bildirim konumundan içinde bulunduğu deyim bloğunun sonuna kadar kapsamlandırılan bir yerel değişkenin değerinin ayarlanması",
  T_48_META_API_2005_P0_D: "değişken adı",
  T_48_META_API_2005_P1: "Değişken Değer",
  T_48_META_API_2005_P1_D: "değişken değeri",
  T_48_META_API_2005_P2_D: "Tüm türler atamayı destekler ve sayısal türler kendi kendine toplama, kendi kendine eksiltme, kendi kendine çarpma, kendi kendine bölme ve kendi kendine kalanı destekler.",
  T_48_META_API_2006: "Yerel Değişkeni Al",
  T_48_META_API_2006_D: "Bildirim konumundan deyim bloğunun sonuna kadar kapsamlandırılan bir yerel değişkenin değerini alır.",
  T_48_META_API_2006_P0: "Değişken Adı",
  T_48_META_API_2006_P0_D: "değişken adı",
  T_48_META_API_2006_R_D: "değişken değeri",
  T_48_META_API_2009: "Serial ile Küresel Özel API'yi Bul ve Çağır",
  T_48_META_API_2009_D: "Global özel işlevleri seri bir şekilde çağırır ve özel işlevde bir bekleme varsa, çağrı konumu da bekler",
  T_48_META_API_2009_P0: "Grafik Kimliği",
  T_48_META_API_2009_P0_D: "Özel fonksiyonun bulunduğu kodun kod kimliği",
  T_48_META_API_2009_P1: "İşlev kimliği",
  T_48_META_API_2009_P1_D: "Çağrılan özel işlevin kimliği",
  T_48_META_API_2009_P2_D: "Özel fonksiyona aktarılan argümanların listesi",
  T_48_META_API_2010: "Parallel ile Küresel Özel API'yi Bul ve Çağır",
  T_48_META_API_2010_D: "Global özel işlevleri paralel bir şekilde çağırır, özel işlevde bir bekleme olup olmadığına bakılmaksızın satırda devam etmek için hemen çağrı konumuna döner",
  T_48_META_API_2010_P0: "Grafik Kimliği",
  T_48_META_API_2010_P0_D: "Özel fonksiyonun bulunduğu kodun kod kimliği",
  T_48_META_API_2010_P1: "İşlev kimliği",
  T_48_META_API_2010_P1_D: "Çağrılan özel işlevin kimliği",
  T_48_META_API_2010_P2_D: "Özel fonksiyona aktarılan argümanların listesi",
  T_48_META_API_2013: "Kendi Grafik Özelliğini Ayarla",
  T_48_META_API_2013_D: "Geçerli kod için değişkenleri ayarlama",
  T_48_META_API_2013_P0: "Mülk Kimliği",
  T_48_META_API_2013_P0_D: "Hedef Öznitelik Kimliği",
  T_48_META_API_2013_P1: "Emlak Değeri",
  T_48_META_API_2013_P1_D: "hedef değer",
  T_48_META_API_2013_P2_D: "Tüm türler atamayı destekler ve sayısal türler kendi kendine toplama, kendi kendine eksiltme, kendi kendine çarpma, kendi kendine bölme ve kendi kendine kalanı destekler.",
  T_48_META_API_2014: "Kendi Grafik Özelliğini Al",
  T_48_META_API_2014_D: "Geçerli kod için değişkenleri alma",
  T_48_META_API_2014_P0: "Mülk Kimliği",
  T_48_META_API_2014_P0_D: "Hedef Öznitelik Kimliği",
  T_48_META_API_2014_R_D: "bir niteliğin değeri",
  T_48_META_API_21_D: "Küresel alan içindeki tüm varlıkları tespit etmek ve geri döndürmek için statik bir küresel alan kullanın. Seviye parametresi boşluklara doldurulursa arazi tespit edilebilir.",
  T_48_META_API_21_P0_D: "Küresel bölgenin yarıçapı, sadece pozitif değerler kabul edilir",
  T_48_META_API_21_P1_D: "küresel alanın merkez noktası",
  T_48_META_API_21_P2_D: "Katman maskesi, sadece dolu katmanlar taramaya katılacaktır, boş bırakılması tüm katmanların taramaya katılması anlamına gelir",
  T_48_META_API_21_P3_D: "Tetikleyicinin tespit edilip edilemeyeceği",
  T_48_META_API_21_P4_D: "İsabet alan kuruluşların listesi",
  T_48_META_API_22_D: "Kapsül alanı içindeki tüm varlıkları tespit etmek ve geri döndürmek için statik bir kapsül alanı kullanın. Seviye parametresi doldurulursa arazi tespit edilebilir.",
  T_48_META_API_22_P0_D: "Kapsül gövdesi bölgesinin her iki ucundaki yarım kürenin yarıçapı, sadece pozitif değerler kabul edilir",
  T_48_META_API_22_P1_D: "Kapsül gövde bölgesinin her bir ucundaki yarım kürelerin küresel merkezleri arasındaki mesafe, her bir uçtaki yarım kürelerin yarıçapının iki katından daha büyük olmalıdır",
  T_48_META_API_22_P2_D: "Kapsül gövdesi bölgesinin merkez noktası",
  T_48_META_API_22_P3_D: "Kapsül gövdesi bölgesinin rotasyonu",
  T_48_META_API_22_P4_D: "Katman maskesi, sadece dolu katmanlar taramaya katılacaktır, boş bırakılması tüm katmanların taramaya katılması anlamına gelir",
  T_48_META_API_22_P5_D: "Tetikleyicinin tespit edilip edilemeyeceği",
  T_48_META_API_22_P6_D: "İsabet alan kuruluşların listesi",
  T_48_META_API_23_D: "Oyuncu için özel eşya durumunu ayarlayın, özel eşyaların yalnızca bir",
  T_48_META_API_23_P0_D: "oyuncu",
  T_48_META_API_23_P1_D: "Ürün Kimliği",
  T_48_META_API_23_P2_D: "Öğenin etkinleştirilip etkinleştirilmeyeceği",
  T_48_META_API_23_P3_D: "özel madde",
  T_48_META_API_24_D: "Fiziksel bir nesne olması gereken hedefe bir kuvvet uygulayın.",
  T_48_META_API_24_P0_D: "hedef fiziksel nesne",
  T_48_META_API_24_P1_D: "kuvvet vektörü",
  T_48_META_API_24_P2_D: "Kuvvet türü",
  T_48_META_API_25_D: "Bir noktaya bir kez kuvvet uygulayın, hedef katı bir cisim olmalıdır",
  T_48_META_API_25_P0_D: "hedef rijit gövde",
  T_48_META_API_25_P1_D: "kuvvet vektörü",
  T_48_META_API_25_P2_D: "Kuvvet uygulama konumu",
  T_48_META_API_25_P3_D: "Kuvvet türü",
  T_48_META_API_26_D: "Sert olması gereken hedefe bir tork uygulayın.",
  T_48_META_API_26_P0_D: "hedef rijit gövde",
  T_48_META_API_26_P1_D: "burulma",
  T_48_META_API_26_P2_D: "Uygulanan kuvvet türü",
  T_48_META_API_27_D: "Hedef katı gövdeyi belirtilen konuma taşıma",
  T_48_META_API_27_P0_D: "hedef rijit gövde",
  T_48_META_API_27_P1_D: "belirlenmiş yer",
  T_48_META_API_28_D: "Hedef katı gövdeyi döndürme",
  T_48_META_API_28_P0_D: "hedef rijit gövde",
  T_48_META_API_28_P1_D: "dönen kuaterniyon",
  T_48_META_API_29_D: "Hedef varlığın belirtilen özelliklerinin ayarlara göre yumuşatıldığı enterpolasyonlu bir hareket oluşturur.",
  T_48_META_API_29_P0_D: "hedef varlık",
  T_48_META_API_29_P1_D: "Hareket değişikliği gerektiren öznitelik kimlikleri",
  T_48_META_API_29_P2_D: "Öznitelik Başlangıç Değeri",
  T_48_META_API_29_P3_D: "Öznitelik son değeri",
  T_48_META_API_29_P4_D: `Tek, döngü ve ileri geri hareket etmeyi seçebilirsiniz. 
 Döngü, her hareket tamamlandıktan sonra varlığın başlangıç ​​değerinden tekrar hareket edeceği anlamına gelir. İleri geri hareket, başlangıç ​​değerinden hedef değere hareket tamamlandıktan sonra varlığın hedef değerden tekrar başlangıç ​​değerine hareket edeceği ve ardından işlemi tekrarlayacağı anlamına gelir.`,
  T_48_META_API_29_P5_D: "Bessel eğrisi kontrol noktası",
  T_48_META_API_29_P6_D: "Milisaniye cinsinden değişim süresi",
  T_48_META_API_29_P7_D: "Enterpolasyonlu hareket varlıkları oluşturuldu",
  T_48_META_API_29_P8_D: "Oluşturulduktan sonra oynatmanın otomatik olarak başlayıp başlamayacağı",
  T_48_META_API_3_D: "Oyunu hedef aşamaya geçiren tur aynı zamanda özel bir aşamadır. Bir turda bir aşamaya geçerken, tur sayısı 0'dır.",
  T_48_META_API_3_P0_D: "Hedef tur veya aşama indeksi",
  T_48_META_API_30_D: "Hedef oyuncuyu belirtilen araca girmeye zorlar",
  T_48_META_API_30_P0_D: "hedef oyuncu",
  T_48_META_API_30_P1_D: "taşıyıcı kuruluş",
  T_48_META_API_30_P2_D: "Koltuk numarası",
  T_48_META_API_30_P3_D: "Oyuncuyu taşıyıcıya sokmayı başarsa da başaramasa da",
  T_48_META_API_3001_D: "Hedef oyuncunun bir öğeyi atmasını sağlayın",
  T_48_META_API_3001_P0_D: "hedef oyuncu",
  T_48_META_API_3001_P1_D: "fiziksel varlık",
  T_48_META_API_3002_D: "Tamamen dolu olmayan mevcut rastgele doğum noktası içindeki mevcut koordinatları alın (kullanımdan kaldırılmıştır, lütfen GetRandomSpawnPosition kullanın)",
  T_48_META_API_3002_P0_D: "Bir doğum noktası alanı atanması gereken oyuncular",
  T_48_META_API_3002_R_D: "Rastgele atanan nokta koordinatları",
  T_48_META_API_3003_D: "Belirtilen puan türü için oyuncunun toplam puanını alır",
  T_48_META_API_3003_P0_D: "oyuncu",
  T_48_META_API_3003_P1_D: "Puan türü",
  T_48_META_API_3003_R_D: "puan değeri",
  T_48_META_API_3004_D: "Bir oyuncunun belirtilen puan türü için tur skorunu ayarlama",
  T_48_META_API_3004_P0_D: "oyuncu varlığı",
  T_48_META_API_3004_P1_D: "Puan türü",
  T_48_META_API_3004_P2_D: "puan değeri",
  T_48_META_API_3005_D: "Belirtilen puan türü için takımın toplam puanını alır",
  T_48_META_API_3005_P0_D: "ekip varlığı",
  T_48_META_API_3005_P1_D: "Puan türü",
  T_48_META_API_3005_R_D: "puan değeri",
  T_48_META_API_3006_D: "Bir takımın belirtilen puan türü için tur skorunun ayarlanması",
  T_48_META_API_3006_P0_D: "ekip varlığı",
  T_48_META_API_3006_P1_D: "Puan türü",
  T_48_META_API_3006_P2_D: "puan değeri",
  T_48_META_API_3007_D: "Belirtilen tur ve puan türü için oyuncunun puanını alır",
  T_48_META_API_3007_P0_D: "oyuncu varlığı",
  T_48_META_API_3007_P1_D: "Yuvarlak Endeks",
  T_48_META_API_3007_P2_D: "Puan türü",
  T_48_META_API_3007_R_D: "puan değeri",
  T_48_META_API_3008_D: "Belirtilen tur için takımın puanını, puan türünü alın",
  T_48_META_API_3008_P0_D: "ekip varlığı",
  T_48_META_API_3008_P1_D: "Yuvarlak Endeks",
  T_48_META_API_3008_P2_D: "Puan türü",
  T_48_META_API_3008_R_D: "puan değeri",
  T_48_META_API_3009_D: "Oyuncunun genel oyun sıralamasını alın",
  T_48_META_API_3009_P0_D: "oyuncu varlığı",
  T_48_META_API_3009_R_D: "bir isim sıralamasındaki konum",
  T_48_META_API_3011_D: "Takımın genel oyun sıralamasını alın",
  T_48_META_API_3011_P0_D: "terkedilmiş",
  T_48_META_API_3011_R_D: "bir isim sıralamasındaki konum",
  T_48_META_API_3013_D: "Belirli bir tur için oyuncunun sıralamasını alın",
  T_48_META_API_3013_P0_D: "oyuncu varlığı",
  T_48_META_API_3013_P1_D: "Yuvarlak Endeks",
  T_48_META_API_3013_R_D: "bir isim sıralamasındaki konum",
  T_48_META_API_3014_D: "Belirli bir tur için takım sıralamalarını alın",
  T_48_META_API_3014_P0_D: "terkedilmiş",
  T_48_META_API_3014_P1_D: "Yuvarlak Endeks",
  T_48_META_API_3014_R_D: "bir isim sıralamasındaki konum",
  T_48_META_API_3015_D: "Hedef varlığın cüzdanını alın",
  T_48_META_API_3015_P0_D: "hedef varlık",
  T_48_META_API_3015_P1_D: "Bir cüzdanın varlığı",
  T_48_META_API_3015_P2_D: "Satın alınan cüzdan kuruluşları",
  T_48_META_API_3016_D: "Hedef oyuncu için bir cüzdan oluşturur, oyuncunun zaten bir cüzdanı varsa geçerli değildir.",
  T_48_META_API_3016_P0_D: "hedef oyuncu",
  T_48_META_API_3016_P1_D: "Cüzdana bağlı varlık, cüzdanın sahibi",
  T_48_META_API_3016_P2_D: "cüzdan varlığı",
  T_48_META_API_3017_D: "Belirli bir cüzdana para birimi ekleme",
  T_48_META_API_3017_P0_D: "Hedef cüzdan",
  T_48_META_API_3017_P1_D: "Eklenen para birimi türü",
  T_48_META_API_3017_P2_D: "Para birimi sayısındaki artış",
  T_48_META_API_3018_D: "Belirli bir cüzdan için para birimi indirimi",
  T_48_META_API_3018_P0_D: "Hedef cüzdan",
  T_48_META_API_3018_P1_D: "Azaltılmış para birimi türü",
  T_48_META_API_3018_P2_D: "Azaltılmış para birimi sayısı",
  T_48_META_API_3019_D: "Para birimini bir cüzdandan başka bir cüzdana aktarma",
  T_48_META_API_3019_P0_D: "Para birimlerini transfer etmek için cüzdanlar",
  T_48_META_API_3019_P1_D: "Transfer edilen para türleri",
  T_48_META_API_3019_P2_D: "Transfer edilen para birimi sayısı",
  T_48_META_API_3019_P3_D: "Para biriminin aktarıldığı cüzdan",
  T_48_META_API_3020_D: "Belirli bir cüzdandaki belirli bir türdeki para birimlerinin sayısını alın",
  T_48_META_API_3020_P0_D: "Hedef cüzdan",
  T_48_META_API_3020_P1_D: "Sorgunun para birimi türü",
  T_48_META_API_3020_R_D: "Para birimi miktarı",
  T_48_META_API_3021_D: "Belirtilen cüzdandaki belirtilen para birimi türünün varlıklarını alın",
  T_48_META_API_3021_P0_D: "Hedef cüzdan",
  T_48_META_API_3021_P1_D: "Sorgunun para birimi türü",
  T_48_META_API_3021_R_D: "Parasal kuruluşlar",
  T_48_META_API_3022_D: "Oyundaki tüm dükkanları alın, liste olarak döndürün",
  T_48_META_API_3022_R_D: "Mağaza Varlıklarının Listesi",
  T_48_META_API_3023_D: "Hedef oyuncunun şeklini belirtilen bir sahne nesnesinin şekliyle değiştirir.",
  T_48_META_API_3023_P0_D: "hedef oyuncu",
  T_48_META_API_3023_P1_D: "Değiştirme için Hedef Sahne Nesneleri",
  T_48_META_API_3023_P2_D: "Sonrasında oluşturulan oyuncu dönüşümü kamuflaj bileşeninin değiştirilmesi",
  T_48_META_API_3024_D: "Oyuncunun kamuflaj durumunu iptal eder",
  T_48_META_API_3024_P0_D: "hedef oyuncu",
  T_48_META_API_3025_D: "Hedef oyuncuda bir sahne varlığı şeklinde bir alter ego oluşturun",
  T_48_META_API_3025_P0_D: "hedef oyuncu",
  T_48_META_API_3025_P1_D: "Bölünmüş görüntüler için sahne varlıkları",
  T_48_META_API_3025_P2_D: "Oluşturulan çelik varlıklar",
  T_48_META_API_3026_D: "Oyuncunun kamuflajlı varlığının elde edilmesi",
  T_48_META_API_3026_P0_D: "oyuncu",
  T_48_META_API_3026_R_D: "Varlıkları gizleyen oyuncular",
  T_48_META_API_3027_D: "Sohbet kanalı varlığını dizine göre al",
  T_48_META_API_3027_P0_D: "Sohbet kanalı indeksi, aralık [1,8]",
  T_48_META_API_3027_R_D: "Sohbet kanalı varlıkları",
  T_48_META_API_3028_D: "Belirtilen oyuncunun o anda içinde bulunduğu sohbet kanalı varlığını döndürür",
  T_48_META_API_3028_P0_D: "hedef oyuncu",
  T_48_META_API_3028_R_D: "Sohbet kanalı varlıkları",
  T_48_META_API_3029_D: "Oyuncuların belirlenen sohbet kanalına katılmalarını ve oyuncular zaten diğer sohbet kanallarındayken hedef kanala geçmelerini sağlayın.",
  T_48_META_API_3029_P0_D: "hedef oyuncu",
  T_48_META_API_3029_P1_D: "Sohbet kanalı varlıkları",
  T_48_META_API_3030_D: "Oyuncunun o anda bulunduğu kanaldan çıkmasına ve bundan sonra herhangi bir sohbet kanalında bulunmamasına neden olur",
  T_48_META_API_3030_P0_D: "hedef oyuncu",
  T_48_META_API_3031_D: "terkedilmiş",
  T_48_META_API_3031_P0_D: "Sohbet kanalı varlığı, kanalda oyuncu olmadığında boş",
  T_48_META_API_3032_D: "Oyuncunun davranışsal durumunu ayarlama",
  T_48_META_API_3032_P0_D: "hedef oyuncu",
  T_48_META_API_3032_P1_D: "Oyuncu Davranış Türleri",
  T_48_META_API_3032_P2_D: `Etkin: HUD düğmesi mevcut, normalde kullanılabilir
 Devre dışı: HUD düğmesi devre dışı, davranışsal duruma aktif veya pasif olarak erişemiyor
 Maskeli: HUD düğmesi gizli, davranışsal duruma aktif olarak erişemiyor, ancak davranışsal duruma pasif olarak `,
  T_48_META_API_3033_D: "Oyuncu belirli bir sahnede bir nesneye dönüşür",
  T_48_META_API_3033_P0_D: "hedef oyuncu",
  T_48_META_API_3033_P1_D: "nesnesine dönüştürülecek",
  T_48_META_API_3033_P2_D: "Dönüşümden sonra oluşturulan varlıklar",
  T_48_META_API_3034_D: "Oyuncu kendi görünümünde bir alter ego yaratır",
  T_48_META_API_3034_P0_D: "hedef oyuncu",
  T_48_META_API_3034_P1_D: "Yaratılan ego varlıklarını değiştirin",
  T_48_META_API_3035_D: "Mağazanın bir sonraki seviyesi olarak raflı özel bir mağaza oluşturun",
  T_48_META_API_3035_P0_D: "Mağaza varlıkları oluşturuldu",
  T_48_META_API_3036_D: "Rafın üst seviyesinin mağaza ve alt seviyesinin ürünler olduğu özel bir raf oluşturun",
  T_48_META_API_3036_P0_D: "Oluşturulan raf varlıkları",
  T_48_META_API_3037_D: "Özel bir ürün oluşturun, ürün öğeleri ekleyebilir",
  T_48_META_API_3037_P0_D: "Oluşturulan emtia varlıkları",
  T_48_META_API_3038_D: "Bir ürüne öğe eklemek, öğeyi birden çok kez kullanarak bir ürüne birden çok öğe eklemenize olanak tanır.",
  T_48_META_API_3038_P0_D: "Emtia kuruluşları",
  T_48_META_API_3038_P1_D: "Eklenecek öğeler",
  T_48_META_API_3038_P2_D: "Ürün sayısı",
  T_48_META_API_3039_D: "Jailbreak Ödülleri Verme",
  T_48_META_API_3039_P0_D: "oyuncu varlığı",
  T_48_META_API_3039_P1_D: "Miktarlar",
  T_48_META_API_3039_P2_D: "gerçek para",
  T_48_META_API_3040_D: "Güncellenmiş jailbreak görevleri",
  T_48_META_API_3040_P0_D: "oyuncu varlığı",
  T_48_META_API_3040_P1_D: "Görev Kimliği",
  T_48_META_API_3040_P2_D: "(olmak) değer",
  T_48_META_API_3041_D: "Yalnızca tamamen dolu olmayan mevcut doğum noktalarından rastgele bir doğum noktasının koordinatlarını alın.",
  T_48_META_API_3041_P0_D: "hedef oyuncu",
  T_48_META_API_3041_R_D: "Doğum noktasının koordinatlarını rastgele belirler, kriterlere uyan bir doğum noktası yoksa (0, 0, 0) yakınında bir konum döndürür.",
  T_48_META_API_3042_D: "Jailbreak oyunundan çık",
  T_48_META_API_3042_P0_D: "oyuncu varlığı",
  T_48_META_API_3042_P1_D: "Görev Kimliği",
  T_48_META_API_3043_D: "Jailbreak desteklerine göre",
  T_48_META_API_3043_P0_D: "oyuncu varlığı",
  T_48_META_API_3043_P1_D: "Sahne tipi",
  T_48_META_API_3043_P2_D: "Sahne Kimliği",
  T_48_META_API_31_D: "Hedef varlığın her seferinde mevcut öznitelik değerlerine göre değiştiği bir kendisine göreli hareket oluşturur",
  T_48_META_API_31_P0_D: "hedef varlık",
  T_48_META_API_31_P1_D: "Hareket değişikliği gerektiren özellikler",
  T_48_META_API_31_P2_D: "Hareket başına değişim miktarı",
  T_48_META_API_31_P3_D: "Bessel eğrisi kontrol noktası",
  T_48_META_API_31_P4_D: `Tek: nitelik Delta miktarını değiştirdiğinde hareket durur 
 Döngüsel: nitelik Delta miktarını her değiştirdiğinde hareket tekrarlanır`,
  T_48_META_API_31_P5_D: "Milisaniye cinsinden değişim süresi",
  T_48_META_API_31_P6_D: "Kendilerine göre hareket eden varlıklar oluşturuldu",
  T_48_META_API_31_P7_D: "Oluşturulduktan sonra oynatmanın otomatik olarak başlayıp başlamayacağı",
  T_48_META_API_3100_D: "Hedef, animasyonu belirtilen durumda oynatır",
  T_48_META_API_3100_P0_D: "Monte edilebilir animasyon denetleyicileri ile animasyonları oynatan varlık bileşenleri",
  T_48_META_API_3100_P1_D: "Animasyon denetleyicisinin belirtilen durumu",
  T_48_META_API_3100_P2_D: "Animasyon oynatma hızı ölçeklendirme",
  T_48_META_API_3100_P3_D: "Döngü türü, animasyonun orijinal mantığını koruyabilir, yalnızca bir kez oynatabilir veya döngü yapabilirsiniz.",
  T_48_META_API_3101_D: "Karakter animasyonu oynatın, özel animasyon kaynaklarını destekleyin",
  T_48_META_API_3101_P0_D: "hedef oyuncu",
  T_48_META_API_3101_P1_D: "Özel Animasyon Kaynak Kimliği",
  T_48_META_API_3101_P2_D: "Döngü olsun ya da olmasın",
  T_48_META_API_3102_D: "Belirli bir oyuncu için karakter kaynaklarının ayarlanması",
  T_48_META_API_3102_P0_D: "hedef oyuncu",
  T_48_META_API_3102_P1_D: "Özel Rol Kaynak Kimliği",
  T_48_META_API_3109_D: "Açmak, güvenlik bölgesinin sonuna kadar hareketi yumuşatacaktır",
  T_48_META_API_3109_P0_D: "Güvenlik bölgesinin başlangıç konumu",
  T_48_META_API_3109_P1_D: "Güvenlik bölgesinin sonunun konumu",
  T_48_META_API_3109_P2_D: "Güvenlik bölgesinin başlangıç yarıçapı",
  T_48_META_API_3109_P3_D: "Güvenlik bölgesinin nihai yarıçapı",
  T_48_META_API_3109_P4_D: "Güvenlik bölgesinin son durumuna ulaşması için saniye cinsinden süre",
  T_48_META_API_3109_P5_D: "Güvenli bölge dışında alınan saniye başına hasar miktarı",
  T_48_META_API_3110_D: "Karakter Görünüm Gruplarını Değiştirme",
  T_48_META_API_3110_P0_D: "hedefler",
  T_48_META_API_3110_P1_D: "Görünüm Grubu",
  T_48_META_API_3111_D: "Rol Görünüş Grubunu Göster",
  T_48_META_API_3111_P0_D: "hedefler",
  T_48_META_API_3111_P1_D: "Görünüm Grubu",
  T_48_META_API_3112_D: "Gizli Karakter Görünüm Grubu",
  T_48_META_API_3112_P0_D: "hedefler",
  T_48_META_API_3112_P1_D: "Görünüm Grubu",
  T_48_META_API_3121_D: "Doğrulama Sonuçlarının İstatistiksel Kullanım için Craftland Studio PC'ye Gönderilmesi",
  T_48_META_API_3121_P0_D: "iddia ifadesi",
  T_48_META_API_3121_P1_D: "bir şeye dikkat çekmek.",
  T_48_META_API_32_D: "Oyuncunun bugünkü token verilerini alın",
  T_48_META_API_32_P0_D: "hedef oyuncu",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "Jeton sayısı",
  T_48_META_API_32_P3_D: "Tuple'ın başarıyla çağrılıp çağrılmadığı",
  T_48_META_API_3200_D: "Oynatıcıya öğeler ekler ve verilen öğelerin bir listesini döndürür",
  T_48_META_API_3200_P0_D: "oyuncu",
  T_48_META_API_3200_P1_D: "Ürün Kimliği",
  T_48_META_API_3200_P2_D: "Ürün sayısı",
  T_48_META_API_3200_P3_D: "Oyuncu için eklenen öğelerin bir listesi, yalnızca bir öğe eklenmiş olsa bile, bir liste olarak döndürülür.",
  T_48_META_API_3201_D: "Kan limitini aşmadan belirlenen oyuncuya kan geri yükler",
  T_48_META_API_3201_P0_D: "hedef oyuncu",
  T_48_META_API_3201_P1_D: "Oyuncuya kan ekleyen bir değer, sadece pozitif sayılar kabul edilir",
  T_48_META_API_3202_D: "Hedef oyuncunun beceri listesini ayarlama",
  T_48_META_API_3202_P0_D: "hedef oyuncu",
  T_48_META_API_3202_P1_D: "Beceriler Listesi",
  T_48_META_API_3203_D: "Hedef oyuncunun becerilerinin bir listesini alır",
  T_48_META_API_3203_P0_D: "hedef oyuncu",
  T_48_META_API_3203_R_D: "Beceriler Listesi",
  T_48_META_API_3205_D: "Oynatıcıdan belirli sayıda öğeyi silme",
  T_48_META_API_3205_P0_D: "hedef oyuncu",
  T_48_META_API_3205_P1_D: "Silinecek öğenin türü",
  T_48_META_API_3205_P2_D: "Silinecek öğelerin sayısı, eğer oyuncu tarafından tutulan sayıyı aşarsa, o zaman sadece tutulan öğeler silinecektir",
  T_48_META_API_3206_D: "Bir oyuncu tarafından tutulan öğelerin belirtilen sayısını alır",
  T_48_META_API_3206_P0_D: "hedef oyuncu",
  T_48_META_API_3206_P1_D: "Ürün tipi",
  T_48_META_API_3206_R_D: "Oyuncu holdinglerinin sayısı",
  T_48_META_API_3207_D: "Oyuncunun mevcut kontrol noktasını tetikleyip tetikleyemeyeceğini tespit eder",
  T_48_META_API_3207_P0_D: "hedef oyuncu",
  T_48_META_API_3207_P1_D: "Tetikleyici",
  T_48_META_API_3207_R_D: "Doğru: tetiklenebilir, Yanlış: tetiklenemez",
  T_48_META_API_3208_D: "Enfeksiyon Modu Zombi Evrimi",
  T_48_META_API_3208_P0_D: "hedef oyuncu",
  T_48_META_API_3209_D: "Yapay zeka varlığı varsayılan davranış ağacını durdurur/uygular",
  T_48_META_API_3209_P0_D: "Davranış ağacının hedefini etkinleştirmek için",
  T_48_META_API_3209_P1_D: "Varsayılan davranış ağacının uygulanıp uygulanmayacağı",
  T_48_META_API_3210_D: "Belirlenmiş bir hedefi takip eden yapay zeka kuruluşu",
  T_48_META_API_3210_P0_D: "Takip gerçekleştiren yapay zeka varlıkları",
  T_48_META_API_3210_P1_D: "hedef",
  T_48_META_API_3211_D: "Oyuncu öğelerini yok et (kullanımdan kaldırılmıştır, DeleteEquipment kullanın)",
  T_48_META_API_3211_P0_D: "Eşyası yok edilen oyuncu",
  T_48_META_API_3211_P1_D: "İmha edilen öğenin türü",
  T_48_META_API_3211_P2_D: "Silah yuvası, sadece silah.",
  T_48_META_API_3212_D: "Forma değiştirme",
  T_48_META_API_3212_P0_D: "hedef oyuncu",
  T_48_META_API_3212_P1_D: "Giyim Tarzı",
  T_48_META_API_3212_P2_D: "Ana renkler I",
  T_48_META_API_3212_P3_D: "Ana Renk II",
  T_48_META_API_3212_P4_D: "Yapılandır",
  T_48_META_API_3213_D: "Oyuncunun formasını orijinal durumuna geri getirin",
  T_48_META_API_3213_P0_D: "hedef oyuncu",
  T_48_META_API_3214_D: "Oyuncu Sesli Sohbetini Değiştir",
  T_48_META_API_3214_P0_D: "hedef oyuncu",
  T_48_META_API_3214_P1_D: "Sesli sohbetin kapatılıp kapatılmayacağı, Doğru:Kapat Yanlış:Aç",
  T_48_META_API_3215_D: "Switch Player Hızlı Sohbet",
  T_48_META_API_3215_P0_D: "hedef oyuncu",
  T_48_META_API_3215_P1_D: "Hızlı Sohbetin kapatılıp kapatılmayacağı, Doğru:Kapat Yanlış:Aç",
  T_48_META_API_3216_D: "Hedef oyuncunun eşyaları alıp alamayacağını ayarlayın",
  T_48_META_API_3216_P0_D: "hedef oyuncu",
  T_48_META_API_3216_P1_D: "Eşyaları kaldırmanın yasak olup olmadığı, true: kaldırmak yasaktır false: kaldırmaya izin verilir",
  T_48_META_API_3217_D: "Hedef oyuncunun öğeleri atıp atamayacağını ayarlayın",
  T_48_META_API_3217_P0_D: "hedef oyuncu",
  T_48_META_API_3217_P1_D: "Öğeleri düşürmenin yasak olup olmadığı, doğru: toplamak yasaktır yanlış: toplamak mümkündür",
  T_48_META_API_3218_D: "Oyuncunun belirlenmiş yuvasındaki bir silahı yok eder",
  T_48_META_API_3218_P0_D: "hedef oyuncu",
  T_48_META_API_3218_P1_D: "İmha edilecek silah yuvaları",
  T_48_META_API_3218_P2_D: "İmha edilecek sayı",
  T_48_META_API_3218_P3_D: "İmha başarılı olsun ya da olmasın, silah yuvasında silah yoksa imha başarısız olur",
  T_48_META_API_3219_D: "Hedef oyuncunun sırt çantasını, kuşanılan eşyalar da dahil olmak üzere tüm eşyalardan boşaltır.",
  T_48_META_API_3219_P0_D: "hedef oyuncu",
  T_48_META_API_3220_D: "Oyuncu Yönünü Ayarlama",
  T_48_META_API_3220_P0_D: "hedef oyuncu",
  T_48_META_API_3220_P1_D: "Oyuncu oryantasyonu",
  T_48_META_API_3221_D: "<Player>(kullanımdan kaldırılmıştır, kullanmayın, bilgi için :Skeleton niteliğine bakın)",
  T_48_META_API_3221_P0_D: "oyuncu varlığı",
  T_48_META_API_3221_P1_D: "yakınlaştırma alanı",
  T_48_META_API_3221_P2_D: "yakınlaştırma değeri",
  T_48_META_API_3222_D: "Oyuncuya itme etkisi verin, hedef oyuncu sabit hızla düşecek ve havada çarpışma durumunda itme etkisi zorla durdurulacaktır",
  T_48_META_API_3222_P0_D: "hedef oyuncu",
  T_48_META_API_3222_P1_D: "Nakavt yönü",
  T_48_META_API_3222_P2_D: "vur-kaç zamanı",
  T_48_META_API_3222_P3_D: "Çarpma anında Y ekseninin ilk hızı",
  T_48_META_API_3222_P4_D: "Çarpma anında XZ düzlemindeki ilk hız",
  T_48_META_API_3222_P5_D: "Oyuncu yönünün değiştirilip değiştirilmeyeceği",
  T_48_META_API_3223_D: "Hedef oyuncu veya NPC'nin kostüm kimliğini al",
  T_48_META_API_3223_P0_D: "Hedef Oyuncu veya NPC",
  T_48_META_API_3223_P1_D: "Giysi türü",
  T_48_META_API_3223_R_D: "Giysi Kimliği",
  T_48_META_API_3224_D: "Hedef oyuncu veya NPC'nin kostüm kimliğini ayarlama",
  T_48_META_API_3224_P0_D: "Hedef Oyuncu veya NPC",
  T_48_META_API_3224_P1_D: "Giysi Kimliği",
  T_48_META_API_3225_D: "Hedef oyuncunun varsayılan kıyafetini geri yükler, NPC'lere uygulanamaz.",
  T_48_META_API_3225_P0_D: "hedef oyuncu",
  T_48_META_API_3226_D: "Yapay Zeka Varlığı Belirlenen Hedefe Saldırıyor",
  T_48_META_API_3226_P0_D: "Saldırıyı gerçekleştiren yapay zeka varlığı",
  T_48_META_API_3226_P1_D: "hedef",
  T_48_META_API_3227_D: "Oyuncunun silahını belirtilen yuvadaki silahla değiştirir",
  T_48_META_API_3227_P0_D: "hedef oyuncu",
  T_48_META_API_3227_P1_D: "Değiştirilecek silah yuvası",
  T_48_META_API_3227_P2_D: "Anahtarlama başarılı olsun ya da olmasın, silah yuvasında silah yoksa anahtarlama başarısız olur.",
  T_48_META_API_3228_D: "Hedef oyuncular veya NPC'ler için silah kaplamaları edinin",
  T_48_META_API_3228_P0_D: "Hedef Oyuncu veya NPC",
  T_48_META_API_3228_P1_D: "Silah Derisi Kimliği",
  T_48_META_API_3228_R_D: "Silah Derisi Kimliği",
  T_48_META_API_3229_D: "Hedef oyuncu veya NPC'nin silah görünümünü ayarlama",
  T_48_META_API_3229_P0_D: "Hedef Oyuncu veya NPC",
  T_48_META_API_3229_P1_D: "Silah Derisi Kimliği",
  T_48_META_API_3230_D: "Hedef oyuncunun varsayılan silah kaplamasını geri yükler, bu kaplama NPC'lere uygulanamaz.",
  T_48_META_API_3230_P0_D: "hedef oyuncu",
  T_48_META_API_3230_P1_D: "Silah Kimliği",
  T_48_META_API_3231_D: "Oyuncunun kıyafetini ayarlama",
  T_48_META_API_3231_P0_D: "hedef oyuncu",
  T_48_META_API_3231_P1_D: "Kıyafet Listesi",
  T_48_META_API_3232_D: "Belirtilen kostüm türündeki tüm kostümleri hedef oyuncu veya NPC'den kaldırır",
  T_48_META_API_3232_P0_D: "Hedef Oyuncu veya NPC",
  T_48_META_API_3232_P1_D: "Giysi türü",
  T_48_META_API_3233_D: "Bir oyuncunun veya NPC'nin belirlenmiş silahının derisini kaldırın",
  T_48_META_API_3233_P0_D: "Hedef Oyuncu veya NPC",
  T_48_META_API_3233_P1_D: "Silah Kimliği",
  T_48_META_API_3234_D: "Hedefe güçlendirmeler ekler",
  T_48_META_API_3234_P0_D: "Hedef varlık, buffların eklenebileceği bir varlık olmalıdır",
  T_48_META_API_3234_P1_D: "Buff kimliği",
  T_48_META_API_3235_D: "Hedeften güçlendirmeleri kaldır",
  T_48_META_API_3235_P0_D: "Hedef varlık, buffların eklenebileceği bir varlık olmalıdır",
  T_48_META_API_3235_P1_D: "Buff kimliği",
  T_48_META_API_3236_D: "Hedefin mevcut buff'ını alır",
  T_48_META_API_3236_P0_D: "Hedef varlık, buffların eklenebileceği bir varlık olmalıdır",
  T_48_META_API_3236_R_D: "Buff Listesi",
  T_48_META_API_3237_D: "Hedef oyuncunun sırt çantası aksesuar çubuğundaki eşyaları alır.",
  T_48_META_API_3237_P0_D: "hedef oyuncu",
  T_48_META_API_3237_P1_D: "Sahne Malzemeleri Listesi",
  T_48_META_API_3238_D: "Silahın belirtilen yuvasına aksesuar ekleyin, yuvayla eşleşmeyen aksesuarlar başarısız olur; eşleşen ancak kopya aksesuarlar orijinal aksesuarların yerini alacak, orijinal aksesuarlar oyuncunun sırt çantasına gönderilecek ve oyuncunun sırt çantası dolduğu",
  T_48_META_API_3238_P0_D: "hedef oyuncu",
  T_48_META_API_3238_P1_D: "ekipman çubuğu yuvası",
  T_48_META_API_3238_P2_D: "deği̇şti̇rme (parçalar)",
  T_48_META_API_3238_P3_D: `Aksesuarın başarıyla eklenip eklenmediği
 Doğru: Aksesuar ilgili yuvadaki silaha takılmıştır
 Yanlış: Aksesuar eklenememiştir ve oyuncunun sırt çantasında görünmeyecektir`,
  T_48_META_API_3238_P4_D: "Aksesuarlar eklendi, başarısızlık durumunda null",
  T_48_META_API_3239_D: "Ekipmanı sırt çantası ekipmanı sütununa alma",
  T_48_META_API_3239_P0_D: "hedef oyuncu",
  T_48_META_API_3239_P1_D: "ekipman çubuğu yuvası",
  T_48_META_API_3239_P2_D: "Belirtilen yuvadaki ekipman, donanımlı değilse boş",
  T_48_META_API_3239_P3_D: "Bu ekipman için tüm aksesuarlar",
  T_48_META_API_3240_D: "2 boyutlu bir vektör x bileşenini alır",
  T_48_META_API_3240_P0_D: "iki boyutlu vektör",
  T_48_META_API_3240_R_D: "2B vektör x-bileşeni",
  T_48_META_API_3241_D: "İki boyutlu vektörler y-bileşenini alır",
  T_48_META_API_3241_P0_D: "iki boyutlu vektör",
  T_48_META_API_3241_R_D: "2B vektörün Y bileşeni",
  T_48_META_API_3242_D: "2D vektör ayarı x-bileşeni",
  T_48_META_API_3242_P0_D: "iki boyutlu vektör",
  T_48_META_API_3242_P1_D: "2B vektör x-bileşeni",
  T_48_META_API_3243_D: "2D vektör ayarı y-bileşeni",
  T_48_META_API_3243_P0_D: "iki boyutlu vektör",
  T_48_META_API_3243_P1_D: "2B vektörün Y bileşeni",
  T_48_META_API_3244_D: "İki 2B vektörü birbirine ekleme",
  T_48_META_API_3244_P0_D: "Sol değer",
  T_48_META_API_3244_P1_D: "Sağ değer",
  T_48_META_API_3244_R_D: "2B vektör toplamı sonucu",
  T_48_META_API_3245_D: "İki 2B vektörü çıkarma",
  T_48_META_API_3245_P0_D: "Sol değer",
  T_48_META_API_3245_P1_D: "Sağ değer",
  T_48_META_API_3245_R_D: "2B vektör çıkarma sonucu",
  T_48_META_API_3246_D: "İki boyutlu vektörleri aşağıdakilerle çarpın",
  T_48_META_API_3246_P0_D: "iki boyutlu vektör",
  T_48_META_API_3246_P1_D: "2B vektör ölçekleme değerleri",
  T_48_META_API_3246_R_D: "2B vektör çarpma sonucu",
  T_48_META_API_3247_D: "İki 2B vektörü noktasal olarak çarpın, noktasal çarpmanın sonucu iki vektör arasındaki açıyı karakterize eden bir skalerdir",
  T_48_META_API_3247_P0_D: "Sol değer",
  T_48_META_API_3247_P1_D: "Sağ değer",
  T_48_META_API_3247_R_D: "Nokta çarpım sonucu",
  T_48_META_API_3248_D: "İki 2B vektör arasındaki Öklid mesafesini hesaplama",
  T_48_META_API_3248_P0_D: "Sol değer",
  T_48_META_API_3248_P1_D: "Sağ değer",
  T_48_META_API_3248_R_D: "İki vektörü çıkardıktan sonra, ortaya çıkan vektörün modülü",
  T_48_META_API_3249_D: "İki 2B vektör arasındaki açıyı hesaplama",
  T_48_META_API_3249_P0_D: "Sol değer",
  T_48_META_API_3249_P1_D: "Sağ değer",
  T_48_META_API_3249_R_D: "Vektör açısı, açı aralığı 0-180",
  T_48_META_API_3250_D: "2B vektörü normalleştirin",
  T_48_META_API_3250_P0_D: "iki boyutlu vektör",
  T_48_META_API_3250_R_D: "Vektörle aynı yönde 1 m uzunluğundaki vektörler için normalleştirilmiş sonuç",
  T_48_META_API_3251_D: "2B vektör modelleme",
  T_48_META_API_3251_P0_D: "iki boyutlu vektör",
  T_48_META_API_3251_R_D: "Modellemenin sonucu, vektör uzunluğu olarak",
  T_48_META_API_3252_D: "Normal bir dikey çizgi tarafından yansıtıldıktan sonra 2 boyutlu bir vektörün vektörünü hesaplama",
  T_48_META_API_3252_P0_D: "gelen 2B vektör",
  T_48_META_API_3252_P1_D: "Normal 2D vektör",
  T_48_META_API_3252_R_D: "Yansıtıcı 2D vektör",
  T_48_META_API_3253_D: "Normal bir dikey düzlem tarafından yansıtıldıktan sonra 3B vektörlerin hesaplanması",
  T_48_META_API_3253_P0_D: "olay 3D vektörü",
  T_48_META_API_3253_P1_D: "Normal 3B vektör",
  T_48_META_API_3253_R_D: "yansıtıcı 3D vektör",
  T_48_META_API_3254_D: "3D vektörü 2D vektöre dönüştürün, 3D vektörün Z bileşenini kaldırın",
  T_48_META_API_3254_P0_D: "Hedef 3B vektör",
  T_48_META_API_3254_R_D: "Dönüştürülmüş 2B vektör",
  T_48_META_API_3255_D: "2D vektörden 3D vektöre, 3D vektörün Z bileşeni 0 olarak ayarlanır",
  T_48_META_API_3255_P0_D: "Hedef 2B vektör",
  T_48_META_API_3255_R_D: "Dönüştürülmüş 3B vektör",
  T_48_META_API_3256_D: "2B vektör oluşturma",
  T_48_META_API_3256_P0_D: "2B vektörün x bileşeni",
  T_48_META_API_3256_P1_D: "2B vektörün Y bileşeni",
  T_48_META_API_3256_R_D: "Oluşturulan 2B vektör",
  T_48_META_API_3257_D: "Kullanıcı deneyimi veri analizi için özel yarışma gömme günlükleri",
  T_48_META_API_3257_P0_D: "log",
  T_48_META_API_3258_D: "Kullanıcı deneyimi veri analizi için özel yarışma gömme günlükleri",
  T_48_META_API_3258_P0_D: "Rapor edilen oyuncuları takip etmek için",
  T_48_META_API_3258_P1_D: "log",
  T_48_META_API_33_D: "ayıp kelimeler için filtreler",
  T_48_META_API_33_P0_D: "Kirli kelime filtrelemesi gerektiren orijinal metin",
  T_48_META_API_33_R_D: "Filtrelenmiş metin",
  T_48_META_API_3301_D: "Bir kamp varlığı oluşturun",
  T_48_META_API_3301_P0_D: "Oluşum kuruluşları",
  T_48_META_API_3302_D: "Hedef kuruluş belirlenen kampa katılır",
  T_48_META_API_3302_P0_D: "hedef varlık",
  T_48_META_API_3302_P1_D: "Oluşum kuruluşları",
  T_48_META_API_3303_D: "Saldırılabilir kamplar için kamp alma",
  T_48_META_API_3303_P0_D: "saldıran kamp",
  T_48_META_API_3303_R_D: "Kamp kuruluşlarının listesi",
  T_48_META_API_3304_D: "Kamp kurmak için saldırılabilir kamplar",
  T_48_META_API_3304_P0_D: "saldıran kamp",
  T_48_META_API_3304_P1_D: "hedef kamp",
  T_48_META_API_3304_P2_D: "Saldırılabilirlik",
  T_48_META_API_3305_D: "Saldırılabilir oyuncuları ayarlama",
  T_48_META_API_3305_P0_D: "oyuncu",
  T_48_META_API_3305_P1_D: "Saldırılabilir oyuncular",
  T_48_META_API_3305_P2_D: "Saldırılabilirlik",
  T_48_META_API_3306_D: "Takımın saldırılabilir takımını ayarlama",
  T_48_META_API_3306_P0_D: "grev ti̇mi̇",
  T_48_META_API_3306_P1_D: "hedef grup",
  T_48_META_API_3306_P2_D: "Saldırılabilirlik",
  T_48_META_API_3307_D: "terkedilmiş",
  T_48_META_API_3307_P0_D: "terkedilmiş",
  T_48_META_API_3307_R_D: "Oyuncu Varlıklarının Listesi",
  T_48_META_API_3308_D: "Belirlenen kuruluşun mevcut kamptan çekilmesi",
  T_48_META_API_3308_P0_D: "hedef varlık",
  T_48_META_API_3309_D: "Hedefin satın alınma kampı",
  T_48_META_API_3309_P0_D: "hedef varlık",
  T_48_META_API_3309_R_D: "Oluşum kuruluşları",
  T_48_META_API_3310_D: "Hedefin saldırıya uğrayıp uğramayacağını belirleyin",
  T_48_META_API_3310_P0_D: "saldırganlar",
  T_48_META_API_3310_P1_D: "hedef varlık",
  T_48_META_API_3310_R_D: "Saldırılabilirlik",
  T_48_META_API_3311_D: "Bir varlığın saldırılabilir hedeflerini ayarlama",
  T_48_META_API_3311_P0_D: "saldırganlar",
  T_48_META_API_3311_P1_D: "hedef varlık",
  T_48_META_API_3311_P2_D: "Saldırılabilirlik",
  T_48_META_API_3312_D: "Bir kuruluşun saldırılabilir hedeflerinin elde edilmesi",
  T_48_META_API_3312_P0_D: "saldırganlar",
  T_48_META_API_3312_R_D: "Saldırılabilir varlıkların listesi",
  T_48_META_API_34_D: "Hedef varlık için bir bileşenin mevcut olup olmadığını belirleme",
  T_48_META_API_34_P0_D: "hedef varlık",
  T_48_META_API_34_P1_D: "Bileşen Tipi",
  T_48_META_API_34_R_D: "Var mı",
  T_48_META_API_35_D: "Bot Ekle",
  T_48_META_API_35_P0_D: "Bot Zorluk Seviyesi",
  T_48_META_API_35_P1_D: "Bot'un ekibi",
  T_48_META_API_35_P2_D: "Oluşturulan Bot Oyuncu Varlığı",
  T_48_META_API_3500_D: "Oyuncu belirteci verilerini al",
  T_48_META_API_3500_P0_D: "hedef oyuncu",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "Jeton sayısı",
  T_48_META_API_3500_P3_D: "başarı veya başarısızlık",
  T_48_META_API_3501_D: "Oynatıcıya belirteç verisi ekleme",
  T_48_META_API_3501_P0_D: "hedef oyuncu",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "Jeton sayısı",
  T_48_META_API_3501_P3_D: "Tuple'ın başarıyla çağrılıp çağrılmadığı",
  T_48_META_API_3502_D: "Hedef oyuncu jetonunu tüket",
  T_48_META_API_3502_P0_D: "hedef oyuncu",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "Jeton sayısı",
  T_48_META_API_3502_P3_D: "Tuple'ın başarıyla çağrılıp çağrılmadığı",
  T_48_META_API_3503_D: "Belirtilen konuma bir belirteç ekleme",
  T_48_META_API_3503_P0_D: "yerleştirme",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "Jeton sayısı",
  T_48_META_API_3503_P3_D: "Tuple'ın başarıyla çağrılıp çağrılmadığı",
  T_48_META_API_3504_D: "Hedef YZ belirtilen beceriyi serbest bırakır",
  T_48_META_API_3504_P0_D: "Hedef Yapay Zeka",
  T_48_META_API_3504_P1_D: "tekniği",
  T_48_META_API_3504_P2_D: "beceri hedefi",
  T_48_META_API_3504_P3_D: "Becerinin başarılı bir şekilde serbest bırakılıp bırakılmadığı",
  T_48_META_API_3505_D: "Blokları atlayacak ve AI yol bulma için kullanılabilecek baştan sona yol bulma yolları oluşturur",
  T_48_META_API_3505_P0_D: "başlangıç noktası koordinatları",
  T_48_META_API_3505_P1_D: "hedefin koordinatları",
  T_48_META_API_3505_P2_D: "Yol bulma yolunun başarıyla oluşturulup oluşturulmadığı",
  T_48_META_API_3505_P3_D: "Yol Bulma Noktası Montajı",
  T_48_META_API_3506_D: "Davranış ağacı yazı tahtası değişkeninin ayarlanması",
  T_48_META_API_3506_P0_D: "Hedef Davranış Ağacı",
  T_48_META_API_3506_P1_D: "değişken adı",
  T_48_META_API_3506_P2_D: "değişken değeri",
  T_48_META_API_3507_D: "Davranışsal ağaç karatahta değişkenlerini alma",
  T_48_META_API_3507_P0_D: "Hedef Davranış Ağacı",
  T_48_META_API_3507_P1_D: "değişken adı",
  T_48_META_API_3507_P2_D: "değişken değeri",
  T_48_META_API_3508_D: "Davranışsal ağaç düğümü parametrelerini al",
  T_48_META_API_3508_P0_D: "Hedef davranış ağacı düğümleri",
  T_48_META_API_3508_P1_D: "parametre adı",
  T_48_META_API_3508_P2_D: "parametre değeri",
  T_48_META_API_3509_D: "Hedef oyuncunun taşıyıcı görünümünü al",
  T_48_META_API_3509_P0_D: "hedef oyuncu",
  T_48_META_API_3509_P1_D: "Taşıyıcı Kimliği",
  T_48_META_API_3509_R_D: "Taşıyıcı Cilt",
  T_48_META_API_3510_D: "Hedef oyuncunun taşıyıcı görünümünü ayarlama",
  T_48_META_API_3510_P0_D: "hedef oyuncu",
  T_48_META_API_3510_P1_D: "Taşıyıcı Cilt Kimliği",
  T_48_META_API_3511_D: "Hedef oyuncunun belirtilen araç skinini temizleyin",
  T_48_META_API_3511_P0_D: "hedef oyuncu",
  T_48_META_API_3511_P1_D: "Taşıyıcı Kimliği",
  T_48_META_API_3512_D: "Hedef oyuncunun varsayılan taşıyıcı görünümünü geri yükle",
  T_48_META_API_3512_P0_D: "hedef oyuncu",
  T_48_META_API_3512_P1_D: "Taşıyıcı Kimliği",
  T_48_META_API_36_D: "Hareketsiz hedef, sadece Dinamik tip katı cisimler için kullanılabilir.",
  T_48_META_API_36_P0_D: "hedef rijit gövde",
  T_48_META_API_37_D: "Uyandırma hedefi, sadece Dinamik tip katı cisimler üzerinde kullanılabilir.",
  T_48_META_API_37_P0_D: "hedef rijit gövde",
  T_48_META_API_38_D: "Hedef katı gövdenin hareketsiz olup olmadığını kontrol edin",
  T_48_META_API_38_P0_D: "hedef rijit gövde",
  T_48_META_API_38_R_D: "Kış uykusunda olup olmadığı",
  T_48_META_API_39_D: "Hazırda bekleme eşiğinin ayarlanması",
  T_48_META_API_39_P0_D: "hedef rijit gövde",
  T_48_META_API_39_P1_D: "Hareketsiz eşik, rijit gövdenin hareketi ve dönüşü hareketsiz duruma girmek için bir süre boyunca bu değerden daha azdır, rijit gövdenin hareketsiz durumu artık fiziksel hesaplamalar yapmayacaktır",
  T_48_META_API_4_D: "Tüm oyuncuların hareket edip edemeyeceğini ayarlayın",
  T_48_META_API_4_P0_D: `Doğru: taşınabilir 
 Yanlış: taşınamaz`,
  T_48_META_API_40_D: "Hazırda bekleme eşiğini al",
  T_48_META_API_40_P0_D: "hedef rijit gövde",
  T_48_META_API_40_R_D: "Hareketsiz eşik, rijit gövdenin hareketi ve dönüşü hareketsiz duruma girmek için bir süre boyunca bu değerden daha azdır, rijit gövdenin hareketsiz durumu artık fiziksel hesaplamalar yapmayacaktır",
  T_48_META_API_4000_D: "Tüm tablonun içeriğini okur ve satır sırasına göre iki boyutlu bir dizi döndürür",
  T_48_META_API_4000_P0_D: "tablo adı",
  T_48_META_API_4000_R_D: "Tablonun içeriği",
  T_48_META_API_4001_D: "Bir tablonun bir satırını okur ve bir dizi döndürür",
  T_48_META_API_4001_P0_D: "tablo adı",
  T_48_META_API_4001_P1_D: "1'den itibaren sayarak okunacak satır sayısı",
  T_48_META_API_4001_R_D: "Tablo, bir satırın içeriğini belirtir",
  T_48_META_API_4002_D: "Bir tablonun bir sütununun içeriğini okur ve bir dizi döndürür",
  T_48_META_API_4002_P0_D: "tablo adı",
  T_48_META_API_4002_P1_D: "1'den itibaren sayarak okunacak sütun sayısı",
  T_48_META_API_4002_R_D: "Tablo, bir sütunun içeriğini belirtir",
  T_48_META_API_4003_D: "Tablodaki bir hücrenin içeriğini okuma",
  T_48_META_API_4003_P0_D: "tablo adı",
  T_48_META_API_4003_P1_D: "1'den itibaren sayarak okunacak satır sayısı",
  T_48_META_API_4003_P2_D: "1'den itibaren sayarak okunacak sütun sayısı",
  T_48_META_API_4003_R_D: "Tablonun belirtilen hücresinin içeriği",
  T_48_META_API_4004_D: "Tablodaki bir hücrenin içeriğini satır ve sütun adına göre okuma",
  T_48_META_API_4004_P0_D: "tablo adı",
  T_48_META_API_4004_P1_D: "1'den itibaren sayarak okunacak satır sayısı",
  T_48_META_API_4004_P2_D: "Okunacak sütunun adı",
  T_48_META_API_4004_R_D: "Tablonun belirtilen hücresinin içeriği",
  T_48_META_API_4005_D: "Tüm tablonun içeriğini okur ve iki boyutlu bir dizi döndürür",
  T_48_META_API_4005_P0_D: "tablo adı",
  T_48_META_API_4005_R_D: "Tablonun içeriği, iki boyutlu bir dizi",
  T_48_META_API_4006_D: "Bir tablonun bir satırını okur ve bir dizi döndürür.",
  T_48_META_API_4006_P0_D: "tablo adı",
  T_48_META_API_4006_P1_D: "1'den itibaren sayarak okunacak satır sayısı",
  T_48_META_API_4006_R_D: "Tablo bir satırın içeriğini belirtir, bir dizi",
  T_48_META_API_4007_D: "Tüm tablonun bir sütununun içeriğini okur, dizi döndürür",
  T_48_META_API_4007_P0_D: "tablo adı",
  T_48_META_API_4007_P1_D: "1'den itibaren sayarak okunacak sütun sayısı",
  T_48_META_API_4007_R_D: "Tablo bir sütunun, dizinin içeriğini belirtir",
  T_48_META_API_4008_D: "Tablodaki bir hücrenin içeriğini okuma",
  T_48_META_API_4008_P0_D: "tablo adı",
  T_48_META_API_4008_P1_D: "1'den itibaren sayarak okunacak satır sayısı",
  T_48_META_API_4008_P2_D: "1'den itibaren sayarak okunacak sütun sayısı",
  T_48_META_API_4008_R_D: "Tablonun belirtilen hücresinin içeriği",
  T_48_META_API_4009_D: "Belirtilen satırı sütun sayısına ve hücrenin değerine göre bulur.",
  T_48_META_API_4009_P0_D: "tablo adı",
  T_48_META_API_4009_P1_D: "Okunacak sütun sayısı",
  T_48_META_API_4009_P2_D: "Bulunacak Hücre Değeri",
  T_48_META_API_4009_R_D: "Bulunan satırların içeriği, dizi",
  T_48_META_API_4010_D: "Sütun numarasını sütun adına göre al",
  T_48_META_API_4010_P0_D: "tablo adı",
  T_48_META_API_4010_P1_D: "Seri numarasının aranacağı sütunun adı",
  T_48_META_API_4010_R_D: "Sütunlar, 1'den itibaren sayılır",
  T_48_META_API_41_D: "Yalnızca Dinamik türünde yeni oluşturulan katı gövdeler için geçerli olan global uyku eşiğini ayarlar.",
  T_48_META_API_41_P0_D: "Hareketsiz eşik, rijit gövdenin hareketi ve dönüşü hareketsiz duruma girmek için bir süre boyunca bu değerden daha azdır, rijit gövdenin hareketsiz durumu artık fiziksel hesaplamalar yapmayacaktır",
  T_48_META_API_42_D: "Küresel hazırda bekleme eşiğini alın",
  T_48_META_API_42_R_D: "Hareketsiz eşik, varsayılan 0,005'tir, katı cismin hareketi ve dönüşü hareketsiz duruma girmek için belirli bir süre boyunca bu değerden daha azdır, hareketsiz katı cisim artık fiziksel hesaplamalar yapmayacaktır",
  T_48_META_API_43_D: "Verilen kuaterniyonu bir Euler açısına dönüştürür, Euler açısının dönme sırası YXZ'dir, gelen kuaterniyon yasal değilse (0,0,0) döndürür",
  T_48_META_API_43_P0_D: "Giriş kuaterniyonu",
  T_48_META_API_43_R_D: "Döndürülen Euler açıları",
  T_48_META_API_44_D: "Verilen bir Euler açısını kuaterniyona dönüştürme",
  T_48_META_API_44_P0_D: "Giriş Euler açıları",
  T_48_META_API_44_R_D: "Döndürülen kuaterniyon",
  T_48_META_API_45_D: "Eksenel açı gösterimlerinin rotasyonlarını kuaterniyonlara dönüştürme",
  T_48_META_API_45_P0_D: "dönme ekseni",
  T_48_META_API_45_P1_D: "Dönme ekseni etrafında saat yönünde dönme açısı",
  T_48_META_API_45_R_D: "Döndürülen kuaterniyon",
  T_48_META_API_46_D: "Kuaterniyonları eksenel açı gösterimlerine dönüştürme",
  T_48_META_API_46_P0_D: "Giriş kuaterniyonu",
  T_48_META_API_46_P1_D: "dönme ekseni",
  T_48_META_API_46_P2_D: "Dönme ekseni etrafında saat yönünde dönme açısı",
  T_48_META_API_47_D: "Özel görev tamamlama ilerlemesini ayarlama",
  T_48_META_API_47_P0_D: "hedef oyuncu",
  T_48_META_API_47_P1_D: "Görev Kimliği",
  T_48_META_API_47_P2_D: "Tamamlanmaya doğru ilerleme, negatif sayılara izin verilmez",
  T_48_META_API_48_D: "Hareketi enterpole etmek için kullanılabilecek bir Bezier eğrisi oluşturur",
  T_48_META_API_48_P0_D: "eğri kontrol noktası",
  T_48_META_API_48_R_D: "Bessel eğrisi",
  T_48_META_API_49_D: "Sahne haritası kimliğini al",
  T_48_META_API_49_P0_D: "Sahne Kimliği",
  T_48_META_API_49_R_D: "Harita Kimliği",
  T_48_META_API_5_D: "Sahneye yerleştirilen nesneleri silme (kullanımdan kaldırılmıştır, DeleteEntity kullanın)",
  T_48_META_API_5_P0_D: "Silinecek nesne varlıkları",
  T_48_META_API_50_D: "Her karede kendine göre hareket oluşturur, hedef varlık her karede bir kez kendi özniteliklerini değiştirir, her seferinde mevcut öznitelik değerlerine göre",
  T_48_META_API_50_P0_D: "hedef varlık",
  T_48_META_API_50_P1_D: "Hareket değişikliği gerektiren özellikler",
  T_48_META_API_50_P2_D: "Hareket başına değişim miktarı",
  T_48_META_API_50_P3_D: `Diğer hareket modları ile birlikte kullanıldığında yapılandırma
 Doğru: göreli hareket ile birlikte kullanılabilir
 Yanlış: mutlak hareket ile birlikte kullanılabilir`,
  T_48_META_API_50_P4_D: "Kendilerine göre çerçeve başına hareket varlıkları oluşturuldu",
  T_48_META_API_50_P5_D: "Oluşturulduktan sonra oynatmanın otomatik olarak başlayıp başlamayacağı",
  T_48_META_API_5000_D: "Veritabanındaki bir tabloda bir Anahtara karşılık gelen değeri okuyun.",
  T_48_META_API_5000_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_5000_P1_D: "Oyuncuları etiketleme ve eşzamanlılığı işleme",
  T_48_META_API_5000_P2_D: "Verileri tanımlamak için kullanılan özel ad",
  T_48_META_API_5000_P3_D: "Okuma sonucunu döndürür",
  T_48_META_API_5000_P4_D: "gelen savaş alanı kodu",
  T_48_META_API_5001_D: "Veritabanındaki bir tabloda bir Anahtara karşılık gelen değeri yazın.",
  T_48_META_API_5001_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_5001_P1_D: "Oyuncuları etiketleme ve eşzamanlılığı işleme",
  T_48_META_API_5001_P2_D: "Verileri tanımlamak için kullanılan özel ad",
  T_48_META_API_5001_P3_D: "Yazılan değer",
  T_48_META_API_5001_P4_D: "Boşluklara doldurulabilen veritabanına karşılık gelen savaş alanı kodu, mevcut haritanın savaş alanı kodunu temsil eder.",
  T_48_META_API_5002_D: "Veritabanındaki bir tabloda bir Anahtara karşılık gelen değeri silin.",
  T_48_META_API_5002_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_5002_P1_D: "Oyuncuları etiketleme ve eşzamanlılığı işleme",
  T_48_META_API_5002_P2_D: "Verileri tanımlamak için kullanılan özel ad",
  T_48_META_API_5002_P3_D: "gelen savaş alanı kodu",
  T_48_META_API_5003_D: "Veritabanının bir tablosundaki bir Anahtarın değerini alır.",
  T_48_META_API_5003_P0_D: "Veritabanındaki Leaderboard tablo adı",
  T_48_META_API_5003_P1_D: "Verileri tanımlamak için kullanılan özel ad",
  T_48_META_API_5003_P2_D: "Okuma sonucunu döndürür",
  T_48_META_API_5003_P3_D: "gelen savaş alanı kodu",
  T_48_META_API_5004_D: "Veritabanındaki bir grafik tablosunda bir Anahtara karşılık gelen değeri yazın.",
  T_48_META_API_5004_P0_D: "Veritabanındaki Leaderboard tablo adı",
  T_48_META_API_5004_P1_D: "Verileri tanımlamak için kullanılan özel ad",
  T_48_META_API_5004_P2_D: "Yazılan değer",
  T_48_META_API_5004_P3_D: "gelen savaş alanı kodu",
  T_48_META_API_5005_D: "Veritabanındaki bir grafik tablosunda bir Anahtara karşılık gelen değeri silin.",
  T_48_META_API_5005_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_5005_P1_D: "Verileri tanımlamak için kullanılan özel ad",
  T_48_META_API_5005_P2_D: "gelen savaş alanı kodu",
  T_48_META_API_5006_D: "Veritabanındaki bir sıralama tablosunda bir sıralamaya karşılık gelen değeri silin.",
  T_48_META_API_5006_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_5006_P1_D: "Liderlik Tablosundaki Sıralama",
  T_48_META_API_5006_P2_D: "gelen savaş alanı kodu",
  T_48_META_API_5007_D: "Veritabanındaki bir grafik tablosunda belirli bir dereceden belirli bir dereceye kadar olan değerleri okuyun.",
  T_48_META_API_5007_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_5007_P1_D: "başlangıç pozisyonu",
  T_48_META_API_5007_P2_D: "bitirme pozisyonu",
  T_48_META_API_5007_P3_D: "Okuma sonucunu döndürür",
  T_48_META_API_5007_P4_D: "gelen savaş alanı kodu",
  T_48_META_API_5008_D: "Kümülatif veritabanının bir tablosundaki bir Anahtara karşılık gelen değeri okuyun.",
  T_48_META_API_5008_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_5008_P1_D: "Verileri tanımlamak için kullanılan özel ad",
  T_48_META_API_5008_P2_D: "Okuma sonucunu döndürür",
  T_48_META_API_5008_P3_D: "gelen savaş alanı kodu",
  T_48_META_API_5009_D: "Kümülatif veritabanının bir tablosundaki bir Anahtara karşılık gelen ofset değerini yazın",
  T_48_META_API_5009_P0_D: "Veritabanındaki tablo adları",
  T_48_META_API_5009_P1_D: "Verileri tanımlamak için kullanılan özel ad",
  T_48_META_API_5009_P2_D: "Dört işlemin türleri, şu anda aşağıdaki türleri desteklemektedir: Int türü toplama, çıkarma, çarpma, bölme ve kalanı destekler; Float türü toplama, çıkarma, çarpma ve bölmeyi destekler",
  T_48_META_API_5009_P3_D: "Yazılan ofset değeri",
  T_48_META_API_5009_P4_D: "gelen savaş alanı kodu",
  T_48_META_API_51_D: "Oynatılabilir Varlığı Sıfırla, oynatma durumunu değiştirmeden oynatılabilir varlığı ilk haline geri yükler",
  T_48_META_API_51_P0_D: "Hedef Oynanabilir Varlık",
  T_48_META_API_52_D: "İki kuaterniyonu çarpmak, A*B, A'yı ve sonra B'yi döndürmek anlamına gelir. Farklı bir döndürme sırası farklı bir sonuca yol açacaktır.",
  T_48_META_API_52_P0_D: "sol değerli kuaterniyon",
  T_48_META_API_52_P1_D: "sağ değerli kuaterniyon",
  T_48_META_API_52_R_D: "Ortaya çıkan kuaterniyon",
  T_48_META_API_53_D: "Belirtilen bir yöne bakan dönen bir kuaterniyon oluşturur",
  T_48_META_API_53_P0_D: "yön belirtmek",
  T_48_META_API_53_P1_D: "yukarı doğru",
  T_48_META_API_53_R_D: "Belirtilen yönde hizalamak için gereken döndürme miktarı.",
  T_48_META_API_54_D: "A'dan B'ye kuaterniyonik küresel enterpolasyon",
  T_48_META_API_54_P0_D: "A-değeri",
  T_48_META_API_54_P1_D: "B-değeri",
  T_48_META_API_54_P2_D: "Enterpolasyon ilerlemesi, değer aralığı [0,1], değerin başlangıcına dönmek için 0 değeri, hedef değere dönmek için 1 değeri",
  T_48_META_API_54_R_D: "Ortaya çıkan kuaterniyon",
  T_48_META_API_57_D: "Hedef verileri konsola uyarı olarak yazdırır",
  T_48_META_API_57_P0_D: "Ne yazdırmalı",
  T_48_META_API_58_D: "Hedef veriyi hata mesajı olarak konsola yazdırır.",
  T_48_META_API_58_P0_D: "Ne yazdırmalı",
  T_48_META_API_59_D: "Eğri üzerinde değer elde etme",
  T_48_META_API_59_P0_D: "dolambaçlı bir şekilde",
  T_48_META_API_59_P1_D: "Örnekleme noktası, değer aralığı [0,1]",
  T_48_META_API_59_R_D: "Sonunda",
  T_48_META_API_6_D: "Belirtilen koordinatlarda sahne nesneleri oluşturur",
  T_48_META_API_6_P0_D: "Oluşturulan Sahne Nesnesi Varlıkları",
  T_48_META_API_6_P1_D: "Nesne Oluşturma Konumu",
  T_48_META_API_6_P2_D: "Kod komut dosyalarında kullanılmak üzere önceden varlık kayıt defterine kaydedilmesi gereken, oluşturulan nesne türünün kimliği.",
  T_48_META_API_60_D: "Eğrilere dayalı enterpolasyon",
  T_48_META_API_60_P0_D: "değer türü",
  T_48_META_API_60_P1_D: "başlangıç değeri",
  T_48_META_API_60_P2_D: "hedef değer",
  T_48_META_API_60_P3_D: "dolambaçlı bir şekilde",
  T_48_META_API_60_P4_D: "Örnekleme noktası, değer aralığı [0,1]",
  T_48_META_API_60_R_D: "Sonunda",
  T_48_META_API_6000_D: "Hedef varlıklara komut dosyası ekleme",
  T_48_META_API_6000_P0_D: "hedef varlık",
  T_48_META_API_6000_P1_D: "Senaryo Kimliği",
  T_48_META_API_6001_D: "Hedef varlıklar için komut dosyalarını boşaltma",
  T_48_META_API_6001_P0_D: "hedef varlık",
  T_48_META_API_6001_P1_D: "Senaryo Kimliği",
  T_48_META_API_6002_D: "Hedef varlık için belirtilen komut dosyasının var olup olmadığını kontrol eder",
  T_48_META_API_6002_P0_D: "hedef varlık",
  T_48_META_API_6002_P1_D: "Senaryo Kimliği",
  T_48_META_API_6002_R_D: "Belirtilen komut dosyasının varlığı",
  T_48_META_API_61_D: "UI denetiminin üst düğümünü ayarlama",
  T_48_META_API_61_P0_D: "Üst düğüm, UI kontrolü veya özel UI belirtebilir",
  T_48_META_API_61_P1_D: "çocuk düğümü",
  T_48_META_API_62_D: "terkedilmiş",
  T_48_META_API_62_P0_D: "terkedilmiş",
  T_48_META_API_62_P1_D: "terkedilmiş",
  T_48_META_API_62_P2_D: "terkedilmiş",
  T_48_META_API_62_P3_D: "terkedilmiş",
  T_48_META_API_62_P4_D: "terkedilmiş",
  T_48_META_API_63_D: "Geçerli kameradan ekran dokunma noktasına bir ışın oluşturma",
  T_48_META_API_63_P0_D: "ekran teması",
  T_48_META_API_63_P1_D: "eşik",
  T_48_META_API_63_P2_D: "ışın yönü",
  T_48_META_API_64_D: "Özelleştirilmiş fatura bilgilerini yükleme",
  T_48_META_API_64_P0_D: "oyuncu varlığı",
  T_48_META_API_64_P1_D: "yarışma sonuçları",
  T_48_META_API_64_P2_D: "integral başlık (bilgi işlem)",
  T_48_META_API_64_P3_D: "puan değeri",
  T_48_META_API_65_D: "Belirtilen ses efektini çalın ve ayarlamanız gereken daha fazla özellik varsa varlık özelliklerini ayarlayın.",
  T_48_META_API_65_P0_D: "Ses varlıkları oluşturuldu",
  T_48_META_API_65_P1_D: "Hedef oyuncu, sadece hedef oyuncu ses efektlerini duyabilir",
  T_48_META_API_65_P2_D: "Ses efekti türü",
  T_48_META_API_65_P3_D: "Döngü tipi",
  T_48_META_API_65_P4_D: "Hemen oynayıp oynamamak",
  T_48_META_API_66_D: "Belirtilen görsel efekti oluşturur ve ayarlanacak daha fazla öznitelik varsa varlık özniteliklerini ayarlar.",
  T_48_META_API_66_P0_D: "Oluşturulan özel efekt varlıkları",
  T_48_META_API_66_P1_D: "Hedeflenen oyuncular, sadece hedeflenen oyuncular tarafından görülebilir",
  T_48_META_API_66_P2_D: "Özel efekt türü",
  T_48_META_API_66_P3_D: "Döngü tipi",
  T_48_META_API_66_P4_D: "Hemen oynayıp oynamamak",
  T_48_META_API_67_D: "Belirtilen ses efektini oluşturur ve ayarlanacak daha fazla özellik varsa varlık özelliklerini ayarlar.",
  T_48_META_API_67_P0_D: "Ses varlıkları oluşturuldu",
  T_48_META_API_67_P1_D: "Ses efekti türü",
  T_48_META_API_67_P2_D: "Döngü tipi",
  T_48_META_API_67_P3_D: "Hemen oynayıp oynamamak",
  T_48_META_API_68_D: "Dünya koordinatlarının ekran koordinatlarına dönüştürülmesi",
  T_48_META_API_68_P0_D: "dünya koordinatı",
  T_48_META_API_68_P1_D: "Ekran içinde eşlenip eşlenmediği",
  T_48_META_API_68_P2_D: "haritalama konumu",
  T_48_META_API_69_D: "Ekran koordinatlarından dünya koordinatlarına",
  T_48_META_API_69_P0_D: "ekran koordinatı",
  T_48_META_API_69_P1_D: "Ekrana olan uzaklık",
  T_48_META_API_69_P2_D: "dünya koordinatı",
  T_48_META_API_7_D: "Hedef değeri dizeye dönüştür",
  T_48_META_API_7_P0_D: "Dönüştürülecek dizenin hedef değeri",
  T_48_META_API_7_R_D: "string",
  T_48_META_API_70_D: "Ekran dokunuşuyla ışın algılama ilk vurulan varlığı döndürür",
  T_48_META_API_70_P0_D: "Başlangıç Ekranı Kişiler",
  T_48_META_API_70_P1_D: "Algılama mesafesi",
  T_48_META_API_70_P2_D: "Katman maskesi, sadece dolu katmanlar taramaya katılacaktır, boş bırakılması tüm katmanların taramaya katılması anlamına gelir",
  T_48_META_API_70_P3_D: "Tetikleyicinin tespit edilip edilemeyeceği",
  T_48_META_API_70_P4_D: "varlık vurmak",
  T_48_META_API_70_P5_D: "vuruş noktası koordinatları",
  T_48_META_API_70_P6_D: "Vuruş noktasının başlangıç noktasına uzaklığı",
  T_48_META_API_70_P7_D: "yüzey normaline çarptı",
  T_48_META_API_71_D: "Ekran dokunuşuyla ışın algılama, vurulan tüm varlıkları döndürür",
  T_48_META_API_71_P0_D: "Başlangıç Ekranı Dokunma Noktası",
  T_48_META_API_71_P1_D: "Algılama mesafesi",
  T_48_META_API_71_P2_D: "Katman maskesi, sadece dolu katmanlar taramaya katılacaktır, boş bırakılması tüm katmanların taramaya katılması anlamına gelir",
  T_48_META_API_71_P3_D: "Tetikleyicinin tespit edilip edilemeyeceği",
  T_48_META_API_71_P4_D: "İsabet alan kuruluşların listesi",
  T_48_META_API_71_P5_D: "Vuruş noktası koordinatlarının listesi",
  T_48_META_API_71_P6_D: "Vuruş noktası ile başlangıç ​​noktası arasındaki mesafelerin listesi",
  T_48_META_API_71_P7_D: "Vurulan yüzey normallerinin listesi",
  T_48_META_API_72_D: "Belirtilen görsel efekti oluşturur ve ayarlanacak daha fazla öznitelik varsa varlık özniteliklerini ayarlar.",
  T_48_META_API_72_P0_D: "Oluşturulan özel efekt varlıkları",
  T_48_META_API_72_P1_D: "Özel efekt türü",
  T_48_META_API_72_P2_D: "Döngü tipi",
  T_48_META_API_72_P3_D: "Hemen oynayıp oynamamak",
  T_48_META_API_73_D: "Diğer istemcilerle senkronize edilmeyen yerleşik bir kullanıcı arayüzü oluşturma",
  T_48_META_API_73_P0_D: "Oluşturulan yerleşik kullanıcı arayüzü varlıkları",
  T_48_META_API_73_P1_D: "Yerleşik kullanıcı arayüzü türleri",
  T_48_META_API_74_D: "Diğer istemcilerle senkronize edilmeyen özel bir kullanıcı arayüzü oluşturma",
  T_48_META_API_74_P0_D: "Özel kullanıcı arayüzü varlıkları oluşturuldu",
  T_48_META_API_74_P1_D: "Özel UI Dizini",
  T_48_META_API_75_D: "Geçerli istemcinin ilgili oyuncusunu alın",
  T_48_META_API_75_R_D: "oyuncu varlığı",
  T_48_META_API_76_D: "Yapay Zeka Canavarları Yaratmak",
  T_48_META_API_76_P0_D: "Hedef Yapay Zeka",
  T_48_META_API_76_P1_D: "Konum Oluştur",
  T_48_META_API_76_P2_D: "AI tipi",
  T_48_META_API_76_P3_D: "BAĞLI EKİP",
  T_48_META_API_76_P4_D: "düşmanı otomatik olarak talep edip etmemek",
  T_48_META_API_76_P5_D: "saldırı modu",
  T_48_META_API_76_P6_D: "Seyahat güzergahı",
  T_48_META_API_77_D: "Vektörün ilk bileşenini ayarlayın",
  T_48_META_API_77_P0_D: "vektörler",
  T_48_META_API_77_P1_D: "İlk bileşen değeri",
  T_48_META_API_77_R_D: "İlk bileşeni değiştirdikten sonra vektör",
  T_48_META_API_78_D: "Vektörün ikinci bileşenini ayarlayın",
  T_48_META_API_78_P0_D: "vektörler",
  T_48_META_API_78_P1_D: "İkinci bileşen değeri",
  T_48_META_API_78_R_D: "İkinci bileşeni değiştirdikten sonra vektör",
  T_48_META_API_79_D: "Vektörün üçüncü bileşenini ayarlayın",
  T_48_META_API_79_P0_D: "vektörler",
  T_48_META_API_79_P1_D: "Üçüncü bileşen değeri",
  T_48_META_API_79_R_D: "Üçüncü bileşeni değiştirdikten sonra vektör",
  T_48_META_API_8_D: "Merkez koordinat noktasına doğru daralan güvenlik bölgesini açın.",
  T_48_META_API_8_P0_D: "Güvenlik bölgesinin merkez noktası",
  T_48_META_API_8_P1_D: "Güvenlik bölgesinin yarıçapı",
  T_48_META_API_8_P2_D: "Güvenlik bölgesinin merkez noktaya doğru küçülmeye başlayacağı saniye cinsinden bekleme süresi",
  T_48_META_API_8_P3_D: "Güvenlik bölgesinin merkez noktasına küçülmesi için gereken süre, saniye cinsinden",
  T_48_META_API_8_P4_D: "Güvenli bölge dışında alınan saniye başına hasar miktarı",
  T_48_META_API_80_D: "2B vektörün ilk bileşenini ayarlayın",
  T_48_META_API_80_P0_D: "iki boyutlu vektör",
  T_48_META_API_80_P1_D: "İlk bileşen değeri",
  T_48_META_API_80_R_D: "İlk bileşen değiştirildikten sonraki 2B vektör",
  T_48_META_API_81_D: "2B vektörün ikinci bileşenini ayarlayın",
  T_48_META_API_81_P0_D: "iki boyutlu vektör",
  T_48_META_API_81_P1_D: "İkinci bileşen değeri",
  T_48_META_API_81_R_D: "İkinci bileşen değiştirildikten sonraki 2B vektör",
  T_48_META_API_82_D: "Karakter denetleyicisini belirtilen konuma taşı, eğer oyuncuya etki ederse, oyuncunun fizik etkisini kullanan oyuncu denetleyicisini açması gerekir",
  T_48_META_API_82_P0_D: "Hedef Rol Denetleyicisi",
  T_48_META_API_82_P1_D: "belirlenmiş yer",
  T_48_META_API_83_D: "Hedef üst varlığın belirtilen alt düğümünü ada göre alır",
  T_48_META_API_83_P0_D: "ana kuruluş",
  T_48_META_API_83_P1_D: "Alt düğüm adı",
  T_48_META_API_83_R_D: "çocuk varlık",
  T_48_META_API_84_D: "AOI'ye özel dikkat gösterin ve mesafeden bağımsız olarak her zaman senkronize edin",
  T_48_META_API_84_P0_D: "Özel ilgi gösterilmesi gereken hedefler",
  T_48_META_API_84_P1_D: "gözlemci",
  T_48_META_API_85_D: "AOI özel dikkatini kaldırın ve görüş dışı AOI senkronizasyonunu iptal edin",
  T_48_META_API_85_P0_D: "Özel ilgi gösterilmesi gereken hedefler",
  T_48_META_API_85_P1_D: "gözlemci",
  T_48_META_API_86_D: "Belirtilen hedef için tüm AOI özel endişelerini temizleyin.",
  T_48_META_API_86_P0_D: "Özel ilgi gösterilmesi gereken hedefler",
  T_48_META_API_87_D: "Özel bir AOI endişesi olup olmadığını belirleyin",
  T_48_META_API_87_P0_D: "Özel ilgi gösterilmesi gereken hedefler",
  T_48_META_API_87_P1_D: "terkedilmiş",
  T_48_META_API_87_R_D: "Var mı",
  T_48_META_API_88_D: "Oyuncunun proxy gözlemcisini değiştirme",
  T_48_META_API_88_P0_D: "oyuncu",
  T_48_META_API_88_P1_D: "vekil gözlemci",
  T_48_META_API_89_D: "Karakter kumandasını bir kez yerinden çıkarır ve oyuncuya etki ederse, oyuncunun fizik etkisini kullanan oyuncu kumandasını açması gerekir",
  T_48_META_API_89_P0_D: "Hedef nesne veya bir oyuncu söz konusu olduğunda, oyuncunun fiziksel efektleri kullanan bir oyuncu denetleyicisinin efektin etkili olması için açık olması gerekir",
  T_48_META_API_89_P1_D: "yer değiştirme vektörü",
  T_48_META_API_9_D: "Güvenli bölge mekanizmasını kapatın, güvenli bölge minimuma indirildiğinde, güvenli bölge dışındaki oyuncular hasar almaya devam eder, güvenli bölge mekanizması kapatıldıktan sonra oyuncular güvenliğe geri döner",
  T_48_META_API_90_D: "Oyuncunun serbestçe çıkıp çıkamayacağını ayarlayın",
  T_48_META_API_90_P0_D: "hedef oyuncu",
  T_48_META_API_90_P1_D: "Geri çekilme özgürlüğü",
  T_48_META_API_9000_D: "Yalnızca belirli oyuncular tarafından görülebilen yerleşik bir kullanıcı arayüzü oluşturun",
  T_48_META_API_9000_P0_D: "Oluşturulan yerleşik kullanıcı arayüzü varlıkları",
  T_48_META_API_9000_P1_D: "Kullanıcı arayüzünün ait olduğu oyuncu varlığı, sadece o oyuncu tarafından görülebilir",
  T_48_META_API_9000_P2_D: "Yerleşik kullanıcı arayüzü türleri",
  T_48_META_API_9001_D: "Yerleşik oyun kullanıcı arayüzünü kaldırın",
  T_48_META_API_9001_P0_D: "Kaldırılacak yerleşik kullanıcı arayüzü varlıkları",
  T_48_META_API_9002_D: "Belirtilen simge türüne sahip bir simge oluşturur ve ayarlanması gereken daha fazla özellik olduğunda, varlık özelliklerini varlık aracılığıyla ayarlar (kullanımdan kaldırılmıştır, CreateLevelObject kullanın)",
  T_48_META_API_9002_P0_D: "Kodda, simgeyi oluşturan varlığı temsil etmek için kullanılan resmi parametrenin adı ve buna karşılık gelen yerel değişken değeri simgeyi oluşturan varlıktır",
  T_48_META_API_9002_P1_D: "Ait olduğu oyuncu varlığı, sadece o oyuncu tarafından görülebilir",
  T_48_META_API_9002_P2_D: "Kaynak yolu, oyuncu tarafından seçilen simgeye karşılık gelen kaynak yolu",
  T_48_META_API_9003_D: "Belirtilen simgeyi kaldırın (kullanımdan kaldırılmıştır, DeleteEntity kullanın)",
  T_48_META_API_9003_P0_D: "Kaldırılacak simge varlığı",
  T_48_META_API_9004_D: "Belirtilen metin içeriğine sahip bir metin oluşturur ve ayarlanacak daha fazla nitelik olduğunda, varlık aracılığıyla varlık niteliklerini de ayarlar (kullanımdan kaldırılmıştır, lütfen CreateLevelObject kullanın)",
  T_48_META_API_9004_P0_D: "Kodda, metni oluşturan varlığı temsil etmek için kullanılan resmi parametrenin adı ve buna karşılık gelen yerel değişken değeri metni oluşturan varlıktır",
  T_48_META_API_9004_P1_D: "Ait olduğu oyuncu varlığı, sadece o oyuncu tarafından görülebilir",
  T_48_META_API_9004_P2_D: "Sunulacak metin içeriği",
  T_48_META_API_9005_D: "Belirtilen metni kaldırın (kullanımdan kaldırılmıştır, DeleteEntity kullanın)",
  T_48_META_API_9005_P0_D: "Kaldırılacak metin varlıkları",
  T_48_META_API_9006_D: "Belirtilen efekt türüne sahip bir simge oluşturur ve ayarlanması gereken daha fazla özellik olduğunda, varlık özelliklerini varlık aracılığıyla daha fazla ayarlar (kullanımdan kaldırılmıştır, lütfen CreateEffect kullanın)",
  T_48_META_API_9006_P0_D: "Kodda, efekti oluşturan varlığı temsil etmek için kullanılan resmi parametrenin adı ve buna karşılık gelen yerel değişkenin değeri efekti oluşturan varlıktır.",
  T_48_META_API_9006_P1_D: "Ait olduğu oyuncu varlığı, sadece o oyuncu tarafından görülebilir",
  T_48_META_API_9006_P2_D: "Efekt türleri, oyuncuların seçebileceği efekt türleri",
  T_48_META_API_9007_D: "Belirtilen etkiyi kaldırın (kullanımdan kaldırılmıştır, DeleteEntity kullanın)",
  T_48_META_API_9007_P0_D: "Kaldırılacak etki varlığı",
  T_48_META_API_9008_D: "Yalnızca belirli oyuncular tarafından görülebilen özel bir kullanıcı arayüzü oluşturun",
  T_48_META_API_9008_P0_D: "Özel kullanıcı arayüzü varlıkları oluşturuldu",
  T_48_META_API_9008_P1_D: "Kullanıcı arayüzünün ait olduğu oyuncu varlığı, sadece o oyuncu tarafından görülebilir",
  T_48_META_API_9008_P2_D: "Özel UI Dizini",
  T_48_META_API_9009_D: "Özel oyun kullanıcı arayüzünü kaldırma",
  T_48_META_API_9009_P0_D: "Kaldırılacak özel kullanıcı arayüzü varlıkları",
  T_48_META_API_9010_D: "Özel bir kullanıcı arayüzünden kullanıcı arayüzü denetimleri alma",
  T_48_META_API_9010_P0_D: "Kullanıcı arayüzünün ait olduğu oyuncu varlığı",
  T_48_META_API_9010_P1_D: "Özel UI varlıkları",
  T_48_META_API_9010_P2_D: "Benzersiz Dizini Kontrol Et",
  T_48_META_API_9010_R_D: "UI kontrol varlığı",
  T_48_META_API_9011_D: "Belirtilen sesi çalın ve ayarlanması gereken daha fazla özellik varsa, varlık özelliklerini varlık aracılığıyla daha fazla ayarlayın (kullanımdan kaldırılmıştır, lütfen CreateSound kullanın)",
  T_48_META_API_9011_P0_D: "Kodda, ses efektini oluşturan varlığı temsil etmek için kullanılan resmi parametrenin adı ve buna karşılık gelen yerel değişken değeri, ses efektini oluşturan varlıktır",
  T_48_META_API_9011_P1_D: "Ait olduğu oyuncu varlığı, sadece o oyuncu tarafından görülebilir",
  T_48_META_API_9011_P2_D: "Ses türleri, oyuncunun seçebileceği ses efektleri türleri",
  T_48_META_API_9012_D: "Belirtilen ses efektini kaldırın (kullanımdan kaldırılmıştır, DeleteEntity kullanın)",
  T_48_META_API_9012_P0_D: "Kaldırılacak ses varlıkları",
  T_48_META_API_9013_D: "Bir yol kullanarak özel bir kullanıcı arayüzünden kullanıcı arayüzü kontrolü alma",
  T_48_META_API_9013_P0_D: "Kullanıcı arayüzünün ait olduğu oyuncu varlığı",
  T_48_META_API_9013_P1_D: "Özel Kullanıcı Arayüzü",
  T_48_META_API_9013_P2_D: "Kontrol Yolu",
  T_48_META_API_9013_R_D: "UI kontrol varlığı",
  T_48_META_API_9014_D: "Kesintili oynatmada ses varlığı (kullanımdan kaldırılmıştır, PauseSound kullanın)",
  T_48_META_API_9014_P0_D: "Askıya alınması gereken ses varlıkları",
  T_48_META_API_9015_D: "İsteğe bağlı olarak baştan ses çalmayı sürdürme (kullanımdan kaldırılmıştır, ResumeSound kullanın)",
  T_48_META_API_9015_P0_D: "Duraklatıldıktan sonra çalmaya devam etmesi gereken ses varlıkları",
  T_48_META_API_9015_P1_D: "Sıfırdan başlanıp başlanmayacağı",
  T_48_META_API_9016_D: "Özel UI Kontrolleri Oluşturma",
  T_48_META_API_9016_P0_D: "Oluşturulan özel kontrol varlıkları",
  T_48_META_API_9016_P1_D: "Oluşturulan kontrol türü",
  T_48_META_API_9016_P2_D: "Bağlı UI kuruluşları",
  T_48_META_API_9016_P3_D: "Üst kontrol, doldurulmazsa, UI varlığı üst düğüm olacaktır.",
  T_48_META_API_9017_D: "Hedef kamera katmanı maskesini ayarlama",
  T_48_META_API_9017_P0_D: "hedef kamera varlığı",
  T_48_META_API_9017_P1_D: "Katman maskesi, hedef kamerada yalnızca dolu katmanlar gösterilecektir, boş bırakılması tüm katmanların gösterileceği anlamına gelir.",
  T_48_META_API_9018_D: "Hedef kamera katmanı maskesini al",
  T_48_META_API_9018_P0_D: "hedef kamera varlığı",
  T_48_META_API_9018_R_D: "Katman maskesi, hedef kamerada yalnızca katman maskesi içindeki katmanlar gösterilir",
  T_48_META_API_9019_D: "Belirtilen seviyenin hedef kameraya görünür olup olmadığını ayarlar",
  T_48_META_API_9019_P0_D: "hedef kamera varlığı",
  T_48_META_API_9019_P1_D: "Görünürlük Hiyerarşisi",
  T_48_META_API_9019_P2_D: "görünürlük",
  T_48_META_API_9020_D: "Hedef oyuncunun varsayılan arayüz durumunu ayarlama",
  T_48_META_API_9020_P0_D: "hedef oyuncu",
  T_48_META_API_9020_P1_D: "Oyuncuyu ve oyuncuyla ilgili içeriği manipüle etmek için kullanılan UI öğeleri olan oyuncu arayüzü türleri",
  T_48_META_API_9020_P2_D: "Anahtar değeri, oyuncunun arayüzünün görünürlüğünü belirler",
  T_48_META_API_9021_D: "Bir zaman damgası yerelleştirme dizesi oluşturun",
  T_48_META_API_9021_P0_D: "zaman damgası",
  T_48_META_API_9021_P1_D: "Biçimlendirme stilleri",
  T_48_META_API_9021_R_D: "Zaman Damgası Yerelleştirme Dizesi",
  T_48_META_API_9022_D: "Mini harita simgesi oluşturma",
  T_48_META_API_9022_P0_D: "Zihin haritası simge varlıkları oluşturuldu",
  T_48_META_API_9022_P1_D: "Ait olduğunuz oyuncu, yalnızca o oyuncu tarafından görülebilen bir mini harita simgesi oluşturur.",
  T_48_META_API_9022_P2_D: "Zihin Haritası Simgesi Kaynak Yolu",
  T_48_META_API_9023_D: "Belirtilen efekt türüne sahip bir simge oluşturur ve ayarlanması gereken daha fazla özellik varsa varlık aracılığıyla varlık özelliklerini ayarlar.",
  T_48_META_API_9023_P0_D: "Kodda, efekti oluşturan varlığı temsil etmek için kullanılan resmi parametrenin adı ve buna karşılık gelen yerel değişkenin değeri efekti oluşturan varlıktır.",
  T_48_META_API_9023_P1_D: "Ait olduğu oyuncu varlığı, sadece o oyuncu tarafından görülebilir",
  T_48_META_API_9023_P2_D: "Efekt türleri, oyuncuların seçebileceği efekt türleri",
  T_48_META_API_9024_D: "Belirtilen etkiyi kaldırın (kullanımdan kaldırılmıştır, DeleteEntity kullanın)",
  T_48_META_API_9024_P0_D: "Kaldırılacak etki varlığı",
  T_48_META_API_9025_D: "Hedef nesne için harita üzerinde hedef nesneyle birlikte hareket etmeyen statik pikseller oluşturur.",
  T_48_META_API_9025_P0_D: "Statik piksel varlıkları oluşturuldu",
  T_48_META_API_9025_P1_D: "Ait olduğu oyuncu, yalnızca o oyuncu tarafından görülebilen statik pikseller oluşturur",
  T_48_META_API_9025_P2_D: "hedef nesne varlığı",
  T_48_META_API_9026_D: "Hedef oyuncunun mini harita varlığını alır",
  T_48_META_API_9026_P0_D: "hedef oyuncu",
  T_48_META_API_9026_R_D: "Mevcut Oyuncu Mini Haritası",
  T_48_META_API_9027_D: "Oyuncunun düşme hasarını ayarlayın, yükseklik segmentlerine göre farklı hasar ayarlayabilir",
  T_48_META_API_9027_P0_D: "hedef oyuncu",
  T_48_META_API_9027_P1_D: "Yükseklik Segmentli Liste",
  T_48_META_API_9027_P2_D: "Hasar segmentlerinin listesi",
  T_48_META_API_91_D: "Bir hedefin belirli bir takıma eklenmesi, hedefin daha önce üyesi olduğu takımdan ayrılmasına neden olacaktır.",
  T_48_META_API_91_P0_D: "Ekibe eklenmesi gereken hedefler",
  T_48_META_API_91_P1_D: "Ekibe katılın",
  T_48_META_API_91_P2_D: "başarı veya başarısızlık",
  T_48_META_API_92_D: "Bir hedefin yeni oluşturulan bir ekibe eklenmesi, hedefin daha önce bulunduğu ekipten düşmesine neden olacaktır.",
  T_48_META_API_92_P0_D: "Ekibe eklenmesi gereken hedefler",
  T_48_META_API_92_P1_D: "Yeni ekibin adı",
  T_48_META_API_92_P2_D: "başarı veya başarısızlık",
  T_48_META_API_94_D: "Yerel bir değişkenin değerini dizine göre ayarlayın; ayarlamadan önce değişkenin geçerli çağrı sürecinde tanımlanması gerekir",
  T_48_META_API_94_P0: "Dizin",
  T_48_META_API_94_P0_D: "Bir değişkeni dizine göre al",
  T_48_META_API_94_P1: "Değişken Değer",
  T_48_META_API_94_P1_D: "Hedef değişken değeri",
  T_48_META_API_94_P2: "Aritmetik Tip",
  T_48_META_API_94_P2_D: "İşlem yöntemi; tüm tipler atamayı destekler ve sayısal tipler ayrıca artırma, azaltma, çarpma, bölme ve modül işlemlerini destekler",
  T_48_META_API_94_P3: "Değişken Adı",
  T_48_META_API_94_P3_D: "Hedef değişken adı. Yalnızca hata çıktısı için kullanılır",
  T_48_META_API_95: "Dizinle Yerel Değişkeni Al",
  T_48_META_API_95_D: "Yerel bir değişkenin değerini alın; almadan önce değişkenin geçerli çağrı sürecinde tanımlanmış olması gerekir",
  T_48_META_API_95_P0: "Dizin",
  T_48_META_API_95_P0_D: "Değişken endeks",
  T_48_META_API_95_P1: "Değişken Adı",
  T_48_META_API_95_P1_D: "Hedef değişken adı. Yalnızca hata çıktısı için kullanılır",
  T_48_META_API_9500_D: "Hedef oynatıcıyı bilgilendiren istemci tarafı oynatma efektleri",
  T_48_META_API_9500_P0_D: "hedef oyuncu",
  T_48_META_API_9500_P1_D: "Özel Efektler Kaynak Yolu",
  T_48_META_API_9500_P2_D: "renk",
  T_48_META_API_9500_P3_D: "Yakınlaştırma boyutu, varsayılan 1",
  T_48_META_API_9500_P4_D: "Etkilerin alt düğümleri olarak eklendiği bağlı nesne",
  T_48_META_API_9500_P5_D: "Bağlı nesneye göre dünya koordinatlarında ofset",
  T_48_META_API_9501_D: "Hedef oyuncunun istemcisini bir ses efekti çalması için bilgilendirin",
  T_48_META_API_9501_P0_D: "hedef oyuncu",
  T_48_META_API_9501_P1_D: "Ses efekti türü",
  T_48_META_API_9502_D: "Hedef oyuncunun istemcisine kayan karakterleri görüntülemesi için bildirimde bulunun",
  T_48_META_API_9502_P0_D: "hedef oyuncu",
  T_48_META_API_9502_P1_D: "Float kelimesinin içeriği",
  T_48_META_API_9502_P2_D: "Kayan Karakter Rengi, Tip Rengi",
  T_48_META_API_9502_P3_D: "Milisaniye cinsinden kayan kelime süresi",
  T_48_META_API_9503_D: "Hedef birimin bir kez Duygu eylem ifadesi oynamasını sağlayın",
  T_48_META_API_9503_P0_D: "Play Emote'un hedefleri",
  T_48_META_API_9503_P1_D: "İfade türü",
  T_48_META_API_9504_D: "Birimin İfade hareketi ifadesini duraklatın/devam ettirin",
  T_48_META_API_9504_P0_D: "Emote'un hedeflerini askıya alma/devam ettirme",
  T_48_META_API_9504_P1_D: "True: Oynatmayı duraklat, False: Oynatmayı sürdür",
  T_48_META_EVT_1_D: "Oyunun başlangıcında tetiklendiğinde, sunucu istemciden bir süre önce hazır olacaktır",
  T_48_META_EVT_10_D: "Geçerli varlık hasar almadan önce tetiklenir",
  T_48_META_EVT_10_P0_D: "Saldırgan varlık, muhtemelen null",
  T_48_META_EVT_10_P1_D: "Hasar türü",
  T_48_META_EVT_10_P2_D: "Verilen hasar miktarı",
  T_48_META_EVT_10_P3_D: "yaralı parça",
  T_48_META_EVT_1000_D: "Oyuncu puanları değiştiğinde tetiklenir",
  T_48_META_EVT_1000_P0_D: "Puanlarında değişiklik olan oyuncular",
  T_48_META_EVT_1000_P1_D: "Değişim noktası türleri",
  T_48_META_EVT_1000_P2_D: "İntegral değişiminden sonra integral değeri",
  T_48_META_EVT_1001_D: "Takım puanları değiştiğinde tetiklenir",
  T_48_META_EVT_1001_P0_D: "Puanlarında değişiklik olan takımlar",
  T_48_META_EVT_1001_P1_D: "Değişim noktası türleri",
  T_48_META_EVT_1001_P2_D: "İntegral değişiminden sonra integral değeri",
  T_48_META_EVT_1002_D: "Oyuncu sıralaması değiştiğinde tetiklenir",
  T_48_META_EVT_1002_P0_D: "Sıralaması değişen oyuncular",
  T_48_META_EVT_1002_P1_D: "Sıralamadaki değişiklikten sonraki sıralama",
  T_48_META_EVT_1003_D: "terkedilmiş",
  T_48_META_EVT_1003_P0_D: "terkedilmiş",
  T_48_META_EVT_1003_P1_D: "Sıralamadaki değişiklikten sonraki sıralama",
  T_48_META_EVT_11_D: "Oyuncu maçın yarısında çıktığında tetiklenir",
  T_48_META_EVT_11_P0_D: "Maçın yarısında çıkan oyuncu",
  T_48_META_EVT_12_D: "Oyuncu kontrolörü bir varlığa dokunduğunda tetiklenir ve yalnızca kontrolör aktif olarak harekete geçtiğinde tetiklenir",
  T_48_META_EVT_12_P0_D: "Karşılaşılan varlıklar",
  T_48_META_EVT_13_D: "Geçerli varlık hasar vermeden önce tetiklenir",
  T_48_META_EVT_13_P0_D: "Zarar gören kuruluşlar",
  T_48_META_EVT_13_P1_D: "Hasar türü",
  T_48_META_EVT_13_P2_D: "Verilen hasar miktarı",
  T_48_META_EVT_13_P3_D: "yaralı parça",
  T_48_META_EVT_14_D: "Oynatılabilir bir varlık her döndüğünde tetiklenen bu olay, yalnızca oynatılabilir varlık bir ses, efekt vb. varlıksa istemci tarafında çalışır.",
  T_48_META_EVT_2_D: "Mantık çerçevesi güncellendiğinde tetiklenir, platforma ve ayarlara bağlı olarak bu olayın sıklığı değişebilir.",
  T_48_META_EVT_2002_D: "Oyuncu öldüğünde tetiklenir",
  T_48_META_EVT_2002_P0_D: "Ölü oyuncular",
  T_48_META_EVT_2003_D: "Oyuncu asistlerinde tetiklenir",
  T_48_META_EVT_2003_P0_D: "Asist yapan oyuncular",
  T_48_META_EVT_2003_P1_D: "Öldürülen oyuncular",
  T_48_META_EVT_2004_D: "Oyuncu hasar verdiğinde tetiklenir",
  T_48_META_EVT_2004_P0_D: "Hasarı yapan oyuncu",
  T_48_META_EVT_2004_P1_D: "hasarlı oynatıcı",
  T_48_META_EVT_2004_P2_D: "Hasar türü",
  T_48_META_EVT_2004_P3_D: "hasar miktarı",
  T_48_META_EVT_2004_P4_D: "yaralı parça",
  T_48_META_EVT_2005_D: "Bir oyuncu bir öldürme gerçekleştirdiğinde tetiklenir",
  T_48_META_EVT_2005_P0_D: "öldürmeye neden olan oyuncu",
  T_48_META_EVT_2005_P1_D: "Öldürülen oyuncular",
  T_48_META_EVT_2005_P2_D: "Hasar türü",
  T_48_META_EVT_2006_D: "Bir oyuncu oyuna katıldığında tetiklenir",
  T_48_META_EVT_2006_P0_D: "Oyuna katılan oyuncular",
  T_48_META_EVT_2007_D: "Oyuncu yeniden canlandırıldığında tetiklenir",
  T_48_META_EVT_2007_P0_D: "Dirilen oyuncular",
  T_48_META_EVT_2007_P1_D: "Diriliş kaynakları",
  T_48_META_EVT_2008_D: "Bir oyuncu yere düştüğünde tetiklenir",
  T_48_META_EVT_2008_P0_D: "Nakavt Edilmiş Oyuncu",
  T_48_META_EVT_2008_P1_D: "SALDIRGAN",
  T_48_META_EVT_2009_D: "Oyuncu bağlantısı kesildiğinde tetiklenir",
  T_48_META_EVT_2009_P0_D: "Bağlantısı kesilen oyuncular",
  T_48_META_EVT_2010_D: "Oyuncu yeniden bağlandığında tetiklenir",
  T_48_META_EVT_2010_P0_D: "Yeniden bağlanan oyuncular",
  T_48_META_EVT_2100_D: "Ekip kaldırıldığında tetiklenir",
  T_48_META_EVT_2100_P0_D: "Kaldırılan ekipler",
  T_48_META_EVT_2101_D: "Bir ekip eklendiğinde tetiklenir",
  T_48_META_EVT_2101_P0_D: "Eklenen ekipler",
  T_48_META_EVT_2102_D: "Ekip grup tarafından yok edildiğinde tetiklenir",
  T_48_META_EVT_2102_P0_D: "Alay tarafından yok edilen ekip",
  T_48_META_EVT_3_D: "Oyun sonunda ve sunucuda oyun sona ermeden önce tetiklenir",
  T_48_META_EVT_30_D: "Sahne başarıyla yüklendiğinde tetiklenir",
  T_48_META_EVT_30_P0_D: "sahne adı",
  T_48_META_EVT_3000_D: "Geçerli varlık oluşturulduktan sonra tetiklenir",
  T_48_META_EVT_3001_D: "Geçerli varlık yok edilmeden önce tetiklenir",
  T_48_META_EVT_3002_D: "Oyuncu tetiğe girdiğinde tetiklenir",
  T_48_META_EVT_3002_P0_D: "Tetikleyiciye giren oyuncular",
  T_48_META_EVT_3003_D: "Oyuncu tetikleyiciden ayrıldığında tetiklenir",
  T_48_META_EVT_3003_P0_D: "Oyuncular tetikten ayrılıyor",
  T_48_META_EVT_3004_D: "UI düğme kontrolüne tıklandıktan sonra tetiklenir",
  T_48_META_EVT_3004_P0_D: "Tıklayan Oyuncular",
  T_48_META_EVT_3005_D: "Yerleşik kullanıcı arayüzünde bir düğmeye tıklandığında tetiklenir",
  T_48_META_EVT_3005_P0_D: "Tıklanacak düğme kontrolünün adı",
  T_48_META_EVT_3006_D: "Oyuncu su kayağı kullandığında tetiklenir",
  T_48_META_EVT_3007_D: "Geçerli varlık kullanılabilir olduktan sonra tetiklenir",
  T_48_META_EVT_3008_D: "Geçerli varlık kullanılamaz hale geldikten sonra tetiklenir",
  T_48_META_EVT_3009_D: "Bir varlık bir tetikleyiciye girdiğinde tetiklenir. Bir tetikleyici olayı tetiklendiğinde, her iki taraf da olayı alır. Bir taraf katı bir gövde olmalı ve diğer taraf bir tetikleyici olmalıdır. Özellikle, tetikleyici özel bir tetikleyici nesnesi olduğunda, yalnızca tetikleyici olayı alır.",
  T_48_META_EVT_3009_P0_D: "Tetikleyici olay sırasında karşıt kuruluş",
  T_48_META_EVT_3010_D: "Varlık tetikleyiciden ayrıldığında tetiklenir. Olay tetiklendiğinde, her iki taraf da olayı alır. Bir taraf katı bir gövde olmalı ve diğer taraf bir tetikleyici olmalıdır. Özellikle, tetikleyici özel bir tetikleyici nesnesi olduğunda, yalnızca tetikleyici olayı alır.",
  T_48_META_EVT_3010_P0_D: "Tetikleyici olay sırasında karşıt kuruluş",
  T_48_META_EVT_3011_D: "Geçerli varlık yok edildiğinde tetiklenir",
  T_48_META_EVT_3011_P0_D: "Saldırgan varlık, muhtemelen null",
  T_48_META_EVT_3011_P1_D: "Hasar türü",
  T_48_META_EVT_3011_P2_D: "yaralı parça",
  T_48_META_EVT_3012_D: "Mevcut varlık saldırıya uğradıktan sonra tetiklenir",
  T_48_META_EVT_3012_P0_D: "Saldırgan varlık, muhtemelen null",
  T_48_META_EVT_3012_P1_D: "Hasar türü",
  T_48_META_EVT_3012_P2_D: "Verilen hasar miktarı",
  T_48_META_EVT_3012_P3_D: "yaralı parça",
  T_48_META_EVT_3013_D: "Geçerli varlık hasar verdikten sonra tetiklenir",
  T_48_META_EVT_3013_P0_D: "Zarar gören kuruluşlar",
  T_48_META_EVT_3013_P1_D: "Hasar türü",
  T_48_META_EVT_3013_P2_D: "Verilen hasar miktarı",
  T_48_META_EVT_3013_P3_D: "yaralı parça",
  T_48_META_EVT_3014_D: "Geçerli varlık başka bir varlığı yok ettikten sonra tetiklenir",
  T_48_META_EVT_3014_P0_D: "Elimine edilen kuruluşlar",
  T_48_META_EVT_3014_P1_D: "yaralı parça",
  T_48_META_EVT_3015_D: "Bu oyuncu yeniden dirildiğinde tetiklenir",
  T_48_META_EVT_3015_P0_D: "Oyuncu türü diriliş kaynağı",
  T_48_META_EVT_3016_D: "Üreteç bir varlık oluşturduğunda tetiklenir",
  T_48_META_EVT_3016_P0_D: "Oluşturulan varlıkların listesi",
  T_48_META_EVT_3016_P1_D: "dalga sayısı",
  T_48_META_EVT_3017_D: "Oyuncu nakavt diz çökme pozisyonuna girdiğinde çağrılır",
  T_48_META_EVT_3018_D: "Tüm ekip üyeleri öldüğünde tetiklenir",
  T_48_META_EVT_3019_D: "Bir kask, vücut zırhı veya sırt çantası takıldığında tetiklenir",
  T_48_META_EVT_3019_P0_D: "Ekipman Kimliği",
  T_48_META_EVT_3020_D: "Yumruğa geçiş de dahil olmak üzere birincil, ikincil veya yakın dövüş silahı tutarken tetiklenir",
  T_48_META_EVT_3020_P0_D: "Tetikleme sırasında donatılmış silah varlığı",
  T_48_META_EVT_3021_D: "Sahne malzemelerinin kullanımından sonra tetiklenir, kullanımı zaman gerektiren sahne malzemeleri kullanım tamamlandıktan sonra bu olayı tetikler",
  T_48_META_EVT_3021_P0_D: "Sahne Kimliği",
  T_48_META_EVT_3021_P1_D: "Props varlığı, muhtemelen null",
  T_48_META_EVT_3021_P2_D: "Proplar kullanılarak oluşturulan yeni prop varlığı, boş olabilir",
  T_48_META_EVT_3022_D: "Bir öğe edinildiğinde tetiklenir",
  T_48_META_EVT_3022_P0_D: "Ürün tipi",
  T_48_META_EVT_3022_P1_D: "Nesne varlığı, muhtemelen null",
  T_48_META_EVT_3023_D: "Varlık noktaları değiştiğinde tetiklenir",
  T_48_META_EVT_3023_P0_D: "Değişim noktası türleri",
  T_48_META_EVT_3023_P1_D: "İntegral değişiminden sonra integral değeri",
  T_48_META_EVT_3024_D: "Varlık sıralaması değiştiğinde tetiklenir",
  T_48_META_EVT_3024_P0_D: "Sıralamadaki değişiklikten sonraki sıralama",
  T_48_META_EVT_3025_D: "Bir asist üzerine tetiklenir",
  T_48_META_EVT_3025_P0_D: "vurmak",
  T_48_META_EVT_3026_D: "Sürücü ve yolcu olarak da dahil olmak üzere bir varlık bir araca girdiğinde tetiklenir",
  T_48_META_EVT_3026_P0_D: "Taşıyıcıya giren kuruluşlar",
  T_48_META_EVT_3026_P1_D: "Taşıyıcılar girdi",
  T_48_META_EVT_3027_D: "Varlık taşıyıcıdan ayrıldığında tetiklenir",
  T_48_META_EVT_3027_P0_D: "Taşıyıcıdan ayrılan kuruluşlar",
  T_48_META_EVT_3027_P1_D: "Kalkış yapan taşıyıcılar",
  T_48_META_EVT_3028_D: "Fiziksel olarak bir taşıyıcıyı sürerken, sürücü olarak bir arabadayken tetiklenir",
  T_48_META_EVT_3028_P0_D: "Taşıyıcıyı yönlendiren kuruluş",
  T_48_META_EVT_3028_P1_D: "Sürülen araçlar",
  T_48_META_EVT_3029_D: "Taşıyıcıya fiziksel olarak girildiğinde tetiklenir",
  T_48_META_EVT_3029_P0_D: "tetikleyen varlık",
  T_48_META_EVT_3030_D: "Taşıyıcı ayrıldığında tetiklenir",
  T_48_META_EVT_3030_P0_D: "tetikleyen varlık",
  T_48_META_EVT_3031_D: "Araç bir varlık tarafından sürüldüğünde tetiklenir",
  T_48_META_EVT_3031_P0_D: "tetikleyen varlık",
  T_48_META_EVT_3032_D: "Bir varlık bir portal kullandığında ışınlanma gerçekleştikten sonra tetiklenir (kullanımdan kaldırılmıştır, OnBouncesOffTire kullanın)",
  T_48_META_EVT_3032_P0_D: "Portalı kullanan kuruluşlar",
  T_48_META_EVT_3032_P1_D: "Kullanılan portal",
  T_48_META_EVT_3033_D: "Varlık sıçradığında tetiklenir",
  T_48_META_EVT_3033_P0_D: "tetikleyen varlık",
  T_48_META_EVT_3033_P1_D: "Kullanılan zıplayan nesneler",
  T_48_META_EVT_3034_D: "Portal varlığın ışınlanmasını sağladıktan sonra tetiklenir",
  T_48_META_EVT_3034_P0_D: "ileten varlık",
  T_48_META_EVT_3035_D: "Lastik varlığı zıplattıktan sonra tetiklenir",
  T_48_META_EVT_3035_P0_D: "açılır varlık",
  T_48_META_EVT_3036_D: "Bir makine uçan bir varlık gönderdiğinde tetiklenir",
  T_48_META_EVT_3036_P0_D: "devrilen varlık",
  T_48_META_EVT_3036_P1_D: "makine tarafından oluşturulan nesne",
  T_48_META_EVT_3037_D: "Varlık tetikleyiciye girdiğinde ateşlenir",
  T_48_META_EVT_3037_P0_D: "Giriş için tetikleyici",
  T_48_META_EVT_3038_D: "Varlık tetikleyiciden ayrıldığında ateşlenir",
  T_48_META_EVT_3038_P0_D: "Ayrılmak için tetikleyici",
  T_48_META_EVT_3039_D: "Bir silah varlığı edinildiğinde tetiklenir",
  T_48_META_EVT_3039_P0_D: "silah varlığı",
  T_48_META_EVT_3040_D: "Bir varlık bir makine tarafından yere düşürüldüğünde tetiklenir",
  T_48_META_EVT_3040_P0_D: "devrilen varlık",
  T_48_META_EVT_3040_P1_D: "makine tarafından oluşturulan nesne",
  T_48_META_EVT_3041_D: "Hedeflenebilir bir varlık hedeflendiğinde tetiklenir",
  T_48_META_EVT_3041_P0_D: "Hedeflenen kuruluşlar",
  T_48_META_EVT_3042_D: "Bir oyuncu tarafından hedef alındığında tetiklenir",
  T_48_META_EVT_3042_P0_D: "Oyuncuları hedefleme",
  T_48_META_EVT_3043_D: "Mermi hedefe isabet ettiğinde tetiklenir",
  T_48_META_EVT_3043_P0_D: "vurmak",
  T_48_META_EVT_3043_P1_D: "Kurşun çarpma konumlarının dünya koordinatları",
  T_48_META_EVT_3044_D: "Bir silah tarafından vurulduğunda tetiklenir",
  T_48_META_EVT_3044_P0_D: "SİLAHLAR",
  T_48_META_EVT_3044_P1_D: "Vurulan bölgenin dünya koordinatları",
  T_48_META_EVT_3045_D: "Oyuncu o seviye için bir nesneye dönüşmeyi seçtiğinde tetiklenir",
  T_48_META_EVT_3045_P0_D: "Oyuncu bir varlığa dönüşür, sahne nesnesinin kendisine değil",
  T_48_META_EVT_3046_D: "Bir oyuncu o diriliş noktasında dirildiğinde tetiklenir",
  T_48_META_EVT_3046_P0_D: "Bu diriliş noktasında diriltilen oyuncular",
  T_48_META_EVT_3047_D: "Bir oyuncu bir silah attığında tetiklenir",
  T_48_META_EVT_3047_P0_D: "Düşen silah varlıkları",
  T_48_META_EVT_3048_D: "Bir oyuncu silah dışında bir eşya attığında tetiklenir",
  T_48_META_EVT_3048_P0_D: "Ürün tipi",
  T_48_META_EVT_3048_P1_D: "Nesne varlığı, muhtemelen null",
  T_48_META_EVT_3049_D: "Bir futbol silahıyla vurulduğunda tetiklenir",
  T_48_META_EVT_3049_P0_D: "oyuncu",
  T_48_META_EVT_3049_P1_D: "Vurulduktan sonraki hız",
  T_48_META_EVT_3050_D: "Futbol topu ve katı madde arasındaki çarpışmada tetiklenir",
  T_48_META_EVT_3050_P0_D: "çarpışma nesnesi",
  T_48_META_EVT_3050_P1_D: "Çarpışma sonrası hız",
  T_48_META_EVT_3051_D: "Bir oyuncu bir ses kanalına başarıyla katıldığında tetiklenir",
  T_48_META_EVT_3051_P0_D: "ses kanalı varlığı",
  T_48_META_EVT_3052_D: "Bir oyuncu bir ses kanalına katılamadığında tetiklenir",
  T_48_META_EVT_3052_P0_D: "ses kanalı varlığı",
  T_48_META_EVT_3053_D: "Bir oyuncu bir ses kanalından çıktığında tetiklenir",
  T_48_META_EVT_3053_P0_D: "ses kanalı varlığı",
  T_48_META_EVT_3054_D: "Top kaleye girdiğinde tetiklenir",
  T_48_META_EVT_3054_P0_D: "kale ağzı",
  T_48_META_EVT_3054_P1_D: "Golcü, kaleye gitmeden önce topa son dokunan oyuncu",
  T_48_META_EVT_3054_P2_D: "Asistanlar, gol atılmadan önce topa dokunan sondan ikinci oyuncu",
  T_48_META_EVT_3055_D: "Oyuncu ateş düğmesine bastığında tetiklenir",
  T_48_META_EVT_3056_D: "Oyuncu zıpladığında tetiklenir",
  T_48_META_EVT_3057_D: "Oyuncu çömeldiğinde tetiklenir",
  T_48_META_EVT_3058_D: "Oyuncu yere düştüğünde tetiklenir",
  T_48_META_EVT_3059_D: "Oyuncu depar attığında tetiklenir",
  T_48_META_EVT_3060_D: "Mağazada bir öğe başarıyla satın alındığında tetiklenir",
  T_48_META_EVT_3060_P0_D: "Mal satın alan oyuncular",
  T_48_META_EVT_3060_P1_D: "mal",
  T_48_META_EVT_3061_D: "Silah oyuncu tarafından kuşanıldığında tetiklenir",
  T_48_META_EVT_3061_P0_D: "Silahlarla donatılmış oyuncular",
  T_48_META_EVT_3062_D: "Bir birim bu silahla öldürüldüğünde tetiklenir",
  T_48_META_EVT_3062_P0_D: "Öldürülen varlıklar",
  T_48_META_EVT_3063_D: "Bir birime hasar vermek için bu silah kullanıldığında tetiklenir",
  T_48_META_EVT_3063_P0_D: "yaralanan kurum",
  T_48_META_EVT_3063_P1_D: "hasar miktarı",
  T_48_META_EVT_3064_D: "Silah mermi değiştirdiğinde tetiklenir",
  T_48_META_EVT_3065_D: "Bir varlık taşıyıcıya sürücü veya yolcu olarak girdiğinde tetiklenir",
  T_48_META_EVT_3065_P0_D: "Taşıyıcılar girdi",
  T_48_META_EVT_3066_D: "Varlık taşıyıcıdan ayrıldığında tetiklenir",
  T_48_META_EVT_3066_P0_D: "Kalkış yapan taşıyıcılar",
  T_48_META_EVT_3067_D: "Taşıyıcı fiziksel olarak sürülürken tetiklenir",
  T_48_META_EVT_3067_P0_D: "Sürülen araçlar",
  T_48_META_EVT_3068_D: "Bir varlık bir portal kullandığında ışınlanma gerçekleştikten sonra tetiklenir",
  T_48_META_EVT_3068_P0_D: "Kullanılan portal",
  T_48_META_EVT_3069_D: "Bir varlık bir lastik tarafından sektirildiğinde tetiklenir",
  T_48_META_EVT_3069_P0_D: "Kullanılan lastikler",
  T_48_META_EVT_3070_D: "Bir varlık bir makine tarafından yere düşürüldüğünde tetiklenir",
  T_48_META_EVT_3070_P0_D: "makine tarafından oluşturulan nesne",
  T_48_META_EVT_3071_D: "Oyuncu tarafından bir UI düğmesi kontrolüne basıldıktan sonra tetiklenir",
  T_48_META_EVT_3071_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3072_D: "UI düğmesi kontrolü kaldırıldığında tetiklenir",
  T_48_META_EVT_3072_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3073_D: "Oyuncu tarafından bir UI düğmesi kontrolüne çift tıklandığında tetiklenir",
  T_48_META_EVT_3073_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3074_D: "Jailbreak alanı başlangıcı",
  T_48_META_EVT_3075_D: "Hapishane kaçış alanı kapalı",
  T_48_META_EVT_3076_D: "Oyuncu su kayaklarını kullanmayı bıraktığında tetiklenir",
  T_48_META_EVT_3077_D: "UI giriş kutusu kontrolünün metin içeriği oyuncu tarafından değiştirildiğinde tetiklenir",
  T_48_META_EVT_3077_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3077_P1_D: "Değiştirilen metin içeriği",
  T_48_META_EVT_3078_D: "Oynanabilir varlık oynamaya başladığında tetiklenir",
  T_48_META_EVT_3078_P0_D: "oynanabilir varlık",
  T_48_META_EVT_3079_D: "Oynatılabilir bir varlık oynatmayı bitirdiğinde tetiklenen bu olay, yalnızca oynatılabilir varlık bir ses, efekt vb. varlıksa istemci tarafında çalışır.",
  T_48_META_EVT_3079_P0_D: "oynanabilir varlık",
  T_48_META_EVT_3080_D: "Oynanabilir varlık oynamaya devam ettiğinde tetiklenir",
  T_48_META_EVT_3080_P0_D: "oynanabilir varlık",
  T_48_META_EVT_3081_D: "Oynatılabilir bir varlık oynatmayı duraklattığında tetiklenir",
  T_48_META_EVT_3081_P0_D: "oynanabilir varlık",
  T_48_META_EVT_3082_D: "Jailbreak oyuncuları katılıyor",
  T_48_META_EVT_3082_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3083_D: "Jailbreak oyuncuları işi bıraktı",
  T_48_META_EVT_3083_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3084_D: "Geri sayımın sonunda tetiklenir",
  T_48_META_EVT_3084_P0_D: "bağlı kuruluş",
  T_48_META_EVT_3085_D: "Bir öğe alındığında tetiklenir",
  T_48_META_EVT_3085_P0_D: "Eşyaları toplayan oyuncular",
  T_48_META_EVT_3086_D: "Bir öğe atıldığında tetiklenir",
  T_48_META_EVT_3086_P0_D: "Öğeyi düşüren oyuncu",
  T_48_META_EVT_3087_D: "Bu öğe kuşanıldığında tetiklenir",
  T_48_META_EVT_3088_D: "Maden oluşturulduktan sonra nesne başlatıldığında tetiklenir",
  T_48_META_EVT_3089_D: "Maden oluşturulduktan sonra nesne tetiklendiğinde tetiklenir",
  T_48_META_EVT_3089_P0_D: "Maden oluşturulduktan sonra nesnelerin hedeflenmesi tetiklenir",
  T_48_META_EVT_3090_D: "Bir mağazada bir ürün satın almadan önce tetiklenir",
  T_48_META_EVT_3090_P0_D: "Mal satın alan oyuncular",
  T_48_META_EVT_3090_P1_D: "mal",
  T_48_META_EVT_3091_D: "Bu cihaz kullanıldığında tetiklenir",
  T_48_META_EVT_3092_D: "Kanca kilidi tabancası ateşlendiğinde tetiklenir",
  T_48_META_EVT_3093_D: "Mermi fırlatıldıktan sonra patladığında tetiklenir.",
  T_48_META_EVT_3093_P0_D: "patlama noktası",
  T_48_META_EVT_3094_D: "Paintball silahı ile vurulduğunda tetiklenir",
  T_48_META_EVT_3094_P0_D: "Boya püskürtme tabancası varlıkları",
  T_48_META_EVT_3094_P1_D: "vuruş noktası",
  T_48_META_EVT_3094_P2_D: "hedef çizgisini vurmak",
  T_48_META_EVT_3095_D: "Boya tabancası ile vurulduğunda tetiklenir",
  T_48_META_EVT_3095_P0_D: "nesneyi vur",
  T_48_META_EVT_3095_P1_D: "vuruş noktası",
  T_48_META_EVT_3095_P2_D: "hedef çizgisini vurmak",
  T_48_META_EVT_3096_D: "Bir taşıyıcı veya boya kovası patladığında tetiklenir",
  T_48_META_EVT_3096_P0_D: "Patlamaya neden olan oyuncu",
  T_48_META_EVT_3096_P1_D: "Patlamadan etkilenen oyuncuların listesi",
  T_48_META_EVT_3097_D: "Silah ateşlemeyi durdurduğunda tetiklenir",
  T_48_META_EVT_3097_P0_D: "Ateşkes sırasında mevcut şarjör kapasitesi",
  T_48_META_EVT_3098_D: "Takip eden hedef takip menziline girdiğinde tetiklenir",
  T_48_META_EVT_3099_D: "Takip eden hedef takip menzilinden çıktığında tetiklenir",
  T_48_META_EVT_31_D: "Başarılı sahne geçişinde tetiklenir",
  T_48_META_EVT_31_P0_D: "sahne adı",
  T_48_META_EVT_3100_D: "Saldırının hedefi saldırı menziline girdiğinde tetiklenir",
  T_48_META_EVT_3101_D: "Saldırının hedefi menzil dışına çıktığında tetiklenir",
  T_48_META_EVT_3102_D: "Kamera ışını algılaması bir istemci tıklama olayı tarafından tetiklendiğinde tetiklenir",
  T_48_META_EVT_3102_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3102_P1_D: "Kamera ışınının nesneye çarpıp çarpmadığı",
  T_48_META_EVT_3102_P2_D: "Kamera ışını isabet konumu",
  T_48_META_EVT_3102_P3_D: "İstemci Kamera Yönü",
  T_48_META_EVT_3102_P4_D: "Müşteri Kamera Konumu",
  T_48_META_EVT_3102_P5_D: "hedefi vurmak",
  T_48_META_EVT_3103_D: "Mağaza ekranı açıldığında tetiklenir",
  T_48_META_EVT_3103_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3104_D: "Mağaza ekranı kapatıldığında tetiklenir",
  T_48_META_EVT_3104_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3105_D: "Davranış ağacı mantığı düğüme girdiğinde tetiklenir",
  T_48_META_EVT_3105_P0_D: "Düğüm adı",
  T_48_META_EVT_3105_P1_D: "bağlı kuruluş",
  T_48_META_EVT_3106_D: "Davranış ağacı mantığı düğümden çıktığında tetiklenir",
  T_48_META_EVT_3106_P0_D: "Düğüm adı",
  T_48_META_EVT_3106_P1_D: "bağlı kuruluş",
  T_48_META_EVT_3107_D: "Sert bir cisim uyandırıldığında tetiklenir",
  T_48_META_EVT_3108_D: "Katı cisim uykuya geçtiğinde tetiklenir",
  T_48_META_EVT_3109_D: "Oyuncu hareket ettiğinde tetiklenir",
  T_48_META_EVT_3109_P0_D: "Uvertürler",
  T_48_META_EVT_3110_D: "Oynatıcı beklemedeyken tetiklenir",
  T_48_META_EVT_3110_P0_D: "Uvertürler",
  T_48_META_EVT_3111_D: "Oyuncu bir beceri kullandığında tetiklenir",
  T_48_META_EVT_3111_P0_D: "Kullanılan beceriler",
  T_48_META_EVT_3112_D: "Oyuncu sprint atmayı bitirdiğinde tetiklenir",
  T_48_META_EVT_3113_D: "SwitchEquipSlot numaralandırması altındaki yuvaya karşılık gelen öğe elde edildiğinde tetiklenir.",
  T_48_META_EVT_3113_P0_D: "Satın alınan kalem kuruluşları",
  T_48_META_EVT_3114_D: "Yumruklara geçiş de dahil olmak üzere elde tutulan eşyalar değiştirilirken tetiklenir",
  T_48_META_EVT_3114_P0_D: "Geçişten sonra elde tutulan kalem varlıkları",
  T_48_META_EVT_3115_D: "Dükkandaki bir oyuncu birinden bir eşya satın almasını istediğinde tetiklenir",
  T_48_META_EVT_3115_P0_D: "Ürün talep eden oyuncular",
  T_48_META_EVT_3115_P1_D: "mal",
  T_48_META_EVT_3116_D: "Dükkandaki bir oyuncu bir eşya istediğinde ve istek kabul edildiğinde tetiklenir.",
  T_48_META_EVT_3116_P0_D: "Satın alınan oyuncular için yardım",
  T_48_META_EVT_3116_P1_D: "Satın alma işlemlerinde yardım isteyen oyuncular",
  T_48_META_EVT_3116_P2_D: "mal",
  T_48_META_EVT_3117_D: "Saniyede 30 kez sabit bir frekansta sabit çerçeve güncellemelerinde tetiklenir",
  T_48_META_EVT_3118_D: "Oyunu Duraklat API'sine yapılan bir çağrıdan sonra tetiklenir",
  T_48_META_EVT_3119_D: "Oyunu Geri Yükle API'sine yapılan bir çağrıdan sonra tetiklenir",
  T_48_META_EVT_3120_D: "Bir oyuncu arkadaş eklediğinde veya sildiğinde tetiklenir",
  T_48_META_EVT_3121_D: "Persona mesajı alındığında tetiklenir",
  T_48_META_EVT_3121_P0_D: "Bilgi içeriği",
  T_48_META_EVT_3121_P1_D: "Gönderen Persona",
  T_48_META_EVT_3122_D: "Bir oyuncunun zıplamasının sonunda tetiklenir",
  T_48_META_EVT_3123_D: "Oyuncu düştüğünde tetiklenir",
  T_48_META_EVT_3124_D: "Bir oyuncunun düşüşünün sonunda tetiklenir",
  T_48_META_EVT_3125_D: "Persona davranışının alınması üzerine tetiklenir",
  T_48_META_EVT_3125_P0_D: "davranış",
  T_48_META_EVT_3125_P1_D: "Gönderen Persona",
  T_48_META_EVT_3126_D: "Üye bilgileri değiştiğinde tetiklenir",
  T_48_META_EVT_3126_P0_D: "Üyenin değişen durumu",
  T_48_META_EVT_3127_D: "Üye Merkezine girildiğinde tetiklenir",
  T_48_META_EVT_3128_D: "Üye Merkezinden çıkarken tetiklenir",
  T_48_META_EVT_3129_D: "Oyuncu yere düşme durumuna girdiğinde tetiklenir",
  T_48_META_EVT_3129_P0_D: "Saldırgan varlık, muhtemelen null",
  T_48_META_EVT_3130_D: "Persona durumu alındığında tetiklenir",
  T_48_META_EVT_3130_P0_D: "Gönderen Persona",
  T_48_META_EVT_3130_P1_D: "hata kodu",
  T_48_META_EVT_3131_D: "Persona'ya kullanıcı arayüzü üzerinden mesaj gönderildiğinde tetiklenir",
  T_48_META_EVT_3131_P0_D: "Bilgi içeriği",
  T_48_META_EVT_3131_P1_D: "Gönderen Persona",
  T_48_META_EVT_3132_D: "Persona almanın sonunda tetiklenir",
  T_48_META_EVT_3132_P0_D: "Gönderen Persona",
  T_48_META_EVT_3132_P1_D: "hata kodu",
  T_48_META_EVT_32_D: "Oyuncu sahne değiştirdiğinde tetiklenir",
  T_48_META_EVT_32_P0_D: "sahne adı",
  T_48_META_EVT_3200_D: "Animasyon klibi oynatmayı bitirdiğinde tetiklenir",
  T_48_META_EVT_3200_P0_D: "Animasyonlu segmentin adı",
  T_48_META_EVT_3201_D: "Animasyon durumu oynatmayı bitirdiğinde tetiklenir",
  T_48_META_EVT_3201_P0_D: "Animasyon durumu adı",
  T_48_META_EVT_3204_D: "Toggle kontrolünün durumu değiştiğinde tetiklenir.",
  T_48_META_EVT_3204_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3204_P1_D: "durum tespiti",
  T_48_META_EVT_3260_D: "Oyuncu tarafından dokunmatik yüzeye basıldığında tetiklenir",
  T_48_META_EVT_3260_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3260_P1_D: "Basın pozisyonu",
  T_48_META_EVT_3261_D: "Dokunmatik yüzey kaldırıldığında tetiklenir",
  T_48_META_EVT_3261_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3261_P1_D: "Kaldırma pozisyonu",
  T_48_META_EVT_3262_D: "Dokunmatik yüzey kaymaya başladığında tetiklenir",
  T_48_META_EVT_3262_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3262_P1_D: "Slayt Konumunu Başlat",
  T_48_META_EVT_3263_D: "Dokunmatik yüzey slaytında tetiklenen bu olay, slayt sırasında her kare için bir kez tetiklenir",
  T_48_META_EVT_3263_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3263_P1_D: "Slayt Konumunu Başlat",
  T_48_META_EVT_3263_P2_D: "yer değiştirme",
  T_48_META_EVT_3264_D: "Dokunmatik yüzey kaydırmasının sonunda tetiklenir",
  T_48_META_EVT_3264_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3264_P1_D: "Son Kaydırak Konumu",
  T_48_META_EVT_3265_D: "JoyStick'e basıldığında tetiklenir",
  T_48_META_EVT_3265_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3266_D: "JoyStick kaldırıldığında tetiklenir",
  T_48_META_EVT_3266_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3267_D: "JoyStick joystick kullanıldığında tetiklenir",
  T_48_META_EVT_3267_P0_D: "tetikleyici oyuncu",
  T_48_META_EVT_3267_P1_D: "Çıkış Deplasmanı",
  T_48_META_EVT_3268_D: "Oyuncu başka bir duruştan ayağa kalktığında tetiklenir",
  T_48_META_EVT_3268_P0_D: "Oyuncunun ayağa kalkmadan önceki duruşu",
  T_48_META_EVT_3269_D: "Silah ateşlendiğinde tetiklenir",
  T_48_META_EVT_4_D: "Her turun başında tetiklenir",
  T_48_META_EVT_4_P0_D: "0'dan itibaren sayılan yuvarlak indeks",
  T_48_META_EVT_5_D: "Her turun sonunda tetiklenir",
  T_48_META_EVT_5_P0_D: "0'dan itibaren sayılan yuvarlak indeks",
  T_48_META_EVT_6_D: "Bir varlık çarpıştığında tetiklenir, yalnızca Sert Gövde bileşeni takılı olan varlıklar tarafından desteklenir.",
  T_48_META_EVT_6_P0_D: "Karşılaşılan varlıklar",
  T_48_META_EVT_7_D: "Her aşamanın başında tetiklenir",
  T_48_META_EVT_7_P0_D: "adım varlığı",
  T_48_META_EVT_8_D: "Her aşamanın sonunda tetiklenir",
  T_48_META_EVT_8_P0_D: "adım varlığı",
  T_48_META_EVT_9_D: "Bir varlık çarpışmasının sonunda tetiklenir, yalnızca üzerlerinde Sert Gövde bileşeni bulunan varlıklar tarafından desteklenir.",
  T_48_META_EVT_9_P0_D: "Karşılaşılan varlıklar",
  T_49_META_TYP_10_I1_D: "Etiket Listesi",
  T_49_META_TYP_10_I2_D: "Mevcut mu?",
  T_49_META_TYP_10_I3_D: "Tüm üst düğümler mevcut mu?",
  T_49_META_TYP_10_I4_D: "Sahnede mevcut mu?",
  T_49_META_TYP_10_I5_D: "Mantık güncellemesinin etkinleştirilip etkinleştirilmeyeceği. Devre dışı bırakıldığında, varlıktaki betik her karede güncellemeyi durduracaktır.",
  T_49_META_TYP_10_I6_D: "Kuruluş Adı",
  T_49_META_TYP_10_I7_D: "Alan filtre seçeneği, 0 otomatik hesaplamanın kontrol edilip edilmediği, 1 kontrol edilmediği ve her zaman senkronize edildiği, 2 kontrol edildiği anlamına gelir",
  T_49_META_TYP_100_I0_D: "Tetik aralığını ayarlayın",
  T_49_META_TYP_100_I1_D: "Model Görünürlüğü",
  T_49_META_TYP_101_I0_D: "Oyuncu",
  T_49_META_TYP_101_I1_D: "Hedef Öğesi ID'si",
  T_49_META_TYP_101_I2_D: "Hedef Dönüşü",
  T_49_META_TYP_101_I3_D: "Hedef Ölçeği",
  T_49_META_TYP_1010_I1_D: "Zamanlamanın süresi, saniye cinsinden",
  T_49_META_TYP_1010_I2_D: "Geri sayımın oyun saniyesi cinsinden başlangıç saati",
  T_49_META_TYP_1010_I3_D: "Zamanlamanın güncelleme türü, bkz. `EUITimeUpdateType`, isteğe bağlı: statik, zamanlama, geri sayım",
  T_49_META_TYP_1010_I4_D: "Ekran konumu, takip edilecek bir hedef olduğunda, hedef kökenine göre ofsettir, takip edilecek bir hedef olmadığında, ekran koordinatıdır",
  T_49_META_TYP_1011_I10_D: "İlerleme İkonu Adı",
  T_49_META_TYP_1011_I2_D: "Tema Rengi",
  T_49_META_TYP_1011_I3_D: "Yerelleştirilmiş görüntülemenin etkinleştirilip etkinleştirilmeyeceği",
  T_49_META_TYP_1011_I4_D: "Başlık",
  T_49_META_TYP_1011_I5_D: "Açıklama",
  T_49_META_TYP_1011_I6_D: "Simge kaynak adı",
  T_49_META_TYP_1011_I7_D: "Maksimum İlerleme",
  T_49_META_TYP_1011_I8_D: "Mevcut İlerleme",
  T_49_META_TYP_1011_I9_D: "İlerleme İkonu",
  T_49_META_TYP_1012_I1_D: "Yerelleştirmenin etkinleştirilip etkinleştirilmeyeceği",
  T_49_META_TYP_1012_I2_D: "Yuvarlak Sayı Metni",
  T_49_META_TYP_1012_I3_D: "Tur Numara Yerelleştirme Anahtarı Parametreleri",
  T_49_META_TYP_1012_I5_D: "Sol Renk",
  T_49_META_TYP_1012_I6_D: "Sağ Renk",
  T_49_META_TYP_1013_I2_D: "Yuvarlak Sayı Metni",
  T_49_META_TYP_1013_I3_D: "Tur Numara Yerelleştirme Anahtarı Parametreleri",
  T_49_META_TYP_1014_I2_D: "İlk puan başlık metni",
  T_49_META_TYP_1014_I3_D: "İlk puan değeri",
  T_49_META_TYP_1014_I4_D: "Birinci Skor Parametreleri",
  T_49_META_TYP_1014_I5_D: "İkinci skor başlık metni",
  T_49_META_TYP_1014_I6_D: "İkinci puan değeri",
  T_49_META_TYP_1014_I7_D: "İkinci Skor Parametreleri",
  T_49_META_TYP_1016_I1_D: "Değere göre ilgili durumu görüntüle, zafer (1), kayıp (2), beraberlik (3), booyah (4)",
  T_49_META_TYP_1016_I2_D: "2 takımın skorlarını göster. Doğruysa gösterilecek, aksi takdirde gizlenecek.",
  T_49_META_TYP_1016_I3_D: "Sol Takım Skoru",
  T_49_META_TYP_1016_I4_D: "Sağ Takım Skoru",
  T_49_META_TYP_1016_I5_D: "Aşama sonu zaman damgası",
  T_49_META_TYP_1017_I1_D: "Sol Takım Adı",
  T_49_META_TYP_1017_I2_D: "Sol Açıklama",
  T_49_META_TYP_1017_I3_D: "Sağ Takım Adı",
  T_49_META_TYP_1017_I4_D: "Sağ Açıklama",
  T_49_META_TYP_1018_I1_D: "Tur Numarası",
  T_49_META_TYP_1018_I4_D: "Sol Takım Skoru",
  T_49_META_TYP_1018_I6_D: "Doğru Takım Skoru",
  T_49_META_TYP_1019_I1_D: "Kazanma, kaybetme ve beraberlik sırasıyla 1 2 3'e karşılık gelir",
  T_49_META_TYP_102_I0_D: "Diriliş kaynak türü, oyuncu ölümden dirildi",
  T_49_META_TYP_102_I1_D: "Diriliş kaynağı türü, oyuncu yere serilmiş bir durumdan dirilir",
  T_49_META_TYP_1020_I2_D: "Görüntülenecek metin tuşu",
  T_49_META_TYP_1020_I3_D: "Metin anahtarına karşılık gelen parametre dizisi",
  T_49_META_TYP_1021_I1_D: "Temel süre (saniye cinsinden)",
  T_49_META_TYP_1021_I2_D: "Saniye cinsinden süre",
  T_49_META_TYP_1021_I3_D: "Görüntüleme konumu. Takip edilecek bir hedef olduğunda, hedef kökenine göre ofsettir. Takip edilecek bir hedef olmadığında, ekran koordinatıdır. Varsayılan değer Vector3(0)'dır",
  T_49_META_TYP_1022_I2_D: "Görüntülenecek metin tuşu",
  T_49_META_TYP_1022_I3_D: "Metin anahtarına karşılık gelen parametre dizisi",
  T_49_META_TYP_1023_I1_D: "Takım puanlarını göster seçeneği doğru olduğunda görüntülenir, aksi takdirde kapatılır",
  T_49_META_TYP_1023_I4_D: "Oyuncu durumu doğru olduğunda görüntüle, aksi takdirde kapat",
  T_49_META_TYP_1023_I5_D: "Sol oyuncunun durum dizisi, 0: hayatta olan oyuncu sayısı, 1: ölen oyuncu sayısı, 2: yere düşen oyuncu sayısı",
  T_49_META_TYP_1023_I6_D: "Sağdaki oyuncunun durum dizisi, 0: hayatta olan oyuncu sayısı, 1: ölen oyuncu sayısı, 2: düşen oyuncu sayısı",
  T_49_META_TYP_1023_I7_D: "Sol Takım Üyesi Bayrak Sayısı",
  T_49_META_TYP_1023_I8_D: "Sağ Takım Bayrağı Sayısı",
  T_49_META_TYP_1024_I2_D: "Telafi etmek",
  T_49_META_TYP_1024_I3_D: "Sıralama",
  T_49_META_TYP_1024_I4_D: "Takım Renk",
  T_49_META_TYP_1024_I5_D: "İkon Adı",
  T_49_META_TYP_1024_I6_D: "Eğer sınır doğru ise gösterilecek, doğru değilse kapatılacak.",
  T_49_META_TYP_1024_I7_D: "Skor Metin Anahtarı",
  T_49_META_TYP_1024_I8_D: "Skor Metin Anahtarı Parametreleri",
  T_49_META_TYP_1028_I1_D: "Sol Takım Üyesi Hayatta Sayısı",
  T_49_META_TYP_1028_I2_D: "Sağ Takım Üyesi Hayatta Sayısı",
  T_49_META_TYP_1028_I3_D: "Sol Arka Plan Rengi",
  T_49_META_TYP_1028_I4_D: "Sağ Arka Plan Rengi",
  T_49_META_TYP_1028_I5_D: "Sol İkon Adı",
  T_49_META_TYP_1028_I6_D: "Sağ İkon Adı",
  T_49_META_TYP_1029_I1_D: "İkon Adı",
  T_49_META_TYP_1029_I2_D: "Arka Plan İkon Adı",
  T_49_META_TYP_103_I0_D: "Birincil Silah A",
  T_49_META_TYP_103_I1_D: "Birincil Silah B",
  T_49_META_TYP_103_I10_D: "Dondurucu bomba",
  T_49_META_TYP_103_I11_D: "Buz Duvarı",
  T_49_META_TYP_103_I12_D: "Mayın",
  T_49_META_TYP_103_I13_D: "Otomatik taret",
  T_49_META_TYP_103_I14_D: "Sahte El Bombası",
  T_49_META_TYP_103_I16_D: "Kaykay, kamuflaj...",
  T_49_META_TYP_103_I2_D: "İkincil Silah",
  T_49_META_TYP_103_I3_D: "Patlayıcı silahlar",
  T_49_META_TYP_103_I5_D: "Ağır Silah",
  T_49_META_TYP_1030_I3_D: "Sol Takım Üyesi Hayatta Sayısı",
  T_49_META_TYP_1030_I4_D: "Sağ Takım Üyesi Hayatta Sayısı",
  T_49_META_TYP_1030_I5_D: "Soldaki takım simgesi adı",
  T_49_META_TYP_1030_I6_D: "Sağ tarafta takım simgesi adı",
  T_49_META_TYP_1031_I2_D: "Hızlı bilgi açıklaması",
  T_49_META_TYP_1031_I3_D: "Geri sayım başlangıç zaman damgası saniye cinsinden",
  T_49_META_TYP_1031_I4_D: "İpucu Açıklama Parametreleri",
  T_49_META_TYP_1032_I1_D: "İpucu Türü",
  T_49_META_TYP_1032_I3_D: "Parametreler",
  T_49_META_TYP_1033_I1_D: "Geçiş aşaması, 0 geçerli turun sonuçlandığı anlamına gelir, 1 bir sonraki turun başladığı anlamına gelir",
  T_49_META_TYP_1033_I10_D: "Başarısızlık uyarı metni, varsayılan olarak boş bırakın",
  T_49_META_TYP_1033_I11_D: "Tur Geliri Başlığı",
  T_49_META_TYP_1033_I12_D: "Tur Geliri",
  T_49_META_TYP_1033_I13_D: "Tur Geliri Detay Başlıkları",
  T_49_META_TYP_1033_I14_D: "Yuvarlak gelir değerlerinin detaylı listesi yukarıdaki detaylı başlık listesine karşılık gelmektedir.",
  T_49_META_TYP_1033_I15_D: "MVP oyuncusunun takma adı",
  T_49_META_TYP_1033_I16_D: "Bir Sonraki Tur Endeksi",
  T_49_META_TYP_1033_I17_D: "Maç Puanı mı",
  T_49_META_TYP_1033_I18_D: "Son Tur mu",
  T_49_META_TYP_1033_I6_D: "Soldaki takım simgesi adı",
  T_49_META_TYP_1033_I7_D: "Sağ tarafta takım simgesi adı",
  T_49_META_TYP_1033_I8_D: "Değere göre ilgili durumu görüntüle, zafer (1), başarısızlık (2)",
  T_49_META_TYP_1033_I9_D: "Zafer istemi metni, varsayılan olarak boş bırakın",
  T_49_META_TYP_1036_I1_D: "Kaç seviye olduğunu gösterir",
  T_49_META_TYP_1036_I2_D: "Mevcut zombi seviyesini gösterir",
  T_49_META_TYP_1037_I1_D: "Kaç noktanın görüntülendiğini gösterir",
  T_49_META_TYP_1039_I3_D: "Geri sayım başlangıç zaman damgası saniye cinsinden",
  T_49_META_TYP_104_I0_D: "Stil A",
  T_49_META_TYP_104_I1_D: "Stil B",
  T_49_META_TYP_104_I2_D: "Stil C",
  T_49_META_TYP_1040_I10_D: "Kart Açıklamaları",
  T_49_META_TYP_1040_I11_D: "Seçilen öğenin 0'dan başlayarak indeksi. 0'dan küçük olması seçimin kaldırıldığı anlamına gelir.",
  T_49_META_TYP_1040_I12_D: "Buton İsimleri",
  T_49_META_TYP_1040_I13_D: "Buton Renkleri",
  T_49_META_TYP_1040_I2_D: "Geri Sayım Anahtarı",
  T_49_META_TYP_1040_I3_D: "Geri Sayım Süresi",
  T_49_META_TYP_1040_I4_D: "Açıklama Anahtarı",
  T_49_META_TYP_1040_I5_D: "Açıklama bilgi parametre dizisi",
  T_49_META_TYP_1040_I6_D: "Kart Arka Planları",
  T_49_META_TYP_1040_I7_D: "Kart Arka Plan Renkleri",
  T_49_META_TYP_1040_I8_D: "Kart İkonları",
  T_49_META_TYP_1040_I9_D: "Kart İsimleri",
  T_49_META_TYP_1041_I2_D: "Pozisyon",
  T_49_META_TYP_1041_I3_D: "Simge Görüntüsü",
  T_49_META_TYP_1041_I4_D: "Etiket",
  T_49_META_TYP_1041_I5_D: "Arka Plan Rengi",
  T_49_META_TYP_1042_I1_D: "Yerel Konum",
  T_49_META_TYP_1043_I4_D: "Renk",
  T_49_META_TYP_1043_I5_D: "Etiket Anahtarı",
  T_49_META_TYP_1043_I6_D: "Etiket Parametreleri",
  T_49_META_TYP_1045_I2_D: "Düğme Simgesi",
  T_49_META_TYP_1045_I3_D: "İkon Rengi",
  T_49_META_TYP_1045_I4_D: "Boyut, genişlik ve yükseklik aynıdır",
  T_49_META_TYP_1045_I5_D: "Sağ alt bağlantı noktasına göre konum",
  T_49_META_TYP_1045_I6_D: "Şarj miktarı, 0'dan az ise gizli",
  T_49_META_TYP_1045_I7_D: "CD başlangıç süresi, milisaniye cinsinden",
  T_49_META_TYP_1045_I8_D: "CD süresi milisaniye cinsinden",
  T_49_META_TYP_1045_I9_D: "True ise buton gri renge bürünür, False ise geri yüklenir.",
  T_49_META_TYP_106_I1_D: "Etkinleştir",
  T_49_META_TYP_106_I2_D: "Devre Dışı Bırak",
  T_49_META_TYP_109_I0_D: "Sohbet Kanalı ID'si",
  T_49_META_TYP_109_I1_D: "Oyuncu Listesi",
  T_49_META_TYP_11_I0_D: "Mevcut oyun yasadışı bir durumda mı? Yasadışı bir durumdaysa, oyunun çatışma için değerini kaybettiği anlamına gelir. Oyunu doğrudan sonlandırmanız önerilir.",
  T_49_META_TYP_11_I1_D: "Mevcut oyunun süresi, milisaniye cinsinden",
  T_49_META_TYP_11_I10_D: "Her turda ekipmanın sıfırlanıp sıfırlanmayacağı",
  T_49_META_TYP_11_I11_D: "Zehir çemberi mekanizmasının etkinleştirilip etkinleştirilmeyeceği",
  T_49_META_TYP_11_I12_D: "Güvenli Bölge Boyutu",
  T_49_META_TYP_11_I13_D: "Küçülme Başlama Zamanı",
  T_49_META_TYP_11_I14_D: "Küçülme Süresi",
  T_49_META_TYP_11_I15_D: "Alan Dışı Hasar",
  T_49_META_TYP_11_I18_D: "Diriltme Türü",
  T_49_META_TYP_11_I2_D: "Mevcut tur varlığının elde edilebileceği mevcut tur endeksi",
  T_49_META_TYP_11_I27_D: "Toplam Tur Sayısı",
  T_49_META_TYP_11_I3_D: "Mevcut aşama varlığının elde edilebileceği mevcut aşama endeksi",
  T_49_META_TYP_11_I32_D: "Turun başlangıcında elde edilen altın miktarı",
  T_49_META_TYP_11_I33_D: "Öldürme sırasında kazanılan altın miktarı",
  T_49_META_TYP_11_I34_D: "Kazanıldığında kazanılan altın miktarı",
  T_49_META_TYP_11_I35_D: "Cüzdan kullanıcı arayüzünün görüntülenip görüntülenmeyeceği",
  T_49_META_TYP_11_I36_D: "Skybox Varlığı",
  T_49_META_TYP_11_I37_D: "Maç başladığından beri kümülatif koşu kareleri",
  T_49_META_TYP_11_I38_D: "Hareket Edilebilir",
  T_49_META_TYP_11_I39_D: "Yerleşimin özelleştirilmesi gerekip gerekmediği",
  T_49_META_TYP_11_I4_D: "Önceden ayarlanmış UGC modunun şablon kimliği",
  T_49_META_TYP_11_I40_D: "Yarı yolda katılmak mümkün mü?",
  T_49_META_TYP_11_I41_D: "Düşük kare hızı modunu açın, oyun 15 FPS'de, aksi takdirde 30 FPS'de çalışacaktır",
  T_49_META_TYP_11_I42_D: "Oyun sunucusunun iki mantıksal çerçeve güncellemesi arasındaki aralık",
  T_49_META_TYP_11_I43_D: "Sabit çerçeve güncelleme aralığı milisaniye cinsinden",
  T_49_META_TYP_11_I5_D: "Kapalıysa, oyuncu diriltmeleri devre dışı kalır.",
  T_49_META_TYP_11_I6_D: "Kapalıysa, Bot diriltmesi devre dışı bırakılır",
  T_49_META_TYP_11_I7_D: "Diriliş zamanı, saniye cinsinden",
  T_49_META_TYP_11_I8_D: "Oyundaki toplam takım sayısı",
  T_49_META_TYP_11_I9_D: "Takım başına üye sayısı",
  T_49_META_TYP_110_I0_D: "Kanal A",
  T_49_META_TYP_110_I1_D: "Kanal B",
  T_49_META_TYP_110_I2_D: "Kanal C",
  T_49_META_TYP_110_I3_D: "Kanal D",
  T_49_META_TYP_110_I4_D: "Kanal E",
  T_49_META_TYP_110_I5_D: "Kanal F",
  T_49_META_TYP_111_I1_D: "Koşu",
  T_49_META_TYP_111_I2_D: "Saldırı",
  T_49_META_TYP_111_I3_D: "Zıpla",
  T_49_META_TYP_111_I4_D: "Aşmak",
  T_49_META_TYP_111_I5_D: "Sürmek",
  T_49_META_TYP_111_I6_D: "Araca Gir",
  T_49_META_TYP_111_I7_D: "Araçtan Çık",
  T_49_META_TYP_111_I8_D: "Aracı Sür",
  T_49_META_TYP_112_I0_D: "Etkinleştir",
  T_49_META_TYP_112_I1_D: "Devre Dışı Bırak",
  T_49_META_TYP_112_I2_D: "Görünmez",
  T_49_META_TYP_117_I0_D: "Alkış",
  T_49_META_TYP_117_I1_D: "Hi-Hat",
  T_49_META_TYP_117_I2_D: "Bas Davulu",
  T_49_META_TYP_117_I3_D: "Açık Hi-Hat",
  T_49_META_TYP_117_I4_D: "Ride",
  T_49_META_TYP_117_I5_D: "Davul",
  T_49_META_TYP_118_I0_D: "Kamptaki tüm üyelerin ölü olup olmadığı",
  T_49_META_TYP_118_I1_D: "Tüm oyuncuların listesi",
  T_49_META_TYP_118_I2_D: "Müttefik Factions",
  T_49_META_TYP_118_I3_D: "Saldırılabilir Birlikler",
  T_49_META_TYP_118_I4_D: "Kullanıcı arayüzü adının görüntülenip görüntülenmeyeceği",
  T_49_META_TYP_118_I5_D: "Harita bilgilerinin görüntülenip görüntülenmeyeceği",
  T_49_META_TYP_118_I6_D: "Görüntülenip görüntülenmeyeceği",
  T_49_META_TYP_118_I7_D: "Görüntülenip görüntülenmeyeceği",
  T_49_META_TYP_118_I8_D: "Tüm Üyeler",
  T_49_META_TYP_118_I9_D: "Hızlı Mesajı Göster",
  T_49_META_TYP_119_I0_D: "Evet",
  T_49_META_TYP_119_I1_D: "Hayır",
  T_49_META_TYP_120_I1_D: "Takip edilecek hedef varlık, varsayılan boştur",
  T_49_META_TYP_120_I2_D: "Kullanıcı Arayüzü Rengi",
  T_49_META_TYP_120_I3_D: "UI Uzunluğu",
  T_49_META_TYP_120_I4_D: "Mevcut ilerleme değeri, 0 ila 1.0",
  T_49_META_TYP_120_I5_D: "Görüntüleme konumu. Takip edilecek bir hedef olduğunda, hedef kökenine göre ofsettir. Takip edilecek bir hedef olmadığında, ekran koordinatıdır. Varsayılan değer Vector3(0)'dır",
  T_49_META_TYP_121_I0_D: "3 Saniye",
  T_49_META_TYP_121_I1_D: "5 Saniye",
  T_49_META_TYP_121_I2_D: "10 Saniye",
  T_49_META_TYP_121_I3_D: "15 Saniye",
  T_49_META_TYP_121_I4_D: "30 Saniye",
  T_49_META_TYP_121_I5_D: "9999 Saniye",
  T_49_META_TYP_122_I0_D: "Gökyüzü Kutusu Kaynağı",
  T_49_META_TYP_122_I1_D: "Işık Rengi",
  T_49_META_TYP_122_I10_D: "Alt sahne GUID'i",
  T_49_META_TYP_122_I11_D: "Sis efekti anahtarı",
  T_49_META_TYP_122_I12_D: "Sis efekti modu",
  T_49_META_TYP_122_I13_D: "Üstel sis yoğunluğu",
  T_49_META_TYP_122_I14_D: "Doğrusal sisin başlangıç mesafesi",
  T_49_META_TYP_122_I15_D: "Doğrusal sisin son mesafesi",
  T_49_META_TYP_122_I16_D: "Sis efekti özelliğini etkinleştirin",
  T_49_META_TYP_122_I17_D: "Ana ışık kaynağı dönüş açısı",
  T_49_META_TYP_122_I18_D: "Ana ışık kaynağı dönüş açısı özelliğini etkinleştirin",
  T_49_META_TYP_122_I2_D: "Işık Yoğunluğu",
  T_49_META_TYP_122_I3_D: "Karanlık",
  T_49_META_TYP_122_I4_D: "Gölge Gücü",
  T_49_META_TYP_122_I5_D: "Arazi Islaklığı",
  T_49_META_TYP_122_I6_D: "Mercek Parlaması",
  T_49_META_TYP_122_I7_D: "Sis Rengi",
  T_49_META_TYP_122_I8_D: "Ambiyans Rengi",
  T_49_META_TYP_123_I0_D: "Gündüz",
  T_49_META_TYP_123_I1_D: "Gece",
  T_49_META_TYP_123_I2_D: "Alacakaranlık",
  T_49_META_TYP_123_I3_D: "Şehir Manzarası",
  T_49_META_TYP_123_I4_D: "Renkli Gökyüzü",
  T_49_META_TYP_123_I5_D: "Buzul Ay",
  T_49_META_TYP_124_I0_D: "Yakın Mesafe",
  T_49_META_TYP_124_I1_D: "Orta mesafe",
  T_49_META_TYP_124_I2_D: "Uzun mesafe",
  T_49_META_TYP_125_I0_D: "Yaygın Renk",
  T_49_META_TYP_125_I2_D: "Yaygın Doku",
  T_49_META_TYP_125_I4_D: "Diffuse Alpha",
  T_49_META_TYP_126_I1_D: "Adı",
  T_49_META_TYP_126_I2_D: "Mevcut ilerleme değeri",
  T_49_META_TYP_126_I3_D: "Maksimum ilerleme değeri",
  T_49_META_TYP_126_I4_D: "Ekran koordinatları, varsayılan Vector3(0)",
  T_49_META_TYP_126_I5_D: "İlerleme çubuğunun uzunluğu. Mevcut varsayılan değer, prefab'daki kullanıcı arayüzünün uzunluğudur.",
  T_49_META_TYP_127_I0_D: "Belirli bir eksen boyunca çeviri, üç eksen birleştirilebilir",
  T_49_META_TYP_127_I1_D: "Belirli bir eksen boyunca döner, üç eksen birleştirilebilir",
  T_49_META_TYP_127_I2_D: "Belirli bir eksen boyunca yakınlaştırma yapabilir, üç ekseni birleştirebilirsiniz",
  T_49_META_TYP_128_I0_D: "Çalılar",
  T_49_META_TYP_128_I1_D: "Kabak",
  T_49_META_TYP_128_I2_D: "Korkuluk",
  T_49_META_TYP_128_I3_D: "Dolap",
  T_49_META_TYP_129_I0_D: "Rastgele ganimet",
  T_49_META_TYP_129_I1_D: "AR Mermisi",
  T_49_META_TYP_129_I2_D: "SMG Mermisi",
  T_49_META_TYP_129_I3_D: "SN Mermisi",
  T_49_META_TYP_129_I4_D: "HG Mermisi",
  T_49_META_TYP_129_I5_D: "SG Mermisi",
  T_49_META_TYP_129_I6_D: "Yaylı Mermi",
  T_49_META_TYP_13_I1_D: "Ana düğüme göre çapa koordinatları",
  T_49_META_TYP_13_I10_D: "Widget ve bağlantı kutusu boyut farkı",
  T_49_META_TYP_13_I11_D: "Pivot",
  T_49_META_TYP_13_I12_D: "derinlik",
  T_49_META_TYP_13_I14_D: "Aynı ana düğümün altındaki tüm alt düğümlerin sırası",
  T_49_META_TYP_13_I15_D: "Ana ID",
  T_49_META_TYP_13_I16_D: "BenzersizKimlik",
  T_49_META_TYP_13_I17_D: "Öncelik",
  T_49_META_TYP_13_I18_D: "Gerçek Konum",
  T_49_META_TYP_13_I2_D: "Genişlik",
  T_49_META_TYP_13_I4_D: "Z ekseni dönüş açısı",
  T_49_META_TYP_13_I6_D: "Prefab'daki kontrolün dahili kimliği",
  T_49_META_TYP_13_I7_D: "UI varlığı",
  T_49_META_TYP_13_I8_D: "Çapa Min",
  T_49_META_TYP_13_I9_D: "Çapa Max",
  T_49_META_TYP_130_I0_D: "Rastgele sarf malzemeleri Ganimet",
  T_49_META_TYP_130_I1_D: "İlk Yardım Kiti",
  T_49_META_TYP_130_I2_D: "Onarım Kiti",
  T_49_META_TYP_130_I3_D: "Yatay",
  T_49_META_TYP_130_I4_D: "Inhalatör",
  T_49_META_TYP_131_I0_D: "Rastgele Zırh Ganimeti",
  T_49_META_TYP_131_I1_D: "Seviye 1 Zırh",
  T_49_META_TYP_131_I2_D: "İkinci seviye zırh",
  T_49_META_TYP_131_I3_D: "Seviye 3 Zırh",
  T_49_META_TYP_132_I0_D: "Rastgele Atılan Ganimet",
  T_49_META_TYP_132_I1_D: "El Bombası",
  T_49_META_TYP_132_I4_D: "Anlık Dondurma",
  T_49_META_TYP_133_I0_D: "Rastgele Kapsamlı Ganimet",
  T_49_META_TYP_133_I1_D: "2x Kapsama",
  T_49_META_TYP_133_I2_D: "4x Kapsama",
  T_49_META_TYP_133_I3_D: "Termal Dürbün",
  T_49_META_TYP_134_I0_D: "Rastgele Silah Loot",
  T_49_META_TYP_134_I5_D: "Pompalı Tüfek",
  T_49_META_TYP_134_I8_D: "Futbol Tabancası",
  T_49_META_TYP_135_I0_D: "Yağma Madde İşaretleri",
  T_49_META_TYP_136_I0_D: "Tüketilebilir Öğe Puanlarını Yağmala",
  T_49_META_TYP_137_I0_D: "Tüketilebilir Öğe Puanlarını Yağmala",
  T_49_META_TYP_138_I0_D: "Yağma yakınlaştırma noktası",
  T_49_META_TYP_139_I0_D: "Zırh Puanlarını Yağmala",
  T_49_META_TYP_14_I0_D: "Oyuncunun mevcut sağlığı",
  T_49_META_TYP_14_I1_D: "Oyuncunun mevcut maksimum sağlığı",
  T_49_META_TYP_14_I11_D: "Oyuncunun fraksiyonu",
  T_49_META_TYP_14_I12_D: "Oyuncunun hasar çarpanı, örneğin 2x, 2.0'dır",
  T_49_META_TYP_14_I13_D: "Erkek veya kadın karakterle aynı iskeleti kullanın. 0, modeli değiştirmeyin anlamına gelir",
  T_49_META_TYP_14_I14_D: "Mevcut hız ölçeklemesiyle çakışmaz",
  T_49_META_TYP_14_I15_D: "Mevcut atlama yüksekliği ölçeklendirmesiyle çakışmaz",
  T_49_META_TYP_14_I16_D: "Kimlik, 0 Normal Oyuncu, 1 Avcı, 2 Zombi Ana, 3 Normal Zombi, 4 Gelişmiş Zombi Tip 1, 5 Gelişmiş Zombi Tip 2, 6 Gelişmiş Zombi Tip 3",
  T_49_META_TYP_14_I17_D: "Zombi seviyesi, 1~3",
  T_49_META_TYP_14_I19_D: "Oyuncunun takma adı",
  T_49_META_TYP_14_I2_D: "Mevcut oyuncunun bir AI oyuncusu olup olmadığını belirleyin. AI genellikle bir NPC veya PVE canavarıdır.",
  T_49_META_TYP_14_I20_D: "Hasar alındığında hasar yüzdesi azaltılabilir veya artırılabilir.",
  T_49_META_TYP_14_I21_D: "Oyuncunun mevcut EP'si",
  T_49_META_TYP_14_I22_D: "Maksimum oyuncu EP",
  T_49_META_TYP_14_I23_D: "Şu anda elimizdeki ana silah",
  T_49_META_TYP_14_I24_D: "Ölünce Eşyalar Düşer",
  T_49_META_TYP_14_I26_D: "Nişan Yardım Türü",
  T_49_META_TYP_14_I27_D: "Nişan Yardımcısı ile Kilitlenme İzni",
  T_49_META_TYP_14_I28_D: "Sesli sohbeti aç/kapat: true sesi kapatır, false sesi açar",
  T_49_META_TYP_14_I29_D: "Hızlı sohbeti aç/kapat: true sesi kapatır, false sesi açar",
  T_49_META_TYP_14_I3_D: "Oyuncu Durumu",
  T_49_META_TYP_14_I30_D: "Kanal",
  T_49_META_TYP_14_I35_D: "Öğe alımını değiştir: alımı devre dışı bırakmak için doğru, alımı etkinleştirmek için yanlış",
  T_49_META_TYP_14_I36_D: "Öğe atmayı aç/kapat: Öğelerin atılmasını önlemek için doğru, öğelerin atılmasına izin vermek için yanlış",
  T_49_META_TYP_14_I37_D: "Saldırılabilir Hedefler",
  T_49_META_TYP_14_I38_D: "Dost Canlılar",
  T_49_META_TYP_14_I39_D: "Taraf",
  T_49_META_TYP_14_I4_D: "Oyuncunun hayatta kalma süresi. Oyuncu ölürse, süre yeniden hesaplanır.",
  T_49_META_TYP_14_I40_D: "Fraksiyondaki Numarası",
  T_49_META_TYP_14_I41_D: "Oyuncunun kullandığı kamera",
  T_49_META_TYP_14_I42_D: "Özelleştirilmiş Yerçekimi",
  T_49_META_TYP_14_I43_D: "Kask",
  T_49_META_TYP_14_I44_D: "Yelek",
  T_49_META_TYP_14_I5_D: "Oyuncunun yenilmezliği",
  T_49_META_TYP_14_I52_D: "Kullanıcı UID'si",
  T_49_META_TYP_14_I53_D: "Kafadan Aldığı Hasar Azaltma",
  T_49_META_TYP_14_I54_D: "Oyuncuya bağlı AVATAR",
  T_49_META_TYP_14_I55_D: "Cinsiyet",
  T_49_META_TYP_14_I56_D: "Silah Kaplama ID'leri",
  T_49_META_TYP_14_I57_D: "Oyuncunun ortaya çıkış noktası",
  T_49_META_TYP_14_I58_D: "Oyuncunun diriliş noktası. Kontrol noktası kaydı yoksa doğum noktası kullanılır, aksi takdirde kontrol noktası kullanılır.",
  T_49_META_TYP_14_I59_D: "Oyuncunun mevcut pozisyonu",
  T_49_META_TYP_14_I6_D: "Oyuncunun ait olduğu varlık",
  T_49_META_TYP_14_I60_D: "Oyuncunun mevcut yönü",
  T_49_META_TYP_14_I61_D: "Cilt kemiklerine erişmek için kullanılan düğüm",
  T_49_META_TYP_14_I62_D: "Sırt Çantası",
  T_49_META_TYP_14_I63_D: "Geçici Kalkan Puanları",
  T_49_META_TYP_14_I64_D: "Araç Kaplama ID",
  T_49_META_TYP_14_I65_D: "Düşüş Animasyonunu Atla",
  T_49_META_TYP_14_I66_D: "Düşme Hasarını Devre Dışı Bırak",
  T_49_META_TYP_14_I67_D: "Mevcut Taşınabilir Eşya",
  T_49_META_TYP_14_I68_D: "Yasaklı Eşya Listesi",
  T_49_META_TYP_14_I69_D: "Oyuncu Kaynak Kimliği",
  T_49_META_TYP_14_I7_D: "Mevcut kontrol noktası kimliği",
  T_49_META_TYP_14_I70_D: "Satın alma isteği mesajının gönderileceği hedef",
  T_49_META_TYP_14_I71_D: "Şu anda oynatılan Emote kaynağının kimliği",
  T_49_META_TYP_14_I72_D: "Şu anda çalan Emote'un döngüye girip girmediği",
  T_49_META_TYP_14_I73_D: "Devrilme durumuyla başa çıkmak",
  T_49_META_TYP_14_I74_D: "Hasar atlamanın etkinleştirilip etkinleştirilmeyeceği, varsayılan olarak True'dur, yani etkinleştirilmiştir",
  T_49_META_TYP_14_I76_D: "Yarı yolda bırakabilir miyim?",
  T_49_META_TYP_14_I77_D: "Oyuncunun başka bir karaktere dönüşürken saklaması gereken kostüm bilgisi",
  T_49_META_TYP_14_I8_D: "Hedefin gittiği kontrol noktası kimliği",
  T_49_META_TYP_140_I0_D: "Dalga 1",
  T_49_META_TYP_140_I1_D: "Dalga 2",
  T_49_META_TYP_140_I2_D: "Dalga 3",
  T_49_META_TYP_140_I3_D: "Sürekli",
  T_49_META_TYP_141_I0_D: "Rastgele Futbol Yağması",
  T_49_META_TYP_141_I1_D: "Futbol Kalkanı",
  T_49_META_TYP_141_I2_D: "Donma Granatı",
  T_49_META_TYP_142_I0_D: "Loot Futbol",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Klasik (Atış)",
  T_49_META_TYP_147_I1_D: "Üçüncü Kişi",
  T_49_META_TYP_147_I2_D: "Birinci Şahıs (Nişancı)",
  T_49_META_TYP_147_I3_D: "Üstten görünüm",
  T_49_META_TYP_147_I4_D: "Yatay kaydırma",
  T_49_META_TYP_147_I5_D: "Özelleştirilmiş Kamera",
  T_49_META_TYP_147_I6_D: "Takip etmek",
  T_49_META_TYP_147_I7_D: "Oyuncu kontrollü, serbestçe hareket eden kamera",
  T_49_META_TYP_147_I8_D: "Yeni birinci şahıs kamerası",
  T_49_META_TYP_148_I0_D: "Çeşitli önceden ayarlanmış kamera türlerinin yanı sıra özel kamera türleri de sağlar",
  T_49_META_TYP_148_I1_D: "Görüş alanı, kameranın görüş açısıdır",
  T_49_META_TYP_148_I10_D: "Kamera değiştirme animasyonunun türü",
  T_49_META_TYP_148_I11_D: "Sadece anahtar tipi düzgün olduğunda etkili olur. Bu kameraya geçiş için geçiş süresi milisaniye cinsindendir.",
  T_49_META_TYP_148_I12_D: "Kamera ile takip edilen nesne arasında bir engel olduğunda kameranın hareket modu",
  T_49_META_TYP_148_I13_D: "Kamera görüntüyü nasıl oluşturur?",
  T_49_META_TYP_148_I14_D: "Nesne ofset referans koordinat sistemini takip et",
  T_49_META_TYP_148_I15_D: "Nesne ofset referans koordinat sistemini gözlemleyin",
  T_49_META_TYP_148_I16_D: "Kameranın render katmanı maskesi, kameranın render nesnelerini görünürlük düzeyine göre filtreleyebilir",
  T_49_META_TYP_148_I17_D: "Görüş Açısı Sınırlaması",
  T_49_META_TYP_148_I2_D: "Genellikle kamera konumunun oyuncunun başlangıç konumuna göre ofsetini ifade eder. Belirli anlamı farklı kamera tipleri için değişir.",
  T_49_META_TYP_148_I3_D: "Genellikle kameranın odak noktasının oyuncunun başlangıç pozisyonuna göre ofsetini ifade eder. Belirli anlamı farklı kamera tipleri için değişir.",
  T_49_META_TYP_148_I4_D: "Kameranın dikey dönüş açısı",
  T_49_META_TYP_148_I5_D: "Kameranın yatay dönüş açısı",
  T_49_META_TYP_148_I7_D: "Kameranın takip ettiği hedef",
  T_49_META_TYP_148_I8_D: "Kamera neye bakıyor?",
  T_49_META_TYP_148_I9_D: "Şu anda kamerayı kullanan oyuncu",
  T_49_META_TYP_15_I0_D: "Ekibin tüm üyelerinin şu anda ölü olup olmadığı",
  T_49_META_TYP_15_I1_D: "Tüm ekip üyelerinin listesi",
  T_49_META_TYP_15_I3_D: "Düşman takımlarının listesi",
  T_49_META_TYP_15_I4_D: "Dost canlısı ekip listesi",
  T_49_META_TYP_15_I5_D: "Takım No.",
  T_49_META_TYP_150_I0_D: "Dayanıklılık",
  T_49_META_TYP_150_I1_D: "Kapsülün her iki ucundaki yarım kürelerin yarıçapı",
  T_49_META_TYP_150_I2_D: "Hasar Faktörü",
  T_49_META_TYP_152_I1_D: "Özelleştirilmiş Yerçekimi",
  T_49_META_TYP_152_I2_D: "Tetikleyicinin görüntülenip görüntülenmeyeceği, True, görüntüleme anlamına gelir",
  T_49_META_TYP_154_I0_D: "Çift silah kullanamaz",
  T_49_META_TYP_154_I1_D: "Sadece aynı tip silahla çift elle kullanılabilir",
  T_49_META_TYP_154_I2_D: "Başka bir silahla veya kendinizle birlikte çift olarak kullanılabilir",
  T_49_META_TYP_155_I0_D: "seviye",
  T_49_META_TYP_155_I1_D: "Maksimum Dayanıklılık",
  T_49_META_TYP_155_I2_D: "Mevcut Dayanıklılık",
  T_49_META_TYP_155_I3_D: "Hasar Azaltma Faktörü",
  T_49_META_TYP_155_I4_D: "Patlama Hasarı Azaltma Faktörü",
  T_49_META_TYP_155_I5_D: "Dayanıklılık Harcanabilir mi",
  T_49_META_TYP_155_I6_D: "Yok Edilebilir mi",
  T_49_META_TYP_156_I1_D: "Maksimum Dayanıklılık",
  T_49_META_TYP_156_I2_D: "Mevcut Dayanıklılık",
  T_49_META_TYP_156_I3_D: "Hasar Azaltma Faktörü",
  T_49_META_TYP_156_I4_D: "Patlama Hasarı Azaltma Faktörü",
  T_49_META_TYP_156_I5_D: "Dayanıklılık Harcanabilir mi",
  T_49_META_TYP_156_I6_D: "Yok Edilebilir mi",
  T_49_META_TYP_157_I0_D: "Animasyon yok",
  T_49_META_TYP_157_I1_D: "Pürüzsüz",
  T_49_META_TYP_158_I2_D: "UI bağlantı türü numaralandırması, varsayılan değer 9'dur (Merkez)",
  T_49_META_TYP_158_I6_D: "Etiket Anahtarı",
  T_49_META_TYP_158_I7_D: "Etiket Parametreleri",
  T_49_META_TYP_158_I8_D: "Sol Takım",
  T_49_META_TYP_16_I1_D: "Varlığa karşılık gelen öğe kimliği",
  T_49_META_TYP_16_I2_D: "Yalnızca NavMesh'in statik olarak oluşturulup oluşturulmadığını belirlemek için nesneler statik olarak yüklenirken kullanılır",
  T_49_META_TYP_16_I3_D: "NavMesh'in dinamik olarak engellenmesi mi?",
  T_49_META_TYP_16_I4_D: "Eşzamansız yükleme",
  T_49_META_TYP_160_I0_D: "Tuğla A",
  T_49_META_TYP_160_I1_D: "Fayans A",
  T_49_META_TYP_160_I10_D: "Kum A",
  T_49_META_TYP_160_I11_D: "Kar A",
  T_49_META_TYP_160_I12_D: "Ahşap A",
  T_49_META_TYP_160_I13_D: "Ton A",
  T_49_META_TYP_160_I14_D: "Çimen B",
  T_49_META_TYP_160_I15_D: "Tuğla B",
  T_49_META_TYP_160_I16_D: "Tuğla C",
  T_49_META_TYP_160_I17_D: "Temizle",
  T_49_META_TYP_160_I2_D: "Fayans B",
  T_49_META_TYP_160_I3_D: "Fayans C",
  T_49_META_TYP_160_I4_D: "Bambu A",
  T_49_META_TYP_160_I5_D: "Çimento A",
  T_49_META_TYP_160_I6_D: "Konteyner A",
  T_49_META_TYP_160_I7_D: "Çimen A",
  T_49_META_TYP_160_I8_D: "Buz A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Çarpışmanın etkinleştirilip etkinleştirilmeyeceği",
  T_49_META_TYP_165_I1_D: "Tetikleyici olarak hareket edilip edilmeyeceği",
  T_49_META_TYP_165_I2_D: "Fiziksel seviye, fiziksel modüldeki seviyeyi 16'ya kadar yapılandırın",
  T_49_META_TYP_166_I0_D: "Duygu1",
  T_49_META_TYP_166_I1_D: "Duygu2",
  T_49_META_TYP_166_I2_D: "Duygu3",
  T_49_META_TYP_166_I3_D: "Duygu4",
  T_49_META_TYP_166_I4_D: "Duygu5",
  T_49_META_TYP_167_I0_D: "VFX Doku Türü",
  T_49_META_TYP_170_I0_D: "Görünür mü? Görünür değilse, istemci hedefi işlemeyi durdurur.",
  T_49_META_TYP_170_I1_D: "Görünür seviye, değer aralığı [0,15], kameradaki görünürlüğü etkiler",
  T_49_META_TYP_171_I0_D: "Enerji",
  T_49_META_TYP_172_I0_D: "Mermi sayısı",
  T_49_META_TYP_173_I0_D: "Ekstra Sırt Çantası Kapasitesi",
  T_49_META_TYP_173_I1_D: "Oyuncuların oyun dışındaki görünüm yapılandırması önceliklidir",
  T_49_META_TYP_173_I2_D: "Sırt çantası cilt kimliği, sırt çantası cilt yapılandırması",
  T_49_META_TYP_174_I2_D: "Maksimum Hasar",
  T_49_META_TYP_174_I4_D: "Atış Hızı",
  T_49_META_TYP_174_I5_D: "Patlama gecikmesi, saniye cinsinden",
  T_49_META_TYP_174_I6_D: "Kendi Hasar Katsayısı",
  T_49_META_TYP_174_I7_D: "Takım Arkadaşı Hasar Katsayısı",
  T_49_META_TYP_174_I8_D: "Araç Hasar Katsayısı",
  T_49_META_TYP_174_I9_D: "Deri",
  T_49_META_TYP_175_I0_D: "Donmuş Bölge Yarıçapı",
  T_49_META_TYP_175_I1_D: "Dondurulmuş alan süresi, saniye cinsinden",
  T_49_META_TYP_176_I0_D: "Silahın ana türü",
  T_49_META_TYP_176_I1_D: "Silah Alt Türü",
  T_49_META_TYP_177_I0_D: "Kamera ile takip edilen nesne arasında bir engel olduğunda kamera herhangi bir değişiklik yapmaz.",
  T_49_META_TYP_177_I1_D: "Kamera ile takip edilen nesne arasında bir engel olduğunda kamera takip edilen nesneye yaklaşacaktır.",
  T_49_META_TYP_177_I2_D: "Kamera ile takip edilen nesne arasında bir kapatıcı olduğunda, kapatıcı yarı saydam hale gelir",
  T_49_META_TYP_178_I0_D: "Kamera bir nesneyi gözlemlediğinde, yakındaki nesneler daha büyük, uzaktaki nesneler ise daha küçük görünür.",
  T_49_META_TYP_178_I1_D: "Kamera bir nesneyi gözlemlediğinde, yakındaki ve uzaktaki nesneler aynı boyuttadır",
  T_49_META_TYP_184_I0_D: "İşlenecek kaynağın UUID'sini belirtin.",
  T_49_META_TYP_185_I0_D: "Kullanılacak model ağını işleyin",
  T_49_META_TYP_185_I1_D: "Render için kullanılacak malzemelerin listesi",
  T_49_META_TYP_187_I0_D: "Eşya ID",
  T_49_META_TYP_190_I0_D: "Açık durum",
  T_49_META_TYP_190_I1_D: "Oyun Sonuçları",
  T_49_META_TYP_190_I10_D: "Skorlar 1",
  T_49_META_TYP_190_I11_D: "Skorlar 2",
  T_49_META_TYP_190_I12_D: "Skorlar 3",
  T_49_META_TYP_190_I13_D: "Kazanan MVP'ler",
  T_49_META_TYP_190_I14_D: "Kaybeden MVP'ler",
  T_49_META_TYP_190_I15_D: "Maç Detayını Göster",
  T_49_META_TYP_190_I16_D: "Harita Değerlendirmesini Göster",
  T_49_META_TYP_190_I17_D: "Hediyeyi Göster",
  T_49_META_TYP_190_I18_D: "Raporu Göster",
  T_49_META_TYP_190_I19_D: "Tekrarı Göster",
  T_49_META_TYP_190_I20_D: "Paylaşımı Göster",
  T_49_META_TYP_190_I21_D: "Lobiye Dönüşü Göster",
  T_49_META_TYP_190_I22_D: "Beğenileri Göster",
  T_49_META_TYP_190_I23_D: "Arkadaş Ekleme Göster",
  T_49_META_TYP_190_I24_D: "Ekonomi Göster",
  T_49_META_TYP_190_I4_D: "Sağ Takım",
  T_49_META_TYP_190_I5_D: "Başlıklar",
  T_49_META_TYP_190_I6_D: "Oyuncu Sıralaması",
  T_49_META_TYP_190_I9_D: "Başlıklar",
  T_49_META_TYP_191_I0_D: "Merkez Menzili",
  T_49_META_TYP_191_I4_D: "Merkez flaş süresi, milisaniye cinsinden",
  T_49_META_TYP_191_I5_D: "Kenar flaş süresi, milisaniye cinsinden",
  T_49_META_TYP_191_I6_D: "Etki Süresi",
  T_49_META_TYP_192_I3_D: "Özel efektin süresi, saniye cinsinden",
  T_49_META_TYP_193_I1_D: "Maç Başlığı Sol",
  T_49_META_TYP_193_I10_D: "Skorlar 1",
  T_49_META_TYP_193_I11_D: "Skorlar 2",
  T_49_META_TYP_193_I12_D: "Skorlar 3",
  T_49_META_TYP_193_I13_D: "Skorlar 4",
  T_49_META_TYP_193_I14_D: "Skorlar 5",
  T_49_META_TYP_193_I15_D: "Kazanan MVP'ler",
  T_49_META_TYP_193_I16_D: "Kaybeden MVP'ler",
  T_49_META_TYP_193_I17_D: "Maç Detayını Göster",
  T_49_META_TYP_193_I18_D: "Harita Değerlendirmesini Göster",
  T_49_META_TYP_193_I19_D: "Hediyeyi Göster",
  T_49_META_TYP_193_I2_D: "Maç Başlığı Sağ",
  T_49_META_TYP_193_I20_D: "Raporu Göster",
  T_49_META_TYP_193_I21_D: "Tekrarı Göster",
  T_49_META_TYP_193_I22_D: "Paylaşımı Göster",
  T_49_META_TYP_193_I23_D: "Lobiye Dönüşü Göster",
  T_49_META_TYP_193_I24_D: "Beğenileri Göster",
  T_49_META_TYP_193_I25_D: "Arkadaş Ekleme Göster",
  T_49_META_TYP_193_I26_D: "Ekonomi Göster",
  T_49_META_TYP_193_I3_D: "Oyun Sonuçları",
  T_49_META_TYP_193_I4_D: "Takım Sıralaması",
  T_49_META_TYP_193_I5_D: "Oyuncu Sıralaması",
  T_49_META_TYP_193_I6_D: "Takım sıralaması",
  T_49_META_TYP_193_I7_D: "Ana Skor Başlığı",
  T_49_META_TYP_193_I8_D: "Ana Skorlar",
  T_49_META_TYP_193_I9_D: "Başlıklar",
  T_49_META_TYP_194_I0_D: "Mayının etkisini göstereceği saniye cinsinden süre",
  T_49_META_TYP_194_I1_D: "Tetikleme Yarıçapı",
  T_49_META_TYP_194_I2_D: "Mayın menzili içinde bir mayını tetiklemek için gereken süre (saniye cinsinden)",
  T_49_META_TYP_194_I3_D: "Kendiniz tetikleyebilir mi?",
  T_49_META_TYP_194_I4_D: "Takım tarafından tetiklenebilir",
  T_49_META_TYP_194_I5_D: "Araç Tarafından Tetiklenebilir mi",
  T_49_META_TYP_194_I6_D: "Bittiğinde otomatik olarak patlayacak olan mayının var olma süresi. Süre, mayının yerleştirildiği andan itibaren saniye cinsinden başlar",
  T_49_META_TYP_194_I7_D: "Saldırılabilir",
  T_49_META_TYP_194_I8_D: "Sağlık",
  T_49_META_TYP_195_I0_D: "Bir kez",
  T_49_META_TYP_195_I2_D: "Karşılıklı",
  T_49_META_TYP_197_I0_D: "Oynuyor mu?",
  T_49_META_TYP_197_I1_D: "İşaret biti",
  T_49_META_TYP_197_I2_D: "Oluştururken otomatik olarak oynatmayı işaretleyin",
  T_49_META_TYP_198_I0_D: "Eklentiye karşılık gelen prop id'si",
  T_49_META_TYP_199_I0_D: "Maks. EP",
  T_49_META_TYP_199_I1_D: "Enerji Maliyeti",
  T_49_META_TYP_199_I10_D: "Düşüş Hasar Oranı",
  T_49_META_TYP_199_I11_D: "Mevcut Enerji",
  T_49_META_TYP_199_I2_D: "Yukarı Enerji Maliyeti",
  T_49_META_TYP_199_I3_D: "Sprint Enerji Maliyeti",
  T_49_META_TYP_199_I4_D: "Rush Enerji Maliyeti",
  T_49_META_TYP_199_I5_D: "Temel Yatay Hız",
  T_49_META_TYP_199_I6_D: "Sprint Yatay Hız",
  T_49_META_TYP_199_I7_D: "Temel Dikey Hız",
  T_49_META_TYP_199_I8_D: "Sprint dikey hız",
  T_49_META_TYP_199_I9_D: "Rush Mesafe",
  T_49_META_TYP_200_I0_D: "Bölge Kimliği",
  T_49_META_TYP_200_I1_D: "Oyun Kimliği",
  T_49_META_TYP_201_I0_D: "Yavaşlama yüzdesi: Açık sudaki su nesnelerinin hızının yavaşladığı yüzde.",
  T_49_META_TYP_203_I0_D: "hedef varlık",
  T_49_META_TYP_203_I1_D: "Özellik ID'si",
  T_49_META_TYP_203_I10_D: "Oyun sunucusunun çalışmaya başladığı zaman",
  T_49_META_TYP_203_I11_D: "Başlangıç Değeri",
  T_49_META_TYP_203_I12_D: "Bitiş Değeri",
  T_49_META_TYP_203_I13_D: "Geçilen yüzde",
  T_49_META_TYP_203_I4_D: "Geçiş Stili",
  T_49_META_TYP_203_I6_D: "Süre(ler)",
  T_49_META_TYP_203_I7_D: "Ters Çevir",
  T_49_META_TYP_203_I8_D: "Kontrol Noktaları",
  T_49_META_TYP_203_I9_D: "Oyun sunucusu durumunu senkronize et",
  T_49_META_TYP_204_I0_D: "Maks. Atlama Yüksekliği",
  T_49_META_TYP_204_I1_D: "Düşme hasar yüzdesi",
  T_49_META_TYP_204_I2_D: "Enerji Yenileme",
  T_49_META_TYP_204_I3_D: "Enerji tüketin",
  T_49_META_TYP_204_I4_D: "Maksimum Enerji",
  T_49_META_TYP_205_I0_D: "Minimum Uçuş Yüksekliği",
  T_49_META_TYP_205_I1_D: "Minimum Son Yüksekliği",
  T_49_META_TYP_205_I2_D: "Yatay Uçuş Hızı",
  T_49_META_TYP_205_I3_D: "Dikey Uçuş Hızı",
  T_49_META_TYP_205_I4_D: "Düşüş Hızı",
  T_49_META_TYP_205_I5_D: "Dönüş Hızı",
  T_49_META_TYP_205_I6_D: "Maksimum Uçuş Yüksekliği",
  T_49_META_TYP_205_I7_D: "Fazla Yükseklik Düşüş Hızı",
  T_49_META_TYP_205_I8_D: "Değişken hızlı ivmelenme",
  T_49_META_TYP_206_I0_D: "Hız",
  T_49_META_TYP_206_I1_D: "İvme",
  T_49_META_TYP_206_I10_D: "Yüksek hızda, maksimum direksiyon açısı",
  T_49_META_TYP_206_I11_D: "Yüksek hızlı direksiyon açısı enterpolasyonu temel oranı",
  T_49_META_TYP_206_I2_D: "Boost Hızı",
  T_49_META_TYP_206_I3_D: "Sprint süresi (saniye cinsinden)",
  T_49_META_TYP_206_I4_D: "Sprint soğuma süresi, saniye cinsinden",
  T_49_META_TYP_206_I6_D: "Atlama CD'si, saniyeler içinde",
  T_49_META_TYP_206_I7_D: "Kaykay üzerine çıktıktan sonra Sprint CD, birim: saniye",
  T_49_META_TYP_206_I8_D: "Boost'e Binme CD Anahtarı",
  T_49_META_TYP_206_I9_D: "Kaykayda kaymanın CD'si, saniyeler içinde",
  T_49_META_TYP_207_I1_D: "Başlangıç İndeksi",
  T_49_META_TYP_207_I2_D: "Bitiş Pozisyonu",
  T_49_META_TYP_207_I3_D: "Zipline Kimliği",
  T_49_META_TYP_207_I4_D: "Grup Kimliği",
  T_49_META_TYP_207_I5_D: "Bitti mi?",
  T_49_META_TYP_21_I0_D: "UI'nin temel seviyesi",
  T_49_META_TYP_210_I1_D: "Başlangıç Hızı",
  T_49_META_TYP_210_I2_D: "İvme",
  T_49_META_TYP_210_I3_D: "Maks. Yer Değiştirme",
  T_49_META_TYP_210_I4_D: "Başlangıç Dünya Konumu",
  T_49_META_TYP_210_I5_D: "Oyun sunucusu konum bilgilerinin zorunlu senkronizasyonunu sağladı",
  T_49_META_TYP_211_I0_D: "Yerel Konum",
  T_49_META_TYP_211_I1_D: "Dünya Pozisyonu",
  T_49_META_TYP_212_I0_D: "Kendisi",
  T_49_META_TYP_212_I2_D: "Ofset Koordinatları",
  T_49_META_TYP_213_I0_D: "Kendisi",
  T_49_META_TYP_213_I2_D: "Ofset Koordinatları",
  T_49_META_TYP_215_I0_D: "Zafer",
  T_49_META_TYP_215_I1_D: "Yenilgi",
  T_49_META_TYP_215_I2_D: "Buyuyun",
  T_49_META_TYP_215_I3_D: "Beraberlik",
  T_49_META_TYP_218_I0_D: "Yoğunluk",
  T_49_META_TYP_218_I1_D: "Menzil",
  T_49_META_TYP_218_I2_D: "Açık Renk",
  T_49_META_TYP_22_I0_D: "Açık durumu doğru ise gösterilecektir, doğru değilse kapatılacaktır.",
  T_49_META_TYP_22_I1_D: "Prefab ID",
  T_49_META_TYP_22_I2_D: "Mevcut maksimum kontrol kimliği",
  T_49_META_TYP_22_I3_D: "UI'nin temel seviyesi",
  T_49_META_TYP_22_I4_D: "Oyuncu Görünümünü Etkinleştir",
  T_49_META_TYP_22_I5_D: "Dünya Pozisyonu",
  T_49_META_TYP_22_I6_D: "Sahnede mi?",
  T_49_META_TYP_22_I7_D: "Dünya koordinatlarında dönüş",
  T_49_META_TYP_22_I8_D: "Dünya koordinatlarında ölçekleme",
  T_49_META_TYP_221_I0_D: "Vites değiştirme gecikmesi, değer ne kadar büyükse vites değiştirme hızı o kadar yavaş olur",
  T_49_META_TYP_222_I0_D: "Vites değiştirme gecikmesi, değer ne kadar büyükse vites değiştirme hızı o kadar yavaş olur",
  T_49_META_TYP_225_I0_D: "Taret Hasarı",
  T_49_META_TYP_225_I1_D: "Hasar Aralığı (sn)",
  T_49_META_TYP_225_I10_D: "Açı içinde ateş",
  T_49_META_TYP_225_I11_D: "Hasar azaltma oranı",
  T_49_META_TYP_225_I12_D: "Zırh Delme",
  T_49_META_TYP_225_I2_D: "Doğruluk",
  T_49_META_TYP_225_I3_D: "Menzil",
  T_49_META_TYP_225_I4_D: "Açısal Hız",
  T_49_META_TYP_225_I5_D: "Yukarı Açı",
  T_49_META_TYP_225_I6_D: "Aşağı Açı",
  T_49_META_TYP_225_I7_D: "Maks. HP",
  T_49_META_TYP_225_I8_D: "Ömür Süresi (sn)",
  T_49_META_TYP_225_I9_D: "Maks. Kule Sayısı",
  T_49_META_TYP_226_I0_D: "Taretin mevcut durumu",
  T_49_META_TYP_226_I1_D: "Saldırıyı Etkinleştir",
  T_49_META_TYP_227_I0_D: "Basit Widget",
  T_49_META_TYP_227_I1_D: "Görüntü Widget'ı",
  T_49_META_TYP_227_I10_D: "Doku Widget'ı",
  T_49_META_TYP_227_I11_D: "Profil Widget'ı",
  T_49_META_TYP_227_I12_D: "Toggle Widget'ı",
  T_49_META_TYP_227_I13_D: "Dokunmatik Pad Widget'ı",
  T_49_META_TYP_227_I14_D: "Joystick Widget'ı",
  T_49_META_TYP_227_I15_D: "Sosyal Buton Araç",
  T_49_META_TYP_227_I2_D: "Etiket Widget'ı",
  T_49_META_TYP_227_I3_D: "Düğme Widget'ı",
  T_49_META_TYP_227_I4_D: "Giriş Etiketi Widget'ı",
  T_49_META_TYP_227_I5_D: "Panel",
  T_49_META_TYP_227_I6_D: "Kaydırma Paneli",
  T_49_META_TYP_227_I7_D: "Izgara",
  T_49_META_TYP_227_I8_D: "Düzen Widget'ı",
  T_49_META_TYP_227_I9_D: "Konteyner Widget'ı",
  T_49_META_TYP_231_I0_D: "Dayanıklılık Kurtarma",
  T_49_META_TYP_231_I1_D: "Etkili olma süresi aralığı (saniye cinsinden)",
  T_49_META_TYP_233_I2_D: "Zamanlamanın bitiş zamanı, saniye cinsinden",
  T_49_META_TYP_233_I4_D: "Simge kaynak adı",
  T_49_META_TYP_234_I0_D: "Tetikleme süresi, saniye cinsinden",
  T_49_META_TYP_234_I1_D: "Kendiniz tetikleyebilir mi?",
  T_49_META_TYP_234_I10_D: "Güncel sağlık durumu",
  T_49_META_TYP_234_I2_D: "Takım tarafından tetiklenebilir",
  T_49_META_TYP_234_I3_D: "Araç Tarafından Tetiklenebilir mi",
  T_49_META_TYP_234_I4_D: "Süre, saniye cinsinden",
  T_49_META_TYP_234_I5_D: "Saldırılabilir",
  T_49_META_TYP_234_I6_D: "Sağlık",
  T_49_META_TYP_235_I0_D: "Maksimum Sağlık",
  T_49_META_TYP_235_I2_D: "Maks. Sayı",
  T_49_META_TYP_237_I0_D: "Atış Hızı",
  T_49_META_TYP_237_I1_D: "Oyuncu Çekiş Hızı",
  T_49_META_TYP_238_I0_D: "Sprey Rengi",
  T_49_META_TYP_239_I0_D: "Başlangıç Hızı",
  T_49_META_TYP_239_I1_D: "İvme (yerçekimi gibi)",
  T_49_META_TYP_24_I0_D: "Yakın dövüş",
  T_49_META_TYP_24_I1_D: "Silah",
  T_49_META_TYP_24_I10_D: "Havadan atılanların verdiği hasar, canavarların intihar ettiği hasar",
  T_49_META_TYP_24_I11_D: "Araç Patlamasında Yanma Hasarı",
  T_49_META_TYP_24_I12_D: "Yağ Varili Patlaması",
  T_49_META_TYP_24_I13_D: "Füze Türü Silah",
  T_49_META_TYP_24_I14_D: "Canavar",
  T_49_META_TYP_24_I15_D: "Hasar Bölgesi",
  T_49_META_TYP_24_I17_D: "Karakter Yetenekleri",
  T_49_META_TYP_24_I2_D: "El Bombası At",
  T_49_META_TYP_24_I3_D: "Güvenli Bölge",
  T_49_META_TYP_24_I4_D: "Araç",
  T_49_META_TYP_24_I5_D: "Düşme",
  T_49_META_TYP_24_I6_D: "Ölüm Bölgesi",
  T_49_META_TYP_24_I7_D: "Çıkış",
  T_49_META_TYP_24_I8_D: "Bağlantı Kesildi",
  T_49_META_TYP_24_I9_D: "Araç Patlaması",
  T_49_META_TYP_241_I0_D: "Çekiş hızı",
  T_49_META_TYP_241_I1_D: "Sallanma hızı",
  T_49_META_TYP_241_I2_D: "Çekiş düğmesini açın",
  T_49_META_TYP_241_I3_D: "Sallanma düğmesini açın",
  T_49_META_TYP_241_I4_D: "Hareket Çapası",
  T_49_META_TYP_241_I5_D: "Sallanma Çıkış İvmesi",
  T_49_META_TYP_242_I2_D: "Sol Etki Aktif",
  T_49_META_TYP_242_I3_D: "Sağ Etki Aktif",
  T_49_META_TYP_242_I4_D: "Merkez Çizgi Aktif",
  T_49_META_TYP_242_I5_D: "Değer",
  T_49_META_TYP_242_I7_D: "UI konumu, yalnızca XY bileşenleri geçerlidir",
  T_49_META_TYP_242_I8_D: "Orta satır konumu [0,1]",
  T_49_META_TYP_243_I0_D: "Üst Giysi",
  T_49_META_TYP_243_I1_D: "Alt Giysi",
  T_49_META_TYP_243_I2_D: "Ayakkabılar",
  T_49_META_TYP_243_I3_D: "Yüz Boyası",
  T_49_META_TYP_243_I4_D: "Baş Aksesuarı",
  T_49_META_TYP_243_I5_D: "Tulum",
  T_49_META_TYP_243_I6_D: "Yüz Aksesuarı",
  T_49_META_TYP_244_I0_D: "Görüntülenecek metin",
  T_49_META_TYP_244_I10_D: "Bu varlığı görebilen oyuncuların listesi",
  T_49_META_TYP_244_I11_D: "Hiyerarşiyi Görüntüle",
  T_49_META_TYP_244_I2_D: "Hedef Takip",
  T_49_META_TYP_244_I3_D: "Derinlik göz ardı edildiğinde duvardan görüntülenebilir, aksi takdirde görüntülenemez",
  T_49_META_TYP_244_I4_D: "Her Zaman Videoda",
  T_49_META_TYP_244_I5_D: "Doğru olarak ayarlandığında, konum ekranın dışındayken ekranda görüntülenecektir",
  T_49_META_TYP_244_I6_D: "Yazı Stili",
  T_49_META_TYP_244_I7_D: "Yazı Tipi",
  T_49_META_TYP_244_I8_D: "Yazı tipi boyutu",
  T_49_META_TYP_245_I0_D: "Efekt Kaynak Yolu",
  T_49_META_TYP_245_I11_D: "Hiyerarşiyi Görüntüle",
  T_49_META_TYP_245_I3_D: "Derinlik göz ardı edildiğinde duvardan görüntülenebilir, aksi takdirde görüntülenemez",
  T_49_META_TYP_245_I4_D: "Doğru olarak ayarlandığında, konum ekranın dışındayken ekranda görüntülenecektir",
  T_49_META_TYP_245_I5_D: "Her Zaman Videoda",
  T_49_META_TYP_245_I6_D: "Render Türü",
  T_49_META_TYP_245_I7_D: "Genişlik",
  T_49_META_TYP_246_I0_D: "Turuncu",
  T_49_META_TYP_246_I1_D: "Mor",
  T_49_META_TYP_246_I2_D: "Kırmızı",
  T_49_META_TYP_246_I3_D: "Yeşil",
  T_49_META_TYP_246_I4_D: "Mavi",
  T_49_META_TYP_247_I1_D: "Koşu",
  T_49_META_TYP_247_I14_D: "Duygu İfadesi",
  T_49_META_TYP_247_I15_D: "Hızlı Sohbet",
  T_49_META_TYP_247_I16_D: "Eşyalar",
  T_49_META_TYP_247_I17_D: "Hızlı Sohbet Göster",
  T_49_META_TYP_247_I18_D: "Sağlık Puanı (HP)",
  T_49_META_TYP_247_I19_D: "Enerji Puanı (EP)",
  T_49_META_TYP_247_I2_D: "Saldırı",
  T_49_META_TYP_247_I20_D: "Zırh",
  T_49_META_TYP_247_I21_D: "Şarjör Değiştir",
  T_49_META_TYP_247_I22_D: "Hızlı silah değiştirme düğmesi",
  T_49_META_TYP_247_I23_D: "Araç korna düğmesi açılıp kapatılabilir",
  T_49_META_TYP_247_I24_D: "Ses (mikrofon) açma/kapama düğmesi",
  T_49_META_TYP_247_I25_D: "İşaret düğmesini açma/kapatma",
  T_49_META_TYP_247_I27_D: "Ağ sinyali düğmesi açılıp kapatılabilir",
  T_49_META_TYP_247_I28_D: "Aktif Beceri",
  T_49_META_TYP_247_I29_D: "Nişangah",
  T_49_META_TYP_247_I3_D: "Zıpla",
  T_49_META_TYP_247_I30_D: "Pasif Beceri",
  T_49_META_TYP_247_I4_D: "Öldürme İpuçları",
  T_49_META_TYP_247_I5_D: "Silah Yuvası",
  T_49_META_TYP_247_I6_D: "Mini Harita",
  T_49_META_TYP_247_I7_D: "Sırt Çantası Kullanıcı Arayüzü",
  T_49_META_TYP_247_I8_D: "Tıbbi Eşyalar",
  T_49_META_TYP_247_I9_D: "Doğru ise görüntülenecek, aksi takdirde kapatılacak.",
  T_49_META_TYP_249_I3_D: "Patlayıcı silahlar",
  T_49_META_TYP_249_I5_D: "Ağır Silah",
  T_49_META_TYP_249_I8_D: "Dondurucu bomba",
  T_49_META_TYP_249_I9_D: "Sahte El Bombası",
  T_49_META_TYP_25_I0_D: "İşlem düzenleyicisindeki dizine karşılık gelen geçerli aşamanın dizini",
  T_49_META_TYP_25_I1_D: "Mevcut aşamanın başlangıç saati (ms cinsinden)",
  T_49_META_TYP_25_I2_D: "Mevcut aşamanın bitiş zamanı, ms cinsinden",
  T_49_META_TYP_25_I3_D: "Mevcut fazın süresi, ms cinsinden",
  T_49_META_TYP_250_I1_D: "Özel efekt rengi, RGBA dört kanal, tek kanal değer aralığı 0~255, Int32'de saklanır",
  T_49_META_TYP_250_I3_D: "VFX Doku Türü",
  T_49_META_TYP_250_I4_D: "Diffuse Alpha",
  T_49_META_TYP_2500_I1_D: "Varsayılan Doğuş Noktası mı",
  T_49_META_TYP_2500_I3_D: "Bu spawn bölgesinde doğmuş bir oyuncu var mı?",
  T_49_META_TYP_2500_I4_D: "Şu anda atanabilir doğum noktasının koordinatları",
  T_49_META_TYP_2502_I0_D: "Ölüm tetikleyicisiyse, ölüm tetikleyicisi değilse bile yenilmezlik tetikleyicisidir. (Bu OB32'den kalma bir sorundur, lütfen gelecekte işlevselliği bölün!)",
  T_49_META_TYP_2502_I1_D: "Tetikleyici sınırını görüntülemek isteyip istemediğiniz, doğru görüntüleme anlamına gelir",
  T_49_META_TYP_2503_I0_D: "Kontrol Noktası ID",
  T_49_META_TYP_2503_I2_D: "Kontrol noktası konumu",
  T_49_META_TYP_2507_I0_D: "Savunma kulesi hangi kampa aittir? Eğer oyuncuyla aynı kamptaysa, oyuncuya saldırmaz.",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "Nesne ID",
  T_49_META_TYP_2507_I2_D: "Maks. HP",
  T_49_META_TYP_2507_I3_D: "Saldırı hasarı, tek bir saldırının oyuncuya verebileceği hasar",
  T_49_META_TYP_2507_I4_D: "İki saldırı arasındaki süre (saniye cinsinden)",
  T_49_META_TYP_2507_I5_D: "Merkezi merkez olan ve herhangi bir büyüklükte yarıçapa sahip alan saldırıya uğrayabilir",
  T_49_META_TYP_2507_I6_D: "Hasar azaltma oranı, 1'den küçük bir ondalık sayıdır. Son hasar, hasarın (1-hasar azaltma oranı) ile çarpılmasıyla elde edilir.",
  T_49_META_TYP_2507_I7_D: "Saldırı Hedefi",
  T_49_META_TYP_2507_I8_D: "Açı",
  T_49_META_TYP_2507_I9_D: "Mini Sentry Durumu",
  T_49_META_TYP_2508_I0_D: "Her dalgada ortaya çıkacak zombi sayısı",
  T_49_META_TYP_2508_I1_D: "Kaç tane zombi dalgası oluşacak?",
  T_49_META_TYP_2508_I2_D: "Sürekli üretilecek mi ama aynı ekranda bir sınır olacak mı",
  T_49_META_TYP_2508_I3_D: "Şu anda hangi dalga üretiliyor?",
  T_49_META_TYP_2508_I5_D: "Mevcut dalgada hangi tür zombiler ortaya çıkıyor?",
  T_49_META_TYP_2508_I6_D: "Yapay zeka öldüğünde ekipman veya eşya düşürecek mi?",
  T_49_META_TYP_2508_I7_D: "Doğuş Başlangıç Zamanı (s)",
  T_49_META_TYP_2508_I8_D: "Bir sonraki dalga ile bir önceki dalga arasındaki zaman aralığı",
  T_49_META_TYP_2509_I0_D: "Her dalgada ortaya çıkacak birim sayısı",
  T_49_META_TYP_2509_I1_D: "Toplamda kaç adet ünite jeneratör dalgası üretilecek?",
  T_49_META_TYP_2509_I2_D: "Şu anda hangi dalga üretiliyor?",
  T_49_META_TYP_2509_I4_D: "Oluşturulacak her dalga için şablon olarak hangi varlık kullanılacak?",
  T_49_META_TYP_2509_I5_D: "Birim oluşturma zamanı",
  T_49_META_TYP_2509_I6_D: "Sürekli üretilecek mi ama aynı ekranda bir sınır olacak mı",
  T_49_META_TYP_2509_I7_D: "Bir sonraki dalga ile bir önceki dalga arasındaki zaman aralığı",
  T_49_META_TYP_2509_I8_D: "Şablonun prefabID'si",
  T_49_META_TYP_2510_I0_D: "Doğuş Noktası Sayısı",
  T_49_META_TYP_252_I1_D: "Sol İkon",
  T_49_META_TYP_252_I2_D: "Sol Metin",
  T_49_META_TYP_252_I3_D: "Sol Skor",
  T_49_META_TYP_252_I5_D: "Sağ İkon",
  T_49_META_TYP_252_I6_D: "Sağ Metin",
  T_49_META_TYP_252_I7_D: "Sağ Skor",
  T_49_META_TYP_252_I8_D: "İlerleme [0,1]",
  T_49_META_TYP_253_I0_D: "Simge Seç",
  T_49_META_TYP_253_I1_D: "Metin",
  T_49_META_TYP_253_I2_D: "Etki Aktif",
  T_49_META_TYP_253_I3_D: "UI Konumu",
  T_49_META_TYP_254_I1_D: "Örneğin, 1.25 normal hızın 1.25 katı anlamına gelir",
  T_49_META_TYP_254_I2_D: "Renk",
  T_49_META_TYP_256_I0_D: "Tamamen hareketsiz. En ekonomik performans",
  T_49_META_TYP_256_I1_D: "Kuvveti normal şekilde uygulayın. En çok performans tüketen",
  T_49_META_TYP_256_I2_D: "Hareket, senaryolarla kontrol edilebilir ve kütle sonsuz olarak düşünülebilir",
  T_49_META_TYP_257_I0_D: "Farklı tipteki katı cisimlerin farklı işlevleri vardır",
  T_49_META_TYP_257_I1_D: "Yer Çekimi Kullan",
  T_49_META_TYP_257_I2_D: "Kütle (kg), minimum etkili kütle 0,001kg'dır. 0 ise, sonsuz kütle anlamına gelir ve kuvvet altında hareket etmeyecektir",
  T_49_META_TYP_257_I3_D: "Ağırlık merkezi konumu, yerel koordinat sistemi",
  T_49_META_TYP_257_I4_D: "Katı cisim hareketinin doğrusal hızı",
  T_49_META_TYP_257_I5_D: "Katı bir cismin açısal hızı",
  T_49_META_TYP_257_I6_D: "Doğrusal hızın doğal zayıflama katsayısı. Katsayı ne kadar büyükse, hareket hızı o kadar hızlı azalır.",
  T_49_META_TYP_257_I7_D: "Açısal hızın doğal zayıflama katsayısı. Katsayı ne kadar büyükse, hareket hızı o kadar hızlı azalır.",
  T_49_META_TYP_257_I8_D: "Katı gövdeye uygulanan kısıtlamalar RigidbodyConstrainType koleksiyonudur",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Arka Plan",
  T_49_META_TYP_259_I1_D: "Metin",
  T_49_META_TYP_259_I2_D: "UI Konumu",
  T_49_META_TYP_259_I4_D: "Metin Rengi",
  T_49_META_TYP_260_I0_D: "Simge Seç",
  T_49_META_TYP_260_I1_D: "İlerleme çubuğu rengi",
  T_49_META_TYP_260_I2_D: "Değer",
  T_49_META_TYP_260_I3_D: "Hız, m/sn",
  T_49_META_TYP_260_I4_D: "Özel efektlerin gösterilip gösterilmeyeceği",
  T_49_META_TYP_260_I5_D: "Kullanıcı arayüzü konumu [0,1]",
  T_49_META_TYP_260_I6_D: "Becerinin başlangıç ilerlemesi, değeri [0, 1]'dir. Kullanıcı arayüzü oluşturulduktan sonra, ilerleme hemen geçerli ilerlemeyle senkronize edilecektir",
  T_49_META_TYP_260_I7_D: "Etki Rengi",
  T_49_META_TYP_260_I8_D: "Nesnenin ölçek değerini ayarlayın",
  T_49_META_TYP_265_I1_D: "Arka plan doldurma işlemi yapılıp yapılmayacağı",
  T_49_META_TYP_265_I2_D: "Arka Plan Adı",
  T_49_META_TYP_265_I3_D: "Arka Plan Rengi",
  T_49_META_TYP_265_I5_D: "BgAlfa",
  T_49_META_TYP_265_I6_D: "Kesim Tipi",
  T_49_META_TYP_265_I7_D: "Maske türü, maskeleme sırasında seçilen görüntünün adıdır",
  T_49_META_TYP_265_I8_D: "Kenar Yumuşatma Ünitesi",
  T_49_META_TYP_267_I0_D: "Kaydırma başlangıç noktası, varsayılan sol üst köşedir",
  T_49_META_TYP_267_I1_D: "Birden fazla kaydırma yönünü destekler",
  T_49_META_TYP_267_I10_D: "Yatay Çubuk",
  T_49_META_TYP_267_I11_D: "Konum Göster",
  T_49_META_TYP_267_I2_D: "Bileşeni XY yönünde sürükleyin",
  T_49_META_TYP_267_I3_D: "Çoklu sürükleme efektlerini destekler",
  T_49_META_TYP_267_I4_D: "Kaydırma faktörü, değer ne kadar büyük olursa kaydırma o kadar hızlı olur",
  T_49_META_TYP_267_I5_D: "Eylemsizlik faktörü, değer ne kadar büyük olursa yuvarlanma sırasındaki eylemsizlik de o kadar büyük olur.",
  T_49_META_TYP_267_I6_D: "Sürüklemenin varsayılan olarak seçili olan görünüm alanıyla sınırlı olup olmadığı",
  T_49_META_TYP_267_I7_D: "İşaretlendiğinde, sürükleme yavaş çekimde başlayacaktır, işaretlenmediğinde ise sürükleme fare hareketinin hızında başlayacaktır",
  T_49_META_TYP_267_I8_D: "Görünüm alanına sığdığında sürüklemeyi bırakın",
  T_49_META_TYP_267_I9_D: "Dikey Çubuk",
  T_49_META_TYP_268_I0_D: "Varsayılan",
  T_49_META_TYP_268_I1_D: "Kapat",
  T_49_META_TYP_268_I2_D: "Göster",
  T_49_META_TYP_269_I0_D: "Sahip",
  T_49_META_TYP_269_I1_D: "Kimlik Ayarla",
  T_49_META_TYP_269_I2_D: "Başlık Kimliği",
  T_49_META_TYP_269_I3_D: "Yüz Kimliği",
  T_49_META_TYP_269_I4_D: "Makyaj Kimliği",
  T_49_META_TYP_269_I5_D: "Üst gövde kimliği",
  T_49_META_TYP_269_I6_D: "Alt gövde kimliği",
  T_49_META_TYP_269_I7_D: "Ayakkabı kimliği",
  T_49_META_TYP_272_I0_D: "Kadın",
  T_49_META_TYP_272_I1_D: "Erkek",
  T_49_META_TYP_273_I0_D: "Küçük haritanın merkezine karşılık gelen dünya koordinatları",
  T_49_META_TYP_273_I1_D: "Küçük haritanın boyutu, genişliği ve yüksekliği aynıdır",
  T_49_META_TYP_273_I2_D: "Mini harita derinlik haritası görüntüleme modunun etkinleştirilip etkinleştirilmeyeceği",
  T_49_META_TYP_274_I1_D: "Ölçekleme",
  T_49_META_TYP_274_I4_D: "Simge Görüntüleme Seviyesi",
  T_49_META_TYP_275_I0_D: "Kemik Ölçeklendirme",
  T_49_META_TYP_275_I1_D: "Kemik düğümünün dünya koordinatları",
  T_49_META_TYP_276_I0_D: "KAFA",
  T_49_META_TYP_276_I1_D: "Sol Kol",
  T_49_META_TYP_276_I2_D: "Sol El",
  T_49_META_TYP_276_I3_D: "Sağ Kol",
  T_49_META_TYP_276_I4_D: "Sağ El",
  T_49_META_TYP_276_I5_D: "Gövde",
  T_49_META_TYP_276_I6_D: "Sol Bacak",
  T_49_META_TYP_276_I7_D: "Sol Ayak",
  T_49_META_TYP_276_I8_D: "Sağ Bacak",
  T_49_META_TYP_276_I9_D: "Sağ Ayak",
  T_49_META_TYP_277_I1_D: "Kamera ışın tespitinin mesafesi",
  T_49_META_TYP_277_I2_D: "Kamera ışın algılama için çarpışma katmanı maskesi",
  T_49_META_TYP_277_I3_D: "Düğme konum ofseti",
  T_49_META_TYP_277_I4_D: "Simge Kaynak Kimliği",
  T_49_META_TYP_277_I5_D: "Tıklama alanı boyutu",
  T_49_META_TYP_277_I6_D: "Nesnenin hedef noktada görüntülenip görüntülenmeyeceği",
  T_49_META_TYP_277_I7_D: "Hedef nokta görüntüleme nesnesi",
  T_49_META_TYP_278_I0_D: "Harita piksellerini oluşturmak için hedef varlık",
  T_49_META_TYP_28_I0_D: "Her turda sıfırlanabilir mi?",
  T_49_META_TYP_280_I0_D: "Küre Yarıçapı",
  T_49_META_TYP_281_I0_D: "Kapsülün her iki ucundaki yarım kürelerin yarıçapı",
  T_49_META_TYP_29_I0_D: "Küre",
  T_49_META_TYP_29_I1_D: "Işık Işını",
  T_49_META_TYP_29_I10_D: "Ayak tabanındaki ışık sütunu artık bitiş çizgisine girerken geri bildirim için kullanılıyor",
  T_49_META_TYP_29_I11_D: "Donma",
  T_49_META_TYP_29_I12_D: "Işık",
  T_49_META_TYP_29_I13_D: "Yükselen Akıntı",
  T_49_META_TYP_29_I14_D: "Gaz Patlaması",
  T_49_META_TYP_29_I15_D: "Saklanan Öldürüldü",
  T_49_META_TYP_29_I16_D: "Çılgınlık",
  T_49_META_TYP_29_I17_D: "Klon Ölümü",
  T_49_META_TYP_29_I18_D: "Ateş Etme Geri Bildirimi",
  T_49_META_TYP_29_I19_D: "Klon Ölümü",
  T_49_META_TYP_29_I2_D: "Patlama",
  T_49_META_TYP_29_I20_D: "Klon",
  T_49_META_TYP_29_I21_D: "Portal",
  T_49_META_TYP_29_I22_D: "El Feneri Dumanı",
  T_49_META_TYP_29_I23_D: "Ateş Topu",
  T_49_META_TYP_29_I24_D: "Döngüsel Yanma",
  T_49_META_TYP_29_I25_D: "Zehirli Gaz",
  T_49_META_TYP_29_I26_D: "Kalp",
  T_49_META_TYP_29_I29_D: "Kapı",
  T_49_META_TYP_29_I30_D: "Havai Fişek",
  T_49_META_TYP_29_I31_D: "Koşu Ayakkabısı VFX",
  T_49_META_TYP_29_I32_D: "Patlama VFX",
  T_49_META_TYP_29_I33_D: "Yeniden Doğma Noktası VFX",
  T_49_META_TYP_29_I34_D: "Lazer VFX",
  T_49_META_TYP_29_I35_D: "Yetenek Kullanma VFX",
  T_49_META_TYP_29_I36_D: "Mermi VFX",
  T_49_META_TYP_29_I37_D: "Mermi Çarpma VFX",
  T_49_META_TYP_29_I38_D: "Ateş Etme VFX",
  T_49_META_TYP_29_I39_D: "Yetenek VFX",
  T_49_META_TYP_29_I40_D: "Halka",
  T_49_META_TYP_29_I41_D: "kabarcık",
  T_49_META_TYP_29_I42_D: "Duman ve Toz",
  T_49_META_TYP_29_I43_D: "Uçan Parçacıklar",
  T_49_META_TYP_29_I44_D: "astar",
  T_49_META_TYP_29_I45_D: "Titreme",
  T_49_META_TYP_29_I47_D: "Yükselen Partiküller",
  T_49_META_TYP_29_I48_D: "Duman",
  T_49_META_TYP_29_I49_D: "Tılsım",
  T_49_META_TYP_29_I50_D: "Donmuş Alan",
  T_49_META_TYP_29_I51_D: "Sis",
  T_49_META_TYP_29_I52_D: "Kar Tanesi",
  T_49_META_TYP_29_I53_D: "Ateş",
  T_49_META_TYP_29_I54_D: "Işık Işını",
  T_49_META_TYP_29_I55_D: "Zehirli Gaz Yayılması",
  T_49_META_TYP_29_I56_D: "Zehirli Gaz",
  T_49_META_TYP_29_I57_D: "Patlama Alevleri",
  T_49_META_TYP_29_I58_D: "Işık Efekti",
  T_49_META_TYP_29_I59_D: "Yıldız",
  T_49_META_TYP_29_I6_D: "Ayaklarınızın altındaki hale",
  T_49_META_TYP_29_I60_D: "Yanmakta Olan Ateş",
  T_49_META_TYP_29_I61_D: "Su Sıçraması",
  T_49_META_TYP_29_I62_D: "Elektrik Şoku",
  T_49_META_TYP_29_I63_D: "Mürekkep VFX",
  T_49_META_TYP_29_I64_D: "Kara Delik VFX",
  T_49_META_TYP_29_I65_D: "Kara Delik Patlama VFX",
  T_49_META_TYP_29_I66_D: "Kristal Top VFX",
  T_49_META_TYP_29_I67_D: "Lazer mermi özel efektleri",
  T_49_META_TYP_29_I68_D: "Takip etkisi",
  T_49_META_TYP_29_I69_D: "Bulut etkileri",
  T_49_META_TYP_29_I7_D: "Zemin İşareti",
  T_49_META_TYP_29_I8_D: "Duman",
  T_49_META_TYP_29_I9_D: "Tılsım Patlaması",
  T_49_META_TYP_290_I0_D: "Yenileme aralığı, sayı ne kadar büyükse yenileme o kadar yavaştır (milisaniye cinsinden)",
  T_49_META_TYP_290_I1_D: "Hata ayıklamanın etkinleştirilip etkinleştirilmeyeceği",
  T_49_META_TYP_291_I0_D: "KoşulDüğümü",
  T_49_META_TYP_291_I1_D: "EylemDüğümü",
  T_49_META_TYP_293_I0_D: "Davranış Ağacı ID",
  T_49_META_TYP_293_I1_D: "Ekleme Hedefi",
  T_49_META_TYP_294_I1_D: "Düzen Türü",
  T_49_META_TYP_294_I10_D: "Sıralama Türü",
  T_49_META_TYP_294_I2_D: "İçerik Kökeni",
  T_49_META_TYP_294_I3_D: "Düzenleme yönü",
  T_49_META_TYP_294_I4_D: "Alt öğe ızgarasının genişliği ve yüksekliği",
  T_49_META_TYP_294_I5_D: "Hücre Boşluğu",
  T_49_META_TYP_294_I6_D: "Kısıtlama",
  T_49_META_TYP_294_I7_D: "Kısıtlama Sayısı",
  T_49_META_TYP_294_I8_D: "Dikey ofset",
  T_49_META_TYP_294_I9_D: "Yatay ofset",
  T_49_META_TYP_295_I2_D: "Oynatma Hızı",
  T_49_META_TYP_296_I1_D: "Klip Uzunluğu",
  T_49_META_TYP_297_I0_D: "Bağlı Nesne",
  T_49_META_TYP_297_I4_D: "Kaynak ID",
  T_49_META_TYP_298_I0_D: "Varsayılan",
  T_49_META_TYP_298_I2_D: "Bir kez",
  T_49_META_TYP_30_I0_D: "Kare",
  T_49_META_TYP_30_I1_D: "Dörtgen",
  T_49_META_TYP_30_I10_D: "Ok",
  T_49_META_TYP_30_I11_D: "Çağrı",
  T_49_META_TYP_30_I12_D: "Kaya",
  T_49_META_TYP_30_I13_D: "Makas",
  T_49_META_TYP_30_I14_D: "Kağıt",
  T_49_META_TYP_30_I15_D: "Beğen",
  T_49_META_TYP_30_I16_D: "Doğru",
  T_49_META_TYP_30_I17_D: "Yanlış",
  T_49_META_TYP_30_I18_D: "Artı",
  T_49_META_TYP_30_I19_D: "yıldırım",
  T_49_META_TYP_30_I2_D: "Dik Üçgen Trapez",
  T_49_META_TYP_30_I20_D: "Kalp",
  T_49_META_TYP_30_I21_D: "yıldız",
  T_49_META_TYP_30_I22_D: "Ay",
  T_49_META_TYP_30_I23_D: "Güneş",
  T_49_META_TYP_30_I24_D: "Gözlük",
  T_49_META_TYP_30_I25_D: "Anahtar",
  T_49_META_TYP_30_I26_D: "Kupa",
  T_49_META_TYP_30_I27_D: "Bayrak",
  T_49_META_TYP_30_I28_D: "Kum Saati",
  T_49_META_TYP_30_I29_D: "Klasör",
  T_49_META_TYP_30_I3_D: "Trapez",
  T_49_META_TYP_30_I30_D: "Açık Klasör",
  T_49_META_TYP_30_I31_D: "Ev",
  T_49_META_TYP_30_I32_D: "Dinlenme",
  T_49_META_TYP_30_I33_D: "Yenile",
  T_49_META_TYP_30_I34_D: "Döngü",
  T_49_META_TYP_30_I35_D: "Büyüteç",
  T_49_META_TYP_30_I36_D: "Çöp Kutusu",
  T_49_META_TYP_30_I37_D: "Geri Dön",
  T_49_META_TYP_30_I38_D: "Elmas",
  T_49_META_TYP_30_I39_D: "Yüzme Halkası",
  T_49_META_TYP_30_I4_D: "Altıgen",
  T_49_META_TYP_30_I40_D: "Para",
  T_49_META_TYP_30_I41_D: "Kilit",
  T_49_META_TYP_30_I42_D: "Ayarlar",
  T_49_META_TYP_30_I43_D: "Çıkış",
  T_49_META_TYP_30_I44_D: "Diyalog",
  T_49_META_TYP_30_I45_D: "Nişangah",
  T_49_META_TYP_30_I46_D: "silah",
  T_49_META_TYP_30_I47_D: "Kılıç",
  T_49_META_TYP_30_I48_D: "Patlama",
  T_49_META_TYP_30_I49_D: "Hedefleme",
  T_49_META_TYP_30_I5_D: "Yuvarlak",
  T_49_META_TYP_30_I50_D: "Çarpı",
  T_49_META_TYP_30_I51_D: "Savunma",
  T_49_META_TYP_30_I52_D: "Canavar",
  T_49_META_TYP_30_I53_D: "Geri Dönüşüm",
  T_49_META_TYP_30_I54_D: "Hediye",
  T_49_META_TYP_30_I55_D: "Kıyafet",
  T_49_META_TYP_30_I56_D: "Oyun",
  T_49_META_TYP_30_I57_D: "Oyuncu",
  T_49_META_TYP_30_I58_D: "Mağaza",
  T_49_META_TYP_30_I59_D: "çıkış",
  T_49_META_TYP_30_I6_D: "Üçgen",
  T_49_META_TYP_30_I60_D: "Uyarı",
  T_49_META_TYP_30_I61_D: "Metin",
  T_49_META_TYP_30_I62_D: "Zamanlayıcı Nesnesi",
  T_49_META_TYP_30_I63_D: "Zil",
  T_49_META_TYP_30_I64_D: "Evcil Hayvan",
  T_49_META_TYP_30_I65_D: "bomba",
  T_49_META_TYP_30_I66_D: "Onarım",
  T_49_META_TYP_30_I67_D: "Gülümseyen Yüz",
  T_49_META_TYP_30_I68_D: "Hoparlör",
  T_49_META_TYP_30_I7_D: "Ünlem İşareti",
  T_49_META_TYP_30_I70_D: "Taç",
  T_49_META_TYP_30_I71_D: "Savaş",
  T_49_META_TYP_30_I72_D: "Lonca",
  T_49_META_TYP_30_I73_D: "Kalp Atışı",
  T_49_META_TYP_30_I74_D: "Müzik",
  T_49_META_TYP_30_I75_D: "Araç",
  T_49_META_TYP_30_I76_D: "Yakın Dövüş Silahı",
  T_49_META_TYP_30_I77_D: "Tabanca",
  T_49_META_TYP_30_I78_D: "Tüfek",
  T_49_META_TYP_30_I79_D: "Keskin Nişancı Tüfeği",
  T_49_META_TYP_30_I8_D: "Soru İşareti",
  T_49_META_TYP_30_I80_D: "Pompalı Tüfek",
  T_49_META_TYP_30_I81_D: "MP5",
  T_49_META_TYP_30_I82_D: "Şifa Tabancası",
  T_49_META_TYP_30_I83_D: "Zırh Kırma",
  T_49_META_TYP_30_I84_D: "Baş vuruşu",
  T_49_META_TYP_30_I85_D: "Yetenek 1",
  T_49_META_TYP_30_I86_D: "Yetenek 2",
  T_49_META_TYP_30_I87_D: "Yetenek 3",
  T_49_META_TYP_30_I88_D: "Yetenek 4",
  T_49_META_TYP_30_I89_D: "Yetenek 5",
  T_49_META_TYP_30_I9_D: "İşaret",
  T_49_META_TYP_30_I90_D: "Yetenek 6",
  T_49_META_TYP_30_I91_D: "Yetenek 7",
  T_49_META_TYP_30_I92_D: "Yetenek 8",
  T_49_META_TYP_30_I93_D: "Yetenek 9",
  T_49_META_TYP_30_I94_D: "Yetenek 10",
  T_49_META_TYP_300_I0_D: "Kaynak ID",
  T_49_META_TYP_300_I2_D: "Dönme",
  T_49_META_TYP_300_I3_D: "Oluşturulan Varlık",
  T_49_META_TYP_301_I1_D: "Kendini Patlatma",
  T_49_META_TYP_301_I2_D: "Yüksek Hızlı Saldırı",
  T_49_META_TYP_301_I3_D: "Şok Dalgası",
  T_49_META_TYP_301_I4_D: "Rüzgar Saldırısı",
  T_49_META_TYP_301_I5_D: "Zıplama Saldırısı",
  T_49_META_TYP_301_I6_D: "Kalkanı Yükselt",
  T_49_META_TYP_301_I7_D: "Kalkan Kırıldı",
  T_49_META_TYP_302_I5_D: "Çanta",
  T_49_META_TYP_302_I7_D: "Kaykay, kamuflaj...",
  T_49_META_TYP_303_I0_D: "Maks. Oyuncu CP Ekle",
  T_49_META_TYP_303_I1_D: "Sürekli Olarak CP Doldur",
  T_49_META_TYP_305_I0_D: "Bitir",
  T_49_META_TYP_305_I1_D: "Koşma",
  T_49_META_TYP_307_I0_D: "Hasar Başına Deneyim Puanı",
  T_49_META_TYP_307_I1_D: "Hareket Edilen Mesafe Başına Deneyim Puanı",
  T_49_META_TYP_307_I2_D: "Saniye Başına Deneyim Puanı",
  T_49_META_TYP_307_I3_D: "Çip Deneyimi",
  T_49_META_TYP_307_I4_D: "Maks. Yük",
  T_49_META_TYP_308_I0_D: "Jel Üreticisi",
  T_49_META_TYP_31_I0_D: "El bombası patlaması",
  T_49_META_TYP_31_I1_D: "Silah sesi",
  T_49_META_TYP_31_I10_D: "Hasara neden olan vurma sesi efekti",
  T_49_META_TYP_31_I11_D: "Geliştirilmiş ses efektleri",
  T_49_META_TYP_31_I12_D: "Zayıf tıklama sesi efekti",
  T_49_META_TYP_31_I13_D: "Oyuncu mekanizma ses efektine basıyor",
  T_49_META_TYP_31_I14_D: "Ekipman onarım ses efekti",
  T_49_META_TYP_31_I15_D: "Ekipman onarım ses efekti",
  T_49_META_TYP_31_I16_D: "Hatalı veya eksik ses efektleri",
  T_49_META_TYP_31_I17_D: "Hatırlatma ses efekti",
  T_49_META_TYP_31_I18_D: "Futbol iniş ses efekti",
  T_49_META_TYP_31_I19_D: "Tezahürat ses efekti",
  T_49_META_TYP_31_I2_D: "Geri Sayım Bip Sesi",
  T_49_META_TYP_31_I20_D: "Bomba uyarı ses efekti",
  T_49_META_TYP_31_I21_D: "Bomba patlama sesi efekti",
  T_49_META_TYP_31_I22_D: "Hunter ses efekti beliriyor",
  T_49_META_TYP_31_I23_D: "Son bgm ses efekti",
  T_49_META_TYP_31_I24_D: "Tedarik kutusu yenileme ses efekti",
  T_49_META_TYP_31_I25_D: "Hızlandırıcı ses efektleri",
  T_49_META_TYP_31_I26_D: "Kaybolma hatırlatıcı ses efekti",
  T_49_META_TYP_31_I27_D: "Görsel efektler ses efektleri",
  T_49_META_TYP_31_I28_D: "Gece böcek ses efektleri",
  T_49_META_TYP_31_I29_D: "Donuk vurma sesi efekti",
  T_49_META_TYP_31_I3_D: "UI Dokunuşu",
  T_49_META_TYP_31_I30_D: "Duyarlı ses efektleri",
  T_49_META_TYP_31_I31_D: "Şaşırtıcı ses efektlerini keşfedin",
  T_49_META_TYP_31_I32_D: "Küçük hayalet ses efekti çalıyor",
  T_49_META_TYP_31_I33_D: "Faz başlangıç ses efekti",
  T_49_META_TYP_31_I34_D: "Zombi ses efektleri",
  T_49_META_TYP_31_I35_D: "Korku ses efektleri",
  T_49_META_TYP_31_I36_D: "Dönüşüm ses efektleri",
  T_49_META_TYP_31_I37_D: "Hızlı kalp atışı ses efekti",
  T_49_META_TYP_31_I38_D: "Orta hız kalp atışı ses efekti",
  T_49_META_TYP_31_I39_D: "Yavaş kalp atışı ses efekti",
  T_49_META_TYP_31_I4_D: "Kadın Vurulma Çığlığı",
  T_49_META_TYP_31_I40_D: "Öfke ses efektleri",
  T_49_META_TYP_31_I41_D: "Tıklama sesi efekti",
  T_49_META_TYP_31_I42_D: "Beceri kurtarma ses efekti",
  T_49_META_TYP_31_I43_D: "Oyun ses efektleri eklendi",
  T_49_META_TYP_31_I44_D: "Mekanik yankı ses efekti",
  T_49_META_TYP_31_I45_D: "Sivrisinek ses efekti",
  T_49_META_TYP_31_I46_D: "Yoğun Ding Ding Ding 1 ses efekti",
  T_49_META_TYP_31_I47_D: "Yoğun Ding Ding Ding 2 ses efektleri",
  T_49_META_TYP_31_I48_D: "Mekanizma açılış ses efekti",
  T_49_META_TYP_31_I49_D: "Şarj ses efekti 1",
  T_49_META_TYP_31_I5_D: "Erkek Vurulma Çığlığı",
  T_49_META_TYP_31_I50_D: "Adım sesleri ses efektini tetikler",
  T_49_META_TYP_31_I51_D: "Görev başarı istemi 1 ses efekti",
  T_49_META_TYP_31_I52_D: "Tehlike uyarı sesi 1 ses efekti",
  T_49_META_TYP_31_I53_D: "Tehlike uyarı sesi 2 ses efekti",
  T_49_META_TYP_31_I54_D: "Geri sayım 3 ses efekti",
  T_49_META_TYP_31_I55_D: "İpuçlarını Göster ses efekti",
  T_49_META_TYP_31_I56_D: "Kargaların çağrışımının ortam ses efekti",
  T_49_META_TYP_31_I57_D: "Teleporter kullanılarak yanlış alana ışınlanmanın ses efekti",
  T_49_META_TYP_31_I58_D: "Teleport noktasını kullanarak doğru alana teleport olmanın ses efekti",
  T_49_META_TYP_31_I59_D: "Sesi iletmek",
  T_49_META_TYP_31_I6_D: "Altın para alma ses efekti",
  T_49_META_TYP_31_I60_D: "Elektrik şoku ses efekti",
  T_49_META_TYP_31_I61_D: "Sahne ses efektlerini al",
  T_49_META_TYP_31_I62_D: "Elektronik rüya gibi sevimli arka plan müziği ses efektleri",
  T_49_META_TYP_31_I63_D: "Gündelik oyun arka plan müziği ses efektleri",
  T_49_META_TYP_31_I64_D: "Kutu Aç",
  T_49_META_TYP_31_I65_D: "Seviye Atlama",
  T_49_META_TYP_31_I66_D: "Maks. Seviye",
  T_49_META_TYP_31_I67_D: "Düğmeye Dokun",
  T_49_META_TYP_31_I68_D: "Geri Sayım",
  T_49_META_TYP_31_I69_D: "Düşmanı Yen",
  T_49_META_TYP_31_I7_D: "Yarışta bitiş çizgisini geçmek için tetikleyici ses efekti",
  T_49_META_TYP_31_I70_D: "Bitir",
  T_49_META_TYP_31_I71_D: "İleri",
  T_49_META_TYP_31_I72_D: "Zafer",
  T_49_META_TYP_31_I73_D: "Eğitim Üssü Kontrol Noktası",
  T_49_META_TYP_31_I74_D: "Geri Sayım",
  T_49_META_TYP_31_I75_D: "Oyun Başlangıcı",
  T_49_META_TYP_31_I76_D: "Büyük Altın Al",
  T_49_META_TYP_31_I77_D: "Orta Altın Al",
  T_49_META_TYP_31_I78_D: "Küçük Altın Al",
  T_49_META_TYP_31_I79_D: "Çatışmaya Katıl",
  T_49_META_TYP_31_I8_D: "Tetikleyici ses efekti",
  T_49_META_TYP_31_I80_D: "Lonca Tedariki",
  T_49_META_TYP_31_I81_D: "Hoparlör",
  T_49_META_TYP_31_I82_D: "Lonca Liderini Görevden Alma",
  T_49_META_TYP_31_I83_D: "Depo Kaydet",
  T_49_META_TYP_31_I84_D: "Özel Silah Sesi",
  T_49_META_TYP_31_I85_D: "Kurşun Iskalamak",
  T_49_META_TYP_31_I86_D: "Hareket Et",
  T_49_META_TYP_31_I87_D: "Devre Dışı Bırakma Düğmesine Dokun",
  T_49_META_TYP_31_I88_D: "Yetenek Şarjı Tamamlandı",
  T_49_META_TYP_31_I89_D: "Lazer Yetenek",
  T_49_META_TYP_31_I9_D: "Bozulmuş ses efektleri",
  T_49_META_TYP_31_I90_D: "Tüketilebilir Eşya 2 Al",
  T_49_META_TYP_31_I91_D: "Geri Sayım 3",
  T_49_META_TYP_31_I92_D: "Oyun Sonu 2",
  T_49_META_TYP_31_I93_D: "Öldürme İpucu",
  T_49_META_TYP_31_I94_D: "Patlama",
  T_49_META_TYP_31_I95_D: "Enerji Küresi Yetenek",
  T_49_META_TYP_31_I96_D: "Kan Havuzu Yetenek",
  T_49_META_TYP_311_I1_D: "Maksimum Hasar",
  T_49_META_TYP_311_I3_D: "Atılan cismin elden çıktıktan sonraki uçuş hızı (m/s)",
  T_49_META_TYP_311_I4_D: "Atılan nesnenin serbest bırakıldığı andan itibaren etkisini gösterdiği ana kadar geçen zaman aralığı (saniye cinsinden)",
  T_49_META_TYP_313_I0_D: "Bölge Yarıçapı",
  T_49_META_TYP_313_I1_D: "Sayaç bölgesinin süresi, saniye cinsinden",
  T_49_META_TYP_314_I0_D: "Animasyon denetleyicisi kaynak kimliği",
  T_49_META_TYP_314_I1_D: "Animasyon Kumandası",
  T_49_META_TYP_315_I0_D: "Sırt çantası sahibi",
  T_49_META_TYP_315_I1_D: "Sırt çantası alanı",
  T_49_META_TYP_315_I2_D: "Kullanılan Kapasite",
  T_49_META_TYP_315_I3_D: "Tüm Tedarikler",
  T_49_META_TYP_316_I0_D: "Doku Kaynağı",
  T_49_META_TYP_316_I1_D: "Shader Adı",
  T_49_META_TYP_316_I11_D: "Çevirme yöntemi",
  T_49_META_TYP_316_I2_D: "UV Kaydırma",
  T_49_META_TYP_316_I3_D: "UV Boyutu",
  T_49_META_TYP_316_I4_D: "Doldurma Türü",
  T_49_META_TYP_316_I5_D: "Sol Sağ Kenar",
  T_49_META_TYP_316_I6_D: "Üst Alt Kenar",
  T_49_META_TYP_317_I0_D: "Hiçbiri",
  T_49_META_TYP_317_I1_D: "Donma Pozisyonu X",
  T_49_META_TYP_317_I2_D: "Donma Pozisyonu Y",
  T_49_META_TYP_317_I3_D: "Donma Pozisyonu Z",
  T_49_META_TYP_317_I4_D: "X ekseni etrafındaki dönüşü sınırla",
  T_49_META_TYP_317_I5_D: "Y ekseni etrafındaki dönüşü sınırla",
  T_49_META_TYP_317_I6_D: "Z ekseni etrafındaki dönüşü sınırla",
  T_49_META_TYP_317_I7_D: "Donma Pozisyonu",
  T_49_META_TYP_317_I8_D: "Donma Rotasyonu",
  T_49_META_TYP_317_I9_D: "Tümünü Dondur",
  T_49_META_TYP_318_I0_D: "Menzil",
  T_49_META_TYP_318_I1_D: "Tam Hasar Mesafesi",
  T_49_META_TYP_318_I10_D: "Oyuncu Nişan Alma Hızı Faktörü",
  T_49_META_TYP_318_I11_D: "Görüş Büyütme Oranı",
  T_49_META_TYP_318_I12_D: "FOV Büyütme",
  T_49_META_TYP_318_I13_D: "ADS Büyütme",
  T_49_META_TYP_318_I14_D: "ADS Büyütme Süresi (s)",
  T_49_META_TYP_318_I15_D: "ADS Kurtarma Süresi (s)",
  T_49_META_TYP_318_I16_D: "Kapsam için minimum hasar mesafesi düzeltme faktörü",
  T_49_META_TYP_318_I17_D: "ADS Nişan Yardımını Etkinleştir",
  T_49_META_TYP_318_I18_D: "Nişan Yardımı Ekran Alanı Çekim Oranı (0-1)",
  T_49_META_TYP_318_I19_D: "Nişan Yardımı Mesafe Azaltma Katsayısı (0-1)",
  T_49_META_TYP_318_I2_D: "Minimum Hasar Mesafesi",
  T_49_META_TYP_318_I20_D: "Nişan Yardımı Mesafesi Önceliğini Etkinleştir",
  T_49_META_TYP_318_I21_D: "Nişan Yardımı Minimum Mesafe Önceliği",
  T_49_META_TYP_318_I22_D: "Nişan Yardımı Maksimum Mesafe Önceliği",
  T_49_META_TYP_318_I23_D: "Nişan Yardımı Mesafe Etki Katsayısı (>=1)",
  T_49_META_TYP_318_I24_D: "ADS Döndürme Hassasiyeti",
  T_49_META_TYP_318_I25_D: "Yakınsama Oranı",
  T_49_META_TYP_318_I3_D: "Şarjör Boyutu",
  T_49_META_TYP_318_I4_D: "Saldırı Aralığı",
  T_49_META_TYP_318_I5_D: "Yeniden Doldurma Hızı",
  T_49_META_TYP_318_I6_D: "Otomatik Yeniden Doldurma Hızı",
  T_49_META_TYP_318_I7_D: "Dağılma Hızı",
  T_49_META_TYP_318_I8_D: "Çömelirken veya uzanırken dağılım oranı. Her 0.1, nişangah menzilinin her mermi için %10 arttığı anlamına gelir.",
  T_49_META_TYP_318_I9_D: "Maksimum Dağılma",
  T_49_META_TYP_319_I0_D: "Basit",
  T_49_META_TYP_319_I1_D: "Dilimlenmiş",
  T_49_META_TYP_319_I2_D: "Döşenmiş",
  T_49_META_TYP_319_I3_D: "Dolgulu",
  T_49_META_TYP_319_I4_D: "Uygun",
  T_49_META_TYP_32_I0_D: "Oyuncu normal aktif durumdadır",
  T_49_META_TYP_32_I1_D: "Oyuncu yere serilmiş durumda",
  T_49_META_TYP_32_I2_D: "Oyuncu ölü durumdadır",
  T_49_META_TYP_320_I0_D: "Yatay",
  T_49_META_TYP_320_I1_D: "Dikey",
  T_49_META_TYP_320_I2_D: "Radyal 90°",
  T_49_META_TYP_320_I3_D: "Radyal 180°",
  T_49_META_TYP_320_I4_D: "Radyal 360°",
  T_49_META_TYP_321_I0_D: "Nişan yardımını tetiklemek için maksimum mesafe",
  T_49_META_TYP_321_I1_D: "Destekli nişan alma tetiklendiğinde çapraz saç ofseti. Ofset noktası varlıkta değilse, destekli nişan alma başarısız olur.",
  T_49_META_TYP_322_I0_D: "hiçbiri",
  T_49_META_TYP_322_I1_D: "KAFA",
  T_49_META_TYP_322_I2_D: "Gövde",
  T_49_META_TYP_322_I3_D: "Uzuv",
  T_49_META_TYP_323_I0_D: "Ölçek",
  T_49_META_TYP_323_I1_D: "Hesap ID",
  T_49_META_TYP_323_I2_D: "Oyuncu Profil Bilgileri",
  T_49_META_TYP_323_I3_D: "Stil",
  T_49_META_TYP_323_I4_D: "Sıralamayı Göster",
  T_49_META_TYP_323_I5_D: "Pin Göster",
  T_49_META_TYP_323_I6_D: "Takma Adı Göster",
  T_49_META_TYP_324_I0_D: "Belirtilen büyüklükte bir kuvvet üretir",
  T_49_META_TYP_324_I1_D: "Belirtilen büyüklükte ivme oluşturur",
  T_49_META_TYP_324_I2_D: "Belirtilen boyutta bir dürtü üretir",
  T_49_META_TYP_324_I3_D: "Belirtilen boyuttaki hızı üretir",
  T_49_META_TYP_326_I0_D: "Hesap Kimliği",
  T_49_META_TYP_326_I1_D: "Avatar ID",
  T_49_META_TYP_326_I2_D: "Afiş ID",
  T_49_META_TYP_326_I3_D: "Rozet ID",
  T_49_META_TYP_326_I4_D: "Oyuncunun takma adı",
  T_49_META_TYP_326_I5_D: "BR Rütbesi",
  T_49_META_TYP_326_I6_D: "En Yüksek BR Rütbesi",
  T_49_META_TYP_326_I7_D: "CS Rütbesi",
  T_49_META_TYP_326_I8_D: "En Yüksek CS Rütbesi",
  T_49_META_TYP_327_I0_D: "Kaynak Kimliği",
  T_49_META_TYP_327_I1_D: "Parça Maskesi 1",
  T_49_META_TYP_327_I2_D: "Parça Maskesi 2",
  T_49_META_TYP_327_I3_D: "Parça Maskesi 3",
  T_49_META_TYP_327_I4_D: "Parça Maskesi 4",
  T_49_META_TYP_329_I0_D: "Şoför",
  T_49_META_TYP_329_I1_D: "Yolcu A",
  T_49_META_TYP_329_I2_D: "Yolcu B",
  T_49_META_TYP_329_I3_D: "Yolcu C",
  T_49_META_TYP_33_I0_D: "Artan sıralamada sıfır değerleri göz ardı edilir ve en sona sıralanır.",
  T_49_META_TYP_33_I1_D: "Azalan, büyükten küçüğe",
  T_49_META_TYP_33_I2_D: "Yükselen, küçükten büyüğe",
  T_49_META_TYP_330_I4_D: "Yenilmezlik etkisinin süresi (birim: s)",
  T_49_META_TYP_330_I5_D: "Kontrol Noktaları",
  T_49_META_TYP_330_I8_D: "Delta Değeri",
  T_49_META_TYP_332_I0_D: "Döngü Var",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Süpermarket",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Kaynak yolu, varsayılan olarak boştur",
  T_49_META_TYP_335_I1_D: "Oynatma sayısı, varsayılan 1'dir",
  T_49_META_TYP_335_I2_D: "Hacim, varsayılan 50'dir",
  T_49_META_TYP_335_I3_D: "Maks. Mesafe",
  T_49_META_TYP_335_I4_D: "Min. Mesafe",
  T_49_META_TYP_335_I5_D: "3D müzik mi?",
  T_49_META_TYP_335_I6_D: "Öncelik",
  T_49_META_TYP_335_I7_D: "Başlamadan önceki bekleme süresi, saniye cinsinden",
  T_49_META_TYP_335_I8_D: "Oynatılıyor mu",
  T_49_META_TYP_338_I0_D: "Mobil durum",
  T_49_META_TYP_338_I1_D: "Sprint durumu",
  T_49_META_TYP_338_I2_D: "Saldırı Durumu",
  T_49_META_TYP_338_I3_D: "Atlama durumu",
  T_49_META_TYP_338_I4_D: "Tırmanma durumu",
  T_49_META_TYP_338_I5_D: "Araca girin (sürücü)",
  T_49_META_TYP_338_I6_D: "Araca biniş (yolcu)",
  T_49_META_TYP_338_I7_D: "Araçtan Çık",
  T_49_META_TYP_338_I8_D: "Sürmek",
  T_49_META_TYP_339_I0_D: "Uzuv Hasar Oranı",
  T_49_META_TYP_339_I1_D: "Kafa Hasar Oranı",
  T_49_META_TYP_339_I2_D: "Maksimum Dayanıklılık Oranı",
  T_49_META_TYP_339_I3_D: "Ekstra HP Oranı",
  T_49_META_TYP_339_I4_D: "Ek patlama hasarı azaltma faktörü (%)",
  T_49_META_TYP_339_I5_D: "Ekstra Sırt Çantası Kapasitesi",
  T_49_META_TYP_339_I6_D: "Değiştirme Önceliği",
  T_49_META_TYP_34_I0_D: "Varsayılan Yumruk",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Şarjlı Tüfek",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "El Topu",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Kalkan Silahı",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "MP5-III",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Famas-II",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Alev bombası",
  T_49_META_TYP_34_I133_D: "Patlayıcı",
  T_49_META_TYP_34_I134_D: "Duman Grenadı",
  T_49_META_TYP_34_I135_D: "Donma Granatı",
  T_49_META_TYP_34_I136_D: "Kurşun Geçirmez Yelek Lv1",
  T_49_META_TYP_34_I137_D: "Kurşun Geçirmez Yelek Lv2",
  T_49_META_TYP_34_I138_D: "Kurşun Geçirmez Yelek Lv3",
  T_49_META_TYP_34_I139_D: "Kask Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Kask Lv2",
  T_49_META_TYP_34_I141_D: "Kask Lv3",
  T_49_META_TYP_34_I142_D: "Patlamaya dayanıklı zırh",
  T_49_META_TYP_34_I143_D: "Sırt Çantası Lv1",
  T_49_META_TYP_34_I144_D: "Sırt Çantası Lv2",
  T_49_META_TYP_34_I145_D: "Sırt Çantası Lv3",
  T_49_META_TYP_34_I146_D: "Ağızlık Lv1",
  T_49_META_TYP_34_I147_D: "Ağızlık Lv2",
  T_49_META_TYP_34_I148_D: "Ağızlık Lv3",
  T_49_META_TYP_34_I149_D: "Susturucu",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Saldırı namlusu",
  T_49_META_TYP_34_I151_D: "Geniş ağızlı",
  T_49_META_TYP_34_I152_D: "Dergi Lv1",
  T_49_META_TYP_34_I153_D: "Dergi Lv2",
  T_49_META_TYP_34_I154_D: "Dergi Lv3",
  T_49_META_TYP_34_I155_D: "Çift paket dergisi",
  T_49_META_TYP_34_I156_D: "Zincir Dergisi",
  T_49_META_TYP_34_I157_D: "Kavrama Lv1",
  T_49_META_TYP_34_I158_D: "Kavrama Lv2",
  T_49_META_TYP_34_I159_D: "Kavrama Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Katlanır stand",
  T_49_META_TYP_34_I161_D: "Nişancı Tüfek Tutacağı",
  T_49_META_TYP_34_I162_D: "Tüfek Dipçiği",
  T_49_META_TYP_34_I163_D: "Keskin nişancı tüfeği dipçiği",
  T_49_META_TYP_34_I164_D: "Termal görüntüleme kapsamı",
  T_49_META_TYP_34_I165_D: "Stok Seviye 1",
  T_49_META_TYP_34_I166_D: "Stok Seviye 2",
  T_49_META_TYP_34_I167_D: "Stok Seviye 3",
  T_49_META_TYP_34_I168_D: "Kalkan Genişletici",
  T_49_META_TYP_34_I169_D: "Tam vücut zırhı",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Aşırı ara katman",
  T_49_META_TYP_34_I171_D: "Patlamaya dayanıklı ara katman",
  T_49_META_TYP_34_I172_D: "Sırt çantası genişlemesi",
  T_49_META_TYP_34_I173_D: "Tedavi solunum cihazı",
  T_49_META_TYP_34_I174_D: "Yatay",
  T_49_META_TYP_34_I175_D: "İlk Yardım Kiti",
  T_49_META_TYP_34_I176_D: "Zırh Onarım Takımı",
  T_49_META_TYP_34_I177_D: "Yüksek teknoloji ürünü malzemelerden üretilen yapay zekalı gözetleme kulesi, belirli bir menzil içindeki düşmanları aktif bir şekilde arayacak ve saldıracak.",
  T_49_META_TYP_34_I178_D: "Seviye 1 Mantar",
  T_49_META_TYP_34_I179_D: "Seviye 2 Mantar",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Seviye 3 Mantar",
  T_49_META_TYP_34_I181_D: "Seviye 4 Mantar",
  T_49_META_TYP_34_I182_D: "Kişisel UAV",
  T_49_META_TYP_34_I184_D: "Yakınlık Madeni",
  T_49_META_TYP_34_I185_D: "Jet uçan ayakkabılar",
  T_49_META_TYP_34_I186_D: "Bounce Güç Botları",
  T_49_META_TYP_34_I187_D: "deltakanatla uçuş",
  T_49_META_TYP_34_I188_D: "Sahte El Bombası",
  T_49_META_TYP_34_I189_D: "Manyetik hoverboard",
  T_49_META_TYP_34_I19_D: "Çöl Kartalı",
  T_49_META_TYP_34_I190_D: "Bomba imha pensesi",
  T_49_META_TYP_34_I191_D: "Silah Yükseltici",
  T_49_META_TYP_34_I192_D: "Tüfek Mermisi",
  T_49_META_TYP_34_I193_D: "Tabanca Mermisi",
  T_49_META_TYP_34_I194_D: "Keskin Nişancı Tüfeği Mermisi",
  T_49_META_TYP_34_I195_D: "Pompalı Tüfek Mermisi",
  T_49_META_TYP_34_I196_D: "SMG Mermisi",
  T_49_META_TYP_34_I197_D: "Oklar",
  T_49_META_TYP_34_I198_D: "M79 El Bombası",
  T_49_META_TYP_34_I199_D: "Alev makinesi mermisi",
  T_49_META_TYP_34_I2_D: "ARBALET",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "BIÇAK ATMA2",
  T_49_META_TYP_34_I201_D: "Kanca",
  T_49_META_TYP_34_I202_D: "Futbol Tabancası",
  T_49_META_TYP_34_I203_D: "boks",
  T_49_META_TYP_34_I204_D: "Alev Silahı",
  T_49_META_TYP_34_I205_D: "MaymuntanrıKartı",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "DjmaleKart",
  T_49_META_TYP_34_I208_D: "GraffitistKart",
  T_49_META_TYP_34_I209_D: "Dedektif Kartı",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "Profesör Kartı",
  T_49_META_TYP_34_I211_D: "Ödül Avcısı Kartı",
  T_49_META_TYP_34_I212_D: "SüperstarKart",
  T_49_META_TYP_34_I213_D: "XtremeKart",
  T_49_META_TYP_34_I214_D: "MusicBroKart",
  T_49_META_TYP_34_I215_D: "KentaKart",
  T_49_META_TYP_34_I216_D: "TAKİPÇİKart",
  T_49_META_TYP_34_I217_D: "ÇılgınkızKart",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "SantinoKart",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "Kötü Adam Kartı",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "YARA İZİ-I",
  T_49_META_TYP_34_I25_D: "YARA İZİ-II",
  T_49_META_TYP_34_I26_D: "YARA-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Futbol Kalkanı",
  T_49_META_TYP_34_I30_D: "Süper Isı Enerji Silahı",
  T_49_META_TYP_34_I31_D: "Aşırı Isınma Silahı-I",
  T_49_META_TYP_34_I32_D: "Süperısıtma Silahı-II",
  T_49_META_TYP_34_I33_D: "Süperısıtma Silahı-III",
  T_49_META_TYP_34_I34_D: "PLAZMA-X",
  T_49_META_TYP_34_I35_D: "Şifa Tabancası-Y",
  T_49_META_TYP_34_I36_D: "Keskin Nişancıyı İyileştir",
  T_49_META_TYP_34_I37_D: "Şifa tabancası",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "GROZA",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "GROZA",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "tava",
  T_49_META_TYP_34_I44_D: "Pala",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Beyzbol sopası",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Katana",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "mitralyöz",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Güçlü kancalı silah",
  T_49_META_TYP_34_I71_D: "FF Bıçağı",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3 mermi 1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Ağaçkakan",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Tırpan",
  T_49_META_TYP_34_I87_D: "Çekiç",
  T_49_META_TYP_34_I88_D: "Atma Bıçağı (alma)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Balıkçıl kuşu",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-ı",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Kolay",
  T_49_META_TYP_340_I1_D: "Basit",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Orta",
  T_49_META_TYP_340_I4_D: "Zor",
  T_49_META_TYP_340_I5_D: "Cehennem",
  T_49_META_TYP_342_I0_D: "Olay Başlat",
  T_49_META_TYP_342_I1_D: "Olay Durdur",
  T_49_META_TYP_342_I2_D: "Olayı Duraklat",
  T_49_META_TYP_342_I3_D: "Zamanlamayı başlatmak için oluşturulduktan sonra ne kadar süre beklenmesi gerektiği (milisaniye cinsinden)",
  T_49_META_TYP_342_I4_D: "Döngü Sayısı",
  T_49_META_TYP_342_I5_D: "Olaylar",
  T_49_META_TYP_342_I6_D: "Geri sayım veya geri sayım",
  T_49_META_TYP_342_I7_D: "Oyuncu Durumu",
  T_49_META_TYP_342_I8_D: "Zamanlamanın bitiş zamanı, saniye cinsinden",
  T_49_META_TYP_345_I10_D: "El Topu",
  T_49_META_TYP_345_I12_D: "Buz Duvar Silahı",
  T_49_META_TYP_345_I13_D: "Alev Silahı",
  T_49_META_TYP_345_I4_D: "Av tüfeği",
  T_49_META_TYP_345_I6_D: "Özel Silah",
  T_49_META_TYP_345_I8_D: "Şarj Silahı",
  T_49_META_TYP_346_I0_D: "Tüfek Mermisi",
  T_49_META_TYP_346_I1_D: "Tabanca Mermisi",
  T_49_META_TYP_346_I2_D: "Keskin Nişancı Tüfeği Mermisi",
  T_49_META_TYP_346_I3_D: "Pompalı Tüfek Mermisi",
  T_49_META_TYP_346_I4_D: "SMG Mermisi",
  T_49_META_TYP_346_I5_D: "Oklar",
  T_49_META_TYP_346_I6_D: "M79 El Bombası",
  T_49_META_TYP_346_I7_D: "Kanca",
  T_49_META_TYP_346_I8_D: "M79 Özel El Bombası",
  T_49_META_TYP_347_I3_D: "Doğru olduğunda, bağıl hareketle birleştirilebilir. Yanlış olduğunda, mutlak hareketle birleştirilmelidir, aksi takdirde özellik doğru şekilde etkili olmaz.",
  T_49_META_TYP_347_I6_D: "Delta Değeri",
  T_49_META_TYP_350_I0_D: "Spor Araba",
  T_49_META_TYP_350_I1_D: "Motoiklet",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Canavar Kamyonlar",
  T_49_META_TYP_350_I5_D: "Tuk Tuk",
  T_49_META_TYP_352_I1_D: "Seçilmemiş Sprite",
  T_49_META_TYP_352_I2_D: "Hiçbir görüntü türü seçilmedi",
  T_49_META_TYP_352_I3_D: "Seçilmemiş Renk",
  T_49_META_TYP_352_I4_D: "Seçili Sprite",
  T_49_META_TYP_352_I5_D: "Resim türünü seçin",
  T_49_META_TYP_352_I6_D: "Seçili Renk",
  T_49_META_TYP_353_I0_D: "HP Kurtarma Miktarı",
  T_49_META_TYP_353_I1_D: "HP Kurtarma Hızı (ms)",
  T_49_META_TYP_353_I2_D: "Gerekli Süre (ms)",
  T_49_META_TYP_354_I0_D: "EP Kurtarma Miktarı",
  T_49_META_TYP_355_I0_D: "HP Kurtarma Miktarı",
  T_49_META_TYP_355_I1_D: "EP Kurtarma Miktarı",
  T_49_META_TYP_355_I2_D: "Gerekli Süre (ms)",
  T_49_META_TYP_356_I0_D: "Düşen Eşyalar",
  T_49_META_TYP_356_I1_D: "Airdrop kutusu bırakma süresi ms",
  T_49_META_TYP_356_I2_D: "Hava Düşüş Durumu",
  T_49_META_TYP_357_I0_D: "Yüzey",
  T_49_META_TYP_357_I1_D: "sınır",
  T_49_META_TYP_359_I0_D: "Oyuncu kontrolcüsünün fizikle kullanılıp kullanılmayacağı",
  T_49_META_TYP_359_I1_D: "Bu açıyı aşan bir eğime yerleştirilirse aşağı doğru kayacaktır.",
  T_49_META_TYP_359_I10_D: "Bu yerçekimi ivmesi sadece oyuncu kontrolcüsüne uygulanır.",
  T_49_META_TYP_359_I11_D: "Kütle, kg",
  T_49_META_TYP_359_I12_D: "Eğim maksimum yukarı açıyı aşarsa aşağı doğru kayar.",
  T_49_META_TYP_359_I16_D: "Açıldıktan sonra, sunucu tarafındaki ilkel öğeler veya betikler hareketi kontrol eder",
  T_49_META_TYP_359_I17_D: "Etkinleştirildiğinde, karakterin katı gövdeyi iterken uyguladığı kuvvet özelleştirilebilir",
  T_49_META_TYP_359_I18_D: "Karakterin katı cismi ittiğinde uygulanan kuvvet miktarı",
  T_49_META_TYP_359_I19_D: "Alt kısım çarpıştırıcıya değdiğinde doğrudur, genellikle oyuncunun yerde olup olmadığını belirlemek için kullanılır",
  T_49_META_TYP_359_I2_D: "Sadece bu yüksekliği aşan engeller engelleme etkisine sahip olacaktır. Değer aralığı [0, Yükseklik]'tir",
  T_49_META_TYP_359_I20_D: "Özel fiziksel seviye, değer [0,15]",
  T_49_META_TYP_359_I21_D: "Yerçekimi ile Döndürmeyi Etkinleştir",
  T_49_META_TYP_359_I3_D: "Kapsülün gömülebileceği derinlik. Karakterin sıkışmasını veya sallanmasını önleyebilir. Özel bir ihtiyaç olmadığı sürece değiştirilmesi önerilmez. Değer aralığı (0, Yarıçap]",
  T_49_META_TYP_359_I4_D: "Minimum hareket mesafesi. Bu değerden daha küçük hareketler yürütülmeyecektir. Özel bir ihtiyaç yoksa 0 olarak tutulması önerilir.",
  T_49_META_TYP_359_I5_D: "Çarpışma kutusu merkezinin yerel koordinat kökeninden uzaklığı",
  T_49_META_TYP_359_I6_D: "Kapsülün yarıçapı, minimum değer 0,01'dir",
  T_49_META_TYP_359_I7_D: "Üst ve alt yarım küreler dahil olmak üzere kapsülün toplam yüksekliği, en az 2*Radius değerinde olmalıdır.",
  T_49_META_TYP_359_I8_D: "Mevcut doğrusal hız, m/s cinsinden",
  T_49_META_TYP_360_I0_D: "Sol Ateş Açısı",
  T_49_META_TYP_360_I1_D: "Sağ Ateş Açısı",
  T_49_META_TYP_360_I2_D: "Minimum Yükselme Açısı",
  T_49_META_TYP_360_I3_D: "Maksimum İniş Açısı",
  T_49_META_TYP_360_I4_D: "Namlu Hızı",
  T_49_META_TYP_362_I0_D: "Oyuncuya vurulduktan sonraki donma süresi (saniye cinsinden)",
  T_49_META_TYP_363_I0_D: "HUD istek satın alma özelliğini devre dışı bırak",
  T_49_META_TYP_363_I1_D: "Satın alma konusunda ekipten yardım isteyin",
  T_49_META_TYP_363_I2_D: "Satın alma konusunda fraksiyondan yardım isteyin",
  T_49_META_TYP_364_I0_D: "Merkez Pozisyonu",
  T_49_META_TYP_364_I1_D: "Döngü olsun ya da olmasın",
  T_49_META_TYP_364_I2_D: "Animasyon Adı",
  T_49_META_TYP_364_I3_D: "Otomatik olarak oynatılıp oynatılmayacağı",
  T_49_META_TYP_364_I4_D: "Özel Kaynak Kullan",
  T_49_META_TYP_366_I0_D: "İşlenecek Toplu iş kaynağının UUID'sini belirtin",
  T_49_META_TYP_367_I1_D: "Etiketi Göster",
  T_49_META_TYP_367_I2_D: "Hedefleri işaretlemek için simge stili",
  T_49_META_TYP_367_I3_D: "Bir hedefi işaretlerken görüntülenen simgenin kaplama rengi",
  T_49_META_TYP_367_I4_D: "Bir ölçek üzerinde görüntülenen simge stili",
  T_49_META_TYP_367_I5_D: "Bir ölçekte görüntülenen simge kaplama rengi",
  T_49_META_TYP_367_I6_D: "İşareti Her Zaman Göster",
  T_49_META_TYP_370_I0_D: "Ana Başlık",
  T_49_META_TYP_370_I1_D: "Altyazı",
  T_49_META_TYP_370_I2_D: "Üst arka plan rengi",
  T_49_META_TYP_370_I3_D: "Alttaki arka plan rengi",
  T_49_META_TYP_371_I2_D: "Sol Skor",
  T_49_META_TYP_371_I3_D: "Sağ Skor",
  T_49_META_TYP_371_I4_D: "Soldaki son puan, puan değiştirme animasyonunu oynatmak için kullanılır",
  T_49_META_TYP_371_I5_D: "Sağdaki son puan, puan değiştirme animasyonunu oynatmak için kullanılır",
  T_49_META_TYP_372_I0_D: "Ayakta",
  T_49_META_TYP_372_I1_D: "Çömelme Göster",
  T_49_META_TYP_372_I10_D: "Yüksek irtifadan düşme",
  T_49_META_TYP_372_I11_D: "Atlama gibi düşük bir yükseklikten düşme",
  T_49_META_TYP_372_I12_D: "Uçan ayakkabılar",
  T_49_META_TYP_372_I13_D: "Çift zıplama",
  T_49_META_TYP_372_I14_D: "Bir sandalyeye otur",
  T_49_META_TYP_372_I15_D: "Bir mancınıkla fırlatılmak",
  T_49_META_TYP_372_I16_D: "Mancınık hazırlık aşaması",
  T_49_META_TYP_372_I17_D: "Süzülen pervaneler süzülüyor",
  T_49_META_TYP_372_I18_D: "Süzülerek pervane düşmesi",
  T_49_META_TYP_372_I19_D: "Lastikler tarafından sektirildi",
  T_49_META_TYP_372_I2_D: "koşma",
  T_49_META_TYP_372_I20_D: "İnsan lastiği tarafından sektirildi",
  T_49_META_TYP_372_I21_D: "Parti alanında bir eylem",
  T_49_META_TYP_372_I22_D: "Bir uçağa binin",
  T_49_META_TYP_372_I23_D: "Topa Girin",
  T_49_META_TYP_372_I24_D: "Bir top, araç vb. çıkarken, bindiğiniz nesne uçuyorsa, bu durum",
  T_49_META_TYP_372_I25_D: "Tramplenden atladıktan sonra",
  T_49_META_TYP_372_I26_D: "Fermuarlı hattan inin",
  T_49_META_TYP_372_I27_D: "Kullanılmadı",
  T_49_META_TYP_372_I3_D: "Sürünmek",
  T_49_META_TYP_372_I4_D: "Hızlı yüzme",
  T_49_META_TYP_372_I5_D: "Dikey düşüş",
  T_49_META_TYP_372_I6_D: "Duvarın Ötesinde",
  T_49_META_TYP_372_I7_D: "Kullanılmadı",
  T_49_META_TYP_372_I8_D: "Yıkıldı ama ölmedi",
  T_49_META_TYP_372_I9_D: "Su tahtası kullanın",
  T_49_META_TYP_374_I0_D: "Sağlık, seviye ve vuruş rengi",
  T_49_META_TYP_374_I1_D: "Sağlık azaldıkça, eksik kısım kısa bir süre bu rengi gösterir",
  T_49_META_TYP_374_I10_D: "Takip edilecek hedefe göre ofset",
  T_49_META_TYP_374_I11_D: "Her iki bölme çizgisi arasındaki sağlık değeri 0'dan küçük veya eşitse görüntülenmeyecektir",
  T_49_META_TYP_374_I12_D: "Toplam HP",
  T_49_META_TYP_374_I13_D: "Mevcut HP",
  T_49_META_TYP_374_I14_D: "Etkinleştirildiğinde, sağlık değişiklikleri farklı renklerde görüntülenecektir",
  T_49_META_TYP_374_I15_D: "Etkinleştirildiğinde, ofset özellikleri yerel koordinat sistemi kullanılarak dünya koordinatlarına dönüştürülür.",
  T_49_META_TYP_374_I2_D: "Sağlık arttığında, artan kısım kısa bir süre bu rengi gösterir",
  T_49_META_TYP_374_I3_D: "Sağlık sınırının rengi ve bulanık alt kısım",
  T_49_META_TYP_374_I4_D: "Aralık 0~1, genel kullanıcı arayüzünün şeffaflığı",
  T_49_META_TYP_374_I5_D: "Genel kullanıcı arayüzü ölçeklemesini belirler ve yazı tipleri birlikte ölçeklenir",
  T_49_META_TYP_374_I6_D: "Mevcut sağlık çubuğu sahibinin adını belirtir",
  T_49_META_TYP_374_I8_D: "Ekranda görüntülenen sağlık çubuğunun uzunluğu",
  T_49_META_TYP_374_I9_D: "Bir varlığın Dönüşüm bileşeniyle takip edilmesi gerekir",
  T_49_META_TYP_375_I1_D: "Savaş varlığı",
  T_49_META_TYP_376_I1_D: "Savaş varlığı",
  T_49_META_TYP_38_I0_D: "Alfa",
  T_49_META_TYP_382_I0_D: "varsayılan",
  T_49_META_TYP_382_I1_D: "Devrilme durumunu atla ve doğrudan öl",
  T_49_META_TYP_382_I2_D: "Düşme Atlama Yok",
  T_49_META_TYP_387_I1_D: "Dışarıda Basmayı İzin Ver",
  T_49_META_TYP_389_I0_D: "Tabanın varsayılan ofseti",
  T_49_META_TYP_389_I1_D: "Arka Plan Sprite",
  T_49_META_TYP_389_I10_D: "Etkin Olmayan Alfa",
  T_49_META_TYP_389_I2_D: "Arka Plan Yarıçapı",
  T_49_META_TYP_389_I3_D: "Joystick Kap Resmi",
  T_49_META_TYP_389_I4_D: "Joystick Kap Yarıçapı",
  T_49_META_TYP_389_I5_D: "Joystick Kap Sürükleme Yarıçapı",
  T_49_META_TYP_389_I6_D: "Ok Sprite'ı",
  T_49_META_TYP_389_I7_D: "Ok Boyutu",
  T_49_META_TYP_389_I8_D: "Ok Kaydırması",
  T_49_META_TYP_389_I9_D: "Etkin Alfa",
  T_49_META_TYP_39_I1_D: "Sprite Şekli",
  T_49_META_TYP_39_I10_D: "Üst Gradyan",
  T_49_META_TYP_39_I11_D: "Alt Gradyan",
  T_49_META_TYP_39_I12_D: "Üst Alfa",
  T_49_META_TYP_39_I13_D: "Alt Alfa",
  T_49_META_TYP_39_I3_D: "Çevirme",
  T_49_META_TYP_39_I4_D: "Dolgulu",
  T_49_META_TYP_39_I5_D: "Merkezi Görünmez",
  T_49_META_TYP_39_I6_D: "Doldurma Yönü",
  T_49_META_TYP_39_I7_D: "Doldurma Değeri",
  T_49_META_TYP_39_I8_D: "Doldurmayı Ters Çevir",
  T_49_META_TYP_39_I9_D: "Gradyan",
  T_49_META_TYP_392_I0_D: "Oyunda her turda güvenli bölgenin belirme süresi, varsayılan değer 0'dır, birimi ms'dir.",
  T_49_META_TYP_392_I1_D: "Dairenin küçülmesi için gereken süre (ms cinsinden)",
  T_49_META_TYP_392_I10_D: "Küçülen çemberin son zamanı, ms cinsinden",
  T_49_META_TYP_392_I12_D: "Zehir çemberi son yarıçapı",
  T_49_META_TYP_392_I13_D: "Küçülme Başlama Zamanı",
  T_49_META_TYP_392_I14_D: "Hasar Aralığı (ms)",
  T_49_META_TYP_392_I3_D: "Zehir çemberindeki oyunculara verilen hasar miktarı.",
  T_49_META_TYP_392_I4_D: "Güvenli bölgedeki oyuncuların listesi",
  T_49_META_TYP_392_I5_D: "Güvenli bölgenin kaybolma süresi. Güvenli bölgenin kaybolma süresi etkin zamandan az ise, güvenli bölge oluşturulmaz.",
  T_49_META_TYP_392_I6_D: "Grup ID'si",
  T_49_META_TYP_392_I7_D: "Zehir çemberi başlangıç yarıçapı",
  T_49_META_TYP_392_I8_D: "Son Durum",
  T_49_META_TYP_392_I9_D: "Durum",
  T_49_META_TYP_394_I0_D: "Değer yaklaşık 3.1416",
  T_49_META_TYP_394_I1_D: "Değer yaklaşık 2.7183'tür",
  T_49_META_TYP_396_I0_D: "Başlık",
  T_49_META_TYP_396_I1_D: "İçerik",
  T_49_META_TYP_396_I2_D: "Seçenekler",
  T_49_META_TYP_396_I3_D: "Arka Planı Göster",
  T_49_META_TYP_399_I0_D: "Zıplama Yüksekliği",
  T_49_META_TYP_399_I1_D: "İnişe geçmeden önce gerçekleştirebileceğiniz ardışık sıçrama sayısı",
  T_49_META_TYP_399_I2_D: "İnişe geçmeden önce birden fazla zıplama yapabilirsiniz.",
  T_49_META_TYP_399_I3_D: "Havada Yatay Hareket Etme",
  T_49_META_TYP_40_I1_D: "Etiket",
  T_49_META_TYP_40_I10_D: "Satır Aralığı",
  T_49_META_TYP_40_I11_D: "Taşma yöntemi",
  T_49_META_TYP_40_I12_D: "Yazı Stili",
  T_49_META_TYP_40_I13_D: "Gölge Uygula",
  T_49_META_TYP_40_I14_D: "Gölge Rengi",
  T_49_META_TYP_40_I15_D: "Gölge Kaydırması",
  T_49_META_TYP_40_I3_D: "Yerelleştirme Anahtarı, birden fazla dilde kullanılabilir",
  T_49_META_TYP_40_I5_D: "Hizalama",
  T_49_META_TYP_40_I6_D: "Dikey Hizalama",
  T_49_META_TYP_40_I7_D: "Kalın",
  T_49_META_TYP_40_I8_D: "İtalik",
  T_49_META_TYP_40_I9_D: "Altı Çizili",
  T_49_META_TYP_400_I0_D: "Aktif",
  T_49_META_TYP_400_I1_D: "Pasif",
  T_49_META_TYP_400_I2_D: "Saldırı Yok",
  T_49_META_TYP_401_I0_D: "Ateş edilemiyor",
  T_49_META_TYP_401_I1_D: "Sürekli ateş edebilir",
  T_49_META_TYP_401_I2_D: "Saldırı komutu başına bir kez ateş eder",
  T_49_META_TYP_401_I3_D: "Her saldırı komutu üç kez ateşlenir",
  T_49_META_TYP_401_I4_D: "Her saldırı komutu iki kez ateşlenir",
  T_49_META_TYP_401_I5_D: "Mermi",
  T_49_META_TYP_402_I0_D: "Arkadaş olarak eklenecek hedef",
  T_49_META_TYP_402_I1_D: "İşlev Türü",
  T_49_META_TYP_402_I2_D: "Stil",
  T_49_META_TYP_403_I0_D: "Arkadaş Ekle",
  T_49_META_TYP_403_I1_D: "Rapor Et",
  T_49_META_TYP_404_I0_D: "Açık",
  T_49_META_TYP_404_I1_D: "Koyu",
  T_49_META_TYP_405_I0_D: "Hiyerarşiye Göre",
  T_49_META_TYP_405_I1_D: "Öncelikten Düşüğe",
  T_49_META_TYP_405_I2_D: "Öncelikten Yükseğe",
  T_49_META_TYP_406_I0_D: "Oyuncunun atlama eyleminin mesafesini kontrol eder",
  T_49_META_TYP_406_I1_D: "Oyuncunun yukarı ve aşağı tırmanırken vücudunun yüksekliğini kontrol eder",
  T_49_META_TYP_407_I0_D: "Yerel",
  T_49_META_TYP_407_I1_D: "İstemci",
  T_49_META_TYP_407_I2_D: "Sunucu",
  T_49_META_TYP_407_I3_D: "İkisi de",
  T_49_META_TYP_409_I0_D: "Hata Yok",
  T_49_META_TYP_409_I1_D: "Veri depolama zaman aşımı, esas olarak okuma işlemleri için",
  T_49_META_TYP_409_I10_D: "Takım Değişikliği Başarısız - Geçersiz Hedef Takım",
  T_49_META_TYP_409_I11_D: "Takım Değişikliği Başarısız - Ölü oyuncuların takım değiştirmesine izin verilmez",
  T_49_META_TYP_409_I12_D: "Takım Değişikliği Başarısız - Araçlardaki takım değişikliklerine izin verilmez",
  T_49_META_TYP_409_I2_D: "Veri depolama okuma ve yazma sıklığı sınırı aşıyor",
  T_49_META_TYP_409_I3_D: "Parametre anormalliği",
  T_49_META_TYP_409_I4_D: "Oda oluşturulamadı: Geçerli PersonaID yok",
  T_49_META_TYP_409_I5_D: "Tanımsız hata durumu",
  T_49_META_TYP_409_I6_D: "Ticari hizmetler kapatıldı ve kullanıcılar artık geliştiricinin hizmetlerini kullanamıyor",
  T_49_META_TYP_409_I7_D: "Takım değişikliği başarısız oldu - mod desteklenmiyor",
  T_49_META_TYP_409_I8_D: "Takım değişikliği başarısız oldu - şu anda hedef takımda",
  T_49_META_TYP_409_I9_D: "Takım değişikliği başarısız oldu - geçersiz nesne",
  T_49_META_TYP_41_I0_D: "Sprite Şekli",
  T_49_META_TYP_41_I19_D: "Çarpışma kutusunu devre dışı bırak",
  T_49_META_TYP_41_I3_D: "Rengi Devre Dışı Bırak",
  T_49_META_TYP_41_I4_D: "Basılı Renk",
  T_49_META_TYP_41_I5_D: "Doldurma Türü",
  T_49_META_TYP_41_I6_D: "FE Düğmesi mi",
  T_49_META_TYP_41_I7_D: "Basılı Sprite",
  T_49_META_TYP_41_I8_D: "Basılı Sprite Türü",
  T_49_META_TYP_41_I9_D: "Çevirme Türü",
  T_49_META_TYP_411_I0_D: "İleri Hız",
  T_49_META_TYP_411_I1_D: "Geri Hız",
  T_49_META_TYP_411_I2_D: "Yukarı Hız",
  T_49_META_TYP_411_I3_D: "Aşağı Hız",
  T_49_META_TYP_411_I4_D: "El Bombası Minimum Hasar",
  T_49_META_TYP_411_I5_D: "El Bombası Maksimum Hasar",
  T_49_META_TYP_411_I6_D: "El Bombası Menzili",
  T_49_META_TYP_412_I0_D: "Gaz kelebeği düğmesi kullanıldığında aracın kazandığı beygir gücü miktarı",
  T_49_META_TYP_412_I1_D: "Geri vites/fren düğmesi kullanıldığında aracın kazandığı beygir gücü miktarı",
  T_49_META_TYP_412_I2_D: "Yüksek hızda, maksimum direksiyon açısı",
  T_49_META_TYP_412_I3_D: "Yüksek hızda maksimum direksiyon açısı uygulaması için hız eşiği",
  T_49_META_TYP_412_I4_D: "Araç maksimum hıza ulaştıktan sonra artık beygir gücü sağlamayacaktır ancak araç bu maksimum hızı aşabilir (örneğin yokuş aşağı giderken)",
  T_49_META_TYP_412_I5_D: "Araç kontrol edilmediğinde, IdleBrakeInput ile BrakeTorque çarpılarak araç yavaşlatılır",
  T_49_META_TYP_412_I6_D: "Hasar formülünün parametreleri kullanılarak insanlara çarpmanın verdiği hasarın hesaplanmasında kullanılır",
  T_49_META_TYP_412_I7_D: "İnsanlara çarpmanın verdiği hasarı hesaplamak için kullanılır. Bu hızı aştıktan sonra hasar artmaz.",
  T_49_META_TYP_412_I8_D: "Çarpışmanın hasar hesaplamasında, minimum hasarda kullanılır",
  T_49_META_TYP_412_I9_D: "Çarpışmanın hasar hesaplamasında, azami hasarda kullanılır",
  T_49_META_TYP_413_I0_D: "Oyuncu (NPC) dönüştürülmüş giyim",
  T_49_META_TYP_414_I1_D: "Geniş Aralık",
  T_49_META_TYP_415_I0_D: "Persona ID",
  T_49_META_TYP_415_I1_D: "Takma Ad",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "Bağlı Kişilik",
  T_49_META_TYP_416_I2_D: "Telafi etmek",
  T_49_META_TYP_416_I3_D: "Yükseklik",
  T_49_META_TYP_416_I4_D: "Sistem mesajlarına yanıt verilip verilmeyeceği",
  T_49_META_TYP_416_I5_D: "Kişi Takma Adı",
  T_49_META_TYP_416_I6_D: "KişiAvatar",
  T_49_META_TYP_416_I7_D: "Kullanıcı Takma Adı",
  T_49_META_TYP_416_I8_D: "Kullanıcı Avatarı",
  T_49_META_TYP_417_I0_D: "Kaynak Kimliği",
  T_49_META_TYP_418_I0_D: "Üyelik Sonu",
  T_49_META_TYP_418_I1_D: "Üye Ol",
  T_49_META_TYP_418_I2_D: "Üyelik Yenileme",
  T_49_META_TYP_42_I0_D: "Varsayılan Metin",
  T_49_META_TYP_42_I1_D: "Aktif Metin",
  T_49_META_TYP_42_I10_D: "Maksimum Uzunluk",
  T_49_META_TYP_42_I14_D: "Basılı Renk",
  T_49_META_TYP_42_I16_D: "Yerelleştirme Anahtarı, birden fazla dilde kullanılabilir",
  T_49_META_TYP_42_I3_D: "Hizalama",
  T_49_META_TYP_42_I4_D: "Dikey Hizalama",
  T_49_META_TYP_42_I5_D: "Kalın",
  T_49_META_TYP_42_I6_D: "İtalik",
  T_49_META_TYP_42_I7_D: "Altı Çizili",
  T_49_META_TYP_42_I8_D: "Satır Aralığı",
  T_49_META_TYP_42_I9_D: "Kelime Kaydırma",
  T_49_META_TYP_424_I0_D: "Doğrusal sis etkisi",
  T_49_META_TYP_424_I1_D: "Endeks sis etkisi",
  T_49_META_TYP_424_I2_D: "Üstel kare sis etkisi",
  T_49_META_TYP_426_I0_D: "Yoğunluk",
  T_49_META_TYP_426_I1_D: "Menzil",
  T_49_META_TYP_426_I2_D: "Spot ışığı konisinin açısı (derece cinsinden)",
  T_49_META_TYP_426_I3_D: "Açık Renk",
  T_49_META_TYP_428_I0_D: "Silah Kaplama ID'leri",
  T_49_META_TYP_428_I2_D: "Kimlik Ayarla",
  T_49_META_TYP_428_I3_D: "Başlık Kimliği",
  T_49_META_TYP_428_I4_D: "Yüz Kimliği",
  T_49_META_TYP_428_I5_D: "Makyaj Kimliği",
  T_49_META_TYP_428_I6_D: "Üst gövde kimliği",
  T_49_META_TYP_428_I7_D: "Alt gövde kimliği",
  T_49_META_TYP_428_I8_D: "Ayakkabı kimliği",
  T_49_META_TYP_431_I1_D: "Hedef varlığın yörüngesi",
  T_49_META_TYP_431_I3_D: "Hareket hızı, birim: m/s",
  T_49_META_TYP_431_I4_D: `Teğet yola doğru hareket edilmeli mi.
Varsayılan değer False'dur ve hareket eden nesnenin yönü değişmeden kalır.
True olduğunda hareket eden nesne yolun yönüne bakacaktır.`,
  T_49_META_TYP_431_I5_D: "Oynanan yüzde",
  T_49_META_TYP_432_I0_D: "Bu noktanın her iki tarafındaki yolun radyal dönüşünü etkileyen yuvarlanma açısı",
  T_49_META_TYP_432_I1_D: "Teğet kontrol noktasının ve geçiş noktasının göreli konumu, yol teğetini belirler",
  T_49_META_TYP_433_I0_D: "Yol noktaları arasında düz çizgiler oluşturun",
  T_49_META_TYP_433_I1_D: "Düzgün hareket için yol noktaları arasında eğrisel enterpolasyon",
  T_49_META_TYP_433_I2_D: "Eğri noktasının tanjantının manuel olarak ayarlanmasını destekler",
  T_49_META_TYP_434_I0_D: "Yol Türü",
  T_49_META_TYP_434_I1_D: "Yolun toplam uzunluğu",
  T_49_META_TYP_434_I2_D: "Başlangıç ve sonun birbirine bağlı olup olmadığı",
  T_49_META_TYP_434_I3_D: "Yol Noktası Koleksiyonu",
  T_49_META_TYP_437_I3_D: "Sol Oyuncular",
  T_49_META_TYP_437_I4_D: "Sağ Oyuncular",
  T_49_META_TYP_437_I5_D: "İntegral tip adları dizisi",
  T_49_META_TYP_437_I6_D: "Soldaki puan dizisi (Birinci boyut listesi: oyuncular; İkinci boyut listesi: özel puan türüne göre doldurulan puan verileri)",
  T_49_META_TYP_437_I7_D: "Sağdaki puan dizisi (Birinci boyut listesi: oyuncular; İkinci boyut listesi: özel puan türüne göre doldurulan puan verileri)",
  T_49_META_TYP_438_I1_D: "Oyuncu dizisini gruplandırma",
  T_49_META_TYP_438_I2_D: "Grup sıralaması dizisi",
  T_49_META_TYP_438_I3_D: "Grup puan dizisi",
  T_49_META_TYP_438_I4_D: "İntegral tip adları dizisi",
  T_49_META_TYP_438_I5_D: "Gruplanmış renk dizisi",
  T_49_META_TYP_438_I6_D: "Oyuncu puanları dizisi (gruplandırılmadığında sıraya karşılık gelir)",
  T_49_META_TYP_442_I1_D: "Sol Skor",
  T_49_META_TYP_442_I10_D: "Sağdaki ölüm simgesi",
  T_49_META_TYP_442_I2_D: "Sağ Skor",
  T_49_META_TYP_442_I3_D: "Soldaki kurtulanların sayısı",
  T_49_META_TYP_442_I4_D: "Sağdaki kurtulanların sayısı",
  T_49_META_TYP_442_I5_D: "Soldaki ölüm sayısı",
  T_49_META_TYP_442_I6_D: "Sağdaki ölüm sayısı",
  T_49_META_TYP_442_I7_D: "Soldaki hayatta kalma simgesi",
  T_49_META_TYP_442_I8_D: "Sağdaki hayatta kalma simgesi",
  T_49_META_TYP_442_I9_D: "Soldaki ölüm simgesi",
  T_49_META_TYP_444_I0_D: "İngilizce",
  T_49_META_TYP_444_I1_D: "Basitleştirilmiş Çince",
  T_49_META_TYP_444_I10_D: "Fransızca",
  T_49_META_TYP_444_I11_D: "Almanca",
  T_49_META_TYP_444_I12_D: "Türkçe",
  T_49_META_TYP_444_I13_D: "Hintçe",
  T_49_META_TYP_444_I14_D: "Japonca",
  T_49_META_TYP_444_I15_D: "Romence",
  T_49_META_TYP_444_I16_D: "Arapça",
  T_49_META_TYP_444_I17_D: "Birmanyalı",
  T_49_META_TYP_444_I18_D: "Urdu",
  T_49_META_TYP_444_I19_D: "Bengalce",
  T_49_META_TYP_444_I2_D: "Geleneksel Çince",
  T_49_META_TYP_444_I3_D: "Tayca",
  T_49_META_TYP_444_I4_D: "Vietnam",
  T_49_META_TYP_444_I5_D: "Endonezyaca",
  T_49_META_TYP_444_I6_D: "Portekizce",
  T_49_META_TYP_444_I7_D: "İspanyol",
  T_49_META_TYP_444_I8_D: "Rusça",
  T_49_META_TYP_444_I9_D: "Korece",
  T_49_META_TYP_51_I0_D: "Normal zombi",
  T_49_META_TYP_51_I1_D: "Ağaç Kesme Zombisi",
  T_49_META_TYP_51_I10_D: "Uçan Bomba Arı",
  T_49_META_TYP_51_I11_D: "Zombi ejderhası",
  T_49_META_TYP_51_I2_D: "Fırlatma Zombisi",
  T_49_META_TYP_51_I3_D: "Patlayıcı Zombi",
  T_49_META_TYP_51_I4_D: "Zorba Zombi",
  T_49_META_TYP_51_I5_D: "Kırmızı Fırlatma Zombisi",
  T_49_META_TYP_51_I6_D: "Bay V",
  T_49_META_TYP_51_I7_D: "Tank Zombisi",
  T_49_META_TYP_51_I8_D: "Matkap Zombisi",
  T_49_META_TYP_51_I9_D: "Samuray",
  T_49_META_TYP_56_I10_D: "Patlama Gecikmesi",
  T_49_META_TYP_56_I11_D: "Patlama Aralığı",
  T_49_META_TYP_56_I12_D: "Patlama Hasarı",
  T_49_META_TYP_56_I13_D: "Yanma Süresi",
  T_49_META_TYP_56_I14_D: "Yanma Hasarı",
  T_49_META_TYP_56_I15_D: "Yanma Hasarı Aralığı",
  T_49_META_TYP_56_I17_D: "Araç Sürücüsü",
  T_49_META_TYP_56_I18_D: "Gemideki tüm yolcular",
  T_49_META_TYP_56_I19_D: "Araç Kaplama ID",
  T_49_META_TYP_56_I20_D: "Oyuncu Konfigürasyon Önceliği",
  T_49_META_TYP_56_I21_D: "Maks. HP",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "Manuel mi yoksa otomatik olarak mı aktarılacağı (varsayılan olarak manuel)",
  T_49_META_TYP_58_I0_D: "BUFF türü oluşturuldu",
  T_49_META_TYP_58_I1_D: "Bir BUFF'ın alındığı andan bir sonraki BUFF'ın oluşturulduğu ana kadar geçen süre (saniye cinsinden)",
  T_49_META_TYP_59_I0_D: "Hareket Türü",
  T_49_META_TYP_59_I1_D: "X Yönü Hareket Değeri",
  T_49_META_TYP_59_I2_D: "Y Yönü Hareket Değeri",
  T_49_META_TYP_59_I3_D: "Z Yönü Hareket Değeri",
  T_49_META_TYP_59_I4_D: "Hareket Süresi",
  T_49_META_TYP_59_I5_D: "Durma Süresi",
  T_49_META_TYP_59_I6_D: "Karşılıklı Hareketi Devre Dışı Bırak",
  T_49_META_TYP_60_I0_D: "Silah Puanlarını Yağmala",
  T_49_META_TYP_61_I0_D: "Bağlı Para",
  T_49_META_TYP_61_I1_D: "Tetik aralığını ayarlayın",
  T_49_META_TYP_61_I2_D: "Model Görünürlüğü",
  T_49_META_TYP_62_I0_D: "XZ Yönü Hızı",
  T_49_META_TYP_62_I1_D: "Y Yönü Hızı",
  T_49_META_TYP_64_I0_D: "Müzik bileşeni türü",
  T_49_META_TYP_66_I0_D: "ÖrnekKimliği",
  T_49_META_TYP_66_I1_D: "Yol Noktası",
  T_49_META_TYP_68_I0_D: "Yapay zekanın mevcut durumu",
  T_49_META_TYP_68_I1_D: "Yapay zekanın şu anki maksimum sağlığı",
  T_49_META_TYP_68_I10_D: "Yapay zeka öldüğünde ekipman veya eşya düşürecek mi?",
  T_49_META_TYP_68_I11_D: "Yapay zeka şu anda yenilmez bir durumda mı?",
  T_49_META_TYP_68_I12_D: "Hasar alındığında hasar yüzdesi azaltılabilir veya artırılabilir.",
  T_49_META_TYP_68_I13_D: "Yapay Zeka Türleri",
  T_49_META_TYP_68_I14_D: "düşmanı otomatik olarak talep edip etmemek",
  T_49_META_TYP_68_I15_D: "0 otomatik saldırı, 1 savunma saldırısı, 2 ise hiç saldırı olmayacağı anlamına gelir",
  T_49_META_TYP_68_I16_D: "Yol ID'si",
  T_49_META_TYP_68_I17_D: "Takip Hedefi",
  T_49_META_TYP_68_I18_D: "Saldırı Hedefi",
  T_49_META_TYP_68_I19_D: "Yapay zekanın ortaya çıkış noktası koordinatları",
  T_49_META_TYP_68_I2_D: "Yapay zekanın ait olduğu takımın varlığını alın",
  T_49_META_TYP_68_I20_D: "Takım Fraksiyon Numarası",
  T_49_META_TYP_68_I4_D: "Sadece normal saldırıların saldırı gücü değiştirilebilir, becerilerin saldırı gücü sayılmaz.",
  T_49_META_TYP_68_I7_D: "AI'nın serbest hareket aralığı. Sadece temel değeri değiştirebilirsiniz. Ek bir bonus varsa, değere göre eklenecektir.",
  T_49_META_TYP_68_I8_D: "AI düşmanın menzilini algılar ve yalnızca temel değeri değiştirebilir. Ek bir bonus varsa, değere göre eklenecektir.",
  T_49_META_TYP_68_I9_D: "Gerçek hareket hızı. Eğer bir beceri ivmesi varsa, bununla çarpılacaktır.",
  T_49_META_TYP_70_I0_D: "Formülün hedef varlık kimliği, dahili olarak kullanılır ve oyuncu tarafından görülemez.",
  T_49_META_TYP_70_I1_D: "Formülün dahili olarak kullanılan ve oyuncu tarafından görülemeyen hedef varlık öznitelik kimliği.",
  T_49_META_TYP_70_I2_D: "İzin verilen minimum değer",
  T_49_META_TYP_70_I3_D: "İzin verilen maksimum değer",
  T_49_META_TYP_70_I4_D: "Temel Katsayı",
  T_49_META_TYP_70_I5_D: "Ön Toplayıcı",
  T_49_META_TYP_70_I6_D: "Çarpan",
  T_49_META_TYP_70_I7_D: "Çarp ve Topla",
  T_49_META_TYP_70_I8_D: "Son Toplayıcı",
  T_49_META_TYP_71_I0_D: "Ürün Numarası",
  T_49_META_TYP_71_I1_D: "Fiyat",
  T_49_META_TYP_71_I10_D: "Mağaza Ürünleri",
  T_49_META_TYP_71_I2_D: "Para Birimi Türü",
  T_49_META_TYP_71_I3_D: "Genel satın alma limiti",
  T_49_META_TYP_71_I4_D: "Mevcut genel satın alma kısıtlamaları",
  T_49_META_TYP_71_I5_D: "Ürün Adı",
  T_49_META_TYP_71_I6_D: "Ürün Açıklaması",
  T_49_META_TYP_71_I7_D: "Ürün Öğe Listesi",
  T_49_META_TYP_71_I8_D: "Satın Alınabilir mi",
  T_49_META_TYP_71_I9_D: "Kaynak yolu, varsayılan olarak boştur",
  T_49_META_TYP_72_I1_D: "Raflar",
  T_49_META_TYP_73_I1_D: "Manuel Kapatma Devre Dışı mı",
  T_49_META_TYP_74_I0_D: "Silah",
  T_49_META_TYP_74_I1_D: "Kask",
  T_49_META_TYP_74_I2_D: "Yelek",
  T_49_META_TYP_74_I3_D: "El Bombası",
  T_49_META_TYP_75_I0_D: "Tek Yön",
  T_49_META_TYP_75_I1_D: "Gidiş Dönüş",
  T_49_META_TYP_76_I0_D: "Sadece devriye gez, yol üzerindeki hedeflere saldırma",
  T_49_META_TYP_76_I1_D: "Devriye ve Saldırı",
  T_49_META_TYP_79_I0_D: "Silah saldırı gücü",
  T_49_META_TYP_79_I1_D: "Saldırı Menzili",
  T_49_META_TYP_79_I10_D: "Yaylı Başlangıç Sayısı",
  T_49_META_TYP_79_I11_D: "Eşya ID'si",
  T_49_META_TYP_79_I12_D: "İki atış arasındaki minimum bekleme süresi, saniye cinsinden. Her atış, atış türüne bağlı olarak birden fazla mermi ateşleyebilir.",
  T_49_META_TYP_79_I13_D: "Bu silaha sahip olan oyuncular",
  T_49_META_TYP_79_I14_D: "Mermi Tüketimi",
  T_49_META_TYP_79_I15_D: "Çift silah kullanma türü (0: çift silah kullanma yok, 1: sahip olunan, 2: herhangi bir silah)",
  T_49_META_TYP_79_I16_D: "Zırh Hasar Katsayısı",
  T_49_META_TYP_79_I17_D: "Oyuncu hareket hızı",
  T_49_META_TYP_79_I18_D: "Gövde vuruşlarında hasar oranı",
  T_49_META_TYP_79_I19_D: "Kafa vuruşları için hasar oranı",
  T_49_META_TYP_79_I2_D: "İki mermi arasındaki minimum bekleme süresi (saniye cinsinden)",
  T_49_META_TYP_79_I20_D: "Uzuvlar için hasar oranı",
  T_49_META_TYP_79_I21_D: "Ek hasar oranı (araba, petrol varil buz duvarı)",
  T_49_META_TYP_79_I22_D: "Sırtında Görünür",
  T_49_META_TYP_79_I23_D: "Ekstra hasar için yere vurun",
  T_49_META_TYP_79_I24_D: "Mermi Başına Miktar",
  T_49_META_TYP_79_I25_D: "Yeniden yükleme hızı (temel hız * katsayı)",
  T_49_META_TYP_79_I26_D: "Mevcut Mermi Sayısı",
  T_49_META_TYP_79_I27_D: "Silah kaplama kimliği",
  T_49_META_TYP_79_I28_D: "Oyuncunun yapılandırması önceliklendirildiğinde, oyuncunun silah görünümü yapılandırması silahın kendi silah görünümü niteliklerini geçersiz kılacaktır",
  T_49_META_TYP_79_I29_D: "Bir silah kaplamasının özelliklerini bir silaha yazarken, silahın temel değeri silah kaplamasından etkilenecektir.",
  T_49_META_TYP_79_I3_D: "Mermi Şarjör Boyutu",
  T_49_META_TYP_79_I30_D: "Yayılma artış oranı (0,1 = her ek atış patlaması nişangahı %10 artırır)",
  T_49_META_TYP_79_I31_D: "Dağılım kurtarma hızı",
  T_49_META_TYP_79_I32_D: "Oyuncunun atış sırasındaki hızı etkiler",
  T_49_META_TYP_79_I33_D: "Hareket halindeyken yayılma boyutu (1,5 = 1,5 * taban artı işareti boyutu)",
  T_49_META_TYP_79_I34_D: "Silah Türü",
  T_49_META_TYP_79_I36_D: "Ateş Türü",
  T_49_META_TYP_79_I37_D: "Tek Atış Midir",
  T_49_META_TYP_79_I38_D: "Sessiz",
  T_49_META_TYP_79_I39_D: "Kapsama Hız Oranı",
  T_49_META_TYP_79_I4_D: "İlk Şarjör Sayısı",
  T_49_META_TYP_79_I5_D: "Zırh Delme",
  T_49_META_TYP_79_I6_D: "Tam Hasar Mesafesi",
  T_49_META_TYP_79_I7_D: "Minimum Hasar Mesafesi",
  T_49_META_TYP_79_I8_D: "Minimum Hasar",
  T_49_META_TYP_79_I9_D: "Dağılma başlamadan önce ateşlenebilecek mermi sayısı",
  T_49_META_TYP_80_I1_D: "Doğru olduğunda, manuel kapatma yasaktır",
  T_49_META_TYP_80_I2_D: "Bağlı mağaza varlığı",
  T_49_META_TYP_80_I4_D: "Bağlı Cüzdan ID",
  T_49_META_TYP_80_I5_D: "İstek Türü",
  T_49_META_TYP_80_I6_D: "Mevcut kullanıcı arayüzü oynatıcısının talep ettiği hedef türü",
  T_49_META_TYP_80_I7_D: "Tetiklenen Varlık ID",
  T_49_META_TYP_81_I0_D: "Rastgele Buff",
  T_49_META_TYP_81_I1_D: "HP Buff",
  T_49_META_TYP_81_I2_D: "Mermi Buff",
  T_49_META_TYP_81_I3_D: "Zırh Buff",
  T_49_META_TYP_82_I1_D: "Düğme Simgesi",
  T_49_META_TYP_82_I3_D: "Bağlantı noktasına göre konum",
  T_49_META_TYP_83_I1_D: "Para",
  T_49_META_TYP_83_I2_D: "Parametreleri Geçme",
  T_49_META_TYP_86_I0_D: "Minimum",
  T_49_META_TYP_86_I1_D: "Maksimum",
  T_49_META_TYP_86_I2_D: "Tüm hesaplamalardan önce temel katsayı, orijinal değerle çarpılır",
  T_49_META_TYP_86_I3_D: "Ön biriktirici, çarpmadan önce biriktirir ve çarpma hesaplamasına katılır",
  T_49_META_TYP_86_I4_D: "Sürekli çarpan, sürekli çarpma, örneğin (%90'a düşür, %110'a güçlendir) etkisi Değer*%90*%110'dur",
  T_49_META_TYP_86_I5_D: "Çarpım biriktiricisi, örneğin (%10 ekle, %5 ekle) Değer*(1+%10+%5) etkisine sahiptir",
  T_49_META_TYP_86_I6_D: "Post-akümülatör, çarpma işlemine katılmaz ve sonuna eklenir",
  T_49_META_TYP_88_I0_D: "Temel tip, en temel oyun para birimi, mevcut versiyonda genel emtiaların fiyatlandırma tipi",
  T_49_META_TYP_89_I0_D: "Şu anda sürümde yalnızca temel para birimi var",
  T_49_META_TYP_89_I1_D: "Para birimi miktarı",
  T_49_META_TYP_89_I2_D: "Para Birimi Simgeleri",
  T_49_META_TYP_89_I3_D: "Para Birimi Simge Rengi",
  T_49_META_TYP_90_I0_D: "Cüzdanın içeriği bir sürü para biriminden oluşuyor",
  T_49_META_TYP_92_I0_D: "Kare Ahşap Kutu",
  T_49_META_TYP_92_I1_D: "Uzun Ahşap Kutu",
  T_49_META_TYP_92_I10_D: "Gözetleme Kulesi",
  T_49_META_TYP_92_I100_D: "Merdiven",
  T_49_META_TYP_92_I101_D: "Merdiven Durağı B",
  T_49_META_TYP_92_I102_D: "Merdiven Durağı A",
  T_49_META_TYP_92_I103_D: "Telefon Kulübesi",
  T_49_META_TYP_92_I104_D: "BIS Temalı Duvar",
  T_49_META_TYP_92_I105_D: "BIS Temalı Çiçek Yatakları",
  T_49_META_TYP_92_I106_D: "Otomatik Satış Makinesi",
  T_49_META_TYP_92_I107_D: "Canavar varlık",
  T_49_META_TYP_92_I108_D: "Ünite Üreteci",
  T_49_META_TYP_92_I109_D: "Spor Araba",
  T_49_META_TYP_92_I11_D: "Bekçi Evi",
  T_49_META_TYP_92_I110_D: "Tuk-Tuk",
  T_49_META_TYP_92_I111_D: "Yıkılabilir Ahşap Kasa",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Motoiklet",
  T_49_META_TYP_92_I114_D: "Canavar Kamyonlar",
  T_49_META_TYP_92_I115_D: "Altın Üreteci",
  T_49_META_TYP_92_I116_D: "Merdiven Durağı C",
  T_49_META_TYP_92_I117_D: "İşaret",
  T_49_META_TYP_92_I118_D: "Çit",
  T_49_META_TYP_92_I119_D: "Forman Makinesi",
  T_49_META_TYP_92_I12_D: "İki Katlı Ev",
  T_49_META_TYP_92_I121_D: "Beton Direk",
  T_49_META_TYP_92_I122_D: "Loot Futbol Kutusu",
  T_49_META_TYP_92_I123_D: "Yağ Fıçısı",
  T_49_META_TYP_92_I124_D: "Düşük Yerçekimi Bölgesi",
  T_49_META_TYP_92_I125_D: "Silah",
  T_49_META_TYP_92_I126_D: "Çit B",
  T_49_META_TYP_92_I127_D: "Küçük Ev A",
  T_49_META_TYP_92_I128_D: "Hasarlı Kamyon",
  T_49_META_TYP_92_I129_D: "Temel Küre",
  T_49_META_TYP_92_I13_D: "Kum Heykel",
  T_49_META_TYP_92_I130_D: "Temel Konik",
  T_49_META_TYP_92_I131_D: "Temel Silindir",
  T_49_META_TYP_92_I132_D: "Tüketilebilir Üretici",
  T_49_META_TYP_92_I133_D: "Özel Su Alanı",
  T_49_META_TYP_92_I134_D: "Ok",
  T_49_META_TYP_92_I135_D: "Boyanmış Blok",
  T_49_META_TYP_92_I136_D: "Boyanmış Yağ Varili",
  T_49_META_TYP_92_I137_D: "Metin",
  T_49_META_TYP_92_I138_D: "Simge",
  T_49_META_TYP_92_I139_D: "Buz Bebek",
  T_49_META_TYP_92_I14_D: "Şelale",
  T_49_META_TYP_92_I140_D: "Kapsül Tetikleyici",
  T_49_META_TYP_92_I141_D: "Küre Çarpışma Tetikleyici",
  T_49_META_TYP_92_I142_D: "Yansıtan Düz Renk Temel Blok 1",
  T_49_META_TYP_92_I143_D: "Bumper Car Üreticisi",
  T_49_META_TYP_92_I144_D: "Kareli Lunapark Bloku",
  T_49_META_TYP_92_I145_D: "Büyük Ekran",
  T_49_META_TYP_92_I146_D: "Podyum",
  T_49_META_TYP_92_I147_D: "Dev Şekerleme",
  T_49_META_TYP_92_I148_D: "Yiyecek Kamyonu B",
  T_49_META_TYP_92_I15_D: "Kiraz Ağacı",
  T_49_META_TYP_92_I16_D: "Tek Katlı Ev",
  T_49_META_TYP_92_I17_D: "Üç Katlı Ev",
  T_49_META_TYP_92_I18_D: "Muz Ağacı",
  T_49_META_TYP_92_I19_D: "Tuvalet",
  T_49_META_TYP_92_I2_D: "Çalılık Kapatılmış Uzun Ahşap Kutu",
  T_49_META_TYP_92_I20_D: "Çit",
  T_49_META_TYP_92_I21_D: "Yıkılabilir Konteyner",
  T_49_META_TYP_92_I22_D: "Yıkılabilir Çit",
  T_49_META_TYP_92_I23_D: "Lastik",
  T_49_META_TYP_92_I24_D: "Pandalı Araba",
  T_49_META_TYP_92_I25_D: "Amfibi Araç",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Çöp Kutusu",
  T_49_META_TYP_92_I28_D: "Medikal Çadır",
  T_49_META_TYP_92_I29_D: "Garaj",
  T_49_META_TYP_92_I3_D: "Saman Yığını",
  T_49_META_TYP_92_I30_D: "Boyanmış Duvar",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Demir Platformu",
  T_49_META_TYP_92_I33_D: "Konteyner Ev",
  T_49_META_TYP_92_I34_D: "Römork",
  T_49_META_TYP_92_I35_D: "Duvar A",
  T_49_META_TYP_92_I36_D: "Müzik Notları - Piyano",
  T_49_META_TYP_92_I37_D: "Müzik Notları - Piyano",
  T_49_META_TYP_92_I38_D: "Müzik Notları - Davul",
  T_49_META_TYP_92_I39_D: "Müzik Notları - Davul",
  T_49_META_TYP_92_I4_D: "Hurda Araç",
  T_49_META_TYP_92_I40_D: "Müzik Notları - Synthesizer A",
  T_49_META_TYP_92_I41_D: "Müzik Notları - Synthesizer A",
  T_49_META_TYP_92_I42_D: "Müzik Notları - Synthesizer B",
  T_49_META_TYP_92_I43_D: "Müzik Notları - Synthesizer B",
  T_49_META_TYP_92_I44_D: "Müzik Notları - Synthesizer C",
  T_49_META_TYP_92_I45_D: "Müzik Notları - Synthesizer C",
  T_49_META_TYP_92_I46_D: "Buff Üretici",
  T_49_META_TYP_92_I47_D: "Pervane mekanizması",
  T_49_META_TYP_92_I48_D: "Tava mekanizması",
  T_49_META_TYP_92_I49_D: "Blok Tuzağı",
  T_49_META_TYP_92_I5_D: "Hurda Otobüs",
  T_49_META_TYP_92_I50_D: "Halka mekanizması",
  T_49_META_TYP_92_I51_D: "Dev Çekiç Tuzağı",
  T_49_META_TYP_92_I52_D: "Mobil pano",
  T_49_META_TYP_92_I53_D: "Hareketli Hedef",
  T_49_META_TYP_92_I54_D: "Teleskopik Duvar",
  T_49_META_TYP_92_I55_D: "Yağma noktası silah bileşenleri",
  T_49_META_TYP_92_I56_D: "Yağma noktası mermi bileşeni",
  T_49_META_TYP_92_I57_D: "Yağma noktası tüketilebilir öğe bileşenleri",
  T_49_META_TYP_92_I58_D: "Yağma noktası atma öğesi bileşeni",
  T_49_META_TYP_92_I59_D: "Yağma noktası yakınlaştırma bileşeni",
  T_49_META_TYP_92_I6_D: "Konteyner A",
  T_49_META_TYP_92_I60_D: "Yağma noktası zırh bileşenleri",
  T_49_META_TYP_92_I61_D: "I Boru",
  T_49_META_TYP_92_I62_D: "T Boru",
  T_49_META_TYP_92_I63_D: "Çapraz Boru",
  T_49_META_TYP_92_I64_D: "Dirsek Boru",
  T_49_META_TYP_92_I65_D: "Dev Mantar Kümesi",
  T_49_META_TYP_92_I66_D: "Kuru Raf",
  T_49_META_TYP_92_I67_D: "Ahşap Köprü",
  T_49_META_TYP_92_I68_D: "Ekran",
  T_49_META_TYP_92_I69_D: "Beton Direği",
  T_49_META_TYP_92_I7_D: "Konteyner B",
  T_49_META_TYP_92_I70_D: "Kaktüs",
  T_49_META_TYP_92_I71_D: "Ölü Ağaç",
  T_49_META_TYP_92_I72_D: "Saray Feneri",
  T_49_META_TYP_92_I73_D: "Sokak Lambası",
  T_49_META_TYP_92_I74_D: "Güneş Paneli",
  T_49_META_TYP_92_I75_D: "Klima",
  T_49_META_TYP_92_I76_D: "Kare",
  T_49_META_TYP_92_I77_D: "Eğim",
  T_49_META_TYP_92_I78_D: "Yiyecek Kamyonu",
  T_49_META_TYP_92_I79_D: "Ölüm veya Dokunulmazlık Tetikleyicisi",
  T_49_META_TYP_92_I8_D: "Konteyner C",
  T_49_META_TYP_92_I80_D: "Kontrol Noktası",
  T_49_META_TYP_92_I81_D: "Bitiş Pozisyonu",
  T_49_META_TYP_92_I82_D: "Zar",
  T_49_META_TYP_92_I83_D: "Bank",
  T_49_META_TYP_92_I84_D: "Otobüs Durağı",
  T_49_META_TYP_92_I85_D: "Köpek Evi",
  T_49_META_TYP_92_I86_D: "Reklam Panosu",
  T_49_META_TYP_92_I87_D: "Su Kovası",
  T_49_META_TYP_92_I88_D: "Grafiti Duvarı",
  T_49_META_TYP_92_I89_D: "Kıl Çatı Kulübe",
  T_49_META_TYP_92_I9_D: "Kabin",
  T_49_META_TYP_92_I90_D: "Taş Kemeri Köprü",
  T_49_META_TYP_92_I91_D: "Şemsiye Seti",
  T_49_META_TYP_92_I92_D: "Finisher Afişi",
  T_49_META_TYP_92_I93_D: "Kale",
  T_49_META_TYP_92_I94_D: "Canavar Doğma Noktası",
  T_49_META_TYP_92_I95_D: "İşaret",
  T_49_META_TYP_92_I97_D: "Özelleştirilmiş Tetikleyici",
  T_49_META_TYP_92_I98_D: "Çift Kapı",
  T_49_META_TYP_92_I99_D: "Barikat",
  T_49_META_TYP_94_I0_D: "Ekle",
  T_49_META_TYP_94_I1_D: "Çarpma",
  T_49_META_TYP_95_I0_D: "Para Birimi Türü",
  T_49_META_TYP_95_I1_D: "Para birimi miktarı",
  T_49_META_TYP_96_I0_D: "Cüzdanı Al",
  T_49_META_TYP_96_I1_D: "Görüntüleme konumu (bağlantı noktası sağ üst köşedir)",
  T_49_META_TYP_97_I0_D: "Dünya koordinatlarındaki konum",
  T_49_META_TYP_97_I1_D: "Dünya koordinat sisteminde dönüş açısı, XYZ bileşenleri eğim açısı, sapma açısı ve yuvarlanma açısı olup dönüş sırası YXZ'dir.",
  T_49_META_TYP_97_I10_D: "Yerel koordinat ekseninin yönü x",
  T_49_META_TYP_97_I11_D: "Yerel koordinat ekseni z'nin yönü",
  T_49_META_TYP_97_I2_D: "Dünya koordinatlarında ölçekleme",
  T_49_META_TYP_97_I3_D: "Bu düğümün üst düğümü",
  T_49_META_TYP_97_I4_D: "Dünya koordinatlarında dönüş, kuaterniyonlar olarak ifade edilir",
  T_49_META_TYP_97_I5_D: "Yerel koordinat sistemindeki konum",
  T_49_META_TYP_97_I6_D: "Yerel koordinat sistemindeki dönüş, bir kuaterniyon olarak ifade edilir",
  T_49_META_TYP_97_I7_D: "Yerel koordinat sistemindeki dönüş açısı, XYZ bileşenleri eğim açısı, sapma açısı ve yuvarlanma açısı olup dönüş sırası YXZ'dir.",
  T_49_META_TYP_97_I8_D: "Yerel koordinat sisteminde ölçekleme boyutu",
  T_49_META_TYP_97_I9_D: "Yerel koordinat ekseni y'nin yönü",
  T_49_META_TYP_99_I0_D: "Futbol Yarıçapı",
  T_49_META_TYP_99_I1_D: "Normal koşullar altında sürtünme katsayısı",
  T_49_META_TYP_99_I2_D: "Darbe altındaki sürtünme katsayısı",
  T_49_META_TYP_99_I3_D: "Minimum Atış Açısı",
  T_49_META_TYP_99_I4_D: "Minimum Yükseklik Açısı",
  T_49_META_TYP_99_I5_D: "Sıfırlama Süresi",
  T_49_META_TYP_99_I6_D: "Maksimum Atış Açısı",
  T_49_META_TYP_99_I7_D: "Sıfırlama Konumu",
  T_49_META_TYPE_0_D: "Nesne, tür hiyerarşisinin köküdür",
  T_49_META_TYPE_1_D: "Liste, bir veri kümesi için bir kapsayıcıdır",
  T_49_META_TYPE_10_D: "Varlık tabanlı bileşen, tüm bileşenler bu bileşeni birleştirecek",
  T_49_META_TYPE_100_D: "Forma Makinesi",
  T_49_META_TYPE_101_D: "Morf Nesnesi",
  T_49_META_TYPE_1010_D: "Zamanlayıcı Bilgisi",
  T_49_META_TYPE_1011_D: "Açılış Afişi",
  T_49_META_TYPE_1012_D: "İki takımın turunun başlangıcındaki afiş varlığı. Varlık özelliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir",
  T_49_META_TYPE_1013_D: "Genellikle, turun başındaki afiş varlığı, varlık özelliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir.",
  T_49_META_TYPE_1014_D: "Takım turu skoru afiş varlığı. Varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir.",
  T_49_META_TYPE_1015_D: "Kontrol Noktası Yöneticisi Varlığı. Varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir.",
  T_49_META_TYPE_1016_D: "Varlık, turun sonunda görüntülenir. Varlık özniteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir",
  T_49_META_TYPE_1017_D: "Başlangıçta iki takım varsa, birbirleriyle savaşan iki takımın pankartını asın",
  T_49_META_TYPE_1018_D: "Her iki takımın skoru",
  T_49_META_TYPE_1019_D: "Sonuç: galibiyet, mağlubiyet, beraberlik",
  T_49_META_TYPE_102_D: "Diriliş kaynak türü: Ölüm, Düşüş",
  T_49_META_TYPE_1020_D: "Sayı varlığını çevirin, varlık niteliklerini değiştirmek ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir",
  T_49_META_TYPE_1021_D: "Aşama geri sayım varlığı. Varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir.",
  T_49_META_TYPE_1022_D: "Oyun bilgisi altyazı varlığı. Varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntü içeriğini etkileyecektir.",
  T_49_META_TYPE_1023_D: "İki takımın oyun bilgisi varlıkları. Varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir",
  T_49_META_TYPE_1024_D: "Takım maç bilgisi kullanıcı arayüzü varlığı. Varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir.",
  T_49_META_TYPE_1027_D: "Typeof kullanıldığında döndürülen bir türün türünü açıklar",
  T_49_META_TYPE_1028_D: "Fraksiyon bilgi varlığı. Varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir.",
  T_49_META_TYPE_1029_D: "Simge, bilgi varlığına ilişkin istemlerde bulunur; varlık niteliklerinin değiştirilmesi, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkiler",
  T_49_META_TYPE_103_D: "Öğe yuvası türü numaralandırması",
  T_49_META_TYPE_1030_D: "İki takımın oyun bilgilerinin basitleştirilmiş bir varlığı. Varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir",
  T_49_META_TYPE_1031_D: "Zamanlama istemi arayüzü varlığı, varlık özniteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir",
  T_49_META_TYPE_1032_D: "Kayan metin, varlığa istemde bulunur. Varlık özniteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkiler",
  T_49_META_TYPE_1033_D: "Sıra değiştirme varlığı, geçerli sıra yerleşimini ve bir sonraki sıra başlangıç bilgisini içerir. Varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir",
  T_49_META_TYPE_1035_D: "Puan tablosu düğmesi UI varlığını açın. Varlık özniteliklerini değiştirmek, ilgili UI'daki görüntüleme içeriğini etkileyecektir.",
  T_49_META_TYPE_1036_D: "Enfeksiyon modu, kullanıcı arayüzü mevcut zombi seviyesini gösteriyor",
  T_49_META_TYPE_1037_D: "Nokta dinamik efektli bir kullanıcı arayüzü varlığı ekleyin. Varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir.",
  T_49_META_TYPE_1038_D: "Enfeksiyon modu zombi kullanıcı arayüzü efektleri",
  T_49_META_TYPE_1039_D: "Geri sayım kayan metin istemi varlığı, varlık niteliklerini değiştirmek, ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir",
  T_49_META_TYPE_104_D: "Forma Stili",
  T_49_META_TYPE_1040_D: "UI Kart Seçim Paneli",
  T_49_META_TYPE_1041_D: "UI Kimlik Bildirimi",
  T_49_META_TYPE_1042_D: "UI 5 Saniyelik Geri Sayım",
  T_49_META_TYPE_1043_D: "UI Başlık Afişi",
  T_49_META_TYPE_1044_D: "UI Dahili Anahtar",
  T_49_META_TYPE_1045_D: "UI Beceri Düğmesi",
  T_49_META_TYPE_105_D: "Futbol Golü",
  T_49_META_TYPE_106_D: "Amaç yardım türü",
  T_49_META_TYPE_107_D: "Hedef alınabilir ve vurulabilir, ancak mutlaka hasar almaz",
  T_49_META_TYPE_108_D: "Tam sayı türü, 64 bitlik işaretli tam sayı",
  T_49_META_TYPE_109_D: "Sohbet kanalı varlığı, kendi kanal kimliğini ve oynatıcılarını içeren bir kapsayıcıdır.",
  T_49_META_TYPE_11_D: "Küresel varlık, tüm oyunda benzersiz",
  T_49_META_TYPE_110_D: "Boşta Ses Kanalı",
  T_49_META_TYPE_111_D: "Davranış Türü",
  T_49_META_TYPE_112_D: "Oyuncu Davranış Durum Türü",
  T_49_META_TYPE_113_D: "Davul Müziği",
  T_49_META_TYPE_114_D: "Lead1 Müziği",
  T_49_META_TYPE_115_D: "Lead2 Müziği",
  T_49_META_TYPE_116_D: "Lead3 Müziği",
  T_49_META_TYPE_117_D: "Davul müzik bileşeni türü",
  T_49_META_TYPE_118_D: "Taraf",
  T_49_META_TYPE_119_D: "Saldırı seçenekleri",
  T_49_META_TYPE_12_D: "Saldırabilen, saldırıya uğrayabilen, öldürebilen vb. bir savaşçı varlık.",
  T_49_META_TYPE_120_D: "UI İlerleme Çubuğu",
  T_49_META_TYPE_121_D: "Her dalga aralığı zamanı",
  T_49_META_TYPE_122_D: "Gök Kutusu",
  T_49_META_TYPE_123_D: "Skybox temel tür numaralandırması",
  T_49_META_TYPE_124_D: "Arama Aralığı",
  T_49_META_TYPE_125_D: "Dokular ve şeffaflık gibi nesnelerin temel görünümünü değiştirebilirsiniz",
  T_49_META_TYPE_126_D: "Sağlık Çubuğu",
  T_49_META_TYPE_127_D: "Nesneler nasıl taşınır",
  T_49_META_TYPE_128_D: "Morf Edilebilir Nesne",
  T_49_META_TYPE_129_D: "Ganimet Mermi Türü",
  T_49_META_TYPE_13_D: "UI kontrol varlığı",
  T_49_META_TYPE_130_D: "Ganimet Tüketim Malzemesi Türü",
  T_49_META_TYPE_131_D: "Ganimet Zırh Türü",
  T_49_META_TYPE_132_D: "Ganimet Atılabilir Türü",
  T_49_META_TYPE_133_D: "Ganimet Dürbün Türü",
  T_49_META_TYPE_134_D: "Ganimet Silah Türü",
  T_49_META_TYPE_135_D: "Seçilen mühimmat türünün düşmesine neden olur",
  T_49_META_TYPE_136_D: "Seçilen türdeki sahne malzemelerinin düşmesini sağlayacak",
  T_49_META_TYPE_137_D: "Seçilen türde bir merminin düşmesine neden olur",
  T_49_META_TYPE_138_D: "Seçili türün kapsamının düşmesine neden olur",
  T_49_META_TYPE_139_D: "Seçilen türdeki zırhın düşmesine neden olur",
  T_49_META_TYPE_14_D: "Oyun içindeki oyuncu varlıkları, kullanıcı başına bir tane",
  T_49_META_TYPE_140_D: "Dalga",
  T_49_META_TYPE_141_D: "Loot Futbol Türü",
  T_49_META_TYPE_142_D: "Loot Futbol Kutusu",
  T_49_META_TYPE_143_D: "Lead1 Müzik Bileşeni Türü",
  T_49_META_TYPE_144_D: "Lead2 Müzik Bileşeni Türü",
  T_49_META_TYPE_145_D: "Lead3 Müzik Bileşeni Türü",
  T_49_META_TYPE_146_D: "Klavye Müzik Bileşeni Türü",
  T_49_META_TYPE_147_D: "Çeşitli önceden ayarlanmış kamera türlerinin yanı sıra özel kamera türleri de sağlar",
  T_49_META_TYPE_148_D: "Kamera Bileşenleri",
  T_49_META_TYPE_149_D: "Çeviri Anahtarı",
  T_49_META_TYPE_15_D: "Oyundaki takım varlıkları, her takım için bir tane",
  T_49_META_TYPE_150_D: "Yağ Fıçısı",
  T_49_META_TYPE_151_D: "Kuaterniyon, yalnızca dönüşü temsil etmek için kullanılan özel bir dört boyutlu vektördür.",
  T_49_META_TYPE_152_D: "Düşük Yerçekimi Bölgesi",
  T_49_META_TYPE_153_D: "Konumda karşılık gelen türdeki varlıkları üretecek varlık konteyneri",
  T_49_META_TYPE_154_D: "Çift Ellerle Silah Türü",
  T_49_META_TYPE_155_D: "Kask Varlığı",
  T_49_META_TYPE_156_D: "Vücut zırhı varlığı",
  T_49_META_TYPE_157_D: "Kamera Geçiş Türü",
  T_49_META_TYPE_158_D: "Metin istemi arayüzü",
  T_49_META_TYPE_159_D: "Vektör2",
  T_49_META_TYPE_16_D: "Seviye Nesnesi Varlığı",
  T_49_META_TYPE_160_D: "Harita Türü",
  T_49_META_TYPE_161_D: "Değiştirilemez Doku VFX",
  T_49_META_TYPE_162_D: "Tür Listesi",
  T_49_META_TYPE_163_D: "Tür veya Tür Listesi",
  T_49_META_TYPE_164_D: "Bileşen, tüm varlık bileşenlerinin veya belirli bileşen sınıflarının temel sınıfıdır",
  T_49_META_TYPE_165_D: "Çarpışma Kutusu Bileşeni",
  T_49_META_TYPE_166_D: "Duygu",
  T_49_META_TYPE_167_D: "Özel efekt varlığı, görüntülenen özel bir efekti (silinebilir, geri dönüştürülebilir ve yeniden kullanılabilir) temsil eder",
  T_49_META_TYPE_17_D: "Seviye Nesne Listesi",
  T_49_META_TYPE_170_D: "Görünürlüğün ayarlanıp ayarlanamayacağını belirtir",
  T_49_META_TYPE_171_D: "Mantar",
  T_49_META_TYPE_172_D: "Mühimmat",
  T_49_META_TYPE_173_D: "Sırt Çantası",
  T_49_META_TYPE_174_D: "El bombası bileşenleri",
  T_49_META_TYPE_175_D: "Dondurucu Grenat",
  T_49_META_TYPE_176_D: "Silah Üretici",
  T_49_META_TYPE_177_D: "Kamera ile takip edilen nesne arasında bir engel olduğunda kameranın hareket modu",
  T_49_META_TYPE_178_D: "Kamera görüntüyü nasıl oluşturur?",
  T_49_META_TYPE_179_D: "Temel Küre",
  T_49_META_TYPE_18_D: "(Eskidi, kullanmıyorum)",
  T_49_META_TYPE_180_D: "Bir bileşenin bir özelliğine atıfta bulunur",
  T_49_META_TYPE_181_D: "Örgü varlığının türünü tanımlamak için kullanılır",
  T_49_META_TYPE_182_D: "Maddi varlık türünü tanımlamak için kullanılır",
  T_49_META_TYPE_183_D: "Doku varlığının türünü tanımlamak için kullanılır",
  T_49_META_TYPE_184_D: "Yerleşik model kaynaklarını kullanarak işleme için bir köprü işleme bileşeni",
  T_49_META_TYPE_185_D: "Özel model kaynaklarıyla işleme için özel işleme bileşeni",
  T_49_META_TYPE_186_D: "Renderer bileşenleri, collider bileşenleri vb. ile birlikte kullanılabilen boş bir nesne bileşeni.",
  T_49_META_TYPE_187_D: "Konteyner",
  T_49_META_TYPE_188_D: "Temel Silindirin veya Koni",
  T_49_META_TYPE_189_D: "Yerelleştirilmiş dizelerin listesi",
  T_49_META_TYPE_19_D: "Liste şablonu, T aracılığıyla içerik türünü belirtebilirsiniz",
  T_49_META_TYPE_190_D: "İki Takım Skor Paneli",
  T_49_META_TYPE_191_D: "Belirli bir menzil içindeki düşmanları geçici olarak kör edebilen taktiksel bir fırlatma silahı.",
  T_49_META_TYPE_192_D: "Kullanımdan sonra, olayı gizleyen duman üretebilir, bu da düşmanın saldırısını engellemek için güçlü bir silahtır.",
  T_49_META_TYPE_193_D: "Çoklu Takım Sonuç Paneli",
  T_49_META_TYPE_194_D: "İndüksiyon mayınları yere yerleştirilebilir. Düşman yaklaştığında patlayacaklardır. Üzerlerine basmamaya dikkat edin.",
  T_49_META_TYPE_195_D: "Araya sıkıştırılmış hareket nasıl çalınır",
  T_49_META_TYPE_197_D: "Oynanabilir bileşenler",
  T_49_META_TYPE_198_D: "Eşya Temeli",
  T_49_META_TYPE_199_D: "Hava muharebesi için yardımcı ekipman, ancak her zaman enerji tüketimine dikkat etmeniz gerekir",
  T_49_META_TYPE_2_D: "Doğru, yanlış veya evet veya hayırı temsil etmek için kullanılan Boole türü",
  T_49_META_TYPE_20_D: "Tür sistemine göre otomatik olarak oluşturulan yerleşik arayüz türü numaralandırması",
  T_49_META_TYPE_200_D: "Jailbreak Alanı",
  T_49_META_TYPE_201_D: "Girişten sonra yüzebileceğiniz alanlar",
  T_49_META_TYPE_202_D: "Çarpışma ID'si",
  T_49_META_TYPE_203_D: "Enterpolasyon Hareketi",
  T_49_META_TYPE_204_D: "Havada çift zıplama yapmanızı sağlayan teknolojik bir güç cihazıyla donatılmış ayakkabılar",
  T_49_META_TYPE_205_D: "Gökyüzünde uçabilen bir yamaç paraşütü. Yüksek bir irtifadan iniş yapmak ve daha uzak bir yere hareket etmek için kullanılabilir.",
  T_49_META_TYPE_206_D: "Kaykay",
  T_49_META_TYPE_207_D: "Zipline",
  T_49_META_TYPE_208_D: "Oynanabilirlerin Listesi",
  T_49_META_TYPE_209_D: "Oynanabilir veya Oynanabilirlerin listesi",
  T_49_META_TYPE_21_D: "Belirli işlevlerin arayüzünü kapsülleyen yerleşik arayüz varlığı",
  T_49_META_TYPE_210_D: "Balistik animasyon balistik hareketin simülasyonudur.",
  T_49_META_TYPE_211_D: "Koordinat Sistemi",
  T_49_META_TYPE_212_D: "Bir nesne diğerini takip eder",
  T_49_META_TYPE_213_D: "Bir nesnenin ön yüzü her zaman diğer nesneye bakar",
  T_49_META_TYPE_214_D: "Atlas sprite varlığını tanımlamak için kullanılan kimlik",
  T_49_META_TYPE_215_D: "yarışma sonuçları",
  T_49_META_TYPE_216_D: "Sözlük veri kabı, veri öğesi Anahtar, Değer çiftidir",
  T_49_META_TYPE_217_D: "Sözlük veri şablonu, içerik türü T1 ve T2 ile belirtilebilir",
  T_49_META_TYPE_218_D: "Bulunduğu yerden her yöne eşit yoğunlukta ışık yayan bir ışık kaynağı türü",
  T_49_META_TYPE_219_D: "Motosiklet Araçlar",
  T_49_META_TYPE_22_D: "Özel arayüz, oyuncunun arayüz düzenleyicisi aracılığıyla oluşturduğu arayüz",
  T_49_META_TYPE_220_D: "Tuk-tuk (üç tekerlekli) araç",
  T_49_META_TYPE_221_D: "Amfibi/Makineli Tüfekli Motosiklet Araç",
  T_49_META_TYPE_222_D: "Dört tekerlekli araç",
  T_49_META_TYPE_224_D: "Yetenek Türü Listesi",
  T_49_META_TYPE_225_D: "Yüksek teknoloji ürünü malzemelerden üretilen yapay zekalı taret, belirli bir menzil içindeki düşmanları aktif bir şekilde arayıp saldıracak.",
  T_49_META_TYPE_226_D: "Taret pervanesi kullanıldıktan sonra oluşturulan taret",
  T_49_META_TYPE_227_D: "Özel kullanıcı arayüzü denetim türü numaralandırması",
  T_49_META_TYPE_23_D: "Tür sistemine göre otomatik olarak oluşturulacak seviye nesne türü numaralandırması",
  T_49_META_TYPE_231_D: "Onarım Kiti",
  T_49_META_TYPE_233_D: "İlerleme Çemberi",
  T_49_META_TYPE_234_D: "Oluşturulan Mayın",
  T_49_META_TYPE_235_D: "Jel Duvarı",
  T_49_META_TYPE_236_D: "Oluşturulan Buz Duvarı",
  T_49_META_TYPE_237_D: "Kanca Tabancası",
  T_49_META_TYPE_238_D: "Gökkuşağı sprey tabancası",
  T_49_META_TYPE_239_D: "Sprey Tüfeği",
  T_49_META_TYPE_24_D: "Sistem tarafından şu anda tanımlanan hasar türleri",
  T_49_META_TYPE_240_D: "Varlık tüm bileşenlerin taşıyıcısıdır. Örnekleri oluşturmak için bileşenlerin varlığa eklenmesi gerekir.",
  T_49_META_TYPE_241_D: "Güçlü kancalı silah",
  T_49_META_TYPE_242_D: "Skor Çubuğu",
  T_49_META_TYPE_243_D: "Giyim yuvaları",
  T_49_META_TYPE_244_D: "Bir metin varlığı görüntülenen bir metni temsil eder.",
  T_49_META_TYPE_245_D: "Simge varlığı görüntülenen bir simgeyi temsil eder",
  T_49_META_TYPE_246_D: "Sprey Rengi",
  T_49_META_TYPE_247_D: "Oyuncu UI Türü",
  T_49_META_TYPE_248_D: "Genel kullanıcı arayüzü anahtar varlığı",
  T_49_META_TYPE_249_D: "Ekipman Yuvasını Değiştir",
  T_49_META_TYPE_25_D: "Oyun sürecindeki aşamalar; oyun başlangıcı, oyun hazırlığı, oyun sonu vb.",
  T_49_META_TYPE_250_D: "Etki varlığı görüntülenen bir etkiyi temsil eder",
  T_49_META_TYPE_2500_D: "Oyuncunun ortaya çıkış noktası",
  T_49_META_TYPE_2501_D: "Tetikleyiciler, oyuncuların (veya diğer nesnelerin) giriş ve çıkış olaylarını tetiklemek için kullanılır",
  T_49_META_TYPE_2502_D: "Ölüm veya yenilmezlik tetikleyicisi, oyuncu girdiğinde, niteliğe göre ölüm veya yenilmezlik etkisinin olup olmayacağını kontrol eder.",
  T_49_META_TYPE_2503_D: "Yarış Modu Kontrol Noktaları",
  T_49_META_TYPE_2504_D: "Genellikle yarış modunda belirlenen bitiş çizgisine giren oyuncuyu tanımlamak için kullanılır. Bu belirli bir tetikleyicidir. Özel tetikleyiciler daha sonra açılacaktır. Bu uç nokta, özel tetikleyicinin yalnızca bir sarmalayıcısıdır.",
  T_49_META_TYPE_2505_D: "Spawn noktasının etrafındaki çiti kapattıktan sonra spawn noktasından ayrılabilirsiniz.",
  T_49_META_TYPE_2507_D: "Kule",
  T_49_META_TYPE_2508_D: "Canavar Doğma",
  T_49_META_TYPE_2509_D: "İlgili türün örnekleri talep üzerine üretilebilir",
  T_49_META_TYPE_251_D: "Etki Konteyneri",
  T_49_META_TYPE_2510_D: "Oyuncu yumurtlama alanı (dikdörtgen)",
  T_49_META_TYPE_252_D: "Sprey Sonuç UI",
  T_49_META_TYPE_253_D: "İpucu Butonu",
  T_49_META_TYPE_254_D: "Kalp Atışı Efekti",
  T_49_META_TYPE_255_D: "Zaman Damgası Yerelleştirme Dizesi",
  T_49_META_TYPE_256_D: "Rigidbody Türü",
  T_49_META_TYPE_257_D: "Katı Cisim Bileşeni",
  T_49_META_TYPE_258_D: "Zaman Damgası Format Stili Türü",
  T_49_META_TYPE_259_D: "İpuçları",
  T_49_META_TYPE_26_D: "Oyunda bir tur genellikle birkaç aşamadan oluşan küçük bir turdur.",
  T_49_META_TYPE_260_D: "İlerleme Beceri Butonu",
  T_49_META_TYPE_261_D: "Benzersiz Kimlik",
  T_49_META_TYPE_262_D: "Silah Görünümü ID",
  T_49_META_TYPE_263_D: "Giysi Kimliği",
  T_49_META_TYPE_264_D: "Öğe Kimliği, sürümde yalnızca silah kimliği olduğunda",
  T_49_META_TYPE_265_D: "UI Paneli Varlığı",
  T_49_META_TYPE_267_D: "UI kaydırma görünümü varlığı, oyuncunun UI düzenleyicisi aracılığıyla düzenlediği UI",
  T_49_META_TYPE_268_D: "Açık ve kapalıya ek olarak üç durumlu bir anahtar, orijinal mantığı korumayı seçebilirsiniz",
  T_49_META_TYPE_269_D: "Oyuncunun ekipmanı",
  T_49_META_TYPE_270_D: "Varlık veya Prefabrik Kimliği",
  T_49_META_TYPE_271_D: "UI paneli varlığı, oyuncunun UI düzenleyicisi aracılığıyla düzenlediği UI",
  T_49_META_TYPE_272_D: "Cinsiyet sayımı",
  T_49_META_TYPE_273_D: "Mini Harita",
  T_49_META_TYPE_274_D: "Mini haritada görüntülenen simge hedefi takip edebilir",
  T_49_META_TYPE_275_D: "Bir iskeletteki bireysel parça düğümleri",
  T_49_META_TYPE_276_D: "Cilt kemiklerine erişmek için kullanılan düğüm",
  T_49_META_TYPE_277_D: "İstemci tarafı kamera ışın tespiti",
  T_49_META_TYPE_278_D: "Küçük haritada görüntülenen piksel bloğu, nesnenin o konumdaki çarpışma boyutunu temsil eder",
  T_49_META_TYPE_279_D: "Renkli Davul",
  T_49_META_TYPE_28_D: "Her turun başında durum sıfırlanacak",
  T_49_META_TYPE_280_D: "Küre Tetikleyici",
  T_49_META_TYPE_281_D: "Kapsül Tetikleyici",
  T_49_META_TYPE_282_D: "Ana paketle birlikte gelen ve yüklemeden önce yapılandırma tablosunda ayrıştırılması gereken varlık yapılandırma kimliğini belirtmek için kullanılan varlık yapılandırma kimliğinin türünü açıklar",
  T_49_META_TYPE_283_D: "Varlık tanımlayıcısını temsil etmek için kullanılan ve doğrudan yüklenebilen varlık türünü açıklar",
  T_49_META_TYPE_284_D: "Bir oyuncu karakteriyle değiştirilebilen insansı bir model kaynağını temsil eder",
  T_49_META_TYPE_285_D: "Liste veya sözlük, üzerinde döngü kurulabilir",
  T_49_META_TYPE_286_D: "Komut dosyası varlığını tanımlayan bir kimlik.",
  T_49_META_TYPE_287_D: "Statik bir betik varlığını tanımlayan bir kimlik.",
  T_49_META_TYPE_288_D: "Özel bir kullanıcı arayüzü varlığını tanımlayan bir kimlik.",
  T_49_META_TYPE_289_D: "Önceden ayarlanmış varlığı tanımlamak için kullanılan kimlik",
  T_49_META_TYPE_29_D: "Özel Efektler",
  T_49_META_TYPE_290_D: "Davranış Ağacı",
  T_49_META_TYPE_291_D: "Davranış Ağacı Düğüm Türü",
  T_49_META_TYPE_292_D: "Davranış Ağacı Özel Düğüm",
  T_49_META_TYPE_293_D: "Takılabilir Davranış Ağacı",
  T_49_META_TYPE_294_D: "Kullanıcı arayüzü düzeni varlığı, oyuncuların kullanıcı arayüzü düzenleyicisi aracılığıyla düzenlediği kullanıcı arayüzü",
  T_49_META_TYPE_295_D: "Durum",
  T_49_META_TYPE_296_D: "Animasyon Klibi",
  T_49_META_TYPE_297_D: "Animasyon Kumandası",
  T_49_META_TYPE_298_D: "Döngü Türü",
  T_49_META_TYPE_3_D: "Tam sayı türü, 32 bitlik işaretli tam sayı",
  T_49_META_TYPE_30_D: "İkon",
  T_49_META_TYPE_300_D: "UI3DContainer varlığı, oyuncuların kullanıcı arayüzü düzenleyicisi aracılığıyla düzenlediği kullanıcı arayüzü",
  T_49_META_TYPE_301_D: "AI Yetenek Türü",
  T_49_META_TYPE_302_D: "Ekipman yuvası numaralandırması",
  T_49_META_TYPE_303_D: "BuffData.csv dosyasındaki Id sütununa karşılık gelen, yeni öğeler eklemeden önce bunun geçerli olup olmadığını GPP ile teyit edin.",
  T_49_META_TYPE_304_D: "Güçlendirme Türü Listesi",
  T_49_META_TYPE_305_D: "Davranış Ağacı Düğüm Durumu",
  T_49_META_TYPE_306_D: "Güçlendirmeler ekleyebilir, güçlendirmeleri kaldırabilir ve eklenen güçlendirmelerin bir listesini alabilirsiniz",
  T_49_META_TYPE_307_D: "Buz Duvarı Yapıcısı",
  T_49_META_TYPE_308_D: "Özel Ürün ID Türü",
  T_49_META_TYPE_309_D: "Sahne malzemelerini fırlatmak",
  T_49_META_TYPE_31_D: "Ses",
  T_49_META_TYPE_310_D: "Okçuluk",
  T_49_META_TYPE_311_D: "El Bombası Temeli",
  T_49_META_TYPE_312_D: "Sahne malzemelerini fırlatmak",
  T_49_META_TYPE_313_D: "DeIce Duvarı Grenadı",
  T_49_META_TYPE_314_D: "Animasyon denetleyicilerini ve kaynaklarını yönetme",
  T_49_META_TYPE_315_D: "Oyuncu Çantası",
  T_49_META_TYPE_316_D: "UITexture varlığı, UI düzenleyicisi aracılığıyla oynatıcı tarafından düzenlenen UI",
  T_49_META_TYPE_317_D: "Katı cisim hareket kısıtlamaları, her kısıtlama kombinasyon halinde kullanılabilir",
  T_49_META_TYPE_318_D: "Eklenti",
  T_49_META_TYPE_319_D: "Doldurma Türü Numaralandırması",
  T_49_META_TYPE_32_D: "Oyuncu Durum Türü",
  T_49_META_TYPE_320_D: "Doldurma yönü numaralandırması",
  T_49_META_TYPE_321_D: "Hedef alınabilecek varlıklar",
  T_49_META_TYPE_322_D: "Hasar Görmüş Vücut Bölgesi Türü",
  T_49_META_TYPE_323_D: "UIProfileInfo varlığı, oyuncuların kullanıcı arayüzü düzenleyicisi aracılığıyla düzenlediği kullanıcı arayüzü",
  T_49_META_TYPE_324_D: "Kuvvetlerin katı cisimler üzerindeki çeşitli etkileri. Bu durumun sadece Dinamik katı cisimler için geçerli olduğunu unutmayın.",
  T_49_META_TYPE_325_D: "Özel arayüz varlığındaki denetimi tanımlamak için kullanılan kimlik",
  T_49_META_TYPE_326_D: "Oyuncu Profil Bilgileri",
  T_49_META_TYPE_327_D: "Her bir bileşenin yapılandırmasına göre değiştirme",
  T_49_META_TYPE_328_D: "Davranış Ağacı Kimliği",
  T_49_META_TYPE_329_D: "Koltuk Türü",
  T_49_META_TYPE_33_D: "Sıralama: Artan Sıfır Değerlerini Yoksay, Azalan, Artan",
  T_49_META_TYPE_330_D: "Kendine göre hareket",
  T_49_META_TYPE_331_D: "Bezier Eğrisi",
  T_49_META_TYPE_332_D: "Geri dönüştürülebilir bileşenler",
  T_49_META_TYPE_333_D: "Yazı Tipi Türü",
  T_49_META_TYPE_334_D: "Araç Görünümü ID",
  T_49_META_TYPE_335_D: "Ses efekti varlığı, çalınan bir ses efektini temsil eder.",
  T_49_META_TYPE_336_D: "Ses Efektleri Listesi",
  T_49_META_TYPE_337_D: "Ses Efekti veya Ses Efekti Listesi",
  T_49_META_TYPE_338_D: "Oyuncu davranış niteliği senkronizasyon varlığı",
  T_49_META_TYPE_339_D: "Ekipman Aksesuarı",
  T_49_META_TYPE_34_D: "Eşya Kimliği",
  T_49_META_TYPE_340_D: "Bot Zorluk Türü",
  T_49_META_TYPE_341_D: "Tamsayı sözlüğü",
  T_49_META_TYPE_342_D: "Zamanlayıcı Nesnesi",
  T_49_META_TYPE_343_D: "Atma Bıçağı (alma)",
  T_49_META_TYPE_344_D: "Atma Bıçağı",
  T_49_META_TYPE_345_D: "Silah Türü",
  T_49_META_TYPE_346_D: "Mermi Türü",
  T_49_META_TYPE_347_D: "Çerçeve Kendi Göreceli",
  T_49_META_TYPE_348_D: "Fonksiyon işaretçisi, sanal bir fonksiyonu veya devretme mekanizmasını uygulamak için bir fonksiyon örneğini işaret eder.",
  T_49_META_TYPE_349_D: "Bir coroutine'in tutamacına atıfta bulunur ve bazı tutamak işlemlerini gerçekleştirebilir",
  T_49_META_TYPE_350_D: "Araç Sayımı",
  T_49_META_TYPE_351_D: "Nesnenin türünü tanımlar",
  T_49_META_TYPE_352_D: "UIToggle varlığı, oyuncunun kullanıcı arayüzü düzenleyicisi aracılığıyla düzenlediği kullanıcı arayüzü",
  T_49_META_TYPE_353_D: "İlk Yardım Kiti",
  T_49_META_TYPE_354_D: "Inhalatör",
  T_49_META_TYPE_355_D: "Yatay Çizgi",
  T_49_META_TYPE_356_D: "Airdrop, hazırlık süresi bittikten sonra yüksek bir yerden düşmeye başlayacaktır",
  T_49_META_TYPE_357_D: "Nesnelerin, kenarlıkların, yüzeylerin vb. tanımlayıcı renkleri (silinebilir, geri dönüştürülebilir)",
  T_49_META_TYPE_358_D: "Bir olaya atıfta bulunur",
  T_49_META_TYPE_359_D: "Fizik efektlerine sahip oyuncu kontrolcüsü, kuvvet uygulayabilir ve kuvvet alabilir",
  T_49_META_TYPE_360_D: "Fırlatma Rampası",
  T_49_META_TYPE_361_D: "Katlanmış top, açıldığında insanları fırlatmak için kullanılabilir. Kendinizi güvenli bölgenin dışına fırlatmamaya dikkat edin!",
  T_49_META_TYPE_362_D: "Kartopu savaşı! Şarj!",
  T_49_META_TYPE_363_D: "Mağaza İsteği Satın Alma",
  T_49_META_TYPE_364_D: "Animasyon Tetikleyici",
  T_49_META_TYPE_365_D: "Animasyon tetikleyici arayüz bileşeni",
  T_49_META_TYPE_366_D: "İşlemeyi Toplu Birleştir",
  T_49_META_TYPE_367_D: "Üst pusula",
  T_49_META_TYPE_368_D: "Özel Rol Kaynak Kimliği",
  T_49_META_TYPE_369_D: "Özel Animasyon Kaynak Kimliği",
  T_49_META_TYPE_370_D: "Turun başlangıcında görüntülenen bilgiler",
  T_49_META_TYPE_371_D: "Her turun sonunda sonuçları görüntüleyin",
  T_49_META_TYPE_372_D: "Oyuncu Duruş Türü",
  T_49_META_TYPE_373_D: "Kaynak bilgisi toplama için kullanılan koleksiyon kimliği",
  T_49_META_TYPE_374_D: "Takip Sağlık Çubuğu",
  T_49_META_TYPE_375_D: "Canavar saldırısı hedef türü numaralandırması",
  T_49_META_TYPE_376_D: "Savunma kulesi saldırı hedef türü sayımı",
  T_49_META_TYPE_377_D: "Oyuncu varlıkları ve araç varlık türleri için takma adlar",
  T_49_META_TYPE_378_D: "Ses varlığını tanımlayan bir kimlik.",
  T_49_META_TYPE_379_D: "Yapılandırma tablosu varlığını tanımlamak için kullanılan kimlik",
  T_49_META_TYPE_38_D: "UI boş Widget varlığı, UI, UI düzenleyicisi aracılığıyla oynatıcı tarafından düzenlenir",
  T_49_META_TYPE_380_D: "Özel efekt varlığını tanımlayan bir kimlik.",
  T_49_META_TYPE_381_D: "Animasyon denetleyicisi varlığını tanımlayan bir kimlik.",
  T_49_META_TYPE_382_D: "Devrilme durumu işleme yöntemi",
  T_49_META_TYPE_383_D: "Haritanın yüzeyi veya süslemeleri",
  T_49_META_TYPE_384_D: "Öğeler",
  T_49_META_TYPE_385_D: "Karakter Beceri Kimliği",
  T_49_META_TYPE_386_D: "Yetenek ID Listesi",
  T_49_META_TYPE_387_D: "UITouchPad varlığı, oyuncunun kullanıcı arayüzü düzenleyicisi aracılığıyla düzenlediği kullanıcı arayüzü",
  T_49_META_TYPE_388_D: "Çanta Görünümü ID",
  T_49_META_TYPE_389_D: "Joystick varlığı, UI editörü aracılığıyla oyuncunun düzenlediği UI",
  T_49_META_TYPE_39_D: "UI resim varlığı, UI düzenleyicisi aracılığıyla oynatıcı tarafından düzenlenen UI",
  T_49_META_TYPE_390_D: "Hiyerarşik",
  T_49_META_TYPE_391_D: "Özelleştirilmiş UI veya Widget",
  T_49_META_TYPE_392_D: "Zehir Çemberi Yerleştirilebilen nesneler",
  T_49_META_TYPE_393_D: "PhysicalCCT veya Rigidbody bileşenlerine sahip varlıklar",
  T_49_META_TYPE_394_D: "Matematiksel sabitler",
  T_49_META_TYPE_395_D: "PhysicalCCT veya PlayerCCT bileşenlerine sahip varlıklar bunlarla birlikte hareket edebilir",
  T_49_META_TYPE_396_D: "Oyun Ortası Çıkış Yapılandırması",
  T_49_META_TYPE_397_D: "Çarpışma şeklini tanımlamak için kullanılan bileşen",
  T_49_META_TYPE_398_D: "Dize veya Yerelleştirilmiş Dize",
  T_49_META_TYPE_399_D: "Fiziksel efektlere sahip karakter kontrolörü, yalnızca FF karakterleri için",
  T_49_META_TYPE_4_D: "Kayan nokta türü, 32 bit tek hassasiyetli kayan nokta sayısı",
  T_49_META_TYPE_40_D: "UI metin varlığı, UI düzenleyicisi aracılığıyla oyuncunun düzenlediği UI",
  T_49_META_TYPE_400_D: "Saldırgan davranışlarda nasıl bulunulur?",
  T_49_META_TYPE_401_D: "Ateş Türü",
  T_49_META_TYPE_402_D: "Sosyal Buton Widget'ı",
  T_49_META_TYPE_403_D: "Sosyal Buton Türleri",
  T_49_META_TYPE_404_D: "Sosyal Düğme Stilleri",
  T_49_META_TYPE_405_D: "Düzenleme Sıralama Türü",
  T_49_META_TYPE_406_D: "Engellerin üzerinden tetiklenebilir",
  T_49_META_TYPE_407_D: "Platform Türü",
  T_49_META_TYPE_408_D: "Temel Veri Takma Adı",
  T_49_META_TYPE_409_D: "Hata kodu numaralandırması",
  T_49_META_TYPE_41_D: "UI düğmesi varlığı, oyuncunun UI düzenleyicisi aracılığıyla düzenlediği UI",
  T_49_META_TYPE_410_D: "Bir oyuncu varlığı veya Dönüşüm varlık türü için takma ad.",
  T_49_META_TYPE_411_D: "Helikopter Aracı",
  T_49_META_TYPE_412_D: "Araba bileşeni, araç bileşeninin işlevsel genişlemesidir",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Kameranın dönüş açısını sınırla",
  T_49_META_TYPE_415_D: "Kişilik",
  T_49_META_TYPE_416_D: "Persona sohbet penceresi arayüzü",
  T_49_META_TYPE_417_D: "Parçacık Varlık Bileşeni",
  T_49_META_TYPE_418_D: "Üyelik durumu sayımı",
  T_49_META_TYPE_419_D: "Silah Derisi Türü",
  T_49_META_TYPE_42_D: "UI giriş varlığı, oyuncunun UI düzenleyicisi aracılığıyla düzenlediği UI",
  T_49_META_TYPE_420_D: "Araç Deri Tipleri",
  T_49_META_TYPE_421_D: "Cilt Tipi",
  T_49_META_TYPE_422_D: "Sırt Çantası Cilt Tipi",
  T_49_META_TYPE_423_D: "Persona ID",
  T_49_META_TYPE_424_D: "Sis efekti temel türü",
  T_49_META_TYPE_425_D: "Parçacık Varlık Kimliği",
  T_49_META_TYPE_426_D: "Işık kaynağından negatif Y eksenine doğru konik ışık yayan ve varsayılan olarak zemini aydınlatan bir ışık kaynağı türü",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "Oyuncunun başka bir karaktere dönüşürken saklaması gereken kostüm bilgisi",
  T_49_META_TYPE_429_D: "Oyuncu veya NPC varlığı",
  T_49_META_TYPE_43_D: "Öğe türü, oyuncu varlıklarının bir listesi olmalıdır",
  T_49_META_TYPE_430_D: "Rastgele Sayı Üreteci",
  T_49_META_TYPE_431_D: "Hareket eden nesne özel bir yol boyunca hareket eder",
  T_49_META_TYPE_432_D: "Eğri Yol Noktalarını Özelleştir",
  T_49_META_TYPE_433_D: "Eğri Yol Nokta Türünü Özelleştir",
  T_49_META_TYPE_434_D: "Özel eğri yolu",
  T_49_META_TYPE_435_D: "Oyuncu benzersiz tanımlayıcı listesi",
  T_49_META_TYPE_436_D: "Hata kodu listesi",
  T_49_META_TYPE_437_D: "Her iki takım için de maç detayları UI varlığı. Varlık niteliklerini değiştirmek, ilgili UI'daki görüntüleme içeriğini etkileyecektir.",
  T_49_META_TYPE_438_D: "Birden fazla takım maçı ayrıntıları kullanıcı arayüzü varlığı, varlık niteliklerini değiştirmek ilgili kullanıcı arayüzündeki görüntüleme içeriğini etkileyecektir",
  T_49_META_TYPE_439_D: "Birleştir",
  T_49_META_TYPE_44_D: "Öğe türü, takım varlıklarının bir listesi olmalıdır",
  T_49_META_TYPE_440_D: "Zaman çizelgesi",
  T_49_META_TYPE_441_D: "Zaman çizelgesi kaynak kimliği",
  T_49_META_TYPE_442_D: "İki takım maç bilgileri için yeni basitleştirilmiş varlık bileşeni, tamamen özelleştirilmiş sayı gösterimini destekler",
  T_49_META_TYPE_443_D: "Diyalog akışı varlık kimliği",
  T_49_META_TYPE_444_D: "Dil Türü",
  T_49_META_TYPE_45_D: "Bool Listesi",
  T_49_META_TYPE_46_D: "Int Listesi",
  T_49_META_TYPE_47_D: "Kayan Liste",
  T_49_META_TYPE_48_D: "Dizi Listesi",
  T_49_META_TYPE_49_D: "Vektör3 Listesi",
  T_49_META_TYPE_5_D: "Dize türü, değer metin içeriğidir",
  T_49_META_TYPE_50_D: "Öğe türü bir varlık listesi olmalıdır",
  T_49_META_TYPE_51_D: "Zombi türü",
  T_49_META_TYPE_53_D: "Genel Seviye Nesnesi",
  T_49_META_TYPE_54_D: "Yıkılabilir Nesne",
  T_49_META_TYPE_55_D: "Genel Spawn Noktası",
  T_49_META_TYPE_56_D: "Araç",
  T_49_META_TYPE_57_D: "Oyuncular oyuna girdiklerinde belirlenen bir yere ışınlanabilirler.",
  T_49_META_TYPE_58_D: "Buff'lar talep üzerine üretilebilir",
  T_49_META_TYPE_59_D: "Hareketli Platform",
  T_49_META_TYPE_6_D: "Mekansal koordinatları veya mekansal yönleri temsil edebilen üç boyutlu vektör",
  T_49_META_TYPE_60_D: "Seçilen türde bir silahın düşmesine neden olur",
  T_49_META_TYPE_61_D: "Tetikleme aralığına girildiğinde bağlı depo açılacaktır",
  T_49_META_TYPE_62_D: "Mükemmel sıçrama özelliğine sahip zarlar",
  T_49_META_TYPE_63_D: "Oyuncular üzerine bastıklarında belirlenen yere zıplayacaklar",
  T_49_META_TYPE_64_D: "Oyuncu üzerine bastığında ses çıkaracak",
  T_49_META_TYPE_65_D: "Temel Ölçeklenebilir",
  T_49_META_TYPE_66_D: "Özel Yol",
  T_49_META_TYPE_67_D: "Yol Noktası",
  T_49_META_TYPE_68_D: "Zombiler gibi yapay zeka canavar varlıkları",
  T_49_META_TYPE_69_D: "Büyük sayılar yüksek hassasiyetli kayan nokta sayılarıdır",
  T_49_META_TYPE_7_D: "Sayı, tam sayı, 64 bit tam sayı veya kayan nokta türü için bir tür takma adıdır",
  T_49_META_TYPE_70_D: "Öznitelik formülleri, varlık öznitelik değerlerini hesaplamak için kullanılır. Şu anda yalnızca bazı oyuncu öznitelikleri ve silah öznitelikleri desteklenmektedir.",
  T_49_META_TYPE_71_D: "Sadece mağazalarda satılan varlıklar için kullanılır. Mal, mal satın alınarak elde edilen ürün kavramından farklıdır.",
  T_49_META_TYPE_72_D: "Birkaç ürün içerir",
  T_49_META_TYPE_73_D: "Birkaç raf içerir",
  T_49_META_TYPE_74_D: "Eşya Kimliği",
  T_49_META_TYPE_75_D: "Geri Dön",
  T_49_META_TYPE_76_D: "Devriye Stili",
  T_49_META_TYPE_77_D: "Nesneleri üretebilen ve yenileyebilen bir jeneratör varlığı",
  T_49_META_TYPE_78_D: "Birim üreteçleri tarafından emilebilen ve gruplar halinde üretilebilen bir birim varlığı",
  T_49_META_TYPE_79_D: "Silah",
  T_49_META_TYPE_8_D: "Koşullar özel Bool tipindedir",
  T_49_META_TYPE_80_D: "Mağaza arayüzü",
  T_49_META_TYPE_81_D: "Buff Türü",
  T_49_META_TYPE_82_D: "UI Kalp Atışı",
  T_49_META_TYPE_83_D: "Etkileşim Butonu",
  T_49_META_TYPE_84_D: "Sıralanabilir varlıklar, sıralanabilir olma yeteneğine sahip",
  T_49_META_TYPE_85_D: "İntegral edilebilir varlıkların kendi integralleri vardır",
  T_49_META_TYPE_86_D: "Öznitelik formülü faktör türü",
  T_49_META_TYPE_87_D: "RGBA renginin türünü açıklar, her kanal değer aralığı 0~255'tir",
  T_49_META_TYPE_88_D: "Para birimi türü, şu anda yalnızca temel para birimi türü",
  T_49_META_TYPE_89_D: "Para birimi varlığı, para biriminin türünü ve miktarını tanımlamak için kullanılır",
  T_49_META_TYPE_9_D: "Bir dizi koşul",
  T_49_META_TYPE_90_D: "Cüzdan varlığı, bir dizi para birimi varlığı için bir kapsayıcıdır",
  T_49_META_TYPE_91_D: "Tam sayı veya tam sayı dizi türünü ifade eder",
  T_49_META_TYPE_92_D: "Dinamik Olarak Oluşturulabilir Seviye Nesnesi Türü",
  T_49_META_TYPE_93_D: "Formüle edilebilir özelliklere sahip varlıklar",
  T_49_META_TYPE_94_D: "Öznitelik değiştirme yöntemi",
  T_49_META_TYPE_95_D: "Altın Üreteci",
  T_49_META_TYPE_96_D: "Cüzdan",
  T_49_META_TYPE_97_D: "Pozisyon, döndürme ve ölçekleme, ebeveyn-çocuk yapısını destekler",
  T_49_META_TYPE_98_D: "Mevcut tüm türleri listeleyin",
  T_49_META_TYPE_99_D: "Futbol Topu"
};
export {
  _ as default
};
